import { p as In, c as pe, g as ce, j as Ze, a as Upe } from "./jsx-runtime.js";
import { f as Wpe, _ as Gpe, b as Hse, d as Kpe, V as v1, l as Ype, o as Cr, O as Xpe, c as tn, a as iw } from "./index3.js";
import { z, a as ge, h as S, v as gt, p as K, M as cn, N as lr, O as Fn, t as Qpe, D as Hn, g as Uu, T as Jpe, A as Dse, b as ege, c as tge, I as nge, R as wr, P as rge, j as age, U as Wu, S as lge, d as ige, e as zse, i as oge, k as Fse, f as Vse, l as sge, m as qse, n as Use, o as cge, q as Wse, r as Gse, s as uge, u as fge, w as dge, x as pge, y as el, H as gge } from "./index2.js";
import { u as hge, o as ta, a as mge, x as vge } from "./useLinkData.js";
import * as u from "react";
import k, { useState as ht, useEffect as Tt, useMemo as kt, forwardRef as wn, useRef as Dn, isValidElement as b1, useCallback as rn, createContext as z9, useContext as jl, Fragment as bge } from "react";
import { W as Kse, x as yge, U as wge, r as Oge, a as ko, k as ow, C as Yse, M as xge, I as Ege, d as $ge } from "./ui-text.js";
import { _ as jge, a as Xse, r as he, m as v, E as Q, F as b, N as V, C as W, L as Y, w as it, A as It, M as ee, o as H, t as il, c as $r, j as un, B as gn, n as Cge } from "./index4.js";
import "./index6.js";
import { v as te, e as tt, l as ne, a as nt, s as Sc } from "./index5.js";
import { j as F9, O as V9, f as Mge, R as kge, r as Qse, Y as Pge, V as sw, A as Sge } from "./index9.js";
import { c as Jse, W as xn, z as fi, h as q9, f as Nge } from "./index7.js";
import { flushSync as Rge } from "react-dom";
import { a as _ge } from "./UserProvider.js";
import { r as Zi, p as ece, i as Age, a as Lge, o as Zge } from "./index8.js";
import { c as U9, h as Tge, d as Bge, t as W9, g as Ti, a as Hr, b as Ige, s as Bi, e as tce, f as Hge, i as nce, w as Dge } from "./util.js";
import { useChatbotContext as rce } from "./useChatbotContext.js";
import { b as zge } from "./utils.js";
import "./LinkDataProvider.js";
import "./ChatbotProvider.js";
function Fge(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function Vge(e, t) {
  e.classList ? e.classList.add(t) : Fge(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function cw(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function qge(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = cw(e.className, t) : e.setAttribute("class", cw(e.className && e.className.baseVal || "", t));
}
var Uge = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return Vge(t, r);
  });
}, Nc = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return qge(t, r);
  });
}, G9 = /* @__PURE__ */ function(e) {
  jge(t, e);
  function t() {
    for (var r, l = arguments.length, i = new Array(l), c = 0; c < l; c++)
      i[c] = arguments[c];
    return r = e.call.apply(e, [this].concat(i)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(f, d) {
      var h = r.resolveArguments(f, d), g = h[0], m = h[1];
      r.removeClasses(g, "exit"), r.addClass(g, m ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(f, d);
    }, r.onEntering = function(f, d) {
      var h = r.resolveArguments(f, d), g = h[0], m = h[1], y = m ? "appear" : "enter";
      r.addClass(g, y, "active"), r.props.onEntering && r.props.onEntering(f, d);
    }, r.onEntered = function(f, d) {
      var h = r.resolveArguments(f, d), g = h[0], m = h[1], y = m ? "appear" : "enter";
      r.removeClasses(g, y), r.addClass(g, y, "done"), r.props.onEntered && r.props.onEntered(f, d);
    }, r.onExit = function(f) {
      var d = r.resolveArguments(f), h = d[0];
      r.removeClasses(h, "appear"), r.removeClasses(h, "enter"), r.addClass(h, "exit", "base"), r.props.onExit && r.props.onExit(f);
    }, r.onExiting = function(f) {
      var d = r.resolveArguments(f), h = d[0];
      r.addClass(h, "exit", "active"), r.props.onExiting && r.props.onExiting(f);
    }, r.onExited = function(f) {
      var d = r.resolveArguments(f), h = d[0];
      r.removeClasses(h, "exit"), r.addClass(h, "exit", "done"), r.props.onExited && r.props.onExited(f);
    }, r.resolveArguments = function(f, d) {
      return r.props.nodeRef ? [r.props.nodeRef.current, f] : [f, d];
    }, r.getClassNames = function(f) {
      var d = r.props.classNames, h = typeof d == "string", g = h && d ? d + "-" : "", m = h ? "" + g + f : d[f], y = h ? m + "-active" : d[f + "Active"], w = h ? m + "-done" : d[f + "Done"];
      return {
        baseClassName: m,
        activeClassName: y,
        doneClassName: w
      };
    }, r;
  }
  var n = t.prototype;
  return n.addClass = function(l, i, c) {
    var f = this.getClassNames(i)[c + "ClassName"], d = this.getClassNames("enter"), h = d.doneClassName;
    i === "appear" && c === "done" && h && (f += " " + h), c === "active" && l && Wpe(l), f && (this.appliedClasses[i][c] = f, Uge(l, f));
  }, n.removeClasses = function(l, i) {
    var c = this.appliedClasses[i], f = c.base, d = c.active, h = c.done;
    this.appliedClasses[i] = {}, f && Nc(l, f), d && Nc(l, d), h && Nc(l, h);
  }, n.render = function() {
    var l = this.props;
    l.classNames;
    var i = Gpe(l, ["classNames"]);
    return /* @__PURE__ */ k.createElement(Hse, Xse({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(k.Component);
G9.defaultProps = {
  classNames: ""
};
G9.propTypes = In.env.NODE_ENV !== "production" ? Xse({}, Hse.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: Kpe,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: z.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: z.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: z.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: z.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: z.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: z.func
}) : {};
const Wge = G9;
var ace = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(ace);
var Gge = ace.exports;
const Kge = /* @__PURE__ */ ce(Gge);
var lce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(lce);
var Yge = lce.exports;
const Xge = /* @__PURE__ */ ce(Yge);
var ice = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(ice);
var Qge = ice.exports;
const Jge = /* @__PURE__ */ ce(Qge);
function ehe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ve(e, t, n) {
  return (t = ehe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function jn() {
  return jn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jn.apply(this, arguments);
}
function cr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function be(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function the(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return uw(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return uw(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function uw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var fw, dw, pw, gw, hw, mw, vw, bw, Cl = v(fw || (fw = be([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), oce = Ve(Ve({}, W.Body1, v(dw || (dw = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(pw || (pw = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), nhe = Ve(Ve({}, W.Body1, v(gw || (gw = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(hw || (hw = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), y1 = Ve(Ve({}, S.Light, v(mw || (mw = be([`
    color: `, `;
  `])), b.black)), S.Dark, v(vw || (vw = be([`
    color: `, `;
  `])), b.gray.light2)), Ml = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, rhe = ["baseFontSize", "darkMode", "className", "weight", "as"], ahe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = cr(e, rhe), h = K(n).theme, g = Ml(t), m = ne(f).Component, y = v(bw || (bw = be([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, jn({ className: H(Cl, oce[g], y1[h], y, r) }, d));
});
ahe.displayName = "Body";
var yw, ww, Ow, xw, Ew, $w, jw, Cw, Mw, kw, lhe = { label: "lg-label", description: "lg-description" };
v(yw || (yw = be([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Ve(Ve({}, S.Light, v(ww || (ww = be([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(Ow || (Ow = be([`
    color: `, `;
  `])), b.gray.light1));
Ve(Ve({}, S.Light, v(xw || (xw = be([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(Ew || (Ew = be([`
    color: `, `;
  `])), b.gray.dark1));
Ve(Ve({}, W.Body1, v($w || ($w = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(jw || (jw = be([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var Pw, Sw, Nw, Rw, _w;
Ve(Ve({}, S.Light, v(Cw || (Cw = be([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(Mw || (Mw = be([`
    color: `, `;
  `])), b.gray.light1));
v(kw || (kw = be([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var Aw, Lw, Zw, Tw, Bw, Iw, ihe = v(Pw || (Pw = be([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), ohe = Ve(Ve({}, S.Light, v(Sw || (Sw = be([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(Nw || (Nw = be([`
    color: `, `;
  `])), b.red.light1)), she = Ve(Ve({}, W.Body1, v(Rw || (Rw = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(_w || (_w = be([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), che = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = cr(e, che), f = K(r).theme, d = Ml(), h = ne(n).Component;
  return k.createElement(h, jn({}, c, { className: H(ihe, ohe[f], she[d], i) }), l);
});
var uhe = v(Aw || (Aw = be([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), fhe = Ve(Ve({}, S.Light, v(Lw || (Lw = be([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(Zw || (Zw = be([`
    color: `, `;
  `])), b.gray.light2)), dhe = ["darkMode", "className", "as"], phe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = cr(e, dhe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, jn({ className: H(Cl, uhe, fhe[c], n) }, i));
});
phe.displayName = "H1";
var Hw, ghe = v(Tw || (Tw = be([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), hhe = Ve(Ve({}, S.Light, v(Bw || (Bw = be([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(Iw || (Iw = be([`
    color: `, `;
  `])), b.gray.light2)), mhe = ["darkMode", "className", "as"], vhe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = cr(e, mhe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, jn({ className: H(Cl, ghe, hhe[c], n) }, i));
});
vhe.displayName = "H2";
var Dw, zw, Fw, Vw, qw, Uw, Ww, Gw, Kw, Yw, bhe = v(Hw || (Hw = be([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), yhe = ["darkMode", "className", "as"], whe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = cr(e, yhe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, jn({ className: H(Cl, bhe, y1[c], n) }, i));
});
whe.displayName = "H3";
var Xw, Qw, Jw, ol = gt(), Ohe = v(Dw || (Dw = be([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, ol), xhe = Ve(Ve({}, S.Light, v(zw || (zw = be([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, ol, b.gray.light2, b.gray.light1)), S.Dark, v(Fw || (Fw = be([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, ol, b.gray.dark2, b.gray.dark1)), Ehe = Ve(Ve({}, S.Light, v(Vw || (Vw = be([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ol, it[S.Light].default, b.blue.base)), S.Dark, v(qw || (qw = be([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ol, it[S.Dark].default, b.blue.base)), $he = Ve(Ve({}, S.Light, v(Uw || (Uw = be([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(Ww || (Ww = be([`
    color: `, `;
  `])), b.blue.light1)), jhe = v(Gw || (Gw = be([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), Che = v(Kw || (Kw = be([`
  white-space: nowrap;
`]))), Mhe = v(Yw || (Yw = be([`
  white-space: normal;
`]))), khe = ["children", "className", "darkMode", "baseFontSize", "as"], eO = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = cr(e, khe), g = K(c).theme, m = Ml(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? Che : Mhe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(nhe[m], Ohe, xhe[g], Ehe[g], w, Ve({}, $he[g], C), i) }, l);
  return C ? k.createElement(y, jn({ className: H(ol, jhe, i) }, h), E) : k.cloneElement(E, h);
});
eO.displayName = "InlineCode", eO.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var tO, nO, rO, aO, lO, iO, oO;
v(Xw || (Xw = be([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Ve(Ve({}, S.Light, v(Qw || (Qw = be([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(Jw || (Jw = be([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var sO, cO, uO, Phe = v(tO || (tO = be([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), She = Ve(Ve({}, S.Light, v(nO || (nO = be([`
    color: `, `;
  `])), b.black)), S.Dark, v(rO || (rO = be([`
    color: `, `;
  `])), b.gray.light2)), Nhe = Ve(Ve({}, S.Light, v(aO || (aO = be([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(lO || (lO = be([`
    color: `, `;
  `])), b.gray.dark1)), Rhe = Ve(Ve({}, W.Body1, v(iO || (iO = be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(oO || (oO = be([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), _he = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], Ahe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? lhe.label : h, m = cr(e, _he), y = K(n).theme, w = Ml(t), C = ne(d).Component;
  return k.createElement(C, jn({ "data-lgid": g, className: H(Phe, She[y], Rhe[w], Ve({}, Nhe[y], c), r) }, m), l);
});
Ahe.displayName = "Label";
var fO, dO, pO, gO, hO, mO, Po = gt(), sce = v(sO || (sO = be([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), cce = Ve(Ve({}, S.Light, v(cO || (cO = be([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(uO || (uO = be([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), uce = function(e) {
  if (e)
    return oce[e];
}, Lhe = v(fO || (fO = be([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), Zhe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = cr(e, Zhe), d = K(i).theme, h = Ml(l), g = nt(c, f, "span").Component;
  return k.createElement(g, jn({ className: H(Po, sce, uce(h), cce[d], Lhe, r), ref: t }, f), k.createElement(Kge, { role: "presentation" }), n);
});
var The = v(dO || (dO = be([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), Bhe = v(pO || (pO = be([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Po, Po), Ihe = v(gO || (gO = be([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), Hhe = "hover", Dhe = "persist", vO = "none", zhe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? vO : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = cr(e, zhe), y = the(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Ml(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== vO && (E = k.createElement(Xge, { role: "presentation", size: 12, className: H(Ve(Ve({}, Bhe, i === Hhe), The, i === Dhe)) })) : E = k.createElement(Jge, { role: "presentation", className: Ihe }), k.createElement(P, jn({ className: H(Po, sce, uce(M), cce[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var Fhe = v(hO || (hO = be([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), Vhe = ["darkMode", "className", "as"], qhe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = cr(e, Vhe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, jn({ className: H(Cl, Fhe, y1[c], n) }, i));
});
qhe.displayName = "Overline";
var Uhe = v(mO || (mO = be([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), Whe = ["darkMode", "className", "as"], Ghe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = cr(e, Whe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, jn({ className: H(Cl, Uhe, y1[c], n) }, i));
});
Ghe.displayName = "Subtitle";
var bO;
v(bO || (bO = be([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function Khe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ir(e, t, n) {
  return (t = Khe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ft(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var yO, wO, OO, xO, EO, $O, jO, CO, MO, kO, PO, SO, NO, RO, _O, AO, LO, ZO, TO, BO, IO, HO, DO, zO, mo = { TopLeft: "top left", TopRight: "top right", BottomRight: "bottom right" }, Gu = { Center: "center", Fill: "fill" };
v(yO || (yO = Ft([`
  position: absolute;
  z-index: -1;
`])));
ir(ir({}, S.Light, v(wO || (wO = Ft([`
    color: `, `;
  `])), b.purple.light3)), S.Dark, v(OO || (OO = Ft([`
    color: `, `;
  `])), b.gray.dark3));
ir(ir(ir({}, mo.TopLeft, { viewBox: "0 0 265 501", path: "M-10.0239 -12.0209L154.458 -12.0208C215.515 -12.0208 265 52.2446 265 131.538C265 210.041 215.934 273.615 155.523 273.467L98.8817 273.318C68.886 273.269 44.5623 304.808 44.5623 343.714L44.5623 346.186C44.5623 385.091 20.2765 416.581 -9.64308 416.581L-10.709 416.581C-40.7047 416.581 -64.9905 448.219 -64.9144 487.174C-64.8382 526.129 -89.1241 557.767 -119.12 557.767L-120.604 557.767C-150.524 557.767 -174.772 526.277 -174.81 487.421L-175 201.242C-175.038 162.336 -150.752 130.797 -120.795 130.797L-118.435 130.797C-88.477 130.797 -64.2292 99.2574 -64.2292 60.4015L-64.2292 58.3251C-64.2292 19.5186 -39.9815 -12.0209 -10.0239 -12.0209Z", styles: v(xO || (xO = Ft([`
      top: 0;
      left: 0;
      width: 265px;
      max-width: 80%;
    `]))) }), mo.TopRight, { viewBox: "0 0 342 368", path: "M474 92.9761L474 257.458C474 318.515 420.538 368 354.575 368C289.269 368 236.383 318.934 236.506 258.523L236.63 201.882C236.671 171.886 210.434 147.562 178.069 147.562L176.012 147.562C143.648 147.562 117.451 123.277 117.451 93.357L117.451 92.291C117.451 62.2953 91.1317 38.0095 58.7256 38.0857C26.3196 38.1618 -4.40929e-07 13.876 -3.06323e-06 -16.1197L-3.19302e-06 -17.6043C-5.80867e-06 -47.5239 26.1962 -71.7716 58.52 -71.8097L296.589 -72C328.954 -72.038 355.192 -47.7522 355.192 -17.7946L355.192 -15.4346C355.192 14.5231 381.429 38.7708 413.753 38.7708L415.48 38.7708C447.763 38.7708 474 63.0185 474 92.9761Z", styles: v(EO || (EO = Ft([`
      top: 0;
      right: 0;
      width: 342px;
      max-width: 80%;
    `]))) }), mo.BottomRight, { viewBox: "0 0 322 501", path: "M323.778 501L130.139 501C58.2575 501 -2.75101e-06 434.759 -6.14535e-06 353.027C-9.50583e-06 272.11 57.7646 206.582 128.884 206.735L195.566 206.888C230.88 206.939 259.515 174.43 259.515 134.328L259.515 131.78C259.515 91.6788 288.106 59.2206 323.33 59.2206L324.585 59.2206C359.898 59.2206 388.489 26.6094 388.399 -13.5431C388.309 -53.6956 416.901 -86.3068 452.214 -86.3068L453.961 -86.3068C489.185 -86.3068 517.731 -53.8486 517.776 -13.798L518 281.18C518.045 321.282 489.454 353.791 454.185 353.791L451.407 353.791C416.139 353.791 387.593 386.3 387.593 426.351L387.593 428.491C387.593 468.491 359.046 501 323.778 501Z", styles: v($O || ($O = Ft([`
      right: 0;
      bottom: 0;
      width: 322px;
      max-width: 70%;
    `]))) });
var Yhe = v(jO || (jO = Ft([`
  padding-top: 48px;
  padding-bottom: `, `px;
`])), ee[4]), Xhe = v(CO || (CO = Ft([`
  padding-bottom: `, `px;
  position: relative;
`])), ee[4]);
ir(ir({}, Gu.Center, Yhe), Gu.Fill, Xhe);
v(MO || (MO = Ft([`
  display: flex;
  align-items: center;
  justify-content: center;
`])));
v(kO || (kO = Ft([`
  width: 100%;
`])));
v(PO || (PO = Ft([`
  display: block;
`])));
v(SO || (SO = Ft([`
  position: absolute;
  left: 0;
  bottom: `, `px;
`])), ee[4]);
ir(ir({}, S.Light, v(NO || (NO = Ft([`
    color: `, `;
  `])), b.white)), S.Dark, v(RO || (RO = Ft([`
    color: `, `;
  `])), b.black));
v(_O || (_O = Ft([`
  margin-bottom: `, `px;
`])), ee[1]);
v(AO || (AO = Ft([`
  width: 600px;
  padding: initial;
  overflow: hidden;
`])));
v(LO || (LO = Ft([`
  text-align: center;
  padding: 0 20px 32px;
  max-width: 476px;
  margin: 0 auto;
`])));
v(ZO || (ZO = Ft([`
  font-size: `, `px;
  line-height: `, `px;
`])), V.body1.fontSize, V.body1.lineHeight);
ir(ir({}, S.Light, v(TO || (TO = Ft([`
    color: `, `;
  `])), b.black)), S.Dark, v(BO || (BO = Ft([`
    color: `, `;
  `])), b.gray.light1));
v(IO || (IO = Ft([`
  line-height: 24px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`])));
v(HO || (HO = Ft([`
  min-width: 200px;
`])));
v(DO || (DO = Ft([`
  margin-top: `, `px;
`])), ee[3]);
v(zO || (zO = Ft([`
  padding: `, "px ", `px 0px;
  color: `, `;
`])), ee[5], ee[5] + ee[3], b.gray.dark1);
z.element.isRequired, z.element.isRequired, z.oneOf(Object.values(Gu)), z.bool, z.func, z.func, z.func, z.node, z.string, z.string.isRequired, z.string.isRequired, z.oneOf(Object.values(mo)), z.bool, z.bool;
var fce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(fce);
var Qhe = fce.exports;
const Jhe = /* @__PURE__ */ ce(Qhe);
var dce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(dce);
var e3e = dce.exports;
const t3e = /* @__PURE__ */ ce(e3e);
var pce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(pce);
var n3e = pce.exports;
const r3e = /* @__PURE__ */ ce(n3e);
function a3e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function qe(e, t, n) {
  return (t = a3e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mn.apply(this, arguments);
}
function Vn(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function ye(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function l3e(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return FO(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return FO(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function FO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var VO, qO, UO, WO, GO, KO, YO, XO, Na = v(VO || (VO = ye([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), gce = qe(qe({}, W.Body1, v(qO || (qO = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(UO || (UO = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), i3e = qe(qe({}, W.Body1, v(WO || (WO = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(GO || (GO = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), w1 = qe(qe({}, S.Light, v(KO || (KO = ye([`
    color: `, `;
  `])), b.black)), S.Dark, v(YO || (YO = ye([`
    color: `, `;
  `])), b.gray.light2)), kl = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, o3e = ["baseFontSize", "darkMode", "className", "weight", "as"], hce = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = Vn(e, o3e), h = K(n).theme, g = kl(t), m = ne(f).Component, y = v(XO || (XO = ye([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, mn({ className: H(Na, gce[g], w1[h], y, r) }, d));
});
hce.displayName = "Body";
var QO, JO, ex, tx, nx, rx, ax, lx, ix, ox, s3e = { label: "lg-label", description: "lg-description" };
v(QO || (QO = ye([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
qe(qe({}, S.Light, v(JO || (JO = ye([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(ex || (ex = ye([`
    color: `, `;
  `])), b.gray.light1));
qe(qe({}, S.Light, v(tx || (tx = ye([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(nx || (nx = ye([`
    color: `, `;
  `])), b.gray.dark1));
qe(qe({}, W.Body1, v(rx || (rx = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(ax || (ax = ye([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var sx, cx, ux, fx, dx, c3e = qe(qe({}, S.Light, v(lx || (lx = ye([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(ix || (ix = ye([`
    color: `, `;
  `])), b.gray.light1)), u3e = v(ox || (ox = ye([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`]))), f3e = ["darkMode", "children", "className"];
function mce(e) {
  var t = e.darkMode, n = e.children, r = e.className, l = Vn(e, f3e), i = K(t).theme;
  return k.createElement("small", mn({}, l, { className: H(Na, u3e, c3e[i], r) }), n);
}
mce.displayName = "Disclaimer";
var px, gx, hx, mx, vx, bx, d3e = v(sx || (sx = ye([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), p3e = qe(qe({}, S.Light, v(cx || (cx = ye([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(ux || (ux = ye([`
    color: `, `;
  `])), b.red.light1)), g3e = qe(qe({}, W.Body1, v(fx || (fx = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(dx || (dx = ye([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), h3e = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = Vn(e, h3e), f = K(r).theme, d = kl(), h = ne(n).Component;
  return k.createElement(h, mn({}, c, { className: H(d3e, p3e[f], g3e[d], i) }), l);
});
var m3e = v(px || (px = ye([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), v3e = qe(qe({}, S.Light, v(gx || (gx = ye([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(hx || (hx = ye([`
    color: `, `;
  `])), b.gray.light2)), b3e = ["darkMode", "className", "as"], y3e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = Vn(e, b3e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, mn({ className: H(Na, m3e, v3e[c], n) }, i));
});
y3e.displayName = "H1";
var yx, w3e = v(mx || (mx = ye([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), O3e = qe(qe({}, S.Light, v(vx || (vx = ye([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(bx || (bx = ye([`
    color: `, `;
  `])), b.gray.light2)), x3e = ["darkMode", "className", "as"], E3e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = Vn(e, x3e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, mn({ className: H(Na, w3e, O3e[c], n) }, i));
});
E3e.displayName = "H2";
var wx, Ox, xx, Ex, $x, jx, Cx, Mx, kx, Px, $3e = v(yx || (yx = ye([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), j3e = ["darkMode", "className", "as"], C3e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = Vn(e, j3e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, mn({ className: H(Na, $3e, w1[c], n) }, i));
});
C3e.displayName = "H3";
var Sx, Nx, Rx, sl = gt(), M3e = v(wx || (wx = ye([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, sl), k3e = qe(qe({}, S.Light, v(Ox || (Ox = ye([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, sl, b.gray.light2, b.gray.light1)), S.Dark, v(xx || (xx = ye([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, sl, b.gray.dark2, b.gray.dark1)), P3e = qe(qe({}, S.Light, v(Ex || (Ex = ye([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), sl, it[S.Light].default, b.blue.base)), S.Dark, v($x || ($x = ye([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), sl, it[S.Dark].default, b.blue.base)), S3e = qe(qe({}, S.Light, v(jx || (jx = ye([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(Cx || (Cx = ye([`
    color: `, `;
  `])), b.blue.light1)), N3e = v(Mx || (Mx = ye([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), R3e = v(kx || (kx = ye([`
  white-space: nowrap;
`]))), _3e = v(Px || (Px = ye([`
  white-space: normal;
`]))), A3e = ["children", "className", "darkMode", "baseFontSize", "as"], _x = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = Vn(e, A3e), g = K(c).theme, m = kl(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? R3e : _3e, C = y !== "code", E = k.createElement("code", { ref: t, className: H(i3e[m], M3e, k3e[g], P3e[g], w, qe({}, S3e[g], C), i) }, l);
  return C ? k.createElement(y, mn({ className: H(sl, N3e, i) }, h), E) : k.cloneElement(E, h);
});
_x.displayName = "InlineCode", _x.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var Ax, Lx, Zx, Tx, Bx, Ix, Hx;
v(Sx || (Sx = ye([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
qe(qe({}, S.Light, v(Nx || (Nx = ye([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(Rx || (Rx = ye([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var Dx, zx, Fx, L3e = v(Ax || (Ax = ye([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), Z3e = qe(qe({}, S.Light, v(Lx || (Lx = ye([`
    color: `, `;
  `])), b.black)), S.Dark, v(Zx || (Zx = ye([`
    color: `, `;
  `])), b.gray.light2)), T3e = qe(qe({}, S.Light, v(Tx || (Tx = ye([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(Bx || (Bx = ye([`
    color: `, `;
  `])), b.gray.dark1)), B3e = qe(qe({}, W.Body1, v(Ix || (Ix = ye([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Hx || (Hx = ye([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), I3e = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], H3e = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? s3e.label : h, m = Vn(e, I3e), y = K(n).theme, w = kl(t), C = ne(d).Component;
  return k.createElement(C, mn({ "data-lgid": g, className: H(L3e, Z3e[y], B3e[w], qe({}, T3e[y], c), r) }, m), l);
});
H3e.displayName = "Label";
var Vx, qx, Ux, Wx, Gx, Kx, So = gt(), vce = v(Dx || (Dx = ye([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), bce = qe(qe({}, S.Light, v(zx || (zx = ye([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(Fx || (Fx = ye([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), yce = function(e) {
  if (e)
    return gce[e];
}, D3e = v(Vx || (Vx = ye([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), z3e = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = Vn(e, z3e), d = K(i).theme, h = kl(l), g = nt(c, f, "span").Component;
  return k.createElement(g, mn({ className: H(So, vce, yce(h), bce[d], D3e, r), ref: t }, f), k.createElement(Jhe, { role: "presentation" }), n);
});
var F3e = v(qx || (qx = ye([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), V3e = v(Ux || (Ux = ye([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), So, So), q3e = v(Wx || (Wx = ye([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), U3e = "hover", W3e = "persist", Yx = "none", G3e = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? Yx : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = Vn(e, G3e), y = l3e(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = kl(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== Yx && (E = k.createElement(t3e, { role: "presentation", size: 12, className: H(qe(qe({}, V3e, i === U3e), F3e, i === W3e)) })) : E = k.createElement(r3e, { role: "presentation", className: q3e }), k.createElement(P, mn({ className: H(So, vce, yce(M), bce[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var K3e = v(Gx || (Gx = ye([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), Y3e = ["darkMode", "className", "as"], X3e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = Vn(e, Y3e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, mn({ className: H(Na, K3e, w1[c], n) }, i));
});
X3e.displayName = "Overline";
var Q3e = v(Kx || (Kx = ye([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), J3e = ["darkMode", "className", "as"], eme = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = Vn(e, J3e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, mn({ className: H(Na, Q3e, w1[c], n) }, i));
});
eme.displayName = "Subtitle";
var Xx;
v(Xx || (Xx = ye([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var Qx;
function tme(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var Rc, _c, nme = v(Qx || (Rc = [`
  margin-bottom: `, `px;
`], _c || (_c = Rc.slice(0)), Qx = Object.freeze(Object.defineProperties(Rc, { raw: { value: Object.freeze(_c) } }))), ee[2]), rme = ["title", "children"], wce = function(e) {
  var t = e.title, n = e.children, r = tme(e, rme);
  return k.createElement("div", r, t && k.createElement(hce, { weight: "medium", className: nme }, t), k.createElement(mce, null, n));
};
wce.displayName = "DisclaimerText";
function $i(e, t, n) {
  return (t = function(r) {
    var l = function(i, c) {
      if (typeof i != "object" || i === null)
        return i;
      var f = i[Symbol.toPrimitive];
      if (f !== void 0) {
        var d = f.call(i, c || "default");
        if (typeof d != "object")
          return d;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(i);
    }(r, "string");
    return typeof l == "symbol" ? l : String(l);
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ku() {
  return Ku = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ku.apply(this, arguments);
}
function ame(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Tr(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var Jx, eE, tE, Ac, nE, rE, aE, Lc, lE, iE, oE, lme = v(Jx || (Jx = Tr([`
  height: 500px;
  width: 100%;
  display: flex;
  justify-content: center;
`]))), ime = ($i(Ac = {}, S.Dark, v(eE || (eE = Tr([`
    background-color: `, `;
  `])), b.black)), $i(Ac, S.Light, v(tE || (tE = Tr([`
    background-color: `, `;
  `])), b.gray.light3)), Ac), ome = v(nE || (nE = Tr([`
  width: 100%;
  max-width: `, `px;
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  position: relative;
  padding: `, "px ", "px ", `px;
  z-index: 2;
`])), il.Tablet + 2 * (F9[V9.Default] + ee[5] + ee[3]), ee[3], ee[5], ee[2]), sme = ($i(Lc = {}, S.Dark, v(rE || (rE = Tr([`
    // https://css-tricks.com/books/greatest-css-tricks/scroll-shadows/
    background:
      /* Shadow Cover TOP */ 
      // eslint-disable-next-line Maintain natural line break
      linear-gradient(`, " 30%, ", ` 0%) center top,
      /* Shadow Cover BOTTOM */
        linear-gradient(`, " 0%, ", ` 70%) center bottom,
      /* Shadow TOP */
        radial-gradient(
          farthest-side at 50% 0,
          rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 0)
        )
        center top,
      /* Shadow BOTTOM */
        radial-gradient(
          farthest-side at 50% 100%,
          rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 0)
        )
        center bottom;
    background-repeat: no-repeat;
    background-size: 100% 16px, 100% 16px, 100% 8px, 100% 8px;
    background-attachment: local, local, scroll, scroll;
  `])), b.black, b.black, b.black, b.black)), $i(Lc, S.Light, v(aE || (aE = Tr([`
    // https://css-tricks.com/books/greatest-css-tricks/scroll-shadows/
    background:
      /* Shadow Cover TOP */ 
      // eslint-disable-next-line Maintain natural line break
      linear-gradient(`, " 30%, ", ` 0%)
        center top,
      /* Shadow Cover BOTTOM */
        linear-gradient(`, " 0%, ", ` 30%)
        center bottom,
      /* Shadow TOP */
        radial-gradient(
          farthest-side at 50% 0,
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0)
        )
        center top,
      /* Shadow BOTTOM */
        radial-gradient(
          farthest-side at 50% 100%,
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0)
        )
        center bottom;
    background-repeat: no-repeat;
    background-size: 100% 16px, 100% 16px, 100% 8px, 100% 8px;
    background-attachment: local, local, scroll, scroll;
  `])), b.gray.light3, b.gray.light3, b.gray.light3, b.gray.light3)), Lc), cme = v(lE || (lE = Tr([`
  padding: 0px `, `px;
`])), F9[V9.Small] + ee[2]), ume = v(iE || (iE = Tr([`
  padding: 0px `, `px;
`])), F9[V9.Default] + ee[3]), fme = v(oE || (oE = Tr([`
  text-align: center;
  margin-top: `, `px;
  margin-bottom: `, `px;
`])), ee[4], ee[6]), dme = ["children", "darkMode", "className"], Yu = wn(function(e, t) {
  var n = e.children, r = e.darkMode, l = e.className, i = ame(e, dme), c = Jse().containerWidth, f = K(r), d = f.darkMode, h = f.theme, g = Dn(null), m = Mge(n).map(function(y) {
    return lr(y, "DisclaimerText") ? k.createElement("div", { className: fme, key: "disclaimer-text" }, y) : lr(y, "MessagePrompts") ? k.createElement("div", { key: "message-prompts", className: H(cme, $i({}, ume, !!c && c >= il.Tablet)) }, y) : y;
  });
  return Tt(function() {
    g.current && g.current.scrollTo(0, g.current.scrollHeight);
  }, [n]), k.createElement(Fn, { darkMode: d }, k.createElement("div", Ku({}, i, { className: H(lme, ime[h], l), ref: t }), k.createElement("div", { className: H(sme[h], ome), ref: g }, m)));
});
Yu.displayName = "MessageFeed", Yu.propTypes = { darkMode: z.bool };
var Oce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Oce);
var pme = Oce.exports;
const gme = /* @__PURE__ */ ce(pme);
var xce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(xce);
var hme = xce.exports;
const mme = /* @__PURE__ */ ce(hme);
var Ece = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Ece);
var vme = Ece.exports;
const bme = /* @__PURE__ */ ce(vme);
function yme(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ue(e, t, n) {
  return (t = yme(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Cn() {
  return Cn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cn.apply(this, arguments);
}
function ur(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function we(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function wme(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return sE(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return sE(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function sE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var cE, uE, fE, dE, pE, gE, hE, mE, Pl = v(cE || (cE = we([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), K9 = Ue(Ue({}, W.Body1, v(uE || (uE = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(fE || (fE = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), Ome = Ue(Ue({}, W.Body1, v(dE || (dE = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(pE || (pE = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), O1 = Ue(Ue({}, S.Light, v(gE || (gE = we([`
    color: `, `;
  `])), b.black)), S.Dark, v(hE || (hE = we([`
    color: `, `;
  `])), b.gray.light2)), Ra = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, xme = ["baseFontSize", "darkMode", "className", "weight", "as"], Eme = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = ur(e, xme), h = K(n).theme, g = Ra(t), m = ne(f).Component, y = v(mE || (mE = we([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, Cn({ className: H(Pl, K9[g], O1[h], y, r) }, d));
});
Eme.displayName = "Body";
var vE, bE, yE, wE, OE, xE, EE, $E, jE, CE, $me = { label: "lg-label", description: "lg-description" };
v(vE || (vE = we([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Ue(Ue({}, S.Light, v(bE || (bE = we([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(yE || (yE = we([`
    color: `, `;
  `])), b.gray.light1));
Ue(Ue({}, S.Light, v(wE || (wE = we([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(OE || (OE = we([`
    color: `, `;
  `])), b.gray.dark1));
Ue(Ue({}, W.Body1, v(xE || (xE = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(EE || (EE = we([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var ME, kE, PE, SE, NE;
Ue(Ue({}, S.Light, v($E || ($E = we([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(jE || (jE = we([`
    color: `, `;
  `])), b.gray.light1));
v(CE || (CE = we([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var RE, _E, AE, LE, ZE, TE, jme = v(ME || (ME = we([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), Cme = Ue(Ue({}, S.Light, v(kE || (kE = we([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(PE || (PE = we([`
    color: `, `;
  `])), b.red.light1)), Mme = Ue(Ue({}, W.Body1, v(SE || (SE = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(NE || (NE = we([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), kme = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = ur(e, kme), f = K(r).theme, d = Ra(), h = ne(n).Component;
  return k.createElement(h, Cn({}, c, { className: H(jme, Cme[f], Mme[d], i) }), l);
});
var Pme = v(RE || (RE = we([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), Sme = Ue(Ue({}, S.Light, v(_E || (_E = we([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(AE || (AE = we([`
    color: `, `;
  `])), b.gray.light2)), Nme = ["darkMode", "className", "as"], Rme = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = ur(e, Nme), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Cn({ className: H(Pl, Pme, Sme[c], n) }, i));
});
Rme.displayName = "H1";
var BE, _me = v(LE || (LE = we([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), Ame = Ue(Ue({}, S.Light, v(ZE || (ZE = we([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(TE || (TE = we([`
    color: `, `;
  `])), b.gray.light2)), Lme = ["darkMode", "className", "as"], Zme = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = ur(e, Lme), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Cn({ className: H(Pl, _me, Ame[c], n) }, i));
});
Zme.displayName = "H2";
var IE, HE, DE, zE, FE, VE, qE, UE, WE, GE, Tme = v(BE || (BE = we([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), Bme = ["darkMode", "className", "as"], Ime = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = ur(e, Bme), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Cn({ className: H(Pl, Tme, O1[c], n) }, i));
});
Ime.displayName = "H3";
var KE, YE, XE, cl = gt(), Hme = v(IE || (IE = we([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, cl), Dme = Ue(Ue({}, S.Light, v(HE || (HE = we([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, cl, b.gray.light2, b.gray.light1)), S.Dark, v(DE || (DE = we([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, cl, b.gray.dark2, b.gray.dark1)), zme = Ue(Ue({}, S.Light, v(zE || (zE = we([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), cl, it[S.Light].default, b.blue.base)), S.Dark, v(FE || (FE = we([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), cl, it[S.Dark].default, b.blue.base)), Fme = Ue(Ue({}, S.Light, v(VE || (VE = we([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(qE || (qE = we([`
    color: `, `;
  `])), b.blue.light1)), Vme = v(UE || (UE = we([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), qme = v(WE || (WE = we([`
  white-space: nowrap;
`]))), Ume = v(GE || (GE = we([`
  white-space: normal;
`]))), Wme = ["children", "className", "darkMode", "baseFontSize", "as"], QE = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = ur(e, Wme), g = K(c).theme, m = Ra(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? qme : Ume, C = y !== "code", E = k.createElement("code", { ref: t, className: H(Ome[m], Hme, Dme[g], zme[g], w, Ue({}, Fme[g], C), i) }, l);
  return C ? k.createElement(y, Cn({ className: H(cl, Vme, i) }, h), E) : k.cloneElement(E, h);
});
QE.displayName = "InlineCode", QE.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var JE, e$, t$, n$, r$, a$, l$;
v(KE || (KE = we([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Ue(Ue({}, S.Light, v(YE || (YE = we([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(XE || (XE = we([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var i$, o$, s$, Gme = v(JE || (JE = we([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), Kme = Ue(Ue({}, S.Light, v(e$ || (e$ = we([`
    color: `, `;
  `])), b.black)), S.Dark, v(t$ || (t$ = we([`
    color: `, `;
  `])), b.gray.light2)), Yme = Ue(Ue({}, S.Light, v(n$ || (n$ = we([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(r$ || (r$ = we([`
    color: `, `;
  `])), b.gray.dark1)), Xme = Ue(Ue({}, W.Body1, v(a$ || (a$ = we([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(l$ || (l$ = we([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), Qme = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], Jme = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? $me.label : h, m = ur(e, Qme), y = K(n).theme, w = Ra(t), C = ne(d).Component;
  return k.createElement(C, Cn({ "data-lgid": g, className: H(Gme, Kme[y], Xme[w], Ue({}, Yme[y], c), r) }, m), l);
});
Jme.displayName = "Label";
var c$, u$, f$, d$, p$, g$, qn = gt(), $ce = v(i$ || (i$ = we([`
  font-family: `, `;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), jce = Ue(Ue({}, S.Light, v(o$ || (o$ = we([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(s$ || (s$ = we([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), Cce = function(e) {
  if (e)
    return K9[e];
}, e4e = v(c$ || (c$ = we([`
  gap: `, `px;
`])), ee[100]), t4e = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = ur(e, t4e), d = K(i).theme, h = Ra(l), g = nt(c, f, "span").Component;
  return k.createElement(g, Cn({ className: H(qn, $ce, Cce(h), jce[d], e4e, r), ref: t }, f), k.createElement(gme, { role: "presentation" }), n);
});
var n4e = v(u$ || (u$ = we([`
  transform: translate3d(3px, 0, 0);
`]))), r4e = v(f$ || (f$ = we([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;

  .`, `:hover & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), qn), a4e = v(d$ || (d$ = we([`
  position: relative;
  bottom: 4px;
  left: -1px;
  height: 12px;
`]))), l4e = "hover", i4e = "persist", h$ = "none", o4e = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? h$ : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = ur(e, o4e), y = wme(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Ra(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== h$ && (E = k.createElement(mme, { role: "presentation", size: 12, className: H(Ue(Ue({}, r4e, i === l4e), n4e, i === i4e)) })) : E = k.createElement(bme, { role: "presentation", className: a4e }), k.createElement(P, Cn({ className: H(qn, $ce, Cce(M), jce[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var s4e = v(p$ || (p$ = we([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), c4e = ["darkMode", "className", "as"], u4e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = ur(e, c4e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Cn({ className: H(Pl, s4e, O1[c], n) }, i));
});
u4e.displayName = "Overline";
var f4e = v(g$ || (g$ = we([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), d4e = ["darkMode", "className", "as"], p4e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = ur(e, d4e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Cn({ className: H(Pl, f4e, O1[c], n) }, i));
});
p4e.displayName = "Subtitle";
var m$;
v(m$ || (m$ = we([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var Mce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "X", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2028 3.40381C11.8123 3.01329 11.1791 3.01329 10.7886 3.40381L8.3137 5.87869L5.83883 3.40381C5.44831 3.01329 4.81514 3.01329 4.42462 3.40381L3.71751 4.11092C3.32699 4.50144 3.32699 5.13461 3.71751 5.52513L6.19238 8.00001L3.71751 10.4749C3.32699 10.8654 3.32699 11.4986 3.71751 11.8891L4.42462 12.5962C4.81514 12.9867 5.44831 12.9867 5.83883 12.5962L8.3137 10.1213L10.7886 12.5962C11.1791 12.9867 11.8123 12.9867 12.2028 12.5962L12.9099 11.8891C13.3004 11.4986 13.3004 10.8654 12.9099 10.4749L10.435 8.00001L12.9099 5.52513C13.3004 5.13461 13.3004 4.50144 12.9099 4.11092L12.2028 3.40381Z", fill: "currentColor" }));
    };
    return P.displayName = "X", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Mce);
var g4e = Mce.exports;
const h4e = /* @__PURE__ */ ce(g4e);
var kce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "CheckmarkWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.4485 4.89583C10.8275 4.45816 11.4983 4.43411 11.9077 4.84352C12.2777 5.21345 12.2989 5.80633 11.9564 6.2018L7.38365 11.4818C7.31367 11.5739 7.22644 11.6552 7.12309 11.7208C6.65669 12.0166 6.03882 11.8783 5.74302 11.4119L3.9245 8.54448C3.6287 8.07809 3.767 7.46021 4.2334 7.16442C4.69979 6.86863 5.31767 7.00693 5.61346 7.47332L6.71374 9.20819L10.4485 4.89583Z", fill: "currentColor" }));
    };
    return P.displayName = "CheckmarkWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(kce);
var m4e = kce.exports;
const v4e = /* @__PURE__ */ ce(m4e);
var Pce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ImportantWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5V8.5C9 9.05228 8.55228 9.5 8 9.5C7.44772 9.5 7 9.05228 7 8.5V4.5ZM9 11.5C9 12.0523 8.55228 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5C7 10.9477 7.44772 10.5 8 10.5C8.55228 10.5 9 10.9477 9 11.5Z", fill: "currentColor" }));
    };
    return P.displayName = "ImportantWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Pce);
var b4e = Pce.exports;
const y4e = /* @__PURE__ */ ce(b4e);
var Sce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "InfoWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM8 6C8.55228 6 9 6.44772 9 7V11H9.5C9.77614 11 10 11.2239 10 11.5C10 11.7761 9.77614 12 9.5 12H6.5C6.22386 12 6 11.7761 6 11.5C6 11.2239 6.22386 11 6.5 11H7V7H6.5C6.22386 7 6 6.77614 6 6.5C6 6.22386 6.22386 6 6.5 6H8Z", fill: "currentColor" }));
    };
    return P.displayName = "InfoWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Sce);
var w4e = Sce.exports;
const O4e = /* @__PURE__ */ ce(w4e);
var Nce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Warning", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8639 1.51357C8.49039 0.828811 7.50961 0.828811 7.1361 1.51357L1.12218 12.5388C0.763263 13.1968 1.23814 14 1.98608 14H14.0139C14.7619 14 15.2367 13.1968 14.8778 12.5388L8.8639 1.51357ZM7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z", fill: "currentColor" }));
    };
    return P.displayName = "Warning", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Nce);
var x4e = Nce.exports;
const E4e = /* @__PURE__ */ ce(x4e);
function ct(e, t, n) {
  return (t = function(r) {
    var l = function(i, c) {
      if (typeof i != "object" || i === null)
        return i;
      var f = i[Symbol.toPrimitive];
      if (f !== void 0) {
        var d = f.call(i, c || "default");
        if (typeof d != "object")
          return d;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(i);
    }(r, "string");
    return typeof l == "symbol" ? l : String(l);
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Xu() {
  return Xu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xu.apply(this, arguments);
}
function $4e(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function mt(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var v$, b$, y$, w$, O$, x$, E$, $$, j$, Yl, Xl, Zc, C$, M$, k$, P$, Tc, S$, N$, R$, _$, Ql, A$, L$, Z$, T$, Jl, Bc, ei, B$, I$, H$, D$, z$, F$, V$, q$, U$, ti, ni, Ic, W$, G$, yt = { Info: "info", Warning: "warning", Danger: "danger", Success: "success" }, j4e = v(v$ || (v$ = mt([`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 8px; // Icon is 24px(it's 24px to include hover background), in figma its 16px(does not include the hover background) (24px - 16px)/2 = 4. The space between the icon and the banner is 12px from the right, 12px - 4px = 8px
  top: 8px;
  flex-shrink: 0;
  cursor: pointer;
`]))), C4e = v(b$ || (b$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, `,
      0 0 0 4px `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.blue.light2, b.blue.light2, b.blue.dark3, b.blue.light1, b.blue.dark2), M4e = v(y$ || (y$ = mt([`
  color: `, `;
  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, `,
      0 0 0 4px `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.yellow.light2, b.yellow.light2, b.yellow.dark3, b.blue.light1, b.yellow.dark2), k4e = v(w$ || (w$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, ", 0 0 0 4px ", `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.red.light2, b.red.light2, b.red.dark3, b.blue.light1, b.red.dark2), P4e = v(O$ || (O$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, `,
      0 0 0 4px `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.green.light2, b.green.light2, b.green.dark3, b.blue.light1, b.green.dark2), S4e = v(x$ || (x$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.blue.dark2, b.blue.dark2, b.blue.light2), N4e = v(E$ || (E$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.yellow.dark2, b.yellow.dark2, b.yellow.light2), R4e = v($$ || ($$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.red.dark2, b.red.dark2, b.red.light2), _4e = v(j$ || (j$ = mt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.green.dark2, b.green.dark2, b.green.light2), A4e = (ct(Zc = {}, S.Dark, (ct(Yl = {}, yt.Info, C4e), ct(Yl, yt.Warning, M4e), ct(Yl, yt.Danger, k4e), ct(Yl, yt.Success, P4e), Yl)), ct(Zc, S.Light, (ct(Xl = {}, yt.Info, S4e), ct(Xl, yt.Warning, N4e), ct(Xl, yt.Danger, R4e), ct(Xl, yt.Success, _4e), Xl)), Zc), L4e = function(e) {
  var t = e.onClose, n = e.darkMode, r = e.theme, l = e.variant;
  return k.createElement(v1, { className: H(j4e, A4e[r][l]), "aria-label": "Close Message", onClick: t, darkMode: n }, k.createElement(h4e, null));
}, Z4e = v(C$ || (C$ = mt([`
  position: relative;
  flex-shrink: 0;
`]))), T4e = v(M$ || (M$ = mt([`
  // this margin is set to control text alignment with the base of the renderedImage
  margin-top: 3px;
  margin-bottom: 3px;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`]))), B4e = (ct(Tc = {}, W.Body1, v(k$ || (k$ = mt([`
    top: 2px; // 18px(height in figma) - 16px(actual height of icon)
  `])))), ct(Tc, W.Body2, v(P$ || (P$ = mt([`
    top: 5.5px; // 21.5px(height in figma) - 16px(actual height of icon)
  `])))), Tc), I4e = (ct(Bc = {}, S.Dark, (ct(Ql = {}, yt.Info, v(S$ || (S$ = mt([`
      color: `, `;
    `])), b.blue.light1)), ct(Ql, yt.Warning, v(N$ || (N$ = mt([`
      color: `, `;
    `])), b.yellow.base)), ct(Ql, yt.Danger, v(R$ || (R$ = mt([`
      color: `, `;
    `])), b.red.light1)), ct(Ql, yt.Success, v(_$ || (_$ = mt([`
      color: `, `;
    `])), b.green.base)), Ql)), ct(Bc, S.Light, (ct(Jl = {}, yt.Info, v(A$ || (A$ = mt([`
      color: `, `;
    `])), b.blue.base)), ct(Jl, yt.Warning, v(L$ || (L$ = mt([`
      color: `, `;
    `])), b.yellow.dark2)), ct(Jl, yt.Danger, v(Z$ || (Z$ = mt([`
      color: `, `;
    `])), b.red.base)), ct(Jl, yt.Success, v(T$ || (T$ = mt([`
      color: `, `;
    `])), b.green.dark1)), Jl)), Bc), H4e = (ct(ei = {}, yt.Info, O4e), ct(ei, yt.Warning, y4e), ct(ei, yt.Danger, E4e), ct(ei, yt.Success, v4e), ei), D4e = function(e) {
  var t = e.image, n = e.baseFontSize, r = e.variant, l = e.theme, i = H4e[r];
  return t ? k.cloneElement(t, { className: T4e }) : k.createElement(i, { className: H(Z4e, I4e[l][r], B4e[n]) });
}, z4e = v(B$ || (B$ = mt([`
  position: relative;
  display: flex;
  padding: 10px 12px 10px 20px;
  border-width: 1px 1px 1px 0px;
  border-style: solid;
  border-radius: 12px;
  font-family: `, `;

  &:before {
    content: '';
    position: absolute;
    width: 13px;
    top: -1px;
    bottom: -1px;
    left: 0px;
    border-radius: 12px 0px 0px 12px;
  }
`])), Q.default), F4e = v(I$ || (I$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.blue.light2, b.blue.dark2, b.blue.light1, b.blue.dark3, qn, b.blue.light3, b.blue.light2, b.blue.dark3, b.blue.light1, b.blue.light1), V4e = v(H$ || (H$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.yellow.light2, b.yellow.dark2, b.yellow.dark2, b.yellow.dark3, qn, b.yellow.light3, b.yellow.light2, b.yellow.dark3, b.blue.light1, b.yellow.dark2), q4e = v(D$ || (D$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.red.light2, b.red.dark2, b.red.base, b.red.dark3, qn, b.red.light3, b.red.light2, b.red.dark3, b.blue.light1, b.red.base), U4e = v(z$ || (z$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.green.light2, b.green.dark2, b.green.base, b.green.dark3, qn, b.green.light3, b.green.light2, b.green.dark3, b.blue.light1, b.green.base), W4e = v(F$ || (F$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.blue.dark2, b.blue.light2, b.blue.base, b.blue.light3, qn, b.blue.dark3, b.blue.dark2, b.blue.light3, b.white, b.blue.light1, b.blue.base), G4e = v(V$ || (V$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.yellow.dark2, b.yellow.light2, b.yellow.base, b.yellow.light3, qn, b.yellow.dark3, b.yellow.dark2, b.yellow.light3, b.white, b.blue.light1, b.yellow.base), K4e = v(q$ || (q$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.red.dark2, b.red.light2, b.red.base, b.red.light3, qn, b.red.dark3, b.red.dark2, b.red.light3, b.white, b.blue.light1, b.red.base), Y4e = v(U$ || (U$ = mt([`
  color: `, `;
  border-color: `, `;
  border-left-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.green.dark2, b.green.light2, b.green.base, b.green.light3, qn, b.green.dark3, b.green.dark2, b.green.light3, b.white, b.blue.light1, b.green.dark1), X4e = (ct(Ic = {}, S.Dark, (ct(ti = {}, yt.Info, F4e), ct(ti, yt.Warning, V4e), ct(ti, yt.Danger, q4e), ct(ti, yt.Success, U4e), ti)), ct(Ic, S.Light, (ct(ni = {}, yt.Info, W4e), ct(ni, yt.Warning, G4e), ct(ni, yt.Danger, K4e), ct(ni, yt.Success, Y4e), ni)), Ic), Q4e = function(e, t) {
  return v(W$ || (W$ = mt([`
  align-self: center;
  flex-grow: 1;
  margin-left: `, `;
  margin-right: `, `;

  .`, `, a {
    font-size: inherit;
    line-height: inherit;
    font-weight: `, `;
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 2px;
    border-radius: 4px;
    display: inline;

    &:hover,
    &:focus,
    &:focus-visible {
      outline: none;
      span {
        &::after {
          display: none;
        }
      }
    }

    &:focus-visible {
      position: relative;
    }
  }
`])), K$(e, t).marginLeft, K$(e, t).marginRight, qn, Y.bold);
}, K$ = function(e, t) {
  var n = { marginLeft: void 0, marginRight: void 0 };
  return e ? (n.marginLeft = "17px", n.marginRight = "4px", t && (n.marginRight = "".concat(28, "px"))) : (n.marginLeft = "13px", n.marginRight = "10px", t && (n.marginRight = "".concat(32, "px"))), n;
}, J4e = v(G$ || (G$ = mt([`
  padding-right: 36px; // add space for the icon
`]))), eve = ["variant", "dismissible", "onClose", "image", "children", "className", "darkMode", "baseFontSize"];
function Qu(e) {
  var t = e.variant, n = t === void 0 ? yt.Info : t, r = e.dismissible, l = r !== void 0 && r, i = e.onClose, c = i === void 0 ? function() {
  } : i, f = e.image, d = e.children, h = e.className, g = e.darkMode, m = e.baseFontSize, y = $4e(e, eve), w = K(g), C = w.theme, E = w.darkMode, R = Ra(m);
  return k.createElement("div", Xu({ role: "alert", className: H(z4e, K9[R], X4e[C][n], ct({}, J4e, l), h) }, y), k.createElement(D4e, { image: f, theme: C, baseFontSize: R, variant: n }), k.createElement("div", { className: Q4e(f != null, l) }, d), l && k.createElement(L4e, { theme: C, baseFontSize: R, variant: n, onClose: c, darkMode: E }));
}
Qu.displayName = "Banner", Qu.propTypes = { darkMode: z.bool, variant: z.oneOf(Object.values(yt)), onClose: z.func, dismissible: z.bool, image: z.element, baseFontSize: z.oneOf(Object.values(W)) };
function tve(e) {
  const { message: t = "Something went wrong" } = e, { darkMode: n } = K();
  return /* @__PURE__ */ Ze.jsxs(Qu, { darkMode: e.darkMode ?? n, variant: "danger", children: [
    t,
    /* @__PURE__ */ Ze.jsx("br", {}),
    "Reload the page to start a new conversation."
  ] });
}
function Ju(e, t, n) {
  return (t = function(r) {
    var l = function(i, c) {
      if (typeof i != "object" || i === null)
        return i;
      var f = i[Symbol.toPrimitive];
      if (f !== void 0) {
        var d = f.call(i, c || "default");
        if (typeof d != "object")
          return d;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(i);
    }(r, "string");
    return typeof l == "symbol" ? l : String(l);
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function e2() {
  return e2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e2.apply(this, arguments);
}
function nve(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function di(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var Y$, X$, Q$, J$, Hc, ej, tj = "0 4px 10px -4px ".concat($r(0.7, b.black)), nj = "0 4px 20px -4px ".concat($r(0.8, b.black)), rj = it.light.default, aj = "0 4px 20px -4px #01121A", lj = "0 4px 20px -4px ".concat($r(0.3, "#000000")), ij = it.dark.default, oj = (Ju(Hc = {}, S.Light, { containerStyle: v(Y$ || (Y$ = di([`
      border: 1px solid `, `;
      box-shadow: `, `;
      background-color: `, `;
      color: `, `;
    `])), b.gray.light2, tj, b.white, b.gray.dark3), clickableStyle: v(X$ || (X$ = di([`
      cursor: pointer;

      &:focus {
        outline: none;
        box-shadow: `, ", ", `;
      }

      &:hover,
      &:active {
        border: 1px solid `, `;
        box-shadow: `, `;

        &:focus {
          box-shadow: `, ", ", `;
        }
      }
    `])), rj, tj, b.gray.light2, nj, rj, nj) }), Ju(Hc, S.Dark, { containerStyle: v(Q$ || (Q$ = di([`
      border: 1px solid `, `;
      box-shadow: `, `;
      background-color: `, `;
      color: `, `;
    `])), b.gray.dark2, aj, b.black, b.white), clickableStyle: v(J$ || (J$ = di([`
      cursor: pointer;

      &:focus {
        outline: none;
        box-shadow: `, ", ", `;
      }

      &:hover {
        box-shadow: `, `;

        &:focus {
          box-shadow: `, ", ", `;
        }
      }
    `])), aj, ij, lj, lj, ij) }), Hc), rve = v(ej || (ej = di([`
  position: relative;
  transition: `, `ms ease-in-out;
  transition-property: border, box-shadow;
  border-radius: 24px;
  font-family: `, `;
  font-size: `, `px;
  line-height: `, `px;
  padding: 24px;
  min-height: 68px; // 48px + 20px (padding + line-height)
`])), It.default, Q.default, V.body1.fontSize, V.body1.lineHeight), t2 = { None: "none", Clickable: "clickable" }, ave = ["className", "contentStyle", "darkMode"], n2 = k.forwardRef(function(e, t) {
  var n = e.className, r = e.contentStyle, l = e.darkMode, i = nve(e, ave);
  r === void 0 && ("onClick" in i && i.onClick !== void 0 || "href" in i && i.href) && (r = t2.Clickable);
  var c = K(l).theme;
  return k.createElement(Ype, e2({ className: H(rve, oj[c].containerStyle, Ju({}, oj[c].clickableStyle, r === t2.Clickable), n), ref: t }, i));
});
n2.displayName = "Card", n2.propTypes = { className: z.string, darkMode: z.bool, contentStyle: z.oneOf(Object.values(t2)) };
var Rce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Rce);
var lve = Rce.exports;
const ive = /* @__PURE__ */ ce(lve);
var _ce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(_ce);
var ove = _ce.exports;
const sve = /* @__PURE__ */ ce(ove);
var Ace = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Ace);
var cve = Ace.exports;
const uve = /* @__PURE__ */ ce(cve);
function fve(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function We(e, t, n) {
  return (t = fve(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mn.apply(this, arguments);
}
function fr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Oe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function dve(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return sj(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return sj(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function sj(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var cj, uj, fj, dj, pj, gj, hj, mj, Sl = v(cj || (cj = Oe([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), Lce = We(We({}, W.Body1, v(uj || (uj = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(fj || (fj = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), pve = We(We({}, W.Body1, v(dj || (dj = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(pj || (pj = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), x1 = We(We({}, S.Light, v(gj || (gj = Oe([`
    color: `, `;
  `])), b.black)), S.Dark, v(hj || (hj = Oe([`
    color: `, `;
  `])), b.gray.light2)), Nl = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, gve = ["baseFontSize", "darkMode", "className", "weight", "as"], hve = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = fr(e, gve), h = K(n).theme, g = Nl(t), m = ne(f).Component, y = v(mj || (mj = Oe([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, Mn({ className: H(Sl, Lce[g], x1[h], y, r) }, d));
});
hve.displayName = "Body";
var vj, bj, yj, wj, Oj, xj, Ej, $j, jj, Cj, mve = { label: "lg-label", description: "lg-description" };
v(vj || (vj = Oe([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
We(We({}, S.Light, v(bj || (bj = Oe([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(yj || (yj = Oe([`
    color: `, `;
  `])), b.gray.light1));
We(We({}, S.Light, v(wj || (wj = Oe([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(Oj || (Oj = Oe([`
    color: `, `;
  `])), b.gray.dark1));
We(We({}, W.Body1, v(xj || (xj = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Ej || (Ej = Oe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var Mj, kj, Pj, Sj, Nj;
We(We({}, S.Light, v($j || ($j = Oe([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(jj || (jj = Oe([`
    color: `, `;
  `])), b.gray.light1));
v(Cj || (Cj = Oe([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var Rj, _j, Aj, Lj, Zj, Tj, vve = v(Mj || (Mj = Oe([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), bve = We(We({}, S.Light, v(kj || (kj = Oe([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(Pj || (Pj = Oe([`
    color: `, `;
  `])), b.red.light1)), yve = We(We({}, W.Body1, v(Sj || (Sj = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Nj || (Nj = Oe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), wve = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = fr(e, wve), f = K(r).theme, d = Nl(), h = ne(n).Component;
  return k.createElement(h, Mn({}, c, { className: H(vve, bve[f], yve[d], i) }), l);
});
var Ove = v(Rj || (Rj = Oe([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), xve = We(We({}, S.Light, v(_j || (_j = Oe([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(Aj || (Aj = Oe([`
    color: `, `;
  `])), b.gray.light2)), Eve = ["darkMode", "className", "as"], $ve = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = fr(e, Eve), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Mn({ className: H(Sl, Ove, xve[c], n) }, i));
});
$ve.displayName = "H1";
var Bj, jve = v(Lj || (Lj = Oe([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), Cve = We(We({}, S.Light, v(Zj || (Zj = Oe([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(Tj || (Tj = Oe([`
    color: `, `;
  `])), b.gray.light2)), Mve = ["darkMode", "className", "as"], kve = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = fr(e, Mve), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Mn({ className: H(Sl, jve, Cve[c], n) }, i));
});
kve.displayName = "H2";
var Ij, Hj, Dj, zj, Fj, Vj, qj, Uj, Wj, Gj, Pve = v(Bj || (Bj = Oe([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), Sve = ["darkMode", "className", "as"], Nve = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = fr(e, Sve), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Mn({ className: H(Sl, Pve, x1[c], n) }, i));
});
Nve.displayName = "H3";
var Kj, Yj, Xj, ul = gt(), Rve = v(Ij || (Ij = Oe([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, ul), _ve = We(We({}, S.Light, v(Hj || (Hj = Oe([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, ul, b.gray.light2, b.gray.light1)), S.Dark, v(Dj || (Dj = Oe([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, ul, b.gray.dark2, b.gray.dark1)), Ave = We(We({}, S.Light, v(zj || (zj = Oe([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ul, it[S.Light].default, b.blue.base)), S.Dark, v(Fj || (Fj = Oe([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ul, it[S.Dark].default, b.blue.base)), Lve = We(We({}, S.Light, v(Vj || (Vj = Oe([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(qj || (qj = Oe([`
    color: `, `;
  `])), b.blue.light1)), Zve = v(Uj || (Uj = Oe([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), Tve = v(Wj || (Wj = Oe([`
  white-space: nowrap;
`]))), Bve = v(Gj || (Gj = Oe([`
  white-space: normal;
`]))), Ive = ["children", "className", "darkMode", "baseFontSize", "as"], Qj = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = fr(e, Ive), g = K(c).theme, m = Nl(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? Tve : Bve, C = y !== "code", E = k.createElement("code", { ref: t, className: H(pve[m], Rve, _ve[g], Ave[g], w, We({}, Lve[g], C), i) }, l);
  return C ? k.createElement(y, Mn({ className: H(ul, Zve, i) }, h), E) : k.cloneElement(E, h);
});
Qj.displayName = "InlineCode", Qj.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var Jj, eC, tC, nC, rC, aC, lC;
v(Kj || (Kj = Oe([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
We(We({}, S.Light, v(Yj || (Yj = Oe([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(Xj || (Xj = Oe([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var iC, oC, sC, Hve = v(Jj || (Jj = Oe([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), Dve = We(We({}, S.Light, v(eC || (eC = Oe([`
    color: `, `;
  `])), b.black)), S.Dark, v(tC || (tC = Oe([`
    color: `, `;
  `])), b.gray.light2)), zve = We(We({}, S.Light, v(nC || (nC = Oe([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(rC || (rC = Oe([`
    color: `, `;
  `])), b.gray.dark1)), Fve = We(We({}, W.Body1, v(aC || (aC = Oe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(lC || (lC = Oe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), Vve = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], qve = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? mve.label : h, m = fr(e, Vve), y = K(n).theme, w = Nl(t), C = ne(d).Component;
  return k.createElement(C, Mn({ "data-lgid": g, className: H(Hve, Dve[y], Fve[w], We({}, zve[y], c), r) }, m), l);
});
qve.displayName = "Label";
var cC, uC, fC, dC, pC, gC, No = gt(), Zce = v(iC || (iC = Oe([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), Tce = We(We({}, S.Light, v(oC || (oC = Oe([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(sC || (sC = Oe([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), Bce = function(e) {
  if (e)
    return Lce[e];
}, Uve = v(cC || (cC = Oe([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), Wve = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = fr(e, Wve), d = K(i).theme, h = Nl(l), g = nt(c, f, "span").Component;
  return k.createElement(g, Mn({ className: H(No, Zce, Bce(h), Tce[d], Uve, r), ref: t }, f), k.createElement(ive, { role: "presentation" }), n);
});
var Gve = v(uC || (uC = Oe([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), Kve = v(fC || (fC = Oe([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), No, No), Yve = v(dC || (dC = Oe([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), Xve = "hover", Qve = "persist", hC = "none", Jve = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? hC : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = fr(e, Jve), y = dve(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Nl(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== hC && (E = k.createElement(sve, { role: "presentation", size: 12, className: H(We(We({}, Kve, i === Xve), Gve, i === Qve)) })) : E = k.createElement(uve, { role: "presentation", className: Yve }), k.createElement(P, Mn({ className: H(No, Zce, Bce(M), Tce[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var e6e = v(pC || (pC = Oe([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), t6e = ["darkMode", "className", "as"], n6e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = fr(e, t6e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Mn({ className: H(Sl, e6e, x1[c], n) }, i));
});
n6e.displayName = "Overline";
var r6e = v(gC || (gC = Oe([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), a6e = ["darkMode", "className", "as"], l6e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = fr(e, a6e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Mn({ className: H(Sl, r6e, x1[c], n) }, i));
});
l6e.displayName = "Subtitle";
var mC;
v(mC || (mC = Oe([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function i6e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function $a(e, t, n) {
  return (t = i6e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ro() {
  return Ro = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ro.apply(this, arguments);
}
function Ice(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Bt(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var vC, bC, yC;
v(vC || (vC = Bt([`
  width: 100%;
`])));
var wC, OC;
v(bC || (bC = Bt([`
  width: 100%;
  display: grid;
  row-gap: `, `px;
  grid-template-columns: 75px 1fr 75px;
`])), ee[3]);
v(yC || (yC = Bt([`
  &:nth-child(even) {
    grid-column: 2 / -1;
  }

  &:nth-child(odd) {
    grid-column: 1 / span 2;
  }
`])));
v(wC || (wC = Bt([`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: `, `px;
`])), ee[3]);
v(OC || (OC = Bt([`
  grid-column-start: 1;
  grid-column-end: 3;
`])));
var xC, EC, $C, jC, CC, MC, kC, PC, ja = { Small: "small", Default: "default", Large: "large" }, o6e = function(e) {
  var t = e.enableAnimations;
  return v(xC || (xC = Bt([`
  width: 100%;
  border-radius: `, `px;
  background-position: 50vw 0;

  `, `
`])), ee[150], t && v(EC || (EC = Bt([`
    animation: SkeletonShimmer 1.5s infinite linear;

    @keyframes SkeletonShimmer {
      to {
        background-position: 100vw 0;
      }
    }
  `]))));
};
v($C || ($C = Bt([`
  width: 100%;
  border-radius: 6px;
`])));
var SC, s6e = $a($a($a({}, ja.Small, v(jC || (jC = Bt([`
    height: `, `px;
  `])), ee[400])), ja.Default, v(CC || (CC = Bt([`
    height: `, `px;
  `])), ee[800])), ja.Large, v(MC || (MC = Bt([`
    height: `, `px;
  `])), ee[1200])), c6e = $a($a({}, S.Dark, v(kC || (kC = Bt([`
    background: linear-gradient(
        110deg,
        `, ` 35%,
        `, `,
        `, ` 65%
      )
      0 0/ 100vw 100% fixed;
  `])), b.gray.dark2, b.gray.dark1, b.gray.dark2)), S.Light, v(PC || (PC = Bt([`
    background: linear-gradient(
        110deg,
        `, ` 35%,
        `, `,
        `, ` 65%
      )
      0 0/ 100vw 100% fixed;
  `])), b.gray.light2, b.gray.light3, b.gray.light2)), u6e = ["enableAnimations", "size", "darkMode", "className"];
function pi(e) {
  var t = e.enableAnimations, n = t === void 0 || t, r = e.size, l = r === void 0 ? ja.Default : r, i = e.darkMode, c = e.className, f = Ice(e, u6e), d = K(i).theme;
  return k.createElement("div", Ro({ className: H(o6e({ enableAnimations: n }), s6e[l], c6e[d], c), "aria-hidden": !0 }, f));
}
pi.displayName = "Skeleton";
var NC, RC, _C, AC;
v(SC || (SC = Bt([`
  width: 100%;
  padding: 0;
  margin: 0;
`])));
var LC, ZC, TC, BC, IC, HC, DC, f6e = v(NC || (NC = Bt([`
  width: 100%;
`]))), d6e = v(RC || (RC = Bt([`
  width: 250px;
  margin-bottom: 20px;
`]))), zC = v(_C || (_C = Bt([`
  margin-bottom: `, `px;
`])), ee[3]), p6e = v(AC || (AC = Bt([`
  width: 350px;
`]))), g6e = ["darkMode", "enableAnimations", "withHeader", "className"];
function Hce(e) {
  var t = e.darkMode, n = e.enableAnimations, r = e.withHeader, l = r !== void 0 && r, i = e.className, c = Ice(e, g6e), f = K(t).darkMode;
  return k.createElement(Fn, { darkMode: f }, k.createElement("div", Ro({}, c, { className: H(f6e, i), "aria-busy": !0 }), l && k.createElement(pi, { enableAnimations: n, className: d6e, "data-testid": "lg-paragraph-skeleton-header" }), k.createElement(pi, { enableAnimations: n, size: ja.Small, className: zC }), k.createElement(pi, { enableAnimations: n, size: ja.Small, className: zC }), k.createElement(pi, { enableAnimations: n, size: ja.Small, className: p6e })));
}
Hce.displayName = "ParagraphSkeleton";
v(LC || (LC = Bt([`
  width: 100%;
  table-layout: fixed;
`])));
v(ZC || (ZC = Bt([`
  padding: 10px 40px 10px 8px;
`])));
$a($a({}, S.Dark, v(TC || (TC = Bt([`
    background-color: `, `;
    box-shadow: 0 3px `, `;
  `])), b.black, b.gray.dark2)), S.Light, v(BC || (BC = Bt([`
    background-color: `, `;
    box-shadow: 0 3px `, `;
  `])), b.white, b.gray.light2));
v(IC || (IC = Bt([`
  margin-top: 2px; // the td doesn't start exactly at the bottom of the box-shadow
`])));
v(HC || (HC = Bt([`
  text-align: left;
`])));
v(DC || (DC = Bt([`
  font-weight: 600;
`])));
var Dce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Dce);
var h6e = Dce.exports;
const m6e = /* @__PURE__ */ ce(h6e);
var zce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(zce);
var v6e = zce.exports;
const b6e = /* @__PURE__ */ ce(v6e);
var Fce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Fce);
var y6e = Fce.exports;
const w6e = /* @__PURE__ */ ce(y6e);
function O6e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ge(e, t, n) {
  return (t = O6e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function kn() {
  return kn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kn.apply(this, arguments);
}
function dr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function xe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function x6e(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return FC(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return FC(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function FC(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var VC, qC, UC, WC, GC, KC, YC, XC, Rl = v(VC || (VC = xe([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), Y9 = Ge(Ge({}, W.Body1, v(qC || (qC = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(UC || (UC = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), E6e = Ge(Ge({}, W.Body1, v(WC || (WC = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(GC || (GC = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), E1 = Ge(Ge({}, S.Light, v(KC || (KC = xe([`
    color: `, `;
  `])), b.black)), S.Dark, v(YC || (YC = xe([`
    color: `, `;
  `])), b.gray.light2)), _a = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, $6e = ["baseFontSize", "darkMode", "className", "weight", "as"], j6e = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = dr(e, $6e), h = K(n).theme, g = _a(t), m = ne(f).Component, y = v(XC || (XC = xe([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, kn({ className: H(Rl, Y9[g], E1[h], y, r) }, d));
});
j6e.displayName = "Body";
var QC, JC, eM, tM, nM, rM, aM, lM, iM, oM, C6e = { label: "lg-label", description: "lg-description" };
v(QC || (QC = xe([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Ge(Ge({}, S.Light, v(JC || (JC = xe([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(eM || (eM = xe([`
    color: `, `;
  `])), b.gray.light1));
Ge(Ge({}, S.Light, v(tM || (tM = xe([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(nM || (nM = xe([`
    color: `, `;
  `])), b.gray.dark1));
Ge(Ge({}, W.Body1, v(rM || (rM = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(aM || (aM = xe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var sM, cM, uM, fM, dM;
Ge(Ge({}, S.Light, v(lM || (lM = xe([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(iM || (iM = xe([`
    color: `, `;
  `])), b.gray.light1));
v(oM || (oM = xe([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var pM, gM, hM, mM, vM, bM, M6e = v(sM || (sM = xe([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), k6e = Ge(Ge({}, S.Light, v(cM || (cM = xe([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(uM || (uM = xe([`
    color: `, `;
  `])), b.red.light1)), P6e = Ge(Ge({}, W.Body1, v(fM || (fM = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(dM || (dM = xe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), S6e = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = dr(e, S6e), f = K(r).theme, d = _a(), h = ne(n).Component;
  return k.createElement(h, kn({}, c, { className: H(M6e, k6e[f], P6e[d], i) }), l);
});
var N6e = v(pM || (pM = xe([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), R6e = Ge(Ge({}, S.Light, v(gM || (gM = xe([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(hM || (hM = xe([`
    color: `, `;
  `])), b.gray.light2)), _6e = ["darkMode", "className", "as"], A6e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = dr(e, _6e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, kn({ className: H(Rl, N6e, R6e[c], n) }, i));
});
A6e.displayName = "H1";
var yM, L6e = v(mM || (mM = xe([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), Z6e = Ge(Ge({}, S.Light, v(vM || (vM = xe([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(bM || (bM = xe([`
    color: `, `;
  `])), b.gray.light2)), T6e = ["darkMode", "className", "as"], B6e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = dr(e, T6e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, kn({ className: H(Rl, L6e, Z6e[c], n) }, i));
});
B6e.displayName = "H2";
var wM, OM, xM, EM, $M, jM, CM, MM, kM, PM, I6e = v(yM || (yM = xe([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), H6e = ["darkMode", "className", "as"], D6e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = dr(e, H6e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, kn({ className: H(Rl, I6e, E1[c], n) }, i));
});
D6e.displayName = "H3";
var SM, NM, RM, fl = gt(), z6e = v(wM || (wM = xe([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, fl), F6e = Ge(Ge({}, S.Light, v(OM || (OM = xe([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, fl, b.gray.light2, b.gray.light1)), S.Dark, v(xM || (xM = xe([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, fl, b.gray.dark2, b.gray.dark1)), V6e = Ge(Ge({}, S.Light, v(EM || (EM = xe([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), fl, it[S.Light].default, b.blue.base)), S.Dark, v($M || ($M = xe([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), fl, it[S.Dark].default, b.blue.base)), q6e = Ge(Ge({}, S.Light, v(jM || (jM = xe([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(CM || (CM = xe([`
    color: `, `;
  `])), b.blue.light1)), U6e = v(MM || (MM = xe([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), W6e = v(kM || (kM = xe([`
  white-space: nowrap;
`]))), G6e = v(PM || (PM = xe([`
  white-space: normal;
`]))), K6e = ["children", "className", "darkMode", "baseFontSize", "as"], _M = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = dr(e, K6e), g = K(c).theme, m = _a(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? W6e : G6e, C = y !== "code", E = k.createElement("code", { ref: t, className: H(E6e[m], z6e, F6e[g], V6e[g], w, Ge({}, q6e[g], C), i) }, l);
  return C ? k.createElement(y, kn({ className: H(fl, U6e, i) }, h), E) : k.cloneElement(E, h);
});
_M.displayName = "InlineCode", _M.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var AM, LM, ZM, TM, BM, IM, HM;
v(SM || (SM = xe([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Ge(Ge({}, S.Light, v(NM || (NM = xe([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(RM || (RM = xe([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var DM, zM, FM, Y6e = v(AM || (AM = xe([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), X6e = Ge(Ge({}, S.Light, v(LM || (LM = xe([`
    color: `, `;
  `])), b.black)), S.Dark, v(ZM || (ZM = xe([`
    color: `, `;
  `])), b.gray.light2)), Q6e = Ge(Ge({}, S.Light, v(TM || (TM = xe([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(BM || (BM = xe([`
    color: `, `;
  `])), b.gray.dark1)), J6e = Ge(Ge({}, W.Body1, v(IM || (IM = xe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(HM || (HM = xe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), e7e = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], t7e = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? C6e.label : h, m = dr(e, e7e), y = K(n).theme, w = _a(t), C = ne(d).Component;
  return k.createElement(C, kn({ "data-lgid": g, className: H(Y6e, X6e[y], J6e[w], Ge({}, Q6e[y], c), r) }, m), l);
});
t7e.displayName = "Label";
var VM, qM, UM, WM, GM, KM, Pn = gt(), Vce = v(DM || (DM = xe([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), qce = Ge(Ge({}, S.Light, v(zM || (zM = xe([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(FM || (FM = xe([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), Uce = function(e) {
  if (e)
    return Y9[e];
}, n7e = v(VM || (VM = xe([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), r7e = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = dr(e, r7e), d = K(i).theme, h = _a(l), g = nt(c, f, "span").Component;
  return k.createElement(g, kn({ className: H(Pn, Vce, Uce(h), qce[d], n7e, r), ref: t }, f), k.createElement(m6e, { role: "presentation" }), n);
});
var a7e = v(qM || (qM = xe([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), l7e = v(UM || (UM = xe([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Pn, Pn), i7e = v(WM || (WM = xe([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), o7e = "hover", s7e = "persist", YM = "none", c7e = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"], u7e = tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? YM : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = dr(e, c7e), y = x6e(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = _a(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== YM && (E = k.createElement(b6e, { role: "presentation", size: 12, className: H(Ge(Ge({}, l7e, i === o7e), a7e, i === s7e)) })) : E = k.createElement(w6e, { role: "presentation", className: i7e }), k.createElement(P, kn({ className: H(Pn, Vce, Uce(M), qce[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
}), f7e = v(GM || (GM = xe([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), d7e = ["darkMode", "className", "as"], p7e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = dr(e, d7e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, kn({ className: H(Rl, f7e, E1[c], n) }, i));
});
p7e.displayName = "Overline";
var g7e = v(KM || (KM = xe([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), h7e = ["darkMode", "className", "as"], Wce = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = dr(e, h7e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, kn({ className: H(Rl, g7e, E1[c], n) }, i));
});
Wce.displayName = "Subtitle";
var XM;
v(XM || (XM = xe([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var Gce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "X", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2028 3.40381C11.8123 3.01329 11.1791 3.01329 10.7886 3.40381L8.3137 5.87869L5.83883 3.40381C5.44831 3.01329 4.81514 3.01329 4.42462 3.40381L3.71751 4.11092C3.32699 4.50144 3.32699 5.13461 3.71751 5.52513L6.19238 8.00001L3.71751 10.4749C3.32699 10.8654 3.32699 11.4986 3.71751 11.8891L4.42462 12.5962C4.81514 12.9867 5.44831 12.9867 5.83883 12.5962L8.3137 10.1213L10.7886 12.5962C11.1791 12.9867 11.8123 12.9867 12.2028 12.5962L12.9099 11.8891C13.3004 11.4986 13.3004 10.8654 12.9099 10.4749L10.435 8.00001L12.9099 5.52513C13.3004 5.13461 13.3004 4.50144 12.9099 4.11092L12.2028 3.40381Z", fill: "currentColor" }));
    };
    return P.displayName = "X", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Gce);
var m7e = Gce.exports;
const v7e = /* @__PURE__ */ ce(m7e);
var Kce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "CheckmarkWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.4485 4.89583C10.8275 4.45816 11.4983 4.43411 11.9077 4.84352C12.2777 5.21345 12.2989 5.80633 11.9564 6.2018L7.38365 11.4818C7.31367 11.5739 7.22644 11.6552 7.12309 11.7208C6.65669 12.0166 6.03882 11.8783 5.74302 11.4119L3.9245 8.54448C3.6287 8.07809 3.767 7.46021 4.2334 7.16442C4.69979 6.86863 5.31767 7.00693 5.61346 7.47332L6.71374 9.20819L10.4485 4.89583Z", fill: "currentColor" }));
    };
    return P.displayName = "CheckmarkWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Kce);
var b7e = Kce.exports;
const y7e = /* @__PURE__ */ ce(b7e);
var Yce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ImportantWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5V8.5C9 9.05228 8.55228 9.5 8 9.5C7.44772 9.5 7 9.05228 7 8.5V4.5ZM9 11.5C9 12.0523 8.55228 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5C7 10.9477 7.44772 10.5 8 10.5C8.55228 10.5 9 10.9477 9 11.5Z", fill: "currentColor" }));
    };
    return P.displayName = "ImportantWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Yce);
var w7e = Yce.exports;
const O7e = /* @__PURE__ */ ce(w7e);
var Xce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "InfoWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM8 6C8.55228 6 9 6.44772 9 7V11H9.5C9.77614 11 10 11.2239 10 11.5C10 11.7761 9.77614 12 9.5 12H6.5C6.22386 12 6 11.7761 6 11.5C6 11.2239 6.22386 11 6.5 11H7V7H6.5C6.22386 7 6 6.77614 6 6.5C6 6.22386 6.22386 6 6.5 6H8Z", fill: "currentColor" }));
    };
    return P.displayName = "InfoWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Xce);
var x7e = Xce.exports;
const E7e = /* @__PURE__ */ ce(x7e);
var Qce = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Warning", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8639 1.51357C8.49039 0.828811 7.50961 0.828811 7.1361 1.51357L1.12218 12.5388C0.763263 13.1968 1.23814 14 1.98608 14H14.0139C14.7619 14 15.2367 13.1968 14.8778 12.5388L8.8639 1.51357ZM7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z", fill: "currentColor" }));
    };
    return P.displayName = "Warning", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Qce);
var $7e = Qce.exports;
const j7e = /* @__PURE__ */ ce($7e);
function C7e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ut(e, t, n) {
  return (t = C7e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function r2() {
  return r2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r2.apply(this, arguments);
}
function M7e(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function vt(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var QM, JM, ek, tk, nk, rk, ak, lk, ik, ok, sk, ck, uk, fk, dk, pk, gk, hk, mk, vk, bk, yk, wk, Ok, xk, Ek, $k, jk, Ck, Mk, kk, Pk, wt = { Info: "info", Warning: "warning", Danger: "danger", Success: "success" }, k7e = v(QM || (QM = vt([`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 8px; // Icon is 24px(it's 24px to include hover background), in figma its 16px(does not include the hover background) (24px - 16px)/2 = 4. The space between the icon and the banner is 12px from the right, 12px - 4px = 8px
  top: 8px;
  flex-shrink: 0;
  cursor: pointer;
`]))), P7e = v(JM || (JM = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, `,
      0 0 0 4px `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.blue.light2, b.blue.light2, b.blue.dark3, b.blue.light1, b.blue.dark2), S7e = v(ek || (ek = vt([`
  color: `, `;
  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, `,
      0 0 0 4px `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.yellow.light2, b.yellow.light2, b.yellow.dark3, b.blue.light1, b.yellow.dark2), N7e = v(tk || (tk = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, ", 0 0 0 4px ", `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.red.light2, b.red.light2, b.red.dark3, b.blue.light1, b.red.dark2), R7e = v(nk || (nk = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;
    box-shadow: 0 0 0 2px `, `,
      0 0 0 4px `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.green.light2, b.green.light2, b.green.dark3, b.blue.light1, b.green.dark2), _7e = v(rk || (rk = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.blue.dark2, b.blue.dark2, b.blue.light2), A7e = v(ak || (ak = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.yellow.dark2, b.yellow.dark2, b.yellow.light2), L7e = v(lk || (lk = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.red.dark2, b.red.dark2, b.red.light2), Z7e = v(ik || (ik = vt([`
  color: `, `;

  &:active,
  &:hover,
  &:focus-visible {
    color: `, `;

    &:before {
      background-color: `, `;
    }
  }
`])), b.green.dark2, b.green.dark2, b.green.light2), T7e = ut(ut({}, S.Dark, ut(ut(ut(ut({}, wt.Info, P7e), wt.Warning, S7e), wt.Danger, N7e), wt.Success, R7e)), S.Light, ut(ut(ut(ut({}, wt.Info, _7e), wt.Warning, A7e), wt.Danger, L7e), wt.Success, Z7e)), B7e = function(e) {
  var t = e.onClose, n = e.darkMode, r = e.theme, l = e.variant;
  return k.createElement(v1, { className: H(k7e, T7e[r][l]), "aria-label": "Close Message", onClick: t, darkMode: n }, k.createElement(v7e, null));
}, I7e = v(ok || (ok = vt([`
  position: relative;
  flex-shrink: 0;
`]))), H7e = v(sk || (sk = vt([`
  // this margin is set to control text alignment with the base of the renderedImage
  margin-top: 3px;
  margin-bottom: 3px;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`]))), D7e = ut(ut({}, W.Body1, v(ck || (ck = vt([`
    top: 2px; // 18px(height in figma) - 16px(actual height of icon)
  `])))), W.Body2, v(uk || (uk = vt([`
    top: 5.5px; // 21.5px(height in figma) - 16px(actual height of icon)
  `])))), z7e = ut(ut({}, S.Dark, ut(ut(ut(ut({}, wt.Info, v(fk || (fk = vt([`
      color: `, `;
    `])), b.blue.light1)), wt.Warning, v(dk || (dk = vt([`
      color: `, `;
    `])), b.yellow.base)), wt.Danger, v(pk || (pk = vt([`
      color: `, `;
    `])), b.red.light1)), wt.Success, v(gk || (gk = vt([`
      color: `, `;
    `])), b.green.base))), S.Light, ut(ut(ut(ut({}, wt.Info, v(hk || (hk = vt([`
      color: `, `;
    `])), b.blue.base)), wt.Warning, v(mk || (mk = vt([`
      color: `, `;
    `])), b.yellow.dark2)), wt.Danger, v(vk || (vk = vt([`
      color: `, `;
    `])), b.red.base)), wt.Success, v(bk || (bk = vt([`
      color: `, `;
    `])), b.green.dark1))), F7e = ut(ut(ut(ut({}, wt.Info, E7e), wt.Warning, O7e), wt.Danger, j7e), wt.Success, y7e), V7e = function(e) {
  var t = e.image, n = e.baseFontSize, r = e.variant, l = e.theme, i = F7e[r];
  return t ? k.cloneElement(t, { className: H7e }) : k.createElement(i, { className: H(I7e, z7e[l][r], D7e[n]) });
}, q7e = v(yk || (yk = vt([`
  position: relative;
  display: flex;
  padding: 10px 12px 10px 20px;
  border-width: 1px 1px 1px 0px;
  border-style: solid;
  border-radius: 12px;
  font-family: `, `;

  &:before {
    content: '';
    position: absolute;
    width: 13px;
    top: -1px;
    bottom: -1px;
    left: 0px;
    border-radius: 12px 0px 0px 12px;
  }
`])), Q.default), U7e = v(wk || (wk = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.blue.light2, b.blue.dark2, b.blue.dark3, Pn, b.blue.light3, b.blue.light2, b.blue.dark3, b.blue.light1, b.blue.light1), W7e = v(Ok || (Ok = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.yellow.light2, b.yellow.dark2, b.yellow.dark3, Pn, b.yellow.light3, b.yellow.light2, b.yellow.dark3, b.blue.light1, b.yellow.dark2), G7e = v(xk || (xk = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.red.light2, b.red.dark2, b.red.dark3, Pn, b.red.light3, b.red.light2, b.red.dark3, b.blue.light1, b.red.base), K7e = v(Ek || (Ek = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px `, `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.green.light2, b.green.dark2, b.green.dark3, Pn, b.green.light3, b.green.light2, b.green.dark3, b.blue.light1, b.green.base), Y7e = v($k || ($k = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.blue.dark2, b.blue.light2, b.blue.light3, Pn, b.blue.dark3, b.blue.dark2, b.blue.light3, b.white, b.blue.light1, b.blue.base), X7e = v(jk || (jk = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.yellow.dark2, b.yellow.light2, b.yellow.light3, Pn, b.yellow.dark3, b.yellow.dark2, b.yellow.light3, b.white, b.blue.light1, b.yellow.base), Q7e = v(Ck || (Ck = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.red.dark2, b.red.light2, b.red.light3, Pn, b.red.dark3, b.red.dark2, b.red.light3, b.white, b.blue.light1, b.red.base), J7e = v(Mk || (Mk = vt([`
  color: `, `;
  border-color: `, `;
  background-color: `, `;

  .`, `, a {
    color: `, `;

    &:hover {
      color: `, `;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px `, ", 0 0 0 5px ", `,
        0 0 0 7px `, `;
    }
  }

  &:before {
    background: linear-gradient(
      to left,
      transparent 6px,
      `, ` 6px
    );
  }
`])), b.green.dark2, b.green.light2, b.green.light3, Pn, b.green.dark3, b.green.dark2, b.green.light3, b.white, b.blue.light1, b.green.dark1), ebe = ut(ut({}, S.Dark, ut(ut(ut(ut({}, wt.Info, U7e), wt.Warning, W7e), wt.Danger, G7e), wt.Success, K7e)), S.Light, ut(ut(ut(ut({}, wt.Info, Y7e), wt.Warning, X7e), wt.Danger, Q7e), wt.Success, J7e)), tbe = function(e, t) {
  return v(kk || (kk = vt([`
  align-self: center;
  flex-grow: 1;
  margin-left: `, `;
  margin-right: `, `;

  .`, `, a {
    font-size: inherit;
    line-height: inherit;
    font-weight: `, `;
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 2px;
    border-radius: 4px;
    display: inline;

    &:hover,
    &:focus,
    &:focus-visible {
      outline: none;
      span {
        &::after {
          display: none;
        }
      }
    }

    &:focus-visible {
      position: relative;
    }
  }
`])), Sk(e, t).marginLeft, Sk(e, t).marginRight, Pn, Y.bold);
}, Sk = function(e, t) {
  var n = { marginLeft: void 0, marginRight: void 0 };
  return e ? (n.marginLeft = "17px", n.marginRight = "4px", t && (n.marginRight = "".concat(28, "px"))) : (n.marginLeft = "13px", n.marginRight = "10px", t && (n.marginRight = "".concat(32, "px"))), n;
}, nbe = v(Pk || (Pk = vt([`
  padding-right: 36px; // add space for the icon
`]))), rbe = ["variant", "dismissible", "onClose", "image", "children", "className", "darkMode", "baseFontSize"], a2 = wn(function(e, t) {
  var n = e.variant, r = n === void 0 ? wt.Info : n, l = e.dismissible, i = l !== void 0 && l, c = e.onClose, f = c === void 0 ? function() {
  } : c, d = e.image, h = e.children, g = e.className, m = e.darkMode, y = e.baseFontSize, w = M7e(e, rbe), C = K(m), E = C.theme, R = C.darkMode, M = _a(y);
  return k.createElement("div", r2({ role: "alert", ref: t, className: H(q7e, Y9[M], ebe[E][r], ut({}, nbe, i), g) }, w), k.createElement(V7e, { image: d, theme: E, baseFontSize: M, variant: r }), k.createElement("div", { className: tbe(d != null, i) }, h), i && k.createElement(B7e, { theme: E, baseFontSize: M, variant: r, onClose: f, darkMode: R }));
});
a2.displayName = "Banner", a2.propTypes = { darkMode: z.bool, variant: z.oneOf(Object.values(wt)), onClose: z.func, dismissible: z.bool, image: z.element, baseFontSize: z.oneOf(Object.values(W)) };
const Nk = ["http", "https", "mailto", "tel"];
function abe(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let l = -1;
  for (; ++l < Nk.length; ) {
    const i = Nk[l];
    if (r === i.length && t.slice(0, i.length).toLowerCase() === i)
      return t;
  }
  return l = t.indexOf("?"), l !== -1 && r > l || (l = t.indexOf("#"), l !== -1 && r > l) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var lbe = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const Jce = /* @__PURE__ */ ce(lbe);
function mi(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Rk(e.position) : "start" in e || "end" in e ? Rk(e) : "line" in e || "column" in e ? l2(e) : "";
}
function l2(e) {
  return _k(e && e.line) + ":" + _k(e && e.column);
}
function Rk(e) {
  return l2(e && e.start) + "-" + l2(e && e.end);
}
function _k(e) {
  return e && typeof e == "number" ? e : 1;
}
class Un extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const l = [null, null];
    let i = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? l[1] = r : (l[0] = r.slice(0, c), l[1] = r.slice(c + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (i = n.position) : "start" in n || "end" in n ? i = n : ("line" in n || "column" in n) && (i.start = n)), this.name = mi(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = i.start.line, this.column = i.start.column, this.position = i, this.source = l[0], this.ruleId = l[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
Un.prototype.file = "";
Un.prototype.name = "";
Un.prototype.reason = "";
Un.prototype.message = "";
Un.prototype.stack = "";
Un.prototype.fatal = null;
Un.prototype.column = null;
Un.prototype.line = null;
Un.prototype.source = null;
Un.prototype.ruleId = null;
Un.prototype.position = null;
const yr = { basename: ibe, dirname: obe, extname: sbe, join: cbe, sep: "/" };
function ibe(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ii(e);
  let n = 0, r = -1, l = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; l--; )
      if (e.charCodeAt(l) === 47) {
        if (i) {
          n = l + 1;
          break;
        }
      } else
        r < 0 && (i = !0, r = l + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let c = -1, f = t.length - 1;
  for (; l--; )
    if (e.charCodeAt(l) === 47) {
      if (i) {
        n = l + 1;
        break;
      }
    } else
      c < 0 && (i = !0, c = l + 1), f > -1 && (e.charCodeAt(l) === t.charCodeAt(f--) ? f < 0 && (r = l) : (f = -1, r = c));
  return n === r ? r = c : r < 0 && (r = e.length), e.slice(n, r);
}
function obe(e) {
  if (Ii(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function sbe(e) {
  Ii(e);
  let t = e.length, n = -1, r = 0, l = -1, i = 0, c;
  for (; t--; ) {
    const f = e.charCodeAt(t);
    if (f === 47) {
      if (c) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (c = !0, n = t + 1), f === 46 ? l < 0 ? l = t : i !== 1 && (i = 1) : l > -1 && (i = -1);
  }
  return l < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && l === n - 1 && l === r + 1 ? "" : e.slice(l, n);
}
function cbe(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ii(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : ube(n);
}
function ube(e) {
  Ii(e);
  const t = e.charCodeAt(0) === 47;
  let n = fbe(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function fbe(e, t) {
  let n = "", r = 0, l = -1, i = 0, c = -1, f, d;
  for (; ++c <= e.length; ) {
    if (c < e.length)
      f = e.charCodeAt(c);
    else {
      if (f === 47)
        break;
      f = 47;
    }
    if (f === 47) {
      if (!(l === c - 1 || i === 1))
        if (l !== c - 1 && i === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (d = n.lastIndexOf("/"), d !== n.length - 1) {
                d < 0 ? (n = "", r = 0) : (n = n.slice(0, d), r = n.length - 1 - n.lastIndexOf("/")), l = c, i = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, l = c, i = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(l + 1, c) : n = e.slice(l + 1, c), r = c - l - 1;
      l = c, i = 0;
    } else
      f === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function Ii(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const dbe = { cwd: pbe };
function pbe() {
  return "/";
}
function i2(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function gbe(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!i2(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return hbe(e);
}
function hbe(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const l = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw l.code = "ERR_INVALID_FILE_URL_PATH", l;
      }
    }
  return decodeURIComponent(t);
}
const Dc = ["history", "path", "basename", "stem", "extname", "dirname"];
class eue {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || mbe(t) ? n = { value: t } : i2(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = dbe.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < Dc.length; ) {
      const i = Dc[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let l;
    for (l in n)
      Dc.includes(l) || (this[l] = n[l]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    i2(t) && (t = gbe(t)), Fc(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? yr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    Ak(this.basename, "dirname"), this.path = yr.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? yr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    Fc(t, "basename"), zc(t, "basename"), this.path = yr.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? yr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (zc(t, "extname"), Ak(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = yr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? yr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    Fc(t, "stem"), zc(t, "stem"), this.path = yr.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const l = new Un(t, n, r);
    return this.path && (l.name = this.path + ":" + l.name, l.file = this.path), l.fatal = !1, this.messages.push(l), l;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const l = this.message(t, n, r);
    return l.fatal = null, l;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const l = this.message(t, n, r);
    throw l.fatal = !0, l;
  }
}
function zc(e, t) {
  if (e && e.includes(yr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + yr.sep + "`"
    );
}
function Fc(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Ak(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function mbe(e) {
  return Jce(e);
}
function Lk(e) {
  if (e)
    throw e;
}
var vo = Object.prototype.hasOwnProperty, tue = Object.prototype.toString, Zk = Object.defineProperty, Tk = Object.getOwnPropertyDescriptor, Bk = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : tue.call(t) === "[object Array]";
}, Ik = function(t) {
  if (!t || tue.call(t) !== "[object Object]")
    return !1;
  var n = vo.call(t, "constructor"), r = t.constructor && t.constructor.prototype && vo.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var l;
  for (l in t)
    ;
  return typeof l > "u" || vo.call(t, l);
}, Hk = function(t, n) {
  Zk && n.name === "__proto__" ? Zk(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, Dk = function(t, n) {
  if (n === "__proto__")
    if (vo.call(t, n)) {
      if (Tk)
        return Tk(t, n).value;
    } else
      return;
  return t[n];
}, vbe = function e() {
  var t, n, r, l, i, c, f = arguments[0], d = 1, h = arguments.length, g = !1;
  for (typeof f == "boolean" && (g = f, f = arguments[1] || {}, d = 2), (f == null || typeof f != "object" && typeof f != "function") && (f = {}); d < h; ++d)
    if (t = arguments[d], t != null)
      for (n in t)
        r = Dk(f, n), l = Dk(t, n), f !== l && (g && l && (Ik(l) || (i = Bk(l))) ? (i ? (i = !1, c = r && Bk(r) ? r : []) : c = r && Ik(r) ? r : {}, Hk(f, { name: n, newValue: e(g, c, l) })) : typeof l < "u" && Hk(f, { name: n, newValue: l }));
  return f;
};
const zk = /* @__PURE__ */ ce(vbe);
function o2(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function bbe() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...l) {
    let i = -1;
    const c = l.pop();
    if (typeof c != "function")
      throw new TypeError("Expected function as last argument, not " + c);
    f(null, ...l);
    function f(d, ...h) {
      const g = e[++i];
      let m = -1;
      if (d) {
        c(d);
        return;
      }
      for (; ++m < l.length; )
        (h[m] === null || h[m] === void 0) && (h[m] = l[m]);
      l = h, g ? ybe(g, f)(...h) : c(null, ...h);
    }
  }
  function r(l) {
    if (typeof l != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + l
      );
    return e.push(l), t;
  }
}
function ybe(e, t) {
  let n;
  return r;
  function r(...c) {
    const f = e.length > c.length;
    let d;
    f && c.push(l);
    try {
      d = e.apply(this, c);
    } catch (h) {
      const g = (
        /** @type {Error} */
        h
      );
      if (f && n)
        throw g;
      return l(g);
    }
    f || (d && d.then && typeof d.then == "function" ? d.then(i, l) : d instanceof Error ? l(d) : i(d));
  }
  function l(c, ...f) {
    n || (n = !0, t(c, ...f));
  }
  function i(c) {
    l(null, c);
  }
}
const wbe = rue().freeze(), nue = {}.hasOwnProperty;
function rue() {
  const e = bbe(), t = [];
  let n = {}, r, l = -1;
  return i.data = c, i.Parser = void 0, i.Compiler = void 0, i.freeze = f, i.attachers = t, i.use = d, i.parse = h, i.stringify = g, i.run = m, i.runSync = y, i.process = w, i.processSync = C, i;
  function i() {
    const E = rue();
    let R = -1;
    for (; ++R < t.length; )
      E.use(...t[R]);
    return E.data(zk(!0, {}, n)), E;
  }
  function c(E, R) {
    return typeof E == "string" ? arguments.length === 2 ? (Uc("data", r), n[E] = R, i) : nue.call(n, E) && n[E] || null : E ? (Uc("data", r), n = E, i) : n;
  }
  function f() {
    if (r)
      return i;
    for (; ++l < t.length; ) {
      const [E, ...R] = t[l];
      if (R[0] === !1)
        continue;
      R[0] === !0 && (R[0] = void 0);
      const M = E.call(i, ...R);
      typeof M == "function" && e.use(M);
    }
    return r = !0, l = Number.POSITIVE_INFINITY, i;
  }
  function d(E, ...R) {
    let M;
    if (Uc("use", r), E != null)
      if (typeof E == "function")
        s(E, ...R);
      else if (typeof E == "object")
        Array.isArray(E) ? o(E) : a(E);
      else
        throw new TypeError("Expected usable value, not `" + E + "`");
    return M && (n.settings = Object.assign(n.settings || {}, M)), i;
    function P(p) {
      if (typeof p == "function")
        s(p);
      else if (typeof p == "object")
        if (Array.isArray(p)) {
          const [O, ...x] = p;
          s(O, ...x);
        } else
          a(p);
      else
        throw new TypeError("Expected usable value, not `" + p + "`");
    }
    function a(p) {
      o(p.plugins), p.settings && (M = Object.assign(M || {}, p.settings));
    }
    function o(p) {
      let O = -1;
      if (p != null)
        if (Array.isArray(p))
          for (; ++O < p.length; ) {
            const x = p[O];
            P(x);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + p + "`");
    }
    function s(p, O) {
      let x = -1, N;
      for (; ++x < t.length; )
        if (t[x][0] === p) {
          N = t[x];
          break;
        }
      N ? (o2(N[1]) && o2(O) && (O = zk(!0, N[1], O)), N[1] = O) : t.push([...arguments]);
    }
  }
  function h(E) {
    i.freeze();
    const R = ri(E), M = i.Parser;
    return Vc("parse", M), Fk(M, "parse") ? new M(String(R), R).parse() : M(String(R), R);
  }
  function g(E, R) {
    i.freeze();
    const M = ri(R), P = i.Compiler;
    return qc("stringify", P), Vk(E), Fk(P, "compile") ? new P(E, M).compile() : P(E, M);
  }
  function m(E, R, M) {
    if (Vk(E), i.freeze(), !M && typeof R == "function" && (M = R, R = void 0), !M)
      return new Promise(P);
    P(null, M);
    function P(a, o) {
      e.run(E, ri(R), s);
      function s(p, O, x) {
        O = O || E, p ? o(p) : a ? a(O) : M(null, O, x);
      }
    }
  }
  function y(E, R) {
    let M, P;
    return i.run(E, R, a), qk("runSync", "run", P), M;
    function a(o, s) {
      Lk(o), M = s, P = !0;
    }
  }
  function w(E, R) {
    if (i.freeze(), Vc("process", i.Parser), qc("process", i.Compiler), !R)
      return new Promise(M);
    M(null, R);
    function M(P, a) {
      const o = ri(E);
      i.run(i.parse(o), o, (p, O, x) => {
        if (p || !O || !x)
          s(p);
        else {
          const N = i.stringify(O, x);
          N == null || (Ebe(N) ? x.value = N : x.result = N), s(p, x);
        }
      });
      function s(p, O) {
        p || !O ? a(p) : P ? P(O) : R(null, O);
      }
    }
  }
  function C(E) {
    let R;
    i.freeze(), Vc("processSync", i.Parser), qc("processSync", i.Compiler);
    const M = ri(E);
    return i.process(M, P), qk("processSync", "process", R), M;
    function P(a) {
      R = !0, Lk(a);
    }
  }
}
function Fk(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (Obe(e.prototype) || t in e.prototype);
}
function Obe(e) {
  let t;
  for (t in e)
    if (nue.call(e, t))
      return !0;
  return !1;
}
function Vc(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function qc(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Uc(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Vk(e) {
  if (!o2(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function qk(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function ri(e) {
  return xbe(e) ? e : new eue(e);
}
function xbe(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Ebe(e) {
  return typeof e == "string" || Jce(e);
}
const $be = {};
function jbe(e, t) {
  const n = t || $be, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, l = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return aue(e, r, l);
}
function aue(e, t, n) {
  if (Cbe(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Uk(e.children, t, n);
  }
  return Array.isArray(e) ? Uk(e, t, n) : "";
}
function Uk(e, t, n) {
  const r = [];
  let l = -1;
  for (; ++l < e.length; )
    r[l] = aue(e[l], t, n);
  return r.join("");
}
function Cbe(e) {
  return !!(e && typeof e == "object");
}
function Mr(e, t, n, r) {
  const l = e.length;
  let i = 0, c;
  if (t < 0 ? t = -t > l ? 0 : l + t : t = t > l ? l : t, n = n > 0 ? n : 0, r.length < 1e4)
    c = Array.from(r), c.unshift(t, n), e.splice(...c);
  else
    for (n && e.splice(t, n); i < r.length; )
      c = r.slice(i, i + 1e4), c.unshift(t, 0), e.splice(...c), i += 1e4, t += 1e4;
}
function Bn(e, t) {
  return e.length > 0 ? (Mr(e, e.length, 0, t), e) : t;
}
const Wk = {}.hasOwnProperty;
function Mbe(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    kbe(t, e[n]);
  return t;
}
function kbe(e, t) {
  let n;
  for (n in t) {
    const l = (Wk.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let c;
    if (i)
      for (c in i) {
        Wk.call(l, c) || (l[c] = []);
        const f = i[c];
        Pbe(
          // @ts-expect-error Looks like a list.
          l[c],
          Array.isArray(f) ? f : f ? [f] : []
        );
      }
  }
}
function Pbe(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Mr(e, 0, 0, r);
}
const Sbe = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Er = ha(/[A-Za-z]/), En = ha(/[\dA-Za-z]/), Nbe = ha(/[#-'*+\--9=?A-Z^-~]/);
function s2(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const c2 = ha(/\d/), Rbe = ha(/[\dA-Fa-f]/), _be = ha(/[!-/:-@[-`{-~]/);
function Te(e) {
  return e !== null && e < -2;
}
function hn(e) {
  return e !== null && (e < 0 || e === 32);
}
function bt(e) {
  return e === -2 || e === -1 || e === 32;
}
const Abe = ha(Sbe), Lbe = ha(/\s/);
function ha(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function _t(e, t, n, r) {
  const l = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return c;
  function c(d) {
    return bt(d) ? (e.enter(n), f(d)) : t(d);
  }
  function f(d) {
    return bt(d) && i++ < l ? (e.consume(d), f) : (e.exit(n), t(d));
  }
}
const Zbe = {
  tokenize: Tbe
};
function Tbe(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    l
  );
  let n;
  return t;
  function r(f) {
    if (f === null) {
      e.consume(f);
      return;
    }
    return e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), _t(e, t, "linePrefix");
  }
  function l(f) {
    return e.enter("paragraph"), i(f);
  }
  function i(f) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = d), n = d, c(f);
  }
  function c(f) {
    if (f === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(f);
      return;
    }
    return Te(f) ? (e.consume(f), e.exit("chunkText"), i) : (e.consume(f), c);
  }
}
const Bbe = {
  tokenize: Ibe
}, Gk = {
  tokenize: Hbe
};
function Ibe(e) {
  const t = this, n = [];
  let r = 0, l, i, c;
  return f;
  function f(a) {
    if (r < n.length) {
      const o = n[r];
      return t.containerState = o[1], e.attempt(
        o[0].continuation,
        d,
        h
      )(a);
    }
    return h(a);
  }
  function d(a) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, l && P();
      const o = t.events.length;
      let s = o, p;
      for (; s--; )
        if (t.events[s][0] === "exit" && t.events[s][1].type === "chunkFlow") {
          p = t.events[s][1].end;
          break;
        }
      M(r);
      let O = o;
      for (; O < t.events.length; )
        t.events[O][1].end = Object.assign({}, p), O++;
      return Mr(
        t.events,
        s + 1,
        0,
        t.events.slice(o)
      ), t.events.length = O, h(a);
    }
    return f(a);
  }
  function h(a) {
    if (r === n.length) {
      if (!l)
        return y(a);
      if (l.currentConstruct && l.currentConstruct.concrete)
        return C(a);
      t.interrupt = !!(l.currentConstruct && !l._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      Gk,
      g,
      m
    )(a);
  }
  function g(a) {
    return l && P(), M(r), y(a);
  }
  function m(a) {
    return t.parser.lazy[t.now().line] = r !== n.length, c = t.now().offset, C(a);
  }
  function y(a) {
    return t.containerState = {}, e.attempt(
      Gk,
      w,
      C
    )(a);
  }
  function w(a) {
    return r++, n.push([t.currentConstruct, t.containerState]), y(a);
  }
  function C(a) {
    if (a === null) {
      l && P(), M(0), e.consume(a);
      return;
    }
    return l = l || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: i,
      _tokenizer: l
    }), E(a);
  }
  function E(a) {
    if (a === null) {
      R(e.exit("chunkFlow"), !0), M(0), e.consume(a);
      return;
    }
    return Te(a) ? (e.consume(a), R(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, f) : (e.consume(a), E);
  }
  function R(a, o) {
    const s = t.sliceStream(a);
    if (o && s.push(null), a.previous = i, i && (i.next = a), i = a, l.defineSkip(a.start), l.write(s), t.parser.lazy[a.start.line]) {
      let p = l.events.length;
      for (; p--; )
        if (
          // The token starts before the line ending…
          l.events[p][1].start.offset < c && // …and either is not ended yet…
          (!l.events[p][1].end || // …or ends after it.
          l.events[p][1].end.offset > c)
        )
          return;
      const O = t.events.length;
      let x = O, N, T;
      for (; x--; )
        if (t.events[x][0] === "exit" && t.events[x][1].type === "chunkFlow") {
          if (N) {
            T = t.events[x][1].end;
            break;
          }
          N = !0;
        }
      for (M(r), p = O; p < t.events.length; )
        t.events[p][1].end = Object.assign({}, T), p++;
      Mr(
        t.events,
        x + 1,
        0,
        t.events.slice(O)
      ), t.events.length = p;
    }
  }
  function M(a) {
    let o = n.length;
    for (; o-- > a; ) {
      const s = n[o];
      t.containerState = s[1], s[0].exit.call(t, e);
    }
    n.length = a;
  }
  function P() {
    l.write([null]), i = void 0, l = void 0, t.containerState._closeFlow = void 0;
  }
}
function Hbe(e, t, n) {
  return _t(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Kk(e) {
  if (e === null || hn(e) || Lbe(e))
    return 1;
  if (Abe(e))
    return 2;
}
function X9(e, t, n) {
  const r = [];
  let l = -1;
  for (; ++l < e.length; ) {
    const i = e[l].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const u2 = {
  name: "attention",
  tokenize: zbe,
  resolveAll: Dbe
};
function Dbe(e, t) {
  let n = -1, r, l, i, c, f, d, h, g;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          d = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const m = Object.assign({}, e[r][1].end), y = Object.assign({}, e[n][1].start);
          Yk(m, -d), Yk(y, d), c = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: m,
            end: Object.assign({}, e[r][1].end)
          }, f = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: y
          }, i = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, l = {
            type: d > 1 ? "strong" : "emphasis",
            start: Object.assign({}, c.start),
            end: Object.assign({}, f.end)
          }, e[r][1].end = Object.assign({}, c.start), e[n][1].start = Object.assign({}, f.end), h = [], e[r][1].end.offset - e[r][1].start.offset && (h = Bn(h, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), h = Bn(h, [
            ["enter", l, t],
            ["enter", c, t],
            ["exit", c, t],
            ["enter", i, t]
          ]), h = Bn(
            h,
            X9(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), h = Bn(h, [
            ["exit", i, t],
            ["enter", f, t],
            ["exit", f, t],
            ["exit", l, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (g = 2, h = Bn(h, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : g = 0, Mr(e, r - 1, n - r + 3, h), n = r + h.length - g - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function zbe(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, l = Kk(r);
  let i;
  return c;
  function c(d) {
    return i = d, e.enter("attentionSequence"), f(d);
  }
  function f(d) {
    if (d === i)
      return e.consume(d), f;
    const h = e.exit("attentionSequence"), g = Kk(d), m = !g || g === 2 && l || n.includes(d), y = !l || l === 2 && g || n.includes(r);
    return h._open = !!(i === 42 ? m : m && (l || !y)), h._close = !!(i === 42 ? y : y && (g || !m)), t(d);
  }
}
function Yk(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Fbe = {
  name: "autolink",
  tokenize: Vbe
};
function Vbe(e, t, n) {
  let r = 0;
  return l;
  function l(w) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(w), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(w) {
    return Er(w) ? (e.consume(w), c) : h(w);
  }
  function c(w) {
    return w === 43 || w === 45 || w === 46 || En(w) ? (r = 1, f(w)) : h(w);
  }
  function f(w) {
    return w === 58 ? (e.consume(w), r = 0, d) : (w === 43 || w === 45 || w === 46 || En(w)) && r++ < 32 ? (e.consume(w), f) : (r = 0, h(w));
  }
  function d(w) {
    return w === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(w), e.exit("autolinkMarker"), e.exit("autolink"), t) : w === null || w === 32 || w === 60 || s2(w) ? n(w) : (e.consume(w), d);
  }
  function h(w) {
    return w === 64 ? (e.consume(w), g) : Nbe(w) ? (e.consume(w), h) : n(w);
  }
  function g(w) {
    return En(w) ? m(w) : n(w);
  }
  function m(w) {
    return w === 46 ? (e.consume(w), r = 0, g) : w === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(w), e.exit("autolinkMarker"), e.exit("autolink"), t) : y(w);
  }
  function y(w) {
    if ((w === 45 || En(w)) && r++ < 63) {
      const C = w === 45 ? y : m;
      return e.consume(w), C;
    }
    return n(w);
  }
}
const $1 = {
  tokenize: qbe,
  partial: !0
};
function qbe(e, t, n) {
  return r;
  function r(i) {
    return bt(i) ? _t(e, l, "linePrefix")(i) : l(i);
  }
  function l(i) {
    return i === null || Te(i) ? t(i) : n(i);
  }
}
const lue = {
  name: "blockQuote",
  tokenize: Ube,
  continuation: {
    tokenize: Wbe
  },
  exit: Gbe
};
function Ube(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    if (c === 62) {
      const f = r.containerState;
      return f.open || (e.enter("blockQuote", {
        _container: !0
      }), f.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(c), e.exit("blockQuoteMarker"), i;
    }
    return n(c);
  }
  function i(c) {
    return bt(c) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(c), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(c));
  }
}
function Wbe(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    return bt(c) ? _t(
      e,
      i,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(c) : i(c);
  }
  function i(c) {
    return e.attempt(lue, t, n)(c);
  }
}
function Gbe(e) {
  e.exit("blockQuote");
}
const iue = {
  name: "characterEscape",
  tokenize: Kbe
};
function Kbe(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), l;
  }
  function l(i) {
    return _be(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const Xk = document.createElement("i");
function Q9(e) {
  const t = "&" + e + ";";
  Xk.innerHTML = t;
  const n = Xk.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const oue = {
  name: "characterReference",
  tokenize: Ybe
};
function Ybe(e, t, n) {
  const r = this;
  let l = 0, i, c;
  return f;
  function f(m) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(m), e.exit("characterReferenceMarker"), d;
  }
  function d(m) {
    return m === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(m), e.exit("characterReferenceMarkerNumeric"), h) : (e.enter("characterReferenceValue"), i = 31, c = En, g(m));
  }
  function h(m) {
    return m === 88 || m === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(m), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, c = Rbe, g) : (e.enter("characterReferenceValue"), i = 7, c = c2, g(m));
  }
  function g(m) {
    if (m === 59 && l) {
      const y = e.exit("characterReferenceValue");
      return c === En && !Q9(r.sliceSerialize(y)) ? n(m) : (e.enter("characterReferenceMarker"), e.consume(m), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return c(m) && l++ < i ? (e.consume(m), g) : n(m);
  }
}
const Qk = {
  tokenize: Qbe,
  partial: !0
}, Jk = {
  name: "codeFenced",
  tokenize: Xbe,
  concrete: !0
};
function Xbe(e, t, n) {
  const r = this, l = {
    tokenize: s,
    partial: !0
  };
  let i = 0, c = 0, f;
  return d;
  function d(p) {
    return h(p);
  }
  function h(p) {
    const O = r.events[r.events.length - 1];
    return i = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, f = p, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), g(p);
  }
  function g(p) {
    return p === f ? (c++, e.consume(p), g) : c < 3 ? n(p) : (e.exit("codeFencedFenceSequence"), bt(p) ? _t(e, m, "whitespace")(p) : m(p));
  }
  function m(p) {
    return p === null || Te(p) ? (e.exit("codeFencedFence"), r.interrupt ? t(p) : e.check(Qk, E, o)(p)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), y(p));
  }
  function y(p) {
    return p === null || Te(p) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), m(p)) : bt(p) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), _t(e, w, "whitespace")(p)) : p === 96 && p === f ? n(p) : (e.consume(p), y);
  }
  function w(p) {
    return p === null || Te(p) ? m(p) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(p));
  }
  function C(p) {
    return p === null || Te(p) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), m(p)) : p === 96 && p === f ? n(p) : (e.consume(p), C);
  }
  function E(p) {
    return e.attempt(l, o, R)(p);
  }
  function R(p) {
    return e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), M;
  }
  function M(p) {
    return i > 0 && bt(p) ? _t(
      e,
      P,
      "linePrefix",
      i + 1
    )(p) : P(p);
  }
  function P(p) {
    return p === null || Te(p) ? e.check(Qk, E, o)(p) : (e.enter("codeFlowValue"), a(p));
  }
  function a(p) {
    return p === null || Te(p) ? (e.exit("codeFlowValue"), P(p)) : (e.consume(p), a);
  }
  function o(p) {
    return e.exit("codeFenced"), t(p);
  }
  function s(p, O, x) {
    let N = 0;
    return T;
    function T(G) {
      return p.enter("lineEnding"), p.consume(G), p.exit("lineEnding"), $;
    }
    function $(G) {
      return p.enter("codeFencedFence"), bt(G) ? _t(
        p,
        j,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(G) : j(G);
    }
    function j(G) {
      return G === f ? (p.enter("codeFencedFenceSequence"), A(G)) : x(G);
    }
    function A(G) {
      return G === f ? (N++, p.consume(G), A) : N >= c ? (p.exit("codeFencedFenceSequence"), bt(G) ? _t(p, Z, "whitespace")(G) : Z(G)) : x(G);
    }
    function Z(G) {
      return G === null || Te(G) ? (p.exit("codeFencedFence"), O(G)) : x(G);
    }
  }
}
function Qbe(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    return c === null ? n(c) : (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), i);
  }
  function i(c) {
    return r.parser.lazy[r.now().line] ? n(c) : t(c);
  }
}
const Wc = {
  name: "codeIndented",
  tokenize: e8e
}, Jbe = {
  tokenize: t8e,
  partial: !0
};
function e8e(e, t, n) {
  const r = this;
  return l;
  function l(h) {
    return e.enter("codeIndented"), _t(e, i, "linePrefix", 4 + 1)(h);
  }
  function i(h) {
    const g = r.events[r.events.length - 1];
    return g && g[1].type === "linePrefix" && g[2].sliceSerialize(g[1], !0).length >= 4 ? c(h) : n(h);
  }
  function c(h) {
    return h === null ? d(h) : Te(h) ? e.attempt(Jbe, c, d)(h) : (e.enter("codeFlowValue"), f(h));
  }
  function f(h) {
    return h === null || Te(h) ? (e.exit("codeFlowValue"), c(h)) : (e.consume(h), f);
  }
  function d(h) {
    return e.exit("codeIndented"), t(h);
  }
}
function t8e(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    return r.parser.lazy[r.now().line] ? n(c) : Te(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), l) : _t(e, i, "linePrefix", 4 + 1)(c);
  }
  function i(c) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? t(c) : Te(c) ? l(c) : n(c);
  }
}
const n8e = {
  name: "codeText",
  tokenize: l8e,
  resolve: r8e,
  previous: a8e
};
function r8e(e) {
  let t = e.length - 4, n = 3, r, l;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    l === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (l = r) : (r === t || e[r][1].type === "lineEnding") && (e[l][1].type = "codeTextData", r !== l + 2 && (e[l][1].end = e[r - 1][1].end, e.splice(l + 2, r - l - 2), t -= r - l - 2, r = l + 2), l = void 0);
  return e;
}
function a8e(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function l8e(e, t, n) {
  let r = 0, l, i;
  return c;
  function c(m) {
    return e.enter("codeText"), e.enter("codeTextSequence"), f(m);
  }
  function f(m) {
    return m === 96 ? (e.consume(m), r++, f) : (e.exit("codeTextSequence"), d(m));
  }
  function d(m) {
    return m === null ? n(m) : m === 32 ? (e.enter("space"), e.consume(m), e.exit("space"), d) : m === 96 ? (i = e.enter("codeTextSequence"), l = 0, g(m)) : Te(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), d) : (e.enter("codeTextData"), h(m));
  }
  function h(m) {
    return m === null || m === 32 || m === 96 || Te(m) ? (e.exit("codeTextData"), d(m)) : (e.consume(m), h);
  }
  function g(m) {
    return m === 96 ? (e.consume(m), l++, g) : l === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(m)) : (i.type = "codeTextData", h(m));
  }
}
function sue(e) {
  const t = {};
  let n = -1, r, l, i, c, f, d, h;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (d = r[1]._tokenizer.events, i = 0, i < d.length && d[i][1].type === "lineEndingBlank" && (i += 2), i < d.length && d[i][1].type === "content"))
      for (; ++i < d.length && d[i][1].type !== "content"; )
        d[i][1].type === "chunkText" && (d[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, i8e(e, n)), n = t[n], h = !0);
    else if (r[1]._container) {
      for (i = n, l = void 0; i-- && (c = e[i], c[1].type === "lineEnding" || c[1].type === "lineEndingBlank"); )
        c[0] === "enter" && (l && (e[l][1].type = "lineEndingBlank"), c[1].type = "lineEnding", l = i);
      l && (r[1].end = Object.assign({}, e[l][1].start), f = e.slice(l, n), f.unshift(r), Mr(e, l, n - l + 1, f));
    }
  }
  return !h;
}
function i8e(e, t) {
  const n = e[t][1], r = e[t][2];
  let l = t - 1;
  const i = [], c = n._tokenizer || r.parser[n.contentType](n.start), f = c.events, d = [], h = {};
  let g, m, y = -1, w = n, C = 0, E = 0;
  const R = [E];
  for (; w; ) {
    for (; e[++l][1] !== w; )
      ;
    i.push(l), w._tokenizer || (g = r.sliceStream(w), w.next || g.push(null), m && c.defineSkip(w.start), w._isInFirstContentOfListItem && (c._gfmTasklistFirstContentOfListItem = !0), c.write(g), w._isInFirstContentOfListItem && (c._gfmTasklistFirstContentOfListItem = void 0)), m = w, w = w.next;
  }
  for (w = n; ++y < f.length; )
    // Find a void token that includes a break.
    f[y][0] === "exit" && f[y - 1][0] === "enter" && f[y][1].type === f[y - 1][1].type && f[y][1].start.line !== f[y][1].end.line && (E = y + 1, R.push(E), w._tokenizer = void 0, w.previous = void 0, w = w.next);
  for (c.events = [], w ? (w._tokenizer = void 0, w.previous = void 0) : R.pop(), y = R.length; y--; ) {
    const M = f.slice(R[y], R[y + 1]), P = i.pop();
    d.unshift([P, P + M.length - 1]), Mr(e, P, 2, M);
  }
  for (y = -1; ++y < d.length; )
    h[C + d[y][0]] = C + d[y][1], C += d[y][1] - d[y][0] - 1;
  return h;
}
const o8e = {
  tokenize: u8e,
  resolve: c8e
}, s8e = {
  tokenize: f8e,
  partial: !0
};
function c8e(e) {
  return sue(e), e;
}
function u8e(e, t) {
  let n;
  return r;
  function r(f) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), l(f);
  }
  function l(f) {
    return f === null ? i(f) : Te(f) ? e.check(
      s8e,
      c,
      i
    )(f) : (e.consume(f), l);
  }
  function i(f) {
    return e.exit("chunkContent"), e.exit("content"), t(f);
  }
  function c(f) {
    return e.consume(f), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, l;
  }
}
function f8e(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), _t(e, i, "linePrefix");
  }
  function i(c) {
    if (c === null || Te(c))
      return n(c);
    const f = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? t(c) : e.interrupt(r.parser.constructs.flow, n, t)(c);
  }
}
function cue(e, t, n, r, l, i, c, f, d) {
  const h = d || Number.POSITIVE_INFINITY;
  let g = 0;
  return m;
  function m(M) {
    return M === 60 ? (e.enter(r), e.enter(l), e.enter(i), e.consume(M), e.exit(i), y) : M === null || M === 32 || M === 41 || s2(M) ? n(M) : (e.enter(r), e.enter(c), e.enter(f), e.enter("chunkString", {
      contentType: "string"
    }), E(M));
  }
  function y(M) {
    return M === 62 ? (e.enter(i), e.consume(M), e.exit(i), e.exit(l), e.exit(r), t) : (e.enter(f), e.enter("chunkString", {
      contentType: "string"
    }), w(M));
  }
  function w(M) {
    return M === 62 ? (e.exit("chunkString"), e.exit(f), y(M)) : M === null || M === 60 || Te(M) ? n(M) : (e.consume(M), M === 92 ? C : w);
  }
  function C(M) {
    return M === 60 || M === 62 || M === 92 ? (e.consume(M), w) : w(M);
  }
  function E(M) {
    return !g && (M === null || M === 41 || hn(M)) ? (e.exit("chunkString"), e.exit(f), e.exit(c), e.exit(r), t(M)) : g < h && M === 40 ? (e.consume(M), g++, E) : M === 41 ? (e.consume(M), g--, E) : M === null || M === 32 || M === 40 || s2(M) ? n(M) : (e.consume(M), M === 92 ? R : E);
  }
  function R(M) {
    return M === 40 || M === 41 || M === 92 ? (e.consume(M), E) : E(M);
  }
}
function uue(e, t, n, r, l, i) {
  const c = this;
  let f = 0, d;
  return h;
  function h(w) {
    return e.enter(r), e.enter(l), e.consume(w), e.exit(l), e.enter(i), g;
  }
  function g(w) {
    return f > 999 || w === null || w === 91 || w === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    w === 94 && !f && "_hiddenFootnoteSupport" in c.parser.constructs ? n(w) : w === 93 ? (e.exit(i), e.enter(l), e.consume(w), e.exit(l), e.exit(r), t) : Te(w) ? (e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), g) : (e.enter("chunkString", {
      contentType: "string"
    }), m(w));
  }
  function m(w) {
    return w === null || w === 91 || w === 93 || Te(w) || f++ > 999 ? (e.exit("chunkString"), g(w)) : (e.consume(w), d || (d = !bt(w)), w === 92 ? y : m);
  }
  function y(w) {
    return w === 91 || w === 92 || w === 93 ? (e.consume(w), f++, m) : m(w);
  }
}
function fue(e, t, n, r, l, i) {
  let c;
  return f;
  function f(y) {
    return y === 34 || y === 39 || y === 40 ? (e.enter(r), e.enter(l), e.consume(y), e.exit(l), c = y === 40 ? 41 : y, d) : n(y);
  }
  function d(y) {
    return y === c ? (e.enter(l), e.consume(y), e.exit(l), e.exit(r), t) : (e.enter(i), h(y));
  }
  function h(y) {
    return y === c ? (e.exit(i), d(c)) : y === null ? n(y) : Te(y) ? (e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), _t(e, h, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), g(y));
  }
  function g(y) {
    return y === c || y === null || Te(y) ? (e.exit("chunkString"), h(y)) : (e.consume(y), y === 92 ? m : g);
  }
  function m(y) {
    return y === c || y === 92 ? (e.consume(y), g) : g(y);
  }
}
function vi(e, t) {
  let n;
  return r;
  function r(l) {
    return Te(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), n = !0, r) : bt(l) ? _t(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(l) : t(l);
  }
}
function tl(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const d8e = {
  name: "definition",
  tokenize: g8e
}, p8e = {
  tokenize: h8e,
  partial: !0
};
function g8e(e, t, n) {
  const r = this;
  let l;
  return i;
  function i(w) {
    return e.enter("definition"), c(w);
  }
  function c(w) {
    return uue.call(
      r,
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(w);
  }
  function f(w) {
    return l = tl(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), w === 58 ? (e.enter("definitionMarker"), e.consume(w), e.exit("definitionMarker"), d) : n(w);
  }
  function d(w) {
    return hn(w) ? vi(e, h)(w) : h(w);
  }
  function h(w) {
    return cue(
      e,
      g,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(w);
  }
  function g(w) {
    return e.attempt(p8e, m, m)(w);
  }
  function m(w) {
    return bt(w) ? _t(e, y, "whitespace")(w) : y(w);
  }
  function y(w) {
    return w === null || Te(w) ? (e.exit("definition"), r.parser.defined.push(l), t(w)) : n(w);
  }
}
function h8e(e, t, n) {
  return r;
  function r(f) {
    return hn(f) ? vi(e, l)(f) : n(f);
  }
  function l(f) {
    return fue(
      e,
      i,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(f);
  }
  function i(f) {
    return bt(f) ? _t(e, c, "whitespace")(f) : c(f);
  }
  function c(f) {
    return f === null || Te(f) ? t(f) : n(f);
  }
}
const m8e = {
  name: "hardBreakEscape",
  tokenize: v8e
};
function v8e(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), l;
  }
  function l(i) {
    return Te(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const b8e = {
  name: "headingAtx",
  tokenize: w8e,
  resolve: y8e
};
function y8e(e, t) {
  let n = e.length - 2, r = 3, l, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (l = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Mr(e, r, n - r + 1, [
    ["enter", l, t],
    ["enter", i, t],
    ["exit", i, t],
    ["exit", l, t]
  ])), e;
}
function w8e(e, t, n) {
  let r = 0;
  return l;
  function l(g) {
    return e.enter("atxHeading"), i(g);
  }
  function i(g) {
    return e.enter("atxHeadingSequence"), c(g);
  }
  function c(g) {
    return g === 35 && r++ < 6 ? (e.consume(g), c) : g === null || hn(g) ? (e.exit("atxHeadingSequence"), f(g)) : n(g);
  }
  function f(g) {
    return g === 35 ? (e.enter("atxHeadingSequence"), d(g)) : g === null || Te(g) ? (e.exit("atxHeading"), t(g)) : bt(g) ? _t(e, f, "whitespace")(g) : (e.enter("atxHeadingText"), h(g));
  }
  function d(g) {
    return g === 35 ? (e.consume(g), d) : (e.exit("atxHeadingSequence"), f(g));
  }
  function h(g) {
    return g === null || g === 35 || hn(g) ? (e.exit("atxHeadingText"), f(g)) : (e.consume(g), h);
  }
}
const O8e = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], eP = ["pre", "script", "style", "textarea"], x8e = {
  name: "htmlFlow",
  tokenize: C8e,
  resolveTo: j8e,
  concrete: !0
}, E8e = {
  tokenize: k8e,
  partial: !0
}, $8e = {
  tokenize: M8e,
  partial: !0
};
function j8e(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function C8e(e, t, n) {
  const r = this;
  let l, i, c, f, d;
  return h;
  function h(_) {
    return g(_);
  }
  function g(_) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(_), m;
  }
  function m(_) {
    return _ === 33 ? (e.consume(_), y) : _ === 47 ? (e.consume(_), i = !0, E) : _ === 63 ? (e.consume(_), l = 3, r.interrupt ? t : L) : Er(_) ? (e.consume(_), c = String.fromCharCode(_), R) : n(_);
  }
  function y(_) {
    return _ === 45 ? (e.consume(_), l = 2, w) : _ === 91 ? (e.consume(_), l = 5, f = 0, C) : Er(_) ? (e.consume(_), l = 4, r.interrupt ? t : L) : n(_);
  }
  function w(_) {
    return _ === 45 ? (e.consume(_), r.interrupt ? t : L) : n(_);
  }
  function C(_) {
    const re = "CDATA[";
    return _ === re.charCodeAt(f++) ? (e.consume(_), f === re.length ? r.interrupt ? t : j : C) : n(_);
  }
  function E(_) {
    return Er(_) ? (e.consume(_), c = String.fromCharCode(_), R) : n(_);
  }
  function R(_) {
    if (_ === null || _ === 47 || _ === 62 || hn(_)) {
      const re = _ === 47, ue = c.toLowerCase();
      return !re && !i && eP.includes(ue) ? (l = 1, r.interrupt ? t(_) : j(_)) : O8e.includes(c.toLowerCase()) ? (l = 6, re ? (e.consume(_), M) : r.interrupt ? t(_) : j(_)) : (l = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(_) : i ? P(_) : a(_));
    }
    return _ === 45 || En(_) ? (e.consume(_), c += String.fromCharCode(_), R) : n(_);
  }
  function M(_) {
    return _ === 62 ? (e.consume(_), r.interrupt ? t : j) : n(_);
  }
  function P(_) {
    return bt(_) ? (e.consume(_), P) : T(_);
  }
  function a(_) {
    return _ === 47 ? (e.consume(_), T) : _ === 58 || _ === 95 || Er(_) ? (e.consume(_), o) : bt(_) ? (e.consume(_), a) : T(_);
  }
  function o(_) {
    return _ === 45 || _ === 46 || _ === 58 || _ === 95 || En(_) ? (e.consume(_), o) : s(_);
  }
  function s(_) {
    return _ === 61 ? (e.consume(_), p) : bt(_) ? (e.consume(_), s) : a(_);
  }
  function p(_) {
    return _ === null || _ === 60 || _ === 61 || _ === 62 || _ === 96 ? n(_) : _ === 34 || _ === 39 ? (e.consume(_), d = _, O) : bt(_) ? (e.consume(_), p) : x(_);
  }
  function O(_) {
    return _ === d ? (e.consume(_), d = null, N) : _ === null || Te(_) ? n(_) : (e.consume(_), O);
  }
  function x(_) {
    return _ === null || _ === 34 || _ === 39 || _ === 47 || _ === 60 || _ === 61 || _ === 62 || _ === 96 || hn(_) ? s(_) : (e.consume(_), x);
  }
  function N(_) {
    return _ === 47 || _ === 62 || bt(_) ? a(_) : n(_);
  }
  function T(_) {
    return _ === 62 ? (e.consume(_), $) : n(_);
  }
  function $(_) {
    return _ === null || Te(_) ? j(_) : bt(_) ? (e.consume(_), $) : n(_);
  }
  function j(_) {
    return _ === 45 && l === 2 ? (e.consume(_), I) : _ === 60 && l === 1 ? (e.consume(_), F) : _ === 62 && l === 4 ? (e.consume(_), q) : _ === 63 && l === 3 ? (e.consume(_), L) : _ === 93 && l === 5 ? (e.consume(_), B) : Te(_) && (l === 6 || l === 7) ? (e.exit("htmlFlowData"), e.check(
      E8e,
      D,
      A
    )(_)) : _ === null || Te(_) ? (e.exit("htmlFlowData"), A(_)) : (e.consume(_), j);
  }
  function A(_) {
    return e.check(
      $8e,
      Z,
      D
    )(_);
  }
  function Z(_) {
    return e.enter("lineEnding"), e.consume(_), e.exit("lineEnding"), G;
  }
  function G(_) {
    return _ === null || Te(_) ? A(_) : (e.enter("htmlFlowData"), j(_));
  }
  function I(_) {
    return _ === 45 ? (e.consume(_), L) : j(_);
  }
  function F(_) {
    return _ === 47 ? (e.consume(_), c = "", U) : j(_);
  }
  function U(_) {
    if (_ === 62) {
      const re = c.toLowerCase();
      return eP.includes(re) ? (e.consume(_), q) : j(_);
    }
    return Er(_) && c.length < 8 ? (e.consume(_), c += String.fromCharCode(_), U) : j(_);
  }
  function B(_) {
    return _ === 93 ? (e.consume(_), L) : j(_);
  }
  function L(_) {
    return _ === 62 ? (e.consume(_), q) : _ === 45 && l === 2 ? (e.consume(_), L) : j(_);
  }
  function q(_) {
    return _ === null || Te(_) ? (e.exit("htmlFlowData"), D(_)) : (e.consume(_), q);
  }
  function D(_) {
    return e.exit("htmlFlow"), t(_);
  }
}
function M8e(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    return Te(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), i) : n(c);
  }
  function i(c) {
    return r.parser.lazy[r.now().line] ? n(c) : t(c);
  }
}
function k8e(e, t, n) {
  return r;
  function r(l) {
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), e.attempt($1, t, n);
  }
}
const P8e = {
  name: "htmlText",
  tokenize: S8e
};
function S8e(e, t, n) {
  const r = this;
  let l, i, c;
  return f;
  function f(L) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(L), d;
  }
  function d(L) {
    return L === 33 ? (e.consume(L), h) : L === 47 ? (e.consume(L), s) : L === 63 ? (e.consume(L), a) : Er(L) ? (e.consume(L), x) : n(L);
  }
  function h(L) {
    return L === 45 ? (e.consume(L), g) : L === 91 ? (e.consume(L), i = 0, C) : Er(L) ? (e.consume(L), P) : n(L);
  }
  function g(L) {
    return L === 45 ? (e.consume(L), w) : n(L);
  }
  function m(L) {
    return L === null ? n(L) : L === 45 ? (e.consume(L), y) : Te(L) ? (c = m, F(L)) : (e.consume(L), m);
  }
  function y(L) {
    return L === 45 ? (e.consume(L), w) : m(L);
  }
  function w(L) {
    return L === 62 ? I(L) : L === 45 ? y(L) : m(L);
  }
  function C(L) {
    const q = "CDATA[";
    return L === q.charCodeAt(i++) ? (e.consume(L), i === q.length ? E : C) : n(L);
  }
  function E(L) {
    return L === null ? n(L) : L === 93 ? (e.consume(L), R) : Te(L) ? (c = E, F(L)) : (e.consume(L), E);
  }
  function R(L) {
    return L === 93 ? (e.consume(L), M) : E(L);
  }
  function M(L) {
    return L === 62 ? I(L) : L === 93 ? (e.consume(L), M) : E(L);
  }
  function P(L) {
    return L === null || L === 62 ? I(L) : Te(L) ? (c = P, F(L)) : (e.consume(L), P);
  }
  function a(L) {
    return L === null ? n(L) : L === 63 ? (e.consume(L), o) : Te(L) ? (c = a, F(L)) : (e.consume(L), a);
  }
  function o(L) {
    return L === 62 ? I(L) : a(L);
  }
  function s(L) {
    return Er(L) ? (e.consume(L), p) : n(L);
  }
  function p(L) {
    return L === 45 || En(L) ? (e.consume(L), p) : O(L);
  }
  function O(L) {
    return Te(L) ? (c = O, F(L)) : bt(L) ? (e.consume(L), O) : I(L);
  }
  function x(L) {
    return L === 45 || En(L) ? (e.consume(L), x) : L === 47 || L === 62 || hn(L) ? N(L) : n(L);
  }
  function N(L) {
    return L === 47 ? (e.consume(L), I) : L === 58 || L === 95 || Er(L) ? (e.consume(L), T) : Te(L) ? (c = N, F(L)) : bt(L) ? (e.consume(L), N) : I(L);
  }
  function T(L) {
    return L === 45 || L === 46 || L === 58 || L === 95 || En(L) ? (e.consume(L), T) : $(L);
  }
  function $(L) {
    return L === 61 ? (e.consume(L), j) : Te(L) ? (c = $, F(L)) : bt(L) ? (e.consume(L), $) : N(L);
  }
  function j(L) {
    return L === null || L === 60 || L === 61 || L === 62 || L === 96 ? n(L) : L === 34 || L === 39 ? (e.consume(L), l = L, A) : Te(L) ? (c = j, F(L)) : bt(L) ? (e.consume(L), j) : (e.consume(L), Z);
  }
  function A(L) {
    return L === l ? (e.consume(L), l = void 0, G) : L === null ? n(L) : Te(L) ? (c = A, F(L)) : (e.consume(L), A);
  }
  function Z(L) {
    return L === null || L === 34 || L === 39 || L === 60 || L === 61 || L === 96 ? n(L) : L === 47 || L === 62 || hn(L) ? N(L) : (e.consume(L), Z);
  }
  function G(L) {
    return L === 47 || L === 62 || hn(L) ? N(L) : n(L);
  }
  function I(L) {
    return L === 62 ? (e.consume(L), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(L);
  }
  function F(L) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(L), e.exit("lineEnding"), U;
  }
  function U(L) {
    return bt(L) ? _t(
      e,
      B,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(L) : B(L);
  }
  function B(L) {
    return e.enter("htmlTextData"), c(L);
  }
}
const J9 = {
  name: "labelEnd",
  tokenize: Z8e,
  resolveTo: L8e,
  resolveAll: A8e
}, N8e = {
  tokenize: T8e
}, R8e = {
  tokenize: B8e
}, _8e = {
  tokenize: I8e
};
function A8e(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function L8e(e, t) {
  let n = e.length, r = 0, l, i, c, f;
  for (; n--; )
    if (l = e[n][1], i) {
      if (l.type === "link" || l.type === "labelLink" && l._inactive)
        break;
      e[n][0] === "enter" && l.type === "labelLink" && (l._inactive = !0);
    } else if (c) {
      if (e[n][0] === "enter" && (l.type === "labelImage" || l.type === "labelLink") && !l._balanced && (i = n, l.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      l.type === "labelEnd" && (c = n);
  const d = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, h = {
    type: "label",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[c][1].end)
  }, g = {
    type: "labelText",
    start: Object.assign({}, e[i + r + 2][1].end),
    end: Object.assign({}, e[c - 2][1].start)
  };
  return f = [
    ["enter", d, t],
    ["enter", h, t]
  ], f = Bn(f, e.slice(i + 1, i + r + 3)), f = Bn(f, [["enter", g, t]]), f = Bn(
    f,
    X9(
      t.parser.constructs.insideSpan.null,
      e.slice(i + r + 4, c - 3),
      t
    )
  ), f = Bn(f, [
    ["exit", g, t],
    e[c - 2],
    e[c - 1],
    ["exit", h, t]
  ]), f = Bn(f, e.slice(c + 1)), f = Bn(f, [["exit", d, t]]), Mr(e, i, e.length, f), e;
}
function Z8e(e, t, n) {
  const r = this;
  let l = r.events.length, i, c;
  for (; l--; )
    if ((r.events[l][1].type === "labelImage" || r.events[l][1].type === "labelLink") && !r.events[l][1]._balanced) {
      i = r.events[l][1];
      break;
    }
  return f;
  function f(y) {
    return i ? i._inactive ? m(y) : (c = r.parser.defined.includes(
      tl(
        r.sliceSerialize({
          start: i.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(y), e.exit("labelMarker"), e.exit("labelEnd"), d) : n(y);
  }
  function d(y) {
    return y === 40 ? e.attempt(
      N8e,
      g,
      c ? g : m
    )(y) : y === 91 ? e.attempt(
      R8e,
      g,
      c ? h : m
    )(y) : c ? g(y) : m(y);
  }
  function h(y) {
    return e.attempt(
      _8e,
      g,
      m
    )(y);
  }
  function g(y) {
    return t(y);
  }
  function m(y) {
    return i._balanced = !0, n(y);
  }
}
function T8e(e, t, n) {
  return r;
  function r(m) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(m), e.exit("resourceMarker"), l;
  }
  function l(m) {
    return hn(m) ? vi(e, i)(m) : i(m);
  }
  function i(m) {
    return m === 41 ? g(m) : cue(
      e,
      c,
      f,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(m);
  }
  function c(m) {
    return hn(m) ? vi(e, d)(m) : g(m);
  }
  function f(m) {
    return n(m);
  }
  function d(m) {
    return m === 34 || m === 39 || m === 40 ? fue(
      e,
      h,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(m) : g(m);
  }
  function h(m) {
    return hn(m) ? vi(e, g)(m) : g(m);
  }
  function g(m) {
    return m === 41 ? (e.enter("resourceMarker"), e.consume(m), e.exit("resourceMarker"), e.exit("resource"), t) : n(m);
  }
}
function B8e(e, t, n) {
  const r = this;
  return l;
  function l(f) {
    return uue.call(
      r,
      e,
      i,
      c,
      "reference",
      "referenceMarker",
      "referenceString"
    )(f);
  }
  function i(f) {
    return r.parser.defined.includes(
      tl(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(f) : n(f);
  }
  function c(f) {
    return n(f);
  }
}
function I8e(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), l;
  }
  function l(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const H8e = {
  name: "labelStartImage",
  tokenize: D8e,
  resolveAll: J9.resolveAll
};
function D8e(e, t, n) {
  const r = this;
  return l;
  function l(f) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(f), e.exit("labelImageMarker"), i;
  }
  function i(f) {
    return f === 91 ? (e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelImage"), c) : n(f);
  }
  function c(f) {
    return f === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(f) : t(f);
  }
}
const z8e = {
  name: "labelStartLink",
  tokenize: F8e,
  resolveAll: J9.resolveAll
};
function F8e(e, t, n) {
  const r = this;
  return l;
  function l(c) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(c), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(c) {
    return c === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(c) : t(c);
  }
}
const Gc = {
  name: "lineEnding",
  tokenize: V8e
};
function V8e(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), _t(e, t, "linePrefix");
  }
}
const bo = {
  name: "thematicBreak",
  tokenize: q8e
};
function q8e(e, t, n) {
  let r = 0, l;
  return i;
  function i(h) {
    return e.enter("thematicBreak"), c(h);
  }
  function c(h) {
    return l = h, f(h);
  }
  function f(h) {
    return h === l ? (e.enter("thematicBreakSequence"), d(h)) : r >= 3 && (h === null || Te(h)) ? (e.exit("thematicBreak"), t(h)) : n(h);
  }
  function d(h) {
    return h === l ? (e.consume(h), r++, d) : (e.exit("thematicBreakSequence"), bt(h) ? _t(e, f, "whitespace")(h) : f(h));
  }
}
const fn = {
  name: "list",
  tokenize: G8e,
  continuation: {
    tokenize: K8e
  },
  exit: X8e
}, U8e = {
  tokenize: Q8e,
  partial: !0
}, W8e = {
  tokenize: Y8e,
  partial: !0
};
function G8e(e, t, n) {
  const r = this, l = r.events[r.events.length - 1];
  let i = l && l[1].type === "linePrefix" ? l[2].sliceSerialize(l[1], !0).length : 0, c = 0;
  return f;
  function f(w) {
    const C = r.containerState.type || (w === 42 || w === 43 || w === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !r.containerState.marker || w === r.containerState.marker : c2(w)) {
      if (r.containerState.type || (r.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), w === 42 || w === 45 ? e.check(bo, n, h)(w) : h(w);
      if (!r.interrupt || w === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(w);
    }
    return n(w);
  }
  function d(w) {
    return c2(w) && ++c < 10 ? (e.consume(w), d) : (!r.interrupt || c < 2) && (r.containerState.marker ? w === r.containerState.marker : w === 41 || w === 46) ? (e.exit("listItemValue"), h(w)) : n(w);
  }
  function h(w) {
    return e.enter("listItemMarker"), e.consume(w), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || w, e.check(
      $1,
      // Can’t be empty when interrupting.
      r.interrupt ? n : g,
      e.attempt(
        U8e,
        y,
        m
      )
    );
  }
  function g(w) {
    return r.containerState.initialBlankLine = !0, i++, y(w);
  }
  function m(w) {
    return bt(w) ? (e.enter("listItemPrefixWhitespace"), e.consume(w), e.exit("listItemPrefixWhitespace"), y) : n(w);
  }
  function y(w) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(w);
  }
}
function K8e(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check($1, l, i);
  function l(f) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, _t(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(f);
  }
  function i(f) {
    return r.containerState.furtherBlankLines || !bt(f) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, c(f)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(W8e, t, c)(f));
  }
  function c(f) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, _t(
      e,
      e.attempt(fn, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(f);
  }
}
function Y8e(e, t, n) {
  const r = this;
  return _t(
    e,
    l,
    "listItemIndent",
    r.containerState.size + 1
  );
  function l(i) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "listItemIndent" && c[2].sliceSerialize(c[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function X8e(e) {
  e.exit(this.containerState.type);
}
function Q8e(e, t, n) {
  const r = this;
  return _t(
    e,
    l,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function l(i) {
    const c = r.events[r.events.length - 1];
    return !bt(i) && c && c[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const tP = {
  name: "setextUnderline",
  tokenize: e9e,
  resolveTo: J8e
};
function J8e(e, t) {
  let n = e.length, r, l, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (l = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const c = {
    type: "setextHeading",
    start: Object.assign({}, e[l][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[l][1].type = "setextHeadingText", i ? (e.splice(l, 0, ["enter", c, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[i][1].end)) : e[r][1] = c, e.push(["exit", c, t]), e;
}
function e9e(e, t, n) {
  const r = this;
  let l;
  return i;
  function i(h) {
    let g = r.events.length, m;
    for (; g--; )
      if (r.events[g][1].type !== "lineEnding" && r.events[g][1].type !== "linePrefix" && r.events[g][1].type !== "content") {
        m = r.events[g][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || m) ? (e.enter("setextHeadingLine"), l = h, c(h)) : n(h);
  }
  function c(h) {
    return e.enter("setextHeadingLineSequence"), f(h);
  }
  function f(h) {
    return h === l ? (e.consume(h), f) : (e.exit("setextHeadingLineSequence"), bt(h) ? _t(e, d, "lineSuffix")(h) : d(h));
  }
  function d(h) {
    return h === null || Te(h) ? (e.exit("setextHeadingLine"), t(h)) : n(h);
  }
}
const t9e = {
  tokenize: n9e
};
function n9e(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    $1,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      l,
      _t(
        e,
        e.attempt(
          this.parser.constructs.flow,
          l,
          e.attempt(o8e, l)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function l(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const r9e = {
  resolveAll: pue()
}, a9e = due("string"), l9e = due("text");
function due(e) {
  return {
    tokenize: t,
    resolveAll: pue(
      e === "text" ? i9e : void 0
    )
  };
  function t(n) {
    const r = this, l = this.parser.constructs[e], i = n.attempt(l, c, f);
    return c;
    function c(g) {
      return h(g) ? i(g) : f(g);
    }
    function f(g) {
      if (g === null) {
        n.consume(g);
        return;
      }
      return n.enter("data"), n.consume(g), d;
    }
    function d(g) {
      return h(g) ? (n.exit("data"), i(g)) : (n.consume(g), d);
    }
    function h(g) {
      if (g === null)
        return !0;
      const m = l[g];
      let y = -1;
      if (m)
        for (; ++y < m.length; ) {
          const w = m[y];
          if (!w.previous || w.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function pue(e) {
  return t;
  function t(n, r) {
    let l = -1, i;
    for (; ++l <= n.length; )
      i === void 0 ? n[l] && n[l][1].type === "data" && (i = l, l++) : (!n[l] || n[l][1].type !== "data") && (l !== i + 2 && (n[i][1].end = n[l - 1][1].end, n.splice(i + 2, l - i - 2), l = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function i9e(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], l = t.sliceStream(r);
      let i = l.length, c = -1, f = 0, d;
      for (; i--; ) {
        const h = l[i];
        if (typeof h == "string") {
          for (c = h.length; h.charCodeAt(c - 1) === 32; )
            f++, c--;
          if (c)
            break;
          c = -1;
        } else if (h === -2)
          d = !0, f++;
        else if (h !== -1) {
          i++;
          break;
        }
      }
      if (f) {
        const h = {
          type: n === e.length || d || f < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - f,
            offset: r.end.offset - f,
            _index: r.start._index + i,
            _bufferIndex: i ? c : r.start._bufferIndex + c
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, h.start), r.start.offset === r.end.offset ? Object.assign(r, h) : (e.splice(
          n,
          0,
          ["enter", h, t],
          ["exit", h, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function o9e(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const l = {}, i = [];
  let c = [], f = [];
  const d = {
    consume: P,
    enter: a,
    exit: o,
    attempt: O(s),
    check: O(p),
    interrupt: O(p, {
      interrupt: !0
    })
  }, h = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: w,
    sliceSerialize: y,
    now: C,
    defineSkip: E,
    write: m
  };
  let g = t.tokenize.call(h, d);
  return t.resolveAll && i.push(t), h;
  function m($) {
    return c = Bn(c, $), R(), c[c.length - 1] !== null ? [] : (x(t, 0), h.events = X9(i, h.events, h), h.events);
  }
  function y($, j) {
    return c9e(w($), j);
  }
  function w($) {
    return s9e(c, $);
  }
  function C() {
    const { line: $, column: j, offset: A, _index: Z, _bufferIndex: G } = r;
    return {
      line: $,
      column: j,
      offset: A,
      _index: Z,
      _bufferIndex: G
    };
  }
  function E($) {
    l[$.line] = $.column, T();
  }
  function R() {
    let $;
    for (; r._index < c.length; ) {
      const j = c[r._index];
      if (typeof j == "string")
        for ($ = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === $ && r._bufferIndex < j.length; )
          M(j.charCodeAt(r._bufferIndex));
      else
        M(j);
    }
  }
  function M($) {
    g = g($);
  }
  function P($) {
    Te($) ? (r.line++, r.column = 1, r.offset += $ === -3 ? 2 : 1, T()) : $ !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === c[r._index].length && (r._bufferIndex = -1, r._index++)), h.previous = $;
  }
  function a($, j) {
    const A = j || {};
    return A.type = $, A.start = C(), h.events.push(["enter", A, h]), f.push(A), A;
  }
  function o($) {
    const j = f.pop();
    return j.end = C(), h.events.push(["exit", j, h]), j;
  }
  function s($, j) {
    x($, j.from);
  }
  function p($, j) {
    j.restore();
  }
  function O($, j) {
    return A;
    function A(Z, G, I) {
      let F, U, B, L;
      return Array.isArray(Z) ? D(Z) : "tokenize" in Z ? (
        // @ts-expect-error Looks like a construct.
        D([Z])
      ) : q(Z);
      function q(se) {
        return Re;
        function Re(ft) {
          const Le = ft !== null && se[ft], Lt = ft !== null && se.null, de = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(Lt) ? Lt : Lt ? [Lt] : []
          ];
          return D(de)(ft);
        }
      }
      function D(se) {
        return F = se, U = 0, se.length === 0 ? I : _(se[U]);
      }
      function _(se) {
        return Re;
        function Re(ft) {
          return L = N(), B = se, se.partial || (h.currentConstruct = se), se.name && h.parser.constructs.disable.null.includes(se.name) ? ue() : se.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            j ? Object.assign(Object.create(h), j) : h,
            d,
            re,
            ue
          )(ft);
        }
      }
      function re(se) {
        return $(B, L), G;
      }
      function ue(se) {
        return L.restore(), ++U < F.length ? _(F[U]) : I;
      }
    }
  }
  function x($, j) {
    $.resolveAll && !i.includes($) && i.push($), $.resolve && Mr(
      h.events,
      j,
      h.events.length - j,
      $.resolve(h.events.slice(j), h)
    ), $.resolveTo && (h.events = $.resolveTo(h.events, h));
  }
  function N() {
    const $ = C(), j = h.previous, A = h.currentConstruct, Z = h.events.length, G = Array.from(f);
    return {
      restore: I,
      from: Z
    };
    function I() {
      r = $, h.previous = j, h.currentConstruct = A, h.events.length = Z, f = G, T();
    }
  }
  function T() {
    r.line in l && r.column < 2 && (r.column = l[r.line], r.offset += l[r.line] - 1);
  }
}
function s9e(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, l = t.end._index, i = t.end._bufferIndex;
  let c;
  if (n === l)
    c = [e[n].slice(r, i)];
  else {
    if (c = e.slice(n, l), r > -1) {
      const f = c[0];
      typeof f == "string" ? c[0] = f.slice(r) : c.shift();
    }
    i > 0 && c.push(e[l].slice(0, i));
  }
  return c;
}
function c9e(e, t) {
  let n = -1;
  const r = [];
  let l;
  for (; ++n < e.length; ) {
    const i = e[n];
    let c;
    if (typeof i == "string")
      c = i;
    else
      switch (i) {
        case -5: {
          c = "\r";
          break;
        }
        case -4: {
          c = `
`;
          break;
        }
        case -3: {
          c = `\r
`;
          break;
        }
        case -2: {
          c = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && l)
            continue;
          c = " ";
          break;
        }
        default:
          c = String.fromCharCode(i);
      }
    l = i === -2, r.push(c);
  }
  return r.join("");
}
const u9e = {
  42: fn,
  43: fn,
  45: fn,
  48: fn,
  49: fn,
  50: fn,
  51: fn,
  52: fn,
  53: fn,
  54: fn,
  55: fn,
  56: fn,
  57: fn,
  62: lue
}, f9e = {
  91: d8e
}, d9e = {
  [-2]: Wc,
  [-1]: Wc,
  32: Wc
}, p9e = {
  35: b8e,
  42: bo,
  45: [tP, bo],
  60: x8e,
  61: tP,
  95: bo,
  96: Jk,
  126: Jk
}, g9e = {
  38: oue,
  92: iue
}, h9e = {
  [-5]: Gc,
  [-4]: Gc,
  [-3]: Gc,
  33: H8e,
  38: oue,
  42: u2,
  60: [Fbe, P8e],
  91: z8e,
  92: [m8e, iue],
  93: J9,
  95: u2,
  96: n8e
}, m9e = {
  null: [u2, r9e]
}, v9e = {
  null: [42, 95]
}, b9e = {
  null: []
}, y9e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: v9e,
  contentInitial: f9e,
  disable: b9e,
  document: u9e,
  flow: p9e,
  flowInitial: d9e,
  insideSpan: m9e,
  string: g9e,
  text: h9e
}, Symbol.toStringTag, { value: "Module" }));
function w9e(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    Mbe([y9e, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: l(Zbe),
    document: l(Bbe),
    flow: l(t9e),
    string: l(a9e),
    text: l(l9e)
  };
  return r;
  function l(i) {
    return c;
    function c(f) {
      return o9e(r, i, f);
    }
  }
}
const nP = /[\0\t\n\r]/g;
function O9e() {
  let e = 1, t = "", n = !0, r;
  return l;
  function l(i, c, f) {
    const d = [];
    let h, g, m, y, w;
    for (i = t + i.toString(c), m = 0, t = "", n && (i.charCodeAt(0) === 65279 && m++, n = void 0); m < i.length; ) {
      if (nP.lastIndex = m, h = nP.exec(i), y = h && h.index !== void 0 ? h.index : i.length, w = i.charCodeAt(y), !h) {
        t = i.slice(m);
        break;
      }
      if (w === 10 && m === y && r)
        d.push(-3), r = void 0;
      else
        switch (r && (d.push(-5), r = void 0), m < y && (d.push(i.slice(m, y)), e += y - m), w) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (g = Math.ceil(e / 4) * 4, d.push(-2); e++ < g; )
              d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      m = y + 1;
    }
    return f && (r && d.push(-5), t && d.push(t), d.push(null)), d;
  }
}
function x9e(e) {
  for (; !sue(e); )
    ;
  return e;
}
function gue(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
const E9e = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $9e(e) {
  return e.replace(E9e, j9e);
}
function j9e(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const l = n.charCodeAt(1), i = l === 120 || l === 88;
    return gue(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Q9(n) || e;
}
const hue = {}.hasOwnProperty, C9e = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(e, t, n) {
    return typeof t != "string" && (n = t, t = void 0), M9e(n)(
      x9e(
        w9e(n).document().write(O9e()(e, t, !0))
      )
    );
  }
);
function M9e(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: f(ot),
      autolinkProtocol: $,
      autolinkEmail: $,
      atxHeading: f(an),
      blockQuote: f(de),
      characterEscape: $,
      characterReference: $,
      codeFenced: f(Zt),
      codeFencedFenceInfo: d,
      codeFencedFenceMeta: d,
      codeIndented: f(Zt, d),
      codeText: f(Jt, d),
      codeTextData: $,
      data: $,
      codeFlowValue: $,
      definition: f(Ht),
      definitionDestinationString: d,
      definitionLabelString: d,
      definitionTitleString: d,
      emphasis: f(Zn),
      hardBreakEscape: f(me),
      hardBreakTrailing: f(me),
      htmlFlow: f(at, d),
      htmlFlowData: $,
      htmlText: f(at, d),
      htmlTextData: $,
      image: f(He),
      label: d,
      link: f(ot),
      listItem: f(Ut),
      listItemValue: C,
      listOrdered: f(Dt, w),
      listUnordered: f(Dt),
      paragraph: f(Kt),
      reference: ue,
      referenceString: d,
      resourceDestinationString: d,
      resourceTitleString: d,
      setextHeading: f(an),
      strong: f(Qn),
      thematicBreak: f(fe)
    },
    exit: {
      atxHeading: g(),
      atxHeadingSequence: O,
      autolink: g(),
      autolinkEmail: Lt,
      autolinkProtocol: Le,
      blockQuote: g(),
      characterEscapeValue: j,
      characterReferenceMarkerHexadecimal: Re,
      characterReferenceMarkerNumeric: Re,
      characterReferenceValue: ft,
      codeFenced: g(P),
      codeFencedFence: M,
      codeFencedFenceInfo: E,
      codeFencedFenceMeta: R,
      codeFlowValue: j,
      codeIndented: g(a),
      codeText: g(F),
      codeTextData: j,
      data: j,
      definition: g(),
      definitionDestinationString: p,
      definitionLabelString: o,
      definitionTitleString: s,
      emphasis: g(),
      hardBreakEscape: g(Z),
      hardBreakTrailing: g(Z),
      htmlFlow: g(G),
      htmlFlowData: j,
      htmlText: g(I),
      htmlTextData: j,
      image: g(B),
      label: q,
      labelText: L,
      lineEnding: A,
      link: g(U),
      listItem: g(),
      listOrdered: g(),
      listUnordered: g(),
      paragraph: g(),
      referenceString: se,
      resourceDestinationString: D,
      resourceTitleString: _,
      resource: re,
      setextHeading: g(T),
      setextHeadingLineSequence: N,
      setextHeadingText: x,
      strong: g(),
      thematicBreak: g()
    }
  };
  mue(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(X) {
    let J = {
      type: "root",
      children: []
    };
    const oe = {
      stack: [J],
      tokenStack: [],
      config: t,
      enter: h,
      exit: m,
      buffer: d,
      resume: y,
      setData: i,
      getData: c
    }, ve = [];
    let Ie = -1;
    for (; ++Ie < X.length; )
      if (X[Ie][1].type === "listOrdered" || X[Ie][1].type === "listUnordered")
        if (X[Ie][0] === "enter")
          ve.push(Ie);
        else {
          const Pt = ve.pop();
          Ie = l(X, Pt, Ie);
        }
    for (Ie = -1; ++Ie < X.length; ) {
      const Pt = t[X[Ie][0]];
      hue.call(Pt, X[Ie][1].type) && Pt[X[Ie][1].type].call(
        Object.assign(
          {
            sliceSerialize: X[Ie][2].sliceSerialize
          },
          oe
        ),
        X[Ie][1]
      );
    }
    if (oe.tokenStack.length > 0) {
      const Pt = oe.tokenStack[oe.tokenStack.length - 1];
      (Pt[1] || rP).call(oe, void 0, Pt[0]);
    }
    for (J.position = {
      start: qr(
        X.length > 0 ? X[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: qr(
        X.length > 0 ? X[X.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Ie = -1; ++Ie < t.transforms.length; )
      J = t.transforms[Ie](J) || J;
    return J;
  }
  function l(X, J, oe) {
    let ve = J - 1, Ie = -1, Pt = !1, Vt, Wt, Fr, qt;
    for (; ++ve <= oe; ) {
      const Et = X[ve];
      if (Et[1].type === "listUnordered" || Et[1].type === "listOrdered" || Et[1].type === "blockQuote" ? (Et[0] === "enter" ? Ie++ : Ie--, qt = void 0) : Et[1].type === "lineEndingBlank" ? Et[0] === "enter" && (Vt && !qt && !Ie && !Fr && (Fr = ve), qt = void 0) : Et[1].type === "linePrefix" || Et[1].type === "listItemValue" || Et[1].type === "listItemMarker" || Et[1].type === "listItemPrefix" || Et[1].type === "listItemPrefixWhitespace" || (qt = void 0), !Ie && Et[0] === "enter" && Et[1].type === "listItemPrefix" || Ie === -1 && Et[0] === "exit" && (Et[1].type === "listUnordered" || Et[1].type === "listOrdered")) {
        if (Vt) {
          let nn = ve;
          for (Wt = void 0; nn--; ) {
            const Tn = X[nn];
            if (Tn[1].type === "lineEnding" || Tn[1].type === "lineEndingBlank") {
              if (Tn[0] === "exit")
                continue;
              Wt && (X[Wt][1].type = "lineEndingBlank", Pt = !0), Tn[1].type = "lineEnding", Wt = nn;
            } else if (!(Tn[1].type === "linePrefix" || Tn[1].type === "blockQuotePrefix" || Tn[1].type === "blockQuotePrefixWhitespace" || Tn[1].type === "blockQuoteMarker" || Tn[1].type === "listItemIndent"))
              break;
          }
          Fr && (!Wt || Fr < Wt) && (Vt._spread = !0), Vt.end = Object.assign(
            {},
            Wt ? X[Wt][1].start : Et[1].end
          ), X.splice(Wt || ve, 0, ["exit", Vt, Et[2]]), ve++, oe++;
        }
        Et[1].type === "listItemPrefix" && (Vt = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, Et[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, X.splice(ve, 0, ["enter", Vt, Et[2]]), ve++, oe++, Fr = void 0, qt = !0);
      }
    }
    return X[J][1]._spread = Pt, oe;
  }
  function i(X, J) {
    n[X] = J;
  }
  function c(X) {
    return n[X];
  }
  function f(X, J) {
    return oe;
    function oe(ve) {
      h.call(this, X(ve), ve), J && J.call(this, ve);
    }
  }
  function d() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function h(X, J, oe) {
    return this.stack[this.stack.length - 1].children.push(X), this.stack.push(X), this.tokenStack.push([J, oe]), X.position = {
      start: qr(J.start)
    }, X;
  }
  function g(X) {
    return J;
    function J(oe) {
      X && X.call(this, oe), m.call(this, oe);
    }
  }
  function m(X, J) {
    const oe = this.stack.pop(), ve = this.tokenStack.pop();
    if (ve)
      ve[0].type !== X.type && (J ? J.call(this, X, ve[0]) : (ve[1] || rP).call(this, X, ve[0]));
    else
      throw new Error(
        "Cannot close `" + X.type + "` (" + mi({
          start: X.start,
          end: X.end
        }) + "): it’s not open"
      );
    return oe.position.end = qr(X.end), oe;
  }
  function y() {
    return jbe(this.stack.pop());
  }
  function w() {
    i("expectingFirstListItemValue", !0);
  }
  function C(X) {
    if (c("expectingFirstListItemValue")) {
      const J = this.stack[this.stack.length - 2];
      J.start = Number.parseInt(this.sliceSerialize(X), 10), i("expectingFirstListItemValue");
    }
  }
  function E() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.lang = X;
  }
  function R() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.meta = X;
  }
  function M() {
    c("flowCodeInside") || (this.buffer(), i("flowCodeInside", !0));
  }
  function P() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = X.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), i("flowCodeInside");
  }
  function a() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = X.replace(/(\r?\n|\r)$/g, "");
  }
  function o(X) {
    const J = this.resume(), oe = this.stack[this.stack.length - 1];
    oe.label = J, oe.identifier = tl(
      this.sliceSerialize(X)
    ).toLowerCase();
  }
  function s() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.title = X;
  }
  function p() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.url = X;
  }
  function O(X) {
    const J = this.stack[this.stack.length - 1];
    if (!J.depth) {
      const oe = this.sliceSerialize(X).length;
      J.depth = oe;
    }
  }
  function x() {
    i("setextHeadingSlurpLineEnding", !0);
  }
  function N(X) {
    const J = this.stack[this.stack.length - 1];
    J.depth = this.sliceSerialize(X).charCodeAt(0) === 61 ? 1 : 2;
  }
  function T() {
    i("setextHeadingSlurpLineEnding");
  }
  function $(X) {
    const J = this.stack[this.stack.length - 1];
    let oe = J.children[J.children.length - 1];
    (!oe || oe.type !== "text") && (oe = le(), oe.position = {
      start: qr(X.start)
    }, J.children.push(oe)), this.stack.push(oe);
  }
  function j(X) {
    const J = this.stack.pop();
    J.value += this.sliceSerialize(X), J.position.end = qr(X.end);
  }
  function A(X) {
    const J = this.stack[this.stack.length - 1];
    if (c("atHardBreak")) {
      const oe = J.children[J.children.length - 1];
      oe.position.end = qr(X.end), i("atHardBreak");
      return;
    }
    !c("setextHeadingSlurpLineEnding") && t.canContainEols.includes(J.type) && ($.call(this, X), j.call(this, X));
  }
  function Z() {
    i("atHardBreak", !0);
  }
  function G() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = X;
  }
  function I() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = X;
  }
  function F() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = X;
  }
  function U() {
    const X = this.stack[this.stack.length - 1];
    if (c("inReference")) {
      const J = c("referenceType") || "shortcut";
      X.type += "Reference", X.referenceType = J, delete X.url, delete X.title;
    } else
      delete X.identifier, delete X.label;
    i("referenceType");
  }
  function B() {
    const X = this.stack[this.stack.length - 1];
    if (c("inReference")) {
      const J = c("referenceType") || "shortcut";
      X.type += "Reference", X.referenceType = J, delete X.url, delete X.title;
    } else
      delete X.identifier, delete X.label;
    i("referenceType");
  }
  function L(X) {
    const J = this.sliceSerialize(X), oe = this.stack[this.stack.length - 2];
    oe.label = $9e(J), oe.identifier = tl(J).toLowerCase();
  }
  function q() {
    const X = this.stack[this.stack.length - 1], J = this.resume(), oe = this.stack[this.stack.length - 1];
    if (i("inReference", !0), oe.type === "link") {
      const ve = X.children;
      oe.children = ve;
    } else
      oe.alt = J;
  }
  function D() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.url = X;
  }
  function _() {
    const X = this.resume(), J = this.stack[this.stack.length - 1];
    J.title = X;
  }
  function re() {
    i("inReference");
  }
  function ue() {
    i("referenceType", "collapsed");
  }
  function se(X) {
    const J = this.resume(), oe = this.stack[this.stack.length - 1];
    oe.label = J, oe.identifier = tl(
      this.sliceSerialize(X)
    ).toLowerCase(), i("referenceType", "full");
  }
  function Re(X) {
    i("characterReferenceType", X.type);
  }
  function ft(X) {
    const J = this.sliceSerialize(X), oe = c("characterReferenceType");
    let ve;
    oe ? (ve = gue(
      J,
      oe === "characterReferenceMarkerNumeric" ? 10 : 16
    ), i("characterReferenceType")) : ve = Q9(J);
    const Ie = this.stack.pop();
    Ie.value += ve, Ie.position.end = qr(X.end);
  }
  function Le(X) {
    j.call(this, X);
    const J = this.stack[this.stack.length - 1];
    J.url = this.sliceSerialize(X);
  }
  function Lt(X) {
    j.call(this, X);
    const J = this.stack[this.stack.length - 1];
    J.url = "mailto:" + this.sliceSerialize(X);
  }
  function de() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Zt() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Jt() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ht() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Zn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function an() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function me() {
    return {
      type: "break"
    };
  }
  function at() {
    return {
      type: "html",
      value: ""
    };
  }
  function He() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ot() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Dt(X) {
    return {
      type: "list",
      ordered: X.type === "listOrdered",
      start: null,
      spread: X._spread,
      children: []
    };
  }
  function Ut(X) {
    return {
      type: "listItem",
      spread: X._spread,
      checked: null,
      children: []
    };
  }
  function Kt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Qn() {
    return {
      type: "strong",
      children: []
    };
  }
  function le() {
    return {
      type: "text",
      value: ""
    };
  }
  function fe() {
    return {
      type: "thematicBreak"
    };
  }
}
function qr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function mue(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? mue(e, r) : k9e(e, r);
  }
}
function k9e(e, t) {
  let n;
  for (n in t)
    if (hue.call(t, n)) {
      if (n === "canContainEols") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "transforms") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "enter" || n === "exit") {
        const r = t[n];
        r && Object.assign(e[n], r);
      }
    }
}
function rP(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + mi({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + mi({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + mi({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function P9e(e) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return C9e(
      n,
      Object.assign({}, r, e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function S9e(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function N9e(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function R9e(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, l = {};
  r && (l.className = ["language-" + r]);
  let i = {
    type: "element",
    tagName: "code",
    properties: l,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function _9e(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function A9e(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function _l(e) {
  const t = [];
  let n = -1, r = 0, l = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let c = "";
    if (i === 37 && En(e.charCodeAt(n + 1)) && En(e.charCodeAt(n + 2)))
      l = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (c = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const f = e.charCodeAt(n + 1);
      i < 56320 && f > 56319 && f < 57344 ? (c = String.fromCharCode(i, f), l = 1) : c = "�";
    } else
      c = String.fromCharCode(i);
    c && (t.push(e.slice(r, n), encodeURIComponent(c)), r = n + l + 1, c = ""), l && (n += l, l = 0);
  }
  return t.join("") + e.slice(r);
}
function vue(e, t) {
  const n = String(t.identifier).toUpperCase(), r = _l(n.toLowerCase()), l = e.footnoteOrder.indexOf(n);
  let i;
  l === -1 ? (e.footnoteOrder.push(n), e.footnoteCounts[n] = 1, i = e.footnoteOrder.length) : (e.footnoteCounts[n]++, i = l + 1);
  const c = e.footnoteCounts[n], f = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + r,
      id: e.clobberPrefix + "fnref-" + r + (c > 1 ? "-" + c : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(i) }]
  };
  e.patch(t, f);
  const d = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [f]
  };
  return e.patch(t, d), e.applyData(t, d);
}
function L9e(e, t) {
  const n = e.footnoteById;
  let r = 1;
  for (; r in n; )
    r++;
  const l = String(r);
  return n[l] = {
    type: "footnoteDefinition",
    identifier: l,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, vue(e, {
    type: "footnoteReference",
    identifier: l,
    position: t.position
  });
}
function Z9e(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function T9e(e, t) {
  if (e.dangerous) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
  return null;
}
function bue(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + r };
  const l = e.all(t), i = l[0];
  i && i.type === "text" ? i.value = "[" + i.value : l.unshift({ type: "text", value: "[" });
  const c = l[l.length - 1];
  return c && c.type === "text" ? c.value += r : l.push({ type: "text", value: r }), l;
}
function B9e(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return bue(e, t);
  const r = { src: _l(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const l = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, l), e.applyData(t, l);
}
function I9e(e, t) {
  const n = { src: _l(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function H9e(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function D9e(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return bue(e, t);
  const r = { href: _l(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function z9e(e, t) {
  const n = { href: _l(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function F9e(e, t, n) {
  const r = e.all(t), l = n ? V9e(n) : yue(t), i = {}, c = [];
  if (typeof t.checked == "boolean") {
    const g = r[0];
    let m;
    g && g.type === "element" && g.tagName === "p" ? m = g : (m = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(m)), m.children.length > 0 && m.children.unshift({ type: "text", value: " " }), m.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let f = -1;
  for (; ++f < r.length; ) {
    const g = r[f];
    (l || f !== 0 || g.type !== "element" || g.tagName !== "p") && c.push({ type: "text", value: `
` }), g.type === "element" && g.tagName === "p" && !l ? c.push(...g.children) : c.push(g);
  }
  const d = r[r.length - 1];
  d && (l || d.type !== "element" || d.tagName !== "p") && c.push({ type: "text", value: `
` });
  const h = { type: "element", tagName: "li", properties: i, children: c };
  return e.patch(t, h), e.applyData(t, h);
}
function V9e(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = yue(n[r]);
  }
  return t;
}
function yue(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function q9e(e, t) {
  const n = {}, r = e.all(t);
  let l = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++l < r.length; ) {
    const c = r[l];
    if (c.type === "element" && c.tagName === "li" && c.properties && Array.isArray(c.properties.className) && c.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function U9e(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function W9e(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function G9e(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const ey = wue("start"), ty = wue("end");
function K9e(e) {
  return { start: ey(e), end: ty(e) };
}
function wue(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function Y9e(e, t) {
  const n = e.all(t), r = n.shift(), l = [];
  if (r) {
    const c = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], c), l.push(c);
  }
  if (n.length > 0) {
    const c = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, f = ey(t.children[1]), d = ty(t.children[t.children.length - 1]);
    f.line && d.line && (c.position = { start: f, end: d }), l.push(c);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function X9e(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", c = n && n.type === "table" ? n.align : void 0, f = c ? c.length : t.children.length;
  let d = -1;
  const h = [];
  for (; ++d < f; ) {
    const m = t.children[d], y = {}, w = c ? c[d] : void 0;
    w && (y.align = w);
    let C = { type: "element", tagName: i, properties: y, children: [] };
    m && (C.children = e.all(m), e.patch(m, C), C = e.applyData(t, C)), h.push(C);
  }
  const g = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(h, !0)
  };
  return e.patch(t, g), e.applyData(t, g);
}
function Q9e(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const aP = 9, lP = 32;
function J9e(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), l = 0;
  const i = [];
  for (; r; )
    i.push(
      iP(t.slice(l, r.index), l > 0, !0),
      r[0]
    ), l = r.index + r[0].length, r = n.exec(t);
  return i.push(iP(t.slice(l), l > 0, !1)), i.join("");
}
function iP(e, t, n) {
  let r = 0, l = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === aP || i === lP; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(l - 1);
    for (; i === aP || i === lP; )
      l--, i = e.codePointAt(l - 1);
  }
  return l > r ? e.slice(r, l) : "";
}
function eye(e, t) {
  const n = { type: "text", value: J9e(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function tye(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const nye = {
  blockquote: S9e,
  break: N9e,
  code: R9e,
  delete: _9e,
  emphasis: A9e,
  footnoteReference: vue,
  footnote: L9e,
  heading: Z9e,
  html: T9e,
  imageReference: B9e,
  image: I9e,
  inlineCode: H9e,
  linkReference: D9e,
  link: z9e,
  listItem: F9e,
  list: q9e,
  paragraph: U9e,
  root: W9e,
  strong: G9e,
  table: Y9e,
  tableCell: Q9e,
  tableRow: X9e,
  text: eye,
  thematicBreak: tye,
  toml: Yi,
  yaml: Yi,
  definition: Yi,
  footnoteDefinition: Yi
};
function Yi() {
  return null;
}
const Oue = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return iye;
    if (typeof e == "string")
      return lye(e);
    if (typeof e == "object")
      return Array.isArray(e) ? rye(e) : aye(e);
    if (typeof e == "function")
      return j1(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function rye(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Oue(e[n]);
  return j1(r);
  function r(...l) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].call(this, ...l))
        return !0;
    return !1;
  }
}
function aye(e) {
  return j1(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function lye(e) {
  return j1(t);
  function t(n) {
    return n && n.type === e;
  }
}
function j1(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function iye() {
  return !0;
}
const oye = !0, oP = !1, sye = "skip", cye = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const l = Oue(t), i = r ? -1 : 1;
    c(e, void 0, [])();
    function c(f, d, h) {
      const g = f && typeof f == "object" ? f : {};
      if (typeof g.type == "string") {
        const y = (
          // `hast`
          typeof g.tagName == "string" ? g.tagName : (
            // `xast`
            typeof g.name == "string" ? g.name : void 0
          )
        );
        Object.defineProperty(m, "name", {
          value: "node (" + (f.type + (y ? "<" + y + ">" : "")) + ")"
        });
      }
      return m;
      function m() {
        let y = [], w, C, E;
        if ((!t || l(f, d, h[h.length - 1] || null)) && (y = uye(n(f, h)), y[0] === oP))
          return y;
        if (f.children && y[0] !== sye)
          for (C = (r ? f.children.length : -1) + i, E = h.concat(f); C > -1 && C < f.children.length; ) {
            if (w = c(f.children[C], C, E)(), w[0] === oP)
              return w;
            C = typeof w[1] == "number" ? w[1] : C + i;
          }
        return y;
      }
    }
  }
);
function uye(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [oye, e] : [e];
}
const ny = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), cye(e, t, l, r);
    function l(i, c) {
      const f = c[c.length - 1];
      return n(
        i,
        f ? f.children.indexOf(i) : null,
        f
      );
    }
  }
);
function fye(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const sP = {}.hasOwnProperty;
function dye(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return ny(e, "definition", (r) => {
    const l = cP(r.identifier);
    l && !sP.call(t, l) && (t[l] = r);
  }), n;
  function n(r) {
    const l = cP(r);
    return l && sP.call(t, l) ? t[l] : null;
  }
}
function cP(e) {
  return String(e || "").toUpperCase();
}
const _o = {}.hasOwnProperty;
function pye(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, l = {};
  return c.dangerous = r, c.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, c.footnoteLabel = n.footnoteLabel || "Footnotes", c.footnoteLabelTagName = n.footnoteLabelTagName || "h2", c.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, c.footnoteBackLabel = n.footnoteBackLabel || "Back to content", c.unknownHandler = n.unknownHandler, c.passThrough = n.passThrough, c.handlers = { ...nye, ...n.handlers }, c.definition = dye(e), c.footnoteById = l, c.footnoteOrder = [], c.footnoteCounts = {}, c.patch = gye, c.applyData = hye, c.one = f, c.all = d, c.wrap = vye, c.augment = i, ny(e, "footnoteDefinition", (h) => {
    const g = String(h.identifier).toUpperCase();
    _o.call(l, g) || (l[g] = h);
  }), c;
  function i(h, g) {
    if (h && "data" in h && h.data) {
      const m = h.data;
      m.hName && (g.type !== "element" && (g = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), g.tagName = m.hName), g.type === "element" && m.hProperties && (g.properties = { ...g.properties, ...m.hProperties }), "children" in g && g.children && m.hChildren && (g.children = m.hChildren);
    }
    if (h) {
      const m = "type" in h ? h : { position: h };
      fye(m) || (g.position = { start: ey(m), end: ty(m) });
    }
    return g;
  }
  function c(h, g, m, y) {
    return Array.isArray(m) && (y = m, m = {}), i(h, {
      type: "element",
      tagName: g,
      properties: m || {},
      children: y || []
    });
  }
  function f(h, g) {
    return xue(c, h, g);
  }
  function d(h) {
    return ry(c, h);
  }
}
function gye(e, t) {
  e.position && (t.position = K9e(e));
}
function hye(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, l = e.data.hChildren, i = e.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && i && (n.properties = { ...n.properties, ...i }), "children" in n && n.children && l !== null && l !== void 0 && (n.children = l);
  }
  return n;
}
function xue(e, t, n) {
  const r = t && t.type;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return _o.call(e.handlers, r) ? e.handlers[r](e, t, n) : e.passThrough && e.passThrough.includes(r) ? "children" in t ? { ...t, children: ry(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, n) : mye(e, t);
}
function ry(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let l = -1;
    for (; ++l < r.length; ) {
      const i = xue(e, r[l], t);
      if (i) {
        if (l && r[l - 1].type === "break" && (!Array.isArray(i) && i.type === "text" && (i.value = i.value.replace(/^\s+/, "")), !Array.isArray(i) && i.type === "element")) {
          const c = i.children[0];
          c && c.type === "text" && (c.value = c.value.replace(/^\s+/, ""));
        }
        Array.isArray(i) ? n.push(...i) : n.push(i);
      }
    }
  }
  return n;
}
function mye(e, t) {
  const n = t.data || {}, r = "value" in t && !(_o.call(n, "hProperties") || _o.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: ry(e, t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function vye(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function bye(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.footnoteOrder.length; ) {
    const r = e.footnoteById[e.footnoteOrder[n]];
    if (!r)
      continue;
    const l = e.all(r), i = String(r.identifier).toUpperCase(), c = _l(i.toLowerCase());
    let f = 0;
    const d = [];
    for (; ++f <= e.footnoteCounts[i]; ) {
      const m = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e.clobberPrefix + "fnref-" + c + (f > 1 ? "-" + f : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: e.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      f > 1 && m.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(f) }]
      }), d.length > 0 && d.push({ type: "text", value: " " }), d.push(m);
    }
    const h = l[l.length - 1];
    if (h && h.type === "element" && h.tagName === "p") {
      const m = h.children[h.children.length - 1];
      m && m.type === "text" ? m.value += " " : h.children.push({ type: "text", value: " " }), h.children.push(...d);
    } else
      l.push(...d);
    const g = {
      type: "element",
      tagName: "li",
      properties: { id: e.clobberPrefix + "fn-" + c },
      children: e.wrap(l, !0)
    };
    e.patch(r, g), t.push(g);
  }
  if (t.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            // To do: use structured clone.
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function Eue(e, t) {
  const n = pye(e, t), r = n.one(e, null), l = bye(n);
  return l && r.children.push({ type: "text", value: `
` }, l), Array.isArray(r) ? { type: "root", children: r } : r;
}
const yye = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(e, t) {
    return e && "run" in e ? Oye(e, t) : xye(e || t);
  }
), wye = yye;
function Oye(e, t) {
  return (n, r, l) => {
    e.run(Eue(n, t), r, (i) => {
      l(i);
    });
  };
}
function xye(e) {
  return (t) => Eue(t, e);
}
class Hi {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Hi.prototype.property = {};
Hi.prototype.normal = {};
Hi.prototype.space = null;
function $ue(e, t) {
  const n = {}, r = {};
  let l = -1;
  for (; ++l < e.length; )
    Object.assign(n, e[l].property), Object.assign(r, e[l].normal);
  return new Hi(n, r, t);
}
function f2(e) {
  return e.toLowerCase();
}
class Wn {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Wn.prototype.space = null;
Wn.prototype.boolean = !1;
Wn.prototype.booleanish = !1;
Wn.prototype.overloadedBoolean = !1;
Wn.prototype.number = !1;
Wn.prototype.commaSeparated = !1;
Wn.prototype.spaceSeparated = !1;
Wn.prototype.commaOrSpaceSeparated = !1;
Wn.prototype.mustUseProperty = !1;
Wn.prototype.defined = !1;
let Eye = 0;
const rt = Aa(), Yt = Aa(), jue = Aa(), ae = Aa(), Rt = Aa(), nl = Aa(), On = Aa();
function Aa() {
  return 2 ** ++Eye;
}
const d2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: rt,
  booleanish: Yt,
  commaOrSpaceSeparated: On,
  commaSeparated: nl,
  number: ae,
  overloadedBoolean: jue,
  spaceSeparated: Rt
}, Symbol.toStringTag, { value: "Module" })), Kc = Object.keys(d2);
class ay extends Wn {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, l) {
    let i = -1;
    if (super(t, n), uP(this, "space", l), typeof r == "number")
      for (; ++i < Kc.length; ) {
        const c = Kc[i];
        uP(this, Kc[i], (r & d2[c]) === d2[c]);
      }
  }
}
ay.prototype.defined = !0;
function uP(e, t, n) {
  n && (e[t] = n);
}
const $ye = {}.hasOwnProperty;
function Al(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if ($ye.call(e.properties, r)) {
      const l = e.properties[r], i = new ay(
        r,
        e.transform(e.attributes || {}, r),
        l,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[f2(r)] = r, n[f2(i.attribute)] = r;
    }
  return new Hi(t, n, e.space);
}
const Cue = Al({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Mue = Al({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function kue(e, t) {
  return t in e ? e[t] : t;
}
function Pue(e, t) {
  return kue(e, t.toLowerCase());
}
const Sue = Al({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Pue,
  properties: { xmlns: null, xmlnsXLink: null }
}), Nue = Al({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Yt,
    ariaAutoComplete: null,
    ariaBusy: Yt,
    ariaChecked: Yt,
    ariaColCount: ae,
    ariaColIndex: ae,
    ariaColSpan: ae,
    ariaControls: Rt,
    ariaCurrent: null,
    ariaDescribedBy: Rt,
    ariaDetails: null,
    ariaDisabled: Yt,
    ariaDropEffect: Rt,
    ariaErrorMessage: null,
    ariaExpanded: Yt,
    ariaFlowTo: Rt,
    ariaGrabbed: Yt,
    ariaHasPopup: null,
    ariaHidden: Yt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Rt,
    ariaLevel: ae,
    ariaLive: null,
    ariaModal: Yt,
    ariaMultiLine: Yt,
    ariaMultiSelectable: Yt,
    ariaOrientation: null,
    ariaOwns: Rt,
    ariaPlaceholder: null,
    ariaPosInSet: ae,
    ariaPressed: Yt,
    ariaReadOnly: Yt,
    ariaRelevant: null,
    ariaRequired: Yt,
    ariaRoleDescription: Rt,
    ariaRowCount: ae,
    ariaRowIndex: ae,
    ariaRowSpan: ae,
    ariaSelected: Yt,
    ariaSetSize: ae,
    ariaSort: null,
    ariaValueMax: ae,
    ariaValueMin: ae,
    ariaValueNow: ae,
    ariaValueText: null,
    role: null
  }
}), jye = Al({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Pue,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: nl,
    acceptCharset: Rt,
    accessKey: Rt,
    action: null,
    allow: null,
    allowFullScreen: rt,
    allowPaymentRequest: rt,
    allowUserMedia: rt,
    alt: null,
    as: null,
    async: rt,
    autoCapitalize: null,
    autoComplete: Rt,
    autoFocus: rt,
    autoPlay: rt,
    blocking: Rt,
    capture: null,
    charSet: null,
    checked: rt,
    cite: null,
    className: Rt,
    cols: ae,
    colSpan: null,
    content: null,
    contentEditable: Yt,
    controls: rt,
    controlsList: Rt,
    coords: ae | nl,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: rt,
    defer: rt,
    dir: null,
    dirName: null,
    disabled: rt,
    download: jue,
    draggable: Yt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: rt,
    formTarget: null,
    headers: Rt,
    height: ae,
    hidden: rt,
    high: ae,
    href: null,
    hrefLang: null,
    htmlFor: Rt,
    httpEquiv: Rt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: rt,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: rt,
    itemId: null,
    itemProp: Rt,
    itemRef: Rt,
    itemScope: rt,
    itemType: Rt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: rt,
    low: ae,
    manifest: null,
    max: null,
    maxLength: ae,
    media: null,
    method: null,
    min: null,
    minLength: ae,
    multiple: rt,
    muted: rt,
    name: null,
    nonce: null,
    noModule: rt,
    noValidate: rt,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: rt,
    optimum: ae,
    pattern: null,
    ping: Rt,
    placeholder: null,
    playsInline: rt,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: rt,
    referrerPolicy: null,
    rel: Rt,
    required: rt,
    reversed: rt,
    rows: ae,
    rowSpan: ae,
    sandbox: Rt,
    scope: null,
    scoped: rt,
    seamless: rt,
    selected: rt,
    shadowRootDelegatesFocus: rt,
    shadowRootMode: null,
    shape: null,
    size: ae,
    sizes: null,
    slot: null,
    span: ae,
    spellCheck: Yt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ae,
    step: null,
    style: null,
    tabIndex: ae,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: rt,
    useMap: null,
    value: Yt,
    width: ae,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Rt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ae,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ae,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: rt,
    // Lists. Use CSS to reduce space between items instead
    declare: rt,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ae,
    // `<img>` and `<object>`
    leftMargin: ae,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ae,
    // `<body>`
    marginWidth: ae,
    // `<body>`
    noResize: rt,
    // `<frame>`
    noHref: rt,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: rt,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: rt,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ae,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Yt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ae,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ae,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: rt,
    disableRemotePlayback: rt,
    prefix: null,
    property: null,
    results: ae,
    security: null,
    unselectable: null
  }
}), Cye = Al({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: kue,
  properties: {
    about: On,
    accentHeight: ae,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ae,
    amplitude: ae,
    arabicForm: null,
    ascent: ae,
    attributeName: null,
    attributeType: null,
    azimuth: ae,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ae,
    by: null,
    calcMode: null,
    capHeight: ae,
    className: Rt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ae,
    diffuseConstant: ae,
    direction: null,
    display: null,
    dur: null,
    divisor: ae,
    dominantBaseline: null,
    download: rt,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ae,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ae,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ae,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: nl,
    g2: nl,
    glyphName: nl,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ae,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ae,
    horizOriginX: ae,
    horizOriginY: ae,
    id: null,
    ideographic: ae,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ae,
    k: ae,
    k1: ae,
    k2: ae,
    k3: ae,
    k4: ae,
    kernelMatrix: On,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ae,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ae,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ae,
    overlineThickness: ae,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ae,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Rt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ae,
    pointsAtY: ae,
    pointsAtZ: ae,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: On,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: On,
    rev: On,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: On,
    requiredFeatures: On,
    requiredFonts: On,
    requiredFormats: On,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ae,
    specularExponent: ae,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ae,
    strikethroughThickness: ae,
    string: null,
    stroke: null,
    strokeDashArray: On,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ae,
    strokeOpacity: ae,
    strokeWidth: null,
    style: null,
    surfaceScale: ae,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: On,
    tabIndex: ae,
    tableValues: null,
    target: null,
    targetX: ae,
    targetY: ae,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: On,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ae,
    underlineThickness: ae,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ae,
    values: null,
    vAlphabetic: ae,
    vMathematical: ae,
    vectorEffect: null,
    vHanging: ae,
    vIdeographic: ae,
    version: null,
    vertAdvY: ae,
    vertOriginX: ae,
    vertOriginY: ae,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ae,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Mye = /^data[-\w.:]+$/i, fP = /-[a-z]/g, kye = /[A-Z]/g;
function Pye(e, t) {
  const n = f2(t);
  let r = t, l = Wn;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Mye.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(fP, Nye);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!fP.test(i)) {
        let c = i.replace(kye, Sye);
        c.charAt(0) !== "-" && (c = "-" + c), t = "data" + c;
      }
    }
    l = ay;
  }
  return new l(r, t);
}
function Sye(e) {
  return "-" + e.toLowerCase();
}
function Nye(e) {
  return e.charAt(1).toUpperCase();
}
const dP = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Rye = $ue([Mue, Cue, Sue, Nue, jye], "html"), _ye = $ue([Mue, Cue, Sue, Nue, Cye], "svg");
function Aye(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      ny(t, "element", (n, r, l) => {
        const i = (
          /** @type {Element|Root} */
          l
        );
        let c;
        if (e.allowedElements ? c = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (c = e.disallowedElements.includes(n.tagName)), !c && e.allowElement && typeof r == "number" && (c = !e.allowElement(n, r, i)), c && typeof r == "number")
          return e.unwrapDisallowed && n.children ? i.children.splice(r, 1, ...n.children) : i.children.splice(r, 1), r;
      });
    };
}
function Lye(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function Zye(e) {
  return e.join(" ").trim();
}
function Tye(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var ly = { exports: {} }, pP = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Bye = /\n/g, Iye = /^\s*/, Hye = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Dye = /^:\s*/, zye = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Fye = /^[;\s]*/, Vye = /^\s+|\s+$/g, qye = `
`, gP = "/", hP = "*", xa = "", Uye = "comment", Wye = "declaration", Gye = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function l(C) {
    var E = C.match(Bye);
    E && (n += E.length);
    var R = C.lastIndexOf(qye);
    r = ~R ? C.length - R : r + C.length;
  }
  function i() {
    var C = { line: n, column: r };
    return function(E) {
      return E.position = new c(C), h(), E;
    };
  }
  function c(C) {
    this.start = C, this.end = { line: n, column: r }, this.source = t.source;
  }
  c.prototype.content = e;
  function f(C) {
    var E = new Error(
      t.source + ":" + n + ":" + r + ": " + C
    );
    if (E.reason = C, E.filename = t.source, E.line = n, E.column = r, E.source = e, !t.silent)
      throw E;
  }
  function d(C) {
    var E = C.exec(e);
    if (E) {
      var R = E[0];
      return l(R), e = e.slice(R.length), E;
    }
  }
  function h() {
    d(Iye);
  }
  function g(C) {
    var E;
    for (C = C || []; E = m(); )
      E !== !1 && C.push(E);
    return C;
  }
  function m() {
    var C = i();
    if (!(gP != e.charAt(0) || hP != e.charAt(1))) {
      for (var E = 2; xa != e.charAt(E) && (hP != e.charAt(E) || gP != e.charAt(E + 1)); )
        ++E;
      if (E += 2, xa === e.charAt(E - 1))
        return f("End of comment missing");
      var R = e.slice(2, E - 2);
      return r += 2, l(R), e = e.slice(E), r += 2, C({
        type: Uye,
        comment: R
      });
    }
  }
  function y() {
    var C = i(), E = d(Hye);
    if (E) {
      if (m(), !d(Dye))
        return f("property missing ':'");
      var R = d(zye), M = C({
        type: Wye,
        property: mP(E[0].replace(pP, xa)),
        value: R ? mP(R[0].replace(pP, xa)) : xa
      });
      return d(Fye), M;
    }
  }
  function w() {
    var C = [];
    g(C);
    for (var E; E = y(); )
      E !== !1 && (C.push(E), g(C));
    return C;
  }
  return h(), w();
};
function mP(e) {
  return e ? e.replace(Vye, xa) : xa;
}
var Kye = Gye;
function Rue(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, l = Kye(e), i = typeof t == "function", c, f, d = 0, h = l.length; d < h; d++)
    r = l[d], c = r.property, f = r.value, i ? t(c, f, r) : f && (n || (n = {}), n[c] = f);
  return n;
}
ly.exports = Rue;
ly.exports.default = Rue;
var Yye = ly.exports;
const Xye = /* @__PURE__ */ ce(Yye), p2 = {}.hasOwnProperty, Qye = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function _ue(e, t) {
  const n = [];
  let r = -1, l;
  for (; ++r < t.children.length; )
    l = t.children[r], l.type === "element" ? n.push(Jye(e, l, r, t)) : l.type === "text" ? (t.type !== "element" || !Qye.has(t.tagName) || !Lye(l)) && n.push(l.value) : l.type === "raw" && !e.options.skipHtml && n.push(l.value);
  return n;
}
function Jye(e, t, n, r) {
  const l = e.options, i = l.transformLinkUri === void 0 ? abe : l.transformLinkUri, c = e.schema, f = t.tagName, d = {};
  let h = c, g;
  if (c.space === "html" && f === "svg" && (h = _ye, e.schema = h), t.properties)
    for (g in t.properties)
      p2.call(t.properties, g) && twe(d, g, t.properties[g], e);
  (f === "ol" || f === "ul") && e.listDepth++;
  const m = _ue(e, t);
  (f === "ol" || f === "ul") && e.listDepth--, e.schema = c;
  const y = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, w = l.components && p2.call(l.components, f) ? l.components[f] : f, C = typeof w == "string" || w === k.Fragment;
  if (!kge.isValidElementType(w))
    throw new TypeError(
      `Component for name \`${f}\` not defined or is not renderable`
    );
  if (d.key = n, f === "a" && l.linkTarget && (d.target = typeof l.linkTarget == "function" ? l.linkTarget(
    String(d.href || ""),
    t.children,
    typeof d.title == "string" ? d.title : null
  ) : l.linkTarget), f === "a" && i && (d.href = i(
    String(d.href || ""),
    t.children,
    typeof d.title == "string" ? d.title : null
  )), !C && f === "code" && r.type === "element" && r.tagName !== "pre" && (d.inline = !0), !C && (f === "h1" || f === "h2" || f === "h3" || f === "h4" || f === "h5" || f === "h6") && (d.level = Number.parseInt(f.charAt(1), 10)), f === "img" && l.transformImageUri && (d.src = l.transformImageUri(
    String(d.src || ""),
    String(d.alt || ""),
    typeof d.title == "string" ? d.title : null
  )), !C && f === "li" && r.type === "element") {
    const E = ewe(t);
    d.checked = E && E.properties ? !!E.properties.checked : null, d.index = Yc(r, t), d.ordered = r.tagName === "ol";
  }
  return !C && (f === "ol" || f === "ul") && (d.ordered = f === "ol", d.depth = e.listDepth), (f === "td" || f === "th") && (d.align && (d.style || (d.style = {}), d.style.textAlign = d.align, delete d.align), C || (d.isHeader = f === "th")), !C && f === "tr" && r.type === "element" && (d.isHeader = r.tagName === "thead"), l.sourcePos && (d["data-sourcepos"] = awe(y)), !C && l.rawSourcePos && (d.sourcePosition = t.position), !C && l.includeElementIndex && (d.index = Yc(r, t), d.siblingCount = Yc(r)), C || (d.node = t), m.length > 0 ? k.createElement(w, d, m) : k.createElement(w, d);
}
function ewe(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function Yc(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function twe(e, t, n, r) {
  const l = Pye(r.schema, t);
  let i = n;
  i == null || i !== i || (Array.isArray(i) && (i = l.commaSeparated ? Tye(i) : Zye(i)), l.property === "style" && typeof i == "string" && (i = nwe(i)), l.space && l.property ? e[p2.call(dP, l.property) ? dP[l.property] : l.property] = i : l.attribute && (e[l.attribute] = i));
}
function nwe(e) {
  const t = {};
  try {
    Xye(e, n);
  } catch {
  }
  return t;
  function n(r, l) {
    const i = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[i.replace(/-([a-z])/g, rwe)] = l;
  }
}
function rwe(e, t) {
  return t.toUpperCase();
}
function awe(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map(String).join("");
}
const vP = {}.hasOwnProperty, lwe = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Xi = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function Aue(e) {
  for (const i in Xi)
    if (vP.call(Xi, i) && vP.call(e, i)) {
      const c = Xi[i];
      console.warn(
        `[react-markdown] Warning: please ${c.to ? `use \`${c.to}\` instead of` : "remove"} \`${i}\` (see <${lwe}#${c.id}> for more info)`
      ), delete Xi[i];
    }
  const t = wbe().use(P9e).use(e.remarkPlugins || []).use(wye, {
    ...e.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(e.rehypePlugins || []).use(Aye, e), n = new eue();
  typeof e.children == "string" ? n.value = e.children : e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  );
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let l = k.createElement(
    k.Fragment,
    {},
    _ue({ options: e, schema: Rye, listDepth: 0 }, r)
  );
  return e.className && (l = k.createElement("div", { className: e.className }, l)), l;
}
Aue.propTypes = {
  // Core options:
  children: z.string,
  // Layout options:
  className: z.string,
  // Filter options:
  allowElement: z.func,
  allowedElements: z.arrayOf(z.string),
  disallowedElements: z.arrayOf(z.string),
  unwrapDisallowed: z.bool,
  // Plugin options:
  remarkPlugins: z.arrayOf(
    z.oneOfType([
      z.object,
      z.func,
      z.arrayOf(
        z.oneOfType([
          z.bool,
          z.string,
          z.object,
          z.func,
          z.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            z.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: z.arrayOf(
    z.oneOfType([
      z.object,
      z.func,
      z.arrayOf(
        z.oneOfType([
          z.bool,
          z.string,
          z.object,
          z.func,
          z.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            z.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: z.bool,
  rawSourcePos: z.bool,
  skipHtml: z.bool,
  includeElementIndex: z.bool,
  transformLinkUri: z.oneOfType([z.func, z.bool]),
  linkTarget: z.oneOfType([z.func, z.string]),
  transformImageUri: z.func,
  components: z.object
};
var Lue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Lue);
var iwe = Lue.exports;
const owe = /* @__PURE__ */ ce(iwe);
var Zue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Zue);
var swe = Zue.exports;
const cwe = /* @__PURE__ */ ce(swe);
var Tue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Tue);
var uwe = Tue.exports;
const fwe = /* @__PURE__ */ ce(uwe);
function dwe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ke(e, t, n) {
  return (t = dwe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Sn() {
  return Sn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sn.apply(this, arguments);
}
function pr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Ee(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function pwe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return bP(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return bP(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function bP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var yP, wP, OP, xP, EP, $P, jP, CP, Ll = v(yP || (yP = Ee([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), Bue = Ke(Ke({}, W.Body1, v(wP || (wP = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(OP || (OP = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), gwe = Ke(Ke({}, W.Body1, v(xP || (xP = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(EP || (EP = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), C1 = Ke(Ke({}, S.Light, v($P || ($P = Ee([`
    color: `, `;
  `])), b.black)), S.Dark, v(jP || (jP = Ee([`
    color: `, `;
  `])), b.gray.light2)), La = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, hwe = ["baseFontSize", "darkMode", "className", "weight", "as"], Iue = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = pr(e, hwe), h = K(n).theme, g = La(t), m = ne(f).Component, y = v(CP || (CP = Ee([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, Sn({ className: H(Ll, Bue[g], C1[h], y, r) }, d));
});
Iue.displayName = "Body";
var MP, kP, PP, SP, NP, RP, _P, AP, LP, ZP, mwe = { label: "lg-label", description: "lg-description" };
v(MP || (MP = Ee([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Ke(Ke({}, S.Light, v(kP || (kP = Ee([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(PP || (PP = Ee([`
    color: `, `;
  `])), b.gray.light1));
Ke(Ke({}, S.Light, v(SP || (SP = Ee([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(NP || (NP = Ee([`
    color: `, `;
  `])), b.gray.dark1));
Ke(Ke({}, W.Body1, v(RP || (RP = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(_P || (_P = Ee([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var TP, BP, IP, HP, DP;
Ke(Ke({}, S.Light, v(AP || (AP = Ee([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(LP || (LP = Ee([`
    color: `, `;
  `])), b.gray.light1));
v(ZP || (ZP = Ee([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var zP, FP, VP, qP, UP, WP, vwe = v(TP || (TP = Ee([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), bwe = Ke(Ke({}, S.Light, v(BP || (BP = Ee([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(IP || (IP = Ee([`
    color: `, `;
  `])), b.red.light1)), ywe = Ke(Ke({}, W.Body1, v(HP || (HP = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(DP || (DP = Ee([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), wwe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = pr(e, wwe), f = K(r).theme, d = La(), h = ne(n).Component;
  return k.createElement(h, Sn({}, c, { className: H(vwe, bwe[f], ywe[d], i) }), l);
});
var Owe = v(zP || (zP = Ee([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), xwe = Ke(Ke({}, S.Light, v(FP || (FP = Ee([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(VP || (VP = Ee([`
    color: `, `;
  `])), b.gray.light2)), Ewe = ["darkMode", "className", "as"], Hue = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = pr(e, Ewe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Sn({ className: H(Ll, Owe, xwe[c], n) }, i));
});
Hue.displayName = "H1";
var GP, $we = v(qP || (qP = Ee([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), jwe = Ke(Ke({}, S.Light, v(UP || (UP = Ee([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(WP || (WP = Ee([`
    color: `, `;
  `])), b.gray.light2)), Cwe = ["darkMode", "className", "as"], Due = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = pr(e, Cwe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Sn({ className: H(Ll, $we, jwe[c], n) }, i));
});
Due.displayName = "H2";
var KP, YP, XP, QP, JP, eS, tS, nS, rS, aS, Mwe = v(GP || (GP = Ee([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), kwe = ["darkMode", "className", "as"], zue = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = pr(e, kwe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Sn({ className: H(Ll, Mwe, C1[c], n) }, i));
});
zue.displayName = "H3";
var lS, iS, oS, dl = gt(), Pwe = v(KP || (KP = Ee([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, dl), Swe = Ke(Ke({}, S.Light, v(YP || (YP = Ee([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, dl, b.gray.light2, b.gray.light1)), S.Dark, v(XP || (XP = Ee([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, dl, b.gray.dark2, b.gray.dark1)), Nwe = Ke(Ke({}, S.Light, v(QP || (QP = Ee([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), dl, it[S.Light].default, b.blue.base)), S.Dark, v(JP || (JP = Ee([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), dl, it[S.Dark].default, b.blue.base)), Rwe = Ke(Ke({}, S.Light, v(eS || (eS = Ee([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(tS || (tS = Ee([`
    color: `, `;
  `])), b.blue.light1)), _we = v(nS || (nS = Ee([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), Awe = v(rS || (rS = Ee([`
  white-space: nowrap;
`]))), Lwe = v(aS || (aS = Ee([`
  white-space: normal;
`]))), Zwe = ["children", "className", "darkMode", "baseFontSize", "as"], g2 = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = pr(e, Zwe), g = K(c).theme, m = La(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? Awe : Lwe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(gwe[m], Pwe, Swe[g], Nwe[g], w, Ke({}, Rwe[g], C), i) }, l);
  return C ? k.createElement(y, Sn({ className: H(dl, _we, i) }, h), E) : k.cloneElement(E, h);
});
g2.displayName = "InlineCode", g2.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var sS, cS, uS, fS, dS, pS, gS;
v(lS || (lS = Ee([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Ke(Ke({}, S.Light, v(iS || (iS = Ee([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(oS || (oS = Ee([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var hS, mS, vS, Twe = v(sS || (sS = Ee([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), Bwe = Ke(Ke({}, S.Light, v(cS || (cS = Ee([`
    color: `, `;
  `])), b.black)), S.Dark, v(uS || (uS = Ee([`
    color: `, `;
  `])), b.gray.light2)), Iwe = Ke(Ke({}, S.Light, v(fS || (fS = Ee([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(dS || (dS = Ee([`
    color: `, `;
  `])), b.gray.dark1)), Hwe = Ke(Ke({}, W.Body1, v(pS || (pS = Ee([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(gS || (gS = Ee([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), Dwe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], zwe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? mwe.label : h, m = pr(e, Dwe), y = K(n).theme, w = La(t), C = ne(d).Component;
  return k.createElement(C, Sn({ "data-lgid": g, className: H(Twe, Bwe[y], Hwe[w], Ke({}, Iwe[y], c), r) }, m), l);
});
zwe.displayName = "Label";
var bS, yS, wS, OS, xS, ES, Ao = gt(), Fue = v(hS || (hS = Ee([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), Vue = Ke(Ke({}, S.Light, v(mS || (mS = Ee([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(vS || (vS = Ee([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), que = function(e) {
  if (e)
    return Bue[e];
}, Fwe = v(bS || (bS = Ee([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), Vwe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = pr(e, Vwe), d = K(i).theme, h = La(l), g = nt(c, f, "span").Component;
  return k.createElement(g, Sn({ className: H(Ao, Fue, que(h), Vue[d], Fwe, r), ref: t }, f), k.createElement(owe, { role: "presentation" }), n);
});
var qwe = v(yS || (yS = Ee([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), Uwe = v(wS || (wS = Ee([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Ao, Ao), Wwe = v(OS || (OS = Ee([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), Gwe = "hover", Kwe = "persist", $S = "none", Ywe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"], Xwe = tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? $S : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = pr(e, Ywe), y = pwe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = La(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== $S && (E = k.createElement(cwe, { role: "presentation", size: 12, className: H(Ke(Ke({}, Uwe, i === Gwe), qwe, i === Kwe)) })) : E = k.createElement(fwe, { role: "presentation", className: Wwe }), k.createElement(P, Sn({ className: H(Ao, Fue, que(M), Vue[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
}), Qwe = v(xS || (xS = Ee([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), Jwe = ["darkMode", "className", "as"], eOe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = pr(e, Jwe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Sn({ className: H(Ll, Qwe, C1[c], n) }, i));
});
eOe.displayName = "Overline";
var tOe = v(ES || (ES = Ee([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), nOe = ["darkMode", "className", "as"], rOe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = pr(e, nOe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Sn({ className: H(Ll, tOe, C1[c], n) }, i));
});
rOe.displayName = "Subtitle";
var jS;
v(jS || (jS = Ee([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var Uue = { exports: {} };
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function(e, t) {
  (function(r, l) {
    e.exports = l();
  })(pe, function() {
    return (
      /******/
      function() {
        var n = {
          /***/
          686: (
            /***/
            function(i, c, f) {
              f.d(c, {
                default: function() {
                  return (
                    /* binding */
                    q
                  );
                }
              });
              var d = f(279), h = /* @__PURE__ */ f.n(d), g = f(370), m = /* @__PURE__ */ f.n(g), y = f(817), w = /* @__PURE__ */ f.n(y);
              function C(D) {
                try {
                  return document.execCommand(D);
                } catch {
                  return !1;
                }
              }
              var E = function(_) {
                var re = w()(_);
                return C("cut"), re;
              }, R = E;
              function M(D) {
                var _ = document.documentElement.getAttribute("dir") === "rtl", re = document.createElement("textarea");
                re.style.fontSize = "12pt", re.style.border = "0", re.style.padding = "0", re.style.margin = "0", re.style.position = "absolute", re.style[_ ? "right" : "left"] = "-9999px";
                var ue = window.pageYOffset || document.documentElement.scrollTop;
                return re.style.top = "".concat(ue, "px"), re.setAttribute("readonly", ""), re.value = D, re;
              }
              var P = function(_, re) {
                var ue = M(_);
                re.container.appendChild(ue);
                var se = w()(ue);
                return C("copy"), ue.remove(), se;
              }, a = function(_) {
                var re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                }, ue = "";
                return typeof _ == "string" ? ue = P(_, re) : _ instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(_ == null ? void 0 : _.type) ? ue = P(_.value, re) : (ue = w()(_), C("copy")), ue;
              }, o = a;
              function s(D) {
                "@babel/helpers - typeof";
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? s = function(re) {
                  return typeof re;
                } : s = function(re) {
                  return re && typeof Symbol == "function" && re.constructor === Symbol && re !== Symbol.prototype ? "symbol" : typeof re;
                }, s(D);
              }
              var p = function() {
                var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, re = _.action, ue = re === void 0 ? "copy" : re, se = _.container, Re = _.target, ft = _.text;
                if (ue !== "copy" && ue !== "cut")
                  throw new Error('Invalid "action" value, use either "copy" or "cut"');
                if (Re !== void 0)
                  if (Re && s(Re) === "object" && Re.nodeType === 1) {
                    if (ue === "copy" && Re.hasAttribute("disabled"))
                      throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    if (ue === "cut" && (Re.hasAttribute("readonly") || Re.hasAttribute("disabled")))
                      throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                  } else
                    throw new Error('Invalid "target" value, use a valid Element');
                if (ft)
                  return o(ft, {
                    container: se
                  });
                if (Re)
                  return ue === "cut" ? R(Re) : o(Re, {
                    container: se
                  });
              }, O = p;
              function x(D) {
                "@babel/helpers - typeof";
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? x = function(re) {
                  return typeof re;
                } : x = function(re) {
                  return re && typeof Symbol == "function" && re.constructor === Symbol && re !== Symbol.prototype ? "symbol" : typeof re;
                }, x(D);
              }
              function N(D, _) {
                if (!(D instanceof _))
                  throw new TypeError("Cannot call a class as a function");
              }
              function T(D, _) {
                for (var re = 0; re < _.length; re++) {
                  var ue = _[re];
                  ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(D, ue.key, ue);
                }
              }
              function $(D, _, re) {
                return _ && T(D.prototype, _), re && T(D, re), D;
              }
              function j(D, _) {
                if (typeof _ != "function" && _ !== null)
                  throw new TypeError("Super expression must either be null or a function");
                D.prototype = Object.create(_ && _.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), _ && A(D, _);
              }
              function A(D, _) {
                return A = Object.setPrototypeOf || function(ue, se) {
                  return ue.__proto__ = se, ue;
                }, A(D, _);
              }
              function Z(D) {
                var _ = F();
                return function() {
                  var ue = U(D), se;
                  if (_) {
                    var Re = U(this).constructor;
                    se = Reflect.construct(ue, arguments, Re);
                  } else
                    se = ue.apply(this, arguments);
                  return G(this, se);
                };
              }
              function G(D, _) {
                return _ && (x(_) === "object" || typeof _ == "function") ? _ : I(D);
              }
              function I(D) {
                if (D === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return D;
              }
              function F() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function U(D) {
                return U = Object.setPrototypeOf ? Object.getPrototypeOf : function(re) {
                  return re.__proto__ || Object.getPrototypeOf(re);
                }, U(D);
              }
              function B(D, _) {
                var re = "data-clipboard-".concat(D);
                if (_.hasAttribute(re))
                  return _.getAttribute(re);
              }
              var L = /* @__PURE__ */ function(D) {
                j(re, D);
                var _ = Z(re);
                function re(ue, se) {
                  var Re;
                  return N(this, re), Re = _.call(this), Re.resolveOptions(se), Re.listenClick(ue), Re;
                }
                return $(re, [{
                  key: "resolveOptions",
                  value: function() {
                    var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    this.action = typeof se.action == "function" ? se.action : this.defaultAction, this.target = typeof se.target == "function" ? se.target : this.defaultTarget, this.text = typeof se.text == "function" ? se.text : this.defaultText, this.container = x(se.container) === "object" ? se.container : document.body;
                  }
                  /**
                   * Adds a click event listener to the passed trigger.
                   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                   */
                }, {
                  key: "listenClick",
                  value: function(se) {
                    var Re = this;
                    this.listener = m()(se, "click", function(ft) {
                      return Re.onClick(ft);
                    });
                  }
                  /**
                   * Defines a new `ClipboardAction` on each click event.
                   * @param {Event} e
                   */
                }, {
                  key: "onClick",
                  value: function(se) {
                    var Re = se.delegateTarget || se.currentTarget, ft = this.action(Re) || "copy", Le = O({
                      action: ft,
                      container: this.container,
                      target: this.target(Re),
                      text: this.text(Re)
                    });
                    this.emit(Le ? "success" : "error", {
                      action: ft,
                      text: Le,
                      trigger: Re,
                      clearSelection: function() {
                        Re && Re.focus(), window.getSelection().removeAllRanges();
                      }
                    });
                  }
                  /**
                   * Default `action` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultAction",
                  value: function(se) {
                    return B("action", se);
                  }
                  /**
                   * Default `target` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultTarget",
                  value: function(se) {
                    var Re = B("target", se);
                    if (Re)
                      return document.querySelector(Re);
                  }
                  /**
                   * Allow fire programmatically a copy action
                   * @param {String|HTMLElement} target
                   * @param {Object} options
                   * @returns Text copied.
                   */
                }, {
                  key: "defaultText",
                  /**
                   * Default `text` lookup function.
                   * @param {Element} trigger
                   */
                  value: function(se) {
                    return B("text", se);
                  }
                  /**
                   * Destroy lifecycle.
                   */
                }, {
                  key: "destroy",
                  value: function() {
                    this.listener.destroy();
                  }
                }], [{
                  key: "copy",
                  value: function(se) {
                    var Re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                      container: document.body
                    };
                    return o(se, Re);
                  }
                  /**
                   * Allow fire programmatically a cut action
                   * @param {String|HTMLElement} target
                   * @returns Text cutted.
                   */
                }, {
                  key: "cut",
                  value: function(se) {
                    return R(se);
                  }
                  /**
                   * Returns the support of the given action, or all actions if no action is
                   * given.
                   * @param {String} [action]
                   */
                }, {
                  key: "isSupported",
                  value: function() {
                    var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"], Re = typeof se == "string" ? [se] : se, ft = !!document.queryCommandSupported;
                    return Re.forEach(function(Le) {
                      ft = ft && !!document.queryCommandSupported(Le);
                    }), ft;
                  }
                }]), re;
              }(h()), q = L;
            }
          ),
          /***/
          828: (
            /***/
            function(i) {
              var c = 9;
              if (typeof Element < "u" && !Element.prototype.matches) {
                var f = Element.prototype;
                f.matches = f.matchesSelector || f.mozMatchesSelector || f.msMatchesSelector || f.oMatchesSelector || f.webkitMatchesSelector;
              }
              function d(h, g) {
                for (; h && h.nodeType !== c; ) {
                  if (typeof h.matches == "function" && h.matches(g))
                    return h;
                  h = h.parentNode;
                }
              }
              i.exports = d;
            }
          ),
          /***/
          438: (
            /***/
            function(i, c, f) {
              var d = f(828);
              function h(y, w, C, E, R) {
                var M = m.apply(this, arguments);
                return y.addEventListener(C, M, R), {
                  destroy: function() {
                    y.removeEventListener(C, M, R);
                  }
                };
              }
              function g(y, w, C, E, R) {
                return typeof y.addEventListener == "function" ? h.apply(null, arguments) : typeof C == "function" ? h.bind(null, document).apply(null, arguments) : (typeof y == "string" && (y = document.querySelectorAll(y)), Array.prototype.map.call(y, function(M) {
                  return h(M, w, C, E, R);
                }));
              }
              function m(y, w, C, E) {
                return function(R) {
                  R.delegateTarget = d(R.target, w), R.delegateTarget && E.call(y, R);
                };
              }
              i.exports = g;
            }
          ),
          /***/
          879: (
            /***/
            function(i, c) {
              c.node = function(f) {
                return f !== void 0 && f instanceof HTMLElement && f.nodeType === 1;
              }, c.nodeList = function(f) {
                var d = Object.prototype.toString.call(f);
                return f !== void 0 && (d === "[object NodeList]" || d === "[object HTMLCollection]") && "length" in f && (f.length === 0 || c.node(f[0]));
              }, c.string = function(f) {
                return typeof f == "string" || f instanceof String;
              }, c.fn = function(f) {
                var d = Object.prototype.toString.call(f);
                return d === "[object Function]";
              };
            }
          ),
          /***/
          370: (
            /***/
            function(i, c, f) {
              var d = f(879), h = f(438);
              function g(C, E, R) {
                if (!C && !E && !R)
                  throw new Error("Missing required arguments");
                if (!d.string(E))
                  throw new TypeError("Second argument must be a String");
                if (!d.fn(R))
                  throw new TypeError("Third argument must be a Function");
                if (d.node(C))
                  return m(C, E, R);
                if (d.nodeList(C))
                  return y(C, E, R);
                if (d.string(C))
                  return w(C, E, R);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
              }
              function m(C, E, R) {
                return C.addEventListener(E, R), {
                  destroy: function() {
                    C.removeEventListener(E, R);
                  }
                };
              }
              function y(C, E, R) {
                return Array.prototype.forEach.call(C, function(M) {
                  M.addEventListener(E, R);
                }), {
                  destroy: function() {
                    Array.prototype.forEach.call(C, function(M) {
                      M.removeEventListener(E, R);
                    });
                  }
                };
              }
              function w(C, E, R) {
                return h(document.body, C, E, R);
              }
              i.exports = g;
            }
          ),
          /***/
          817: (
            /***/
            function(i) {
              function c(f) {
                var d;
                if (f.nodeName === "SELECT")
                  f.focus(), d = f.value;
                else if (f.nodeName === "INPUT" || f.nodeName === "TEXTAREA") {
                  var h = f.hasAttribute("readonly");
                  h || f.setAttribute("readonly", ""), f.select(), f.setSelectionRange(0, f.value.length), h || f.removeAttribute("readonly"), d = f.value;
                } else {
                  f.hasAttribute("contenteditable") && f.focus();
                  var g = window.getSelection(), m = document.createRange();
                  m.selectNodeContents(f), g.removeAllRanges(), g.addRange(m), d = g.toString();
                }
                return d;
              }
              i.exports = c;
            }
          ),
          /***/
          279: (
            /***/
            function(i) {
              function c() {
              }
              c.prototype = {
                on: function(f, d, h) {
                  var g = this.e || (this.e = {});
                  return (g[f] || (g[f] = [])).push({
                    fn: d,
                    ctx: h
                  }), this;
                },
                once: function(f, d, h) {
                  var g = this;
                  function m() {
                    g.off(f, m), d.apply(h, arguments);
                  }
                  return m._ = d, this.on(f, m, h);
                },
                emit: function(f) {
                  var d = [].slice.call(arguments, 1), h = ((this.e || (this.e = {}))[f] || []).slice(), g = 0, m = h.length;
                  for (g; g < m; g++)
                    h[g].fn.apply(h[g].ctx, d);
                  return this;
                },
                off: function(f, d) {
                  var h = this.e || (this.e = {}), g = h[f], m = [];
                  if (g && d)
                    for (var y = 0, w = g.length; y < w; y++)
                      g[y].fn !== d && g[y].fn._ !== d && m.push(g[y]);
                  return m.length ? h[f] = m : delete h[f], this;
                }
              }, i.exports = c, i.exports.TinyEmitter = c;
            }
          )
          /******/
        }, r = {};
        function l(i) {
          if (r[i])
            return r[i].exports;
          var c = r[i] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[i](c, c.exports, l), c.exports;
        }
        return function() {
          l.n = function(i) {
            var c = i && i.__esModule ? (
              /******/
              function() {
                return i.default;
              }
            ) : (
              /******/
              function() {
                return i;
              }
            );
            return l.d(c, { a: c }), c;
          };
        }(), function() {
          l.d = function(i, c) {
            for (var f in c)
              l.o(c, f) && !l.o(i, f) && Object.defineProperty(i, f, { enumerable: !0, get: c[f] });
          };
        }(), function() {
          l.o = function(i, c) {
            return Object.prototype.hasOwnProperty.call(i, c);
          };
        }(), l(686);
      }().default
    );
  });
})(Uue);
var aOe = Uue.exports;
const Wue = /* @__PURE__ */ ce(aOe);
var Gue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Checkmark", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.30583 9.05037L11.7611 3.59509C12.1516 3.20457 12.7848 3.20457 13.1753 3.59509L13.8824 4.3022C14.273 4.69273 14.273 5.32589 13.8824 5.71642L6.81525 12.7836C6.38819 13.2106 5.68292 13.1646 5.31505 12.6856L2.26638 8.71605C1.92998 8.27804 2.01235 7.65025 2.45036 7.31385L3.04518 6.85702C3.59269 6.43652 4.37742 6.53949 4.79792 7.087L6.30583 9.05037Z", fill: "currentColor" }));
    };
    return P.displayName = "Checkmark", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Gue);
var lOe = Gue.exports;
const iOe = /* @__PURE__ */ ce(lOe);
var Kue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Copy", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 5.71428V10.2857C1 11.2325 1.76751 12 2.71429 12H5.75V7.10957C5.75 6.54414 5.97724 6.00244 6.38065 5.60623L8.67403 3.35381C8.77447 3.25516 8.88376 3.16757 9 3.09182V2.71429C9 1.76751 8.23249 1 7.28571 1H5.8V4.42857C5.8 5.13865 5.22437 5.71428 4.51429 5.71428H1ZM9 4.78571L7.25654 6.49804C7.24689 6.50752 7.23749 6.5172 7.22834 6.52708C7.22208 6.53383 7.21594 6.54068 7.20991 6.54762C7.07504 6.70295 7 6.90234 7 7.10957V7.79762H9H10.0095C10.4829 7.79762 10.8667 7.41386 10.8667 6.94047V4H10.1505C9.92587 4 9.7102 4.0882 9.54992 4.24562L9 4.78571ZM4.86667 1H4.15053C3.92587 1 3.7102 1.0882 3.54992 1.24562L1.25654 3.49804C1.09244 3.65921 1 3.87957 1 4.10957V4.79762H4.00952C4.48291 4.79762 4.86667 4.41386 4.86667 3.94047V1ZM7 12V8.71428H9H10.5143C11.2244 8.71428 11.8 8.13865 11.8 7.42857V4H13.2857C14.2325 4 15 4.76751 15 5.71429V13.2857C15 14.2325 14.2325 15 13.2857 15H8.71429C7.76751 15 7 14.2325 7 13.2857V12Z", fill: "currentColor" }));
    };
    return P.displayName = "Copy", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Kue);
var oOe = Kue.exports;
const sOe = /* @__PURE__ */ ce(oOe);
function cOe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function h2(e) {
  return h2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, h2(e);
}
function Fa(e, t, n) {
  return (t = cOe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function m2() {
  return m2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m2.apply(this, arguments);
}
function Yue(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var CS, v2 = { Small: "small", Default: "default", Large: "large", XLarge: "xlarge" }, uOe = { small: 14, default: 16, large: 20, xlarge: 24 }, fOe = ["className", "size", "fill", "title", "aria-labelledby", "aria-label", "role"];
function dOe(e, t) {
  var n = function(r) {
    var l, i, c = r.className, f = r.size, d = f === void 0 ? v2.Default : f, h = r.fill, g = r.title, m = r["aria-labelledby"], y = r["aria-label"], w = r.role, C = w === void 0 ? "img" : w, E = Yue(r, fOe), R = v(CS || (l = [`
      color: `, `;
    `], i || (i = l.slice(0)), CS = Object.freeze(Object.defineProperties(l, { raw: { value: Object.freeze(i) } }))), h), M = typeof d == "number" ? d : uOe[d];
    return C !== "img" && C !== "presentation" && console.warn("Please provide a valid role to this component. Valid options are 'img' and 'presentation'. If you'd like the Icon to be accessible to screen readers please use 'img', otherwise set the role to 'presentation'."), k.createElement(t, m2({ className: H(Fa({}, R, h != null), c), height: M, width: M, role: C }, function(P, a, o) {
      var s, p = o["aria-label"], O = o["aria-labelledby"], x = o.title;
      switch (P) {
        case "img":
          return p || O || x ? Fa(Fa(Fa({}, "aria-labelledby", O), "aria-label", p), "title", x) : { "aria-label": (s = a, "".concat(s.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
        case "presentation":
          return { "aria-hidden": !0, alt: "" };
      }
    }(C, e, Fa(Fa({ title: g }, "aria-label", y), "aria-labelledby", m)), E));
  };
  return n.displayName = e, n.isGlyph = !0, n.propTypes = { fill: z.string, size: z.oneOfType([z.oneOf(Object.values(v2)), z.number]), className: z.string }, n;
}
var MS, pOe = ["glyph"];
function gOe(e) {
  var t = function(n) {
    var r = n.glyph, l = Yue(n, pOe), i = e[r];
    if (i)
      return k.createElement(i, l);
    var c = Object.keys(e).find(function(f) {
      return Cr(f) === Cr(r);
    });
    return console.error("Error in Icon", 'Could not find glyph named "'.concat(r, '" in the icon set.'), c && 'Did you mean "'.concat(c, '?"')), k.createElement(k.Fragment, null);
  };
  return t.displayName = "Icon", t.isGlyph = !0, t.propTypes = { glyph: z.oneOf(Object.keys(e)).isRequired, size: z.oneOfType([z.oneOf(Object.values(v2)), z.number]) }, t;
}
function b2() {
  return b2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b2.apply(this, arguments);
}
var kS;
function y2() {
  return y2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y2.apply(this, arguments);
}
var PS;
function w2() {
  return w2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w2.apply(this, arguments);
}
var SS;
function O2() {
  return O2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O2.apply(this, arguments);
}
var NS;
function x2() {
  return x2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x2.apply(this, arguments);
}
var RS;
function E2() {
  return E2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E2.apply(this, arguments);
}
var _S;
function $2() {
  return $2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $2.apply(this, arguments);
}
var AS;
function j2() {
  return j2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j2.apply(this, arguments);
}
var LS;
function C2() {
  return C2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C2.apply(this, arguments);
}
var ZS;
function M2() {
  return M2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M2.apply(this, arguments);
}
var TS;
function k2() {
  return k2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k2.apply(this, arguments);
}
var BS;
function P2() {
  return P2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P2.apply(this, arguments);
}
var IS;
function S2() {
  return S2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S2.apply(this, arguments);
}
var HS;
function N2() {
  return N2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N2.apply(this, arguments);
}
var DS, zS;
function R2() {
  return R2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R2.apply(this, arguments);
}
var FS, VS, qS;
function _2() {
  return _2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _2.apply(this, arguments);
}
var US, WS;
function A2() {
  return A2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A2.apply(this, arguments);
}
var GS, KS;
function L2() {
  return L2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L2.apply(this, arguments);
}
var YS;
function Z2() {
  return Z2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z2.apply(this, arguments);
}
var XS;
function T2() {
  return T2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T2.apply(this, arguments);
}
var QS;
function B2() {
  return B2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B2.apply(this, arguments);
}
var JS;
function I2() {
  return I2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I2.apply(this, arguments);
}
var eN;
function H2() {
  return H2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H2.apply(this, arguments);
}
var tN;
function D2() {
  return D2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D2.apply(this, arguments);
}
var nN;
function z2() {
  return z2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z2.apply(this, arguments);
}
var rN;
function F2() {
  return F2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F2.apply(this, arguments);
}
var aN;
function V2() {
  return V2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V2.apply(this, arguments);
}
var lN;
function q2() {
  return q2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q2.apply(this, arguments);
}
var iN;
function U2() {
  return U2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U2.apply(this, arguments);
}
var oN;
function W2() {
  return W2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W2.apply(this, arguments);
}
var sN;
function G2() {
  return G2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G2.apply(this, arguments);
}
var cN, uN;
function K2() {
  return K2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K2.apply(this, arguments);
}
var fN, dN;
function Y2() {
  return Y2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y2.apply(this, arguments);
}
var pN;
function X2() {
  return X2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X2.apply(this, arguments);
}
var gN;
function Q2() {
  return Q2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q2.apply(this, arguments);
}
var hN, mN;
function J2() {
  return J2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J2.apply(this, arguments);
}
var vN;
function e5() {
  return e5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e5.apply(this, arguments);
}
var bN;
function t5() {
  return t5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t5.apply(this, arguments);
}
var yN;
function n5() {
  return n5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n5.apply(this, arguments);
}
var wN;
function r5() {
  return r5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r5.apply(this, arguments);
}
var ON;
function a5() {
  return a5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a5.apply(this, arguments);
}
var xN;
function l5() {
  return l5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, l5.apply(this, arguments);
}
var EN;
function i5() {
  return i5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, i5.apply(this, arguments);
}
var $N, jN, CN;
function o5() {
  return o5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, o5.apply(this, arguments);
}
var MN;
function s5() {
  return s5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, s5.apply(this, arguments);
}
var kN;
function c5() {
  return c5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, c5.apply(this, arguments);
}
var PN;
function u5() {
  return u5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, u5.apply(this, arguments);
}
var SN;
function f5() {
  return f5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, f5.apply(this, arguments);
}
var NN;
function d5() {
  return d5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d5.apply(this, arguments);
}
var RN;
function p5() {
  return p5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, p5.apply(this, arguments);
}
var _N;
function g5() {
  return g5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g5.apply(this, arguments);
}
var AN;
function h5() {
  return h5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h5.apply(this, arguments);
}
var LN, ZN;
function m5() {
  return m5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m5.apply(this, arguments);
}
var TN;
function v5() {
  return v5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v5.apply(this, arguments);
}
var BN, IN;
function b5() {
  return b5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b5.apply(this, arguments);
}
var HN;
function y5() {
  return y5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y5.apply(this, arguments);
}
var DN;
function w5() {
  return w5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w5.apply(this, arguments);
}
var zN, FN;
function O5() {
  return O5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O5.apply(this, arguments);
}
var VN;
function x5() {
  return x5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x5.apply(this, arguments);
}
var qN;
function E5() {
  return E5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E5.apply(this, arguments);
}
var UN;
function $5() {
  return $5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $5.apply(this, arguments);
}
var WN;
function j5() {
  return j5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j5.apply(this, arguments);
}
var GN;
function C5() {
  return C5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C5.apply(this, arguments);
}
var KN;
function M5() {
  return M5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M5.apply(this, arguments);
}
var YN, XN;
function k5() {
  return k5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k5.apply(this, arguments);
}
var QN;
function P5() {
  return P5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P5.apply(this, arguments);
}
var JN;
function S5() {
  return S5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S5.apply(this, arguments);
}
var eR, tR;
function N5() {
  return N5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N5.apply(this, arguments);
}
var nR;
function R5() {
  return R5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R5.apply(this, arguments);
}
var rR, aR;
function _5() {
  return _5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _5.apply(this, arguments);
}
var lR;
function A5() {
  return A5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A5.apply(this, arguments);
}
var iR;
function L5() {
  return L5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L5.apply(this, arguments);
}
var oR, sR;
function Z5() {
  return Z5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z5.apply(this, arguments);
}
var cR, uR;
function T5() {
  return T5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T5.apply(this, arguments);
}
var fR;
function B5() {
  return B5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B5.apply(this, arguments);
}
var dR, pR;
function I5() {
  return I5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I5.apply(this, arguments);
}
var gR;
function H5() {
  return H5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H5.apply(this, arguments);
}
var hR, mR;
function D5() {
  return D5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D5.apply(this, arguments);
}
var vR;
function z5() {
  return z5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z5.apply(this, arguments);
}
var bR;
function F5() {
  return F5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F5.apply(this, arguments);
}
var yR, wR;
function V5() {
  return V5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V5.apply(this, arguments);
}
var OR, xR;
function q5() {
  return q5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q5.apply(this, arguments);
}
var ER;
function U5() {
  return U5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U5.apply(this, arguments);
}
var $R;
function W5() {
  return W5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W5.apply(this, arguments);
}
var jR;
function G5() {
  return G5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G5.apply(this, arguments);
}
var CR;
function K5() {
  return K5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K5.apply(this, arguments);
}
var MR;
function Y5() {
  return Y5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y5.apply(this, arguments);
}
var kR, PR;
function X5() {
  return X5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X5.apply(this, arguments);
}
var SR;
function Q5() {
  return Q5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q5.apply(this, arguments);
}
var NR, RR;
function J5() {
  return J5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J5.apply(this, arguments);
}
var _R, AR;
function ef() {
  return ef = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ef.apply(this, arguments);
}
var LR;
function tf() {
  return tf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tf.apply(this, arguments);
}
var ZR;
function nf() {
  return nf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nf.apply(this, arguments);
}
var TR, BR;
function rf() {
  return rf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rf.apply(this, arguments);
}
var IR, HR;
function af() {
  return af = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, af.apply(this, arguments);
}
var DR;
function lf() {
  return lf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lf.apply(this, arguments);
}
var zR, FR;
function of() {
  return of = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, of.apply(this, arguments);
}
var VR;
function sf() {
  return sf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sf.apply(this, arguments);
}
var qR, UR;
function cf() {
  return cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cf.apply(this, arguments);
}
var WR;
function uf() {
  return uf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uf.apply(this, arguments);
}
var GR;
function ff() {
  return ff = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ff.apply(this, arguments);
}
var KR;
function df() {
  return df = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, df.apply(this, arguments);
}
var YR;
function pf() {
  return pf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pf.apply(this, arguments);
}
var XR;
function gf() {
  return gf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gf.apply(this, arguments);
}
var QR, JR;
function hf() {
  return hf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hf.apply(this, arguments);
}
var e_;
function mf() {
  return mf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mf.apply(this, arguments);
}
var t_, n_;
function vf() {
  return vf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vf.apply(this, arguments);
}
var r_, a_;
function bf() {
  return bf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bf.apply(this, arguments);
}
var l_;
function yf() {
  return yf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yf.apply(this, arguments);
}
var i_;
function wf() {
  return wf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wf.apply(this, arguments);
}
var o_;
function Of() {
  return Of = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Of.apply(this, arguments);
}
var s_;
function xf() {
  return xf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xf.apply(this, arguments);
}
var c_;
function Ef() {
  return Ef = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ef.apply(this, arguments);
}
var u_;
function $f() {
  return $f = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $f.apply(this, arguments);
}
var f_, d_;
function jf() {
  return jf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jf.apply(this, arguments);
}
var p_, g_, h_;
function Cf() {
  return Cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cf.apply(this, arguments);
}
var m_, v_;
function Mf() {
  return Mf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mf.apply(this, arguments);
}
var b_;
function kf() {
  return kf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kf.apply(this, arguments);
}
var y_;
function Pf() {
  return Pf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pf.apply(this, arguments);
}
var w_;
function Sf() {
  return Sf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sf.apply(this, arguments);
}
var O_;
function Nf() {
  return Nf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nf.apply(this, arguments);
}
var x_;
function Rf() {
  return Rf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rf.apply(this, arguments);
}
var E_;
function _f() {
  return _f = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _f.apply(this, arguments);
}
var $_;
function Af() {
  return Af = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Af.apply(this, arguments);
}
var j_;
function Lf() {
  return Lf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lf.apply(this, arguments);
}
var C_;
function Zf() {
  return Zf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zf.apply(this, arguments);
}
var M_;
function Tf() {
  return Tf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tf.apply(this, arguments);
}
var k_;
function Bf() {
  return Bf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bf.apply(this, arguments);
}
var P_;
function If() {
  return If = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, If.apply(this, arguments);
}
var S_;
function Hf() {
  return Hf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hf.apply(this, arguments);
}
var N_;
function Df() {
  return Df = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Df.apply(this, arguments);
}
var R_;
function zf() {
  return zf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zf.apply(this, arguments);
}
var __;
function Ff() {
  return Ff = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ff.apply(this, arguments);
}
var A_;
function Vf() {
  return Vf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vf.apply(this, arguments);
}
var L_;
function qf() {
  return qf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qf.apply(this, arguments);
}
var Z_;
function Uf() {
  return Uf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uf.apply(this, arguments);
}
var T_, B_, I_;
function Wf() {
  return Wf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wf.apply(this, arguments);
}
var H_;
function Gf() {
  return Gf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gf.apply(this, arguments);
}
var D_;
function Kf() {
  return Kf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kf.apply(this, arguments);
}
var z_;
function Yf() {
  return Yf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yf.apply(this, arguments);
}
var F_;
function Xf() {
  return Xf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xf.apply(this, arguments);
}
var V_;
function Qf() {
  return Qf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qf.apply(this, arguments);
}
var q_;
function Jf() {
  return Jf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jf.apply(this, arguments);
}
var U_;
function ed() {
  return ed = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ed.apply(this, arguments);
}
var W_;
function td() {
  return td = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, td.apply(this, arguments);
}
var G_;
function nd() {
  return nd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nd.apply(this, arguments);
}
var K_;
function rd() {
  return rd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rd.apply(this, arguments);
}
var Y_;
function ad() {
  return ad = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ad.apply(this, arguments);
}
var X_;
function ld() {
  return ld = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ld.apply(this, arguments);
}
var Q_;
function id() {
  return id = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, id.apply(this, arguments);
}
var J_, eA;
function od() {
  return od = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, od.apply(this, arguments);
}
var tA;
function sd() {
  return sd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sd.apply(this, arguments);
}
var nA;
function cd() {
  return cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cd.apply(this, arguments);
}
var rA = { ActivityFeed: function(e) {
  return u.createElement("svg", b2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MS || (MS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 13V7h4.5A1.5 1.5 0 0 0 7 5.5V1h2a2 2 0 0 1 2 2v4.515a2.5 2.5 0 0 0-2.612 1.602l-1.06 2.808A2.501 2.501 0 0 0 5.59 15H3a2 2 0 0 1-2-2ZM4.914 1h.92v3.833a1 1 0 0 1-1 1H1v-.919a1 1 0 0 1 .293-.707L2.5 3l1.707-1.707A1 1 0 0 1 4.914 1ZM10.8 9.003a1 1 0 0 1 .904.784l.61 2.792.508-.714a1 1 0 0 1 .814-.42H15a1 1 0 0 1 0 2h-.848l-1.519 2.135a1 1 0 0 1-1.792-.367l-.371-1.701-.444 1.175a1 1 0 0 1-.935.646H8a1 1 0 1 1 0-2h.4l1.392-3.686a1 1 0 0 1 1.008-.644Z", clipRule: "evenodd" })));
}, AddFile: function(e) {
  return u.createElement("svg", y2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kS || (kS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 7v6a2 2 0 0 0 2 2h5.968a2.25 2.25 0 0 1 .794-4.238A2.251 2.251 0 0 1 11 8.984V3a2 2 0 0 0-2-2H7v4.5A1.5 1.5 0 0 1 5.5 7H1Zm8 6a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0-1 1ZM5.833 1h-.919a1 1 0 0 0-.707.293L2.5 3 1.293 4.207A1 1 0 0 0 1 4.914v.92h3.833a1 1 0 0 0 1-1V1Z", clipRule: "evenodd" })));
}, AllProducts: function(e) {
  return u.createElement("svg", w2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PS || (PS = u.createElement("path", { fill: "currentColor", d: "M2.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM6.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 2.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM2.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM7.5 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM10.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM3.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM6.5 11.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" })));
}, Apps: function(e) {
  return u.createElement("svg", O2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SS || (SS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3H3v4h4V3Zm0 6H3v4h4V9Zm2-6h4v4H9V3Zm4 6H9v4h4V9Z", clipRule: "evenodd" })));
}, Array: function(e) {
  return u.createElement("svg", x2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NS || (NS = u.createElement("path", { fill: "currentColor", d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V3h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM13.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12V3H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4Z" })));
}, ArrowDown: function(e) {
  return u.createElement("svg", E2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RS || (RS = u.createElement("path", { fill: "currentColor", d: "M9.168 3v6.944l1.535-1.535a1 1 0 0 1 1.414 0l.239.24a1 1 0 0 1 0 1.414l-3.383 3.382c-.008.01-.017.018-.026.027l-.239.24a1 1 0 0 1-1.414 0L3.643 10.06a1 1 0 0 1 0-1.414l.239-.239a1 1 0 0 1 1.414 0L6.83 9.941V3a1 1 0 0 1 1-1h.338a1 1 0 0 1 1 1Z" })));
}, ArrowLeft: function(e) {
  return u.createElement("svg", $2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _S || (_S = u.createElement("path", { fill: "currentColor", d: "M13 6.832H6.056L7.59 5.297a1 1 0 0 0 0-1.414l-.24-.239a1 1 0 0 0-1.414 0L2.555 7.027c-.01.008-.018.017-.027.026l-.24.239a1 1 0 0 0 0 1.414l3.652 3.651a1 1 0 0 0 1.414 0l.239-.239a1 1 0 0 0 0-1.414L6.059 9.17H13a1 1 0 0 0 1-1v-.338a1 1 0 0 0-1-1Z" })));
}, ArrowRight: function(e) {
  return u.createElement("svg", j2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AS || (AS = u.createElement("path", { fill: "currentColor", d: "M3 6.832h6.944L8.41 5.297a1 1 0 0 1 0-1.414l.24-.239a1 1 0 0 1 1.414 0l3.382 3.383c.01.008.018.017.027.026l.24.239a1 1 0 0 1 0 1.414l-3.652 3.651a1 1 0 0 1-1.414 0l-.239-.239a1 1 0 0 1 0-1.414L9.941 9.17H3a1 1 0 0 1-1-1v-.338a1 1 0 0 1 1-1Z" })));
}, ArrowUp: function(e) {
  return u.createElement("svg", C2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LS || (LS = u.createElement("path", { fill: "currentColor", d: "M9.168 13V6.056l1.535 1.535a1 1 0 0 0 1.414 0l.239-.24a1 1 0 0 0 0-1.414L8.973 2.555a1.023 1.023 0 0 0-.026-.027l-.239-.24a1 1 0 0 0-1.414 0L3.643 5.94a1 1 0 0 0 0 1.414l.239.239a1 1 0 0 0 1.414 0L6.83 6.059V13a1 1 0 0 0 1 1h.338a1 1 0 0 0 1-1Z" })));
}, Beaker: function(e) {
  return u.createElement("svg", M2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZS || (ZS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.953 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C6.333 1 6.473 1 6.753 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219C9.573 3 9.433 3 9.153 3h-2.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219c-.054-.107-.054-.247-.054-.527v-.4Zm.056 2.47c-.056.108-.056.25-.056.535V6l-3.007 5.412c-.663 1.193-.994 1.79-.932 2.277a1.5 1.5 0 0 0 .6 1.02C3.01 15 3.693 15 5.057 15h5.791c1.365 0 2.047 0 2.444-.291a1.5 1.5 0 0 0 .6-1.02c.062-.488-.27-1.084-.932-2.277L9.953 6V4.805c0-.285 0-.427-.056-.535a.5.5 0 0 0-.214-.214C9.575 4 9.433 4 9.148 4h-2.39c-.285 0-.427 0-.536.056a.5.5 0 0 0-.213.214ZM9.333 9l-3.03.5-1.287 2.31c-.218.392-.327.588-.309.748a.5.5 0 0 0 .205.348c.13.094.355.094.802.094h4.48c.447 0 .67 0 .801-.094a.5.5 0 0 0 .205-.348c.019-.16-.09-.355-.307-.746L9.333 9Z", clipRule: "evenodd" })));
}, Bell: function(e) {
  return u.createElement("svg", k2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TS || (TS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.625 6.138a4.656 4.656 0 0 0-3.268-3.925C9.228 1.52 8.67 1 8 1c-.67 0-1.228.52-1.357 1.213a4.656 4.656 0 0 0-3.268 3.925l-.452 3.963h.026a.95.95 0 0 0 0 1.899h10.102a.95.95 0 0 0 0-1.899h.026l-.452-3.963ZM8 15a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z", clipRule: "evenodd" })));
}, Biometric: function(e) {
  return u.createElement("svg", P2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BS || (BS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 1A5.5 5.5 0 0 0 2 6.5v3A5.5 5.5 0 0 0 7.5 15h1A5.5 5.5 0 0 0 14 9.5v-3A5.5 5.5 0 0 0 8.5 1h-1Zm1.074 6.75a.574.574 0 1 0-1.148 0v2.457a.574.574 0 0 0 1.148 0V7.75ZM8 5.338A2.412 2.412 0 0 0 5.588 7.75v2.566a.994.994 0 0 1-.291.704.574.574 0 1 0 .812.812c.402-.402.628-.947.628-1.516V7.75a1.264 1.264 0 1 1 2.527 0v2.648c0 .412-.233.79-.602.973a.574.574 0 0 0 .514 1.028 2.237 2.237 0 0 0 1.236-2V7.75A2.412 2.412 0 0 0 8 5.338ZM4.899 7.75A3.101 3.101 0 0 1 9.64 5.117a.574.574 0 1 0 .609-.974A4.25 4.25 0 0 0 3.75 7.75v2.297a.574.574 0 1 0 1.149 0V7.75Zm6.887-1.932a.574.574 0 1 0-1.023.522c.216.423.338.901.338 1.41v1.378a.574.574 0 1 0 1.149 0V7.75c0-.695-.167-1.352-.464-1.932Z", clipRule: "evenodd" })));
}, Boolean: function(e) {
  return u.createElement("svg", S2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IS || (IS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm4 6a4 4 0 0 1-4 4V4a4 4 0 0 1 4 4Z", clipRule: "evenodd" })));
}, Building: function(e) {
  return u.createElement("svg", N2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HS || (HS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v13H6v-2H4v2H1v-4h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1V5h4.5a.5.5 0 0 0 0-1H1V2Zm8 9h4.5a.5.5 0 0 0 0-1H9V8h4.5a.5.5 0 0 0 0-1H9V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10h-2v-2h-2v2H9v-4Z", clipRule: "evenodd" })));
}, Bulb: function(e) {
  return u.createElement("svg", R2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DS || (DS = u.createElement("path", { fill: "currentColor", d: "M12.331 8.5a5 5 0 1 0-8.612.086L5.408 11.5a1 1 0 0 0 .866.499H6.5V6a1.5 1.5 0 1 1 3 0v6h.224a1 1 0 0 0 .863-.496L12.34 8.5h-.009Z" })), zS || (zS = u.createElement("path", { fill: "currentColor", d: "M7.5 6v6h1V6a.5.5 0 0 0-1 0ZM10 14v-1H6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z" })));
}, Calendar: function(e) {
  return u.createElement("svg", _2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FS || (FS = u.createElement("path", { fill: "currentColor", d: "M4 2a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0V2Z" })), VS || (VS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 3H7a2 2 0 1 1-4 0 2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 2 2 0 1 1-4 0Zm3 4H9v3h3V7Z", clipRule: "evenodd" })), qS || (qS = u.createElement("path", { fill: "currentColor", d: "M10 3a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1Z" })));
}, Camera: function(e) {
  return u.createElement("svg", A2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), US || (US = u.createElement("path", { fill: "currentColor", d: "M10.25 8.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })), WS || (WS = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.585 3.33a1.5 1.5 0 0 1 1.342-.83h4.146a1.5 1.5 0 0 1 1.342.83l.309.617a1 1 0 0 0 .894.553h.882A1.5 1.5 0 0 1 15 6v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V6a1.5 1.5 0 0 1 1.5-1.5h.882a1 1 0 0 0 .894-.553l.31-.618ZM11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", clipRule: "evenodd" })));
}, Cap: function(e) {
  return u.createElement("svg", L2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GS || (GS = u.createElement("path", { fill: "currentColor", d: "M2.97 8.008v2.3l.001.092-.002.262c0 1.926 2.535 2.838 5 2.838 2.466 0 5-.912 5-2.838 0-.085 0-.168-.002-.25.002-.035.002-.07.002-.105V8.001L8.706 9.787a2 2 0 0 1-1.554-.004L2.969 8.008Z" })), KS || (KS = u.createElement("path", { fill: "currentColor", d: "M7.565 2.583a1 1 0 0 1 .794-.002l6.35 2.732a.5.5 0 0 1-.004.92L8.35 8.896a1 1 0 0 1-.778-.001L1.305 6.233a.5.5 0 0 1-.005-.919l6.265-2.73ZM13.97 7.626v1.477a1 1 0 1 0 1 0V7.207l-1 .419Z" })));
}, CaretDown: function(e) {
  return u.createElement("svg", Z2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YS || (YS = u.createElement("path", { fill: "currentColor", d: "M8.679 10.796a.554.554 0 0 1-.858 0L4.64 6.976C4.32 6.594 4.582 6 5.069 6h6.362c.487 0 .748.594.43.976l-3.182 3.82Z" })));
}, CaretLeft: function(e) {
  return u.createElement("svg", T2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XS || (XS = u.createElement("path", { fill: "currentColor", d: "M5.204 8.679a.553.553 0 0 1 0-.858l3.82-3.181c.382-.319.976-.058.976.429v6.362c0 .487-.594.748-.976.43l-3.82-3.182Z" })));
}, CaretRight: function(e) {
  return u.createElement("svg", B2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QS || (QS = u.createElement("path", { fill: "currentColor", d: "M10.796 7.321a.554.554 0 0 1 0 .858l-3.82 3.181c-.382.319-.976.058-.976-.429V4.57c0-.487.594-.748.976-.43l3.82 3.182Z" })));
}, CaretUp: function(e) {
  return u.createElement("svg", I2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JS || (JS = u.createElement("path", { fill: "currentColor", d: "M7.321 5.204a.553.553 0 0 1 .858 0l3.181 3.82c.319.382.058.976-.429.976H4.57c-.487 0-.748-.594-.43-.976l3.182-3.82Z" })));
}, ChartFilled: function(e) {
  return u.createElement("svg", H2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eN || (eN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H3Zm8.25 2a.75.75 0 0 0-.75.75v6.25H12V5.25a.75.75 0 0 0-.75-.75ZM7.5 7.25a.75.75 0 0 1 1.5 0v4.25H7.5V7.25ZM5.25 9a.75.75 0 0 0-.75.75v1.75H6V9.75A.75.75 0 0 0 5.25 9Z", clipRule: "evenodd" })));
}, Charts: function(e) {
  return u.createElement("svg", D2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tN || (tN = u.createElement("path", { fill: "currentColor", d: "M11.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10ZM7.5 14a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1ZM2.5 14a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1Z" })));
}, Checkmark: function(e) {
  return u.createElement("svg", z2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nN || (nN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.306 9.05 5.455-5.455a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-7.067 7.068a1 1 0 0 1-1.5-.098l-3.049-3.97a1 1 0 0 1 .184-1.402l.595-.457a1.25 1.25 0 0 1 1.753.23L6.306 9.05Z", clipRule: "evenodd" })));
}, CheckmarkWithCircle: function(e) {
  return u.createElement("svg", F2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rN || (rN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.448-10.104a.997.997 0 1 1 1.508 1.306l-4.572 5.28a1 1 0 0 1-1.64-.07l-1.82-2.868a1 1 0 1 1 1.69-1.07l1.1 1.734 3.734-4.312Z", clipRule: "evenodd" })));
}, ChevronDown: function(e) {
  return u.createElement("svg", V2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aN || (aN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.636 5.364a1 1 0 0 0 0 1.414l4.95 4.95.707.707a1 1 0 0 0 1.414 0l.707-.707 4.95-4.95a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L8 8.899 3.757 4.657a1 1 0 0 0-1.414 0l-.707.707Z", clipRule: "evenodd" })));
}, ChevronLeft: function(e) {
  return u.createElement("svg", q2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lN || (lN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.778 1.636a1 1 0 0 0-1.414 0l-4.95 4.95-.707.707a1 1 0 0 0 0 1.414l.707.707 4.95 4.95a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L7.243 8l4.242-4.243a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, ChevronRight: function(e) {
  return u.createElement("svg", U2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iN || (iN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.364 14.364a1 1 0 0 0 1.414 0l4.95-4.95.707-.707a1 1 0 0 0 0-1.414l-.707-.707-4.95-4.95a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L8.899 8l-4.242 4.243a1 1 0 0 0 0 1.414l.707.707Z", clipRule: "evenodd" })));
}, ChevronUp: function(e) {
  return u.createElement("svg", W2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oN || (oN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.364 10.778a1 1 0 0 0 0-1.414l-4.95-4.95-.707-.707a1 1 0 0 0-1.414 0l-.707.707-4.95 4.95a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0L8 7.243l4.243 4.242a1 1 0 0 0 1.414 0l.707-.707Z", clipRule: "evenodd" })));
}, Clock: function(e) {
  return u.createElement("svg", G2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sN || (sN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.25a.75.75 0 0 1 1.5 0v3.16l1.744 1.526a.75.75 0 0 1-.988 1.128L7.511 8.818a.761.761 0 0 1-.19-.25.747.747 0 0 1-.071-.318v-3.5Z", clipRule: "evenodd" })));
}, ClockWithArrow: function(e) {
  return u.createElement("svg", K2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cN || (cN = u.createElement("path", { fill: "currentColor", d: "M13 8a5 5 0 0 1-7.304 4.438c-.348-.18-.787-.13-1.038.172l-.33.398c-.276.33-.22.828.152 1.044a7 7 0 1 0-1.452-10.98L1.97 2.146a.584.584 0 0 0-.964.521l.455 3.252c.04.287.285.51.576.511H5.32a.58.58 0 0 0 .387-1.018l-1.168-1.02A5 5 0 0 1 13 8Z" })), uN || (uN = u.createElement("path", { fill: "currentColor", d: "M7.25 5.25a.75.75 0 0 1 1.5 0v2.668l1.68 1.524a.75.75 0 1 1-.988 1.129L7.507 8.815a.758.758 0 0 1-.257-.565v-3Z" })));
}, Clone: function(e) {
  return u.createElement("svg", Y2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fN || (fN = u.createElement("path", { fill: "currentColor", d: "M5.5 12a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v4Z" })), dN || (dN = u.createElement("path", { fill: "currentColor", d: "M4.25 10H3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.75h-2V4h-5v4h.75v2Z" })));
}, Cloud: function(e) {
  return u.createElement("svg", X2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pN || (pN = u.createElement("path", { fill: "currentColor", d: "M12.571 8.143c0 1.775-.899 3.34-2.267 4.264l-.014.01a5.12 5.12 0 0 1-2.861.869H2.857a2.857 2.857 0 0 1-.545-5.663 5.144 5.144 0 0 1 10.26.52ZM13.821 8.143a6.38 6.38 0 0 1-2.358 4.96 3.429 3.429 0 1 0 2.17-6.506c.123.494.188 1.013.188 1.546Z" })));
}, Code: function(e) {
  return u.createElement("svg", Q2({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gN || (gN = u.createElement("path", { fill: "currentColor", d: "M6.11 13.262a.5.5 0 0 0 .395.586l.737.143a.5.5 0 0 0 .585-.396L9.926 2.738a.5.5 0 0 0-.396-.586l-.737-.143a.5.5 0 0 0-.585.396L6.109 13.262ZM1.36 7.246 3.976 5.11a.507.507 0 0 1 .704.063l.64.752a.483.483 0 0 1-.064.69L3.562 7.998 5.256 9.38c.212.173.24.482.064.69l-.64.752a.507.507 0 0 1-.704.062L1.36 8.75A.971.971 0 0 1 1 7.998c0-.29.132-.566.36-.752ZM14.636 7.246 12.02 5.11a.507.507 0 0 0-.704.063l-.64.752a.483.483 0 0 0 .064.69l1.694 1.382L10.74 9.38a.483.483 0 0 0-.064.69l.64.752a.507.507 0 0 0 .704.062l2.616-2.134a.971.971 0 0 0 .36-.752.971.971 0 0 0-.36-.752Z" })));
}, CodeBlock: function(e) {
  return u.createElement("svg", J2({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hN || (hN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4H3v8h10V4ZM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Z", clipRule: "evenodd" })), mN || (mN = u.createElement("path", { fill: "currentColor", d: "M4.221 7.421 6.256 5.78a.398.398 0 0 1 .548.048l.498.578a.368.368 0 0 1-.05.53L5.934 8l1.318 1.063c.165.133.187.37.05.53l-.498.58a.398.398 0 0 1-.548.047L4.221 8.58A.744.744 0 0 1 3.941 8c0-.224.103-.436.28-.579ZM11.779 7.421 9.744 5.78a.398.398 0 0 0-.548.048l-.498.578a.368.368 0 0 0 .05.53L10.066 8 8.748 9.063a.368.368 0 0 0-.05.53l.498.58c.138.159.383.18.548.047l2.035-1.641a.744.744 0 0 0 .28-.579.744.744 0 0 0-.28-.579Z" })));
}, Colon: function(e) {
  return u.createElement("svg", e5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vN || (vN = u.createElement("path", { fill: "currentColor", d: "M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
}, Connect: function(e) {
  return u.createElement("svg", t5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bN || (bN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.867 8.898a4.048 4.048 0 0 0 .687-4.8l1.275-1.275a.584.584 0 0 0 0-.826l-.826-.826a.584.584 0 0 0-.826 0l-1.29 1.29a4.048 4.048 0 0 0-4.734.722L5.277 5.058a.323.323 0 0 0-.041.035L3.182 7.148a4.048 4.048 0 0 0-.72 4.738l-1.29 1.29a.584.584 0 0 0 0 .827l.825.826a.584.584 0 0 0 .826 0l1.278-1.278a4.048 4.048 0 0 0 4.795-.689l1.876-1.875a.324.324 0 0 0 .041-.035l2.054-2.054ZM6.561 6.776 4.685 8.65a1.916 1.916 0 0 0 0 2.707c.747.746 1.961.747 2.707 0l2.055-2.054a.321.321 0 0 1 .04-.035l1.877-1.875a1.916 1.916 0 0 0 0-2.707 1.916 1.916 0 0 0-2.707 0L6.602 6.74a.32.32 0 0 1-.04.035Z", clipRule: "evenodd" })));
}, Copy: function(e) {
  return u.createElement("svg", n5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yN || (yN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 5.714v4.572C1 11.233 1.768 12 2.714 12H5.75V7.11c0-.566.227-1.108.63-1.504l2.294-2.252c.1-.099.21-.186.326-.262v-.378C9 1.768 8.232 1 7.286 1H5.8v3.429c0 .71-.576 1.285-1.286 1.285H1Zm8-.928L7.257 6.498A.857.857 0 0 0 7 7.11v.688h3.01a.857.857 0 0 0 .857-.858V4h-.717a.857.857 0 0 0-.6.246l-.55.54ZM4.867 1H4.15a.857.857 0 0 0-.601.246L1.257 3.498A.857.857 0 0 0 1 4.11v.688h3.01a.857.857 0 0 0 .857-.858V1ZM7 12V8.714H10.514c.71 0 1.286-.575 1.286-1.285V4h1.486C14.233 4 15 4.768 15 5.714v7.572c0 .947-.768 1.714-1.714 1.714H8.714A1.714 1.714 0 0 1 7 13.286V12Z", clipRule: "evenodd" })));
}, CreditCard: function(e) {
  return u.createElement("svg", r5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wN || (wN = u.createElement("path", { fill: "currentColor", d: "M3 3a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2H3ZM15 7H1v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7Z" })));
}, CurlyBraces: function(e) {
  return u.createElement("svg", a5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ON || (ON = u.createElement("path", { fill: "currentColor", d: "M3 3.544a2.5 2.5 0 0 1 2.5-2.5h1a.5.5 0 0 1 .5.5v1.105a.353.353 0 0 1-.353.353h-.79A.858.858 0 0 0 5 3.86v2.802a1.5 1.5 0 0 1-.816 1.335A1.5 1.5 0 0 1 5 9.332v2.803c0 .473.384.857.858.857h.789c.195 0 .353.158.353.353v1.105a.5.5 0 0 1-.5.5h-1a2.5 2.5 0 0 1-2.5-2.5v-1.956a1.5 1.5 0 0 0-1.5-1.5.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-1.95ZM13 12.45a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1-.5-.5v-1.105c0-.195.158-.353.353-.353h.79a.858.858 0 0 0 .857-.858V9.332a1.5 1.5 0 0 1 .816-1.335A1.5 1.5 0 0 1 11 6.662V3.859a.858.858 0 0 0-.858-.857h-.789A.353.353 0 0 1 9 2.65V1.544a.5.5 0 0 1 .5-.5h1a2.5 2.5 0 0 1 2.5 2.5V5.5A1.5 1.5 0 0 0 14.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0-1.5 1.5v1.95Z" })));
}, Cursor: function(e) {
  return u.createElement("svg", l5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xN || (xN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m8.534 8.534.473-.27 2.389-1.366-6.748-2.25 2.25 6.748 1.366-2.389.27-.473ZM10 10l4.48-2.563c.734-.333.678-1.393-.086-1.648L3.169 2.047A.887.887 0 0 0 2.047 3.17l3.742 11.225c.255.764 1.315.82 1.648.086L10 10Z", clipRule: "evenodd" })));
}, Dashboard: function(e) {
  return u.createElement("svg", i5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EN || (EN = u.createElement("path", { fill: "currentColor", d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6ZM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6ZM7 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3ZM2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z" })));
}, Database: function(e) {
  return u.createElement("svg", o5({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $N || ($N = u.createElement("path", { fill: "currentColor", d: "M13.5 4.452c0 .09 0 .177-.002.262l.002.094v.23c0 .3-.136.588-.433.87-.302.289-.75.548-1.305.765-1.11.434-2.541.656-3.762.656-1.22 0-2.652-.222-3.762-.656-.555-.217-1.003-.476-1.305-.764-.297-.283-.433-.571-.433-.872v-.229c0-.035 0-.07.002-.105a12.886 12.886 0 0 1-.002-.251C2.5 2.517 5.288 1.6 8 1.6s5.5.917 5.5 2.852Z" })), jN || (jN = u.createElement("path", { fill: "currentColor", d: "M2.5 6.747v1.957c0 .3.136.589.433.871.302.288.75.548 1.305.765 1.11.433 2.541.656 3.762.656 1.22 0 2.652-.223 3.762-.656.555-.217 1.003-.477 1.305-.765.297-.282.433-.57.433-.87V6.746c-.392.318-.88.575-1.405.78-1.236.483-2.784.719-4.095.719-1.31 0-2.859-.236-4.095-.72-.525-.204-1.013-.461-1.405-.779Z" })), CN || (CN = u.createElement("path", { fill: "currentColor", d: "M12.095 11.194c.525-.205 1.013-.462 1.405-.78v.811c0 .035 0 .07-.002.105l.002.251c0 1.936-2.788 2.852-5.5 2.852s-5.5-.916-5.5-2.852c0-.088 0-.176.002-.262a2.322 2.322 0 0 1-.002-.094v-.811c.392.318.88.575 1.405.78 1.236.483 2.784.718 4.095.718 1.31 0 2.859-.235 4.095-.719Z" })));
}, Diagram: function(e) {
  return u.createElement("svg", s5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MN || (MN = u.createElement("path", { fill: "currentColor", d: "M6 2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H8.5v2h4.75a.75.75 0 0 1 .75.75V10h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H13V8H8.5v2H9a.75.75 0 0 1 .75.75v1.5A.75.75 0 0 1 9 13H7a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 7 10h.5V8H3v2h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H2V7.75A.75.75 0 0 1 2.75 7H7.5V5h-.75A.75.75 0 0 1 6 4.25v-1.5Z" })));
}, Diagram2: function(e) {
  return u.createElement("svg", c5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kN || (kN = u.createElement("path", { fill: "currentColor", d: "M10.72 1c-.398 0-.72.336-.72.75V2H7.48a.49.49 0 0 0-.48.5V7H5v-.25C5 6.336 4.678 6 4.28 6H1.72c-.398 0-.72.336-.72.75v1.5c0 .414.322.75.72.75h2.56c.398 0 .72-.336.72-.75V8h2v4.5c0 .276.215.5.48.5H10v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V12H8V8h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V7H8V3h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06Z" })));
}, Diagram3: function(e) {
  return u.createElement("svg", u5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), PN || (PN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.75 1a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 5 3.25v-1.5A.75.75 0 0 0 4.25 1h-2.5Zm9.25.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm0 9a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm-10 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5ZM6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z", clipRule: "evenodd" })));
}, Disconnect: function(e) {
  return u.createElement("svg", f5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SN || (SN = u.createElement("path", { fill: "currentColor", d: "M7.093 3.671a.317.317 0 0 1 0-.448L8.14 2.175a4.024 4.024 0 0 1 5.685 0 4.024 4.024 0 0 1 0 5.685l-1.048 1.047a.317.317 0 0 1-.448 0L11.28 7.86a.317.317 0 0 1 0-.449l1.048-1.047a1.906 1.906 0 0 0 0-2.693 1.906 1.906 0 0 0-2.693 0L8.59 4.718a.317.317 0 0 1-.449 0L7.093 3.671ZM1.293 1.293a1.001 1.001 0 0 1 1.416 0l11.998 11.998a1.001 1.001 0 0 1-1.416 1.416l-3.159-3.16-2.272 2.277a4.024 4.024 0 0 1-5.685 0 4.024 4.024 0 0 1 0-5.684l2.273-2.277L1.293 2.71a1.001 1.001 0 0 1 0-1.416Zm4.65 6.066L3.672 9.636a1.906 1.906 0 0 0 0 2.693c.743.742 1.95.742 2.693 0l2.272-2.277-2.692-2.693Z" })));
}, Download: function(e) {
  return u.createElement("svg", d5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NN || (NN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.524 2.575v5.557h1.712c.706 0 1.033.783.5 1.196l-3.237 2.506a.832.832 0 0 1-.998 0L4.265 9.328c-.534-.413-.207-1.196.499-1.196h1.611V2.575a1.575 1.575 0 0 1 3.15 0ZM2.5 11h1.8l2.405 1.862a2.132 2.132 0 0 0 2.59 0L11.7 11h1.8a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3Z", clipRule: "evenodd" })));
}, Drag: function(e) {
  return u.createElement("svg", p5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RN || (RN = u.createElement("path", { fill: "currentColor", d: "M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
}, Edit: function(e) {
  return u.createElement("svg", g5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _N || (_N = u.createElement("path", { fill: "currentColor", d: "M10.922.681a.963.963 0 0 1 1.362 0l1.363 1.363a.963.963 0 0 1 0 1.362L12.284 4.77 9.56 2.044 8.538 3.066l2.724 2.725-7.153 7.153-3.747 1.022 1.022-3.747L10.922.68Z" })));
}, Ellipsis: function(e) {
  return u.createElement("svg", h5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AN || (AN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6.75 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", clipRule: "evenodd" })));
}, Email: function(e) {
  return u.createElement("svg", m5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LN || (LN = u.createElement("path", { fill: "currentColor", d: "m2.494 4 4.714 5.05a1.068 1.068 0 0 0 1.584 0L13.505 4H2.494ZM1.133 4.256A2.12 2.12 0 0 0 1 5v6c0 .369.093.715.256 1.011L4.814 8.2l-3.68-3.944Z" })), ZN || (ZN = u.createElement("path", { fill: "currentColor", d: "M2.867 13c-.348 0-.674-.102-.953-.28l3.56-3.813 1.219 1.306a1.78 1.78 0 0 0 2.64 0l1.346-1.443 3.575 3.83c-.313.251-.7.4-1.12.4H2.866ZM14.84 11.813c.103-.248.16-.523.16-.813V5c0-.255-.045-.5-.126-.724l-3.535 3.787 3.5 3.75Z" })));
}, Escalation: function(e) {
  return u.createElement("svg", v5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TN || (TN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.361 4.423a.556.556 0 0 0-.26-.97L5.146 2.009a.556.556 0 0 0-.636.69l1.787 6.672a.556.556 0 0 0 .896.28l6.168-5.228ZM2.911 2.102a.556.556 0 0 0-.392.68l3.163 11.806a.556.556 0 1 0 1.074-.287L3.592 2.493a.556.556 0 0 0-.68-.392Z", clipRule: "evenodd" })));
}, Export: function(e) {
  return u.createElement("svg", b5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BN || (BN = u.createElement("path", { fill: "currentColor", d: "M14.623 5.186a.278.278 0 0 0 0-.385l-2.805-2.915a.277.277 0 0 0-.477.192v1.424A6.5 6.5 0 0 0 5 10v.1a1.5 1.5 0 0 0 3 0V10a3.5 3.5 0 0 1 3.34-3.496v1.405c0 .25.305.373.478.193l2.805-2.916Z" })), IN || (IN = u.createElement("path", { fill: "currentColor", d: "M6.5 3.879a.75.75 0 0 0-.75-.75H4a2 2 0 0 0-2 2v6.864a2 2 0 0 0 2 2h6.864a2 2 0 0 0 2-2V10.05a.75.75 0 0 0-1.5 0v1.943a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V5.129a.5.5 0 0 1 .5-.5h1.75a.75.75 0 0 0 .75-.75Z" })));
}, Favorite: function(e) {
  return u.createElement("svg", y5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HN || (HN = u.createElement("path", { fill: "currentColor", d: "M7.538 1.11a.5.5 0 0 1 .924 0l1.537 3.696a.5.5 0 0 0 .421.306l3.99.32a.5.5 0 0 1 .285.878l-3.04 2.604a.5.5 0 0 0-.16.496l.928 3.893a.5.5 0 0 1-.747.542L8.261 11.76a.5.5 0 0 0-.522 0l-3.415 2.086a.5.5 0 0 1-.747-.542l.928-3.893a.5.5 0 0 0-.16-.496L1.304 6.31a.5.5 0 0 1 .285-.878l3.99-.32A.5.5 0 0 0 6 4.806L7.538 1.11Z" })));
}, Federation: function(e) {
  return u.createElement("svg", w5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DN || (DN = u.createElement("path", { fill: "currentColor", d: "M8 0c1.6 0 2.8 1.3 2.8 3 0 1.5-1 2.7-2.3 3v2.1l3.1 2.4c.4-.3 1-.5 1.5-.5 1.6 0 2.8 1.3 2.8 3s-1.3 3-2.8 3c-1.6 0-2.8-1.3-2.8-3 0-.7.2-1.3.6-1.8L8 9l-2.9 2.2c.4.5.6 1.1.6 1.8 0 1.7-1.3 3-2.8 3C1.4 16 0 14.7 0 13s1.3-3 2.8-3c.6 0 1.1.2 1.5.5l3.1-2.4V5.9C6.2 5.7 5.2 4.5 5.2 3c0-1.7 1.2-3 2.8-3Zm0 5c.8 0 1.9-.8 1.9-2C9.9 1.9 9 1 8 1c-1 0-1.9.9-1.9 2 0 1.2 1 2 1.9 2Zm-5.2 6c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.8-2-1.9-2Zm10.4 0c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.9-2-1.9-2Z" })));
}, File: function(e) {
  return u.createElement("svg", O5({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zN || (zN = u.createElement("path", { fill: "currentColor", d: "M3 13V7h4.5A1.5 1.5 0 0 0 9 5.5V1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" })), FN || (FN = u.createElement("path", { fill: "currentColor", d: "M7.833 1h-.919a1 1 0 0 0-.707.293L3.293 4.207A1 1 0 0 0 3 4.914v.92h3.833a1 1 0 0 0 1-1V1Z" })));
}, Filter: function(e) {
  return u.createElement("svg", x5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VN || (VN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 6.148-3.8-3.94C1.797 1.79 2.044 1 2.576 1h10.848c.532 0 .779.79.377 1.208L10 6.148v5.625a.5.5 0 0 1-.17.376l-3 2.625a.5.5 0 0 1-.83-.376v-8.25Z", clipRule: "evenodd" })));
}, FullScreenEnter: function(e) {
  return u.createElement("svg", $5({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UN || (UN = u.createElement("path", { fill: "currentColor", d: "M1.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM15 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM1.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM14.5 14a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, FullScreenExit: function(e) {
  return u.createElement("svg", j5({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WN || (WN = u.createElement("path", { fill: "currentColor", d: "M10.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM6 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM10.5 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM5.5 7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, Folder: function(e) {
  return u.createElement("svg", E5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qN || (qN = u.createElement("path", { fill: "currentColor", d: "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1 1 1 0 0 0-1-1H2Z" })));
}, Gauge: function(e) {
  return u.createElement("svg", C5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GN || (GN = u.createElement("path", { fill: "currentColor", d: "M1.041 10.251c-.044.412.296.749.71.749h2.494c.414 0 .74-.34.843-.742A3.006 3.006 0 0 1 8.791 8.1l2.99-2.991a7 7 0 0 0-10.74 5.142ZM13.297 6.422l-2.842 2.842c.213.3.368.638.459.994.102.401.429.742.843.742h2.494c.414 0 .754-.337.71-.749a7.001 7.001 0 0 0-1.664-3.829Z" })));
}, GlobeAmericas: function(e) {
  return u.createElement("svg", M5({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KN || (KN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-5.301 4.699A4.73 4.73 0 0 1 5 11.683V10L3.257 8.257A4.75 4.75 0 0 1 8 3.25V4.5L6.5 6v1l-.5.5-.5-.5-1 1 .5.5h2.5L8 9v1l-1 1 1.699 1.699Zm4.047-4.496a4.73 4.73 0 0 0-.924-3.025L10.5 6.5V9h1.25l.996-.797Z", clipRule: "evenodd" })));
}, GovernmentBuilding: function(e) {
  return u.createElement("svg", k5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YN || (YN = u.createElement("path", { fill: "currentColor", d: "M11 5V4a3 3 0 0 0-6 0v1h6Z" })), XN || (XN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 6a.5.5 0 0 0 0 1H2v6h-.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H14V7h.5a.5.5 0 0 0 0-1h-13Zm3 2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3ZM8 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 8Zm2.5.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z", clipRule: "evenodd" })));
}, Hash: function(e) {
  return u.createElement("svg", P5({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QN || (QN = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.616 1.5a.5.5 0 0 0-.492.413L9.668 4.5h-2.47l.426-2.413A.5.5 0 0 0 7.13 1.5H6.116a.5.5 0 0 0-.492.413L5.168 4.5H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.815l-.53 3H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.933l-.425 2.413A.5.5 0 0 0 4 14.5h1.016a.5.5 0 0 0 .492-.413l.456-2.587h2.47l-.426 2.413a.5.5 0 0 0 .492.587h1.016a.5.5 0 0 0 .492-.413l.456-2.587H13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.683l.529-3H13.5A.5.5 0 0 0 14 6V5a.5.5 0 0 0-.5-.5h-1.802l.426-2.413a.5.5 0 0 0-.492-.587h-1.016Zm-4.3 8h2.47l.529-3h-2.47l-.528 3Z", clipRule: "evenodd" })));
}, Highlight: function(e) {
  return u.createElement("svg", S5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JN || (JN = u.createElement("path", { fill: "currentColor", d: "M8.853 12.031A.1.1 0 0 1 8.926 12h5.824a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25H7.231a.1.1 0 0 1-.072-.168l1.694-1.8ZM4.019 9.193l.375-.374L7.576 12l-.375.375a1 1 0 0 1-.779.29l-.574-.04a1 1 0 0 0-.778.29l-.141.14-1.591-1.59.141-.142a1 1 0 0 0 .29-.778l-.04-.573a1 1 0 0 1 .29-.779ZM11.433 1.779a1 1 0 0 1 1.415 0l1.767 1.768a1 1 0 0 1 0 1.414L8.28 11.296 5.098 8.114l6.335-6.335ZM2.632 12.167l1.593 1.593-.17.172a.25.25 0 0 1-.178.074H1.386a.25.25 0 0 1-.176-.428l1.422-1.41Z" })));
}, Home: function(e) {
  return u.createElement("svg", N5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eR || (eR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.687 1.751a.5.5 0 0 1 .626 0l6.433 5.164a.5.5 0 0 1 .069.713l-.644.761a.5.5 0 0 1-.697.065L8.316 4.257a.5.5 0 0 0-.632 0L2.526 8.454a.5.5 0 0 1-.697-.065l-.644-.76a.5.5 0 0 1 .07-.714l6.432-5.164Z", clipRule: "evenodd" })), tR || (tR = u.createElement("path", { fill: "currentColor", d: "M7.688 5.25a.5.5 0 0 1 .624 0l4.5 3.6a.5.5 0 0 1 .188.39v4.26a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9.24a.5.5 0 0 1 .188-.39l4.5-3.6Z" })));
}, HorizontalDrag: function(e) {
  return u.createElement("svg", R5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nR || (nR = u.createElement("path", { fill: "currentColor", d: "M4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" })));
}, Import: function(e) {
  return u.createElement("svg", _5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rR || (rR = u.createElement("path", { fill: "currentColor", d: "M11.623 8.799a.278.278 0 0 0 0-.385L8.818 5.498a.277.277 0 0 0-.477.193v1.405A3.5 3.5 0 0 1 5 3.6v-.1a1.5 1.5 0 1 0-3 0v.1a6.5 6.5 0 0 0 6.34 6.498v1.424c0 .25.305.372.478.192L11.623 8.8Z" })), aR || (aR = u.createElement("path", { fill: "currentColor", d: "M3.95 11a.75.75 0 0 1 1.5 0v1.75a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V5.886a.5.5 0 0 0-.5-.5h-1.943a.75.75 0 0 1 0-1.5h1.943a2 2 0 0 1 2 2v6.864a2 2 0 0 1-2 2H5.95a2 2 0 0 1-2-2V11Z" })));
}, ImportantWithCircle: function(e) {
  return u.createElement("svg", A5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lR || (lR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 4.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, InfoWithCircle: function(e) {
  return u.createElement("svg", L5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iR || (iR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 0 1 1 1v4h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7h-.5a.5.5 0 0 1 0-1H8Z", clipRule: "evenodd" })));
}, InternalEmployee: function(e) {
  return u.createElement("svg", Z5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oR || (oR = u.createElement("path", { fill: "currentColor", d: "M6.5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h8.774l-.003-.05-.03-.022s-2.834-2.213-1.27-5.622c-.263-.055-.56.005-.814.144A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), sR || (sR = u.createElement("path", { fill: "currentColor", d: "M12.746 7.003c-.36-.448-.672-.903-.736-.998a.016.016 0 0 0-.023 0c-.063.095-.373.55-.732.998-3.084 4.137.486 6.925.486 6.925l.03.021c.026.431.093 1.051.093 1.051h.266s.067-.617.093-1.05l.03-.025c.004.003 3.577-2.785.493-6.922ZM12 13.87s-.16-.144-.203-.217v-.007l.193-4.505c0-.014.02-.014.02 0l.193 4.505v.007a1.522 1.522 0 0 1-.203.217Z" })));
}, InviteUser: function(e) {
  return u.createElement("svg", T5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cR || (cR = u.createElement("path", { fill: "currentColor", d: "M8.418 7.428a3.5 3.5 0 1 0-3.836-5.856 3.5 3.5 0 0 0 3.836 5.856ZM3.091 8.562c.308-.357.838-.339 1.252-.112.64.35 1.375.55 2.157.55s1.517-.2 2.157-.55c.414-.227.944-.245 1.252.112.11.128.214.263.31.403A1.996 1.996 0 0 0 9.5 10.5 2 2 0 0 0 8.177 14H2v-2.5c0-1.123.411-2.15 1.091-2.938Z" })), uR || (uR = u.createElement("path", { fill: "currentColor", d: "M10.5 10.5a.998.998 0 0 1 1-1 1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1Z" })));
}, Key: function(e) {
  return u.createElement("svg", B5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fR || (fR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.015 10.03c.652 0 1.267-.155 1.811-.43l1.512 1.51-.921.921a.669.669 0 0 0 0 .946l.827.827a.669.669 0 0 0 .946 0l.92-.92.75.749a1.254 1.254 0 0 0 1.773-1.773L9.599 7.827a4.015 4.015 0 1 0-3.584 2.204Zm-.753-3.513a1.255 1.255 0 1 0 0-2.51 1.255 1.255 0 0 0 0 2.51Z", clipRule: "evenodd" })));
}, Laptop: function(e) {
  return u.createElement("svg", I5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dR || (dR = u.createElement("path", { fill: "currentColor", d: "M5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 6ZM5.5 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })), pR || (pR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a1 1 0 0 0-1 1v7.813l-.29.49a.91.91 0 0 0-.068.1L1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.642-1.096a.901.901 0 0 0-.067-.1L14 11.313V3.5a1 1 0 0 0-1-1H3ZM12.5 4h-9v6.5h9V4Z", clipRule: "evenodd" })));
}, LightningBolt: function(e) {
  return u.createElement("svg", H5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gR || (gR = u.createElement("path", { fill: "currentColor", d: "M9.223 1.993c0-.497-.66-.68-.922-.256l-4.227 6.85a.493.493 0 0 0 .423.75h2.28v4.67c0 .497.66.68.921.257l4.228-6.852a.492.492 0 0 0-.424-.75h-2.28V1.993Z" })));
}, Link: function(e) {
  return u.createElement("svg", D5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hR || (hR = u.createElement("path", { fill: "currentColor", d: "M6.039 9.953a3.596 3.596 0 0 1-.327-.38l1.45-1.445a1.553 1.553 0 0 0 2.496.423l2.885-2.87a1.57 1.57 0 0 0 .01-2.213 1.553 1.553 0 0 0-2.203-.01l-.379.377A.995.995 0 0 1 8.56 3.83a1.005 1.005 0 0 1 .006-1.418l.38-.377a3.542 3.542 0 0 1 5.024.023 3.58 3.58 0 0 1-.022 5.047l-2.884 2.871a3.542 3.542 0 0 1-5.025-.022Z" })), mR || (mR = u.createElement("path", { fill: "currentColor", d: "M9.961 6.047c.12.12.228.248.327.38l-1.45 1.445a1.553 1.553 0 0 0-2.496-.423l-2.885 2.87a1.57 1.57 0 0 0-.01 2.213 1.553 1.553 0 0 0 2.203.01l.379-.377a.995.995 0 0 1 1.411.006 1.005 1.005 0 0 1-.006 1.418l-.38.377a3.542 3.542 0 0 1-5.024-.023 3.58 3.58 0 0 1 .022-5.047l2.884-2.871a3.542 3.542 0 0 1 5.025.022Z" })));
}, List: function(e) {
  return u.createElement("svg", z5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vR || (vR = u.createElement("path", { fill: "currentColor", d: "M3.125 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.125 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.875 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM6.625 3a1 1 0 0 0 0 2h6.5a1 1 0 1 0 0-2h-6.5ZM5.625 8a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1ZM6.625 11a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2h-6.5Z" })));
}, Lock: function(e) {
  return u.createElement("svg", F5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bR || (bR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7V5a4 4 0 1 1 8 0v2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm2-2a2 2 0 1 1 4 0v2H6V5Zm2.587 5.81A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, LogIn: function(e) {
  return u.createElement("svg", V5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yR || (yR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3a1 1 0 0 1 1-1h4.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H3v8h3.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H2a1 1 0 0 1-1-1V3Z", clipRule: "evenodd" })), wR || (wR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.495 4.116 6.293 7.318a1 1 0 0 0 0 1.414l3.202 3.202a.75.75 0 0 0 1.06 0l.354-.353a.75.75 0 0 0 0-1.061L9.389 9h4.861a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75H9.44l1.469-1.47a.75.75 0 0 0 0-1.06l-.354-.354a.75.75 0 0 0-1.06 0Z", clipRule: "evenodd" })));
}, LogOut: function(e) {
  return u.createElement("svg", q5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), OR || (OR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 3c0-.552.446-1 .995-1h4.23c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75H3.49v8h3.235c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75h-4.23a.998.998 0 0 1-.995-1V3Z", clipRule: "evenodd" })), xR || (xR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11.022 11.909 3.187-3.202a1.003 1.003 0 0 0 0-1.414L11.022 4.09a.744.744 0 0 0-1.056 0l-.352.354a.753.753 0 0 0 0 1.06l1.513 1.52H6.29a.748.748 0 0 0-.746.75v.5c0 .414.334.75.746.75h4.788l-1.463 1.47a.753.753 0 0 0 0 1.06l.352.354a.744.744 0 0 0 1.056 0Z", clipRule: "evenodd" })));
}, MagnifyingGlass: function(e) {
  return u.createElement("svg", U5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ER || (ER = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.323 9.819a5.302 5.302 0 0 0 6.463.805l4.144 4.144a1.3 1.3 0 1 0 1.838-1.838l-4.144-4.144a5.302 5.302 0 0 0-8.3-6.463 5.3 5.3 0 0 0 0 7.496ZM7.98 4.162A2.7 2.7 0 1 1 4.162 7.98 2.7 2.7 0 0 1 7.98 4.162Z", clipRule: "evenodd" })));
}, Megaphone: function(e) {
  return u.createElement("svg", W5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $R || ($R = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 3 5.725-1.636A1 1 0 0 1 13 2.326v7.348a1 1 0 0 1-1.275.962L6 9H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3Zm-.657 7H3v5h2.98a1 1 0 0 0 .918-1.396L5.343 10ZM16 6a2 2 0 0 1-2 2V4a2 2 0 0 1 2 2Z", clipRule: "evenodd" })));
}, Menu: function(e) {
  return u.createElement("svg", G5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jR || (jR = u.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
}, Minus: function(e) {
  return u.createElement("svg", K5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CR || (CR = u.createElement("path", { fill: "currentColor", d: "M3 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3Z" })));
}, Mobile: function(e) {
  return u.createElement("svg", Y5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MR || (MR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H5v10h6V3ZM5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z", clipRule: "evenodd" })));
}, MultiDirectionArrow: function(e) {
  return u.createElement("svg", X5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kR || (kR = u.createElement("path", { fill: "currentColor", d: "M5 8.573v4.854c0 .53-.608.774-.928.374L2.13 11.374a.607.607 0 0 1 0-.748l1.943-2.427c.32-.4.928-.155.928.374Z" })), PR || (PR = u.createElement("path", { fill: "currentColor", d: "M5 10h7.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5v-2ZM11 7.427V2.573c0-.53.608-.775.928-.374l1.943 2.427a.607.607 0 0 1 0 .748l-1.943 2.427c-.32.4-.928.155-.928-.374ZM3 4.5a.5.5 0 0 1 .5-.5H11v2H3.5a.5.5 0 0 1-.5-.5v-1Z" })));
}, MultiLayers: function(e) {
  return u.createElement("svg", Q5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SR || (SR = u.createElement("path", { fill: "currentColor", d: "m12.431 9.745-.26-.121.26-.122a1.99 1.99 0 0 0 .758-.597c.197-.252.311-.576.311-.9 0-.324-.114-.637-.311-.9a2.073 2.073 0 0 0-.758-.597l-.29-.142.217-.101c.301-.142.571-.344.758-.597.197-.253.311-.577.311-.9 0-.324-.114-.638-.311-.9a2.073 2.073 0 0 0-.758-.598L9.194 1.763A2.9 2.9 0 0 0 7.97 1.5c-.415 0-.84.08-1.225.263L3.57 3.27c-.301.142-.57.344-.758.597a1.483 1.483 0 0 0-.311.9c0 .324.114.638.311.901.197.253.457.455.758.597l.29.142-.217.1c-.301.142-.571.345-.758.598a1.483 1.483 0 0 0-.311.9c0 .324.114.637.311.9.197.253.457.456.758.597l.259.122-.26.121c-.3.142-.57.344-.757.597a1.484 1.484 0 0 0-.311.9c0 .324.114.638.311.9.197.254.457.456.758.598l3.165 1.497c.384.182.809.263 1.224.263.415 0 .84-.08 1.225-.263l3.165-1.497c.3-.142.57-.344.757-.597.197-.253.312-.577.312-.9 0-.324-.114-.638-.312-.901a2.073 2.073 0 0 0-.757-.597h.01Zm-4.39 3.248c-.207 0-.404-.04-.54-.112l-3.164-1.497c-.114-.05-.166-.111-.187-.132l.02-.02.167-.111 1.36-.637 1.13.536c.384.182.81.263 1.225.263.415 0 .84-.081 1.224-.263l1.132-.536 1.359.637c.114.05.166.111.187.131l-.021.02-.166.112-3.165 1.497a1.28 1.28 0 0 1-.54.112h-.02ZM4.14 8.005l.02-.02.166-.111 1.318-.628 1.1.516c.384.182.81.263 1.225.263.415 0 .84-.08 1.224-.263l1.173-.556 1.39.657c.115.051.167.112.187.132l-.02.02-.166.111-3.165 1.498a1.28 1.28 0 0 1-.54.111c-.208 0-.405-.04-.54-.111L4.347 8.126c-.114-.05-.166-.11-.187-.131l-.02.01Zm-.073-3.237.02-.02.167-.112L7.419 3.14a1.28 1.28 0 0 1 .54-.111c.207 0 .404.04.54.11l3.164 1.498c.114.05.166.111.187.132l-.02.02-.167.111-3.165 1.497a1.28 1.28 0 0 1-.54.112c-.207 0-.404-.04-.54-.112L4.255 4.9c-.114-.05-.166-.111-.187-.131Z" })));
}, NavCollapse: function(e) {
  return u.createElement("svg", J5({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NR || (NR = u.createElement("path", { fill: "currentColor", d: "M11.39 4.818a.5.5 0 0 0-.708 0L7.854 7.646a.5.5 0 0 0 0 .708l2.828 2.828a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L9.62 8l2.122-2.121a.5.5 0 0 0 0-.707l-.354-.354Z" })), RR || (RR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm1 1.5H4A1.5 1.5 0 0 0 2.5 4v8A1.5 1.5 0 0 0 4 13.5h1v-11Zm1.5 0v11H12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 12 2.5H6.5Z", clipRule: "evenodd" })));
}, NavExpand: function(e) {
  return u.createElement("svg", ef({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _R || (_R = u.createElement("path", { fill: "currentColor", d: "M4.61 4.818a.5.5 0 0 1 .708 0l2.828 2.828a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L6.38 8 4.257 5.879a.5.5 0 0 1 0-.707l.354-.354Z" })), AR || (AR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8Zm-1 1.5h1A1.5 1.5 0 0 1 13.5 4v8a1.5 1.5 0 0 1-1.5 1.5h-1v-11Zm-1.5 0v11H4A1.5 1.5 0 0 1 2.5 12V4A1.5 1.5 0 0 1 4 2.5h5.5Z", clipRule: "evenodd" })));
}, NoFilter: function(e) {
  return u.createElement("svg", tf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LR || (LR = u.createElement("path", { fill: "currentColor", d: "M2.606 1.204a1 1 0 0 0-1.313 1.503L7 8.414v5.984a.5.5 0 0 0 .83.376l2.949-2.58 2.512 2.511a1 1 0 0 0 1.414-1.414l-1.818-1.818-.006.006L2.606 1.204ZM10.573 7.15A.25.25 0 0 0 11 6.972v-.825l3.8-3.94C15.202 1.79 14.957 1 14.425 1H5.027a.25.25 0 0 0-.176.427l5.722 5.722Z" })));
}, NotAllowed: function(e) {
  return u.createElement("svg", nf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZR || (ZR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.75 8a3.75 3.75 0 0 1-5.485 3.326l5.06-5.06c.272.518.425 1.108.425 1.734ZM4.674 9.735l5.06-5.06a3.75 3.75 0 0 0-5.06 5.06ZM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z", clipRule: "evenodd" })));
}, Note: function(e) {
  return u.createElement("svg", rf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TR || (TR = u.createElement("path", { fill: "currentColor", d: "M4.5 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM4.5 8.75A.75.75 0 0 1 5.25 8h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" })), BR || (BR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m15 10-4 4H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6Zm-2-6H3v8h7v-2a1 1 0 0 1 1-1h2V4Z", clipRule: "evenodd" })));
}, OpenNewTab: function(e) {
  return u.createElement("svg", af({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IR || (IR = u.createElement("path", { fill: "currentColor", d: "M13.823 2.45a.278.278 0 0 0-.272-.273l-4.045-.079a.277.277 0 0 0-.201.474l1.08 1.08-2.45 2.452a1.395 1.395 0 0 0-.148.174L5.999 8.065a1.369 1.369 0 1 0 1.936 1.936l1.787-1.788c.061-.043.12-.093.174-.147l2.451-2.452 1.081 1.081a.277.277 0 0 0 .474-.201l-.079-4.045Z" })), HR || (HR = u.createElement("path", { fill: "currentColor", d: "M7.25 3.129a.75.75 0 0 1 0 1.5H4a.5.5 0 0 0-.5.5v6.864a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0v3.243a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.129a2 2 0 0 1 2-2h3.25Z" })));
}, Pause: function(e) {
  return u.createElement("svg", lf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DR || (DR = u.createElement("path", { fill: "currentColor", d: "M4.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1ZM10.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1Z" })));
}, Person: function(e) {
  return u.createElement("svg", of({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zR || (zR = u.createElement("path", { fill: "currentColor", d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })), FR || (FR = u.createElement("path", { fill: "currentColor", d: "M8 8c-.708 0-1.367-.21-1.918-.572A4.483 4.483 0 0 1 8 7c.686 0 1.336.154 1.918.428C9.368 7.79 8.708 8 8 8ZM4.591 8.562c.308-.357.838-.339 1.252-.112C6.483 8.8 7.218 9 8 9s1.517-.2 2.158-.55c.413-.227.943-.245 1.251.112A4.482 4.482 0 0 1 12.5 11.5V14h-9v-2.5c0-1.123.411-2.15 1.091-2.938Z" })));
}, PersonGroup: function(e) {
  return u.createElement("svg", sf({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VR || (VR = u.createElement("path", { fill: "currentColor", d: "M4.808 8.923a2.962 2.962 0 1 0 0-5.923 2.962 2.962 0 0 0 0 5.923ZM2.982 9.304c-.35-.192-.798-.207-1.059.095A3.793 3.793 0 0 0 1 11.885V14h7.615v-2.115c0-.95-.347-1.819-.923-2.486-.26-.302-.708-.287-1.059-.095a3.79 3.79 0 0 1-1.825.465 3.79 3.79 0 0 1-1.826-.465ZM9.615 11.885V13H15v-1.906c0-.734-.274-1.405-.727-1.92-.206-.234-.559-.222-.835-.074-.427.23-.917.36-1.438.36-.521 0-1.011-.13-1.438-.36-.276-.148-.63-.16-.835.073-.21.239-.38.51-.504.806.252.585.392 1.23.392 1.906ZM14.333 6.288c0 1.264-1.044 2.289-2.333 2.289-1.289 0-2.333-1.025-2.333-2.289C9.667 5.025 10.71 4 12 4c1.289 0 2.333 1.025 2.333 2.288Z" })));
}, PersonWithLock: function(e) {
  return u.createElement("svg", cf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qR || (qR = u.createElement("path", { fill: "currentColor", d: "M10 4.5A3.497 3.497 0 0 1 6.5 8a3.484 3.484 0 0 1-1.918-.572A3.5 3.5 0 1 1 10 4.5ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h6v-2.5c0-.445.194-.845.502-1.12.033-.82.393-1.554.954-2.076-.259-.051-.55.01-.799.146A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), UR || (UR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 10.5v.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5v-.5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 0-1 1v.5h2v-.5a1 1 0 0 0-1-1Z", clipRule: "evenodd" })));
}, Pin: function(e) {
  return u.createElement("svg", uf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WR || (WR = u.createElement("path", { fill: "currentColor", d: "M10 8.5V3.3h.683a.65.65 0 1 0 0-1.3H5.317a.65.65 0 1 0 0 1.3H6v5.2L4.383 9.55a.843.843 0 0 0 .46 1.55h2.624v3.367a.533.533 0 0 0 1.066 0V11.1h2.624a.843.843 0 0 0 .46-1.55L10 8.5Z" })));
}, Play: function(e) {
  return u.createElement("svg", ff({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GR || (GR = u.createElement("path", { fill: "currentColor", d: "M13.779 6.704a1.5 1.5 0 0 1 0 2.592l-7.523 4.388A1.5 1.5 0 0 1 4 12.388V3.612a1.5 1.5 0 0 1 2.256-1.296l7.523 4.388Z" })));
}, Plus: function(e) {
  return u.createElement("svg", df({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KR || (KR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v3.5H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9.5H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9.5V3a1 1 0 0 0-1-1h-1Z", clipRule: "evenodd" })));
}, PlusWithCircle: function(e) {
  return u.createElement("svg", pf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YR || (YR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z", clipRule: "evenodd" })));
}, Primary: function(e) {
  return u.createElement("svg", gf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XR || (XR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3-8.307C11 5.172 9.918 4 8.433 4H6v8h1.495V9.386h.938C9.918 9.386 11 8.214 11 6.693Zm-1.454 0c0 .653-.453 1.16-1.134 1.16h-.917v-2.32h.917c.68 0 1.134.506 1.134 1.16Z", clipRule: "evenodd" })));
}, Project: function(e) {
  return u.createElement("svg", hf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QR || (QR = u.createElement("path", { fill: "currentColor", d: "M1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 4V2Z" })), JR || (JR = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 5.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75H2.75ZM6.25 7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1h-3.5Z", clipRule: "evenodd" })));
}, QuestionMarkWithCircle: function(e) {
  return u.createElement("svg", mf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), e_ || (e_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.932 5.612C7.054 5.298 7.425 5 7.942 5 8.615 5 9 5.478 9 5.875c0 .162-.057.33-.172.476a.985.985 0 0 1-.242.216l-.016.01a1.141 1.141 0 0 1-.098.054c-.59.286-1.53.967-1.53 2.119V9a1 1 0 0 0 2 0c0-.035.011-.12.138-.27a2.66 2.66 0 0 1 .587-.48 3 3 0 0 0 .726-.656A2.742 2.742 0 0 0 11 5.875C11 4.201 9.54 3 7.941 3c-1.275 0-2.43.745-2.873 1.888a1 1 0 1 0 1.864.724ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, Read: function(e) {
  return u.createElement("svg", vf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), t_ || (t_ = u.createElement("path", { fill: "currentColor", d: "M10.011 8.762V4.185h-1.39c-.574 0-.84-.645-.406-.985l2.63-2.063a.669.669 0 0 1 .81 0l2.63 2.063c.433.34.168.985-.405.985h-1.31v4.577c0 .716-.572 1.297-1.28 1.297-.706 0-1.279-.58-1.279-1.297ZM8.823 9.158c-.814.19-1.677.283-2.448.283-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.2-.079.383-.164.548-.254a2.53 2.53 0 0 1-1.434-1.91Z" })), n_ || (n_ = u.createElement("path", { fill: "currentColor", d: "M6.787 3.479a10.514 10.514 0 0 0-.412-.008c-2.404 0-4.875.823-4.875 2.562 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.768 0 1.63-.101 2.418-.299V5.421H8.62c-.767 0-1.428-.45-1.706-1.125-.107-.26-.15-.54-.128-.817ZM11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729Z" })));
}, Recommended: function(e) {
  return u.createElement("svg", bf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), r_ || (r_ = u.createElement("path", { fill: "currentColor", d: "m8.148 5.458-.944 1.968V9.59h2.099a.5.5 0 0 0 .491-.407l.223-1.182a.5.5 0 0 0-.491-.593h-.638a.623.623 0 0 1-.61-.636V5.708a.302.302 0 0 0-.13-.25Z" })), a_ || (a_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.538 1.554a.75.75 0 0 0-1.076 0L6.4 2.648a.75.75 0 0 1-.615.224L4.27 2.716a.75.75 0 0 0-.824.692l-.11 1.52a.75.75 0 0 1-.328.567l-1.261.856a.75.75 0 0 0-.187 1.06l.893 1.235a.75.75 0 0 1 .113.644l-.416 1.467a.75.75 0 0 0 .538.932l1.478.373a.75.75 0 0 1 .501.42l.624 1.39a.75.75 0 0 0 1.011.369l1.372-.665a.75.75 0 0 1 .654 0l1.372.665a.75.75 0 0 0 1.011-.368l.624-1.391a.75.75 0 0 1 .5-.42l1.48-.373a.75.75 0 0 0 .537-.932l-.416-1.467a.75.75 0 0 1 .114-.644l.892-1.235a.75.75 0 0 0-.187-1.06l-1.261-.856a.75.75 0 0 1-.327-.566l-.11-1.52a.75.75 0 0 0-.825-.693l-1.517.156a.75.75 0 0 1-.614-.224L8.538 1.554Zm-1.064 3.28a.577.577 0 0 1 .518-.334c.639 0 1.157.54 1.157 1.208V6.5h.98c.549 0 .96.523.854 1.085l-.412 2.182a.881.881 0 0 1-.854.733H5.435c-.24 0-.435-.294-.435-.546V7.591c0-.251.195-.455.435-.455h.898c.013 0 .027 0 .04.002a.702.702 0 0 1 .03-.072l1.071-2.232Z", clipRule: "evenodd" })));
}, Redo: function(e) {
  return u.createElement("svg", yf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), l_ || (l_ = u.createElement("path", { fill: "currentColor", d: "M4.018 9.402c-.05.328-.313.598-.645.598h-.8c-.331 0-.603-.27-.57-.6a5.996 5.996 0 0 1 2.543-4.325A5.997 5.997 0 0 1 7.974 4h.028c2.699 0 4.95 1.718 5.467 4h1.414c.541 0 .792.672.383 1.026l-2.482 2.15a.585.585 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.92 8h1.446c-.468-1.085-1.68-2-3.364-2a3.98 3.98 0 0 0-2.543.89 3.996 3.996 0 0 0-1.441 2.512Z" })));
}, Refresh: function(e) {
  return u.createElement("svg", wf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), i_ || (i_ = u.createElement("path", { fill: "currentColor", d: "M8.033 2c2.699 0 4.95 1.718 5.467 4h1.414c.542 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.951 6h1.447c-.469-1.085-1.68-2-3.365-2-1.026 0-1.877.34-2.491.85-.243.202-.618.203-.817-.043l-.61-.754a.468.468 0 0 1 .044-.651C5.163 2.534 6.53 2 8.033 2ZM3.95 6.843a.584.584 0 0 0-.765 0L.703 8.992a.584.584 0 0 0 .383 1.026h1.418C3.03 12.291 5.275 14 7.967 14c1.505 0 2.87-.534 3.874-1.402a.468.468 0 0 0 .044-.65l-.61-.755c-.2-.246-.574-.245-.817-.043-.614.51-1.465.85-2.49.85-1.676 0-2.883-.904-3.358-1.982H6.05a.584.584 0 0 0 .383-1.026L3.95 6.842Z" })));
}, Relationship: function(e) {
  return u.createElement("svg", Of({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), o_ || (o_ = u.createElement("path", { fill: "currentColor", d: "M.5 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6a2.5 2.5 0 0 1 2.5 2.5v5A1.5 1.5 0 0 0 10 12h1.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H10a2.5 2.5 0 0 1-2.5-2.5v-5A1.5 1.5 0 0 0 6 4H4.5v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2Z" })));
}, ReplicaSet: function(e) {
  return u.createElement("svg", xf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), s_ || (s_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.39 7.713A3.488 3.488 0 0 1 8 8c-.494 0-.964-.102-1.39-.287L5.264 9.729a2.5 2.5 0 1 1-1.08-.634L5.57 7.02a3.5 3.5 0 1 1 4.86 0l1.385 2.076A2.501 2.501 0 0 1 15 11.5a2.5 2.5 0 1 1-4.265-1.77L9.391 7.712ZM9.75 4.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, Resize: function(e) {
  return u.createElement("svg", Ef({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), c_ || (c_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.77 5.72a.75.75 0 0 1 0 1.06l-7.991 8a.749.749 0 1 1-1.06-1.06l7.992-8a.749.749 0 0 1 1.06 0ZM14.78 10.22a.75.75 0 0 1 0 1.06l-3.496 3.5a.749.749 0 1 1-1.06-1.06l3.497-3.5a.749.749 0 0 1 1.06 0Z", clipRule: "evenodd" })));
}, Return: function(e) {
  return u.createElement("svg", $f({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), u_ || (u_ = u.createElement("path", { fill: "currentColor", d: "M5 2a1 1 0 0 0 0 2h5a2.5 2.5 0 0 1 0 5H5.203l1.448-1.24a1 1 0 1 0-1.302-1.52l-3.5 3a1 1 0 0 0 0 1.52l3.5 3a1 1 0 0 0 1.302-1.52L5.203 11H10a4.5 4.5 0 1 0 0-9H5Z" })));
}, Save: function(e) {
  return u.createElement("svg", jf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), f_ || (f_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 2 3.04 2 3.6 2h7.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l1.062 1.063c.173.173.26.26.322.36.055.09.095.188.12.29.027.115.027.237.027.482V12.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.2.102-.46.109-.954.109V9.284c0-.126 0-.25-.008-.353a1.01 1.01 0 0 0-.101-.385 1 1 0 0 0-.437-.437 1.01 1.01 0 0 0-.385-.1C11.465 8 11.342 8 11.216 8H4.784c-.126 0-.249 0-.353.008a1.01 1.01 0 0 0-.385.101 1 1 0 0 0-.437.437 1.01 1.01 0 0 0-.1.385c-.009.104-.009.227-.009.353V14c-.494 0-.753-.007-.954-.109a1 1 0 0 1-.437-.437C2 13.24 2 12.96 2 12.4V3.6Zm2-.1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z", clipRule: "evenodd" })), d_ || (d_ = u.createElement("path", { fill: "currentColor", d: "M11.5 9.3V14h-7V9.3c0-.148 0-.23.005-.288v-.006h.007C4.571 9 4.652 9 4.8 9h6.4c.148 0 .23 0 .288.005h.006v.007c.006.059.006.14.006.288Z" })));
}, Serverless: function(e) {
  return u.createElement("svg", kf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), b_ || (b_ = u.createElement("path", { fill: "currentColor", d: "M2.132 10.849a5.5 5.5 0 1 1 8.4-6.571 4 4 0 0 1 4.398 6.444 1 1 0 0 1-.15.192l-1.77 1.898a1.995 1.995 0 0 1-1.51.688H7.792a2.5 2.5 0 1 1 0-2H11.5l1.166-1.25H8.5a3.75 3.75 0 0 0-6.368.599Z" })));
}, ShardedCluster: function(e) {
  return u.createElement("svg", Sf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), w_ || (w_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 2.75a1.75 1.75 0 0 1-2.123 1.71l-.619.866a3.497 3.497 0 0 1 1.186 2.049h1.17a1.75 1.75 0 1 1 0 1.25h-1.17a3.497 3.497 0 0 1-1.186 2.05l.619.865a1.75 1.75 0 1 1-1.046.686l-.662-.926a3.495 3.495 0 0 1-2.331.002l-.664.93a1.75 1.75 0 1 1-1.043-.69l.616-.863a3.497 3.497 0 0 1-1.191-2.054h-1.17a1.75 1.75 0 1 1 0-1.25h1.17c.147-.819.58-1.54 1.191-2.054l-.616-.863a1.75 1.75 0 1 1 1.043-.69l.664.93A3.494 3.494 0 0 1 8 4.5c.41 0 .803.07 1.17.2l.66-.926A1.75 1.75 0 1 1 13 2.75ZM9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, SearchIndex: function(e) {
  return u.createElement("svg", Cf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), p_ || (p_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.816 12.754a2.786 2.786 0 0 0 3.396.424l1.622 1.622a.683.683 0 1 0 .966-.966l-1.622-1.622a2.786 2.786 0 1 0-4.362.542Zm2.972-2.972a1.419 1.419 0 1 1-2.006 2.006 1.419 1.419 0 0 1 2.006-2.006Z", clipRule: "evenodd" })), g_ || (g_ = u.createElement("path", { fill: "currentColor", d: "M12 3.667c0 .083 0 .165-.002.245L12 4v.214c0 .281-.124.55-.393.815-.275.27-.682.512-1.187.715-1.01.405-2.31.613-3.42.613-1.11 0-2.41-.208-3.42-.613-.505-.203-.912-.446-1.187-.715C2.123 4.765 2 4.495 2 4.214V4c0-.033 0-.066.002-.099A12.44 12.44 0 0 1 2 3.667C2 1.857 4.534 1 7 1s5 .857 5 2.667Z" })), h_ || (h_ = u.createElement("path", { fill: "currentColor", d: "M2 5.813v1.83c0 .28.124.55.393.815.275.269.682.511 1.187.714 1.01.406 2.31.614 3.42.614l.134-.001A3.785 3.785 0 0 1 12 7.2V5.812c-.357.297-.8.537-1.277.729-1.124.452-2.532.672-3.723.672-1.191 0-2.599-.22-3.723-.672C2.8 6.35 2.357 6.11 2 5.813ZM7 10.643h.003c-.03.816.201 1.64.696 2.334-.232.015-.466.023-.699.023-2.466 0-5-.857-5-2.667 0-.083 0-.165.002-.245A2.229 2.229 0 0 1 2 10v-.758c.357.297.8.537 1.277.729 1.124.451 2.532.672 3.723.672Z" })));
}, Secondary: function(e) {
  return u.createElement("svg", Mf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), m_ || (m_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z", clipRule: "evenodd" })), v_ || (v_ = u.createElement("path", { fill: "currentColor", d: "M11 9.67C11 11.112 9.786 12 8.117 12 6.337 12 5.07 10.897 5 9.395h1.972c.07.674.594.996 1.2.996.594 0 .897-.245.897-.613 0-.399-.262-.598-.869-.767l-1.297-.367c-1.2-.337-1.751-1.257-1.751-2.376C5.152 4.95 6.2 4 7.924 4c1.517 0 2.676.889 2.786 2.421H8.807c-.097-.582-.497-.781-.91-.781-.483 0-.814.214-.814.582 0 .43.372.598.786.705l1.214.368C10.434 7.678 11 8.475 11 9.671Z" })));
}, Settings: function(e) {
  return u.createElement("svg", Pf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), y_ || (y_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.207 1.067a.75.75 0 0 0-.89.247l-.374.506a6.214 6.214 0 0 0-1.894.002l-.375-.506a.75.75 0 0 0-.89-.246l-1.126.467a.75.75 0 0 0-.454.804l.093.623c-.505.37-.958.82-1.338 1.34l-.623-.093a.75.75 0 0 0-.803.455l-.466 1.127a.75.75 0 0 0 .247.89l.506.374a6.214 6.214 0 0 0 .002 1.893l-.506.376a.75.75 0 0 0-.246.89l.467 1.126a.75.75 0 0 0 .804.454l.623-.093c.37.505.82.958 1.34 1.338l-.093.623a.75.75 0 0 0 .455.803l1.127.466a.75.75 0 0 0 .89-.247l.374-.506a6.218 6.218 0 0 0 1.894-.002l.375.506a.75.75 0 0 0 .89.246l1.126-.467a.75.75 0 0 0 .454-.804l-.093-.623c.505-.37.958-.82 1.338-1.34l.623.093a.75.75 0 0 0 .803-.455l.466-1.127a.75.75 0 0 0-.247-.89l-.506-.374a6.218 6.218 0 0 0-.002-1.894l.506-.375a.75.75 0 0 0 .246-.89l-.467-1.126a.75.75 0 0 0-.804-.454l-.623.093a6.214 6.214 0 0 0-1.34-1.338l.093-.623a.75.75 0 0 0-.455-.803l-1.127-.466Zm.334 7.984A2.75 2.75 0 1 1 5.46 6.949a2.75 2.75 0 0 1 5.082 2.102Z", clipRule: "evenodd" })));
}, Shell: function(e) {
  return u.createElement("svg", Nf({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), O_ || (O_ = u.createElement("path", { fill: "currentColor", d: "m1.8 5.2 3.4 2.2-3.79 2.526a.5.5 0 0 0-.142.688l.557.86a.5.5 0 0 0 .697.145L7.5 8.3c.3-.2.5-.5.5-.8 0-.3-.2-.6-.4-.8L2.522 3.284a.5.5 0 0 0-.699.143l-.547.847a.5.5 0 0 0 .155.695L1.8 5.2ZM6.7 13a.5.5 0 0 0 .5.5h7.7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.2a.5.5 0 0 0-.5.5v1Z" })));
}, SMS: function(e) {
  return u.createElement("svg", Rf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), x_ || (x_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7.755L4.23 14.831c-.488.392-1.23.058-1.23-.555V12a2 2 0 0 1-2-2V4Zm2 .75A.75.75 0 0 1 3.75 4h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 4.75Zm0 3A.75.75 0 0 1 3.75 7h5.5a.75.75 0 1 1 0 1.5h-5.5A.75.75 0 0 1 3 7.75Z", clipRule: "evenodd" })));
}, SortAscending: function(e) {
  return u.createElement("svg", _f({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), E_ || (E_ = u.createElement("path", { fill: "currentColor", d: "M4.45 1.143a.584.584 0 0 0-.765 0L1.203 3.292a.584.584 0 0 0 .383 1.026h1.312v9.352a1.169 1.169 0 1 0 2.338 0V4.318H6.55a.584.584 0 0 0 .383-1.026L4.45 1.142ZM8 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, SortDescending: function(e) {
  return u.createElement("svg", Af({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $_ || ($_ = u.createElement("path", { fill: "currentColor", d: "M4.45 14.696a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.025h1.312V2.168a1.169 1.169 0 1 1 2.338 0v9.351H6.55c.541 0 .792.673.383 1.027L4.45 14.696ZM8 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, Sparkle: function(e) {
  return u.createElement("svg", Lf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), j_ || (j_ = u.createElement("path", { fill: "currentColor", d: "m6.273 2.893-.998 2.995c-.1.3-.336.536-.636.637l-2.995.998a.503.503 0 0 0 0 .954l2.995.998c.3.1.536.336.636.637l.998 2.995a.503.503 0 0 0 .955 0l.998-2.995c.1-.3.336-.536.636-.637l2.995-.998a.503.503 0 0 0 0-.954l-2.995-.998c-.3-.1-.536-.336-.636-.637l-.998-2.995a.503.503 0 0 0-.955 0ZM12.547 1.172l-.231.693c-.1.3-.336.536-.636.636l-.694.231c-.229.077-.229.401 0 .477l.694.231c.3.1.536.336.636.637l.23.693c.077.229.402.229.478 0l.231-.693c.1-.3.336-.536.636-.637l.693-.23c.23-.077.23-.401 0-.478l-.693-.23c-.3-.1-.536-.337-.636-.637l-.231-.693a.251.251 0 0 0-.477 0ZM12.547 11.23l-.231.693c-.1.3-.336.536-.636.636l-.694.232c-.229.076-.229.4 0 .477l.694.23c.3.1.536.337.636.637l.23.693c.077.23.402.23.478 0l.231-.693c.1-.3.336-.536.636-.636l.693-.231c.23-.077.23-.401 0-.477l-.693-.232c-.3-.1-.536-.335-.636-.636l-.231-.693a.251.251 0 0 0-.477 0Z" })));
}, SplitHorizontal: function(e) {
  return u.createElement("svg", Zf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), C_ || (C_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8Zm-2-4.5V3H3v3.5h10Zm-10 1V11h10V7.5H3Z", clipRule: "evenodd" })));
}, SplitVertical: function(e) {
  return u.createElement("svg", Tf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), M_ || (M_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM7.5 3H3v8h4.5V3Zm1 8H13V3H8.5v8Z", clipRule: "evenodd" })));
}, Stitch: function(e) {
  return u.createElement("svg", Bf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), k_ || (k_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h16v16H0V0Zm14 4V2H2v2h12Zm0 10V5H2v9h12ZM8 6v7H6V6h2Zm5 0v4H9V6h4ZM5 8v5H3V8h2Zm8 3v2H9v-2h4Z" })));
}, String: function(e) {
  return u.createElement("svg", If({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), P_ || (P_ = u.createElement("path", { fill: "currentColor", d: "M10.69 14H5.31l-.15-.137v-.754l.15-.138h.602c.376 0 .753-.342.753-.685V3.5h-.903c-2.05 0-2.54.729-2.671 1.826l-.15.137h-.828L2 5.326l.282-3.189.15-.137h11.135l.15.137L14 5.326l-.113.137h-.827l-.15-.137c-.133-1.097-.622-1.826-2.672-1.826h-.903v8.786c0 .343.377.685.753.685h.602l.15.138v.754l-.15.137Z" })));
}, Support: function(e) {
  return u.createElement("svg", Hf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), S_ || (S_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7a3 3 0 0 1 6 0v2.5c0 1.51-.957 2.798-2.298 3.288a1 1 0 1 0 .265.967 4.512 4.512 0 0 0 2.787-2.785c.08.02.161.03.246.03h.5a2.5 2.5 0 0 0 .406-4.967 5.002 5.002 0 0 0-9.813 0A2.5 2.5 0 0 0 3.5 11H4a1 1 0 0 0 1-1V7Z", clipRule: "evenodd" })));
}, Sweep: function(e) {
  return u.createElement("svg", Df({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), N_ || (N_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 14.465 4 12.734c.292.169.631.266.999.266h2v2H5a3.982 3.982 0 0 1-2-.535ZM9 15v-2h2c.368 0 .707-.097.999-.266L13 14.464A3.982 3.982 0 0 1 11 15H9Zm6-8h-2V5c0-.368-.097-.707-.266-.999L14.464 3c.341.588.536 1.271.536 2v2ZM7 1H5c-.729 0-1.412.195-2 .535L4 3.266C4.293 3.097 4.632 3 5 3h2V1ZM1 9h2v2c0 .368.097.707.266.999L1.536 13A3.982 3.982 0 0 1 1 11V9Zm0-2h2V5c0-.368.097-.707.266-.999L1.536 3A3.982 3.982 0 0 0 1 5v2Zm8-6v2h2c.368 0 .707.097.999.266L13 1.536A3.982 3.982 0 0 0 11 1H9Zm6 8h-2v2c0 .368-.097.707-.266.999L14.464 13c.341-.588.536-1.271.536-2V9Z", clipRule: "evenodd" })));
}, Table: function(e) {
  return u.createElement("svg", zf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), R_ || (R_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3.25C1 2.56 1.56 2 2.25 2h11.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 14 1 13.44 1 12.75v-9.5Zm2 4.12V4h4.37v3.37H3Zm0 1.25V12h4.37V8.62H3ZM8.62 12H13V8.62H8.62V12ZM13 7.37V4H8.62v3.37H13Z", clipRule: "evenodd" })));
}, Tag: function(e) {
  return u.createElement("svg", Ff({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), __ || (__ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m9.707 14.293 4.586-4.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 7.586 2H3a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, ThumbsDown: function(e) {
  return u.createElement("svg", Vf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), A_ || (A_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.019 15c.511 0 .98-.28 1.208-.724l2.501-4.837c.026-.05.05-.102.07-.155.03.003.06.004.092.004h2.094c.561 0 1.016-.441 1.016-.985V3.182C15 2.638 14.545 2 13.984 2H3.993C3.023 2 2.188 2.666 2 3.589L1.04 8.316c-.247 1.217.713 2.35 1.993 2.35H5.32v1.717C5.32 13.828 6.528 15 8.019 15Zm1.84-6.34-2.205 4.265a.642.642 0 0 1-.303-.542v-2.307c0-.762-.637-1.379-1.422-1.379H3.644a.5.5 0 0 1-.49-.6l.758-3.727a.5.5 0 0 1 .49-.4h5.456v4.69Z", clipRule: "evenodd" })));
}, ThumbsUp: function(e) {
  return u.createElement("svg", qf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), L_ || (L_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.981 1c-.511 0-.98.28-1.208.724L4.272 6.56c-.026.05-.05.102-.07.155a1.06 1.06 0 0 0-.092-.004H2.016c-.561 0-1.016.441-1.016.985v5.121C1 13.362 1.455 14 2.016 14h9.991c.97 0 1.805-.665 1.993-1.589l.961-4.727c.248-1.217-.713-2.35-1.993-2.35H10.68V3.616C10.68 2.172 9.472 1 7.981 1Zm-1.84 6.34 2.205-4.265a.642.642 0 0 1 .303.542v2.307c0 .762.637 1.379 1.422 1.379h2.285a.5.5 0 0 1 .49.6l-.758 3.727a.5.5 0 0 1-.49.4H6.142V7.34Z", clipRule: "evenodd" })));
}, TimeSeries: function(e) {
  return u.createElement("svg", Uf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Z_ || (Z_ = u.createElement("path", { fill: "currentColor", d: "M7.023 1.518c.513.024.957.363 1.12.853L9.38 6.108l1.56-2.092a1.24 1.24 0 0 1 1.872-.134l1.897 1.91c.388.39.388 1.023 0 1.413l-.377.354a.99.99 0 0 1-1.405 0l-.86-.89-2.122 2.847a1.239 1.239 0 0 1-2.172-.355L6.798 6.22 6.11 7.774c-.2.451-.644.742-1.135.742H1.994a.997.997 0 0 1-.994-1v-.5c0-.552.445-1 .994-1h2.174l1.66-3.758a1.242 1.242 0 0 1 1.195-.74ZM14 12a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h12Z" })));
}, TimeSeriesCollection: function(e) {
  return u.createElement("svg", Wf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), T_ || (T_ = u.createElement("path", { fill: "currentColor", d: "M13.6 10.383H15c.6 0 1 .499 1 1.098 0 .598-.4.998-1 .998h-.9l-1.5 2.096c-.2.3-.6.499-1 .399-.4-.1-.7-.4-.8-.799l-.4-1.696-.4 1.197c-.1.3-.5.6-.9.6H8c-.6 0-1-.4-1-.999s.4-.998 1-.998h.4l1.4-3.693c.1-.4.6-.599 1-.599s.8.4.9.699l.6 2.794.5-.698c.2-.2.5-.4.8-.4Z" })), B_ || (B_ = u.createElement("path", { fill: "currentColor", d: "M1.929 1A.922.922 0 0 0 1 1.915v9.15c0 .505.416.915.929.915H5.84c.101-.173.225-.336.374-.485.322-.321.71-.526 1.118-.63l1.043-2.75c.208-.678.706-1.086 1.107-1.3A2.846 2.846 0 0 1 10.8 6.49c.682 0 1.214.323 1.531.591.318.269.635.66.792 1.131l.026.079.133.617a2.24 2.24 0 0 1 .318-.023h.4v-5.14a.922.922 0 0 0-.929-.915H7.5a.922.922 0 0 1-.929-.915A.922.922 0 0 0 5.643 1H1.929Z" })), I_ || (I_ = u.createElement("path", { fill: "currentColor", d: "M10.95 8.005a.699.699 0 0 0-.066-.012l.065.012Z" })));
}, Trash: function(e) {
  return u.createElement("svg", Gf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), H_ || (H_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2a1 1 0 0 1 1 1v1H2V3a1 1 0 0 1 1-1h2Zm9 3H2l1.678 8.392A2 2 0 0 0 5.64 15h4.72a2 2 0 0 0 1.962-1.608L14 5Z", clipRule: "evenodd" })));
}, Undo: function(e) {
  return u.createElement("svg", Kf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), D_ || (D_ = u.createElement("path", { fill: "currentColor", d: "M11.981 9.402c.05.328.313.598.645.598h.8c.331 0 .603-.27.57-.6a5.996 5.996 0 0 0-2.543-4.325A5.997 5.997 0 0 0 8.026 4h-.029C5.298 4 3.047 5.718 2.53 8H1.116a.584.584 0 0 0-.383 1.026l2.482 2.15c.22.19.545.19.765 0l2.482-2.15A.584.584 0 0 0 6.079 8H4.632c.47-1.085 1.68-2 3.365-2a3.98 3.98 0 0 1 2.543.89 3.996 3.996 0 0 1 1.441 2.512Z" })));
}, University: function(e) {
  return u.createElement("svg", Yf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), z_ || (z_ = u.createElement("path", { fill: "currentColor", d: "M8.5 4.613c0-.383.191-.74.51-.953a6.87 6.87 0 0 1 2.145-.949l2.406-.601a.353.353 0 0 1 .439.342v7.88c0 .238 0 .357-.043.453a.5.5 0 0 1-.176.211c-.087.06-.204.081-.438.123l-3.9.71c-.324.058-.486.088-.612.042a.5.5 0 0 1-.264-.22c-.067-.116-.067-.28-.067-.61V4.613ZM2 2.452c0-.23.216-.398.439-.342l2.407.601a6.87 6.87 0 0 1 2.144.95c.319.211.51.569.51.952v6.428c0 .33 0 .494-.067.61a.5.5 0 0 1-.264.22c-.126.046-.288.016-.612-.043l-3.9-.709c-.234-.042-.35-.063-.438-.123a.5.5 0 0 1-.176-.21C2 10.688 2 10.57 2 10.331v-7.88ZM2.008 12.41a.5.5 0 0 1 .581-.402l5.143.935c.177.032.359.032.536 0l5.143-.935a.5.5 0 0 1 .178.984l-4.134.752c-.163.434-.753.756-1.455.756-.702 0-1.292-.322-1.455-.756l-4.134-.752a.5.5 0 0 1-.403-.581Z" })));
}, Unlock: function(e) {
  return u.createElement("svg", Xf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), F_ || (F_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.157 4.221A2 2 0 0 1 10 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1V5a4 4 0 0 0-7.822-1.182C3.982 4.45 4.538 5 5.2 5c.442 0 .785-.372.957-.779Zm2.43 6.589A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, Unsorted: function(e) {
  return u.createElement("svg", Qf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), V_ || (V_ = u.createElement("path", { fill: "currentColor", d: "M3.685 1.143c.22-.19.545-.19.765 0l2.482 2.149a.584.584 0 0 1-.383 1.026H5.236v7.364H6.55c.541 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.026h1.312V4.318H1.586a.584.584 0 0 1-.383-1.026l2.482-2.15ZM8 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H9ZM8 11a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" })));
}, UpDownCarets: function(e) {
  return u.createElement("svg", Jf({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), q_ || (q_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.527 1.21a.638.638 0 0 1 .948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562Zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 0 1-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654Z" })));
}, Upload: function(e) {
  return u.createElement("svg", ed({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), U_ || (U_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.297 11v.938a4 4 0 1 0-.764-7.66A5.501 5.501 0 0 0 0 6.5a5.5 5.5 0 0 0 5.797 5.492V11h-.403c-1.395 0-2.08-1.7-1.075-2.667L7.472 5.3a1.55 1.55 0 0 1 2.15 0l3.152 3.034C13.78 9.301 13.094 11 11.7 11h-.402ZM8.339 6.2a.3.3 0 0 1 .416 0l3.152 3.034a.3.3 0 0 1-.208.516h-1.652v3.75a1.5 1.5 0 0 1-3 0V9.75H5.394a.3.3 0 0 1-.208-.516L8.339 6.2Z", clipRule: "evenodd" })));
}, VerticalEllipsis: function(e) {
  return u.createElement("svg", td({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), W_ || (W_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM7.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", clipRule: "evenodd" })));
}, Visibility: function(e) {
  return u.createElement("svg", nd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), G_ || (G_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2.008c3.934 0 6.473 3.129 7.455 4.583l.043.064C15.713 6.97 16 7.391 16 8s-.287 1.03-.502 1.345l-.043.064c-.982 1.454-3.521 4.583-7.455 4.583S1.527 10.863.545 9.41l-.043-.064C.287 9.03 0 8.609 0 8s.287-1.03.502-1.345l.043-.064C1.527 5.137 4.066 2.008 8 2.008ZM9.13 4.13A5.147 5.147 0 0 0 8 4.005C5.75 4.005 3.927 5.794 3.927 8c0 2.206 1.824 3.995 4.073 3.995 2.25 0 4.073-1.789 4.073-3.995 0-2.206-1.824-3.995-4.073-3.995.378 0 .756.045 1.13.126ZM8 10.996c1.687 0 3.055-1.341 3.055-2.996S9.687 5.004 8 5.004 4.945 6.345 4.945 8 6.313 10.996 8 10.996Z", clipRule: "evenodd" })));
}, VisibilityOff: function(e) {
  return u.createElement("svg", rd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), K_ || (K_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.601 1.266a1.03 1.03 0 0 0-1.433.049L1.704 13.486a.987.987 0 0 0 .062 1.407 1.03 1.03 0 0 0 1.433-.049l1.793-1.904A7.348 7.348 0 0 0 8 13.587c3.934 0 6.473-3.133 7.455-4.59l.043-.063c.215-.316.502-.737.502-1.347s-.287-1.03-.502-1.346l-.043-.065a12.85 12.85 0 0 0-1.949-2.275l1.157-1.228a.987.987 0 0 0-.062-1.407Zm-2.93 4.585-.764.81c.096.292.148.603.148.926 0 1.657-1.368 3-3.055 3-.246 0-.485-.028-.714-.082l-.763.81c.458.176.956.272 1.477.272 2.25 0 4.073-1.79 4.073-4 0-.622-.145-1.211-.403-1.736ZM8 1.587c.919 0 1.762.171 2.526.452L8.98 3.68A5.13 5.13 0 0 0 8 3.587c-2.25 0-4.073 1.79-4.073 4 0 .435.07.853.201 1.245l-1.985 2.107A13.06 13.06 0 0 1 .545 8.998l-.043-.064C.287 8.618 0 8.197 0 7.587s.287-1.03.502-1.346l.043-.065C1.527 4.72 4.066 1.587 8 1.587Zm0 2c.327 0 .654.034.978.095l-.016.017A4.155 4.155 0 0 0 8 3.587Zm0 1c.041 0 .083 0 .124.002L4.966 7.942a2.978 2.978 0 0 1-.02-.355c0-1.657 1.367-3 3.054-3Z", clipRule: "evenodd" })));
}, Warning: function(e) {
  return u.createElement("svg", ad({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Y_ || (Y_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.864 1.514a.983.983 0 0 0-1.728 0L1.122 12.539A.987.987 0 0 0 1.986 14h12.028a.987.987 0 0 0 .864-1.461L8.864 1.514ZM7 5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V5Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, Wizard: function(e) {
  return u.createElement("svg", ld({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), X_ || (X_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.327 3.277c.188-.38-.236-.8-.618-.613l-2.513 1.223a.461.461 0 0 1-.523-.095L7.603 1.74c-.314-.313-.829-.062-.75.365l.517 2.808a.421.421 0 0 1-.228.46L4.63 6.596c-.383.186-.277.761.154.839l2.832.513a.477.477 0 0 1 .382.379l.517 2.808c.079.427.659.532.846.153l1.234-2.492a.427.427 0 0 1 .464-.225l2.832.512c.43.078.683-.432.368-.744l-2.07-2.052a.452.452 0 0 1-.095-.519l1.233-2.491ZM7 10.5c.353-.35.312-.958-.091-1.359-.404-.4-1.017-.44-1.37-.09L1.84 12.713c-.353.35-.312.958.092 1.358.403.4 1.017.44 1.37.09L7 10.5Z", clipRule: "evenodd" })));
}, Wrench: function(e) {
  return u.createElement("svg", id({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Q_ || (Q_ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.625 9.75a4.374 4.374 0 0 0 4.206-5.584c-.085-.295-.449-.36-.665-.145l-2.1 2.1a.44.44 0 0 1-.184.11c-.078.024-.157-.013-.215-.07L9.84 4.332c-.058-.058-.095-.137-.071-.215a.44.44 0 0 1 .11-.184l2.1-2.1c.216-.216.147-.58-.145-.664a4.374 4.374 0 0 0-5.385 5.512.32.32 0 0 1-.077.32l-4.828 4.829a1.857 1.857 0 0 0 2.625 2.625l4.828-4.828a.32.32 0 0 1 .323-.075c.412.129.851.197 1.305.197ZM2.75 14.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z", clipRule: "evenodd" })));
}, Write: function(e) {
  return u.createElement("svg", od({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), J_ || (J_ = u.createElement("path", { fill: "currentColor", d: "M8.71 3.75a9.487 9.487 0 0 0-2.335-.28c-2.404 0-4.875.824-4.875 2.563 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.267 0 .546-.013.828-.037a1.76 1.76 0 0 1-.288-1.818 1.826 1.826 0 0 1 1.706-1.125h.09V3.75ZM8.068 9.305c-.578.091-1.158.136-1.693.136-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.22-.086.42-.18.598-.282a1.85 1.85 0 0 1-.209-.141l-2.03-1.594Z" })), eA || (eA = u.createElement("path", { fill: "currentColor", d: "M11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729ZM12.489 2.297v4.576h1.39c.574 0 .84.646.406.986l-2.63 2.063a.668.668 0 0 1-.81 0l-2.63-2.063c-.433-.34-.168-.986.406-.986H9.93V2.297C9.93 1.58 10.502 1 11.21 1c.706 0 1.279.58 1.279 1.297Z" })));
}, X: function(e) {
  return u.createElement("svg", sd({ xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tA || (tA = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.203 3.404a1 1 0 0 0-1.414 0L8.314 5.879 5.839 3.404a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L6.192 8l-2.474 2.475a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l2.475-2.475 2.475 2.475a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L10.435 8l2.475-2.475a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, XWithCircle: function(e) {
  return u.createElement("svg", cd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nA || (nA = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.414-9.828a1 1 0 1 1 1.414 1.414L9.414 8l1.414 1.414a1 1 0 1 1-1.414 1.414L8 9.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L6.586 8 5.172 6.586a1 1 0 0 1 1.414-1.414L8 6.586l1.414-1.414Z", clipRule: "evenodd" })));
} }, hOe = Object.keys(rA).reduce(function(e, t) {
  return e[t] = dOe(t, rA[t]), e;
}, {});
gOe(hOe);
function mOe(e) {
  return b1(e) ? e != null && h2(e) === "object" && "type" in e && e.type.isGlyph === !0 : e != null && typeof e == "function" && "isGlyph" in e && e.isGlyph === !0;
}
var Xue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Xue);
var vOe = Xue.exports;
const bOe = /* @__PURE__ */ ce(vOe);
var Que = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Que);
var yOe = Que.exports;
const wOe = /* @__PURE__ */ ce(yOe);
var Jue = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Jue);
var OOe = Jue.exports;
const xOe = /* @__PURE__ */ ce(OOe);
function EOe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ye(e, t, n) {
  return (t = EOe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nn() {
  return Nn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nn.apply(this, arguments);
}
function gr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function $e(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function $Oe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return aA(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return aA(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function aA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var lA, iA, oA, sA, cA, uA, fA, dA, Zl = v(lA || (lA = $e([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), iy = Ye(Ye({}, W.Body1, v(iA || (iA = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(oA || (oA = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), jOe = Ye(Ye({}, W.Body1, v(sA || (sA = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(cA || (cA = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), M1 = Ye(Ye({}, S.Light, v(uA || (uA = $e([`
    color: `, `;
  `])), b.black)), S.Dark, v(fA || (fA = $e([`
    color: `, `;
  `])), b.gray.light2)), Za = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, COe = ["baseFontSize", "darkMode", "className", "weight", "as"], MOe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = gr(e, COe), h = K(n).theme, g = Za(t), m = ne(f).Component, y = v(dA || (dA = $e([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, Nn({ className: H(Zl, iy[g], M1[h], y, r) }, d));
});
MOe.displayName = "Body";
var pA, gA, hA, mA, vA, bA, yA, wA, OA, xA, kOe = { label: "lg-label", description: "lg-description" };
v(pA || (pA = $e([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Ye(Ye({}, S.Light, v(gA || (gA = $e([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(hA || (hA = $e([`
    color: `, `;
  `])), b.gray.light1));
Ye(Ye({}, S.Light, v(mA || (mA = $e([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(vA || (vA = $e([`
    color: `, `;
  `])), b.gray.dark1));
Ye(Ye({}, W.Body1, v(bA || (bA = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(yA || (yA = $e([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var EA, $A, jA, CA, MA;
Ye(Ye({}, S.Light, v(wA || (wA = $e([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(OA || (OA = $e([`
    color: `, `;
  `])), b.gray.light1));
v(xA || (xA = $e([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var kA, PA, SA, NA, RA, _A, POe = v(EA || (EA = $e([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), SOe = Ye(Ye({}, S.Light, v($A || ($A = $e([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(jA || (jA = $e([`
    color: `, `;
  `])), b.red.light1)), NOe = Ye(Ye({}, W.Body1, v(CA || (CA = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(MA || (MA = $e([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), ROe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = gr(e, ROe), f = K(r).theme, d = Za(), h = ne(n).Component;
  return k.createElement(h, Nn({}, c, { className: H(POe, SOe[f], NOe[d], i) }), l);
});
var _Oe = v(kA || (kA = $e([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), AOe = Ye(Ye({}, S.Light, v(PA || (PA = $e([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(SA || (SA = $e([`
    color: `, `;
  `])), b.gray.light2)), LOe = ["darkMode", "className", "as"], ZOe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = gr(e, LOe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Nn({ className: H(Zl, _Oe, AOe[c], n) }, i));
});
ZOe.displayName = "H1";
var AA, TOe = v(NA || (NA = $e([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), BOe = Ye(Ye({}, S.Light, v(RA || (RA = $e([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(_A || (_A = $e([`
    color: `, `;
  `])), b.gray.light2)), IOe = ["darkMode", "className", "as"], HOe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = gr(e, IOe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Nn({ className: H(Zl, TOe, BOe[c], n) }, i));
});
HOe.displayName = "H2";
var LA, ZA, TA, BA, IA, HA, DA, zA, FA, VA, DOe = v(AA || (AA = $e([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), zOe = ["darkMode", "className", "as"], FOe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = gr(e, zOe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Nn({ className: H(Zl, DOe, M1[c], n) }, i));
});
FOe.displayName = "H3";
var qA, UA, WA, pl = gt(), VOe = v(LA || (LA = $e([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, pl), qOe = Ye(Ye({}, S.Light, v(ZA || (ZA = $e([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, pl, b.gray.light2, b.gray.light1)), S.Dark, v(TA || (TA = $e([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, pl, b.gray.dark2, b.gray.dark1)), UOe = Ye(Ye({}, S.Light, v(BA || (BA = $e([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), pl, it[S.Light].default, b.blue.base)), S.Dark, v(IA || (IA = $e([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), pl, it[S.Dark].default, b.blue.base)), WOe = Ye(Ye({}, S.Light, v(HA || (HA = $e([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(DA || (DA = $e([`
    color: `, `;
  `])), b.blue.light1)), GOe = v(zA || (zA = $e([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), KOe = v(FA || (FA = $e([`
  white-space: nowrap;
`]))), YOe = v(VA || (VA = $e([`
  white-space: normal;
`]))), XOe = ["children", "className", "darkMode", "baseFontSize", "as"], GA = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = gr(e, XOe), g = K(c).theme, m = Za(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? KOe : YOe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(jOe[m], VOe, qOe[g], UOe[g], w, Ye({}, WOe[g], C), i) }, l);
  return C ? k.createElement(y, Nn({ className: H(pl, GOe, i) }, h), E) : k.cloneElement(E, h);
});
GA.displayName = "InlineCode", GA.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var KA, YA, XA, QA, JA, eL, tL;
v(qA || (qA = $e([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Ye(Ye({}, S.Light, v(UA || (UA = $e([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(WA || (WA = $e([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var nL, rL, aL, QOe = v(KA || (KA = $e([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), JOe = Ye(Ye({}, S.Light, v(YA || (YA = $e([`
    color: `, `;
  `])), b.black)), S.Dark, v(XA || (XA = $e([`
    color: `, `;
  `])), b.gray.light2)), exe = Ye(Ye({}, S.Light, v(QA || (QA = $e([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(JA || (JA = $e([`
    color: `, `;
  `])), b.gray.dark1)), txe = Ye(Ye({}, W.Body1, v(eL || (eL = $e([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(tL || (tL = $e([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), nxe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], rxe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? kOe.label : h, m = gr(e, nxe), y = K(n).theme, w = Za(t), C = ne(d).Component;
  return k.createElement(C, Nn({ "data-lgid": g, className: H(QOe, JOe[y], txe[w], Ye({}, exe[y], c), r) }, m), l);
});
rxe.displayName = "Label";
var lL, iL, oL, sL, cL, uL, oy = gt(), e2e = v(nL || (nL = $e([`
  font-family: `, `;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), t2e = Ye(Ye({}, S.Light, v(rL || (rL = $e([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(aL || (aL = $e([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), n2e = function(e) {
  if (e)
    return iy[e];
}, axe = v(lL || (lL = $e([`
  gap: `, `px;
`])), ee[100]), lxe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = gr(e, lxe), d = K(i).theme, h = Za(l), g = nt(c, f, "span").Component;
  return k.createElement(g, Nn({ className: H(oy, e2e, n2e(h), t2e[d], axe, r), ref: t }, f), k.createElement(bOe, { role: "presentation" }), n);
});
var ixe = v(iL || (iL = $e([`
  transform: translate3d(3px, 0, 0);
`]))), oxe = v(oL || (oL = $e([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;

  .`, `:hover & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), oy), sxe = v(sL || (sL = $e([`
  position: relative;
  bottom: 4px;
  left: -1px;
  height: 12px;
`]))), cxe = "hover", uxe = "persist", fL = "none", fxe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? fL : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = gr(e, fxe), y = $Oe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Za(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== fL && (E = k.createElement(wOe, { role: "presentation", size: 12, className: H(Ye(Ye({}, oxe, i === cxe), ixe, i === uxe)) })) : E = k.createElement(xOe, { role: "presentation", className: sxe }), k.createElement(P, Nn({ className: H(oy, e2e, n2e(M), t2e[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var dxe = v(cL || (cL = $e([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), pxe = ["darkMode", "className", "as"], gxe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = gr(e, pxe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Nn({ className: H(Zl, dxe, M1[c], n) }, i));
});
gxe.displayName = "Overline";
var hxe = v(uL || (uL = $e([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), mxe = ["darkMode", "className", "as"], vxe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = gr(e, mxe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Nn({ className: H(Zl, hxe, M1[c], n) }, i));
});
vxe.displayName = "Subtitle";
var dL;
v(dL || (dL = $e([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function bxe(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
var yxe = bxe, wxe = yxe, Xc = Qpe;
function Oxe(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = Xc(n), n = n === n ? n : 0), t !== void 0 && (t = Xc(t), t = t === t ? t : 0), wxe(Xc(e), t, n);
}
var xxe = Oxe;
const pL = /* @__PURE__ */ ce(xxe);
function gL(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ai(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gL(Object(n), !0).forEach(function(r) {
      ji(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gL(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ji(e, t, n) {
  return (t = function(r) {
    var l = function(i, c) {
      if (typeof i != "object" || i === null)
        return i;
      var f = i[Symbol.toPrimitive];
      if (f !== void 0) {
        var d = f.call(i, c || "default");
        if (typeof d != "object")
          return d;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(i);
    }(r, "string");
    return typeof l == "symbol" ? l : String(l);
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ci() {
  return Ci = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ci.apply(this, arguments);
}
function Exe(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function $n(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function $xe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return hL(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return hL(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function hL(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jxe(e) {
  return u.createElement("svg", Ci({ width: 26, height: 8, fill: "#001E2B", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 8" }, e), u.createElement("path", { d: "M27 0H-1v1h.699a10 10 0 017.26 3.123l1.685 1.78a6 6 0 008.712 0l1.686-1.78A10 10 0 0126.302 1H27V0z" }));
}
var mL, vL, bL, yL, wL, OL, xL, Qc, EL, $L, jL, CL, ML, kL, Cxe = 8, yo = 26, Lo = 16, Mxe = v(mL || (mL = $n([`
  margin: unset;
  font-family: `, `;
  color: `, `;
  font-weight: `, `;
  width: 100%;
  overflow-wrap: anywhere;
`])), Q.default, b.gray.light1, Y.regular), kxe = v(vL || (vL = $n([`
  display: flex;
  align-items: center;
  border-radius: `, `px;
  padding: 12px `, `px;
  box-shadow: 0px 2px 4px -1px `, `;
  cursor: default;
  width: fit-content;
  max-width: 256px;
`])), Lo, Lo, $r(0.85, b.black)), PL = v(bL || (bL = $n([`
  position: relative;
`]))), Jc = (ji(Qc = {}, S.Light, { tooltip: v(yL || (yL = $n([`
      background-color: `, `;
      color: `, `;
    `])), b.black, b.gray.light1), children: v(wL || (wL = $n([`
      color: inherit;
    `]))), notchFill: b.black }), ji(Qc, S.Dark, { tooltip: v(OL || (OL = $n([`
      background-color: `, `;
      color: `, `;
    `])), b.gray.light2, b.black), children: v(xL || (xL = $n([`
      color: inherit;
    `]))), notchFill: b.gray.light2 }), Qc), Pxe = yo + 2 * Lo, Sxe = v(EL || (EL = $n([`
  min-height: `, `px;
`])), Pxe), Nxe = v($L || ($L = $n([`
  transition-delay: `, `ms;
`])), It.slowest), ud = { Hover: "hover", Click: "click" }, Zo = { Top: fi.Top, Bottom: fi.Bottom, Left: fi.Left, Right: fi.Right }, Rxe = ["initialOpen", "open", "setOpen", "darkMode", "baseFontSize", "triggerEvent", "enabled", "align", "justify", "spacing", "usePortal", "onClose", "id", "shouldClose", "portalClassName", "portalContainer", "scrollContainer", "popoverZIndex", "refEl", "className", "children", "trigger"], _xe = function(e) {
  e.stopPropagation();
};
function fd(e) {
  var t, n = e.initialOpen, r = n !== void 0 && n, l = e.open, i = e.setOpen, c = e.darkMode, f = e.baseFontSize, d = e.triggerEvent, h = d === void 0 ? ud.Hover : d, g = e.enabled, m = g === void 0 || g, y = e.align, w = y === void 0 ? "top" : y, C = e.justify, E = C === void 0 ? "start" : C, R = e.spacing, M = R === void 0 ? 12 : R, P = e.usePortal, a = P === void 0 || P, o = e.onClose, s = o === void 0 ? function() {
  } : o, p = e.id, O = e.shouldClose, x = e.portalClassName, N = e.portalContainer, T = e.scrollContainer, $ = e.popoverZIndex, j = e.refEl, A = e.className, Z = e.children, G = e.trigger, I = Exe(e, Rxe), F = typeof l == "boolean", U = $xe(ht(r), 2), B = U[0], L = U[1], q = Za(f), D = F ? l : B, _ = F && i ? i : L, re = Dn(null), ue = p ?? ((t = re.current) === null || t === void 0 ? void 0 : t.id), se = Hn({ prefix: "tooltip", id: ue }), Re = K(c), ft = Re.darkMode, Le = Re.theme;
  Tt(function() {
    G && b1(G) && mOe(G) && console.warn("Using a LeafyGreenUI Icon or Glyph component as a trigger will not render a Tooltip, as these components do not render their children. To use, please wrap your trigger element in another HTML tag.");
  }, [G]);
  var Lt = rn(function() {
    (typeof O != "function" || O()) && (s(), _(!1));
  }, [_, O, s]), de = rn(function(an, me) {
    return an === ud.Hover ? { onMouseEnter: Uu(function(He) {
      at("onMouseEnter", He), Rge(function() {
        _(!0);
      });
    }, 35), onMouseLeave: Uu(function(He) {
      at("onMouseLeave", He), Lt();
    }, 35), onFocus: function(He) {
      at("onFocus", He), _(!0);
    }, onBlur: function(He) {
      at("onBlur", He), Lt();
    } } : { onClick: function(He) {
      He.target !== re.current && (at("onClick", He), _(function(ot) {
        return !ot;
      }));
    } };
    function at(He, ot) {
      me && me[He] && typeof me[He] == "function" && me[He](ot);
    }
  }, [Lt, _, re]);
  Jpe(Lt, { enabled: D }), Dse(Lt, [re], D && h === "click");
  var Zt = ai({ refEl: j, popoverZIndex: $ }, a ? { spacing: M, usePortal: a, portalClassName: x, portalContainer: N, scrollContainer: T } : { spacing: M, usePortal: a }), Jt = m && D, Ht = ["left", "right"].includes(w), Zn = k.createElement(q9, Ci({ key: "tooltip", active: Jt, align: w, justify: E, adjustOnMutation: !0, onClick: _xe, className: H(Nxe, ji({}, v(kL || (kL = $n([`
          // Try to fit all the content on one line (until it hits max-width)
          // Overrides default behavior, which is to set width to size of the trigger.
          // Except when justify is set to fit because the width should be the size of the trigger.
          // Another exception is when justify is set to fit and the alignment is either left or right. In this case only the height should be the size of the trigger so we still want the width to fit the max content.
          width: max-content;
        `]))), E !== xn.Fit || E === xn.Fit && (w === Zo.Left || w === Zo.Right))) }, Zt), function(an) {
    var me = function(Dt) {
      var Ut = Dt.align, Kt = Dt.justify, Qn = Dt.triggerRect;
      if (!Ut || !Kt || !Qn)
        return { notchContainer: "", notch: "", tooltip: "" };
      var le, fe, X = yo, J = -(X - Cxe) / 2, oe = {}, ve = {}, Ie = Lo, Pt = 2 * Ie, Vt = 0, Wt = "";
      switch (Ut) {
        case "top":
        case "bottom":
          switch (Pt = 3 * Ie, le = Qn.width / 2 - X / 2, Vt = pL(le, Ie, Pt), fe = le <= Ie, oe.left = "0px", oe.right = "0px", Ut === "top" ? (ve.top = "calc(100% - 1px)", oe.top = "".concat(J, "px")) : (ve.bottom = "calc(100% - 1px)", oe.bottom = "".concat(J, "px"), oe.transform = "rotate(180deg)"), Kt) {
            case xn.Start:
              ve.left = "".concat(Vt, "px"), fe && (Wt = "translateX(-".concat(Ie - le, "px)"));
              break;
            case xn.Middle:
              ve.left = "0px", ve.right = "0px";
              break;
            case xn.Fit:
              ve.left = "".concat(Vt, "px"), fe && (Wt = "translateX(-".concat(Ie - le, "px)"));
              break;
            case xn.End:
              ve.right = "".concat(Vt, "px"), fe && (Wt = "translateX(".concat(Ie - le, "px)"));
          }
          break;
        case "left":
        case "right":
          switch (Pt = 2 * Ie, le = Qn.height / 2 - X / 2, Vt = pL(le, Ie, Pt), fe = le <= Ie, oe.top = "0px", oe.bottom = "0px", Ut === "left" ? (ve.left = "calc(100% - 1px)", oe.left = "".concat(J, "px"), oe.transform = "rotate(-90deg)") : (ve.right = "calc(100% - 1px)", oe.right = "".concat(J, "px"), oe.transform = "rotate(90deg)"), Kt) {
            case xn.Start:
              ve.top = "".concat(Vt, "px"), fe && (Wt = "translateY(-".concat(Ie - le, "px)"));
              break;
            case xn.Middle:
              ve.top = "0px", ve.bottom = "0px";
              break;
            case xn.Fit:
              ve.top = "".concat(Vt, "px"), fe && (Wt = "translateY(-".concat(Ie - le, "px)"));
              break;
            case xn.End:
              ve.bottom = "".concat(Vt, "px"), fe && (Wt = "translateY(".concat(Ie - le, "px)"));
          }
      }
      return { notchContainer: v(jL || (jL = $n([`
      position: absolute;
      width: `, `px;
      height: `, `px;
      overflow: hidden;
      margin: auto;
      pointer-events: none;
      `, `;
    `])), X, X, v(ve)), notch: v(CL || (CL = $n([`
      `, `;
      position: absolute;
      width: `, `px;
      height: `, `px; // Keep it square. Rotating is simpler
      margin: 0;
    `])), v(oe), yo, yo), tooltip: v(ML || (ML = $n([`
      min-width: `, `px;
      transform: `, `;
    `])), 2 * Vt + X, Wt) };
    }({ align: an.align, justify: an.justify, triggerRect: an.referenceElPos }), at = me.notchContainer, He = me.notch, ot = me.tooltip;
    return k.createElement(Fn, { darkMode: !ft }, k.createElement("div", Ci({ role: "tooltip" }, I, { id: se, className: H(kxe, ot, Jc[Le].tooltip, ji({}, Sxe, Ht), A), ref: re }), k.createElement("div", { className: H(Mxe, iy[q], Jc[Le].children) }, Z), k.createElement("div", { className: at }, k.createElement(jxe, { className: H(He), fill: Jc[Le].notchFill }))));
  });
  return G ? typeof G == "function" ? G(ai(ai({}, de(h)), {}, { className: PL, "aria-describedby": Jt ? se : void 0, children: Zn })) : k.cloneElement(G, ai(ai({}, de(h, G.props)), {}, { "aria-describedby": Jt ? se : void 0, children: k.createElement(k.Fragment, null, G.props.children, Zn), className: H(PL, G.props.className) })) : Zn;
}
fd.displayName = "Tooltip", fd.propTypes = { children: z.node, className: z.string, align: z.oneOf(Object.values(Zo)), justify: z.oneOf(Object.values(xn)), trigger: z.oneOfType([z.node, z.func]), triggerEvent: z.oneOf(Object.values(ud)), darkMode: z.bool, enabled: z.bool, open: z.bool, setOpen: z.func, id: z.string, shouldClose: z.func, usePortal: z.bool, portalClassName: z.string };
function Axe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function dd(e) {
  return dd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dd(e);
}
function Va(e, t, n) {
  return (t = Axe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pd() {
  return pd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pd.apply(this, arguments);
}
function r2e(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var SL, gd = { Small: "small", Default: "default", Large: "large", XLarge: "xlarge" }, Lxe = { small: 14, default: 16, large: 20, xlarge: 24 }, Zxe = ["className", "size", "fill", "title", "aria-labelledby", "aria-label", "role"];
function Txe(e, t) {
  var n = function(r) {
    var l, i, c = r.className, f = r.size, d = f === void 0 ? gd.Default : f, h = r.fill, g = r.title, m = r["aria-labelledby"], y = r["aria-label"], w = r.role, C = w === void 0 ? "img" : w, E = r2e(r, Zxe), R = v(SL || (l = [`
      color: `, `;
    `], i || (i = l.slice(0)), SL = Object.freeze(Object.defineProperties(l, { raw: { value: Object.freeze(i) } }))), h), M = typeof d == "number" ? d : Lxe[d];
    return C !== "img" && C !== "presentation" && console.warn("Please provide a valid role to this component. Valid options are 'img' and 'presentation'. If you'd like the Icon to be accessible to screen readers please use 'img', otherwise set the role to 'presentation'."), k.createElement(t, pd({ className: H(Va({}, R, h != null), c), height: M, width: M, role: C }, function(P, a, o) {
      var s, p = o["aria-label"], O = o["aria-labelledby"], x = o.title;
      switch (P) {
        case "img":
          return p || O || x ? Va(Va(Va({}, "aria-labelledby", O), "aria-label", p), "title", x) : { "aria-label": (s = a, "".concat(s.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
        case "presentation":
          return { "aria-hidden": !0, alt: "" };
      }
    }(C, e, Va(Va({ title: g }, "aria-label", y), "aria-labelledby", m)), E));
  };
  return n.displayName = e, n.isGlyph = !0, n.propTypes = { fill: z.string, size: z.oneOfType([z.oneOf(Object.values(gd)), z.number]), className: z.string }, n;
}
var NL, Bxe = ["glyph"];
function Ixe(e) {
  var t = function(n) {
    var r = n.glyph, l = r2e(n, Bxe), i = e[r];
    if (i)
      return k.createElement(i, l);
    var c = Object.keys(e).find(function(f) {
      return Cr(f) === Cr(r);
    });
    return console.error("Error in Icon", 'Could not find glyph named "'.concat(r, '" in the icon set.'), c && 'Did you mean "'.concat(c, '?"')), k.createElement(k.Fragment, null);
  };
  return t.displayName = "Icon", t.isGlyph = !0, t.propTypes = { glyph: z.oneOf(Object.keys(e)).isRequired, size: z.oneOfType([z.oneOf(Object.values(gd)), z.number]) }, t;
}
function hd() {
  return hd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hd.apply(this, arguments);
}
var RL;
function md() {
  return md = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, md.apply(this, arguments);
}
var _L;
function vd() {
  return vd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vd.apply(this, arguments);
}
var AL;
function bd() {
  return bd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bd.apply(this, arguments);
}
var LL;
function yd() {
  return yd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yd.apply(this, arguments);
}
var ZL;
function wd() {
  return wd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wd.apply(this, arguments);
}
var TL;
function Od() {
  return Od = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Od.apply(this, arguments);
}
var BL;
function xd() {
  return xd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xd.apply(this, arguments);
}
var IL;
function Ed() {
  return Ed = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ed.apply(this, arguments);
}
var HL;
function $d() {
  return $d = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $d.apply(this, arguments);
}
var DL;
function jd() {
  return jd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jd.apply(this, arguments);
}
var zL;
function Cd() {
  return Cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cd.apply(this, arguments);
}
var FL;
function Md() {
  return Md = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Md.apply(this, arguments);
}
var VL;
function kd() {
  return kd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kd.apply(this, arguments);
}
var qL, UL;
function Pd() {
  return Pd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pd.apply(this, arguments);
}
var WL, GL, KL;
function Sd() {
  return Sd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sd.apply(this, arguments);
}
var YL, XL;
function Nd() {
  return Nd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nd.apply(this, arguments);
}
var QL, JL;
function Rd() {
  return Rd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rd.apply(this, arguments);
}
var eZ;
function _d() {
  return _d = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _d.apply(this, arguments);
}
var tZ;
function Ad() {
  return Ad = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ad.apply(this, arguments);
}
var nZ;
function Ld() {
  return Ld = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ld.apply(this, arguments);
}
var rZ;
function Zd() {
  return Zd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zd.apply(this, arguments);
}
var aZ;
function Td() {
  return Td = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Td.apply(this, arguments);
}
var lZ;
function Bd() {
  return Bd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bd.apply(this, arguments);
}
var iZ;
function Id() {
  return Id = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Id.apply(this, arguments);
}
var oZ;
function Hd() {
  return Hd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hd.apply(this, arguments);
}
var sZ;
function Dd() {
  return Dd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dd.apply(this, arguments);
}
var cZ;
function zd() {
  return zd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zd.apply(this, arguments);
}
var uZ;
function Fd() {
  return Fd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fd.apply(this, arguments);
}
var fZ;
function Vd() {
  return Vd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vd.apply(this, arguments);
}
var dZ;
function qd() {
  return qd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qd.apply(this, arguments);
}
var pZ, gZ;
function Ud() {
  return Ud = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ud.apply(this, arguments);
}
var hZ, mZ;
function Wd() {
  return Wd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wd.apply(this, arguments);
}
var vZ;
function Gd() {
  return Gd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gd.apply(this, arguments);
}
var bZ;
function Kd() {
  return Kd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kd.apply(this, arguments);
}
var yZ, wZ;
function Yd() {
  return Yd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yd.apply(this, arguments);
}
var OZ;
function Xd() {
  return Xd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xd.apply(this, arguments);
}
var xZ;
function Qd() {
  return Qd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qd.apply(this, arguments);
}
var EZ;
function Jd() {
  return Jd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jd.apply(this, arguments);
}
var $Z;
function ep() {
  return ep = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ep.apply(this, arguments);
}
var jZ;
function tp() {
  return tp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tp.apply(this, arguments);
}
var CZ;
function np() {
  return np = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, np.apply(this, arguments);
}
var MZ;
function rp() {
  return rp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rp.apply(this, arguments);
}
var kZ, PZ, SZ;
function ap() {
  return ap = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ap.apply(this, arguments);
}
var NZ;
function lp() {
  return lp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lp.apply(this, arguments);
}
var RZ;
function ip() {
  return ip = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ip.apply(this, arguments);
}
var _Z;
function op() {
  return op = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, op.apply(this, arguments);
}
var AZ;
function sp() {
  return sp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sp.apply(this, arguments);
}
var LZ;
function cp() {
  return cp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cp.apply(this, arguments);
}
var ZZ;
function up() {
  return up = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, up.apply(this, arguments);
}
var TZ;
function fp() {
  return fp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fp.apply(this, arguments);
}
var BZ;
function dp() {
  return dp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dp.apply(this, arguments);
}
var IZ, HZ;
function pp() {
  return pp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pp.apply(this, arguments);
}
var DZ;
function gp() {
  return gp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gp.apply(this, arguments);
}
var zZ, FZ;
function hp() {
  return hp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hp.apply(this, arguments);
}
var VZ;
function mp() {
  return mp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mp.apply(this, arguments);
}
var qZ;
function vp() {
  return vp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vp.apply(this, arguments);
}
var UZ, WZ;
function bp() {
  return bp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bp.apply(this, arguments);
}
var GZ;
function yp() {
  return yp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yp.apply(this, arguments);
}
var KZ;
function wp() {
  return wp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wp.apply(this, arguments);
}
var YZ;
function Op() {
  return Op = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Op.apply(this, arguments);
}
var XZ;
function xp() {
  return xp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xp.apply(this, arguments);
}
var QZ;
function Ep() {
  return Ep = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ep.apply(this, arguments);
}
var JZ;
function $p() {
  return $p = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $p.apply(this, arguments);
}
var eT, tT;
function jp() {
  return jp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jp.apply(this, arguments);
}
var nT;
function Cp() {
  return Cp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cp.apply(this, arguments);
}
var rT;
function Mp() {
  return Mp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mp.apply(this, arguments);
}
var aT, lT;
function kp() {
  return kp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kp.apply(this, arguments);
}
var iT;
function Pp() {
  return Pp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pp.apply(this, arguments);
}
var oT, sT;
function Sp() {
  return Sp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sp.apply(this, arguments);
}
var cT;
function Np() {
  return Np = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Np.apply(this, arguments);
}
var uT;
function Rp() {
  return Rp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rp.apply(this, arguments);
}
var fT, dT;
function _p() {
  return _p = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _p.apply(this, arguments);
}
var pT, gT;
function Ap() {
  return Ap = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ap.apply(this, arguments);
}
var hT;
function Lp() {
  return Lp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lp.apply(this, arguments);
}
var mT, vT;
function Zp() {
  return Zp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zp.apply(this, arguments);
}
var bT;
function Tp() {
  return Tp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tp.apply(this, arguments);
}
var yT, wT;
function Bp() {
  return Bp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bp.apply(this, arguments);
}
var OT;
function Ip() {
  return Ip = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ip.apply(this, arguments);
}
var xT;
function Hp() {
  return Hp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hp.apply(this, arguments);
}
var ET, $T;
function Dp() {
  return Dp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dp.apply(this, arguments);
}
var jT, CT;
function zp() {
  return zp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zp.apply(this, arguments);
}
var MT;
function Fp() {
  return Fp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fp.apply(this, arguments);
}
var kT;
function Vp() {
  return Vp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vp.apply(this, arguments);
}
var PT;
function qp() {
  return qp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qp.apply(this, arguments);
}
var ST;
function Up() {
  return Up = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Up.apply(this, arguments);
}
var NT;
function Wp() {
  return Wp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wp.apply(this, arguments);
}
var RT, _T;
function Gp() {
  return Gp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gp.apply(this, arguments);
}
var AT;
function Kp() {
  return Kp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kp.apply(this, arguments);
}
var LT, ZT;
function Yp() {
  return Yp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yp.apply(this, arguments);
}
var TT, BT;
function Xp() {
  return Xp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xp.apply(this, arguments);
}
var IT;
function Qp() {
  return Qp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qp.apply(this, arguments);
}
var HT;
function Jp() {
  return Jp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jp.apply(this, arguments);
}
var DT, zT;
function eg() {
  return eg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, eg.apply(this, arguments);
}
var FT, VT;
function tg() {
  return tg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tg.apply(this, arguments);
}
var qT;
function ng() {
  return ng = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ng.apply(this, arguments);
}
var UT, WT;
function rg() {
  return rg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rg.apply(this, arguments);
}
var GT;
function ag() {
  return ag = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ag.apply(this, arguments);
}
var KT, YT;
function lg() {
  return lg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lg.apply(this, arguments);
}
var XT;
function ig() {
  return ig = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ig.apply(this, arguments);
}
var QT;
function og() {
  return og = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, og.apply(this, arguments);
}
var JT;
function sg() {
  return sg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sg.apply(this, arguments);
}
var eB;
function cg() {
  return cg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cg.apply(this, arguments);
}
var tB;
function ug() {
  return ug = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ug.apply(this, arguments);
}
var nB, rB;
function fg() {
  return fg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fg.apply(this, arguments);
}
var aB;
function dg() {
  return dg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dg.apply(this, arguments);
}
var lB, iB;
function pg() {
  return pg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pg.apply(this, arguments);
}
var oB, sB;
function gg() {
  return gg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gg.apply(this, arguments);
}
var cB;
function hg() {
  return hg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hg.apply(this, arguments);
}
var uB;
function mg() {
  return mg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mg.apply(this, arguments);
}
var fB;
function vg() {
  return vg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vg.apply(this, arguments);
}
var dB;
function bg() {
  return bg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bg.apply(this, arguments);
}
var pB;
function yg() {
  return yg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yg.apply(this, arguments);
}
var gB;
function wg() {
  return wg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wg.apply(this, arguments);
}
var hB, mB;
function Og() {
  return Og = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Og.apply(this, arguments);
}
var vB, bB, yB;
function xg() {
  return xg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xg.apply(this, arguments);
}
var wB, OB;
function Eg() {
  return Eg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Eg.apply(this, arguments);
}
var xB;
function $g() {
  return $g = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $g.apply(this, arguments);
}
var EB;
function jg() {
  return jg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jg.apply(this, arguments);
}
var $B;
function Cg() {
  return Cg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cg.apply(this, arguments);
}
var jB;
function Mg() {
  return Mg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mg.apply(this, arguments);
}
var CB;
function kg() {
  return kg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kg.apply(this, arguments);
}
var MB;
function Pg() {
  return Pg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pg.apply(this, arguments);
}
var kB;
function Sg() {
  return Sg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sg.apply(this, arguments);
}
var PB;
function Ng() {
  return Ng = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ng.apply(this, arguments);
}
var SB;
function Rg() {
  return Rg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rg.apply(this, arguments);
}
var NB;
function _g() {
  return _g = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _g.apply(this, arguments);
}
var RB;
function Ag() {
  return Ag = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ag.apply(this, arguments);
}
var _B;
function Lg() {
  return Lg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lg.apply(this, arguments);
}
var AB;
function Zg() {
  return Zg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zg.apply(this, arguments);
}
var LB;
function Tg() {
  return Tg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tg.apply(this, arguments);
}
var ZB;
function Bg() {
  return Bg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bg.apply(this, arguments);
}
var TB;
function Ig() {
  return Ig = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ig.apply(this, arguments);
}
var BB;
function Hg() {
  return Hg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hg.apply(this, arguments);
}
var IB;
function Dg() {
  return Dg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dg.apply(this, arguments);
}
var HB;
function zg() {
  return zg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zg.apply(this, arguments);
}
var DB, zB, FB;
function Fg() {
  return Fg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fg.apply(this, arguments);
}
var VB;
function Vg() {
  return Vg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vg.apply(this, arguments);
}
var qB;
function qg() {
  return qg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qg.apply(this, arguments);
}
var UB;
function Ug() {
  return Ug = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ug.apply(this, arguments);
}
var WB;
function Wg() {
  return Wg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wg.apply(this, arguments);
}
var GB;
function Gg() {
  return Gg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gg.apply(this, arguments);
}
var KB;
function Kg() {
  return Kg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kg.apply(this, arguments);
}
var YB;
function Yg() {
  return Yg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yg.apply(this, arguments);
}
var XB;
function Xg() {
  return Xg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xg.apply(this, arguments);
}
var QB;
function Qg() {
  return Qg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qg.apply(this, arguments);
}
var JB;
function Jg() {
  return Jg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jg.apply(this, arguments);
}
var eI;
function eh() {
  return eh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, eh.apply(this, arguments);
}
var tI;
function th() {
  return th = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, th.apply(this, arguments);
}
var nI;
function nh() {
  return nh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nh.apply(this, arguments);
}
var rI, aI;
function rh() {
  return rh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rh.apply(this, arguments);
}
var lI;
function ah() {
  return ah = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ah.apply(this, arguments);
}
var iI;
function lh() {
  return lh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lh.apply(this, arguments);
}
var oI = { ActivityFeed: function(e) {
  return u.createElement("svg", hd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NL || (NL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 13V7h4.5A1.5 1.5 0 0 0 7 5.5V1h2a2 2 0 0 1 2 2v4.515a2.5 2.5 0 0 0-2.612 1.602l-1.06 2.808A2.501 2.501 0 0 0 5.59 15H3a2 2 0 0 1-2-2ZM4.914 1h.92v3.833a1 1 0 0 1-1 1H1v-.919a1 1 0 0 1 .293-.707L2.5 3l1.707-1.707A1 1 0 0 1 4.914 1ZM10.8 9.003a1 1 0 0 1 .904.784l.61 2.792.508-.714a1 1 0 0 1 .814-.42H15a1 1 0 0 1 0 2h-.848l-1.519 2.135a1 1 0 0 1-1.792-.367l-.371-1.701-.444 1.175a1 1 0 0 1-.935.646H8a1 1 0 1 1 0-2h.4l1.392-3.686a1 1 0 0 1 1.008-.644Z", clipRule: "evenodd" })));
}, AddFile: function(e) {
  return u.createElement("svg", md({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RL || (RL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 7v6a2 2 0 0 0 2 2h5.968a2.25 2.25 0 0 1 .794-4.238A2.251 2.251 0 0 1 11 8.984V3a2 2 0 0 0-2-2H7v4.5A1.5 1.5 0 0 1 5.5 7H1Zm8 6a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0-1 1ZM5.833 1h-.919a1 1 0 0 0-.707.293L2.5 3 1.293 4.207A1 1 0 0 0 1 4.914v.92h3.833a1 1 0 0 0 1-1V1Z", clipRule: "evenodd" })));
}, AllProducts: function(e) {
  return u.createElement("svg", vd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _L || (_L = u.createElement("path", { fill: "currentColor", d: "M2.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM6.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 2.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM2.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM7.5 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM10.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM3.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM6.5 11.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" })));
}, Apps: function(e) {
  return u.createElement("svg", bd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AL || (AL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3H3v4h4V3Zm0 6H3v4h4V9Zm2-6h4v4H9V3Zm4 6H9v4h4V9Z", clipRule: "evenodd" })));
}, Array: function(e) {
  return u.createElement("svg", yd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LL || (LL = u.createElement("path", { fill: "currentColor", d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V3h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM13.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12V3H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4Z" })));
}, ArrowDown: function(e) {
  return u.createElement("svg", wd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZL || (ZL = u.createElement("path", { fill: "currentColor", d: "M9.168 3v6.944l1.535-1.535a1 1 0 0 1 1.414 0l.239.24a1 1 0 0 1 0 1.414l-3.383 3.382c-.008.01-.017.018-.026.027l-.239.24a1 1 0 0 1-1.414 0L3.643 10.06a1 1 0 0 1 0-1.414l.239-.239a1 1 0 0 1 1.414 0L6.83 9.941V3a1 1 0 0 1 1-1h.338a1 1 0 0 1 1 1Z" })));
}, ArrowLeft: function(e) {
  return u.createElement("svg", Od({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TL || (TL = u.createElement("path", { fill: "currentColor", d: "M13 6.832H6.056L7.59 5.297a1 1 0 0 0 0-1.414l-.24-.239a1 1 0 0 0-1.414 0L2.555 7.027c-.01.008-.018.017-.027.026l-.24.239a1 1 0 0 0 0 1.414l3.652 3.651a1 1 0 0 0 1.414 0l.239-.239a1 1 0 0 0 0-1.414L6.059 9.17H13a1 1 0 0 0 1-1v-.338a1 1 0 0 0-1-1Z" })));
}, ArrowRight: function(e) {
  return u.createElement("svg", xd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BL || (BL = u.createElement("path", { fill: "currentColor", d: "M3 6.832h6.944L8.41 5.297a1 1 0 0 1 0-1.414l.24-.239a1 1 0 0 1 1.414 0l3.382 3.383c.01.008.018.017.027.026l.24.239a1 1 0 0 1 0 1.414l-3.652 3.651a1 1 0 0 1-1.414 0l-.239-.239a1 1 0 0 1 0-1.414L9.941 9.17H3a1 1 0 0 1-1-1v-.338a1 1 0 0 1 1-1Z" })));
}, ArrowUp: function(e) {
  return u.createElement("svg", Ed({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IL || (IL = u.createElement("path", { fill: "currentColor", d: "M9.168 13V6.056l1.535 1.535a1 1 0 0 0 1.414 0l.239-.24a1 1 0 0 0 0-1.414L8.973 2.555a1.023 1.023 0 0 0-.026-.027l-.239-.24a1 1 0 0 0-1.414 0L3.643 5.94a1 1 0 0 0 0 1.414l.239.239a1 1 0 0 0 1.414 0L6.83 6.059V13a1 1 0 0 0 1 1h.338a1 1 0 0 0 1-1Z" })));
}, Beaker: function(e) {
  return u.createElement("svg", $d({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HL || (HL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.953 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C6.333 1 6.473 1 6.753 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219C9.573 3 9.433 3 9.153 3h-2.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219c-.054-.107-.054-.247-.054-.527v-.4Zm.056 2.47c-.056.108-.056.25-.056.535V6l-3.007 5.412c-.663 1.193-.994 1.79-.932 2.277a1.5 1.5 0 0 0 .6 1.02C3.01 15 3.693 15 5.057 15h5.791c1.365 0 2.047 0 2.444-.291a1.5 1.5 0 0 0 .6-1.02c.062-.488-.27-1.084-.932-2.277L9.953 6V4.805c0-.285 0-.427-.056-.535a.5.5 0 0 0-.214-.214C9.575 4 9.433 4 9.148 4h-2.39c-.285 0-.427 0-.536.056a.5.5 0 0 0-.213.214ZM9.333 9l-3.03.5-1.287 2.31c-.218.392-.327.588-.309.748a.5.5 0 0 0 .205.348c.13.094.355.094.802.094h4.48c.447 0 .67 0 .801-.094a.5.5 0 0 0 .205-.348c.019-.16-.09-.355-.307-.746L9.333 9Z", clipRule: "evenodd" })));
}, Bell: function(e) {
  return u.createElement("svg", jd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DL || (DL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.625 6.138a4.656 4.656 0 0 0-3.268-3.925C9.228 1.52 8.67 1 8 1c-.67 0-1.228.52-1.357 1.213a4.656 4.656 0 0 0-3.268 3.925l-.452 3.963h.026a.95.95 0 0 0 0 1.899h10.102a.95.95 0 0 0 0-1.899h.026l-.452-3.963ZM8 15a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z", clipRule: "evenodd" })));
}, Biometric: function(e) {
  return u.createElement("svg", Cd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zL || (zL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 1A5.5 5.5 0 0 0 2 6.5v3A5.5 5.5 0 0 0 7.5 15h1A5.5 5.5 0 0 0 14 9.5v-3A5.5 5.5 0 0 0 8.5 1h-1Zm1.074 6.75a.574.574 0 1 0-1.148 0v2.457a.574.574 0 0 0 1.148 0V7.75ZM8 5.338A2.412 2.412 0 0 0 5.588 7.75v2.566a.994.994 0 0 1-.291.704.574.574 0 1 0 .812.812c.402-.402.628-.947.628-1.516V7.75a1.264 1.264 0 1 1 2.527 0v2.648c0 .412-.233.79-.602.973a.574.574 0 0 0 .514 1.028 2.237 2.237 0 0 0 1.236-2V7.75A2.412 2.412 0 0 0 8 5.338ZM4.899 7.75A3.101 3.101 0 0 1 9.64 5.117a.574.574 0 1 0 .609-.974A4.25 4.25 0 0 0 3.75 7.75v2.297a.574.574 0 1 0 1.149 0V7.75Zm6.887-1.932a.574.574 0 1 0-1.023.522c.216.423.338.901.338 1.41v1.378a.574.574 0 1 0 1.149 0V7.75c0-.695-.167-1.352-.464-1.932Z", clipRule: "evenodd" })));
}, Boolean: function(e) {
  return u.createElement("svg", Md({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FL || (FL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm4 6a4 4 0 0 1-4 4V4a4 4 0 0 1 4 4Z", clipRule: "evenodd" })));
}, Building: function(e) {
  return u.createElement("svg", kd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VL || (VL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v13H6v-2H4v2H1v-4h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1V5h4.5a.5.5 0 0 0 0-1H1V2Zm8 9h4.5a.5.5 0 0 0 0-1H9V8h4.5a.5.5 0 0 0 0-1H9V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10h-2v-2h-2v2H9v-4Z", clipRule: "evenodd" })));
}, Bulb: function(e) {
  return u.createElement("svg", Pd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qL || (qL = u.createElement("path", { fill: "currentColor", d: "M12.331 8.5a5 5 0 1 0-8.612.086L5.408 11.5a1 1 0 0 0 .866.499H6.5V6a1.5 1.5 0 1 1 3 0v6h.224a1 1 0 0 0 .863-.496L12.34 8.5h-.009Z" })), UL || (UL = u.createElement("path", { fill: "currentColor", d: "M7.5 6v6h1V6a.5.5 0 0 0-1 0ZM10 14v-1H6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z" })));
}, Calendar: function(e) {
  return u.createElement("svg", Sd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WL || (WL = u.createElement("path", { fill: "currentColor", d: "M4 2a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0V2Z" })), GL || (GL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 3H7a2 2 0 1 1-4 0 2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 2 2 0 1 1-4 0Zm3 4H9v3h3V7Z", clipRule: "evenodd" })), KL || (KL = u.createElement("path", { fill: "currentColor", d: "M10 3a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1Z" })));
}, Camera: function(e) {
  return u.createElement("svg", Nd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YL || (YL = u.createElement("path", { fill: "currentColor", d: "M10.25 8.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })), XL || (XL = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.585 3.33a1.5 1.5 0 0 1 1.342-.83h4.146a1.5 1.5 0 0 1 1.342.83l.309.617a1 1 0 0 0 .894.553h.882A1.5 1.5 0 0 1 15 6v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V6a1.5 1.5 0 0 1 1.5-1.5h.882a1 1 0 0 0 .894-.553l.31-.618ZM11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", clipRule: "evenodd" })));
}, Cap: function(e) {
  return u.createElement("svg", Rd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QL || (QL = u.createElement("path", { fill: "currentColor", d: "M2.97 8.008v2.3l.001.092-.002.262c0 1.926 2.535 2.838 5 2.838 2.466 0 5-.912 5-2.838 0-.085 0-.168-.002-.25.002-.035.002-.07.002-.105V8.001L8.706 9.787a2 2 0 0 1-1.554-.004L2.969 8.008Z" })), JL || (JL = u.createElement("path", { fill: "currentColor", d: "M7.565 2.583a1 1 0 0 1 .794-.002l6.35 2.732a.5.5 0 0 1-.004.92L8.35 8.896a1 1 0 0 1-.778-.001L1.305 6.233a.5.5 0 0 1-.005-.919l6.265-2.73ZM13.97 7.626v1.477a1 1 0 1 0 1 0V7.207l-1 .419Z" })));
}, CaretDown: function(e) {
  return u.createElement("svg", _d({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eZ || (eZ = u.createElement("path", { fill: "currentColor", d: "M8.679 10.796a.554.554 0 0 1-.858 0L4.64 6.976C4.32 6.594 4.582 6 5.069 6h6.362c.487 0 .748.594.43.976l-3.182 3.82Z" })));
}, CaretLeft: function(e) {
  return u.createElement("svg", Ad({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tZ || (tZ = u.createElement("path", { fill: "currentColor", d: "M5.204 8.679a.553.553 0 0 1 0-.858l3.82-3.181c.382-.319.976-.058.976.429v6.362c0 .487-.594.748-.976.43l-3.82-3.182Z" })));
}, CaretRight: function(e) {
  return u.createElement("svg", Ld({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nZ || (nZ = u.createElement("path", { fill: "currentColor", d: "M10.796 7.321a.554.554 0 0 1 0 .858l-3.82 3.181c-.382.319-.976.058-.976-.429V4.57c0-.487.594-.748.976-.43l3.82 3.182Z" })));
}, CaretUp: function(e) {
  return u.createElement("svg", Zd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rZ || (rZ = u.createElement("path", { fill: "currentColor", d: "M7.321 5.204a.553.553 0 0 1 .858 0l3.181 3.82c.319.382.058.976-.429.976H4.57c-.487 0-.748-.594-.43-.976l3.182-3.82Z" })));
}, ChartFilled: function(e) {
  return u.createElement("svg", Td({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aZ || (aZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H3Zm8.25 2a.75.75 0 0 0-.75.75v6.25H12V5.25a.75.75 0 0 0-.75-.75ZM7.5 7.25a.75.75 0 0 1 1.5 0v4.25H7.5V7.25ZM5.25 9a.75.75 0 0 0-.75.75v1.75H6V9.75A.75.75 0 0 0 5.25 9Z", clipRule: "evenodd" })));
}, Charts: function(e) {
  return u.createElement("svg", Bd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lZ || (lZ = u.createElement("path", { fill: "currentColor", d: "M11.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10ZM7.5 14a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1ZM2.5 14a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1Z" })));
}, Checkmark: function(e) {
  return u.createElement("svg", Id({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iZ || (iZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.306 9.05 5.455-5.455a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-7.067 7.068a1 1 0 0 1-1.5-.098l-3.049-3.97a1 1 0 0 1 .184-1.402l.595-.457a1.25 1.25 0 0 1 1.753.23L6.306 9.05Z", clipRule: "evenodd" })));
}, CheckmarkWithCircle: function(e) {
  return u.createElement("svg", Hd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oZ || (oZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.448-10.104a.997.997 0 1 1 1.508 1.306l-4.572 5.28a1 1 0 0 1-1.64-.07l-1.82-2.868a1 1 0 1 1 1.69-1.07l1.1 1.734 3.734-4.312Z", clipRule: "evenodd" })));
}, ChevronDown: function(e) {
  return u.createElement("svg", Dd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sZ || (sZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.636 5.364a1 1 0 0 0 0 1.414l4.95 4.95.707.707a1 1 0 0 0 1.414 0l.707-.707 4.95-4.95a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L8 8.899 3.757 4.657a1 1 0 0 0-1.414 0l-.707.707Z", clipRule: "evenodd" })));
}, ChevronLeft: function(e) {
  return u.createElement("svg", zd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cZ || (cZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.778 1.636a1 1 0 0 0-1.414 0l-4.95 4.95-.707.707a1 1 0 0 0 0 1.414l.707.707 4.95 4.95a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L7.243 8l4.242-4.243a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, ChevronRight: function(e) {
  return u.createElement("svg", Fd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uZ || (uZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.364 14.364a1 1 0 0 0 1.414 0l4.95-4.95.707-.707a1 1 0 0 0 0-1.414l-.707-.707-4.95-4.95a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L8.899 8l-4.242 4.243a1 1 0 0 0 0 1.414l.707.707Z", clipRule: "evenodd" })));
}, ChevronUp: function(e) {
  return u.createElement("svg", Vd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fZ || (fZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.364 10.778a1 1 0 0 0 0-1.414l-4.95-4.95-.707-.707a1 1 0 0 0-1.414 0l-.707.707-4.95 4.95a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0L8 7.243l4.243 4.242a1 1 0 0 0 1.414 0l.707-.707Z", clipRule: "evenodd" })));
}, Clock: function(e) {
  return u.createElement("svg", qd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dZ || (dZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.25a.75.75 0 0 1 1.5 0v3.16l1.744 1.526a.75.75 0 0 1-.988 1.128L7.511 8.818a.761.761 0 0 1-.19-.25.747.747 0 0 1-.071-.318v-3.5Z", clipRule: "evenodd" })));
}, ClockWithArrow: function(e) {
  return u.createElement("svg", Ud({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pZ || (pZ = u.createElement("path", { fill: "currentColor", d: "M13 8a5 5 0 0 1-7.304 4.438c-.348-.18-.787-.13-1.038.172l-.33.398c-.276.33-.22.828.152 1.044a7 7 0 1 0-1.452-10.98L1.97 2.146a.584.584 0 0 0-.964.521l.455 3.252c.04.287.285.51.576.511H5.32a.58.58 0 0 0 .387-1.018l-1.168-1.02A5 5 0 0 1 13 8Z" })), gZ || (gZ = u.createElement("path", { fill: "currentColor", d: "M7.25 5.25a.75.75 0 0 1 1.5 0v2.668l1.68 1.524a.75.75 0 1 1-.988 1.129L7.507 8.815a.758.758 0 0 1-.257-.565v-3Z" })));
}, Clone: function(e) {
  return u.createElement("svg", Wd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hZ || (hZ = u.createElement("path", { fill: "currentColor", d: "M5.5 12a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v4Z" })), mZ || (mZ = u.createElement("path", { fill: "currentColor", d: "M4.25 10H3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.75h-2V4h-5v4h.75v2Z" })));
}, Cloud: function(e) {
  return u.createElement("svg", Gd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vZ || (vZ = u.createElement("path", { fill: "currentColor", d: "M12.571 8.143c0 1.775-.899 3.34-2.267 4.264l-.014.01a5.12 5.12 0 0 1-2.861.869H2.857a2.857 2.857 0 0 1-.545-5.663 5.144 5.144 0 0 1 10.26.52ZM13.821 8.143a6.38 6.38 0 0 1-2.358 4.96 3.429 3.429 0 1 0 2.17-6.506c.123.494.188 1.013.188 1.546Z" })));
}, Code: function(e) {
  return u.createElement("svg", Kd({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bZ || (bZ = u.createElement("path", { fill: "currentColor", d: "M6.11 13.262a.5.5 0 0 0 .395.586l.737.143a.5.5 0 0 0 .585-.396L9.926 2.738a.5.5 0 0 0-.396-.586l-.737-.143a.5.5 0 0 0-.585.396L6.109 13.262ZM1.36 7.246 3.976 5.11a.507.507 0 0 1 .704.063l.64.752a.483.483 0 0 1-.064.69L3.562 7.998 5.256 9.38c.212.173.24.482.064.69l-.64.752a.507.507 0 0 1-.704.062L1.36 8.75A.971.971 0 0 1 1 7.998c0-.29.132-.566.36-.752ZM14.636 7.246 12.02 5.11a.507.507 0 0 0-.704.063l-.64.752a.483.483 0 0 0 .064.69l1.694 1.382L10.74 9.38a.483.483 0 0 0-.064.69l.64.752a.507.507 0 0 0 .704.062l2.616-2.134a.971.971 0 0 0 .36-.752.971.971 0 0 0-.36-.752Z" })));
}, CodeBlock: function(e) {
  return u.createElement("svg", Yd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yZ || (yZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4H3v8h10V4ZM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Z", clipRule: "evenodd" })), wZ || (wZ = u.createElement("path", { fill: "currentColor", d: "M4.221 7.421 6.256 5.78a.398.398 0 0 1 .548.048l.498.578a.368.368 0 0 1-.05.53L5.934 8l1.318 1.063c.165.133.187.37.05.53l-.498.58a.398.398 0 0 1-.548.047L4.221 8.58A.744.744 0 0 1 3.941 8c0-.224.103-.436.28-.579ZM11.779 7.421 9.744 5.78a.398.398 0 0 0-.548.048l-.498.578a.368.368 0 0 0 .05.53L10.066 8 8.748 9.063a.368.368 0 0 0-.05.53l.498.58c.138.159.383.18.548.047l2.035-1.641a.744.744 0 0 0 .28-.579.744.744 0 0 0-.28-.579Z" })));
}, Colon: function(e) {
  return u.createElement("svg", Xd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), OZ || (OZ = u.createElement("path", { fill: "currentColor", d: "M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
}, Connect: function(e) {
  return u.createElement("svg", Qd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xZ || (xZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.867 8.898a4.048 4.048 0 0 0 .687-4.8l1.275-1.275a.584.584 0 0 0 0-.826l-.826-.826a.584.584 0 0 0-.826 0l-1.29 1.29a4.048 4.048 0 0 0-4.734.722L5.277 5.058a.323.323 0 0 0-.041.035L3.182 7.148a4.048 4.048 0 0 0-.72 4.738l-1.29 1.29a.584.584 0 0 0 0 .827l.825.826a.584.584 0 0 0 .826 0l1.278-1.278a4.048 4.048 0 0 0 4.795-.689l1.876-1.875a.324.324 0 0 0 .041-.035l2.054-2.054ZM6.561 6.776 4.685 8.65a1.916 1.916 0 0 0 0 2.707c.747.746 1.961.747 2.707 0l2.055-2.054a.321.321 0 0 1 .04-.035l1.877-1.875a1.916 1.916 0 0 0 0-2.707 1.916 1.916 0 0 0-2.707 0L6.602 6.74a.32.32 0 0 1-.04.035Z", clipRule: "evenodd" })));
}, Copy: function(e) {
  return u.createElement("svg", Jd({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EZ || (EZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 5.714v4.572C1 11.233 1.768 12 2.714 12H5.75V7.11c0-.566.227-1.108.63-1.504l2.294-2.252c.1-.099.21-.186.326-.262v-.378C9 1.768 8.232 1 7.286 1H5.8v3.429c0 .71-.576 1.285-1.286 1.285H1Zm8-.928L7.257 6.498A.857.857 0 0 0 7 7.11v.688h3.01a.857.857 0 0 0 .857-.858V4h-.717a.857.857 0 0 0-.6.246l-.55.54ZM4.867 1H4.15a.857.857 0 0 0-.601.246L1.257 3.498A.857.857 0 0 0 1 4.11v.688h3.01a.857.857 0 0 0 .857-.858V1ZM7 12V8.714H10.514c.71 0 1.286-.575 1.286-1.285V4h1.486C14.233 4 15 4.768 15 5.714v7.572c0 .947-.768 1.714-1.714 1.714H8.714A1.714 1.714 0 0 1 7 13.286V12Z", clipRule: "evenodd" })));
}, CreditCard: function(e) {
  return u.createElement("svg", ep({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $Z || ($Z = u.createElement("path", { fill: "currentColor", d: "M3 3a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2H3ZM15 7H1v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7Z" })));
}, CurlyBraces: function(e) {
  return u.createElement("svg", tp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jZ || (jZ = u.createElement("path", { fill: "currentColor", d: "M3 3.544a2.5 2.5 0 0 1 2.5-2.5h1a.5.5 0 0 1 .5.5v1.105a.353.353 0 0 1-.353.353h-.79A.858.858 0 0 0 5 3.86v2.802a1.5 1.5 0 0 1-.816 1.335A1.5 1.5 0 0 1 5 9.332v2.803c0 .473.384.857.858.857h.789c.195 0 .353.158.353.353v1.105a.5.5 0 0 1-.5.5h-1a2.5 2.5 0 0 1-2.5-2.5v-1.956a1.5 1.5 0 0 0-1.5-1.5.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-1.95ZM13 12.45a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1-.5-.5v-1.105c0-.195.158-.353.353-.353h.79a.858.858 0 0 0 .857-.858V9.332a1.5 1.5 0 0 1 .816-1.335A1.5 1.5 0 0 1 11 6.662V3.859a.858.858 0 0 0-.858-.857h-.789A.353.353 0 0 1 9 2.65V1.544a.5.5 0 0 1 .5-.5h1a2.5 2.5 0 0 1 2.5 2.5V5.5A1.5 1.5 0 0 0 14.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0-1.5 1.5v1.95Z" })));
}, Cursor: function(e) {
  return u.createElement("svg", np({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CZ || (CZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m8.534 8.534.473-.27 2.389-1.366-6.748-2.25 2.25 6.748 1.366-2.389.27-.473ZM10 10l4.48-2.563c.734-.333.678-1.393-.086-1.648L3.169 2.047A.887.887 0 0 0 2.047 3.17l3.742 11.225c.255.764 1.315.82 1.648.086L10 10Z", clipRule: "evenodd" })));
}, Dashboard: function(e) {
  return u.createElement("svg", rp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MZ || (MZ = u.createElement("path", { fill: "currentColor", d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6ZM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6ZM7 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3ZM2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z" })));
}, Database: function(e) {
  return u.createElement("svg", ap({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kZ || (kZ = u.createElement("path", { fill: "currentColor", d: "M13.5 4.452c0 .09 0 .177-.002.262l.002.094v.23c0 .3-.136.588-.433.87-.302.289-.75.548-1.305.765-1.11.434-2.541.656-3.762.656-1.22 0-2.652-.222-3.762-.656-.555-.217-1.003-.476-1.305-.764-.297-.283-.433-.571-.433-.872v-.229c0-.035 0-.07.002-.105a12.886 12.886 0 0 1-.002-.251C2.5 2.517 5.288 1.6 8 1.6s5.5.917 5.5 2.852Z" })), PZ || (PZ = u.createElement("path", { fill: "currentColor", d: "M2.5 6.747v1.957c0 .3.136.589.433.871.302.288.75.548 1.305.765 1.11.433 2.541.656 3.762.656 1.22 0 2.652-.223 3.762-.656.555-.217 1.003-.477 1.305-.765.297-.282.433-.57.433-.87V6.746c-.392.318-.88.575-1.405.78-1.236.483-2.784.719-4.095.719-1.31 0-2.859-.236-4.095-.72-.525-.204-1.013-.461-1.405-.779Z" })), SZ || (SZ = u.createElement("path", { fill: "currentColor", d: "M12.095 11.194c.525-.205 1.013-.462 1.405-.78v.811c0 .035 0 .07-.002.105l.002.251c0 1.936-2.788 2.852-5.5 2.852s-5.5-.916-5.5-2.852c0-.088 0-.176.002-.262a2.322 2.322 0 0 1-.002-.094v-.811c.392.318.88.575 1.405.78 1.236.483 2.784.718 4.095.718 1.31 0 2.859-.235 4.095-.719Z" })));
}, Diagram: function(e) {
  return u.createElement("svg", lp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NZ || (NZ = u.createElement("path", { fill: "currentColor", d: "M6 2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H8.5v2h4.75a.75.75 0 0 1 .75.75V10h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H13V8H8.5v2H9a.75.75 0 0 1 .75.75v1.5A.75.75 0 0 1 9 13H7a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 7 10h.5V8H3v2h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H2V7.75A.75.75 0 0 1 2.75 7H7.5V5h-.75A.75.75 0 0 1 6 4.25v-1.5Z" })));
}, Diagram2: function(e) {
  return u.createElement("svg", ip({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RZ || (RZ = u.createElement("path", { fill: "currentColor", d: "M10.72 1c-.398 0-.72.336-.72.75V2H7.48a.49.49 0 0 0-.48.5V7H5v-.25C5 6.336 4.678 6 4.28 6H1.72c-.398 0-.72.336-.72.75v1.5c0 .414.322.75.72.75h2.56c.398 0 .72-.336.72-.75V8h2v4.5c0 .276.215.5.48.5H10v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V12H8V8h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V7H8V3h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06Z" })));
}, Diagram3: function(e) {
  return u.createElement("svg", op({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), _Z || (_Z = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.75 1a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 5 3.25v-1.5A.75.75 0 0 0 4.25 1h-2.5Zm9.25.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm0 9a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm-10 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5ZM6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z", clipRule: "evenodd" })));
}, Disconnect: function(e) {
  return u.createElement("svg", sp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AZ || (AZ = u.createElement("path", { fill: "currentColor", d: "M7.093 3.671a.317.317 0 0 1 0-.448L8.14 2.175a4.024 4.024 0 0 1 5.685 0 4.024 4.024 0 0 1 0 5.685l-1.048 1.047a.317.317 0 0 1-.448 0L11.28 7.86a.317.317 0 0 1 0-.449l1.048-1.047a1.906 1.906 0 0 0 0-2.693 1.906 1.906 0 0 0-2.693 0L8.59 4.718a.317.317 0 0 1-.449 0L7.093 3.671ZM1.293 1.293a1.001 1.001 0 0 1 1.416 0l11.998 11.998a1.001 1.001 0 0 1-1.416 1.416l-3.159-3.16-2.272 2.277a4.024 4.024 0 0 1-5.685 0 4.024 4.024 0 0 1 0-5.684l2.273-2.277L1.293 2.71a1.001 1.001 0 0 1 0-1.416Zm4.65 6.066L3.672 9.636a1.906 1.906 0 0 0 0 2.693c.743.742 1.95.742 2.693 0l2.272-2.277-2.692-2.693Z" })));
}, Download: function(e) {
  return u.createElement("svg", cp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LZ || (LZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.524 2.575v5.557h1.712c.706 0 1.033.783.5 1.196l-3.237 2.506a.832.832 0 0 1-.998 0L4.265 9.328c-.534-.413-.207-1.196.499-1.196h1.611V2.575a1.575 1.575 0 0 1 3.15 0ZM2.5 11h1.8l2.405 1.862a2.132 2.132 0 0 0 2.59 0L11.7 11h1.8a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3Z", clipRule: "evenodd" })));
}, Drag: function(e) {
  return u.createElement("svg", up({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZZ || (ZZ = u.createElement("path", { fill: "currentColor", d: "M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
}, Edit: function(e) {
  return u.createElement("svg", fp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TZ || (TZ = u.createElement("path", { fill: "currentColor", d: "M10.922.681a.963.963 0 0 1 1.362 0l1.363 1.363a.963.963 0 0 1 0 1.362L12.284 4.77 9.56 2.044 8.538 3.066l2.724 2.725-7.153 7.153-3.747 1.022 1.022-3.747L10.922.68Z" })));
}, Ellipsis: function(e) {
  return u.createElement("svg", dp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BZ || (BZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6.75 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", clipRule: "evenodd" })));
}, Email: function(e) {
  return u.createElement("svg", pp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IZ || (IZ = u.createElement("path", { fill: "currentColor", d: "m2.494 4 4.714 5.05a1.068 1.068 0 0 0 1.584 0L13.505 4H2.494ZM1.133 4.256A2.12 2.12 0 0 0 1 5v6c0 .369.093.715.256 1.011L4.814 8.2l-3.68-3.944Z" })), HZ || (HZ = u.createElement("path", { fill: "currentColor", d: "M2.867 13c-.348 0-.674-.102-.953-.28l3.56-3.813 1.219 1.306a1.78 1.78 0 0 0 2.64 0l1.346-1.443 3.575 3.83c-.313.251-.7.4-1.12.4H2.866ZM14.84 11.813c.103-.248.16-.523.16-.813V5c0-.255-.045-.5-.126-.724l-3.535 3.787 3.5 3.75Z" })));
}, Escalation: function(e) {
  return u.createElement("svg", gp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DZ || (DZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.361 4.423a.556.556 0 0 0-.26-.97L5.146 2.009a.556.556 0 0 0-.636.69l1.787 6.672a.556.556 0 0 0 .896.28l6.168-5.228ZM2.911 2.102a.556.556 0 0 0-.392.68l3.163 11.806a.556.556 0 1 0 1.074-.287L3.592 2.493a.556.556 0 0 0-.68-.392Z", clipRule: "evenodd" })));
}, Export: function(e) {
  return u.createElement("svg", hp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zZ || (zZ = u.createElement("path", { fill: "currentColor", d: "M14.623 5.186a.278.278 0 0 0 0-.385l-2.805-2.915a.277.277 0 0 0-.477.192v1.424A6.5 6.5 0 0 0 5 10v.1a1.5 1.5 0 0 0 3 0V10a3.5 3.5 0 0 1 3.34-3.496v1.405c0 .25.305.373.478.193l2.805-2.916Z" })), FZ || (FZ = u.createElement("path", { fill: "currentColor", d: "M6.5 3.879a.75.75 0 0 0-.75-.75H4a2 2 0 0 0-2 2v6.864a2 2 0 0 0 2 2h6.864a2 2 0 0 0 2-2V10.05a.75.75 0 0 0-1.5 0v1.943a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V5.129a.5.5 0 0 1 .5-.5h1.75a.75.75 0 0 0 .75-.75Z" })));
}, Favorite: function(e) {
  return u.createElement("svg", mp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VZ || (VZ = u.createElement("path", { fill: "currentColor", d: "M7.538 1.11a.5.5 0 0 1 .924 0l1.537 3.696a.5.5 0 0 0 .421.306l3.99.32a.5.5 0 0 1 .285.878l-3.04 2.604a.5.5 0 0 0-.16.496l.928 3.893a.5.5 0 0 1-.747.542L8.261 11.76a.5.5 0 0 0-.522 0l-3.415 2.086a.5.5 0 0 1-.747-.542l.928-3.893a.5.5 0 0 0-.16-.496L1.304 6.31a.5.5 0 0 1 .285-.878l3.99-.32A.5.5 0 0 0 6 4.806L7.538 1.11Z" })));
}, Federation: function(e) {
  return u.createElement("svg", vp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qZ || (qZ = u.createElement("path", { fill: "currentColor", d: "M8 0c1.6 0 2.8 1.3 2.8 3 0 1.5-1 2.7-2.3 3v2.1l3.1 2.4c.4-.3 1-.5 1.5-.5 1.6 0 2.8 1.3 2.8 3s-1.3 3-2.8 3c-1.6 0-2.8-1.3-2.8-3 0-.7.2-1.3.6-1.8L8 9l-2.9 2.2c.4.5.6 1.1.6 1.8 0 1.7-1.3 3-2.8 3C1.4 16 0 14.7 0 13s1.3-3 2.8-3c.6 0 1.1.2 1.5.5l3.1-2.4V5.9C6.2 5.7 5.2 4.5 5.2 3c0-1.7 1.2-3 2.8-3Zm0 5c.8 0 1.9-.8 1.9-2C9.9 1.9 9 1 8 1c-1 0-1.9.9-1.9 2 0 1.2 1 2 1.9 2Zm-5.2 6c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.8-2-1.9-2Zm10.4 0c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.9-2-1.9-2Z" })));
}, File: function(e) {
  return u.createElement("svg", bp({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UZ || (UZ = u.createElement("path", { fill: "currentColor", d: "M3 13V7h4.5A1.5 1.5 0 0 0 9 5.5V1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" })), WZ || (WZ = u.createElement("path", { fill: "currentColor", d: "M7.833 1h-.919a1 1 0 0 0-.707.293L3.293 4.207A1 1 0 0 0 3 4.914v.92h3.833a1 1 0 0 0 1-1V1Z" })));
}, Filter: function(e) {
  return u.createElement("svg", yp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GZ || (GZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 6.148-3.8-3.94C1.797 1.79 2.044 1 2.576 1h10.848c.532 0 .779.79.377 1.208L10 6.148v5.625a.5.5 0 0 1-.17.376l-3 2.625a.5.5 0 0 1-.83-.376v-8.25Z", clipRule: "evenodd" })));
}, FullScreenEnter: function(e) {
  return u.createElement("svg", Op({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YZ || (YZ = u.createElement("path", { fill: "currentColor", d: "M1.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM15 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM1.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM14.5 14a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, FullScreenExit: function(e) {
  return u.createElement("svg", xp({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XZ || (XZ = u.createElement("path", { fill: "currentColor", d: "M10.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM6 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM10.5 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM5.5 7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, Folder: function(e) {
  return u.createElement("svg", wp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KZ || (KZ = u.createElement("path", { fill: "currentColor", d: "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1 1 1 0 0 0-1-1H2Z" })));
}, Gauge: function(e) {
  return u.createElement("svg", Ep({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QZ || (QZ = u.createElement("path", { fill: "currentColor", d: "M1.041 10.251c-.044.412.296.749.71.749h2.494c.414 0 .74-.34.843-.742A3.006 3.006 0 0 1 8.791 8.1l2.99-2.991a7 7 0 0 0-10.74 5.142ZM13.297 6.422l-2.842 2.842c.213.3.368.638.459.994.102.401.429.742.843.742h2.494c.414 0 .754-.337.71-.749a7.001 7.001 0 0 0-1.664-3.829Z" })));
}, GlobeAmericas: function(e) {
  return u.createElement("svg", $p({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JZ || (JZ = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-5.301 4.699A4.73 4.73 0 0 1 5 11.683V10L3.257 8.257A4.75 4.75 0 0 1 8 3.25V4.5L6.5 6v1l-.5.5-.5-.5-1 1 .5.5h2.5L8 9v1l-1 1 1.699 1.699Zm4.047-4.496a4.73 4.73 0 0 0-.924-3.025L10.5 6.5V9h1.25l.996-.797Z", clipRule: "evenodd" })));
}, GovernmentBuilding: function(e) {
  return u.createElement("svg", jp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eT || (eT = u.createElement("path", { fill: "currentColor", d: "M11 5V4a3 3 0 0 0-6 0v1h6Z" })), tT || (tT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 6a.5.5 0 0 0 0 1H2v6h-.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H14V7h.5a.5.5 0 0 0 0-1h-13Zm3 2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3ZM8 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 8Zm2.5.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z", clipRule: "evenodd" })));
}, Hash: function(e) {
  return u.createElement("svg", Cp({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nT || (nT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.616 1.5a.5.5 0 0 0-.492.413L9.668 4.5h-2.47l.426-2.413A.5.5 0 0 0 7.13 1.5H6.116a.5.5 0 0 0-.492.413L5.168 4.5H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.815l-.53 3H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.933l-.425 2.413A.5.5 0 0 0 4 14.5h1.016a.5.5 0 0 0 .492-.413l.456-2.587h2.47l-.426 2.413a.5.5 0 0 0 .492.587h1.016a.5.5 0 0 0 .492-.413l.456-2.587H13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.683l.529-3H13.5A.5.5 0 0 0 14 6V5a.5.5 0 0 0-.5-.5h-1.802l.426-2.413a.5.5 0 0 0-.492-.587h-1.016Zm-4.3 8h2.47l.529-3h-2.47l-.528 3Z", clipRule: "evenodd" })));
}, Highlight: function(e) {
  return u.createElement("svg", Mp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rT || (rT = u.createElement("path", { fill: "currentColor", d: "M8.853 12.031A.1.1 0 0 1 8.926 12h5.824a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25H7.231a.1.1 0 0 1-.072-.168l1.694-1.8ZM4.019 9.193l.375-.374L7.576 12l-.375.375a1 1 0 0 1-.779.29l-.574-.04a1 1 0 0 0-.778.29l-.141.14-1.591-1.59.141-.142a1 1 0 0 0 .29-.778l-.04-.573a1 1 0 0 1 .29-.779ZM11.433 1.779a1 1 0 0 1 1.415 0l1.767 1.768a1 1 0 0 1 0 1.414L8.28 11.296 5.098 8.114l6.335-6.335ZM2.632 12.167l1.593 1.593-.17.172a.25.25 0 0 1-.178.074H1.386a.25.25 0 0 1-.176-.428l1.422-1.41Z" })));
}, Home: function(e) {
  return u.createElement("svg", kp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aT || (aT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.687 1.751a.5.5 0 0 1 .626 0l6.433 5.164a.5.5 0 0 1 .069.713l-.644.761a.5.5 0 0 1-.697.065L8.316 4.257a.5.5 0 0 0-.632 0L2.526 8.454a.5.5 0 0 1-.697-.065l-.644-.76a.5.5 0 0 1 .07-.714l6.432-5.164Z", clipRule: "evenodd" })), lT || (lT = u.createElement("path", { fill: "currentColor", d: "M7.688 5.25a.5.5 0 0 1 .624 0l4.5 3.6a.5.5 0 0 1 .188.39v4.26a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9.24a.5.5 0 0 1 .188-.39l4.5-3.6Z" })));
}, HorizontalDrag: function(e) {
  return u.createElement("svg", Pp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iT || (iT = u.createElement("path", { fill: "currentColor", d: "M4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" })));
}, Import: function(e) {
  return u.createElement("svg", Sp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oT || (oT = u.createElement("path", { fill: "currentColor", d: "M11.623 8.799a.278.278 0 0 0 0-.385L8.818 5.498a.277.277 0 0 0-.477.193v1.405A3.5 3.5 0 0 1 5 3.6v-.1a1.5 1.5 0 1 0-3 0v.1a6.5 6.5 0 0 0 6.34 6.498v1.424c0 .25.305.372.478.192L11.623 8.8Z" })), sT || (sT = u.createElement("path", { fill: "currentColor", d: "M3.95 11a.75.75 0 0 1 1.5 0v1.75a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V5.886a.5.5 0 0 0-.5-.5h-1.943a.75.75 0 0 1 0-1.5h1.943a2 2 0 0 1 2 2v6.864a2 2 0 0 1-2 2H5.95a2 2 0 0 1-2-2V11Z" })));
}, ImportantWithCircle: function(e) {
  return u.createElement("svg", Np({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cT || (cT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 4.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, InfoWithCircle: function(e) {
  return u.createElement("svg", Rp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uT || (uT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 0 1 1 1v4h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7h-.5a.5.5 0 0 1 0-1H8Z", clipRule: "evenodd" })));
}, InternalEmployee: function(e) {
  return u.createElement("svg", _p({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fT || (fT = u.createElement("path", { fill: "currentColor", d: "M6.5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h8.774l-.003-.05-.03-.022s-2.834-2.213-1.27-5.622c-.263-.055-.56.005-.814.144A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), dT || (dT = u.createElement("path", { fill: "currentColor", d: "M12.746 7.003c-.36-.448-.672-.903-.736-.998a.016.016 0 0 0-.023 0c-.063.095-.373.55-.732.998-3.084 4.137.486 6.925.486 6.925l.03.021c.026.431.093 1.051.093 1.051h.266s.067-.617.093-1.05l.03-.025c.004.003 3.577-2.785.493-6.922ZM12 13.87s-.16-.144-.203-.217v-.007l.193-4.505c0-.014.02-.014.02 0l.193 4.505v.007a1.522 1.522 0 0 1-.203.217Z" })));
}, InviteUser: function(e) {
  return u.createElement("svg", Ap({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pT || (pT = u.createElement("path", { fill: "currentColor", d: "M8.418 7.428a3.5 3.5 0 1 0-3.836-5.856 3.5 3.5 0 0 0 3.836 5.856ZM3.091 8.562c.308-.357.838-.339 1.252-.112.64.35 1.375.55 2.157.55s1.517-.2 2.157-.55c.414-.227.944-.245 1.252.112.11.128.214.263.31.403A1.996 1.996 0 0 0 9.5 10.5 2 2 0 0 0 8.177 14H2v-2.5c0-1.123.411-2.15 1.091-2.938Z" })), gT || (gT = u.createElement("path", { fill: "currentColor", d: "M10.5 10.5a.998.998 0 0 1 1-1 1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1Z" })));
}, Key: function(e) {
  return u.createElement("svg", Lp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hT || (hT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.015 10.03c.652 0 1.267-.155 1.811-.43l1.512 1.51-.921.921a.669.669 0 0 0 0 .946l.827.827a.669.669 0 0 0 .946 0l.92-.92.75.749a1.254 1.254 0 0 0 1.773-1.773L9.599 7.827a4.015 4.015 0 1 0-3.584 2.204Zm-.753-3.513a1.255 1.255 0 1 0 0-2.51 1.255 1.255 0 0 0 0 2.51Z", clipRule: "evenodd" })));
}, Laptop: function(e) {
  return u.createElement("svg", Zp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mT || (mT = u.createElement("path", { fill: "currentColor", d: "M5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 6ZM5.5 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })), vT || (vT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a1 1 0 0 0-1 1v7.813l-.29.49a.91.91 0 0 0-.068.1L1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.642-1.096a.901.901 0 0 0-.067-.1L14 11.313V3.5a1 1 0 0 0-1-1H3ZM12.5 4h-9v6.5h9V4Z", clipRule: "evenodd" })));
}, LightningBolt: function(e) {
  return u.createElement("svg", Tp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bT || (bT = u.createElement("path", { fill: "currentColor", d: "M9.223 1.993c0-.497-.66-.68-.922-.256l-4.227 6.85a.493.493 0 0 0 .423.75h2.28v4.67c0 .497.66.68.921.257l4.228-6.852a.492.492 0 0 0-.424-.75h-2.28V1.993Z" })));
}, Link: function(e) {
  return u.createElement("svg", Bp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yT || (yT = u.createElement("path", { fill: "currentColor", d: "M6.039 9.953a3.596 3.596 0 0 1-.327-.38l1.45-1.445a1.553 1.553 0 0 0 2.496.423l2.885-2.87a1.57 1.57 0 0 0 .01-2.213 1.553 1.553 0 0 0-2.203-.01l-.379.377A.995.995 0 0 1 8.56 3.83a1.005 1.005 0 0 1 .006-1.418l.38-.377a3.542 3.542 0 0 1 5.024.023 3.58 3.58 0 0 1-.022 5.047l-2.884 2.871a3.542 3.542 0 0 1-5.025-.022Z" })), wT || (wT = u.createElement("path", { fill: "currentColor", d: "M9.961 6.047c.12.12.228.248.327.38l-1.45 1.445a1.553 1.553 0 0 0-2.496-.423l-2.885 2.87a1.57 1.57 0 0 0-.01 2.213 1.553 1.553 0 0 0 2.203.01l.379-.377a.995.995 0 0 1 1.411.006 1.005 1.005 0 0 1-.006 1.418l-.38.377a3.542 3.542 0 0 1-5.024-.023 3.58 3.58 0 0 1 .022-5.047l2.884-2.871a3.542 3.542 0 0 1 5.025.022Z" })));
}, List: function(e) {
  return u.createElement("svg", Ip({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), OT || (OT = u.createElement("path", { fill: "currentColor", d: "M3.125 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.125 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.875 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM6.625 3a1 1 0 0 0 0 2h6.5a1 1 0 1 0 0-2h-6.5ZM5.625 8a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1ZM6.625 11a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2h-6.5Z" })));
}, Lock: function(e) {
  return u.createElement("svg", Hp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xT || (xT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7V5a4 4 0 1 1 8 0v2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm2-2a2 2 0 1 1 4 0v2H6V5Zm2.587 5.81A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, LogIn: function(e) {
  return u.createElement("svg", Dp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ET || (ET = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3a1 1 0 0 1 1-1h4.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H3v8h3.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H2a1 1 0 0 1-1-1V3Z", clipRule: "evenodd" })), $T || ($T = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.495 4.116 6.293 7.318a1 1 0 0 0 0 1.414l3.202 3.202a.75.75 0 0 0 1.06 0l.354-.353a.75.75 0 0 0 0-1.061L9.389 9h4.861a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75H9.44l1.469-1.47a.75.75 0 0 0 0-1.06l-.354-.354a.75.75 0 0 0-1.06 0Z", clipRule: "evenodd" })));
}, LogOut: function(e) {
  return u.createElement("svg", zp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jT || (jT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 3c0-.552.446-1 .995-1h4.23c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75H3.49v8h3.235c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75h-4.23a.998.998 0 0 1-.995-1V3Z", clipRule: "evenodd" })), CT || (CT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11.022 11.909 3.187-3.202a1.003 1.003 0 0 0 0-1.414L11.022 4.09a.744.744 0 0 0-1.056 0l-.352.354a.753.753 0 0 0 0 1.06l1.513 1.52H6.29a.748.748 0 0 0-.746.75v.5c0 .414.334.75.746.75h4.788l-1.463 1.47a.753.753 0 0 0 0 1.06l.352.354a.744.744 0 0 0 1.056 0Z", clipRule: "evenodd" })));
}, MagnifyingGlass: function(e) {
  return u.createElement("svg", Fp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MT || (MT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.323 9.819a5.302 5.302 0 0 0 6.463.805l4.144 4.144a1.3 1.3 0 1 0 1.838-1.838l-4.144-4.144a5.302 5.302 0 0 0-8.3-6.463 5.3 5.3 0 0 0 0 7.496ZM7.98 4.162A2.7 2.7 0 1 1 4.162 7.98 2.7 2.7 0 0 1 7.98 4.162Z", clipRule: "evenodd" })));
}, Megaphone: function(e) {
  return u.createElement("svg", Vp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kT || (kT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 3 5.725-1.636A1 1 0 0 1 13 2.326v7.348a1 1 0 0 1-1.275.962L6 9H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3Zm-.657 7H3v5h2.98a1 1 0 0 0 .918-1.396L5.343 10ZM16 6a2 2 0 0 1-2 2V4a2 2 0 0 1 2 2Z", clipRule: "evenodd" })));
}, Menu: function(e) {
  return u.createElement("svg", qp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PT || (PT = u.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
}, Minus: function(e) {
  return u.createElement("svg", Up({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ST || (ST = u.createElement("path", { fill: "currentColor", d: "M3 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3Z" })));
}, Mobile: function(e) {
  return u.createElement("svg", Wp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NT || (NT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H5v10h6V3ZM5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z", clipRule: "evenodd" })));
}, MultiDirectionArrow: function(e) {
  return u.createElement("svg", Gp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RT || (RT = u.createElement("path", { fill: "currentColor", d: "M5 8.573v4.854c0 .53-.608.774-.928.374L2.13 11.374a.607.607 0 0 1 0-.748l1.943-2.427c.32-.4.928-.155.928.374Z" })), _T || (_T = u.createElement("path", { fill: "currentColor", d: "M5 10h7.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5v-2ZM11 7.427V2.573c0-.53.608-.775.928-.374l1.943 2.427a.607.607 0 0 1 0 .748l-1.943 2.427c-.32.4-.928.155-.928-.374ZM3 4.5a.5.5 0 0 1 .5-.5H11v2H3.5a.5.5 0 0 1-.5-.5v-1Z" })));
}, MultiLayers: function(e) {
  return u.createElement("svg", Kp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AT || (AT = u.createElement("path", { fill: "currentColor", d: "m12.431 9.745-.26-.121.26-.122a1.99 1.99 0 0 0 .758-.597c.197-.252.311-.576.311-.9 0-.324-.114-.637-.311-.9a2.073 2.073 0 0 0-.758-.597l-.29-.142.217-.101c.301-.142.571-.344.758-.597.197-.253.311-.577.311-.9 0-.324-.114-.638-.311-.9a2.073 2.073 0 0 0-.758-.598L9.194 1.763A2.9 2.9 0 0 0 7.97 1.5c-.415 0-.84.08-1.225.263L3.57 3.27c-.301.142-.57.344-.758.597a1.483 1.483 0 0 0-.311.9c0 .324.114.638.311.901.197.253.457.455.758.597l.29.142-.217.1c-.301.142-.571.345-.758.598a1.483 1.483 0 0 0-.311.9c0 .324.114.637.311.9.197.253.457.456.758.597l.259.122-.26.121c-.3.142-.57.344-.757.597a1.484 1.484 0 0 0-.311.9c0 .324.114.638.311.9.197.254.457.456.758.598l3.165 1.497c.384.182.809.263 1.224.263.415 0 .84-.08 1.225-.263l3.165-1.497c.3-.142.57-.344.757-.597.197-.253.312-.577.312-.9 0-.324-.114-.638-.312-.901a2.073 2.073 0 0 0-.757-.597h.01Zm-4.39 3.248c-.207 0-.404-.04-.54-.112l-3.164-1.497c-.114-.05-.166-.111-.187-.132l.02-.02.167-.111 1.36-.637 1.13.536c.384.182.81.263 1.225.263.415 0 .84-.081 1.224-.263l1.132-.536 1.359.637c.114.05.166.111.187.131l-.021.02-.166.112-3.165 1.497a1.28 1.28 0 0 1-.54.112h-.02ZM4.14 8.005l.02-.02.166-.111 1.318-.628 1.1.516c.384.182.81.263 1.225.263.415 0 .84-.08 1.224-.263l1.173-.556 1.39.657c.115.051.167.112.187.132l-.02.02-.166.111-3.165 1.498a1.28 1.28 0 0 1-.54.111c-.208 0-.405-.04-.54-.111L4.347 8.126c-.114-.05-.166-.11-.187-.131l-.02.01Zm-.073-3.237.02-.02.167-.112L7.419 3.14a1.28 1.28 0 0 1 .54-.111c.207 0 .404.04.54.11l3.164 1.498c.114.05.166.111.187.132l-.02.02-.167.111-3.165 1.497a1.28 1.28 0 0 1-.54.112c-.207 0-.404-.04-.54-.112L4.255 4.9c-.114-.05-.166-.111-.187-.131Z" })));
}, NavCollapse: function(e) {
  return u.createElement("svg", Yp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LT || (LT = u.createElement("path", { fill: "currentColor", d: "M11.39 4.818a.5.5 0 0 0-.708 0L7.854 7.646a.5.5 0 0 0 0 .708l2.828 2.828a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L9.62 8l2.122-2.121a.5.5 0 0 0 0-.707l-.354-.354Z" })), ZT || (ZT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm1 1.5H4A1.5 1.5 0 0 0 2.5 4v8A1.5 1.5 0 0 0 4 13.5h1v-11Zm1.5 0v11H12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 12 2.5H6.5Z", clipRule: "evenodd" })));
}, NavExpand: function(e) {
  return u.createElement("svg", Xp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TT || (TT = u.createElement("path", { fill: "currentColor", d: "M4.61 4.818a.5.5 0 0 1 .708 0l2.828 2.828a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L6.38 8 4.257 5.879a.5.5 0 0 1 0-.707l.354-.354Z" })), BT || (BT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8Zm-1 1.5h1A1.5 1.5 0 0 1 13.5 4v8a1.5 1.5 0 0 1-1.5 1.5h-1v-11Zm-1.5 0v11H4A1.5 1.5 0 0 1 2.5 12V4A1.5 1.5 0 0 1 4 2.5h5.5Z", clipRule: "evenodd" })));
}, NoFilter: function(e) {
  return u.createElement("svg", Qp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IT || (IT = u.createElement("path", { fill: "currentColor", d: "M2.606 1.204a1 1 0 0 0-1.313 1.503L7 8.414v5.984a.5.5 0 0 0 .83.376l2.949-2.58 2.512 2.511a1 1 0 0 0 1.414-1.414l-1.818-1.818-.006.006L2.606 1.204ZM10.573 7.15A.25.25 0 0 0 11 6.972v-.825l3.8-3.94C15.202 1.79 14.957 1 14.425 1H5.027a.25.25 0 0 0-.176.427l5.722 5.722Z" })));
}, NotAllowed: function(e) {
  return u.createElement("svg", Jp({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HT || (HT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.75 8a3.75 3.75 0 0 1-5.485 3.326l5.06-5.06c.272.518.425 1.108.425 1.734ZM4.674 9.735l5.06-5.06a3.75 3.75 0 0 0-5.06 5.06ZM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z", clipRule: "evenodd" })));
}, Note: function(e) {
  return u.createElement("svg", eg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DT || (DT = u.createElement("path", { fill: "currentColor", d: "M4.5 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM4.5 8.75A.75.75 0 0 1 5.25 8h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" })), zT || (zT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m15 10-4 4H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6Zm-2-6H3v8h7v-2a1 1 0 0 1 1-1h2V4Z", clipRule: "evenodd" })));
}, OpenNewTab: function(e) {
  return u.createElement("svg", tg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FT || (FT = u.createElement("path", { fill: "currentColor", d: "M13.823 2.45a.278.278 0 0 0-.272-.273l-4.045-.079a.277.277 0 0 0-.201.474l1.08 1.08-2.45 2.452a1.395 1.395 0 0 0-.148.174L5.999 8.065a1.369 1.369 0 1 0 1.936 1.936l1.787-1.788c.061-.043.12-.093.174-.147l2.451-2.452 1.081 1.081a.277.277 0 0 0 .474-.201l-.079-4.045Z" })), VT || (VT = u.createElement("path", { fill: "currentColor", d: "M7.25 3.129a.75.75 0 0 1 0 1.5H4a.5.5 0 0 0-.5.5v6.864a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0v3.243a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.129a2 2 0 0 1 2-2h3.25Z" })));
}, Pause: function(e) {
  return u.createElement("svg", ng({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qT || (qT = u.createElement("path", { fill: "currentColor", d: "M4.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1ZM10.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1Z" })));
}, Person: function(e) {
  return u.createElement("svg", rg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UT || (UT = u.createElement("path", { fill: "currentColor", d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })), WT || (WT = u.createElement("path", { fill: "currentColor", d: "M8 8c-.708 0-1.367-.21-1.918-.572A4.483 4.483 0 0 1 8 7c.686 0 1.336.154 1.918.428C9.368 7.79 8.708 8 8 8ZM4.591 8.562c.308-.357.838-.339 1.252-.112C6.483 8.8 7.218 9 8 9s1.517-.2 2.158-.55c.413-.227.943-.245 1.251.112A4.482 4.482 0 0 1 12.5 11.5V14h-9v-2.5c0-1.123.411-2.15 1.091-2.938Z" })));
}, PersonGroup: function(e) {
  return u.createElement("svg", ag({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GT || (GT = u.createElement("path", { fill: "currentColor", d: "M4.808 8.923a2.962 2.962 0 1 0 0-5.923 2.962 2.962 0 0 0 0 5.923ZM2.982 9.304c-.35-.192-.798-.207-1.059.095A3.793 3.793 0 0 0 1 11.885V14h7.615v-2.115c0-.95-.347-1.819-.923-2.486-.26-.302-.708-.287-1.059-.095a3.79 3.79 0 0 1-1.825.465 3.79 3.79 0 0 1-1.826-.465ZM9.615 11.885V13H15v-1.906c0-.734-.274-1.405-.727-1.92-.206-.234-.559-.222-.835-.074-.427.23-.917.36-1.438.36-.521 0-1.011-.13-1.438-.36-.276-.148-.63-.16-.835.073-.21.239-.38.51-.504.806.252.585.392 1.23.392 1.906ZM14.333 6.288c0 1.264-1.044 2.289-2.333 2.289-1.289 0-2.333-1.025-2.333-2.289C9.667 5.025 10.71 4 12 4c1.289 0 2.333 1.025 2.333 2.288Z" })));
}, PersonWithLock: function(e) {
  return u.createElement("svg", lg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KT || (KT = u.createElement("path", { fill: "currentColor", d: "M10 4.5A3.497 3.497 0 0 1 6.5 8a3.484 3.484 0 0 1-1.918-.572A3.5 3.5 0 1 1 10 4.5ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h6v-2.5c0-.445.194-.845.502-1.12.033-.82.393-1.554.954-2.076-.259-.051-.55.01-.799.146A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), YT || (YT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 10.5v.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5v-.5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 0-1 1v.5h2v-.5a1 1 0 0 0-1-1Z", clipRule: "evenodd" })));
}, Pin: function(e) {
  return u.createElement("svg", ig({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XT || (XT = u.createElement("path", { fill: "currentColor", d: "M10 8.5V3.3h.683a.65.65 0 1 0 0-1.3H5.317a.65.65 0 1 0 0 1.3H6v5.2L4.383 9.55a.843.843 0 0 0 .46 1.55h2.624v3.367a.533.533 0 0 0 1.066 0V11.1h2.624a.843.843 0 0 0 .46-1.55L10 8.5Z" })));
}, Play: function(e) {
  return u.createElement("svg", og({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QT || (QT = u.createElement("path", { fill: "currentColor", d: "M13.779 6.704a1.5 1.5 0 0 1 0 2.592l-7.523 4.388A1.5 1.5 0 0 1 4 12.388V3.612a1.5 1.5 0 0 1 2.256-1.296l7.523 4.388Z" })));
}, Plus: function(e) {
  return u.createElement("svg", sg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JT || (JT = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v3.5H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9.5H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9.5V3a1 1 0 0 0-1-1h-1Z", clipRule: "evenodd" })));
}, PlusWithCircle: function(e) {
  return u.createElement("svg", cg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eB || (eB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z", clipRule: "evenodd" })));
}, Primary: function(e) {
  return u.createElement("svg", ug({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tB || (tB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3-8.307C11 5.172 9.918 4 8.433 4H6v8h1.495V9.386h.938C9.918 9.386 11 8.214 11 6.693Zm-1.454 0c0 .653-.453 1.16-1.134 1.16h-.917v-2.32h.917c.68 0 1.134.506 1.134 1.16Z", clipRule: "evenodd" })));
}, Project: function(e) {
  return u.createElement("svg", fg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nB || (nB = u.createElement("path", { fill: "currentColor", d: "M1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 4V2Z" })), rB || (rB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 5.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75H2.75ZM6.25 7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1h-3.5Z", clipRule: "evenodd" })));
}, QuestionMarkWithCircle: function(e) {
  return u.createElement("svg", dg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aB || (aB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.932 5.612C7.054 5.298 7.425 5 7.942 5 8.615 5 9 5.478 9 5.875c0 .162-.057.33-.172.476a.985.985 0 0 1-.242.216l-.016.01a1.141 1.141 0 0 1-.098.054c-.59.286-1.53.967-1.53 2.119V9a1 1 0 0 0 2 0c0-.035.011-.12.138-.27a2.66 2.66 0 0 1 .587-.48 3 3 0 0 0 .726-.656A2.742 2.742 0 0 0 11 5.875C11 4.201 9.54 3 7.941 3c-1.275 0-2.43.745-2.873 1.888a1 1 0 1 0 1.864.724ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, Read: function(e) {
  return u.createElement("svg", pg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lB || (lB = u.createElement("path", { fill: "currentColor", d: "M10.011 8.762V4.185h-1.39c-.574 0-.84-.645-.406-.985l2.63-2.063a.669.669 0 0 1 .81 0l2.63 2.063c.433.34.168.985-.405.985h-1.31v4.577c0 .716-.572 1.297-1.28 1.297-.706 0-1.279-.58-1.279-1.297ZM8.823 9.158c-.814.19-1.677.283-2.448.283-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.2-.079.383-.164.548-.254a2.53 2.53 0 0 1-1.434-1.91Z" })), iB || (iB = u.createElement("path", { fill: "currentColor", d: "M6.787 3.479a10.514 10.514 0 0 0-.412-.008c-2.404 0-4.875.823-4.875 2.562 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.768 0 1.63-.101 2.418-.299V5.421H8.62c-.767 0-1.428-.45-1.706-1.125-.107-.26-.15-.54-.128-.817ZM11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729Z" })));
}, Recommended: function(e) {
  return u.createElement("svg", gg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oB || (oB = u.createElement("path", { fill: "currentColor", d: "m8.148 5.458-.944 1.968V9.59h2.099a.5.5 0 0 0 .491-.407l.223-1.182a.5.5 0 0 0-.491-.593h-.638a.623.623 0 0 1-.61-.636V5.708a.302.302 0 0 0-.13-.25Z" })), sB || (sB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.538 1.554a.75.75 0 0 0-1.076 0L6.4 2.648a.75.75 0 0 1-.615.224L4.27 2.716a.75.75 0 0 0-.824.692l-.11 1.52a.75.75 0 0 1-.328.567l-1.261.856a.75.75 0 0 0-.187 1.06l.893 1.235a.75.75 0 0 1 .113.644l-.416 1.467a.75.75 0 0 0 .538.932l1.478.373a.75.75 0 0 1 .501.42l.624 1.39a.75.75 0 0 0 1.011.369l1.372-.665a.75.75 0 0 1 .654 0l1.372.665a.75.75 0 0 0 1.011-.368l.624-1.391a.75.75 0 0 1 .5-.42l1.48-.373a.75.75 0 0 0 .537-.932l-.416-1.467a.75.75 0 0 1 .114-.644l.892-1.235a.75.75 0 0 0-.187-1.06l-1.261-.856a.75.75 0 0 1-.327-.566l-.11-1.52a.75.75 0 0 0-.825-.693l-1.517.156a.75.75 0 0 1-.614-.224L8.538 1.554Zm-1.064 3.28a.577.577 0 0 1 .518-.334c.639 0 1.157.54 1.157 1.208V6.5h.98c.549 0 .96.523.854 1.085l-.412 2.182a.881.881 0 0 1-.854.733H5.435c-.24 0-.435-.294-.435-.546V7.591c0-.251.195-.455.435-.455h.898c.013 0 .027 0 .04.002a.702.702 0 0 1 .03-.072l1.071-2.232Z", clipRule: "evenodd" })));
}, Redo: function(e) {
  return u.createElement("svg", hg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cB || (cB = u.createElement("path", { fill: "currentColor", d: "M4.018 9.402c-.05.328-.313.598-.645.598h-.8c-.331 0-.603-.27-.57-.6a5.996 5.996 0 0 1 2.543-4.325A5.997 5.997 0 0 1 7.974 4h.028c2.699 0 4.95 1.718 5.467 4h1.414c.541 0 .792.672.383 1.026l-2.482 2.15a.585.585 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.92 8h1.446c-.468-1.085-1.68-2-3.364-2a3.98 3.98 0 0 0-2.543.89 3.996 3.996 0 0 0-1.441 2.512Z" })));
}, Refresh: function(e) {
  return u.createElement("svg", mg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uB || (uB = u.createElement("path", { fill: "currentColor", d: "M8.033 2c2.699 0 4.95 1.718 5.467 4h1.414c.542 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.951 6h1.447c-.469-1.085-1.68-2-3.365-2-1.026 0-1.877.34-2.491.85-.243.202-.618.203-.817-.043l-.61-.754a.468.468 0 0 1 .044-.651C5.163 2.534 6.53 2 8.033 2ZM3.95 6.843a.584.584 0 0 0-.765 0L.703 8.992a.584.584 0 0 0 .383 1.026h1.418C3.03 12.291 5.275 14 7.967 14c1.505 0 2.87-.534 3.874-1.402a.468.468 0 0 0 .044-.65l-.61-.755c-.2-.246-.574-.245-.817-.043-.614.51-1.465.85-2.49.85-1.676 0-2.883-.904-3.358-1.982H6.05a.584.584 0 0 0 .383-1.026L3.95 6.842Z" })));
}, Relationship: function(e) {
  return u.createElement("svg", vg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fB || (fB = u.createElement("path", { fill: "currentColor", d: "M.5 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6a2.5 2.5 0 0 1 2.5 2.5v5A1.5 1.5 0 0 0 10 12h1.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H10a2.5 2.5 0 0 1-2.5-2.5v-5A1.5 1.5 0 0 0 6 4H4.5v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2Z" })));
}, ReplicaSet: function(e) {
  return u.createElement("svg", bg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dB || (dB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.39 7.713A3.488 3.488 0 0 1 8 8c-.494 0-.964-.102-1.39-.287L5.264 9.729a2.5 2.5 0 1 1-1.08-.634L5.57 7.02a3.5 3.5 0 1 1 4.86 0l1.385 2.076A2.501 2.501 0 0 1 15 11.5a2.5 2.5 0 1 1-4.265-1.77L9.391 7.712ZM9.75 4.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, Resize: function(e) {
  return u.createElement("svg", yg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pB || (pB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.77 5.72a.75.75 0 0 1 0 1.06l-7.991 8a.749.749 0 1 1-1.06-1.06l7.992-8a.749.749 0 0 1 1.06 0ZM14.78 10.22a.75.75 0 0 1 0 1.06l-3.496 3.5a.749.749 0 1 1-1.06-1.06l3.497-3.5a.749.749 0 0 1 1.06 0Z", clipRule: "evenodd" })));
}, Return: function(e) {
  return u.createElement("svg", wg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gB || (gB = u.createElement("path", { fill: "currentColor", d: "M5 2a1 1 0 0 0 0 2h5a2.5 2.5 0 0 1 0 5H5.203l1.448-1.24a1 1 0 1 0-1.302-1.52l-3.5 3a1 1 0 0 0 0 1.52l3.5 3a1 1 0 0 0 1.302-1.52L5.203 11H10a4.5 4.5 0 1 0 0-9H5Z" })));
}, Save: function(e) {
  return u.createElement("svg", Og({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hB || (hB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 2 3.04 2 3.6 2h7.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l1.062 1.063c.173.173.26.26.322.36.055.09.095.188.12.29.027.115.027.237.027.482V12.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.2.102-.46.109-.954.109V9.284c0-.126 0-.25-.008-.353a1.01 1.01 0 0 0-.101-.385 1 1 0 0 0-.437-.437 1.01 1.01 0 0 0-.385-.1C11.465 8 11.342 8 11.216 8H4.784c-.126 0-.249 0-.353.008a1.01 1.01 0 0 0-.385.101 1 1 0 0 0-.437.437 1.01 1.01 0 0 0-.1.385c-.009.104-.009.227-.009.353V14c-.494 0-.753-.007-.954-.109a1 1 0 0 1-.437-.437C2 13.24 2 12.96 2 12.4V3.6Zm2-.1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z", clipRule: "evenodd" })), mB || (mB = u.createElement("path", { fill: "currentColor", d: "M11.5 9.3V14h-7V9.3c0-.148 0-.23.005-.288v-.006h.007C4.571 9 4.652 9 4.8 9h6.4c.148 0 .23 0 .288.005h.006v.007c.006.059.006.14.006.288Z" })));
}, Serverless: function(e) {
  return u.createElement("svg", $g({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xB || (xB = u.createElement("path", { fill: "currentColor", d: "M2.132 10.849a5.5 5.5 0 1 1 8.4-6.571 4 4 0 0 1 4.398 6.444 1 1 0 0 1-.15.192l-1.77 1.898a1.995 1.995 0 0 1-1.51.688H7.792a2.5 2.5 0 1 1 0-2H11.5l1.166-1.25H8.5a3.75 3.75 0 0 0-6.368.599Z" })));
}, ShardedCluster: function(e) {
  return u.createElement("svg", Cg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $B || ($B = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 2.75a1.75 1.75 0 0 1-2.123 1.71l-.619.866a3.497 3.497 0 0 1 1.186 2.049h1.17a1.75 1.75 0 1 1 0 1.25h-1.17a3.497 3.497 0 0 1-1.186 2.05l.619.865a1.75 1.75 0 1 1-1.046.686l-.662-.926a3.495 3.495 0 0 1-2.331.002l-.664.93a1.75 1.75 0 1 1-1.043-.69l.616-.863a3.497 3.497 0 0 1-1.191-2.054h-1.17a1.75 1.75 0 1 1 0-1.25h1.17c.147-.819.58-1.54 1.191-2.054l-.616-.863a1.75 1.75 0 1 1 1.043-.69l.664.93A3.494 3.494 0 0 1 8 4.5c.41 0 .803.07 1.17.2l.66-.926A1.75 1.75 0 1 1 13 2.75ZM9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, SearchIndex: function(e) {
  return u.createElement("svg", xg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vB || (vB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.816 12.754a2.786 2.786 0 0 0 3.396.424l1.622 1.622a.683.683 0 1 0 .966-.966l-1.622-1.622a2.786 2.786 0 1 0-4.362.542Zm2.972-2.972a1.419 1.419 0 1 1-2.006 2.006 1.419 1.419 0 0 1 2.006-2.006Z", clipRule: "evenodd" })), bB || (bB = u.createElement("path", { fill: "currentColor", d: "M12 3.667c0 .083 0 .165-.002.245L12 4v.214c0 .281-.124.55-.393.815-.275.27-.682.512-1.187.715-1.01.405-2.31.613-3.42.613-1.11 0-2.41-.208-3.42-.613-.505-.203-.912-.446-1.187-.715C2.123 4.765 2 4.495 2 4.214V4c0-.033 0-.066.002-.099A12.44 12.44 0 0 1 2 3.667C2 1.857 4.534 1 7 1s5 .857 5 2.667Z" })), yB || (yB = u.createElement("path", { fill: "currentColor", d: "M2 5.813v1.83c0 .28.124.55.393.815.275.269.682.511 1.187.714 1.01.406 2.31.614 3.42.614l.134-.001A3.785 3.785 0 0 1 12 7.2V5.812c-.357.297-.8.537-1.277.729-1.124.452-2.532.672-3.723.672-1.191 0-2.599-.22-3.723-.672C2.8 6.35 2.357 6.11 2 5.813ZM7 10.643h.003c-.03.816.201 1.64.696 2.334-.232.015-.466.023-.699.023-2.466 0-5-.857-5-2.667 0-.083 0-.165.002-.245A2.229 2.229 0 0 1 2 10v-.758c.357.297.8.537 1.277.729 1.124.451 2.532.672 3.723.672Z" })));
}, Secondary: function(e) {
  return u.createElement("svg", Eg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wB || (wB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z", clipRule: "evenodd" })), OB || (OB = u.createElement("path", { fill: "currentColor", d: "M11 9.67C11 11.112 9.786 12 8.117 12 6.337 12 5.07 10.897 5 9.395h1.972c.07.674.594.996 1.2.996.594 0 .897-.245.897-.613 0-.399-.262-.598-.869-.767l-1.297-.367c-1.2-.337-1.751-1.257-1.751-2.376C5.152 4.95 6.2 4 7.924 4c1.517 0 2.676.889 2.786 2.421H8.807c-.097-.582-.497-.781-.91-.781-.483 0-.814.214-.814.582 0 .43.372.598.786.705l1.214.368C10.434 7.678 11 8.475 11 9.671Z" })));
}, Settings: function(e) {
  return u.createElement("svg", jg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EB || (EB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.207 1.067a.75.75 0 0 0-.89.247l-.374.506a6.214 6.214 0 0 0-1.894.002l-.375-.506a.75.75 0 0 0-.89-.246l-1.126.467a.75.75 0 0 0-.454.804l.093.623c-.505.37-.958.82-1.338 1.34l-.623-.093a.75.75 0 0 0-.803.455l-.466 1.127a.75.75 0 0 0 .247.89l.506.374a6.214 6.214 0 0 0 .002 1.893l-.506.376a.75.75 0 0 0-.246.89l.467 1.126a.75.75 0 0 0 .804.454l.623-.093c.37.505.82.958 1.34 1.338l-.093.623a.75.75 0 0 0 .455.803l1.127.466a.75.75 0 0 0 .89-.247l.374-.506a6.218 6.218 0 0 0 1.894-.002l.375.506a.75.75 0 0 0 .89.246l1.126-.467a.75.75 0 0 0 .454-.804l-.093-.623c.505-.37.958-.82 1.338-1.34l.623.093a.75.75 0 0 0 .803-.455l.466-1.127a.75.75 0 0 0-.247-.89l-.506-.374a6.218 6.218 0 0 0-.002-1.894l.506-.375a.75.75 0 0 0 .246-.89l-.467-1.126a.75.75 0 0 0-.804-.454l-.623.093a6.214 6.214 0 0 0-1.34-1.338l.093-.623a.75.75 0 0 0-.455-.803l-1.127-.466Zm.334 7.984A2.75 2.75 0 1 1 5.46 6.949a2.75 2.75 0 0 1 5.082 2.102Z", clipRule: "evenodd" })));
}, Shell: function(e) {
  return u.createElement("svg", Mg({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jB || (jB = u.createElement("path", { fill: "currentColor", d: "m1.8 5.2 3.4 2.2-3.79 2.526a.5.5 0 0 0-.142.688l.557.86a.5.5 0 0 0 .697.145L7.5 8.3c.3-.2.5-.5.5-.8 0-.3-.2-.6-.4-.8L2.522 3.284a.5.5 0 0 0-.699.143l-.547.847a.5.5 0 0 0 .155.695L1.8 5.2ZM6.7 13a.5.5 0 0 0 .5.5h7.7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.2a.5.5 0 0 0-.5.5v1Z" })));
}, SMS: function(e) {
  return u.createElement("svg", kg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CB || (CB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7.755L4.23 14.831c-.488.392-1.23.058-1.23-.555V12a2 2 0 0 1-2-2V4Zm2 .75A.75.75 0 0 1 3.75 4h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 4.75Zm0 3A.75.75 0 0 1 3.75 7h5.5a.75.75 0 1 1 0 1.5h-5.5A.75.75 0 0 1 3 7.75Z", clipRule: "evenodd" })));
}, SortAscending: function(e) {
  return u.createElement("svg", Pg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MB || (MB = u.createElement("path", { fill: "currentColor", d: "M4.45 1.143a.584.584 0 0 0-.765 0L1.203 3.292a.584.584 0 0 0 .383 1.026h1.312v9.352a1.169 1.169 0 1 0 2.338 0V4.318H6.55a.584.584 0 0 0 .383-1.026L4.45 1.142ZM8 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, SortDescending: function(e) {
  return u.createElement("svg", Sg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kB || (kB = u.createElement("path", { fill: "currentColor", d: "M4.45 14.696a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.025h1.312V2.168a1.169 1.169 0 1 1 2.338 0v9.351H6.55c.541 0 .792.673.383 1.027L4.45 14.696ZM8 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, Sparkle: function(e) {
  return u.createElement("svg", Ng({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PB || (PB = u.createElement("path", { fill: "currentColor", d: "m6.273 2.893-.998 2.995c-.1.3-.336.536-.636.637l-2.995.998a.503.503 0 0 0 0 .954l2.995.998c.3.1.536.336.636.637l.998 2.995a.503.503 0 0 0 .955 0l.998-2.995c.1-.3.336-.536.636-.637l2.995-.998a.503.503 0 0 0 0-.954l-2.995-.998c-.3-.1-.536-.336-.636-.637l-.998-2.995a.503.503 0 0 0-.955 0ZM12.547 1.172l-.231.693c-.1.3-.336.536-.636.636l-.694.231c-.229.077-.229.401 0 .477l.694.231c.3.1.536.336.636.637l.23.693c.077.229.402.229.478 0l.231-.693c.1-.3.336-.536.636-.637l.693-.23c.23-.077.23-.401 0-.478l-.693-.23c-.3-.1-.536-.337-.636-.637l-.231-.693a.251.251 0 0 0-.477 0ZM12.547 11.23l-.231.693c-.1.3-.336.536-.636.636l-.694.232c-.229.076-.229.4 0 .477l.694.23c.3.1.536.337.636.637l.23.693c.077.23.402.23.478 0l.231-.693c.1-.3.336-.536.636-.636l.693-.231c.23-.077.23-.401 0-.477l-.693-.232c-.3-.1-.536-.335-.636-.636l-.231-.693a.251.251 0 0 0-.477 0Z" })));
}, SplitHorizontal: function(e) {
  return u.createElement("svg", Rg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), SB || (SB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8Zm-2-4.5V3H3v3.5h10Zm-10 1V11h10V7.5H3Z", clipRule: "evenodd" })));
}, SplitVertical: function(e) {
  return u.createElement("svg", _g({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), NB || (NB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM7.5 3H3v8h4.5V3Zm1 8H13V3H8.5v8Z", clipRule: "evenodd" })));
}, Stitch: function(e) {
  return u.createElement("svg", Ag({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), RB || (RB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h16v16H0V0Zm14 4V2H2v2h12Zm0 10V5H2v9h12ZM8 6v7H6V6h2Zm5 0v4H9V6h4ZM5 8v5H3V8h2Zm8 3v2H9v-2h4Z" })));
}, String: function(e) {
  return u.createElement("svg", Lg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _B || (_B = u.createElement("path", { fill: "currentColor", d: "M10.69 14H5.31l-.15-.137v-.754l.15-.138h.602c.376 0 .753-.342.753-.685V3.5h-.903c-2.05 0-2.54.729-2.671 1.826l-.15.137h-.828L2 5.326l.282-3.189.15-.137h11.135l.15.137L14 5.326l-.113.137h-.827l-.15-.137c-.133-1.097-.622-1.826-2.672-1.826h-.903v8.786c0 .343.377.685.753.685h.602l.15.138v.754l-.15.137Z" })));
}, Support: function(e) {
  return u.createElement("svg", Zg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AB || (AB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7a3 3 0 0 1 6 0v2.5c0 1.51-.957 2.798-2.298 3.288a1 1 0 1 0 .265.967 4.512 4.512 0 0 0 2.787-2.785c.08.02.161.03.246.03h.5a2.5 2.5 0 0 0 .406-4.967 5.002 5.002 0 0 0-9.813 0A2.5 2.5 0 0 0 3.5 11H4a1 1 0 0 0 1-1V7Z", clipRule: "evenodd" })));
}, Sweep: function(e) {
  return u.createElement("svg", Tg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LB || (LB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 14.465 4 12.734c.292.169.631.266.999.266h2v2H5a3.982 3.982 0 0 1-2-.535ZM9 15v-2h2c.368 0 .707-.097.999-.266L13 14.464A3.982 3.982 0 0 1 11 15H9Zm6-8h-2V5c0-.368-.097-.707-.266-.999L14.464 3c.341.588.536 1.271.536 2v2ZM7 1H5c-.729 0-1.412.195-2 .535L4 3.266C4.293 3.097 4.632 3 5 3h2V1ZM1 9h2v2c0 .368.097.707.266.999L1.536 13A3.982 3.982 0 0 1 1 11V9Zm0-2h2V5c0-.368.097-.707.266-.999L1.536 3A3.982 3.982 0 0 0 1 5v2Zm8-6v2h2c.368 0 .707.097.999.266L13 1.536A3.982 3.982 0 0 0 11 1H9Zm6 8h-2v2c0 .368-.097.707-.266.999L14.464 13c.341-.588.536-1.271.536-2V9Z", clipRule: "evenodd" })));
}, Table: function(e) {
  return u.createElement("svg", Bg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZB || (ZB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3.25C1 2.56 1.56 2 2.25 2h11.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 14 1 13.44 1 12.75v-9.5Zm2 4.12V4h4.37v3.37H3Zm0 1.25V12h4.37V8.62H3ZM8.62 12H13V8.62H8.62V12ZM13 7.37V4H8.62v3.37H13Z", clipRule: "evenodd" })));
}, Tag: function(e) {
  return u.createElement("svg", Ig({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TB || (TB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m9.707 14.293 4.586-4.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 7.586 2H3a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, ThumbsDown: function(e) {
  return u.createElement("svg", Hg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BB || (BB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.019 15c.511 0 .98-.28 1.208-.724l2.501-4.837c.026-.05.05-.102.07-.155.03.003.06.004.092.004h2.094c.561 0 1.016-.441 1.016-.985V3.182C15 2.638 14.545 2 13.984 2H3.993C3.023 2 2.188 2.666 2 3.589L1.04 8.316c-.247 1.217.713 2.35 1.993 2.35H5.32v1.717C5.32 13.828 6.528 15 8.019 15Zm1.84-6.34-2.205 4.265a.642.642 0 0 1-.303-.542v-2.307c0-.762-.637-1.379-1.422-1.379H3.644a.5.5 0 0 1-.49-.6l.758-3.727a.5.5 0 0 1 .49-.4h5.456v4.69Z", clipRule: "evenodd" })));
}, ThumbsUp: function(e) {
  return u.createElement("svg", Dg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IB || (IB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.981 1c-.511 0-.98.28-1.208.724L4.272 6.56c-.026.05-.05.102-.07.155a1.06 1.06 0 0 0-.092-.004H2.016c-.561 0-1.016.441-1.016.985v5.121C1 13.362 1.455 14 2.016 14h9.991c.97 0 1.805-.665 1.993-1.589l.961-4.727c.248-1.217-.713-2.35-1.993-2.35H10.68V3.616C10.68 2.172 9.472 1 7.981 1Zm-1.84 6.34 2.205-4.265a.642.642 0 0 1 .303.542v2.307c0 .762.637 1.379 1.422 1.379h2.285a.5.5 0 0 1 .49.6l-.758 3.727a.5.5 0 0 1-.49.4H6.142V7.34Z", clipRule: "evenodd" })));
}, TimeSeries: function(e) {
  return u.createElement("svg", zg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HB || (HB = u.createElement("path", { fill: "currentColor", d: "M7.023 1.518c.513.024.957.363 1.12.853L9.38 6.108l1.56-2.092a1.24 1.24 0 0 1 1.872-.134l1.897 1.91c.388.39.388 1.023 0 1.413l-.377.354a.99.99 0 0 1-1.405 0l-.86-.89-2.122 2.847a1.239 1.239 0 0 1-2.172-.355L6.798 6.22 6.11 7.774c-.2.451-.644.742-1.135.742H1.994a.997.997 0 0 1-.994-1v-.5c0-.552.445-1 .994-1h2.174l1.66-3.758a1.242 1.242 0 0 1 1.195-.74ZM14 12a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h12Z" })));
}, TimeSeriesCollection: function(e) {
  return u.createElement("svg", Fg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DB || (DB = u.createElement("path", { fill: "currentColor", d: "M13.6 10.383H15c.6 0 1 .499 1 1.098 0 .598-.4.998-1 .998h-.9l-1.5 2.096c-.2.3-.6.499-1 .399-.4-.1-.7-.4-.8-.799l-.4-1.696-.4 1.197c-.1.3-.5.6-.9.6H8c-.6 0-1-.4-1-.999s.4-.998 1-.998h.4l1.4-3.693c.1-.4.6-.599 1-.599s.8.4.9.699l.6 2.794.5-.698c.2-.2.5-.4.8-.4Z" })), zB || (zB = u.createElement("path", { fill: "currentColor", d: "M1.929 1A.922.922 0 0 0 1 1.915v9.15c0 .505.416.915.929.915H5.84c.101-.173.225-.336.374-.485.322-.321.71-.526 1.118-.63l1.043-2.75c.208-.678.706-1.086 1.107-1.3A2.846 2.846 0 0 1 10.8 6.49c.682 0 1.214.323 1.531.591.318.269.635.66.792 1.131l.026.079.133.617a2.24 2.24 0 0 1 .318-.023h.4v-5.14a.922.922 0 0 0-.929-.915H7.5a.922.922 0 0 1-.929-.915A.922.922 0 0 0 5.643 1H1.929Z" })), FB || (FB = u.createElement("path", { fill: "currentColor", d: "M10.95 8.005a.699.699 0 0 0-.066-.012l.065.012Z" })));
}, Trash: function(e) {
  return u.createElement("svg", Vg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VB || (VB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2a1 1 0 0 1 1 1v1H2V3a1 1 0 0 1 1-1h2Zm9 3H2l1.678 8.392A2 2 0 0 0 5.64 15h4.72a2 2 0 0 0 1.962-1.608L14 5Z", clipRule: "evenodd" })));
}, Undo: function(e) {
  return u.createElement("svg", qg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qB || (qB = u.createElement("path", { fill: "currentColor", d: "M11.981 9.402c.05.328.313.598.645.598h.8c.331 0 .603-.27.57-.6a5.996 5.996 0 0 0-2.543-4.325A5.997 5.997 0 0 0 8.026 4h-.029C5.298 4 3.047 5.718 2.53 8H1.116a.584.584 0 0 0-.383 1.026l2.482 2.15c.22.19.545.19.765 0l2.482-2.15A.584.584 0 0 0 6.079 8H4.632c.47-1.085 1.68-2 3.365-2a3.98 3.98 0 0 1 2.543.89 3.996 3.996 0 0 1 1.441 2.512Z" })));
}, University: function(e) {
  return u.createElement("svg", Ug({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UB || (UB = u.createElement("path", { fill: "currentColor", d: "M8.5 4.613c0-.383.191-.74.51-.953a6.87 6.87 0 0 1 2.145-.949l2.406-.601a.353.353 0 0 1 .439.342v7.88c0 .238 0 .357-.043.453a.5.5 0 0 1-.176.211c-.087.06-.204.081-.438.123l-3.9.71c-.324.058-.486.088-.612.042a.5.5 0 0 1-.264-.22c-.067-.116-.067-.28-.067-.61V4.613ZM2 2.452c0-.23.216-.398.439-.342l2.407.601a6.87 6.87 0 0 1 2.144.95c.319.211.51.569.51.952v6.428c0 .33 0 .494-.067.61a.5.5 0 0 1-.264.22c-.126.046-.288.016-.612-.043l-3.9-.709c-.234-.042-.35-.063-.438-.123a.5.5 0 0 1-.176-.21C2 10.688 2 10.57 2 10.331v-7.88ZM2.008 12.41a.5.5 0 0 1 .581-.402l5.143.935c.177.032.359.032.536 0l5.143-.935a.5.5 0 0 1 .178.984l-4.134.752c-.163.434-.753.756-1.455.756-.702 0-1.292-.322-1.455-.756l-4.134-.752a.5.5 0 0 1-.403-.581Z" })));
}, Unlock: function(e) {
  return u.createElement("svg", Wg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WB || (WB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.157 4.221A2 2 0 0 1 10 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1V5a4 4 0 0 0-7.822-1.182C3.982 4.45 4.538 5 5.2 5c.442 0 .785-.372.957-.779Zm2.43 6.589A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, Unsorted: function(e) {
  return u.createElement("svg", Gg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GB || (GB = u.createElement("path", { fill: "currentColor", d: "M3.685 1.143c.22-.19.545-.19.765 0l2.482 2.149a.584.584 0 0 1-.383 1.026H5.236v7.364H6.55c.541 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.026h1.312V4.318H1.586a.584.584 0 0 1-.383-1.026l2.482-2.15ZM8 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H9ZM8 11a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" })));
}, UpDownCarets: function(e) {
  return u.createElement("svg", Kg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), KB || (KB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.527 1.21a.638.638 0 0 1 .948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562Zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 0 1-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654Z" })));
}, Upload: function(e) {
  return u.createElement("svg", Yg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YB || (YB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.297 11v.938a4 4 0 1 0-.764-7.66A5.501 5.501 0 0 0 0 6.5a5.5 5.5 0 0 0 5.797 5.492V11h-.403c-1.395 0-2.08-1.7-1.075-2.667L7.472 5.3a1.55 1.55 0 0 1 2.15 0l3.152 3.034C13.78 9.301 13.094 11 11.7 11h-.402ZM8.339 6.2a.3.3 0 0 1 .416 0l3.152 3.034a.3.3 0 0 1-.208.516h-1.652v3.75a1.5 1.5 0 0 1-3 0V9.75H5.394a.3.3 0 0 1-.208-.516L8.339 6.2Z", clipRule: "evenodd" })));
}, VerticalEllipsis: function(e) {
  return u.createElement("svg", Xg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XB || (XB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM7.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", clipRule: "evenodd" })));
}, Visibility: function(e) {
  return u.createElement("svg", Qg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QB || (QB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2.008c3.934 0 6.473 3.129 7.455 4.583l.043.064C15.713 6.97 16 7.391 16 8s-.287 1.03-.502 1.345l-.043.064c-.982 1.454-3.521 4.583-7.455 4.583S1.527 10.863.545 9.41l-.043-.064C.287 9.03 0 8.609 0 8s.287-1.03.502-1.345l.043-.064C1.527 5.137 4.066 2.008 8 2.008ZM9.13 4.13A5.147 5.147 0 0 0 8 4.005C5.75 4.005 3.927 5.794 3.927 8c0 2.206 1.824 3.995 4.073 3.995 2.25 0 4.073-1.789 4.073-3.995 0-2.206-1.824-3.995-4.073-3.995.378 0 .756.045 1.13.126ZM8 10.996c1.687 0 3.055-1.341 3.055-2.996S9.687 5.004 8 5.004 4.945 6.345 4.945 8 6.313 10.996 8 10.996Z", clipRule: "evenodd" })));
}, VisibilityOff: function(e) {
  return u.createElement("svg", Jg({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JB || (JB = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.601 1.266a1.03 1.03 0 0 0-1.433.049L1.704 13.486a.987.987 0 0 0 .062 1.407 1.03 1.03 0 0 0 1.433-.049l1.793-1.904A7.348 7.348 0 0 0 8 13.587c3.934 0 6.473-3.133 7.455-4.59l.043-.063c.215-.316.502-.737.502-1.347s-.287-1.03-.502-1.346l-.043-.065a12.85 12.85 0 0 0-1.949-2.275l1.157-1.228a.987.987 0 0 0-.062-1.407Zm-2.93 4.585-.764.81c.096.292.148.603.148.926 0 1.657-1.368 3-3.055 3-.246 0-.485-.028-.714-.082l-.763.81c.458.176.956.272 1.477.272 2.25 0 4.073-1.79 4.073-4 0-.622-.145-1.211-.403-1.736ZM8 1.587c.919 0 1.762.171 2.526.452L8.98 3.68A5.13 5.13 0 0 0 8 3.587c-2.25 0-4.073 1.79-4.073 4 0 .435.07.853.201 1.245l-1.985 2.107A13.06 13.06 0 0 1 .545 8.998l-.043-.064C.287 8.618 0 8.197 0 7.587s.287-1.03.502-1.346l.043-.065C1.527 4.72 4.066 1.587 8 1.587Zm0 2c.327 0 .654.034.978.095l-.016.017A4.155 4.155 0 0 0 8 3.587Zm0 1c.041 0 .083 0 .124.002L4.966 7.942a2.978 2.978 0 0 1-.02-.355c0-1.657 1.367-3 3.054-3Z", clipRule: "evenodd" })));
}, Warning: function(e) {
  return u.createElement("svg", eh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eI || (eI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.864 1.514a.983.983 0 0 0-1.728 0L1.122 12.539A.987.987 0 0 0 1.986 14h12.028a.987.987 0 0 0 .864-1.461L8.864 1.514ZM7 5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V5Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, Wizard: function(e) {
  return u.createElement("svg", th({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tI || (tI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.327 3.277c.188-.38-.236-.8-.618-.613l-2.513 1.223a.461.461 0 0 1-.523-.095L7.603 1.74c-.314-.313-.829-.062-.75.365l.517 2.808a.421.421 0 0 1-.228.46L4.63 6.596c-.383.186-.277.761.154.839l2.832.513a.477.477 0 0 1 .382.379l.517 2.808c.079.427.659.532.846.153l1.234-2.492a.427.427 0 0 1 .464-.225l2.832.512c.43.078.683-.432.368-.744l-2.07-2.052a.452.452 0 0 1-.095-.519l1.233-2.491ZM7 10.5c.353-.35.312-.958-.091-1.359-.404-.4-1.017-.44-1.37-.09L1.84 12.713c-.353.35-.312.958.092 1.358.403.4 1.017.44 1.37.09L7 10.5Z", clipRule: "evenodd" })));
}, Wrench: function(e) {
  return u.createElement("svg", nh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nI || (nI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.625 9.75a4.374 4.374 0 0 0 4.206-5.584c-.085-.295-.449-.36-.665-.145l-2.1 2.1a.44.44 0 0 1-.184.11c-.078.024-.157-.013-.215-.07L9.84 4.332c-.058-.058-.095-.137-.071-.215a.44.44 0 0 1 .11-.184l2.1-2.1c.216-.216.147-.58-.145-.664a4.374 4.374 0 0 0-5.385 5.512.32.32 0 0 1-.077.32l-4.828 4.829a1.857 1.857 0 0 0 2.625 2.625l4.828-4.828a.32.32 0 0 1 .323-.075c.412.129.851.197 1.305.197ZM2.75 14.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z", clipRule: "evenodd" })));
}, Write: function(e) {
  return u.createElement("svg", rh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rI || (rI = u.createElement("path", { fill: "currentColor", d: "M8.71 3.75a9.487 9.487 0 0 0-2.335-.28c-2.404 0-4.875.824-4.875 2.563 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.267 0 .546-.013.828-.037a1.76 1.76 0 0 1-.288-1.818 1.826 1.826 0 0 1 1.706-1.125h.09V3.75ZM8.068 9.305c-.578.091-1.158.136-1.693.136-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.22-.086.42-.18.598-.282a1.85 1.85 0 0 1-.209-.141l-2.03-1.594Z" })), aI || (aI = u.createElement("path", { fill: "currentColor", d: "M11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729ZM12.489 2.297v4.576h1.39c.574 0 .84.646.406.986l-2.63 2.063a.668.668 0 0 1-.81 0l-2.63-2.063c-.433-.34-.168-.986.406-.986H9.93V2.297C9.93 1.58 10.502 1 11.21 1c.706 0 1.279.58 1.279 1.297Z" })));
}, X: function(e) {
  return u.createElement("svg", ah({ xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lI || (lI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.203 3.404a1 1 0 0 0-1.414 0L8.314 5.879 5.839 3.404a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L6.192 8l-2.474 2.475a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l2.475-2.475 2.475 2.475a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L10.435 8l2.475-2.475a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, XWithCircle: function(e) {
  return u.createElement("svg", lh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iI || (iI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.414-9.828a1 1 0 1 1 1.414 1.414L9.414 8l1.414 1.414a1 1 0 1 1-1.414 1.414L8 9.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L6.586 8 5.172 6.586a1 1 0 0 1 1.414-1.414L8 6.586l1.414-1.414Z", clipRule: "evenodd" })));
} }, Hxe = Object.keys(oI).reduce(function(e, t) {
  return e[t] = Txe(t, oI[t]), e;
}, {});
Ixe(Hxe);
function Dxe(e) {
  return b1(e) ? e != null && dd(e) === "object" && "type" in e && e.type.isGlyph === !0 : e != null && typeof e == "function" && "isGlyph" in e && e.isGlyph === !0;
}
var a2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "File", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 13V7H7.5C8.32843 7 9 6.32843 9 5.5V1H11C12.1046 1 13 1.89543 13 3V8.98388C13 8.98924 13 9 13 9V13C13 14.1046 12.1046 15 11 15H5C3.89543 15 3 14.1046 3 13Z", fill: "currentColor" }), f.createElement("path", { d: "M7.83333 1H6.91421C6.649 1 6.39464 1.10536 6.20711 1.29289L3.29289 4.20711C3.10536 4.39464 3 4.649 3 4.91421V5.83333H6.83333C7.38562 5.83333 7.83333 5.38562 7.83333 4.83333V1Z", fill: "currentColor" }));
    };
    return P.displayName = "File", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(a2e);
var zxe = a2e.exports;
const Fxe = /* @__PURE__ */ ce(zxe);
function Vxe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ih(e) {
  return ih = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ih(e);
}
function qa(e, t, n) {
  return (t = Vxe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oh() {
  return oh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, oh.apply(this, arguments);
}
function l2e(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var sI, sh = { Small: "small", Default: "default", Large: "large", XLarge: "xlarge" }, qxe = { small: 14, default: 16, large: 20, xlarge: 24 }, Uxe = ["className", "size", "fill", "title", "aria-labelledby", "aria-label", "role"];
function Wxe(e, t) {
  var n = function(r) {
    var l, i, c = r.className, f = r.size, d = f === void 0 ? sh.Default : f, h = r.fill, g = r.title, m = r["aria-labelledby"], y = r["aria-label"], w = r.role, C = w === void 0 ? "img" : w, E = l2e(r, Uxe), R = v(sI || (l = [`
      color: `, `;
    `], i || (i = l.slice(0)), sI = Object.freeze(Object.defineProperties(l, { raw: { value: Object.freeze(i) } }))), h), M = typeof d == "number" ? d : qxe[d];
    return C !== "img" && C !== "presentation" && console.warn("Please provide a valid role to this component. Valid options are 'img' and 'presentation'. If you'd like the Icon to be accessible to screen readers please use 'img', otherwise set the role to 'presentation'."), k.createElement(t, oh({ className: H(qa({}, R, h != null), c), height: M, width: M, role: C }, function(P, a, o) {
      var s, p = o["aria-label"], O = o["aria-labelledby"], x = o.title;
      switch (P) {
        case "img":
          return p || O || x ? qa(qa(qa({}, "aria-labelledby", O), "aria-label", p), "title", x) : { "aria-label": (s = a, "".concat(s.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
        case "presentation":
          return { "aria-hidden": !0, alt: "" };
      }
    }(C, e, qa(qa({ title: g }, "aria-label", y), "aria-labelledby", m)), E));
  };
  return n.displayName = e, n.isGlyph = !0, n.propTypes = { fill: z.string, size: z.oneOfType([z.oneOf(Object.values(sh)), z.number]), className: z.string }, n;
}
var cI, Gxe = ["glyph"];
function Kxe(e) {
  var t = function(n) {
    var r = n.glyph, l = l2e(n, Gxe), i = e[r];
    if (i)
      return k.createElement(i, l);
    var c = Object.keys(e).find(function(f) {
      return Cr(f) === Cr(r);
    });
    return console.error("Error in Icon", 'Could not find glyph named "'.concat(r, '" in the icon set.'), c && 'Did you mean "'.concat(c, '?"')), k.createElement(k.Fragment, null);
  };
  return t.displayName = "Icon", t.isGlyph = !0, t.propTypes = { glyph: z.oneOf(Object.keys(e)).isRequired, size: z.oneOfType([z.oneOf(Object.values(sh)), z.number]) }, t;
}
function ch() {
  return ch = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ch.apply(this, arguments);
}
var uI;
function uh() {
  return uh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uh.apply(this, arguments);
}
var fI;
function fh() {
  return fh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fh.apply(this, arguments);
}
var dI;
function dh() {
  return dh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dh.apply(this, arguments);
}
var pI;
function ph() {
  return ph = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ph.apply(this, arguments);
}
var gI;
function gh() {
  return gh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gh.apply(this, arguments);
}
var hI;
function hh() {
  return hh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hh.apply(this, arguments);
}
var mI;
function mh() {
  return mh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mh.apply(this, arguments);
}
var vI;
function vh() {
  return vh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vh.apply(this, arguments);
}
var bI;
function bh() {
  return bh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bh.apply(this, arguments);
}
var yI;
function yh() {
  return yh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yh.apply(this, arguments);
}
var wI;
function wh() {
  return wh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wh.apply(this, arguments);
}
var OI;
function Oh() {
  return Oh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oh.apply(this, arguments);
}
var xI;
function xh() {
  return xh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xh.apply(this, arguments);
}
var EI, $I;
function Eh() {
  return Eh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Eh.apply(this, arguments);
}
var jI, CI, MI;
function $h() {
  return $h = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $h.apply(this, arguments);
}
var kI, PI;
function jh() {
  return jh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jh.apply(this, arguments);
}
var SI, NI;
function Ch() {
  return Ch = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ch.apply(this, arguments);
}
var RI;
function Mh() {
  return Mh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mh.apply(this, arguments);
}
var _I;
function kh() {
  return kh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kh.apply(this, arguments);
}
var AI;
function Ph() {
  return Ph = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ph.apply(this, arguments);
}
var LI;
function Sh() {
  return Sh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sh.apply(this, arguments);
}
var ZI;
function Nh() {
  return Nh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nh.apply(this, arguments);
}
var TI;
function Rh() {
  return Rh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rh.apply(this, arguments);
}
var BI;
function _h() {
  return _h = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _h.apply(this, arguments);
}
var II;
function Ah() {
  return Ah = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ah.apply(this, arguments);
}
var HI;
function Lh() {
  return Lh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lh.apply(this, arguments);
}
var DI;
function Zh() {
  return Zh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zh.apply(this, arguments);
}
var zI;
function Th() {
  return Th = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Th.apply(this, arguments);
}
var FI;
function Bh() {
  return Bh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bh.apply(this, arguments);
}
var VI;
function Ih() {
  return Ih = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ih.apply(this, arguments);
}
var qI, UI;
function Hh() {
  return Hh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hh.apply(this, arguments);
}
var WI, GI;
function Dh() {
  return Dh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dh.apply(this, arguments);
}
var KI;
function zh() {
  return zh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zh.apply(this, arguments);
}
var YI;
function Fh() {
  return Fh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fh.apply(this, arguments);
}
var XI, QI;
function Vh() {
  return Vh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vh.apply(this, arguments);
}
var JI;
function qh() {
  return qh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qh.apply(this, arguments);
}
var eH;
function Uh() {
  return Uh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uh.apply(this, arguments);
}
var tH;
function Wh() {
  return Wh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wh.apply(this, arguments);
}
var nH;
function Gh() {
  return Gh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gh.apply(this, arguments);
}
var rH;
function Kh() {
  return Kh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kh.apply(this, arguments);
}
var aH;
function Yh() {
  return Yh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yh.apply(this, arguments);
}
var lH;
function Xh() {
  return Xh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xh.apply(this, arguments);
}
var iH, oH, sH;
function Qh() {
  return Qh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qh.apply(this, arguments);
}
var cH;
function Jh() {
  return Jh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jh.apply(this, arguments);
}
var uH;
function e3() {
  return e3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e3.apply(this, arguments);
}
var fH;
function t3() {
  return t3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t3.apply(this, arguments);
}
var dH;
function n3() {
  return n3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n3.apply(this, arguments);
}
var pH;
function r3() {
  return r3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r3.apply(this, arguments);
}
var gH;
function a3() {
  return a3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a3.apply(this, arguments);
}
var hH;
function l3() {
  return l3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, l3.apply(this, arguments);
}
var mH;
function i3() {
  return i3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, i3.apply(this, arguments);
}
var vH, bH;
function o3() {
  return o3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, o3.apply(this, arguments);
}
var yH;
function s3() {
  return s3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, s3.apply(this, arguments);
}
var wH, OH;
function c3() {
  return c3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, c3.apply(this, arguments);
}
var xH;
function u3() {
  return u3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, u3.apply(this, arguments);
}
var EH;
function f3() {
  return f3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, f3.apply(this, arguments);
}
var $H, jH;
function d3() {
  return d3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d3.apply(this, arguments);
}
var CH;
function p3() {
  return p3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, p3.apply(this, arguments);
}
var MH;
function g3() {
  return g3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g3.apply(this, arguments);
}
var kH;
function h3() {
  return h3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h3.apply(this, arguments);
}
var PH;
function m3() {
  return m3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m3.apply(this, arguments);
}
var SH;
function v3() {
  return v3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v3.apply(this, arguments);
}
var NH;
function b3() {
  return b3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b3.apply(this, arguments);
}
var RH, _H;
function y3() {
  return y3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y3.apply(this, arguments);
}
var AH;
function w3() {
  return w3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w3.apply(this, arguments);
}
var LH;
function O3() {
  return O3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O3.apply(this, arguments);
}
var ZH, TH;
function x3() {
  return x3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x3.apply(this, arguments);
}
var BH;
function E3() {
  return E3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E3.apply(this, arguments);
}
var IH, HH;
function $3() {
  return $3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $3.apply(this, arguments);
}
var DH;
function j3() {
  return j3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j3.apply(this, arguments);
}
var zH;
function C3() {
  return C3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C3.apply(this, arguments);
}
var FH, VH;
function M3() {
  return M3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M3.apply(this, arguments);
}
var qH, UH;
function k3() {
  return k3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k3.apply(this, arguments);
}
var WH;
function P3() {
  return P3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P3.apply(this, arguments);
}
var GH, KH;
function S3() {
  return S3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S3.apply(this, arguments);
}
var YH;
function N3() {
  return N3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N3.apply(this, arguments);
}
var XH, QH;
function R3() {
  return R3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R3.apply(this, arguments);
}
var JH;
function _3() {
  return _3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _3.apply(this, arguments);
}
var eD;
function A3() {
  return A3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A3.apply(this, arguments);
}
var tD, nD;
function L3() {
  return L3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L3.apply(this, arguments);
}
var rD, aD;
function Z3() {
  return Z3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z3.apply(this, arguments);
}
var lD;
function T3() {
  return T3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T3.apply(this, arguments);
}
var iD;
function B3() {
  return B3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B3.apply(this, arguments);
}
var oD;
function I3() {
  return I3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I3.apply(this, arguments);
}
var sD;
function H3() {
  return H3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H3.apply(this, arguments);
}
var cD;
function D3() {
  return D3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D3.apply(this, arguments);
}
var uD, fD;
function z3() {
  return z3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z3.apply(this, arguments);
}
var dD;
function F3() {
  return F3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F3.apply(this, arguments);
}
var pD, gD;
function V3() {
  return V3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V3.apply(this, arguments);
}
var hD, mD;
function q3() {
  return q3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q3.apply(this, arguments);
}
var vD;
function U3() {
  return U3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U3.apply(this, arguments);
}
var bD;
function W3() {
  return W3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W3.apply(this, arguments);
}
var yD, wD;
function G3() {
  return G3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G3.apply(this, arguments);
}
var OD, xD;
function K3() {
  return K3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K3.apply(this, arguments);
}
var ED;
function Y3() {
  return Y3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y3.apply(this, arguments);
}
var $D, jD;
function X3() {
  return X3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X3.apply(this, arguments);
}
var CD;
function Q3() {
  return Q3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q3.apply(this, arguments);
}
var MD, kD;
function J3() {
  return J3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J3.apply(this, arguments);
}
var PD;
function em() {
  return em = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, em.apply(this, arguments);
}
var SD;
function tm() {
  return tm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tm.apply(this, arguments);
}
var ND;
function nm() {
  return nm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nm.apply(this, arguments);
}
var RD;
function rm() {
  return rm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rm.apply(this, arguments);
}
var _D;
function am() {
  return am = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, am.apply(this, arguments);
}
var AD, LD;
function lm() {
  return lm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lm.apply(this, arguments);
}
var ZD;
function im() {
  return im = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, im.apply(this, arguments);
}
var TD, BD;
function om() {
  return om = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, om.apply(this, arguments);
}
var ID, HD;
function sm() {
  return sm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sm.apply(this, arguments);
}
var DD;
function cm() {
  return cm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cm.apply(this, arguments);
}
var zD;
function um() {
  return um = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, um.apply(this, arguments);
}
var FD;
function fm() {
  return fm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fm.apply(this, arguments);
}
var VD;
function dm() {
  return dm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dm.apply(this, arguments);
}
var qD;
function pm() {
  return pm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pm.apply(this, arguments);
}
var UD;
function gm() {
  return gm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gm.apply(this, arguments);
}
var WD, GD;
function hm() {
  return hm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hm.apply(this, arguments);
}
var KD, YD, XD;
function mm() {
  return mm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mm.apply(this, arguments);
}
var QD, JD;
function vm() {
  return vm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vm.apply(this, arguments);
}
var ez;
function bm() {
  return bm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bm.apply(this, arguments);
}
var tz;
function ym() {
  return ym = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ym.apply(this, arguments);
}
var nz;
function wm() {
  return wm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wm.apply(this, arguments);
}
var rz;
function Om() {
  return Om = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Om.apply(this, arguments);
}
var az;
function xm() {
  return xm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xm.apply(this, arguments);
}
var lz;
function Em() {
  return Em = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Em.apply(this, arguments);
}
var iz;
function $m() {
  return $m = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $m.apply(this, arguments);
}
var oz;
function jm() {
  return jm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jm.apply(this, arguments);
}
var sz;
function Cm() {
  return Cm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cm.apply(this, arguments);
}
var cz;
function Mm() {
  return Mm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mm.apply(this, arguments);
}
var uz;
function km() {
  return km = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, km.apply(this, arguments);
}
var fz;
function Pm() {
  return Pm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pm.apply(this, arguments);
}
var dz;
function Sm() {
  return Sm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sm.apply(this, arguments);
}
var pz;
function Nm() {
  return Nm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nm.apply(this, arguments);
}
var gz;
function Rm() {
  return Rm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rm.apply(this, arguments);
}
var hz;
function _m() {
  return _m = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _m.apply(this, arguments);
}
var mz;
function Am() {
  return Am = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Am.apply(this, arguments);
}
var vz;
function Lm() {
  return Lm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lm.apply(this, arguments);
}
var bz;
function Zm() {
  return Zm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zm.apply(this, arguments);
}
var yz, wz, Oz;
function Tm() {
  return Tm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tm.apply(this, arguments);
}
var xz;
function Bm() {
  return Bm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bm.apply(this, arguments);
}
var Ez;
function Im() {
  return Im = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Im.apply(this, arguments);
}
var $z;
function Hm() {
  return Hm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hm.apply(this, arguments);
}
var jz;
function Dm() {
  return Dm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dm.apply(this, arguments);
}
var Cz;
function zm() {
  return zm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zm.apply(this, arguments);
}
var Mz;
function Fm() {
  return Fm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fm.apply(this, arguments);
}
var kz;
function Vm() {
  return Vm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vm.apply(this, arguments);
}
var Pz;
function qm() {
  return qm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qm.apply(this, arguments);
}
var Sz;
function Um() {
  return Um = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Um.apply(this, arguments);
}
var Nz;
function Wm() {
  return Wm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wm.apply(this, arguments);
}
var Rz;
function Gm() {
  return Gm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gm.apply(this, arguments);
}
var _z;
function Km() {
  return Km = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Km.apply(this, arguments);
}
var Az;
function Ym() {
  return Ym = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ym.apply(this, arguments);
}
var Lz, Zz;
function Xm() {
  return Xm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xm.apply(this, arguments);
}
var Tz;
function Qm() {
  return Qm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qm.apply(this, arguments);
}
var Bz;
function Jm() {
  return Jm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jm.apply(this, arguments);
}
var Iz = { ActivityFeed: function(e) {
  return u.createElement("svg", ch({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cI || (cI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 13V7h4.5A1.5 1.5 0 0 0 7 5.5V1h2a2 2 0 0 1 2 2v4.515a2.5 2.5 0 0 0-2.612 1.602l-1.06 2.808A2.501 2.501 0 0 0 5.59 15H3a2 2 0 0 1-2-2ZM4.914 1h.92v3.833a1 1 0 0 1-1 1H1v-.919a1 1 0 0 1 .293-.707L2.5 3l1.707-1.707A1 1 0 0 1 4.914 1ZM10.8 9.003a1 1 0 0 1 .904.784l.61 2.792.508-.714a1 1 0 0 1 .814-.42H15a1 1 0 0 1 0 2h-.848l-1.519 2.135a1 1 0 0 1-1.792-.367l-.371-1.701-.444 1.175a1 1 0 0 1-.935.646H8a1 1 0 1 1 0-2h.4l1.392-3.686a1 1 0 0 1 1.008-.644Z", clipRule: "evenodd" })));
}, AddFile: function(e) {
  return u.createElement("svg", uh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uI || (uI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 7v6a2 2 0 0 0 2 2h5.968a2.25 2.25 0 0 1 .794-4.238A2.251 2.251 0 0 1 11 8.984V3a2 2 0 0 0-2-2H7v4.5A1.5 1.5 0 0 1 5.5 7H1Zm8 6a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0-1 1ZM5.833 1h-.919a1 1 0 0 0-.707.293L2.5 3 1.293 4.207A1 1 0 0 0 1 4.914v.92h3.833a1 1 0 0 0 1-1V1Z", clipRule: "evenodd" })));
}, AllProducts: function(e) {
  return u.createElement("svg", fh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fI || (fI = u.createElement("path", { fill: "currentColor", d: "M2.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM6.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 2.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM2.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM7.5 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM10.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM3.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM6.5 11.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" })));
}, Apps: function(e) {
  return u.createElement("svg", dh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dI || (dI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3H3v4h4V3Zm0 6H3v4h4V9Zm2-6h4v4H9V3Zm4 6H9v4h4V9Z", clipRule: "evenodd" })));
}, Array: function(e) {
  return u.createElement("svg", ph({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pI || (pI = u.createElement("path", { fill: "currentColor", d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V3h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM13.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12V3H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4Z" })));
}, ArrowDown: function(e) {
  return u.createElement("svg", gh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gI || (gI = u.createElement("path", { fill: "currentColor", d: "M9.168 3v6.944l1.535-1.535a1 1 0 0 1 1.414 0l.239.24a1 1 0 0 1 0 1.414l-3.383 3.382c-.008.01-.017.018-.026.027l-.239.24a1 1 0 0 1-1.414 0L3.643 10.06a1 1 0 0 1 0-1.414l.239-.239a1 1 0 0 1 1.414 0L6.83 9.941V3a1 1 0 0 1 1-1h.338a1 1 0 0 1 1 1Z" })));
}, ArrowLeft: function(e) {
  return u.createElement("svg", hh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hI || (hI = u.createElement("path", { fill: "currentColor", d: "M13 6.832H6.056L7.59 5.297a1 1 0 0 0 0-1.414l-.24-.239a1 1 0 0 0-1.414 0L2.555 7.027c-.01.008-.018.017-.027.026l-.24.239a1 1 0 0 0 0 1.414l3.652 3.651a1 1 0 0 0 1.414 0l.239-.239a1 1 0 0 0 0-1.414L6.059 9.17H13a1 1 0 0 0 1-1v-.338a1 1 0 0 0-1-1Z" })));
}, ArrowRight: function(e) {
  return u.createElement("svg", mh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mI || (mI = u.createElement("path", { fill: "currentColor", d: "M3 6.832h6.944L8.41 5.297a1 1 0 0 1 0-1.414l.24-.239a1 1 0 0 1 1.414 0l3.382 3.383c.01.008.018.017.027.026l.24.239a1 1 0 0 1 0 1.414l-3.652 3.651a1 1 0 0 1-1.414 0l-.239-.239a1 1 0 0 1 0-1.414L9.941 9.17H3a1 1 0 0 1-1-1v-.338a1 1 0 0 1 1-1Z" })));
}, ArrowUp: function(e) {
  return u.createElement("svg", vh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vI || (vI = u.createElement("path", { fill: "currentColor", d: "M9.168 13V6.056l1.535 1.535a1 1 0 0 0 1.414 0l.239-.24a1 1 0 0 0 0-1.414L8.973 2.555a1.023 1.023 0 0 0-.026-.027l-.239-.24a1 1 0 0 0-1.414 0L3.643 5.94a1 1 0 0 0 0 1.414l.239.239a1 1 0 0 0 1.414 0L6.83 6.059V13a1 1 0 0 0 1 1h.338a1 1 0 0 0 1-1Z" })));
}, Beaker: function(e) {
  return u.createElement("svg", bh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bI || (bI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.953 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C6.333 1 6.473 1 6.753 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219C9.573 3 9.433 3 9.153 3h-2.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219c-.054-.107-.054-.247-.054-.527v-.4Zm.056 2.47c-.056.108-.056.25-.056.535V6l-3.007 5.412c-.663 1.193-.994 1.79-.932 2.277a1.5 1.5 0 0 0 .6 1.02C3.01 15 3.693 15 5.057 15h5.791c1.365 0 2.047 0 2.444-.291a1.5 1.5 0 0 0 .6-1.02c.062-.488-.27-1.084-.932-2.277L9.953 6V4.805c0-.285 0-.427-.056-.535a.5.5 0 0 0-.214-.214C9.575 4 9.433 4 9.148 4h-2.39c-.285 0-.427 0-.536.056a.5.5 0 0 0-.213.214ZM9.333 9l-3.03.5-1.287 2.31c-.218.392-.327.588-.309.748a.5.5 0 0 0 .205.348c.13.094.355.094.802.094h4.48c.447 0 .67 0 .801-.094a.5.5 0 0 0 .205-.348c.019-.16-.09-.355-.307-.746L9.333 9Z", clipRule: "evenodd" })));
}, Bell: function(e) {
  return u.createElement("svg", yh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yI || (yI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.625 6.138a4.656 4.656 0 0 0-3.268-3.925C9.228 1.52 8.67 1 8 1c-.67 0-1.228.52-1.357 1.213a4.656 4.656 0 0 0-3.268 3.925l-.452 3.963h.026a.95.95 0 0 0 0 1.899h10.102a.95.95 0 0 0 0-1.899h.026l-.452-3.963ZM8 15a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z", clipRule: "evenodd" })));
}, Biometric: function(e) {
  return u.createElement("svg", wh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wI || (wI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 1A5.5 5.5 0 0 0 2 6.5v3A5.5 5.5 0 0 0 7.5 15h1A5.5 5.5 0 0 0 14 9.5v-3A5.5 5.5 0 0 0 8.5 1h-1Zm1.074 6.75a.574.574 0 1 0-1.148 0v2.457a.574.574 0 0 0 1.148 0V7.75ZM8 5.338A2.412 2.412 0 0 0 5.588 7.75v2.566a.994.994 0 0 1-.291.704.574.574 0 1 0 .812.812c.402-.402.628-.947.628-1.516V7.75a1.264 1.264 0 1 1 2.527 0v2.648c0 .412-.233.79-.602.973a.574.574 0 0 0 .514 1.028 2.237 2.237 0 0 0 1.236-2V7.75A2.412 2.412 0 0 0 8 5.338ZM4.899 7.75A3.101 3.101 0 0 1 9.64 5.117a.574.574 0 1 0 .609-.974A4.25 4.25 0 0 0 3.75 7.75v2.297a.574.574 0 1 0 1.149 0V7.75Zm6.887-1.932a.574.574 0 1 0-1.023.522c.216.423.338.901.338 1.41v1.378a.574.574 0 1 0 1.149 0V7.75c0-.695-.167-1.352-.464-1.932Z", clipRule: "evenodd" })));
}, Boolean: function(e) {
  return u.createElement("svg", Oh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), OI || (OI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm4 6a4 4 0 0 1-4 4V4a4 4 0 0 1 4 4Z", clipRule: "evenodd" })));
}, Building: function(e) {
  return u.createElement("svg", xh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xI || (xI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v13H6v-2H4v2H1v-4h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1V5h4.5a.5.5 0 0 0 0-1H1V2Zm8 9h4.5a.5.5 0 0 0 0-1H9V8h4.5a.5.5 0 0 0 0-1H9V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10h-2v-2h-2v2H9v-4Z", clipRule: "evenodd" })));
}, Bulb: function(e) {
  return u.createElement("svg", Eh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EI || (EI = u.createElement("path", { fill: "currentColor", d: "M12.331 8.5a5 5 0 1 0-8.612.086L5.408 11.5a1 1 0 0 0 .866.499H6.5V6a1.5 1.5 0 1 1 3 0v6h.224a1 1 0 0 0 .863-.496L12.34 8.5h-.009Z" })), $I || ($I = u.createElement("path", { fill: "currentColor", d: "M7.5 6v6h1V6a.5.5 0 0 0-1 0ZM10 14v-1H6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z" })));
}, Calendar: function(e) {
  return u.createElement("svg", $h({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jI || (jI = u.createElement("path", { fill: "currentColor", d: "M4 2a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0V2Z" })), CI || (CI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 3H7a2 2 0 1 1-4 0 2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 2 2 0 1 1-4 0Zm3 4H9v3h3V7Z", clipRule: "evenodd" })), MI || (MI = u.createElement("path", { fill: "currentColor", d: "M10 3a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1Z" })));
}, Camera: function(e) {
  return u.createElement("svg", jh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kI || (kI = u.createElement("path", { fill: "currentColor", d: "M10.25 8.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })), PI || (PI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.585 3.33a1.5 1.5 0 0 1 1.342-.83h4.146a1.5 1.5 0 0 1 1.342.83l.309.617a1 1 0 0 0 .894.553h.882A1.5 1.5 0 0 1 15 6v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V6a1.5 1.5 0 0 1 1.5-1.5h.882a1 1 0 0 0 .894-.553l.31-.618ZM11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", clipRule: "evenodd" })));
}, Cap: function(e) {
  return u.createElement("svg", Ch({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SI || (SI = u.createElement("path", { fill: "currentColor", d: "M2.97 8.008v2.3l.001.092-.002.262c0 1.926 2.535 2.838 5 2.838 2.466 0 5-.912 5-2.838 0-.085 0-.168-.002-.25.002-.035.002-.07.002-.105V8.001L8.706 9.787a2 2 0 0 1-1.554-.004L2.969 8.008Z" })), NI || (NI = u.createElement("path", { fill: "currentColor", d: "M7.565 2.583a1 1 0 0 1 .794-.002l6.35 2.732a.5.5 0 0 1-.004.92L8.35 8.896a1 1 0 0 1-.778-.001L1.305 6.233a.5.5 0 0 1-.005-.919l6.265-2.73ZM13.97 7.626v1.477a1 1 0 1 0 1 0V7.207l-1 .419Z" })));
}, CaretDown: function(e) {
  return u.createElement("svg", Mh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RI || (RI = u.createElement("path", { fill: "currentColor", d: "M8.679 10.796a.554.554 0 0 1-.858 0L4.64 6.976C4.32 6.594 4.582 6 5.069 6h6.362c.487 0 .748.594.43.976l-3.182 3.82Z" })));
}, CaretLeft: function(e) {
  return u.createElement("svg", kh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _I || (_I = u.createElement("path", { fill: "currentColor", d: "M5.204 8.679a.553.553 0 0 1 0-.858l3.82-3.181c.382-.319.976-.058.976.429v6.362c0 .487-.594.748-.976.43l-3.82-3.182Z" })));
}, CaretRight: function(e) {
  return u.createElement("svg", Ph({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AI || (AI = u.createElement("path", { fill: "currentColor", d: "M10.796 7.321a.554.554 0 0 1 0 .858l-3.82 3.181c-.382.319-.976.058-.976-.429V4.57c0-.487.594-.748.976-.43l3.82 3.182Z" })));
}, CaretUp: function(e) {
  return u.createElement("svg", Sh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LI || (LI = u.createElement("path", { fill: "currentColor", d: "M7.321 5.204a.553.553 0 0 1 .858 0l3.181 3.82c.319.382.058.976-.429.976H4.57c-.487 0-.748-.594-.43-.976l3.182-3.82Z" })));
}, ChartFilled: function(e) {
  return u.createElement("svg", Nh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZI || (ZI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H3Zm8.25 2a.75.75 0 0 0-.75.75v6.25H12V5.25a.75.75 0 0 0-.75-.75ZM7.5 7.25a.75.75 0 0 1 1.5 0v4.25H7.5V7.25ZM5.25 9a.75.75 0 0 0-.75.75v1.75H6V9.75A.75.75 0 0 0 5.25 9Z", clipRule: "evenodd" })));
}, Charts: function(e) {
  return u.createElement("svg", Rh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TI || (TI = u.createElement("path", { fill: "currentColor", d: "M11.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10ZM7.5 14a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1ZM2.5 14a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1Z" })));
}, Checkmark: function(e) {
  return u.createElement("svg", _h({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BI || (BI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.306 9.05 5.455-5.455a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-7.067 7.068a1 1 0 0 1-1.5-.098l-3.049-3.97a1 1 0 0 1 .184-1.402l.595-.457a1.25 1.25 0 0 1 1.753.23L6.306 9.05Z", clipRule: "evenodd" })));
}, CheckmarkWithCircle: function(e) {
  return u.createElement("svg", Ah({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), II || (II = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.448-10.104a.997.997 0 1 1 1.508 1.306l-4.572 5.28a1 1 0 0 1-1.64-.07l-1.82-2.868a1 1 0 1 1 1.69-1.07l1.1 1.734 3.734-4.312Z", clipRule: "evenodd" })));
}, ChevronDown: function(e) {
  return u.createElement("svg", Lh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HI || (HI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.636 5.364a1 1 0 0 0 0 1.414l4.95 4.95.707.707a1 1 0 0 0 1.414 0l.707-.707 4.95-4.95a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L8 8.899 3.757 4.657a1 1 0 0 0-1.414 0l-.707.707Z", clipRule: "evenodd" })));
}, ChevronLeft: function(e) {
  return u.createElement("svg", Zh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DI || (DI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.778 1.636a1 1 0 0 0-1.414 0l-4.95 4.95-.707.707a1 1 0 0 0 0 1.414l.707.707 4.95 4.95a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L7.243 8l4.242-4.243a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, ChevronRight: function(e) {
  return u.createElement("svg", Th({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zI || (zI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.364 14.364a1 1 0 0 0 1.414 0l4.95-4.95.707-.707a1 1 0 0 0 0-1.414l-.707-.707-4.95-4.95a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L8.899 8l-4.242 4.243a1 1 0 0 0 0 1.414l.707.707Z", clipRule: "evenodd" })));
}, ChevronUp: function(e) {
  return u.createElement("svg", Bh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FI || (FI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.364 10.778a1 1 0 0 0 0-1.414l-4.95-4.95-.707-.707a1 1 0 0 0-1.414 0l-.707.707-4.95 4.95a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0L8 7.243l4.243 4.242a1 1 0 0 0 1.414 0l.707-.707Z", clipRule: "evenodd" })));
}, Clock: function(e) {
  return u.createElement("svg", Ih({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VI || (VI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.25a.75.75 0 0 1 1.5 0v3.16l1.744 1.526a.75.75 0 0 1-.988 1.128L7.511 8.818a.761.761 0 0 1-.19-.25.747.747 0 0 1-.071-.318v-3.5Z", clipRule: "evenodd" })));
}, ClockWithArrow: function(e) {
  return u.createElement("svg", Hh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qI || (qI = u.createElement("path", { fill: "currentColor", d: "M13 8a5 5 0 0 1-7.304 4.438c-.348-.18-.787-.13-1.038.172l-.33.398c-.276.33-.22.828.152 1.044a7 7 0 1 0-1.452-10.98L1.97 2.146a.584.584 0 0 0-.964.521l.455 3.252c.04.287.285.51.576.511H5.32a.58.58 0 0 0 .387-1.018l-1.168-1.02A5 5 0 0 1 13 8Z" })), UI || (UI = u.createElement("path", { fill: "currentColor", d: "M7.25 5.25a.75.75 0 0 1 1.5 0v2.668l1.68 1.524a.75.75 0 1 1-.988 1.129L7.507 8.815a.758.758 0 0 1-.257-.565v-3Z" })));
}, Clone: function(e) {
  return u.createElement("svg", Dh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WI || (WI = u.createElement("path", { fill: "currentColor", d: "M5.5 12a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v4Z" })), GI || (GI = u.createElement("path", { fill: "currentColor", d: "M4.25 10H3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.75h-2V4h-5v4h.75v2Z" })));
}, Cloud: function(e) {
  return u.createElement("svg", zh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KI || (KI = u.createElement("path", { fill: "currentColor", d: "M12.571 8.143c0 1.775-.899 3.34-2.267 4.264l-.014.01a5.12 5.12 0 0 1-2.861.869H2.857a2.857 2.857 0 0 1-.545-5.663 5.144 5.144 0 0 1 10.26.52ZM13.821 8.143a6.38 6.38 0 0 1-2.358 4.96 3.429 3.429 0 1 0 2.17-6.506c.123.494.188 1.013.188 1.546Z" })));
}, Code: function(e) {
  return u.createElement("svg", Fh({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YI || (YI = u.createElement("path", { fill: "currentColor", d: "M6.11 13.262a.5.5 0 0 0 .395.586l.737.143a.5.5 0 0 0 .585-.396L9.926 2.738a.5.5 0 0 0-.396-.586l-.737-.143a.5.5 0 0 0-.585.396L6.109 13.262ZM1.36 7.246 3.976 5.11a.507.507 0 0 1 .704.063l.64.752a.483.483 0 0 1-.064.69L3.562 7.998 5.256 9.38c.212.173.24.482.064.69l-.64.752a.507.507 0 0 1-.704.062L1.36 8.75A.971.971 0 0 1 1 7.998c0-.29.132-.566.36-.752ZM14.636 7.246 12.02 5.11a.507.507 0 0 0-.704.063l-.64.752a.483.483 0 0 0 .064.69l1.694 1.382L10.74 9.38a.483.483 0 0 0-.064.69l.64.752a.507.507 0 0 0 .704.062l2.616-2.134a.971.971 0 0 0 .36-.752.971.971 0 0 0-.36-.752Z" })));
}, CodeBlock: function(e) {
  return u.createElement("svg", Vh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XI || (XI = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4H3v8h10V4ZM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Z", clipRule: "evenodd" })), QI || (QI = u.createElement("path", { fill: "currentColor", d: "M4.221 7.421 6.256 5.78a.398.398 0 0 1 .548.048l.498.578a.368.368 0 0 1-.05.53L5.934 8l1.318 1.063c.165.133.187.37.05.53l-.498.58a.398.398 0 0 1-.548.047L4.221 8.58A.744.744 0 0 1 3.941 8c0-.224.103-.436.28-.579ZM11.779 7.421 9.744 5.78a.398.398 0 0 0-.548.048l-.498.578a.368.368 0 0 0 .05.53L10.066 8 8.748 9.063a.368.368 0 0 0-.05.53l.498.58c.138.159.383.18.548.047l2.035-1.641a.744.744 0 0 0 .28-.579.744.744 0 0 0-.28-.579Z" })));
}, Colon: function(e) {
  return u.createElement("svg", qh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JI || (JI = u.createElement("path", { fill: "currentColor", d: "M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
}, Connect: function(e) {
  return u.createElement("svg", Uh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eH || (eH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.867 8.898a4.048 4.048 0 0 0 .687-4.8l1.275-1.275a.584.584 0 0 0 0-.826l-.826-.826a.584.584 0 0 0-.826 0l-1.29 1.29a4.048 4.048 0 0 0-4.734.722L5.277 5.058a.323.323 0 0 0-.041.035L3.182 7.148a4.048 4.048 0 0 0-.72 4.738l-1.29 1.29a.584.584 0 0 0 0 .827l.825.826a.584.584 0 0 0 .826 0l1.278-1.278a4.048 4.048 0 0 0 4.795-.689l1.876-1.875a.324.324 0 0 0 .041-.035l2.054-2.054ZM6.561 6.776 4.685 8.65a1.916 1.916 0 0 0 0 2.707c.747.746 1.961.747 2.707 0l2.055-2.054a.321.321 0 0 1 .04-.035l1.877-1.875a1.916 1.916 0 0 0 0-2.707 1.916 1.916 0 0 0-2.707 0L6.602 6.74a.32.32 0 0 1-.04.035Z", clipRule: "evenodd" })));
}, Copy: function(e) {
  return u.createElement("svg", Wh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tH || (tH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 5.714v4.572C1 11.233 1.768 12 2.714 12H5.75V7.11c0-.566.227-1.108.63-1.504l2.294-2.252c.1-.099.21-.186.326-.262v-.378C9 1.768 8.232 1 7.286 1H5.8v3.429c0 .71-.576 1.285-1.286 1.285H1Zm8-.928L7.257 6.498A.857.857 0 0 0 7 7.11v.688h3.01a.857.857 0 0 0 .857-.858V4h-.717a.857.857 0 0 0-.6.246l-.55.54ZM4.867 1H4.15a.857.857 0 0 0-.601.246L1.257 3.498A.857.857 0 0 0 1 4.11v.688h3.01a.857.857 0 0 0 .857-.858V1ZM7 12V8.714H10.514c.71 0 1.286-.575 1.286-1.285V4h1.486C14.233 4 15 4.768 15 5.714v7.572c0 .947-.768 1.714-1.714 1.714H8.714A1.714 1.714 0 0 1 7 13.286V12Z", clipRule: "evenodd" })));
}, CreditCard: function(e) {
  return u.createElement("svg", Gh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nH || (nH = u.createElement("path", { fill: "currentColor", d: "M3 3a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2H3ZM15 7H1v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7Z" })));
}, CurlyBraces: function(e) {
  return u.createElement("svg", Kh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rH || (rH = u.createElement("path", { fill: "currentColor", d: "M3 3.544a2.5 2.5 0 0 1 2.5-2.5h1a.5.5 0 0 1 .5.5v1.105a.353.353 0 0 1-.353.353h-.79A.858.858 0 0 0 5 3.86v2.802a1.5 1.5 0 0 1-.816 1.335A1.5 1.5 0 0 1 5 9.332v2.803c0 .473.384.857.858.857h.789c.195 0 .353.158.353.353v1.105a.5.5 0 0 1-.5.5h-1a2.5 2.5 0 0 1-2.5-2.5v-1.956a1.5 1.5 0 0 0-1.5-1.5.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-1.95ZM13 12.45a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1-.5-.5v-1.105c0-.195.158-.353.353-.353h.79a.858.858 0 0 0 .857-.858V9.332a1.5 1.5 0 0 1 .816-1.335A1.5 1.5 0 0 1 11 6.662V3.859a.858.858 0 0 0-.858-.857h-.789A.353.353 0 0 1 9 2.65V1.544a.5.5 0 0 1 .5-.5h1a2.5 2.5 0 0 1 2.5 2.5V5.5A1.5 1.5 0 0 0 14.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0-1.5 1.5v1.95Z" })));
}, Cursor: function(e) {
  return u.createElement("svg", Yh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aH || (aH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m8.534 8.534.473-.27 2.389-1.366-6.748-2.25 2.25 6.748 1.366-2.389.27-.473ZM10 10l4.48-2.563c.734-.333.678-1.393-.086-1.648L3.169 2.047A.887.887 0 0 0 2.047 3.17l3.742 11.225c.255.764 1.315.82 1.648.086L10 10Z", clipRule: "evenodd" })));
}, Dashboard: function(e) {
  return u.createElement("svg", Xh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lH || (lH = u.createElement("path", { fill: "currentColor", d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6ZM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6ZM7 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3ZM2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z" })));
}, Database: function(e) {
  return u.createElement("svg", Qh({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iH || (iH = u.createElement("path", { fill: "currentColor", d: "M13.5 4.452c0 .09 0 .177-.002.262l.002.094v.23c0 .3-.136.588-.433.87-.302.289-.75.548-1.305.765-1.11.434-2.541.656-3.762.656-1.22 0-2.652-.222-3.762-.656-.555-.217-1.003-.476-1.305-.764-.297-.283-.433-.571-.433-.872v-.229c0-.035 0-.07.002-.105a12.886 12.886 0 0 1-.002-.251C2.5 2.517 5.288 1.6 8 1.6s5.5.917 5.5 2.852Z" })), oH || (oH = u.createElement("path", { fill: "currentColor", d: "M2.5 6.747v1.957c0 .3.136.589.433.871.302.288.75.548 1.305.765 1.11.433 2.541.656 3.762.656 1.22 0 2.652-.223 3.762-.656.555-.217 1.003-.477 1.305-.765.297-.282.433-.57.433-.87V6.746c-.392.318-.88.575-1.405.78-1.236.483-2.784.719-4.095.719-1.31 0-2.859-.236-4.095-.72-.525-.204-1.013-.461-1.405-.779Z" })), sH || (sH = u.createElement("path", { fill: "currentColor", d: "M12.095 11.194c.525-.205 1.013-.462 1.405-.78v.811c0 .035 0 .07-.002.105l.002.251c0 1.936-2.788 2.852-5.5 2.852s-5.5-.916-5.5-2.852c0-.088 0-.176.002-.262a2.322 2.322 0 0 1-.002-.094v-.811c.392.318.88.575 1.405.78 1.236.483 2.784.718 4.095.718 1.31 0 2.859-.235 4.095-.719Z" })));
}, Diagram: function(e) {
  return u.createElement("svg", Jh({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cH || (cH = u.createElement("path", { fill: "currentColor", d: "M6 2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H8.5v2h4.75a.75.75 0 0 1 .75.75V10h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H13V8H8.5v2H9a.75.75 0 0 1 .75.75v1.5A.75.75 0 0 1 9 13H7a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 7 10h.5V8H3v2h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H2V7.75A.75.75 0 0 1 2.75 7H7.5V5h-.75A.75.75 0 0 1 6 4.25v-1.5Z" })));
}, Diagram2: function(e) {
  return u.createElement("svg", e3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uH || (uH = u.createElement("path", { fill: "currentColor", d: "M10.72 1c-.398 0-.72.336-.72.75V2H7.48a.49.49 0 0 0-.48.5V7H5v-.25C5 6.336 4.678 6 4.28 6H1.72c-.398 0-.72.336-.72.75v1.5c0 .414.322.75.72.75h2.56c.398 0 .72-.336.72-.75V8h2v4.5c0 .276.215.5.48.5H10v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V12H8V8h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V7H8V3h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06Z" })));
}, Diagram3: function(e) {
  return u.createElement("svg", t3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), fH || (fH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.75 1a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 5 3.25v-1.5A.75.75 0 0 0 4.25 1h-2.5Zm9.25.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm0 9a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm-10 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5ZM6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z", clipRule: "evenodd" })));
}, Disconnect: function(e) {
  return u.createElement("svg", n3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dH || (dH = u.createElement("path", { fill: "currentColor", d: "M7.093 3.671a.317.317 0 0 1 0-.448L8.14 2.175a4.024 4.024 0 0 1 5.685 0 4.024 4.024 0 0 1 0 5.685l-1.048 1.047a.317.317 0 0 1-.448 0L11.28 7.86a.317.317 0 0 1 0-.449l1.048-1.047a1.906 1.906 0 0 0 0-2.693 1.906 1.906 0 0 0-2.693 0L8.59 4.718a.317.317 0 0 1-.449 0L7.093 3.671ZM1.293 1.293a1.001 1.001 0 0 1 1.416 0l11.998 11.998a1.001 1.001 0 0 1-1.416 1.416l-3.159-3.16-2.272 2.277a4.024 4.024 0 0 1-5.685 0 4.024 4.024 0 0 1 0-5.684l2.273-2.277L1.293 2.71a1.001 1.001 0 0 1 0-1.416Zm4.65 6.066L3.672 9.636a1.906 1.906 0 0 0 0 2.693c.743.742 1.95.742 2.693 0l2.272-2.277-2.692-2.693Z" })));
}, Download: function(e) {
  return u.createElement("svg", r3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pH || (pH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.524 2.575v5.557h1.712c.706 0 1.033.783.5 1.196l-3.237 2.506a.832.832 0 0 1-.998 0L4.265 9.328c-.534-.413-.207-1.196.499-1.196h1.611V2.575a1.575 1.575 0 0 1 3.15 0ZM2.5 11h1.8l2.405 1.862a2.132 2.132 0 0 0 2.59 0L11.7 11h1.8a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3Z", clipRule: "evenodd" })));
}, Drag: function(e) {
  return u.createElement("svg", a3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gH || (gH = u.createElement("path", { fill: "currentColor", d: "M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
}, Edit: function(e) {
  return u.createElement("svg", l3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hH || (hH = u.createElement("path", { fill: "currentColor", d: "M10.922.681a.963.963 0 0 1 1.362 0l1.363 1.363a.963.963 0 0 1 0 1.362L12.284 4.77 9.56 2.044 8.538 3.066l2.724 2.725-7.153 7.153-3.747 1.022 1.022-3.747L10.922.68Z" })));
}, Ellipsis: function(e) {
  return u.createElement("svg", i3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mH || (mH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6.75 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", clipRule: "evenodd" })));
}, Email: function(e) {
  return u.createElement("svg", o3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vH || (vH = u.createElement("path", { fill: "currentColor", d: "m2.494 4 4.714 5.05a1.068 1.068 0 0 0 1.584 0L13.505 4H2.494ZM1.133 4.256A2.12 2.12 0 0 0 1 5v6c0 .369.093.715.256 1.011L4.814 8.2l-3.68-3.944Z" })), bH || (bH = u.createElement("path", { fill: "currentColor", d: "M2.867 13c-.348 0-.674-.102-.953-.28l3.56-3.813 1.219 1.306a1.78 1.78 0 0 0 2.64 0l1.346-1.443 3.575 3.83c-.313.251-.7.4-1.12.4H2.866ZM14.84 11.813c.103-.248.16-.523.16-.813V5c0-.255-.045-.5-.126-.724l-3.535 3.787 3.5 3.75Z" })));
}, Escalation: function(e) {
  return u.createElement("svg", s3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yH || (yH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.361 4.423a.556.556 0 0 0-.26-.97L5.146 2.009a.556.556 0 0 0-.636.69l1.787 6.672a.556.556 0 0 0 .896.28l6.168-5.228ZM2.911 2.102a.556.556 0 0 0-.392.68l3.163 11.806a.556.556 0 1 0 1.074-.287L3.592 2.493a.556.556 0 0 0-.68-.392Z", clipRule: "evenodd" })));
}, Export: function(e) {
  return u.createElement("svg", c3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wH || (wH = u.createElement("path", { fill: "currentColor", d: "M14.623 5.186a.278.278 0 0 0 0-.385l-2.805-2.915a.277.277 0 0 0-.477.192v1.424A6.5 6.5 0 0 0 5 10v.1a1.5 1.5 0 0 0 3 0V10a3.5 3.5 0 0 1 3.34-3.496v1.405c0 .25.305.373.478.193l2.805-2.916Z" })), OH || (OH = u.createElement("path", { fill: "currentColor", d: "M6.5 3.879a.75.75 0 0 0-.75-.75H4a2 2 0 0 0-2 2v6.864a2 2 0 0 0 2 2h6.864a2 2 0 0 0 2-2V10.05a.75.75 0 0 0-1.5 0v1.943a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V5.129a.5.5 0 0 1 .5-.5h1.75a.75.75 0 0 0 .75-.75Z" })));
}, Favorite: function(e) {
  return u.createElement("svg", u3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xH || (xH = u.createElement("path", { fill: "currentColor", d: "M7.538 1.11a.5.5 0 0 1 .924 0l1.537 3.696a.5.5 0 0 0 .421.306l3.99.32a.5.5 0 0 1 .285.878l-3.04 2.604a.5.5 0 0 0-.16.496l.928 3.893a.5.5 0 0 1-.747.542L8.261 11.76a.5.5 0 0 0-.522 0l-3.415 2.086a.5.5 0 0 1-.747-.542l.928-3.893a.5.5 0 0 0-.16-.496L1.304 6.31a.5.5 0 0 1 .285-.878l3.99-.32A.5.5 0 0 0 6 4.806L7.538 1.11Z" })));
}, Federation: function(e) {
  return u.createElement("svg", f3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EH || (EH = u.createElement("path", { fill: "currentColor", d: "M8 0c1.6 0 2.8 1.3 2.8 3 0 1.5-1 2.7-2.3 3v2.1l3.1 2.4c.4-.3 1-.5 1.5-.5 1.6 0 2.8 1.3 2.8 3s-1.3 3-2.8 3c-1.6 0-2.8-1.3-2.8-3 0-.7.2-1.3.6-1.8L8 9l-2.9 2.2c.4.5.6 1.1.6 1.8 0 1.7-1.3 3-2.8 3C1.4 16 0 14.7 0 13s1.3-3 2.8-3c.6 0 1.1.2 1.5.5l3.1-2.4V5.9C6.2 5.7 5.2 4.5 5.2 3c0-1.7 1.2-3 2.8-3Zm0 5c.8 0 1.9-.8 1.9-2C9.9 1.9 9 1 8 1c-1 0-1.9.9-1.9 2 0 1.2 1 2 1.9 2Zm-5.2 6c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.8-2-1.9-2Zm10.4 0c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.9-2-1.9-2Z" })));
}, File: function(e) {
  return u.createElement("svg", d3({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $H || ($H = u.createElement("path", { fill: "currentColor", d: "M3 13V7h4.5A1.5 1.5 0 0 0 9 5.5V1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" })), jH || (jH = u.createElement("path", { fill: "currentColor", d: "M7.833 1h-.919a1 1 0 0 0-.707.293L3.293 4.207A1 1 0 0 0 3 4.914v.92h3.833a1 1 0 0 0 1-1V1Z" })));
}, Filter: function(e) {
  return u.createElement("svg", p3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CH || (CH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 6.148-3.8-3.94C1.797 1.79 2.044 1 2.576 1h10.848c.532 0 .779.79.377 1.208L10 6.148v5.625a.5.5 0 0 1-.17.376l-3 2.625a.5.5 0 0 1-.83-.376v-8.25Z", clipRule: "evenodd" })));
}, FullScreenEnter: function(e) {
  return u.createElement("svg", h3({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kH || (kH = u.createElement("path", { fill: "currentColor", d: "M1.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM15 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM1.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM14.5 14a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, FullScreenExit: function(e) {
  return u.createElement("svg", m3({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PH || (PH = u.createElement("path", { fill: "currentColor", d: "M10.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM6 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM10.5 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM5.5 7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, Folder: function(e) {
  return u.createElement("svg", g3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MH || (MH = u.createElement("path", { fill: "currentColor", d: "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1 1 1 0 0 0-1-1H2Z" })));
}, Gauge: function(e) {
  return u.createElement("svg", v3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SH || (SH = u.createElement("path", { fill: "currentColor", d: "M1.041 10.251c-.044.412.296.749.71.749h2.494c.414 0 .74-.34.843-.742A3.006 3.006 0 0 1 8.791 8.1l2.99-2.991a7 7 0 0 0-10.74 5.142ZM13.297 6.422l-2.842 2.842c.213.3.368.638.459.994.102.401.429.742.843.742h2.494c.414 0 .754-.337.71-.749a7.001 7.001 0 0 0-1.664-3.829Z" })));
}, GlobeAmericas: function(e) {
  return u.createElement("svg", b3({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NH || (NH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-5.301 4.699A4.73 4.73 0 0 1 5 11.683V10L3.257 8.257A4.75 4.75 0 0 1 8 3.25V4.5L6.5 6v1l-.5.5-.5-.5-1 1 .5.5h2.5L8 9v1l-1 1 1.699 1.699Zm4.047-4.496a4.73 4.73 0 0 0-.924-3.025L10.5 6.5V9h1.25l.996-.797Z", clipRule: "evenodd" })));
}, GovernmentBuilding: function(e) {
  return u.createElement("svg", y3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RH || (RH = u.createElement("path", { fill: "currentColor", d: "M11 5V4a3 3 0 0 0-6 0v1h6Z" })), _H || (_H = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 6a.5.5 0 0 0 0 1H2v6h-.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H14V7h.5a.5.5 0 0 0 0-1h-13Zm3 2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3ZM8 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 8Zm2.5.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z", clipRule: "evenodd" })));
}, Hash: function(e) {
  return u.createElement("svg", w3({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AH || (AH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.616 1.5a.5.5 0 0 0-.492.413L9.668 4.5h-2.47l.426-2.413A.5.5 0 0 0 7.13 1.5H6.116a.5.5 0 0 0-.492.413L5.168 4.5H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.815l-.53 3H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.933l-.425 2.413A.5.5 0 0 0 4 14.5h1.016a.5.5 0 0 0 .492-.413l.456-2.587h2.47l-.426 2.413a.5.5 0 0 0 .492.587h1.016a.5.5 0 0 0 .492-.413l.456-2.587H13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.683l.529-3H13.5A.5.5 0 0 0 14 6V5a.5.5 0 0 0-.5-.5h-1.802l.426-2.413a.5.5 0 0 0-.492-.587h-1.016Zm-4.3 8h2.47l.529-3h-2.47l-.528 3Z", clipRule: "evenodd" })));
}, Highlight: function(e) {
  return u.createElement("svg", O3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LH || (LH = u.createElement("path", { fill: "currentColor", d: "M8.853 12.031A.1.1 0 0 1 8.926 12h5.824a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25H7.231a.1.1 0 0 1-.072-.168l1.694-1.8ZM4.019 9.193l.375-.374L7.576 12l-.375.375a1 1 0 0 1-.779.29l-.574-.04a1 1 0 0 0-.778.29l-.141.14-1.591-1.59.141-.142a1 1 0 0 0 .29-.778l-.04-.573a1 1 0 0 1 .29-.779ZM11.433 1.779a1 1 0 0 1 1.415 0l1.767 1.768a1 1 0 0 1 0 1.414L8.28 11.296 5.098 8.114l6.335-6.335ZM2.632 12.167l1.593 1.593-.17.172a.25.25 0 0 1-.178.074H1.386a.25.25 0 0 1-.176-.428l1.422-1.41Z" })));
}, Home: function(e) {
  return u.createElement("svg", x3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZH || (ZH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.687 1.751a.5.5 0 0 1 .626 0l6.433 5.164a.5.5 0 0 1 .069.713l-.644.761a.5.5 0 0 1-.697.065L8.316 4.257a.5.5 0 0 0-.632 0L2.526 8.454a.5.5 0 0 1-.697-.065l-.644-.76a.5.5 0 0 1 .07-.714l6.432-5.164Z", clipRule: "evenodd" })), TH || (TH = u.createElement("path", { fill: "currentColor", d: "M7.688 5.25a.5.5 0 0 1 .624 0l4.5 3.6a.5.5 0 0 1 .188.39v4.26a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9.24a.5.5 0 0 1 .188-.39l4.5-3.6Z" })));
}, HorizontalDrag: function(e) {
  return u.createElement("svg", E3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BH || (BH = u.createElement("path", { fill: "currentColor", d: "M4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" })));
}, Import: function(e) {
  return u.createElement("svg", $3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IH || (IH = u.createElement("path", { fill: "currentColor", d: "M11.623 8.799a.278.278 0 0 0 0-.385L8.818 5.498a.277.277 0 0 0-.477.193v1.405A3.5 3.5 0 0 1 5 3.6v-.1a1.5 1.5 0 1 0-3 0v.1a6.5 6.5 0 0 0 6.34 6.498v1.424c0 .25.305.372.478.192L11.623 8.8Z" })), HH || (HH = u.createElement("path", { fill: "currentColor", d: "M3.95 11a.75.75 0 0 1 1.5 0v1.75a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V5.886a.5.5 0 0 0-.5-.5h-1.943a.75.75 0 0 1 0-1.5h1.943a2 2 0 0 1 2 2v6.864a2 2 0 0 1-2 2H5.95a2 2 0 0 1-2-2V11Z" })));
}, ImportantWithCircle: function(e) {
  return u.createElement("svg", j3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DH || (DH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 4.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, InfoWithCircle: function(e) {
  return u.createElement("svg", C3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zH || (zH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 0 1 1 1v4h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7h-.5a.5.5 0 0 1 0-1H8Z", clipRule: "evenodd" })));
}, InternalEmployee: function(e) {
  return u.createElement("svg", M3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FH || (FH = u.createElement("path", { fill: "currentColor", d: "M6.5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h8.774l-.003-.05-.03-.022s-2.834-2.213-1.27-5.622c-.263-.055-.56.005-.814.144A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), VH || (VH = u.createElement("path", { fill: "currentColor", d: "M12.746 7.003c-.36-.448-.672-.903-.736-.998a.016.016 0 0 0-.023 0c-.063.095-.373.55-.732.998-3.084 4.137.486 6.925.486 6.925l.03.021c.026.431.093 1.051.093 1.051h.266s.067-.617.093-1.05l.03-.025c.004.003 3.577-2.785.493-6.922ZM12 13.87s-.16-.144-.203-.217v-.007l.193-4.505c0-.014.02-.014.02 0l.193 4.505v.007a1.522 1.522 0 0 1-.203.217Z" })));
}, InviteUser: function(e) {
  return u.createElement("svg", k3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qH || (qH = u.createElement("path", { fill: "currentColor", d: "M8.418 7.428a3.5 3.5 0 1 0-3.836-5.856 3.5 3.5 0 0 0 3.836 5.856ZM3.091 8.562c.308-.357.838-.339 1.252-.112.64.35 1.375.55 2.157.55s1.517-.2 2.157-.55c.414-.227.944-.245 1.252.112.11.128.214.263.31.403A1.996 1.996 0 0 0 9.5 10.5 2 2 0 0 0 8.177 14H2v-2.5c0-1.123.411-2.15 1.091-2.938Z" })), UH || (UH = u.createElement("path", { fill: "currentColor", d: "M10.5 10.5a.998.998 0 0 1 1-1 1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1Z" })));
}, Key: function(e) {
  return u.createElement("svg", P3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WH || (WH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.015 10.03c.652 0 1.267-.155 1.811-.43l1.512 1.51-.921.921a.669.669 0 0 0 0 .946l.827.827a.669.669 0 0 0 .946 0l.92-.92.75.749a1.254 1.254 0 0 0 1.773-1.773L9.599 7.827a4.015 4.015 0 1 0-3.584 2.204Zm-.753-3.513a1.255 1.255 0 1 0 0-2.51 1.255 1.255 0 0 0 0 2.51Z", clipRule: "evenodd" })));
}, Laptop: function(e) {
  return u.createElement("svg", S3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GH || (GH = u.createElement("path", { fill: "currentColor", d: "M5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 6ZM5.5 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })), KH || (KH = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a1 1 0 0 0-1 1v7.813l-.29.49a.91.91 0 0 0-.068.1L1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.642-1.096a.901.901 0 0 0-.067-.1L14 11.313V3.5a1 1 0 0 0-1-1H3ZM12.5 4h-9v6.5h9V4Z", clipRule: "evenodd" })));
}, LightningBolt: function(e) {
  return u.createElement("svg", N3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YH || (YH = u.createElement("path", { fill: "currentColor", d: "M9.223 1.993c0-.497-.66-.68-.922-.256l-4.227 6.85a.493.493 0 0 0 .423.75h2.28v4.67c0 .497.66.68.921.257l4.228-6.852a.492.492 0 0 0-.424-.75h-2.28V1.993Z" })));
}, Link: function(e) {
  return u.createElement("svg", R3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XH || (XH = u.createElement("path", { fill: "currentColor", d: "M6.039 9.953a3.596 3.596 0 0 1-.327-.38l1.45-1.445a1.553 1.553 0 0 0 2.496.423l2.885-2.87a1.57 1.57 0 0 0 .01-2.213 1.553 1.553 0 0 0-2.203-.01l-.379.377A.995.995 0 0 1 8.56 3.83a1.005 1.005 0 0 1 .006-1.418l.38-.377a3.542 3.542 0 0 1 5.024.023 3.58 3.58 0 0 1-.022 5.047l-2.884 2.871a3.542 3.542 0 0 1-5.025-.022Z" })), QH || (QH = u.createElement("path", { fill: "currentColor", d: "M9.961 6.047c.12.12.228.248.327.38l-1.45 1.445a1.553 1.553 0 0 0-2.496-.423l-2.885 2.87a1.57 1.57 0 0 0-.01 2.213 1.553 1.553 0 0 0 2.203.01l.379-.377a.995.995 0 0 1 1.411.006 1.005 1.005 0 0 1-.006 1.418l-.38.377a3.542 3.542 0 0 1-5.024-.023 3.58 3.58 0 0 1 .022-5.047l2.884-2.871a3.542 3.542 0 0 1 5.025.022Z" })));
}, List: function(e) {
  return u.createElement("svg", _3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JH || (JH = u.createElement("path", { fill: "currentColor", d: "M3.125 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.125 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.875 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM6.625 3a1 1 0 0 0 0 2h6.5a1 1 0 1 0 0-2h-6.5ZM5.625 8a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1ZM6.625 11a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2h-6.5Z" })));
}, Lock: function(e) {
  return u.createElement("svg", A3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eD || (eD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7V5a4 4 0 1 1 8 0v2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm2-2a2 2 0 1 1 4 0v2H6V5Zm2.587 5.81A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, LogIn: function(e) {
  return u.createElement("svg", L3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tD || (tD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3a1 1 0 0 1 1-1h4.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H3v8h3.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H2a1 1 0 0 1-1-1V3Z", clipRule: "evenodd" })), nD || (nD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.495 4.116 6.293 7.318a1 1 0 0 0 0 1.414l3.202 3.202a.75.75 0 0 0 1.06 0l.354-.353a.75.75 0 0 0 0-1.061L9.389 9h4.861a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75H9.44l1.469-1.47a.75.75 0 0 0 0-1.06l-.354-.354a.75.75 0 0 0-1.06 0Z", clipRule: "evenodd" })));
}, LogOut: function(e) {
  return u.createElement("svg", Z3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rD || (rD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 3c0-.552.446-1 .995-1h4.23c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75H3.49v8h3.235c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75h-4.23a.998.998 0 0 1-.995-1V3Z", clipRule: "evenodd" })), aD || (aD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11.022 11.909 3.187-3.202a1.003 1.003 0 0 0 0-1.414L11.022 4.09a.744.744 0 0 0-1.056 0l-.352.354a.753.753 0 0 0 0 1.06l1.513 1.52H6.29a.748.748 0 0 0-.746.75v.5c0 .414.334.75.746.75h4.788l-1.463 1.47a.753.753 0 0 0 0 1.06l.352.354a.744.744 0 0 0 1.056 0Z", clipRule: "evenodd" })));
}, MagnifyingGlass: function(e) {
  return u.createElement("svg", T3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lD || (lD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.323 9.819a5.302 5.302 0 0 0 6.463.805l4.144 4.144a1.3 1.3 0 1 0 1.838-1.838l-4.144-4.144a5.302 5.302 0 0 0-8.3-6.463 5.3 5.3 0 0 0 0 7.496ZM7.98 4.162A2.7 2.7 0 1 1 4.162 7.98 2.7 2.7 0 0 1 7.98 4.162Z", clipRule: "evenodd" })));
}, Megaphone: function(e) {
  return u.createElement("svg", B3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iD || (iD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 3 5.725-1.636A1 1 0 0 1 13 2.326v7.348a1 1 0 0 1-1.275.962L6 9H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3Zm-.657 7H3v5h2.98a1 1 0 0 0 .918-1.396L5.343 10ZM16 6a2 2 0 0 1-2 2V4a2 2 0 0 1 2 2Z", clipRule: "evenodd" })));
}, Menu: function(e) {
  return u.createElement("svg", I3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oD || (oD = u.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
}, Minus: function(e) {
  return u.createElement("svg", H3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sD || (sD = u.createElement("path", { fill: "currentColor", d: "M3 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3Z" })));
}, Mobile: function(e) {
  return u.createElement("svg", D3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cD || (cD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H5v10h6V3ZM5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z", clipRule: "evenodd" })));
}, MultiDirectionArrow: function(e) {
  return u.createElement("svg", z3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uD || (uD = u.createElement("path", { fill: "currentColor", d: "M5 8.573v4.854c0 .53-.608.774-.928.374L2.13 11.374a.607.607 0 0 1 0-.748l1.943-2.427c.32-.4.928-.155.928.374Z" })), fD || (fD = u.createElement("path", { fill: "currentColor", d: "M5 10h7.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5v-2ZM11 7.427V2.573c0-.53.608-.775.928-.374l1.943 2.427a.607.607 0 0 1 0 .748l-1.943 2.427c-.32.4-.928.155-.928-.374ZM3 4.5a.5.5 0 0 1 .5-.5H11v2H3.5a.5.5 0 0 1-.5-.5v-1Z" })));
}, MultiLayers: function(e) {
  return u.createElement("svg", F3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dD || (dD = u.createElement("path", { fill: "currentColor", d: "m12.431 9.745-.26-.121.26-.122a1.99 1.99 0 0 0 .758-.597c.197-.252.311-.576.311-.9 0-.324-.114-.637-.311-.9a2.073 2.073 0 0 0-.758-.597l-.29-.142.217-.101c.301-.142.571-.344.758-.597.197-.253.311-.577.311-.9 0-.324-.114-.638-.311-.9a2.073 2.073 0 0 0-.758-.598L9.194 1.763A2.9 2.9 0 0 0 7.97 1.5c-.415 0-.84.08-1.225.263L3.57 3.27c-.301.142-.57.344-.758.597a1.483 1.483 0 0 0-.311.9c0 .324.114.638.311.901.197.253.457.455.758.597l.29.142-.217.1c-.301.142-.571.345-.758.598a1.483 1.483 0 0 0-.311.9c0 .324.114.637.311.9.197.253.457.456.758.597l.259.122-.26.121c-.3.142-.57.344-.757.597a1.484 1.484 0 0 0-.311.9c0 .324.114.638.311.9.197.254.457.456.758.598l3.165 1.497c.384.182.809.263 1.224.263.415 0 .84-.08 1.225-.263l3.165-1.497c.3-.142.57-.344.757-.597.197-.253.312-.577.312-.9 0-.324-.114-.638-.312-.901a2.073 2.073 0 0 0-.757-.597h.01Zm-4.39 3.248c-.207 0-.404-.04-.54-.112l-3.164-1.497c-.114-.05-.166-.111-.187-.132l.02-.02.167-.111 1.36-.637 1.13.536c.384.182.81.263 1.225.263.415 0 .84-.081 1.224-.263l1.132-.536 1.359.637c.114.05.166.111.187.131l-.021.02-.166.112-3.165 1.497a1.28 1.28 0 0 1-.54.112h-.02ZM4.14 8.005l.02-.02.166-.111 1.318-.628 1.1.516c.384.182.81.263 1.225.263.415 0 .84-.08 1.224-.263l1.173-.556 1.39.657c.115.051.167.112.187.132l-.02.02-.166.111-3.165 1.498a1.28 1.28 0 0 1-.54.111c-.208 0-.405-.04-.54-.111L4.347 8.126c-.114-.05-.166-.11-.187-.131l-.02.01Zm-.073-3.237.02-.02.167-.112L7.419 3.14a1.28 1.28 0 0 1 .54-.111c.207 0 .404.04.54.11l3.164 1.498c.114.05.166.111.187.132l-.02.02-.167.111-3.165 1.497a1.28 1.28 0 0 1-.54.112c-.207 0-.404-.04-.54-.112L4.255 4.9c-.114-.05-.166-.111-.187-.131Z" })));
}, NavCollapse: function(e) {
  return u.createElement("svg", V3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pD || (pD = u.createElement("path", { fill: "currentColor", d: "M11.39 4.818a.5.5 0 0 0-.708 0L7.854 7.646a.5.5 0 0 0 0 .708l2.828 2.828a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L9.62 8l2.122-2.121a.5.5 0 0 0 0-.707l-.354-.354Z" })), gD || (gD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm1 1.5H4A1.5 1.5 0 0 0 2.5 4v8A1.5 1.5 0 0 0 4 13.5h1v-11Zm1.5 0v11H12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 12 2.5H6.5Z", clipRule: "evenodd" })));
}, NavExpand: function(e) {
  return u.createElement("svg", q3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hD || (hD = u.createElement("path", { fill: "currentColor", d: "M4.61 4.818a.5.5 0 0 1 .708 0l2.828 2.828a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L6.38 8 4.257 5.879a.5.5 0 0 1 0-.707l.354-.354Z" })), mD || (mD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8Zm-1 1.5h1A1.5 1.5 0 0 1 13.5 4v8a1.5 1.5 0 0 1-1.5 1.5h-1v-11Zm-1.5 0v11H4A1.5 1.5 0 0 1 2.5 12V4A1.5 1.5 0 0 1 4 2.5h5.5Z", clipRule: "evenodd" })));
}, NoFilter: function(e) {
  return u.createElement("svg", U3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vD || (vD = u.createElement("path", { fill: "currentColor", d: "M2.606 1.204a1 1 0 0 0-1.313 1.503L7 8.414v5.984a.5.5 0 0 0 .83.376l2.949-2.58 2.512 2.511a1 1 0 0 0 1.414-1.414l-1.818-1.818-.006.006L2.606 1.204ZM10.573 7.15A.25.25 0 0 0 11 6.972v-.825l3.8-3.94C15.202 1.79 14.957 1 14.425 1H5.027a.25.25 0 0 0-.176.427l5.722 5.722Z" })));
}, NotAllowed: function(e) {
  return u.createElement("svg", W3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bD || (bD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.75 8a3.75 3.75 0 0 1-5.485 3.326l5.06-5.06c.272.518.425 1.108.425 1.734ZM4.674 9.735l5.06-5.06a3.75 3.75 0 0 0-5.06 5.06ZM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z", clipRule: "evenodd" })));
}, Note: function(e) {
  return u.createElement("svg", G3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yD || (yD = u.createElement("path", { fill: "currentColor", d: "M4.5 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM4.5 8.75A.75.75 0 0 1 5.25 8h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" })), wD || (wD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m15 10-4 4H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6Zm-2-6H3v8h7v-2a1 1 0 0 1 1-1h2V4Z", clipRule: "evenodd" })));
}, OpenNewTab: function(e) {
  return u.createElement("svg", K3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), OD || (OD = u.createElement("path", { fill: "currentColor", d: "M13.823 2.45a.278.278 0 0 0-.272-.273l-4.045-.079a.277.277 0 0 0-.201.474l1.08 1.08-2.45 2.452a1.395 1.395 0 0 0-.148.174L5.999 8.065a1.369 1.369 0 1 0 1.936 1.936l1.787-1.788c.061-.043.12-.093.174-.147l2.451-2.452 1.081 1.081a.277.277 0 0 0 .474-.201l-.079-4.045Z" })), xD || (xD = u.createElement("path", { fill: "currentColor", d: "M7.25 3.129a.75.75 0 0 1 0 1.5H4a.5.5 0 0 0-.5.5v6.864a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0v3.243a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.129a2 2 0 0 1 2-2h3.25Z" })));
}, Pause: function(e) {
  return u.createElement("svg", Y3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ED || (ED = u.createElement("path", { fill: "currentColor", d: "M4.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1ZM10.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1Z" })));
}, Person: function(e) {
  return u.createElement("svg", X3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $D || ($D = u.createElement("path", { fill: "currentColor", d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })), jD || (jD = u.createElement("path", { fill: "currentColor", d: "M8 8c-.708 0-1.367-.21-1.918-.572A4.483 4.483 0 0 1 8 7c.686 0 1.336.154 1.918.428C9.368 7.79 8.708 8 8 8ZM4.591 8.562c.308-.357.838-.339 1.252-.112C6.483 8.8 7.218 9 8 9s1.517-.2 2.158-.55c.413-.227.943-.245 1.251.112A4.482 4.482 0 0 1 12.5 11.5V14h-9v-2.5c0-1.123.411-2.15 1.091-2.938Z" })));
}, PersonGroup: function(e) {
  return u.createElement("svg", Q3({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CD || (CD = u.createElement("path", { fill: "currentColor", d: "M4.808 8.923a2.962 2.962 0 1 0 0-5.923 2.962 2.962 0 0 0 0 5.923ZM2.982 9.304c-.35-.192-.798-.207-1.059.095A3.793 3.793 0 0 0 1 11.885V14h7.615v-2.115c0-.95-.347-1.819-.923-2.486-.26-.302-.708-.287-1.059-.095a3.79 3.79 0 0 1-1.825.465 3.79 3.79 0 0 1-1.826-.465ZM9.615 11.885V13H15v-1.906c0-.734-.274-1.405-.727-1.92-.206-.234-.559-.222-.835-.074-.427.23-.917.36-1.438.36-.521 0-1.011-.13-1.438-.36-.276-.148-.63-.16-.835.073-.21.239-.38.51-.504.806.252.585.392 1.23.392 1.906ZM14.333 6.288c0 1.264-1.044 2.289-2.333 2.289-1.289 0-2.333-1.025-2.333-2.289C9.667 5.025 10.71 4 12 4c1.289 0 2.333 1.025 2.333 2.288Z" })));
}, PersonWithLock: function(e) {
  return u.createElement("svg", J3({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MD || (MD = u.createElement("path", { fill: "currentColor", d: "M10 4.5A3.497 3.497 0 0 1 6.5 8a3.484 3.484 0 0 1-1.918-.572A3.5 3.5 0 1 1 10 4.5ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h6v-2.5c0-.445.194-.845.502-1.12.033-.82.393-1.554.954-2.076-.259-.051-.55.01-.799.146A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), kD || (kD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 10.5v.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5v-.5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 0-1 1v.5h2v-.5a1 1 0 0 0-1-1Z", clipRule: "evenodd" })));
}, Pin: function(e) {
  return u.createElement("svg", em({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PD || (PD = u.createElement("path", { fill: "currentColor", d: "M10 8.5V3.3h.683a.65.65 0 1 0 0-1.3H5.317a.65.65 0 1 0 0 1.3H6v5.2L4.383 9.55a.843.843 0 0 0 .46 1.55h2.624v3.367a.533.533 0 0 0 1.066 0V11.1h2.624a.843.843 0 0 0 .46-1.55L10 8.5Z" })));
}, Play: function(e) {
  return u.createElement("svg", tm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SD || (SD = u.createElement("path", { fill: "currentColor", d: "M13.779 6.704a1.5 1.5 0 0 1 0 2.592l-7.523 4.388A1.5 1.5 0 0 1 4 12.388V3.612a1.5 1.5 0 0 1 2.256-1.296l7.523 4.388Z" })));
}, Plus: function(e) {
  return u.createElement("svg", nm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ND || (ND = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v3.5H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9.5H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9.5V3a1 1 0 0 0-1-1h-1Z", clipRule: "evenodd" })));
}, PlusWithCircle: function(e) {
  return u.createElement("svg", rm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RD || (RD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z", clipRule: "evenodd" })));
}, Primary: function(e) {
  return u.createElement("svg", am({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _D || (_D = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3-8.307C11 5.172 9.918 4 8.433 4H6v8h1.495V9.386h.938C9.918 9.386 11 8.214 11 6.693Zm-1.454 0c0 .653-.453 1.16-1.134 1.16h-.917v-2.32h.917c.68 0 1.134.506 1.134 1.16Z", clipRule: "evenodd" })));
}, Project: function(e) {
  return u.createElement("svg", lm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AD || (AD = u.createElement("path", { fill: "currentColor", d: "M1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 4V2Z" })), LD || (LD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 5.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75H2.75ZM6.25 7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1h-3.5Z", clipRule: "evenodd" })));
}, QuestionMarkWithCircle: function(e) {
  return u.createElement("svg", im({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZD || (ZD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.932 5.612C7.054 5.298 7.425 5 7.942 5 8.615 5 9 5.478 9 5.875c0 .162-.057.33-.172.476a.985.985 0 0 1-.242.216l-.016.01a1.141 1.141 0 0 1-.098.054c-.59.286-1.53.967-1.53 2.119V9a1 1 0 0 0 2 0c0-.035.011-.12.138-.27a2.66 2.66 0 0 1 .587-.48 3 3 0 0 0 .726-.656A2.742 2.742 0 0 0 11 5.875C11 4.201 9.54 3 7.941 3c-1.275 0-2.43.745-2.873 1.888a1 1 0 1 0 1.864.724ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, Read: function(e) {
  return u.createElement("svg", om({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TD || (TD = u.createElement("path", { fill: "currentColor", d: "M10.011 8.762V4.185h-1.39c-.574 0-.84-.645-.406-.985l2.63-2.063a.669.669 0 0 1 .81 0l2.63 2.063c.433.34.168.985-.405.985h-1.31v4.577c0 .716-.572 1.297-1.28 1.297-.706 0-1.279-.58-1.279-1.297ZM8.823 9.158c-.814.19-1.677.283-2.448.283-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.2-.079.383-.164.548-.254a2.53 2.53 0 0 1-1.434-1.91Z" })), BD || (BD = u.createElement("path", { fill: "currentColor", d: "M6.787 3.479a10.514 10.514 0 0 0-.412-.008c-2.404 0-4.875.823-4.875 2.562 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.768 0 1.63-.101 2.418-.299V5.421H8.62c-.767 0-1.428-.45-1.706-1.125-.107-.26-.15-.54-.128-.817ZM11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729Z" })));
}, Recommended: function(e) {
  return u.createElement("svg", sm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ID || (ID = u.createElement("path", { fill: "currentColor", d: "m8.148 5.458-.944 1.968V9.59h2.099a.5.5 0 0 0 .491-.407l.223-1.182a.5.5 0 0 0-.491-.593h-.638a.623.623 0 0 1-.61-.636V5.708a.302.302 0 0 0-.13-.25Z" })), HD || (HD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.538 1.554a.75.75 0 0 0-1.076 0L6.4 2.648a.75.75 0 0 1-.615.224L4.27 2.716a.75.75 0 0 0-.824.692l-.11 1.52a.75.75 0 0 1-.328.567l-1.261.856a.75.75 0 0 0-.187 1.06l.893 1.235a.75.75 0 0 1 .113.644l-.416 1.467a.75.75 0 0 0 .538.932l1.478.373a.75.75 0 0 1 .501.42l.624 1.39a.75.75 0 0 0 1.011.369l1.372-.665a.75.75 0 0 1 .654 0l1.372.665a.75.75 0 0 0 1.011-.368l.624-1.391a.75.75 0 0 1 .5-.42l1.48-.373a.75.75 0 0 0 .537-.932l-.416-1.467a.75.75 0 0 1 .114-.644l.892-1.235a.75.75 0 0 0-.187-1.06l-1.261-.856a.75.75 0 0 1-.327-.566l-.11-1.52a.75.75 0 0 0-.825-.693l-1.517.156a.75.75 0 0 1-.614-.224L8.538 1.554Zm-1.064 3.28a.577.577 0 0 1 .518-.334c.639 0 1.157.54 1.157 1.208V6.5h.98c.549 0 .96.523.854 1.085l-.412 2.182a.881.881 0 0 1-.854.733H5.435c-.24 0-.435-.294-.435-.546V7.591c0-.251.195-.455.435-.455h.898c.013 0 .027 0 .04.002a.702.702 0 0 1 .03-.072l1.071-2.232Z", clipRule: "evenodd" })));
}, Redo: function(e) {
  return u.createElement("svg", cm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DD || (DD = u.createElement("path", { fill: "currentColor", d: "M4.018 9.402c-.05.328-.313.598-.645.598h-.8c-.331 0-.603-.27-.57-.6a5.996 5.996 0 0 1 2.543-4.325A5.997 5.997 0 0 1 7.974 4h.028c2.699 0 4.95 1.718 5.467 4h1.414c.541 0 .792.672.383 1.026l-2.482 2.15a.585.585 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.92 8h1.446c-.468-1.085-1.68-2-3.364-2a3.98 3.98 0 0 0-2.543.89 3.996 3.996 0 0 0-1.441 2.512Z" })));
}, Refresh: function(e) {
  return u.createElement("svg", um({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zD || (zD = u.createElement("path", { fill: "currentColor", d: "M8.033 2c2.699 0 4.95 1.718 5.467 4h1.414c.542 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.951 6h1.447c-.469-1.085-1.68-2-3.365-2-1.026 0-1.877.34-2.491.85-.243.202-.618.203-.817-.043l-.61-.754a.468.468 0 0 1 .044-.651C5.163 2.534 6.53 2 8.033 2ZM3.95 6.843a.584.584 0 0 0-.765 0L.703 8.992a.584.584 0 0 0 .383 1.026h1.418C3.03 12.291 5.275 14 7.967 14c1.505 0 2.87-.534 3.874-1.402a.468.468 0 0 0 .044-.65l-.61-.755c-.2-.246-.574-.245-.817-.043-.614.51-1.465.85-2.49.85-1.676 0-2.883-.904-3.358-1.982H6.05a.584.584 0 0 0 .383-1.026L3.95 6.842Z" })));
}, Relationship: function(e) {
  return u.createElement("svg", fm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FD || (FD = u.createElement("path", { fill: "currentColor", d: "M.5 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6a2.5 2.5 0 0 1 2.5 2.5v5A1.5 1.5 0 0 0 10 12h1.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H10a2.5 2.5 0 0 1-2.5-2.5v-5A1.5 1.5 0 0 0 6 4H4.5v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2Z" })));
}, ReplicaSet: function(e) {
  return u.createElement("svg", dm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VD || (VD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.39 7.713A3.488 3.488 0 0 1 8 8c-.494 0-.964-.102-1.39-.287L5.264 9.729a2.5 2.5 0 1 1-1.08-.634L5.57 7.02a3.5 3.5 0 1 1 4.86 0l1.385 2.076A2.501 2.501 0 0 1 15 11.5a2.5 2.5 0 1 1-4.265-1.77L9.391 7.712ZM9.75 4.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, Resize: function(e) {
  return u.createElement("svg", pm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qD || (qD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.77 5.72a.75.75 0 0 1 0 1.06l-7.991 8a.749.749 0 1 1-1.06-1.06l7.992-8a.749.749 0 0 1 1.06 0ZM14.78 10.22a.75.75 0 0 1 0 1.06l-3.496 3.5a.749.749 0 1 1-1.06-1.06l3.497-3.5a.749.749 0 0 1 1.06 0Z", clipRule: "evenodd" })));
}, Return: function(e) {
  return u.createElement("svg", gm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UD || (UD = u.createElement("path", { fill: "currentColor", d: "M5 2a1 1 0 0 0 0 2h5a2.5 2.5 0 0 1 0 5H5.203l1.448-1.24a1 1 0 1 0-1.302-1.52l-3.5 3a1 1 0 0 0 0 1.52l3.5 3a1 1 0 0 0 1.302-1.52L5.203 11H10a4.5 4.5 0 1 0 0-9H5Z" })));
}, Save: function(e) {
  return u.createElement("svg", hm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WD || (WD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 2 3.04 2 3.6 2h7.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l1.062 1.063c.173.173.26.26.322.36.055.09.095.188.12.29.027.115.027.237.027.482V12.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.2.102-.46.109-.954.109V9.284c0-.126 0-.25-.008-.353a1.01 1.01 0 0 0-.101-.385 1 1 0 0 0-.437-.437 1.01 1.01 0 0 0-.385-.1C11.465 8 11.342 8 11.216 8H4.784c-.126 0-.249 0-.353.008a1.01 1.01 0 0 0-.385.101 1 1 0 0 0-.437.437 1.01 1.01 0 0 0-.1.385c-.009.104-.009.227-.009.353V14c-.494 0-.753-.007-.954-.109a1 1 0 0 1-.437-.437C2 13.24 2 12.96 2 12.4V3.6Zm2-.1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z", clipRule: "evenodd" })), GD || (GD = u.createElement("path", { fill: "currentColor", d: "M11.5 9.3V14h-7V9.3c0-.148 0-.23.005-.288v-.006h.007C4.571 9 4.652 9 4.8 9h6.4c.148 0 .23 0 .288.005h.006v.007c.006.059.006.14.006.288Z" })));
}, Serverless: function(e) {
  return u.createElement("svg", bm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ez || (ez = u.createElement("path", { fill: "currentColor", d: "M2.132 10.849a5.5 5.5 0 1 1 8.4-6.571 4 4 0 0 1 4.398 6.444 1 1 0 0 1-.15.192l-1.77 1.898a1.995 1.995 0 0 1-1.51.688H7.792a2.5 2.5 0 1 1 0-2H11.5l1.166-1.25H8.5a3.75 3.75 0 0 0-6.368.599Z" })));
}, ShardedCluster: function(e) {
  return u.createElement("svg", wm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nz || (nz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 2.75a1.75 1.75 0 0 1-2.123 1.71l-.619.866a3.497 3.497 0 0 1 1.186 2.049h1.17a1.75 1.75 0 1 1 0 1.25h-1.17a3.497 3.497 0 0 1-1.186 2.05l.619.865a1.75 1.75 0 1 1-1.046.686l-.662-.926a3.495 3.495 0 0 1-2.331.002l-.664.93a1.75 1.75 0 1 1-1.043-.69l.616-.863a3.497 3.497 0 0 1-1.191-2.054h-1.17a1.75 1.75 0 1 1 0-1.25h1.17c.147-.819.58-1.54 1.191-2.054l-.616-.863a1.75 1.75 0 1 1 1.043-.69l.664.93A3.494 3.494 0 0 1 8 4.5c.41 0 .803.07 1.17.2l.66-.926A1.75 1.75 0 1 1 13 2.75ZM9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, SearchIndex: function(e) {
  return u.createElement("svg", mm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KD || (KD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.816 12.754a2.786 2.786 0 0 0 3.396.424l1.622 1.622a.683.683 0 1 0 .966-.966l-1.622-1.622a2.786 2.786 0 1 0-4.362.542Zm2.972-2.972a1.419 1.419 0 1 1-2.006 2.006 1.419 1.419 0 0 1 2.006-2.006Z", clipRule: "evenodd" })), YD || (YD = u.createElement("path", { fill: "currentColor", d: "M12 3.667c0 .083 0 .165-.002.245L12 4v.214c0 .281-.124.55-.393.815-.275.27-.682.512-1.187.715-1.01.405-2.31.613-3.42.613-1.11 0-2.41-.208-3.42-.613-.505-.203-.912-.446-1.187-.715C2.123 4.765 2 4.495 2 4.214V4c0-.033 0-.066.002-.099A12.44 12.44 0 0 1 2 3.667C2 1.857 4.534 1 7 1s5 .857 5 2.667Z" })), XD || (XD = u.createElement("path", { fill: "currentColor", d: "M2 5.813v1.83c0 .28.124.55.393.815.275.269.682.511 1.187.714 1.01.406 2.31.614 3.42.614l.134-.001A3.785 3.785 0 0 1 12 7.2V5.812c-.357.297-.8.537-1.277.729-1.124.452-2.532.672-3.723.672-1.191 0-2.599-.22-3.723-.672C2.8 6.35 2.357 6.11 2 5.813ZM7 10.643h.003c-.03.816.201 1.64.696 2.334-.232.015-.466.023-.699.023-2.466 0-5-.857-5-2.667 0-.083 0-.165.002-.245A2.229 2.229 0 0 1 2 10v-.758c.357.297.8.537 1.277.729 1.124.451 2.532.672 3.723.672Z" })));
}, Secondary: function(e) {
  return u.createElement("svg", vm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QD || (QD = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z", clipRule: "evenodd" })), JD || (JD = u.createElement("path", { fill: "currentColor", d: "M11 9.67C11 11.112 9.786 12 8.117 12 6.337 12 5.07 10.897 5 9.395h1.972c.07.674.594.996 1.2.996.594 0 .897-.245.897-.613 0-.399-.262-.598-.869-.767l-1.297-.367c-1.2-.337-1.751-1.257-1.751-2.376C5.152 4.95 6.2 4 7.924 4c1.517 0 2.676.889 2.786 2.421H8.807c-.097-.582-.497-.781-.91-.781-.483 0-.814.214-.814.582 0 .43.372.598.786.705l1.214.368C10.434 7.678 11 8.475 11 9.671Z" })));
}, Settings: function(e) {
  return u.createElement("svg", ym({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tz || (tz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.207 1.067a.75.75 0 0 0-.89.247l-.374.506a6.214 6.214 0 0 0-1.894.002l-.375-.506a.75.75 0 0 0-.89-.246l-1.126.467a.75.75 0 0 0-.454.804l.093.623c-.505.37-.958.82-1.338 1.34l-.623-.093a.75.75 0 0 0-.803.455l-.466 1.127a.75.75 0 0 0 .247.89l.506.374a6.214 6.214 0 0 0 .002 1.893l-.506.376a.75.75 0 0 0-.246.89l.467 1.126a.75.75 0 0 0 .804.454l.623-.093c.37.505.82.958 1.34 1.338l-.093.623a.75.75 0 0 0 .455.803l1.127.466a.75.75 0 0 0 .89-.247l.374-.506a6.218 6.218 0 0 0 1.894-.002l.375.506a.75.75 0 0 0 .89.246l1.126-.467a.75.75 0 0 0 .454-.804l-.093-.623c.505-.37.958-.82 1.338-1.34l.623.093a.75.75 0 0 0 .803-.455l.466-1.127a.75.75 0 0 0-.247-.89l-.506-.374a6.218 6.218 0 0 0-.002-1.894l.506-.375a.75.75 0 0 0 .246-.89l-.467-1.126a.75.75 0 0 0-.804-.454l-.623.093a6.214 6.214 0 0 0-1.34-1.338l.093-.623a.75.75 0 0 0-.455-.803l-1.127-.466Zm.334 7.984A2.75 2.75 0 1 1 5.46 6.949a2.75 2.75 0 0 1 5.082 2.102Z", clipRule: "evenodd" })));
}, Shell: function(e) {
  return u.createElement("svg", Om({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rz || (rz = u.createElement("path", { fill: "currentColor", d: "m1.8 5.2 3.4 2.2-3.79 2.526a.5.5 0 0 0-.142.688l.557.86a.5.5 0 0 0 .697.145L7.5 8.3c.3-.2.5-.5.5-.8 0-.3-.2-.6-.4-.8L2.522 3.284a.5.5 0 0 0-.699.143l-.547.847a.5.5 0 0 0 .155.695L1.8 5.2ZM6.7 13a.5.5 0 0 0 .5.5h7.7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.2a.5.5 0 0 0-.5.5v1Z" })));
}, SMS: function(e) {
  return u.createElement("svg", xm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), az || (az = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7.755L4.23 14.831c-.488.392-1.23.058-1.23-.555V12a2 2 0 0 1-2-2V4Zm2 .75A.75.75 0 0 1 3.75 4h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 4.75Zm0 3A.75.75 0 0 1 3.75 7h5.5a.75.75 0 1 1 0 1.5h-5.5A.75.75 0 0 1 3 7.75Z", clipRule: "evenodd" })));
}, SortAscending: function(e) {
  return u.createElement("svg", Em({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lz || (lz = u.createElement("path", { fill: "currentColor", d: "M4.45 1.143a.584.584 0 0 0-.765 0L1.203 3.292a.584.584 0 0 0 .383 1.026h1.312v9.352a1.169 1.169 0 1 0 2.338 0V4.318H6.55a.584.584 0 0 0 .383-1.026L4.45 1.142ZM8 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, SortDescending: function(e) {
  return u.createElement("svg", $m({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iz || (iz = u.createElement("path", { fill: "currentColor", d: "M4.45 14.696a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.025h1.312V2.168a1.169 1.169 0 1 1 2.338 0v9.351H6.55c.541 0 .792.673.383 1.027L4.45 14.696ZM8 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, Sparkle: function(e) {
  return u.createElement("svg", jm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oz || (oz = u.createElement("path", { fill: "currentColor", d: "m6.273 2.893-.998 2.995c-.1.3-.336.536-.636.637l-2.995.998a.503.503 0 0 0 0 .954l2.995.998c.3.1.536.336.636.637l.998 2.995a.503.503 0 0 0 .955 0l.998-2.995c.1-.3.336-.536.636-.637l2.995-.998a.503.503 0 0 0 0-.954l-2.995-.998c-.3-.1-.536-.336-.636-.637l-.998-2.995a.503.503 0 0 0-.955 0ZM12.547 1.172l-.231.693c-.1.3-.336.536-.636.636l-.694.231c-.229.077-.229.401 0 .477l.694.231c.3.1.536.336.636.637l.23.693c.077.229.402.229.478 0l.231-.693c.1-.3.336-.536.636-.637l.693-.23c.23-.077.23-.401 0-.478l-.693-.23c-.3-.1-.536-.337-.636-.637l-.231-.693a.251.251 0 0 0-.477 0ZM12.547 11.23l-.231.693c-.1.3-.336.536-.636.636l-.694.232c-.229.076-.229.4 0 .477l.694.23c.3.1.536.337.636.637l.23.693c.077.23.402.23.478 0l.231-.693c.1-.3.336-.536.636-.636l.693-.231c.23-.077.23-.401 0-.477l-.693-.232c-.3-.1-.536-.335-.636-.636l-.231-.693a.251.251 0 0 0-.477 0Z" })));
}, SplitHorizontal: function(e) {
  return u.createElement("svg", Cm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), sz || (sz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8Zm-2-4.5V3H3v3.5h10Zm-10 1V11h10V7.5H3Z", clipRule: "evenodd" })));
}, SplitVertical: function(e) {
  return u.createElement("svg", Mm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), cz || (cz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM7.5 3H3v8h4.5V3Zm1 8H13V3H8.5v8Z", clipRule: "evenodd" })));
}, Stitch: function(e) {
  return u.createElement("svg", km({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), uz || (uz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h16v16H0V0Zm14 4V2H2v2h12Zm0 10V5H2v9h12ZM8 6v7H6V6h2Zm5 0v4H9V6h4ZM5 8v5H3V8h2Zm8 3v2H9v-2h4Z" })));
}, String: function(e) {
  return u.createElement("svg", Pm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fz || (fz = u.createElement("path", { fill: "currentColor", d: "M10.69 14H5.31l-.15-.137v-.754l.15-.138h.602c.376 0 .753-.342.753-.685V3.5h-.903c-2.05 0-2.54.729-2.671 1.826l-.15.137h-.828L2 5.326l.282-3.189.15-.137h11.135l.15.137L14 5.326l-.113.137h-.827l-.15-.137c-.133-1.097-.622-1.826-2.672-1.826h-.903v8.786c0 .343.377.685.753.685h.602l.15.138v.754l-.15.137Z" })));
}, Support: function(e) {
  return u.createElement("svg", Sm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dz || (dz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7a3 3 0 0 1 6 0v2.5c0 1.51-.957 2.798-2.298 3.288a1 1 0 1 0 .265.967 4.512 4.512 0 0 0 2.787-2.785c.08.02.161.03.246.03h.5a2.5 2.5 0 0 0 .406-4.967 5.002 5.002 0 0 0-9.813 0A2.5 2.5 0 0 0 3.5 11H4a1 1 0 0 0 1-1V7Z", clipRule: "evenodd" })));
}, Sweep: function(e) {
  return u.createElement("svg", Nm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pz || (pz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 14.465 4 12.734c.292.169.631.266.999.266h2v2H5a3.982 3.982 0 0 1-2-.535ZM9 15v-2h2c.368 0 .707-.097.999-.266L13 14.464A3.982 3.982 0 0 1 11 15H9Zm6-8h-2V5c0-.368-.097-.707-.266-.999L14.464 3c.341.588.536 1.271.536 2v2ZM7 1H5c-.729 0-1.412.195-2 .535L4 3.266C4.293 3.097 4.632 3 5 3h2V1ZM1 9h2v2c0 .368.097.707.266.999L1.536 13A3.982 3.982 0 0 1 1 11V9Zm0-2h2V5c0-.368.097-.707.266-.999L1.536 3A3.982 3.982 0 0 0 1 5v2Zm8-6v2h2c.368 0 .707.097.999.266L13 1.536A3.982 3.982 0 0 0 11 1H9Zm6 8h-2v2c0 .368-.097.707-.266.999L14.464 13c.341-.588.536-1.271.536-2V9Z", clipRule: "evenodd" })));
}, Table: function(e) {
  return u.createElement("svg", Rm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gz || (gz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3.25C1 2.56 1.56 2 2.25 2h11.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 14 1 13.44 1 12.75v-9.5Zm2 4.12V4h4.37v3.37H3Zm0 1.25V12h4.37V8.62H3ZM8.62 12H13V8.62H8.62V12ZM13 7.37V4H8.62v3.37H13Z", clipRule: "evenodd" })));
}, Tag: function(e) {
  return u.createElement("svg", _m({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hz || (hz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m9.707 14.293 4.586-4.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 7.586 2H3a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, ThumbsDown: function(e) {
  return u.createElement("svg", Am({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mz || (mz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.019 15c.511 0 .98-.28 1.208-.724l2.501-4.837c.026-.05.05-.102.07-.155.03.003.06.004.092.004h2.094c.561 0 1.016-.441 1.016-.985V3.182C15 2.638 14.545 2 13.984 2H3.993C3.023 2 2.188 2.666 2 3.589L1.04 8.316c-.247 1.217.713 2.35 1.993 2.35H5.32v1.717C5.32 13.828 6.528 15 8.019 15Zm1.84-6.34-2.205 4.265a.642.642 0 0 1-.303-.542v-2.307c0-.762-.637-1.379-1.422-1.379H3.644a.5.5 0 0 1-.49-.6l.758-3.727a.5.5 0 0 1 .49-.4h5.456v4.69Z", clipRule: "evenodd" })));
}, ThumbsUp: function(e) {
  return u.createElement("svg", Lm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vz || (vz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.981 1c-.511 0-.98.28-1.208.724L4.272 6.56c-.026.05-.05.102-.07.155a1.06 1.06 0 0 0-.092-.004H2.016c-.561 0-1.016.441-1.016.985v5.121C1 13.362 1.455 14 2.016 14h9.991c.97 0 1.805-.665 1.993-1.589l.961-4.727c.248-1.217-.713-2.35-1.993-2.35H10.68V3.616C10.68 2.172 9.472 1 7.981 1Zm-1.84 6.34 2.205-4.265a.642.642 0 0 1 .303.542v2.307c0 .762.637 1.379 1.422 1.379h2.285a.5.5 0 0 1 .49.6l-.758 3.727a.5.5 0 0 1-.49.4H6.142V7.34Z", clipRule: "evenodd" })));
}, TimeSeries: function(e) {
  return u.createElement("svg", Zm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bz || (bz = u.createElement("path", { fill: "currentColor", d: "M7.023 1.518c.513.024.957.363 1.12.853L9.38 6.108l1.56-2.092a1.24 1.24 0 0 1 1.872-.134l1.897 1.91c.388.39.388 1.023 0 1.413l-.377.354a.99.99 0 0 1-1.405 0l-.86-.89-2.122 2.847a1.239 1.239 0 0 1-2.172-.355L6.798 6.22 6.11 7.774c-.2.451-.644.742-1.135.742H1.994a.997.997 0 0 1-.994-1v-.5c0-.552.445-1 .994-1h2.174l1.66-3.758a1.242 1.242 0 0 1 1.195-.74ZM14 12a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h12Z" })));
}, TimeSeriesCollection: function(e) {
  return u.createElement("svg", Tm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yz || (yz = u.createElement("path", { fill: "currentColor", d: "M13.6 10.383H15c.6 0 1 .499 1 1.098 0 .598-.4.998-1 .998h-.9l-1.5 2.096c-.2.3-.6.499-1 .399-.4-.1-.7-.4-.8-.799l-.4-1.696-.4 1.197c-.1.3-.5.6-.9.6H8c-.6 0-1-.4-1-.999s.4-.998 1-.998h.4l1.4-3.693c.1-.4.6-.599 1-.599s.8.4.9.699l.6 2.794.5-.698c.2-.2.5-.4.8-.4Z" })), wz || (wz = u.createElement("path", { fill: "currentColor", d: "M1.929 1A.922.922 0 0 0 1 1.915v9.15c0 .505.416.915.929.915H5.84c.101-.173.225-.336.374-.485.322-.321.71-.526 1.118-.63l1.043-2.75c.208-.678.706-1.086 1.107-1.3A2.846 2.846 0 0 1 10.8 6.49c.682 0 1.214.323 1.531.591.318.269.635.66.792 1.131l.026.079.133.617a2.24 2.24 0 0 1 .318-.023h.4v-5.14a.922.922 0 0 0-.929-.915H7.5a.922.922 0 0 1-.929-.915A.922.922 0 0 0 5.643 1H1.929Z" })), Oz || (Oz = u.createElement("path", { fill: "currentColor", d: "M10.95 8.005a.699.699 0 0 0-.066-.012l.065.012Z" })));
}, Trash: function(e) {
  return u.createElement("svg", Bm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xz || (xz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2a1 1 0 0 1 1 1v1H2V3a1 1 0 0 1 1-1h2Zm9 3H2l1.678 8.392A2 2 0 0 0 5.64 15h4.72a2 2 0 0 0 1.962-1.608L14 5Z", clipRule: "evenodd" })));
}, Undo: function(e) {
  return u.createElement("svg", Im({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ez || (Ez = u.createElement("path", { fill: "currentColor", d: "M11.981 9.402c.05.328.313.598.645.598h.8c.331 0 .603-.27.57-.6a5.996 5.996 0 0 0-2.543-4.325A5.997 5.997 0 0 0 8.026 4h-.029C5.298 4 3.047 5.718 2.53 8H1.116a.584.584 0 0 0-.383 1.026l2.482 2.15c.22.19.545.19.765 0l2.482-2.15A.584.584 0 0 0 6.079 8H4.632c.47-1.085 1.68-2 3.365-2a3.98 3.98 0 0 1 2.543.89 3.996 3.996 0 0 1 1.441 2.512Z" })));
}, University: function(e) {
  return u.createElement("svg", Hm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $z || ($z = u.createElement("path", { fill: "currentColor", d: "M8.5 4.613c0-.383.191-.74.51-.953a6.87 6.87 0 0 1 2.145-.949l2.406-.601a.353.353 0 0 1 .439.342v7.88c0 .238 0 .357-.043.453a.5.5 0 0 1-.176.211c-.087.06-.204.081-.438.123l-3.9.71c-.324.058-.486.088-.612.042a.5.5 0 0 1-.264-.22c-.067-.116-.067-.28-.067-.61V4.613ZM2 2.452c0-.23.216-.398.439-.342l2.407.601a6.87 6.87 0 0 1 2.144.95c.319.211.51.569.51.952v6.428c0 .33 0 .494-.067.61a.5.5 0 0 1-.264.22c-.126.046-.288.016-.612-.043l-3.9-.709c-.234-.042-.35-.063-.438-.123a.5.5 0 0 1-.176-.21C2 10.688 2 10.57 2 10.331v-7.88ZM2.008 12.41a.5.5 0 0 1 .581-.402l5.143.935c.177.032.359.032.536 0l5.143-.935a.5.5 0 0 1 .178.984l-4.134.752c-.163.434-.753.756-1.455.756-.702 0-1.292-.322-1.455-.756l-4.134-.752a.5.5 0 0 1-.403-.581Z" })));
}, Unlock: function(e) {
  return u.createElement("svg", Dm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jz || (jz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.157 4.221A2 2 0 0 1 10 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1V5a4 4 0 0 0-7.822-1.182C3.982 4.45 4.538 5 5.2 5c.442 0 .785-.372.957-.779Zm2.43 6.589A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, Unsorted: function(e) {
  return u.createElement("svg", zm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Cz || (Cz = u.createElement("path", { fill: "currentColor", d: "M3.685 1.143c.22-.19.545-.19.765 0l2.482 2.149a.584.584 0 0 1-.383 1.026H5.236v7.364H6.55c.541 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.026h1.312V4.318H1.586a.584.584 0 0 1-.383-1.026l2.482-2.15ZM8 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H9ZM8 11a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" })));
}, UpDownCarets: function(e) {
  return u.createElement("svg", Fm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), Mz || (Mz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.527 1.21a.638.638 0 0 1 .948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562Zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 0 1-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654Z" })));
}, Upload: function(e) {
  return u.createElement("svg", Vm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kz || (kz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.297 11v.938a4 4 0 1 0-.764-7.66A5.501 5.501 0 0 0 0 6.5a5.5 5.5 0 0 0 5.797 5.492V11h-.403c-1.395 0-2.08-1.7-1.075-2.667L7.472 5.3a1.55 1.55 0 0 1 2.15 0l3.152 3.034C13.78 9.301 13.094 11 11.7 11h-.402ZM8.339 6.2a.3.3 0 0 1 .416 0l3.152 3.034a.3.3 0 0 1-.208.516h-1.652v3.75a1.5 1.5 0 0 1-3 0V9.75H5.394a.3.3 0 0 1-.208-.516L8.339 6.2Z", clipRule: "evenodd" })));
}, VerticalEllipsis: function(e) {
  return u.createElement("svg", qm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Pz || (Pz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM7.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", clipRule: "evenodd" })));
}, Visibility: function(e) {
  return u.createElement("svg", Um({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Sz || (Sz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2.008c3.934 0 6.473 3.129 7.455 4.583l.043.064C15.713 6.97 16 7.391 16 8s-.287 1.03-.502 1.345l-.043.064c-.982 1.454-3.521 4.583-7.455 4.583S1.527 10.863.545 9.41l-.043-.064C.287 9.03 0 8.609 0 8s.287-1.03.502-1.345l.043-.064C1.527 5.137 4.066 2.008 8 2.008ZM9.13 4.13A5.147 5.147 0 0 0 8 4.005C5.75 4.005 3.927 5.794 3.927 8c0 2.206 1.824 3.995 4.073 3.995 2.25 0 4.073-1.789 4.073-3.995 0-2.206-1.824-3.995-4.073-3.995.378 0 .756.045 1.13.126ZM8 10.996c1.687 0 3.055-1.341 3.055-2.996S9.687 5.004 8 5.004 4.945 6.345 4.945 8 6.313 10.996 8 10.996Z", clipRule: "evenodd" })));
}, VisibilityOff: function(e) {
  return u.createElement("svg", Wm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Nz || (Nz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.601 1.266a1.03 1.03 0 0 0-1.433.049L1.704 13.486a.987.987 0 0 0 .062 1.407 1.03 1.03 0 0 0 1.433-.049l1.793-1.904A7.348 7.348 0 0 0 8 13.587c3.934 0 6.473-3.133 7.455-4.59l.043-.063c.215-.316.502-.737.502-1.347s-.287-1.03-.502-1.346l-.043-.065a12.85 12.85 0 0 0-1.949-2.275l1.157-1.228a.987.987 0 0 0-.062-1.407Zm-2.93 4.585-.764.81c.096.292.148.603.148.926 0 1.657-1.368 3-3.055 3-.246 0-.485-.028-.714-.082l-.763.81c.458.176.956.272 1.477.272 2.25 0 4.073-1.79 4.073-4 0-.622-.145-1.211-.403-1.736ZM8 1.587c.919 0 1.762.171 2.526.452L8.98 3.68A5.13 5.13 0 0 0 8 3.587c-2.25 0-4.073 1.79-4.073 4 0 .435.07.853.201 1.245l-1.985 2.107A13.06 13.06 0 0 1 .545 8.998l-.043-.064C.287 8.618 0 8.197 0 7.587s.287-1.03.502-1.346l.043-.065C1.527 4.72 4.066 1.587 8 1.587Zm0 2c.327 0 .654.034.978.095l-.016.017A4.155 4.155 0 0 0 8 3.587Zm0 1c.041 0 .083 0 .124.002L4.966 7.942a2.978 2.978 0 0 1-.02-.355c0-1.657 1.367-3 3.054-3Z", clipRule: "evenodd" })));
}, Warning: function(e) {
  return u.createElement("svg", Gm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Rz || (Rz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.864 1.514a.983.983 0 0 0-1.728 0L1.122 12.539A.987.987 0 0 0 1.986 14h12.028a.987.987 0 0 0 .864-1.461L8.864 1.514ZM7 5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V5Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, Wizard: function(e) {
  return u.createElement("svg", Km({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _z || (_z = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.327 3.277c.188-.38-.236-.8-.618-.613l-2.513 1.223a.461.461 0 0 1-.523-.095L7.603 1.74c-.314-.313-.829-.062-.75.365l.517 2.808a.421.421 0 0 1-.228.46L4.63 6.596c-.383.186-.277.761.154.839l2.832.513a.477.477 0 0 1 .382.379l.517 2.808c.079.427.659.532.846.153l1.234-2.492a.427.427 0 0 1 .464-.225l2.832.512c.43.078.683-.432.368-.744l-2.07-2.052a.452.452 0 0 1-.095-.519l1.233-2.491ZM7 10.5c.353-.35.312-.958-.091-1.359-.404-.4-1.017-.44-1.37-.09L1.84 12.713c-.353.35-.312.958.092 1.358.403.4 1.017.44 1.37.09L7 10.5Z", clipRule: "evenodd" })));
}, Wrench: function(e) {
  return u.createElement("svg", Ym({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Az || (Az = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.625 9.75a4.374 4.374 0 0 0 4.206-5.584c-.085-.295-.449-.36-.665-.145l-2.1 2.1a.44.44 0 0 1-.184.11c-.078.024-.157-.013-.215-.07L9.84 4.332c-.058-.058-.095-.137-.071-.215a.44.44 0 0 1 .11-.184l2.1-2.1c.216-.216.147-.58-.145-.664a4.374 4.374 0 0 0-5.385 5.512.32.32 0 0 1-.077.32l-4.828 4.829a1.857 1.857 0 0 0 2.625 2.625l4.828-4.828a.32.32 0 0 1 .323-.075c.412.129.851.197 1.305.197ZM2.75 14.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z", clipRule: "evenodd" })));
}, Write: function(e) {
  return u.createElement("svg", Xm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Lz || (Lz = u.createElement("path", { fill: "currentColor", d: "M8.71 3.75a9.487 9.487 0 0 0-2.335-.28c-2.404 0-4.875.824-4.875 2.563 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.267 0 .546-.013.828-.037a1.76 1.76 0 0 1-.288-1.818 1.826 1.826 0 0 1 1.706-1.125h.09V3.75ZM8.068 9.305c-.578.091-1.158.136-1.693.136-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.22-.086.42-.18.598-.282a1.85 1.85 0 0 1-.209-.141l-2.03-1.594Z" })), Zz || (Zz = u.createElement("path", { fill: "currentColor", d: "M11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729ZM12.489 2.297v4.576h1.39c.574 0 .84.646.406.986l-2.63 2.063a.668.668 0 0 1-.81 0l-2.63-2.063c-.433-.34-.168-.986.406-.986H9.93V2.297C9.93 1.58 10.502 1 11.21 1c.706 0 1.279.58 1.279 1.297Z" })));
}, X: function(e) {
  return u.createElement("svg", Qm({ xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Tz || (Tz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.203 3.404a1 1 0 0 0-1.414 0L8.314 5.879 5.839 3.404a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L6.192 8l-2.474 2.475a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l2.475-2.475 2.475 2.475a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L10.435 8l2.475-2.475a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, XWithCircle: function(e) {
  return u.createElement("svg", Jm({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Bz || (Bz = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.414-9.828a1 1 0 1 1 1.414 1.414L9.414 8l1.414 1.414a1 1 0 1 1-1.414 1.414L8 9.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L6.586 8 5.172 6.586a1 1 0 0 1 1.414-1.414L8 6.586l1.414-1.414Z", clipRule: "evenodd" })));
} }, Yxe = Object.keys(Iz).reduce(function(e, t) {
  return e[t] = Wxe(t, Iz[t]), e;
}, {});
Kxe(Yxe);
function Hz(e) {
  return b1(e) ? e != null && ih(e) === "object" && "type" in e && e.type.isGlyph === !0 : e != null && typeof e == "function" && "isGlyph" in e && e.isGlyph === !0;
}
var i2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Checkmark", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.30583 9.05037L11.7611 3.59509C12.1516 3.20457 12.7848 3.20457 13.1753 3.59509L13.8824 4.3022C14.273 4.69273 14.273 5.32589 13.8824 5.71642L6.81525 12.7836C6.38819 13.2106 5.68292 13.1646 5.31505 12.6856L2.26638 8.71605C1.92998 8.27804 2.01235 7.65025 2.45036 7.31385L3.04518 6.85702C3.59269 6.43652 4.37742 6.53949 4.79792 7.087L6.30583 9.05037Z", fill: "currentColor" }));
    };
    return P.displayName = "Checkmark", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(i2e);
var Xxe = i2e.exports;
const Qxe = /* @__PURE__ */ ce(Xxe);
var o2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "CaretDown", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M8.67903 10.7962C8.45271 11.0679 8.04729 11.0679 7.82097 10.7962L4.63962 6.97649C4.3213 6.59428 4.5824 6 5.06866 6L11.4313 6C11.9176 6 12.1787 6.59428 11.8604 6.97649L8.67903 10.7962Z", fill: "currentColor" }));
    };
    return P.displayName = "CaretDown", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(o2e);
var Jxe = o2e.exports;
const eEe = /* @__PURE__ */ ce(Jxe);
var s2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Warning", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8639 1.51357C8.49039 0.828811 7.50961 0.828811 7.1361 1.51357L1.12218 12.5388C0.763263 13.1968 1.23814 14 1.98608 14H14.0139C14.7619 14 15.2367 13.1968 14.8778 12.5388L8.8639 1.51357ZM7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z", fill: "currentColor" }));
    };
    return P.displayName = "Warning", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(s2e);
var tEe = s2e.exports;
const nEe = /* @__PURE__ */ ce(tEe);
var c2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(c2e);
var rEe = c2e.exports;
const aEe = /* @__PURE__ */ ce(rEe);
var u2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(u2e);
var lEe = u2e.exports;
const iEe = /* @__PURE__ */ ce(lEe);
var f2e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(f2e);
var oEe = f2e.exports;
const sEe = /* @__PURE__ */ ce(oEe);
function cEe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function De(e, t, n) {
  return (t = cEe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vn.apply(this, arguments);
}
function Gn(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function je(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function uEe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Dz(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return Dz(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Dz(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var zz, Fz, Vz, qz, Uz, Wz, Gz, Kz, Tl = v(zz || (zz = je([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), d2e = De(De({}, W.Body1, v(Fz || (Fz = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Vz || (Vz = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), fEe = De(De({}, W.Body1, v(qz || (qz = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(Uz || (Uz = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), k1 = De(De({}, S.Light, v(Wz || (Wz = je([`
    color: `, `;
  `])), b.black)), S.Dark, v(Gz || (Gz = je([`
    color: `, `;
  `])), b.gray.light2)), Ta = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, dEe = ["baseFontSize", "darkMode", "className", "weight", "as"], pEe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = Gn(e, dEe), h = K(n).theme, g = Ta(t), m = ne(f).Component, y = v(Kz || (Kz = je([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, vn({ className: H(Tl, d2e[g], k1[h], y, r) }, d));
});
pEe.displayName = "Body";
var Yz, Xz, Qz, Jz, eF, tF, nF, rF, aF, lF, p2e = { label: "lg-label", description: "lg-description" }, gEe = v(Yz || (Yz = je([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular), hEe = De(De({}, S.Light, v(Xz || (Xz = je([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(Qz || (Qz = je([`
    color: `, `;
  `])), b.gray.light1)), mEe = De(De({}, S.Light, v(Jz || (Jz = je([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(eF || (eF = je([`
    color: `, `;
  `])), b.gray.dark1)), vEe = De(De({}, W.Body1, v(tF || (tF = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(nF || (nF = je([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), bEe = ["baseFontSize", "data-lgid", "darkMode", "disabled", "children", "className"], g2e = function(e) {
  var t = e.baseFontSize, n = e["data-lgid"], r = n === void 0 ? p2e.description : n, l = e.darkMode, i = e.disabled, c = i !== void 0 && i, f = e.children, d = e.className, h = Gn(e, bEe), g = K(l).theme, m = Ta(t);
  return k.createElement("p", vn({ "data-lgid": r, className: H(gEe, hEe[g], vEe[m], De({}, mEe[g], c), d) }, h), f);
};
g2e.displayName = "Description";
var iF, oF, sF, cF, uF;
De(De({}, S.Light, v(rF || (rF = je([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(aF || (aF = je([`
    color: `, `;
  `])), b.gray.light1));
v(lF || (lF = je([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var fF, dF, pF, gF, hF, mF, yEe = v(iF || (iF = je([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), wEe = De(De({}, S.Light, v(oF || (oF = je([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(sF || (sF = je([`
    color: `, `;
  `])), b.red.light1)), OEe = De(De({}, W.Body1, v(cF || (cF = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(uF || (uF = je([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), xEe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = Gn(e, xEe), f = K(r).theme, d = Ta(), h = ne(n).Component;
  return k.createElement(h, vn({}, c, { className: H(yEe, wEe[f], OEe[d], i) }), l);
});
var EEe = v(fF || (fF = je([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), $Ee = De(De({}, S.Light, v(dF || (dF = je([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(pF || (pF = je([`
    color: `, `;
  `])), b.gray.light2)), jEe = ["darkMode", "className", "as"], CEe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = Gn(e, jEe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, vn({ className: H(Tl, EEe, $Ee[c], n) }, i));
});
CEe.displayName = "H1";
var vF, MEe = v(gF || (gF = je([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), kEe = De(De({}, S.Light, v(hF || (hF = je([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(mF || (mF = je([`
    color: `, `;
  `])), b.gray.light2)), PEe = ["darkMode", "className", "as"], SEe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = Gn(e, PEe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, vn({ className: H(Tl, MEe, kEe[c], n) }, i));
});
SEe.displayName = "H2";
var bF, yF, wF, OF, xF, EF, $F, jF, CF, MF, NEe = v(vF || (vF = je([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), REe = ["darkMode", "className", "as"], _Ee = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = Gn(e, REe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, vn({ className: H(Tl, NEe, k1[c], n) }, i));
});
_Ee.displayName = "H3";
var kF, PF, SF, gl = gt(), AEe = v(bF || (bF = je([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, gl), LEe = De(De({}, S.Light, v(yF || (yF = je([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, gl, b.gray.light2, b.gray.light1)), S.Dark, v(wF || (wF = je([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, gl, b.gray.dark2, b.gray.dark1)), ZEe = De(De({}, S.Light, v(OF || (OF = je([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), gl, it[S.Light].default, b.blue.base)), S.Dark, v(xF || (xF = je([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), gl, it[S.Dark].default, b.blue.base)), TEe = De(De({}, S.Light, v(EF || (EF = je([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v($F || ($F = je([`
    color: `, `;
  `])), b.blue.light1)), BEe = v(jF || (jF = je([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), IEe = v(CF || (CF = je([`
  white-space: nowrap;
`]))), HEe = v(MF || (MF = je([`
  white-space: normal;
`]))), DEe = ["children", "className", "darkMode", "baseFontSize", "as"], NF = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = Gn(e, DEe), g = K(c).theme, m = Ta(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? IEe : HEe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(fEe[m], AEe, LEe[g], ZEe[g], w, De({}, TEe[g], C), i) }, l);
  return C ? k.createElement(y, vn({ className: H(gl, BEe, i) }, h), E) : k.cloneElement(E, h);
});
NF.displayName = "InlineCode", NF.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var RF, _F, AF, LF, ZF, TF, BF;
v(kF || (kF = je([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
De(De({}, S.Light, v(PF || (PF = je([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(SF || (SF = je([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var IF, HF, DF, zEe = v(RF || (RF = je([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), FEe = De(De({}, S.Light, v(_F || (_F = je([`
    color: `, `;
  `])), b.black)), S.Dark, v(AF || (AF = je([`
    color: `, `;
  `])), b.gray.light2)), VEe = De(De({}, S.Light, v(LF || (LF = je([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(ZF || (ZF = je([`
    color: `, `;
  `])), b.gray.dark1)), qEe = De(De({}, W.Body1, v(TF || (TF = je([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(BF || (BF = je([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), UEe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], h2e = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? p2e.label : h, m = Gn(e, UEe), y = K(n).theme, w = Ta(t), C = ne(d).Component;
  return k.createElement(C, vn({ "data-lgid": g, className: H(zEe, FEe[y], qEe[w], De({}, VEe[y], c), r) }, m), l);
});
h2e.displayName = "Label";
var zF, FF, VF, qF, UF, WF, sy = gt(), m2e = v(IF || (IF = je([`
  font-family: `, `;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), v2e = De(De({}, S.Light, v(HF || (HF = je([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(DF || (DF = je([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), b2e = function(e) {
  if (e)
    return d2e[e];
}, WEe = v(zF || (zF = je([`
  gap: `, `px;
`])), ee[100]), GEe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = Gn(e, GEe), d = K(i).theme, h = Ta(l), g = nt(c, f, "span").Component;
  return k.createElement(g, vn({ className: H(sy, m2e, b2e(h), v2e[d], WEe, r), ref: t }, f), k.createElement(aEe, { role: "presentation" }), n);
});
var KEe = v(FF || (FF = je([`
  transform: translate3d(3px, 0, 0);
`]))), YEe = v(VF || (VF = je([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;

  .`, `:hover & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), sy), XEe = v(qF || (qF = je([`
  position: relative;
  bottom: 4px;
  left: -1px;
  height: 12px;
`]))), QEe = "hover", JEe = "persist", GF = "none", e$e = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? GF : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = Gn(e, e$e), y = uEe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Ta(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== GF && (E = k.createElement(iEe, { role: "presentation", size: 12, className: H(De(De({}, YEe, i === QEe), KEe, i === JEe)) })) : E = k.createElement(sEe, { role: "presentation", className: XEe }), k.createElement(P, vn({ className: H(sy, m2e, b2e(M), v2e[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var t$e = v(UF || (UF = je([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), n$e = ["darkMode", "className", "as"], r$e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = Gn(e, n$e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, vn({ className: H(Tl, t$e, k1[c], n) }, i));
});
r$e.displayName = "Overline";
var a$e = v(WF || (WF = je([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), l$e = ["darkMode", "className", "as"], i$e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = Gn(e, l$e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, vn({ className: H(Tl, a$e, k1[c], n) }, i));
});
i$e.displayName = "Subtitle";
var KF;
v(KF || (KF = je([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function YF(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YF(Object(n), !0).forEach(function(r) {
      lt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YF(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function o$e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function lt(e, t, n) {
  return (t = o$e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Br() {
  return Br = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Br.apply(this, arguments);
}
function Di(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Ae(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function Oo(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || y2e(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function s$e(e) {
  return function(t) {
    if (Array.isArray(t))
      return e4(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || y2e(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function y2e(e, t) {
  if (e) {
    if (typeof e == "string")
      return e4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? e4(e, t) : void 0;
  }
}
function e4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var XF, QF, JF, eV, tV, nV, rV, aV, lV, iV, oV, sV, cV, Qi = "lg-select", To = { root: Qi, errorMessage: "".concat(Qi, "-error_message"), popover: "".concat(Qi, "-popover"), buttonText: "".concat(Qi, "-button_text") }, rr = { XSmall: "xsmall", Small: "small", Default: "default", Large: "large" }, rl = { None: "none", Error: "error" }, Bo = { Trigger: "trigger", Option: "option" }, cy = z9({ size: rr.Default, open: !1, disabled: !1 }), uy = lt(lt({}, S.Light, { menu: { border: b.gray.light2, shadow: $r(0.75, b.black) }, option: { group: { label: b.gray.dark1 }, background: { base: b.white, hovered: b.gray.light2, focused: b.blue.light3 }, text: { base: b.gray.dark3, selected: b.blue.base, disabled: b.gray.base, focused: b.blue.dark2 }, icon: { base: b.gray.dark1, selected: b.blue.base, disabled: b.gray.base }, indicator: { focused: b.blue.base } } }), S.Dark, { menu: { border: b.gray.dark2, shadow: $r(0.85, "#000000") }, option: { group: { label: b.gray.base }, background: { base: b.gray.dark3, hovered: b.gray.dark4, focused: b.blue.dark3 }, text: { base: b.gray.light2, selected: b.gray.light2, disabled: b.gray.base, focused: b.blue.light3 }, icon: { base: b.gray.base, selected: b.blue.light1, disabled: b.gray.base }, indicator: { focused: b.blue.light1 } } }), fy = lt(lt(lt(lt({}, rr.XSmall, { height: 22, text: 13, option: { text: 13 }, warningIcon: 16 }), rr.Small, { height: 28, text: 13, option: { text: 13 }, warningIcon: 16 }), rr.Default, { height: 36, text: 13, option: { text: 13 }, warningIcon: 16 }), rr.Large, { height: 48, text: 18, option: { text: 16 }, warningIcon: 16 }), c$e = 36, u$e = 16, uV = { text: 16, lineHeight: 19 }, Ji = { text: 16, lineHeight: 22 }, f$e = { text: 16 }, w2e = gt("option"), d$e = v(XF || (XF = Ae([`
  display: flex;
  width: 100%;
  outline: none;
  overflow-wrap: anywhere;
  transition: background-color `, `ms ease-in-out;
  position: relative;
  padding: `, `px 12px;
  line-height: inherit;

  &:before {
    content: '';
    position: absolute;
    transform: scaleY(0.3);
    top: 7px;
    bottom: 7px;
    left: 0;
    right: 0;
    width: 4px;
    border-radius: 0px 4px 4px 0px;
    opacity: 0;
    transition: all `, `ms ease-in-out;
  }

  .`, ` {
    line-height: 16px; // Hardcoding because it does not match a token
  }
`])), It.default, ee[2], It.default, Kse), p$e = v(QF || (QF = Ae([`
  display: flex;
  align-items: center;
  font-family: `, `;
`])), Q.default), fV = v(JF || (JF = Ae([`
  min-width: 16px;
`]))), dV = v(eV || (eV = Ae([`
  .`, ` {
    &:focus-visible & {
      color: currentColor;
    }
  }
`])), w2e), g$e = ["children", "className", "glyph", "selected", "focused", "disabled", "onClick", "onFocus", "triggerScrollIntoView", "hasGlyphs", "description"];
function dy(e) {
  var t = e.children, n = e.className, r = e.glyph, l = e.selected, i = e.focused, c = e.disabled, f = e.onClick, d = e.onFocus, h = e.triggerScrollIntoView, g = e.hasGlyphs, m = e.description, y = Di(e, g$e), w = K().theme, C = uy[w].option, E = Dn(null), R = rn(function() {
    if (E.current == null)
      return null;
    var N = E.current, T = N == null ? void 0 : N.offsetParent;
    if (!T)
      return null;
    T.scrollTop = N.offsetTop + (N.clientHeight - T.clientHeight) / 2;
  }, [E]), M = Wu(h), P = h && !M;
  Tt(function() {
    P && R();
  }, [R, P]);
  var a = Wu(i), o = i && !a;
  Tt(function() {
    o && E.current.focus();
  }, [o]), r && (Hz(r) || console.error("`Option` instance did not render icon because it is not a known glyph element."));
  var s = r && Hz(r) ? k.cloneElement(r, { key: "glyph", className: H(fV, v(tV || (tV = Ae([`
              color: `, `;
            `])), C.icon.base), dV, lt({}, v(nV || (nV = Ae([`
                color: `, `;
              `])), C.icon.disabled), c), r.props.className) }) : void 0, p = l ? k.createElement(Qxe, { key: "checkmark", className: H(fV, v(rV || (rV = Ae([`
          color: `, `;
        `])), C.icon.selected), dV, lt({}, v(aV || (aV = Ae([`
            color: `, `;
          `])), C.icon.disabled), c)) }) : void 0, O = g ? s : p, x = g ? p : void 0;
  return k.createElement(wge, Br({ "aria-label": typeof t == "string" ? t : "option" }, y, { disabled: c, role: "option", tabIndex: -1, ref: E, className: H(w2e, d$e, lt(lt({}, v(lV || (lV = Ae([`
            &:focus-visible {
              color: `, `;
              background-color: `, `;

              &:before {
                opacity: 1;
                transform: scaleY(1);
                background-color: `, `;
              }
            }
          `])), C.text.focused, C.background.focused, C.indicator.focused), !c), v(iV || (iV = Ae([`
            &,
            & .`, ` {
              color: `, `;
            }
          `])), Kse, C.text.disabled), c), n), onClick: f, onFocus: d, onKeyDown: void 0 }), k.createElement(Oge, { leftGlyph: O, rightGlyph: x, description: m }, k.createElement("span", { className: H(p$e, lt({}, v(oV || (oV = Ae([`
              font-weight: `, `;
            `])), Y.bold), l)) }, t)));
}
function t4(e) {
  throw Error("`Option` must be a child of a `Select` instance");
}
dy.displayName = "Option", t4.displayName = "Option", t4.propTypes = { children: z.node.isRequired, className: z.string, glyph: z.element, value: z.string, disabled: z.bool, description: z.string };
var pV, h$e = v(sV || (sV = Ae([`
  padding: `, `px 0;
`])), ee[2]), m$e = v(cV || (cV = Ae([`
  cursor: default;
  width: 100%;
  padding: 0 12px 2px;
  outline: none;
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 16px;
  font-weight: `, `;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`])), Y.bold), v$e = ["className", "label", "children"];
function O2e(e) {
  var t = e.className, n = e.label, r = e.children, l = Di(e, v$e), i = K().theme, c = uy[i].option, f = Hn({ prefix: "select-option-group" });
  return k.createElement("div", Br({ className: H(h$e, t) }, l), k.createElement("div", { id: f, className: H(m$e, v(pV || (pV = Ae([`
            color: `, `;
          `])), c.group.label)) }, n), k.createElement("div", { role: "group", "aria-labelledby": f }, r));
}
O2e.displayName = "OptionGroup", z.oneOfType([z.element, z.arrayOf(z.oneOfType([z.oneOf([!1, null, void 0, ""]), z.element]))]).isRequired, z.string, z.string.isRequired, z.bool;
var b$e = ["children"], gV = "@media only screen and (max-width: ".concat(il.Tablet, "px) and (hover: none)"), bi = "".concat(gV, " and (pointer: coarse), ").concat(gV, " and (pointer: none)");
function x2e(e) {
  return e == null || e === !1 || e === "";
}
function Ea(e, t) {
  k.Children.forEach(e, function(n) {
    lr(n, "Option") ? t(n) : lr(n, "OptionGroup") ? Ea(n.props.children, function(r) {
      return t(r, n);
    }) : Qse.isFragment(n) && Ea(n.props.children, t);
  });
}
function n4(e, t, n) {
  return k.Children.toArray(e).every(function(r) {
    return lr(r, "Option");
  }) || k.Children.toArray(e).every(function(r) {
    return lr(r, "OptionGroup");
  }) || lge.warn("LeafyGreen Select: Combining grouped and ungrouped Select Options can cause styling issues"), k.Children.map(e, function(r) {
    if (lr(r, "Option"))
      return k.createElement(dy, t(r));
    if (lr(r, "OptionGroup")) {
      var l = r.props, i = l.children, c = Di(l, b$e);
      return k.createElement(O2e, Br({ className: void 0 }, c), n4(i, function(f) {
        return t(f, r);
      }, n));
    }
    return Qse.isFragment(r) ? n4(r.props.children, t, n) : (x2e(r) || n == null || n(r), null);
  });
}
function gi(e) {
  return e === null ? "" : e.props.value !== void 0 ? e.props.value : Array.isArray(e.props.children) ? e.props.children.filter(function(t) {
    return !x2e(t);
  }).join("") : e.props.children ? e.props.children.toString() : "";
}
function r4(e, t) {
  var n, r, l;
  return (n = e.props.disabled) !== null && n !== void 0 && n || (r = t == null || (l = t.props) === null || l === void 0 ? void 0 : l.disabled) !== null && r !== void 0 && r;
}
function hV(e, t, n) {
  return gi(e) === n && !r4(e, t);
}
function E2e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.initialValue, r = t.deps, l = r === void 0 ? [] : r, i = Dn(n);
  return kt(function() {
    return { get current() {
      return i.current;
    }, set current(c) {
      i.current = c, e(c);
    } };
  }, [e, i].concat(s$e(l)));
}
function $2e(e, t) {
  var n = rn(function(r, l) {
    Array.isArray(r) ? r.forEach(n) : typeof r == "function" ? r(l) : r && (r.current = l);
  }, []);
  return E2e(rn(function(r) {
    return n(e, r);
  }, [e, n]), { initialValue: t });
}
var mV, vV, bV, yV, wV, OV, xV, EV, $V, jV, CV, MV, kV, PV, SV, NV, RV, _V, AV, LV, ZV, TV, BV = function(e) {
  var t = Oo(ht(e), 2), n = t[0];
  return E2e(t[1], { initialValue: e, deps: [n] });
}, y$e = gt("select-popover"), w$e = ee[2], O$e = v(mV || (mV = Ae([`
  position: relative;
  text-align: left;
  width: 100%;
  border-radius: 3px;
  line-height: 16px;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: auto;
`]))), x$e = v(vV || (vV = Ae([`
  width: max-content;
`]))), E$e = function(e, t) {
  var n = fy[t], r = uy[e];
  return H(v(bV || (bV = Ae([`
      font-family: `, `;
      font-size: `, `px;
      min-height: `, `px;
      background-color: `, `;
      border-radius: 12px;
      box-shadow: 0 4px 7px 0 `, `;
      padding: `, `px 0;
      border: 1px solid `, `;
    `])), Q.default, n.option.text, n.height, r.option.background.base, r.menu.shadow, ee[2], r.menu.border));
}, j2e = k.forwardRef(function(e, t) {
  var n = e.children, r = e.id, l = e.referenceElement, i = e.className, c = e.labelId, f = e.dropdownWidthBasis, d = e.usePortal, h = d === void 0 || d, g = e.portalContainer, m = e.scrollContainer, y = e.portalClassName, w = e.popoverZIndex, C = e.onEntering, E = e.onEnter, R = e.onEntered, M = e.onExiting, P = e.onExit, a = e.onExited, o = K().theme, s = jl(cy), p = s.size, O = s.disabled, x = s.open, N = $2e(t, null), T = ege(l, w$e), $ = tge(T) ? "unset" : "".concat(Math.min(T, 274), "px"), j = rn(function(Z) {
    N.current && N.current.focus(), Z.stopPropagation();
  }, [N]), A = wo({ popoverZIndex: w, onEntering: C, onEnter: E, onEntered: R, onExiting: M, onExit: P, onExited: a }, h ? { usePortal: h, portalClassName: y, portalContainer: g, scrollContainer: m } : { usePortal: h });
  return k.createElement(q9, Br({ active: x && !O, spacing: 6, align: fi.Bottom, justify: xn.Start, adjustOnMutation: !0, className: H(y$e, i, lt({}, x$e, f === Bo.Option)), refEl: l }, A), k.createElement("ul", { "data-lgid": To.popover, "aria-labelledby": c, role: "listbox", ref: N, tabIndex: -1, onClick: j, className: H(O$e, E$e(o, p), v(yV || (yV = Ae([`
              max-height: `, `;
              `, ` {
                font-size: `, `px;
              }
            `])), $, bi, f$e.text)), id: r }, n));
});
j2e.displayName = "ListMenu";
var IV, HV, DV, zV, FV, VV, qV, UV, $$e = gt("select-menu"), j$e = v(wV || (wV = Ae([`
  // Override button defaults
  font-weight: `, `;
  > *:last-child {
    grid-template-columns: 1fr 16px;
    justify-content: flex-start;

    > svg {
      justify-self: right;
      width: 16px;
      height: 16px;
    }
  }
`])), Y.regular), C$e = lt(lt(lt(lt({}, un.Default, v(OV || (OV = Ae([`
    > *:last-child {
      padding: 0 12px;
    }
  `])))), un.Large, v(xV || (xV = Ae([`
    > *:last-child {
      padding: 0 12px 0 `, `px;
    }
  `])), ee[3])), un.Small, v(EV || (EV = Ae([`
    > *:last-child {
      padding: 0 `, `px 0 10px;
    }
  `])), ee[2])), un.XSmall, v($V || ($V = Ae([`
    text-transform: none;
    font-size: `, `px;
    line-height: `, `px;
    > *:last-child {
      padding: 0 `, `px 0 10px;
    }
  `])), V.body1.fontSize, V.body1.lineHeight, ee[1])), M$e = lt(lt({}, S.Light, v(jV || (jV = Ae([`
    background-color: `, `;
    // Override button default color
    > *:last-child {
      > svg {
        color: `, `;
      }
    }
  `])), b.white, b.gray.dark2)), S.Dark, v(CV || (CV = Ae([`
    border-color: `, `;
    background-color: `, `;
    color: `, `;

    // Override button default color
    > *:last-child {
      > svg {
        color: `, `;
      }
    }

    &:hover,
    &:active,
    &:focus {
      background-color: `, `;
      color: `, `;
    }
  `])), b.gray.base, b.gray.dark4, b.gray.light3, b.gray.light1, b.gray.dark4, b.gray.light3)), k$e = lt(lt({}, S.Light, v(MV || (MV = Ae([`
    &:focus-visible {
      box-shadow: `, `;
      border-color: rgba(255, 255, 255, 0);
    }
  `])), it.light.input)), S.Dark, v(kV || (kV = Ae([`
    &:focus-visible {
      background-color: `, `;
      box-shadow: `, `;
      border-color: rgba(255, 255, 255, 0);
    }
  `])), b.gray.dark4, it.dark.input)), P$e = lt(lt({}, S.Light, v(PV || (PV = Ae([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(SV || (SV = Ae([`
    color: `, `;

    &:hover,
    &:active,
    &:focus {
      color: `, `;
    }
  `])), b.gray.light1, b.gray.light1)), WV = v(NV || (NV = Ae([`
  cursor: not-allowed;
  pointer-events: unset;
  box-shadow: unset;

  &:active {
    pointer-events: none;
  }
`]))), S$e = lt(lt({}, S.Light, H(WV, v(RV || (RV = Ae([`
      &[aria-disabled='true'] {
        background-color: `, `;
        color: `, `;

        > *:last-child {
          > svg {
            color: `, `;
          }
        }
      }
    `])), b.gray.light2, b.gray.base, b.gray.base))), S.Dark, H(WV, v(_V || (_V = Ae([`
      &[aria-disabled='true'] {
        background-color: `, `;
        color: `, `;
        border-color: `, `;

        > *:last-child {
          > svg {
            color: `, `;
          }
        }
      }
    `])), b.gray.dark3, b.gray.dark1, b.gray.dark2, b.gray.dark1))), N$e = v(AV || (AV = Ae([`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  gap: `, `px;
  overflow: hidden;
`])), ee[1]), R$e = v(LV || (LV = Ae([`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`]))), xo = lt(lt({}, S.Light, b.red.base), S.Dark, b.red.light1), _$e = lt(lt({}, S.Light, v(ZV || (ZV = Ae([`
    border-color: `, `;
    background-color: `, `;

    &:hover,
    &:active {
      box-shadow: `, `;
    }
  `])), xo[S.Light], b.white, gn.light.red)), S.Dark, v(TV || (TV = Ae([`
    border-color: `, `;

    &:hover,
    &:active {
      border-color: `, `;
      box-shadow: `, `;
    }
  `])), xo[S.Dark], xo[S.Dark], gn.dark.red)), A$e = ["children", "value", "text", "name", "deselected", "readOnly", "onClose", "onOpen", "errorMessage", "state", "baseFontSize", "__INTERNAL__menuButtonSlot__", "__INTERNAL__menuButtonSlotProps__"], C2e = k.forwardRef(function(e, t) {
  var n, r = e.children, l = e.value, i = e.text, c = e.name, f = e.deselected;
  e.readOnly;
  var d = e.onClose, h = e.onOpen, g = e.errorMessage, m = e.state, y = e.baseFontSize, w = e.__INTERNAL__menuButtonSlot__, C = e.__INTERNAL__menuButtonSlotProps__, E = Di(e, A$e), R = K().theme, M = jl(cy), P = M.open, a = M.size, o = M.disabled, s = $2e(t, null), p = fy[a], O = rn(function() {
    P ? d() : h(), s.current.focus();
  }, [d, h, P, s]), x = w || ko, N = w ? "" : H(j$e, M$e[R], C$e[a], k$e[R], lt(lt(lt(lt({}, P$e[R], f), S$e[R], o), _$e[R], m === rl.Error && !!g), v(IV || (IV = Ae([`
              letter-spacing: initial;
            `]))), a === ow.XSmall), v(HV || (HV = Ae([`
            width: 100%;
            `, ` {
              height: `, `px;
              font-size: `, `px;
            }
          `])), bi, c$e, u$e)), T = (n = E["data-testid"]) !== null && n !== void 0 ? n : "leafygreen-ui-select-menubutton";
  return k.createElement(x, Br({}, E, C, { ref: s, name: c, value: l, disabled: o, onClick: O, variant: yge.Default, darkMode: R === S.Dark, rightGlyph: k.createElement(eEe, null), size: a, "data-testid": T, className: H(N, lt({}, v(DV || (DV = Ae([`
              font-size: `, `px;
            `])), y), a === ow.Default), C == null ? void 0 : C.className) }), k.createElement("div", { className: N$e }, k.createElement("div", { "data-lgid": To.buttonText, className: H($$e, R$e) }, i), m === rl.Error && g && k.createElement(nEe, { "aria-hidden": !0, className: v(zV || (zV = Ae([`
                color: `, `;
              `])), xo[R]), size: p.warningIcon, title: "Error" })), r);
});
C2e.displayName = "MenuButton";
var GV, KV, YV, XV, QV, JV, eq, tq, L$e = v(FV || (FV = Ae([`
  display: flex;
  flex-direction: column;
  margin-bottom: `, `px;
`])), ee[1]), Z$e = v(VV || (VV = Ae([`
  display: flex;
  flex-direction: column;
`]))), nq = v(qV || (qV = Ae([`
  font-size: `, `px;
  line-height: `, `px;
`])), V.large.fontSize, V.large.lineHeight), T$e = function(e) {
  var t = e.darkMode, n = e.sizeSet;
  return v(UV || (UV = Ae([`
  font-family: `, `;
  color: `, `;
  font-size: `, `px;
  margin-top: `, `px;
  padding-left: 2px;
  transition: color `, `ms ease-in-out;
  transition-delay: `, `ms;
`])), Q.default, t ? b.red.light1 : b.red.base, n.text, ee[1], It.faster, It.faster);
}, B$e = ["children", "darkMode", "size", "disabled", "allowDeselect", "usePortal", "placeholder", "errorMessage", "state", "dropdownWidthBasis", "baseFontSize", "data-lgid", "id", "aria-labelledby", "aria-label", "className", "label", "description", "name", "defaultValue", "value", "onChange", "readOnly", "portalContainer", "scrollContainer", "portalClassName", "popoverZIndex", "onEntering", "onEnter", "onEntered", "onExiting", "onExit", "onExited", "__INTERNAL__menuButtonSlot__"], a4 = wn(function(e, t) {
  var n, r = e.children, l = e.darkMode, i = e.size, c = i === void 0 ? rr.Default : i, f = e.disabled, d = f !== void 0 && f, h = e.allowDeselect, g = h === void 0 || h, m = e.usePortal, y = m === void 0 || m, w = e.placeholder, C = w === void 0 ? "Select" : w, E = e.errorMessage, R = E === void 0 ? "" : E, M = e.state, P = M === void 0 ? rl.None : M, a = e.dropdownWidthBasis, o = a === void 0 ? Bo.Trigger : a, s = e.baseFontSize, p = s === void 0 ? W.Body1 : s, O = e["data-lgid"], x = O === void 0 ? To.root : O, N = e.id, T = e["aria-labelledby"], $ = e["aria-label"], j = e.className, A = e.label, Z = e.description, G = e.name, I = e.defaultValue, F = e.value, U = e.onChange, B = e.readOnly, L = e.portalContainer, q = e.scrollContainer, D = e.portalClassName, _ = e.popoverZIndex, re = e.onEntering, ue = e.onEnter, se = e.onEntered, Re = e.onExiting, ft = e.onExit, Le = e.onExited, Lt = e.__INTERNAL__menuButtonSlot__, de = Di(e, B$e), Zt = Hn({ prefix: "select", id: N }), Jt = kt(function() {
    return $ && !A ? void 0 : T ?? "".concat(Zt, "-label");
  }, [T, $, A, Zt]);
  A || T || $ || console.error("For screen-reader accessibility, label, aria-label, or aria-labelledby must be provided to Select.");
  var Ht = K(l).darkMode, Zn = "".concat(Zt, "-description"), an = "".concat(Zt, "-menu"), me = Oo(ht(!1), 2), at = me[0], He = me[1], ot = nge(t, null), Dt = BV(null), Ut = Hn({ prefix: "select" }), Kt = BV(null), Qn = fy[c], le = kt(function() {
    return { size: c, open: at, disabled: d };
  }, [c, at, d]);
  Tt(function() {
    F !== void 0 && U === void 0 && B !== !0 && console.warn("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
  }, [U, B, F]);
  var fe = rn(function() {
    He(!0);
  }, []), X = rn(function() {
    He(!1), Dt.current.focus();
  }, [Dt]);
  Tt(function() {
    if (at) {
      var _e = function($t) {
        var jt = Dt.current.contains($t.target) || Kt.current.contains($t.target);
        He(jt);
      };
      return document.addEventListener("mousedown", _e), function() {
        document.removeEventListener("mousedown", _e);
      };
    }
  }, [Kt, Dt, at]);
  var J = kt(function() {
    var _e = null;
    return F === void 0 && I !== void 0 && Ea(r, function($t, jt) {
      hV($t, jt, I) && (_e = $t);
    }), _e;
  }, [r, I, F]), oe = Oo(ht(J), 2), ve = oe[0], Ie = oe[1];
  Tt(function() {
    var _e;
    ve !== null && Ie((_e = function($t, jt) {
      var Nr, Vr, jc, Cc, nw, Mc, kc, Pc;
      return Ea($t, function(Rr) {
        if (Rr === jt)
          nw = jt;
        else if (Rr.props.children === jt.props.children && Rr.props.value === jt.props.value) {
          var rw;
          (rw = Mc) !== null && rw !== void 0 || (Mc = Rr);
        } else if (Rr.props.value !== void 0 && Rr.props.value === jt.props.value) {
          var aw;
          (aw = kc) !== null && aw !== void 0 || (kc = Rr);
        } else if (gi(Rr) === gi(jt)) {
          var lw;
          (lw = Pc) !== null && lw !== void 0 || (Pc = Rr);
        }
      }), (Nr = (Vr = (jc = (Cc = nw) !== null && Cc !== void 0 ? Cc : Mc) !== null && jc !== void 0 ? jc : kc) !== null && Vr !== void 0 ? Vr : Pc) !== null && Nr !== void 0 ? Nr : null;
    }(r, ve)) !== null && _e !== void 0 ? _e : J);
  }, [r, J, ve]);
  var Pt = kt(function() {
    if (F !== void 0) {
      var _e = null;
      return Ea(r, function($t, jt) {
        hV($t, jt, F) && (_e = $t);
      }), _e;
    }
    return ve;
  }, [r, ve, F]), Vt = rn(function(_e, $t) {
    $t.preventDefault(), $t.stopPropagation(), F === void 0 && Ie(_e), U == null || U(gi(_e), $t), Et(void 0), X();
  }, [U, X, F]), Wt = rn(function(_e, $t) {
    return function(jt) {
      jt.preventDefault(), jt.stopPropagation(), d || $t || (Vt(_e, jt), X());
    };
  }, [d, X, Vt]), Fr = Oo(ht(), 2), qt = Fr[0], Et = Fr[1], nn = kt(function() {
    var _e = [];
    return g && _e.push(null), Ea(r, function($t, jt) {
      r4($t, jt) || _e.push($t);
    }), _e;
  }, [r, g]), Tn = rn(function(_e) {
    qt !== void 0 && Vt(qt, _e);
  }, [qt, Vt]), Yy = rn(function() {
    Et(nn[0]);
  }, [nn]), Xy = rn(function() {
    Et(nn[nn.length - 1]);
  }, [nn]), Qy = rn(function() {
    if (qt === void 0 || nn.indexOf(qt) === 0)
      Xy();
    else {
      var _e = nn.indexOf(qt) - 1;
      Et(nn[_e]);
    }
  }, [nn, qt, Xy]), Jy = rn(function() {
    if (qt === void 0 || nn.indexOf(qt) === nn.length - 1)
      Yy();
    else {
      var _e = nn.indexOf(qt) + 1;
      Et(nn[_e]);
    }
  }, [nn, qt, Yy]), Gi = rn(function(_e, $t) {
    return function(jt) {
      jt.preventDefault(), jt.stopPropagation(), d || $t || Et(_e);
    };
  }, [d]), zpe = rn(function(_e) {
    var $t, jt;
    if (!(_e.ctrlKey || _e.shiftKey || _e.altKey)) {
      var Nr = ($t = Kt.current) === null || $t === void 0 ? void 0 : $t.contains(document.activeElement), Vr = (jt = Dt.current) === null || jt === void 0 ? void 0 : jt.contains(document.activeElement);
      if (Vr || Nr)
        switch (_e.key) {
          case wr.Tab:
          case wr.Escape:
            X(), Et(void 0);
            break;
          case wr.Enter:
          case wr.Space:
            at && !Vr && _e.preventDefault(), Tn(_e);
            break;
          case wr.ArrowUp:
            !at && Vr && fe(), _e.preventDefault(), Qy();
            break;
          case wr.ArrowDown:
            !at && Vr && fe(), _e.preventDefault(), Jy();
        }
    }
  }, [Kt, Dt, X, at, Tn, Qy, Jy, fe]);
  rge("keydown", zpe);
  var ew = age(), tw = kt(function() {
    var _e = !1;
    return Ea(r, function($t) {
      _e || (_e = $t.props.glyph !== void 0);
    }), _e;
  }, [r]), Ki = kt(function() {
    return ew !== null && Kt.current !== null && qt === void 0 && at;
  }, [qt, Kt, at, ew]), Fpe = kt(function() {
    var _e = Pt === null;
    return k.createElement(dy, { className: void 0, glyph: void 0, selected: _e, focused: qt === null, disabled: !1, onClick: Wt(null, !1), onFocus: Gi(null, !1), hasGlyphs: !1, triggerScrollIntoView: _e && Ki }, C);
  }, [Ki, qt, Wt, Gi, C, Pt]), Vpe = kt(function() {
    return n4(r, function(_e, $t) {
      var jt = _e === Pt, Nr = r4(_e, $t);
      return wo(wo({}, _e.props), {}, { className: _e.props.className, glyph: _e.props.glyph, selected: jt, focused: _e === qt, disabled: Nr, children: _e.props.children, hasGlyphs: tw, onClick: Wt(_e, Nr), onFocus: Gi(_e, Nr), triggerScrollIntoView: jt && Ki });
    }, function() {
      console.error("`Select` instance received child that is not `Option` or `OptionGroup`.");
    });
  }, [Ki, r, qt, Wt, Gi, tw, Pt]), qpe = wo({ popoverZIndex: _, onEntering: re, onEnter: ue, onEntered: se, onExiting: Re, onExit: ft, onExited: Le }, y ? { usePortal: y, portalClassName: D, portalContainer: L, scrollContainer: q } : { usePortal: y });
  return k.createElement(Fn, { darkMode: Ht }, k.createElement("div", { ref: ot, className: H(Z$e, j), "data-lgid": x }, (A || Z) && k.createElement("div", { className: L$e }, A && k.createElement(h2e, { htmlFor: Ut, id: Jt, darkMode: Ht, disabled: d, className: H(lt(lt({}, nq, c === rr.Large), v(GV || (GV = Ae([`
                        font-size: `, `px;
                        line-height: 20px;
                      `])), p), c === rr.Default), v(KV || (KV = Ae([`
                      // Prevent hover state from showing when hovering label
                      pointer-events: none;
                    `]))), v(YV || (YV = Ae([`
                      `, ` {
                        font-size: `, `px;
                        line-height: `, `px;
                      }
                    `])), bi, uV.text, uV.lineHeight)) }, A), Z && k.createElement(g2e, { id: Zn, darkMode: Ht, disabled: d, className: H(lt(lt({}, nq, c === rr.Large), v(XV || (XV = Ae([`
                        font-size: `, `px;
                        line-height: 20px;
                      `])), p), c === rr.Default), v(QV || (QV = Ae([`
                      `, ` {
                        font-size: `, `px;
                        line-height: `, `px;
                      }
                    `])), bi, Ji.text, Ji.lineHeight)) }, Z)), k.createElement(cy.Provider, { value: le }, k.createElement(C2e, Br({}, de, { id: Ut, ref: Dt, name: G, readOnly: B, value: gi(Pt), text: Pt !== null ? Pt.props.children : C, deselected: Pt === null, onOpen: fe, onClose: X, "aria-labelledby": Jt, "aria-label": A || T ? void 0 : $, "aria-controls": an, "aria-expanded": at, "aria-describedby": Zn, "aria-invalid": P === rl.Error, "aria-disabled": d, errorMessage: R, state: P, baseFontSize: p, __INTERNAL__menuButtonSlot__: Lt }), k.createElement(j2e, Br({ labelId: Jt, id: an, referenceElement: Dt, ref: Kt, className: H(lt({}, v(JV || (JV = Ae([`
                    width: `, `px;
                  `])), (n = Dt.current) === null || n === void 0 ? void 0 : n.clientWidth), o === Bo.Trigger)), dropdownWidthBasis: o }, qpe), g && Fpe, Vpe))), P === rl.Error && R && k.createElement("span", { "data-lgid": To.errorMessage, className: H(T$e({ darkMode: Ht, sizeSet: Qn }), v(eq || (eq = Ae([`
                  `, ` {
                    font-size: `, `px;
                    line-height: `, `px;
                  }
                `])), bi, Ji.text, Ji.lineHeight), lt({}, v(tq || (tq = Ae([`
                    // Hide error text when menu is open,
                    // so it doesn't peek around the menu corner
                    color: transparent;
                  `]))), at)) }, R)));
});
a4.displayName = "Select", a4.propTypes = { label: z.string, "aria-labelledby": z.string, "aria-label": z.string, description: z.node, placeholder: z.string, className: z.string, darkMode: z.bool, size: z.oneOf(Object.values(rr)), disabled: z.bool, id: z.string, value: z.string, defaultValue: z.string, onChange: z.func, readOnly: z.bool, errorMessage: z.string, state: z.oneOf(Object.values(rl)), allowDeselect: z.bool, baseFontSize: z.oneOf(Object.values(W)), dropdownWidthBasis: z.oneOf(Object.values(Bo)) };
var py = { exports: {} };
function gy(e) {
  return e instanceof Map ? e.clear = e.delete = e.set = function() {
    throw new Error("map is read-only");
  } : e instanceof Set && (e.add = e.clear = e.delete = function() {
    throw new Error("set is read-only");
  }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach(function(t) {
    var n = e[t];
    typeof n == "object" && !Object.isFrozen(n) && gy(n);
  }), e;
}
py.exports = gy;
py.exports.default = gy;
var I$e = py.exports;
class rq {
  /**
   * @param {CompiledMode} mode
   */
  constructor(t) {
    t.data === void 0 && (t.data = {}), this.data = t.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function M2e(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function na(e, ...t) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r in e)
    n[r] = e[r];
  return t.forEach(function(r) {
    for (const l in r)
      n[l] = r[l];
  }), /** @type {T} */
  n;
}
const H$e = "</span>", aq = (e) => !!e.kind, D$e = (e, { prefix: t }) => {
  if (e.includes(".")) {
    const n = e.split(".");
    return [
      `${t}${n.shift()}`,
      ...n.map((r, l) => `${r}${"_".repeat(l + 1)}`)
    ].join(" ");
  }
  return `${t}${e}`;
};
class z$e {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(t, n) {
    this.buffer = "", this.classPrefix = n.classPrefix, t.walk(this);
  }
  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(t) {
    this.buffer += M2e(t);
  }
  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(t) {
    if (!aq(t))
      return;
    let n = t.kind;
    t.sublanguage ? n = `language-${n}` : n = D$e(n, { prefix: this.classPrefix }), this.span(n);
  }
  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(t) {
    aq(t) && (this.buffer += H$e);
  }
  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }
  // helpers
  /**
   * Builds a span element
   *
   * @param {string} className */
  span(t) {
    this.buffer += `<span class="${t}">`;
  }
}
class hy {
  constructor() {
    this.rootNode = { children: [] }, this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  /** @param {Node} node */
  add(t) {
    this.top.children.push(t);
  }
  /** @param {string} kind */
  openNode(t) {
    const n = { kind: t, children: [] };
    this.add(n), this.stack.push(n);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); )
      ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(t) {
    return this.constructor._walk(t, this.rootNode);
  }
  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(t, n) {
    return typeof n == "string" ? t.addText(n) : n.children && (t.openNode(n), n.children.forEach((r) => this._walk(t, r)), t.closeNode(n)), t;
  }
  /**
   * @param {Node} node
   */
  static _collapse(t) {
    typeof t != "string" && t.children && (t.children.every((n) => typeof n == "string") ? t.children = [t.children.join("")] : t.children.forEach((n) => {
      hy._collapse(n);
    }));
  }
}
class F$e extends hy {
  /**
   * @param {*} options
   */
  constructor(t) {
    super(), this.options = t;
  }
  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(t, n) {
    t !== "" && (this.openNode(n), this.addText(t), this.closeNode());
  }
  /**
   * @param {string} text
   */
  addText(t) {
    t !== "" && this.add(t);
  }
  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(t, n) {
    const r = t.root;
    r.kind = n, r.sublanguage = !0, this.add(r);
  }
  toHTML() {
    return new z$e(this, this.options).value();
  }
  finalize() {
    return !0;
  }
}
function Mi(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function k2e(e) {
  return Ba("(?=", e, ")");
}
function V$e(e) {
  return Ba("(?:", e, ")*");
}
function q$e(e) {
  return Ba("(?:", e, ")?");
}
function Ba(...e) {
  return e.map((n) => Mi(n)).join("");
}
function U$e(e) {
  const t = e[e.length - 1];
  return typeof t == "object" && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
}
function my(...e) {
  return "(" + (U$e(e).capture ? "" : "?:") + e.map((r) => Mi(r)).join("|") + ")";
}
function P2e(e) {
  return new RegExp(e.toString() + "|").exec("").length - 1;
}
function W$e(e, t) {
  const n = e && e.exec(t);
  return n && n.index === 0;
}
const G$e = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function vy(e, { joinWith: t }) {
  let n = 0;
  return e.map((r) => {
    n += 1;
    const l = n;
    let i = Mi(r), c = "";
    for (; i.length > 0; ) {
      const f = G$e.exec(i);
      if (!f) {
        c += i;
        break;
      }
      c += i.substring(0, f.index), i = i.substring(f.index + f[0].length), f[0][0] === "\\" && f[1] ? c += "\\" + String(Number(f[1]) + l) : (c += f[0], f[0] === "(" && n++);
    }
    return c;
  }).map((r) => `(${r})`).join(t);
}
const K$e = /\b\B/, S2e = "[a-zA-Z]\\w*", by = "[a-zA-Z_]\\w*", N2e = "\\b\\d+(\\.\\d+)?", R2e = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", _2e = "\\b(0b[01]+)", Y$e = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", X$e = (e = {}) => {
  const t = /^#![ ]*\//;
  return e.binary && (e.begin = Ba(
    t,
    /.*\b/,
    e.binary,
    /\b.*/
  )), na({
    scope: "meta",
    begin: t,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (n, r) => {
      n.index !== 0 && r.ignoreMatch();
    }
  }, e);
}, ki = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, Q$e = {
  scope: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [ki]
}, J$e = {
  scope: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [ki]
}, eje = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
}, P1 = function(e, t, n = {}) {
  const r = na(
    {
      scope: "comment",
      begin: e,
      end: t,
      contains: []
    },
    n
  );
  r.contains.push({
    scope: "doctag",
    // hack to avoid the space from being included. the space is necessary to
    // match here to prevent the plain text rule below from gobbling up doctags
    begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
    end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
    excludeBegin: !0,
    relevance: 0
  });
  const l = my(
    // list of common 1 and 2 letter words in English
    "I",
    "a",
    "is",
    "so",
    "us",
    "to",
    "at",
    "if",
    "in",
    "it",
    "on",
    // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/,
    // contractions - can't we'd they're let's, etc
    /[A-Za-z]+[-][a-z]+/,
    // `no-way`, etc.
    /[A-Za-z][a-z]{2,}/
    // allow capitalized words at beginning of sentences
  );
  return r.contains.push(
    {
      // TODO: how to include ", (, ) without breaking grammars that use these for
      // comment delimiters?
      // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
      // ---
      // this tries to find sequences of 3 english words in a row (without any
      // "programming" type syntax) this gives us a strong signal that we've
      // TRULY found a comment - vs perhaps scanning with the wrong language.
      // It's possible to find something that LOOKS like the start of the
      // comment - but then if there is no readable text - good chance it is a
      // false match and not a comment.
      //
      // for a visual example please see:
      // https://github.com/highlightjs/highlight.js/issues/2827
      begin: Ba(
        /[ ]+/,
        // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
        "(",
        l,
        /[.]?[:]?([.][ ]|[ ])/,
        "){3}"
      )
      // look for 3 words in a row
    }
  ), r;
}, tje = P1("//", "$"), nje = P1("/\\*", "\\*/"), rje = P1("#", "$"), aje = {
  scope: "number",
  begin: N2e,
  relevance: 0
}, lje = {
  scope: "number",
  begin: R2e,
  relevance: 0
}, ije = {
  scope: "number",
  begin: _2e,
  relevance: 0
}, oje = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    scope: "regexp",
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      ki,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [ki]
      }
    ]
  }]
}, sje = {
  scope: "title",
  begin: S2e,
  relevance: 0
}, cje = {
  scope: "title",
  begin: by,
  relevance: 0
}, uje = {
  // excludes method names from keyword processing
  begin: "\\.\\s*" + by,
  relevance: 0
}, fje = function(e) {
  return Object.assign(
    e,
    {
      /** @type {ModeCallback} */
      "on:begin": (t, n) => {
        n.data._beginMatch = t[1];
      },
      /** @type {ModeCallback} */
      "on:end": (t, n) => {
        n.data._beginMatch !== t[1] && n.ignoreMatch();
      }
    }
  );
};
var eo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MATCH_NOTHING_RE: K$e,
  IDENT_RE: S2e,
  UNDERSCORE_IDENT_RE: by,
  NUMBER_RE: N2e,
  C_NUMBER_RE: R2e,
  BINARY_NUMBER_RE: _2e,
  RE_STARTERS_RE: Y$e,
  SHEBANG: X$e,
  BACKSLASH_ESCAPE: ki,
  APOS_STRING_MODE: Q$e,
  QUOTE_STRING_MODE: J$e,
  PHRASAL_WORDS_MODE: eje,
  COMMENT: P1,
  C_LINE_COMMENT_MODE: tje,
  C_BLOCK_COMMENT_MODE: nje,
  HASH_COMMENT_MODE: rje,
  NUMBER_MODE: aje,
  C_NUMBER_MODE: lje,
  BINARY_NUMBER_MODE: ije,
  REGEXP_MODE: oje,
  TITLE_MODE: sje,
  UNDERSCORE_TITLE_MODE: cje,
  METHOD_GUARD: uje,
  END_SAME_AS_BEGIN: fje
});
function dje(e, t) {
  e.input[e.index - 1] === "." && t.ignoreMatch();
}
function pje(e, t) {
  e.className !== void 0 && (e.scope = e.className, delete e.className);
}
function gje(e, t) {
  t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = dje, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
}
function hje(e, t) {
  Array.isArray(e.illegal) && (e.illegal = my(...e.illegal));
}
function mje(e, t) {
  if (e.match) {
    if (e.begin || e.end)
      throw new Error("begin & end are not supported with match");
    e.begin = e.match, delete e.match;
  }
}
function vje(e, t) {
  e.relevance === void 0 && (e.relevance = 1);
}
const bje = (e, t) => {
  if (!e.beforeMatch)
    return;
  if (e.starts)
    throw new Error("beforeMatch cannot be used with starts");
  const n = Object.assign({}, e);
  Object.keys(e).forEach((r) => {
    delete e[r];
  }), e.keywords = n.keywords, e.begin = Ba(n.beforeMatch, k2e(n.begin)), e.starts = {
    relevance: 0,
    contains: [
      Object.assign(n, { endsParent: !0 })
    ]
  }, e.relevance = 0, delete n.beforeMatch;
}, yje = [
  "of",
  "and",
  "for",
  "in",
  "not",
  "or",
  "if",
  "then",
  "parent",
  // common variable name
  "list",
  // common variable name
  "value"
  // common variable name
], wje = "keyword";
function A2e(e, t, n = wje) {
  const r = /* @__PURE__ */ Object.create(null);
  return typeof e == "string" ? l(n, e.split(" ")) : Array.isArray(e) ? l(n, e) : Object.keys(e).forEach(function(i) {
    Object.assign(
      r,
      A2e(e[i], t, i)
    );
  }), r;
  function l(i, c) {
    t && (c = c.map((f) => f.toLowerCase())), c.forEach(function(f) {
      const d = f.split("|");
      r[d[0]] = [i, Oje(d[0], d[1])];
    });
  }
}
function Oje(e, t) {
  return t ? Number(t) : xje(e) ? 0 : 1;
}
function xje(e) {
  return yje.includes(e.toLowerCase());
}
const lq = {}, Ca = (e) => {
  console.error(e);
}, iq = (e, ...t) => {
  console.log(`WARN: ${e}`, ...t);
}, Ua = (e, t) => {
  lq[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), lq[`${e}/${t}`] = !0);
}, Io = new Error();
function L2e(e, t, { key: n }) {
  let r = 0;
  const l = e[n], i = {}, c = {};
  for (let f = 1; f <= t.length; f++)
    c[f + r] = l[f], i[f + r] = !0, r += P2e(t[f - 1]);
  e[n] = c, e[n]._emit = i, e[n]._multi = !0;
}
function Eje(e) {
  if (Array.isArray(e.begin)) {
    if (e.skip || e.excludeBegin || e.returnBegin)
      throw Ca("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), Io;
    if (typeof e.beginScope != "object" || e.beginScope === null)
      throw Ca("beginScope must be object"), Io;
    L2e(e, e.begin, { key: "beginScope" }), e.begin = vy(e.begin, { joinWith: "" });
  }
}
function $je(e) {
  if (Array.isArray(e.end)) {
    if (e.skip || e.excludeEnd || e.returnEnd)
      throw Ca("skip, excludeEnd, returnEnd not compatible with endScope: {}"), Io;
    if (typeof e.endScope != "object" || e.endScope === null)
      throw Ca("endScope must be object"), Io;
    L2e(e, e.end, { key: "endScope" }), e.end = vy(e.end, { joinWith: "" });
  }
}
function jje(e) {
  e.scope && typeof e.scope == "object" && e.scope !== null && (e.beginScope = e.scope, delete e.scope);
}
function Cje(e) {
  jje(e), typeof e.beginScope == "string" && (e.beginScope = { _wrap: e.beginScope }), typeof e.endScope == "string" && (e.endScope = { _wrap: e.endScope }), Eje(e), $je(e);
}
function Mje(e) {
  function t(c, f) {
    return new RegExp(
      Mi(c),
      "m" + (e.case_insensitive ? "i" : "") + (e.unicodeRegex ? "u" : "") + (f ? "g" : "")
    );
  }
  class n {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    // @ts-ignore
    addRule(f, d) {
      d.position = this.position++, this.matchIndexes[this.matchAt] = d, this.regexes.push([d, f]), this.matchAt += P2e(f) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const f = this.regexes.map((d) => d[1]);
      this.matcherRe = t(vy(f, { joinWith: "|" }), !0), this.lastIndex = 0;
    }
    /** @param {string} s */
    exec(f) {
      this.matcherRe.lastIndex = this.lastIndex;
      const d = this.matcherRe.exec(f);
      if (!d)
        return null;
      const h = d.findIndex((m, y) => y > 0 && m !== void 0), g = this.matchIndexes[h];
      return d.splice(0, h), Object.assign(d, g);
    }
  }
  class r {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    // @ts-ignore
    getMatcher(f) {
      if (this.multiRegexes[f])
        return this.multiRegexes[f];
      const d = new n();
      return this.rules.slice(f).forEach(([h, g]) => d.addRule(h, g)), d.compile(), this.multiRegexes[f] = d, d;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    // @ts-ignore
    addRule(f, d) {
      this.rules.push([f, d]), d.type === "begin" && this.count++;
    }
    /** @param {string} s */
    exec(f) {
      const d = this.getMatcher(this.regexIndex);
      d.lastIndex = this.lastIndex;
      let h = d.exec(f);
      if (this.resumingScanAtSamePosition() && !(h && h.index === this.lastIndex)) {
        const g = this.getMatcher(0);
        g.lastIndex = this.lastIndex + 1, h = g.exec(f);
      }
      return h && (this.regexIndex += h.position + 1, this.regexIndex === this.count && this.considerAll()), h;
    }
  }
  function l(c) {
    const f = new r();
    return c.contains.forEach((d) => f.addRule(d.begin, { rule: d, type: "begin" })), c.terminatorEnd && f.addRule(c.terminatorEnd, { type: "end" }), c.illegal && f.addRule(c.illegal, { type: "illegal" }), f;
  }
  function i(c, f) {
    const d = (
      /** @type CompiledMode */
      c
    );
    if (c.isCompiled)
      return d;
    [
      pje,
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      mje,
      Cje,
      bje
    ].forEach((g) => g(c, f)), e.compilerExtensions.forEach((g) => g(c, f)), c.__beforeBegin = null, [
      gje,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      hje,
      // default to 1 relevance if not specified
      vje
    ].forEach((g) => g(c, f)), c.isCompiled = !0;
    let h = null;
    return typeof c.keywords == "object" && c.keywords.$pattern && (c.keywords = Object.assign({}, c.keywords), h = c.keywords.$pattern, delete c.keywords.$pattern), h = h || /\w+/, c.keywords && (c.keywords = A2e(c.keywords, e.case_insensitive)), d.keywordPatternRe = t(h, !0), f && (c.begin || (c.begin = /\B|\b/), d.beginRe = t(d.begin), !c.end && !c.endsWithParent && (c.end = /\B|\b/), c.end && (d.endRe = t(d.end)), d.terminatorEnd = Mi(d.end) || "", c.endsWithParent && f.terminatorEnd && (d.terminatorEnd += (c.end ? "|" : "") + f.terminatorEnd)), c.illegal && (d.illegalRe = t(
      /** @type {RegExp | string} */
      c.illegal
    )), c.contains || (c.contains = []), c.contains = [].concat(...c.contains.map(function(g) {
      return kje(g === "self" ? c : g);
    })), c.contains.forEach(function(g) {
      i(
        /** @type Mode */
        g,
        d
      );
    }), c.starts && i(c.starts, f), d.matcher = l(d), d;
  }
  if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self"))
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return e.classNameAliases = na(e.classNameAliases || {}), i(
    /** @type Mode */
    e
  );
}
function Z2e(e) {
  return e ? e.endsWithParent || Z2e(e.starts) : !1;
}
function kje(e) {
  return e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
    return na(e, { variants: null }, t);
  })), e.cachedVariants ? e.cachedVariants : Z2e(e) ? na(e, { starts: e.starts ? na(e.starts) : null }) : Object.isFrozen(e) ? na(e) : e;
}
var Pje = "11.5.1";
class Sje extends Error {
  constructor(t, n) {
    super(t), this.name = "HTMLInjectionError", this.html = n;
  }
}
const eu = M2e, oq = na, sq = Symbol("nomatch"), Nje = 7, Rje = function(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), r = [];
  let l = !0;
  const i = "Could not find the language '{}', did you forget to load/include a language module?", c = { disableAutodetect: !0, name: "Plain text", contains: [] };
  let f = {
    ignoreUnescapedHTML: !1,
    throwUnescapedHTML: !1,
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    cssSelector: "pre code",
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: F$e
  };
  function d(I) {
    return f.noHighlightRe.test(I);
  }
  function h(I) {
    let F = I.className + " ";
    F += I.parentNode ? I.parentNode.className : "";
    const U = f.languageDetectRe.exec(F);
    if (U) {
      const B = N(U[1]);
      return B || (iq(i.replace("{}", U[1])), iq("Falling back to no-highlight mode for this block.", I)), B ? U[1] : "no-highlight";
    }
    return F.split(/\s+/).find((B) => d(B) || N(B));
  }
  function g(I, F, U) {
    let B = "", L = "";
    typeof F == "object" ? (B = I, U = F.ignoreIllegals, L = F.language) : (Ua("10.7.0", "highlight(lang, code, ...args) has been deprecated."), Ua("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), L = I, B = F), U === void 0 && (U = !0);
    const q = {
      code: B,
      language: L
    };
    Z("before:highlight", q);
    const D = q.result ? q.result : m(q.language, q.code, U);
    return D.code = q.code, Z("after:highlight", D), D;
  }
  function m(I, F, U, B) {
    const L = /* @__PURE__ */ Object.create(null);
    function q(le, fe) {
      return le.keywords[fe];
    }
    function D() {
      if (!me.keywords) {
        He.addText(ot);
        return;
      }
      let le = 0;
      me.keywordPatternRe.lastIndex = 0;
      let fe = me.keywordPatternRe.exec(ot), X = "";
      for (; fe; ) {
        X += ot.substring(le, fe.index);
        const J = Ht.case_insensitive ? fe[0].toLowerCase() : fe[0], oe = q(me, J);
        if (oe) {
          const [ve, Ie] = oe;
          if (He.addText(X), X = "", L[J] = (L[J] || 0) + 1, L[J] <= Nje && (Dt += Ie), ve.startsWith("_"))
            X += fe[0];
          else {
            const Pt = Ht.classNameAliases[ve] || ve;
            He.addKeyword(fe[0], Pt);
          }
        } else
          X += fe[0];
        le = me.keywordPatternRe.lastIndex, fe = me.keywordPatternRe.exec(ot);
      }
      X += ot.substr(le), He.addText(X);
    }
    function _() {
      if (ot === "")
        return;
      let le = null;
      if (typeof me.subLanguage == "string") {
        if (!t[me.subLanguage]) {
          He.addText(ot);
          return;
        }
        le = m(me.subLanguage, ot, !0, at[me.subLanguage]), at[me.subLanguage] = /** @type {CompiledMode} */
        le._top;
      } else
        le = w(ot, me.subLanguage.length ? me.subLanguage : null);
      me.relevance > 0 && (Dt += le.relevance), He.addSublanguage(le._emitter, le.language);
    }
    function re() {
      me.subLanguage != null ? _() : D(), ot = "";
    }
    function ue(le, fe) {
      let X = 1;
      const J = fe.length - 1;
      for (; X <= J; ) {
        if (!le._emit[X]) {
          X++;
          continue;
        }
        const oe = Ht.classNameAliases[le[X]] || le[X], ve = fe[X];
        oe ? He.addKeyword(ve, oe) : (ot = ve, D(), ot = ""), X++;
      }
    }
    function se(le, fe) {
      return le.scope && typeof le.scope == "string" && He.openNode(Ht.classNameAliases[le.scope] || le.scope), le.beginScope && (le.beginScope._wrap ? (He.addKeyword(ot, Ht.classNameAliases[le.beginScope._wrap] || le.beginScope._wrap), ot = "") : le.beginScope._multi && (ue(le.beginScope, fe), ot = "")), me = Object.create(le, { parent: { value: me } }), me;
    }
    function Re(le, fe, X) {
      let J = W$e(le.endRe, X);
      if (J) {
        if (le["on:end"]) {
          const oe = new rq(le);
          le["on:end"](fe, oe), oe.isMatchIgnored && (J = !1);
        }
        if (J) {
          for (; le.endsParent && le.parent; )
            le = le.parent;
          return le;
        }
      }
      if (le.endsWithParent)
        return Re(le.parent, fe, X);
    }
    function ft(le) {
      return me.matcher.regexIndex === 0 ? (ot += le[0], 1) : (Qn = !0, 0);
    }
    function Le(le) {
      const fe = le[0], X = le.rule, J = new rq(X), oe = [X.__beforeBegin, X["on:begin"]];
      for (const ve of oe)
        if (ve && (ve(le, J), J.isMatchIgnored))
          return ft(fe);
      return X.skip ? ot += fe : (X.excludeBegin && (ot += fe), re(), !X.returnBegin && !X.excludeBegin && (ot = fe)), se(X, le), X.returnBegin ? 0 : fe.length;
    }
    function Lt(le) {
      const fe = le[0], X = F.substr(le.index), J = Re(me, le, X);
      if (!J)
        return sq;
      const oe = me;
      me.endScope && me.endScope._wrap ? (re(), He.addKeyword(fe, me.endScope._wrap)) : me.endScope && me.endScope._multi ? (re(), ue(me.endScope, le)) : oe.skip ? ot += fe : (oe.returnEnd || oe.excludeEnd || (ot += fe), re(), oe.excludeEnd && (ot = fe));
      do
        me.scope && He.closeNode(), !me.skip && !me.subLanguage && (Dt += me.relevance), me = me.parent;
      while (me !== J.parent);
      return J.starts && se(J.starts, le), oe.returnEnd ? 0 : fe.length;
    }
    function de() {
      const le = [];
      for (let fe = me; fe !== Ht; fe = fe.parent)
        fe.scope && le.unshift(fe.scope);
      le.forEach((fe) => He.openNode(fe));
    }
    let Zt = {};
    function Jt(le, fe) {
      const X = fe && fe[0];
      if (ot += le, X == null)
        return re(), 0;
      if (Zt.type === "begin" && fe.type === "end" && Zt.index === fe.index && X === "") {
        if (ot += F.slice(fe.index, fe.index + 1), !l) {
          const J = new Error(`0 width match regex (${I})`);
          throw J.languageName = I, J.badRule = Zt.rule, J;
        }
        return 1;
      }
      if (Zt = fe, fe.type === "begin")
        return Le(fe);
      if (fe.type === "illegal" && !U) {
        const J = new Error('Illegal lexeme "' + X + '" for mode "' + (me.scope || "<unnamed>") + '"');
        throw J.mode = me, J;
      } else if (fe.type === "end") {
        const J = Lt(fe);
        if (J !== sq)
          return J;
      }
      if (fe.type === "illegal" && X === "")
        return 1;
      if (Kt > 1e5 && Kt > fe.index * 3)
        throw new Error("potential infinite loop, way more iterations than matches");
      return ot += X, X.length;
    }
    const Ht = N(I);
    if (!Ht)
      throw Ca(i.replace("{}", I)), new Error('Unknown language: "' + I + '"');
    const Zn = Mje(Ht);
    let an = "", me = B || Zn;
    const at = {}, He = new f.__emitter(f);
    de();
    let ot = "", Dt = 0, Ut = 0, Kt = 0, Qn = !1;
    try {
      for (me.matcher.considerAll(); ; ) {
        Kt++, Qn ? Qn = !1 : me.matcher.considerAll(), me.matcher.lastIndex = Ut;
        const le = me.matcher.exec(F);
        if (!le)
          break;
        const fe = F.substring(Ut, le.index), X = Jt(fe, le);
        Ut = le.index + X;
      }
      return Jt(F.substr(Ut)), He.closeAllNodes(), He.finalize(), an = He.toHTML(), {
        language: I,
        value: an,
        relevance: Dt,
        illegal: !1,
        _emitter: He,
        _top: me
      };
    } catch (le) {
      if (le.message && le.message.includes("Illegal"))
        return {
          language: I,
          value: eu(F),
          illegal: !0,
          relevance: 0,
          _illegalBy: {
            message: le.message,
            index: Ut,
            context: F.slice(Ut - 100, Ut + 100),
            mode: le.mode,
            resultSoFar: an
          },
          _emitter: He
        };
      if (l)
        return {
          language: I,
          value: eu(F),
          illegal: !1,
          relevance: 0,
          errorRaised: le,
          _emitter: He,
          _top: me
        };
      throw le;
    }
  }
  function y(I) {
    const F = {
      value: eu(I),
      illegal: !1,
      relevance: 0,
      _top: c,
      _emitter: new f.__emitter(f)
    };
    return F._emitter.addText(I), F;
  }
  function w(I, F) {
    F = F || f.languages || Object.keys(t);
    const U = y(I), B = F.filter(N).filter($).map(
      (re) => m(re, I, !1)
    );
    B.unshift(U);
    const L = B.sort((re, ue) => {
      if (re.relevance !== ue.relevance)
        return ue.relevance - re.relevance;
      if (re.language && ue.language) {
        if (N(re.language).supersetOf === ue.language)
          return 1;
        if (N(ue.language).supersetOf === re.language)
          return -1;
      }
      return 0;
    }), [q, D] = L, _ = q;
    return _.secondBest = D, _;
  }
  function C(I, F, U) {
    const B = F && n[F] || U;
    I.classList.add("hljs"), I.classList.add(`language-${B}`);
  }
  function E(I) {
    let F = null;
    const U = h(I);
    if (d(U))
      return;
    if (Z(
      "before:highlightElement",
      { el: I, language: U }
    ), I.children.length > 0 && (f.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(I)), f.throwUnescapedHTML))
      throw new Sje(
        "One of your code blocks includes unescaped HTML.",
        I.innerHTML
      );
    F = I;
    const B = F.textContent, L = U ? g(B, { language: U, ignoreIllegals: !0 }) : w(B);
    I.innerHTML = L.value, C(I, U, L.language), I.result = {
      language: L.language,
      // TODO: remove with version 11.0
      re: L.relevance,
      relevance: L.relevance
    }, L.secondBest && (I.secondBest = {
      language: L.secondBest.language,
      relevance: L.secondBest.relevance
    }), Z("after:highlightElement", { el: I, result: L, text: B });
  }
  function R(I) {
    f = oq(f, I);
  }
  const M = () => {
    o(), Ua("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
  };
  function P() {
    o(), Ua("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
  }
  let a = !1;
  function o() {
    if (document.readyState === "loading") {
      a = !0;
      return;
    }
    document.querySelectorAll(f.cssSelector).forEach(E);
  }
  function s() {
    a && o();
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", s, !1);
  function p(I, F) {
    let U = null;
    try {
      U = F(e);
    } catch (B) {
      if (Ca("Language definition for '{}' could not be registered.".replace("{}", I)), l)
        Ca(B);
      else
        throw B;
      U = c;
    }
    U.name || (U.name = I), t[I] = U, U.rawDefinition = F.bind(null, e), U.aliases && T(U.aliases, { languageName: I });
  }
  function O(I) {
    delete t[I];
    for (const F of Object.keys(n))
      n[F] === I && delete n[F];
  }
  function x() {
    return Object.keys(t);
  }
  function N(I) {
    return I = (I || "").toLowerCase(), t[I] || t[n[I]];
  }
  function T(I, { languageName: F }) {
    typeof I == "string" && (I = [I]), I.forEach((U) => {
      n[U.toLowerCase()] = F;
    });
  }
  function $(I) {
    const F = N(I);
    return F && !F.disableAutodetect;
  }
  function j(I) {
    I["before:highlightBlock"] && !I["before:highlightElement"] && (I["before:highlightElement"] = (F) => {
      I["before:highlightBlock"](
        Object.assign({ block: F.el }, F)
      );
    }), I["after:highlightBlock"] && !I["after:highlightElement"] && (I["after:highlightElement"] = (F) => {
      I["after:highlightBlock"](
        Object.assign({ block: F.el }, F)
      );
    });
  }
  function A(I) {
    j(I), r.push(I);
  }
  function Z(I, F) {
    const U = I;
    r.forEach(function(B) {
      B[U] && B[U](F);
    });
  }
  function G(I) {
    return Ua("10.7.0", "highlightBlock will be removed entirely in v12.0"), Ua("10.7.0", "Please use highlightElement now."), E(I);
  }
  Object.assign(e, {
    highlight: g,
    highlightAuto: w,
    highlightAll: o,
    highlightElement: E,
    // TODO: Remove with v12 API
    highlightBlock: G,
    configure: R,
    initHighlighting: M,
    initHighlightingOnLoad: P,
    registerLanguage: p,
    unregisterLanguage: O,
    listLanguages: x,
    getLanguage: N,
    registerAliases: T,
    autoDetection: $,
    inherit: oq,
    addPlugin: A
  }), e.debugMode = function() {
    l = !1;
  }, e.safeMode = function() {
    l = !0;
  }, e.versionString = Pje, e.regex = {
    concat: Ba,
    lookahead: k2e,
    either: my,
    optional: q$e,
    anyNumberOfTimes: V$e
  };
  for (const I in eo)
    typeof eo[I] == "object" && I$e(eo[I]);
  return Object.assign(e, eo), e;
};
var Pi = Rje({}), _je = Pi;
Pi.HighlightJS = Pi;
Pi.default = Pi;
const hi = /* @__PURE__ */ ce(_je);
var yy = { exports: {} };
function T2e(e) {
  return {
    aliases: ["gql"],
    keywords: {
      keyword: "query mutation subscription|10 input schema implements type interface union scalar fragment|10 enum on ...",
      literal: "ID ID! String Float Int Boolean",
      variable: "true false null"
    },
    contains: [
      e.HASH_COMMENT_MODE,
      e.QUOTE_STRING_MODE,
      e.NUMBER_MODE,
      {
        className: "literal",
        begin: "[^\\w][A-Z][a-z]",
        end: "\\W",
        excludeEnd: !0
      },
      {
        className: "literal",
        begin: ":\\s\\[",
        end: "[\\]!]{1,3}",
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "type",
        begin: "[^\\w](?!ID)[A-Z][A-Z]",
        end: "\\W",
        excludeEnd: !0
      },
      {
        className: "name",
        begin: "\\$",
        end: "\\W",
        excludeEnd: !0
      },
      {
        className: "meta",
        begin: "@",
        end: "\\W",
        excludeEnd: !0
      }
    ],
    illegal: /([;<']|BEGIN)/
  };
}
yy.exports = function(e) {
  e.registerLanguage("graphql", T2e);
};
yy.exports.definer = T2e;
var Aje = yy.exports;
const Lje = /* @__PURE__ */ ce(Aje);
function Zje(e) {
  const t = e.regex, n = {}, r = {
    begin: /\$\{/,
    end: /\}/,
    contains: [
      "self",
      {
        begin: /:-/,
        contains: [n]
      }
      // default values
    ]
  };
  Object.assign(n, {
    className: "variable",
    variants: [
      { begin: t.concat(
        /\$[\w\d#@][\w\d_]*/,
        // negative look-ahead tries to avoid matching patterns that are not
        // Perl at all like $ident$, @ident@, etc.
        "(?![\\w\\d])(?![$])"
      ) },
      r
    ]
  });
  const l = {
    className: "subst",
    begin: /\$\(/,
    end: /\)/,
    contains: [e.BACKSLASH_ESCAPE]
  }, i = {
    begin: /<<-?\s*(?=\w+)/,
    starts: { contains: [
      e.END_SAME_AS_BEGIN({
        begin: /(\w+)/,
        end: /(\w+)/,
        className: "string"
      })
    ] }
  }, c = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      e.BACKSLASH_ESCAPE,
      n,
      l
    ]
  };
  l.contains.push(c);
  const f = {
    className: "",
    begin: /\\"/
  }, d = {
    className: "string",
    begin: /'/,
    end: /'/
  }, h = {
    begin: /\$\(\(/,
    end: /\)\)/,
    contains: [
      {
        begin: /\d+#[0-9a-f]+/,
        className: "number"
      },
      e.NUMBER_MODE,
      n
    ]
  }, g = [
    "fish",
    "bash",
    "zsh",
    "sh",
    "csh",
    "ksh",
    "tcsh",
    "dash",
    "scsh"
  ], m = e.SHEBANG({
    binary: `(${g.join("|")})`,
    relevance: 10
  }), y = {
    className: "function",
    begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
    returnBegin: !0,
    contains: [e.inherit(e.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
    relevance: 0
  }, w = [
    "if",
    "then",
    "else",
    "elif",
    "fi",
    "for",
    "while",
    "in",
    "do",
    "done",
    "case",
    "esac",
    "function"
  ], C = [
    "true",
    "false"
  ], E = { match: /(\/[a-z._-]+)+/ }, R = [
    "break",
    "cd",
    "continue",
    "eval",
    "exec",
    "exit",
    "export",
    "getopts",
    "hash",
    "pwd",
    "readonly",
    "return",
    "shift",
    "test",
    "times",
    "trap",
    "umask",
    "unset"
  ], M = [
    "alias",
    "bind",
    "builtin",
    "caller",
    "command",
    "declare",
    "echo",
    "enable",
    "help",
    "let",
    "local",
    "logout",
    "mapfile",
    "printf",
    "read",
    "readarray",
    "source",
    "type",
    "typeset",
    "ulimit",
    "unalias"
  ], P = [
    "autoload",
    "bg",
    "bindkey",
    "bye",
    "cap",
    "chdir",
    "clone",
    "comparguments",
    "compcall",
    "compctl",
    "compdescribe",
    "compfiles",
    "compgroups",
    "compquote",
    "comptags",
    "comptry",
    "compvalues",
    "dirs",
    "disable",
    "disown",
    "echotc",
    "echoti",
    "emulate",
    "fc",
    "fg",
    "float",
    "functions",
    "getcap",
    "getln",
    "history",
    "integer",
    "jobs",
    "kill",
    "limit",
    "log",
    "noglob",
    "popd",
    "print",
    "pushd",
    "pushln",
    "rehash",
    "sched",
    "setcap",
    "setopt",
    "stat",
    "suspend",
    "ttyctl",
    "unfunction",
    "unhash",
    "unlimit",
    "unsetopt",
    "vared",
    "wait",
    "whence",
    "where",
    "which",
    "zcompile",
    "zformat",
    "zftp",
    "zle",
    "zmodload",
    "zparseopts",
    "zprof",
    "zpty",
    "zregexparse",
    "zsocket",
    "zstyle",
    "ztcp"
  ], a = [
    "chcon",
    "chgrp",
    "chown",
    "chmod",
    "cp",
    "dd",
    "df",
    "dir",
    "dircolors",
    "ln",
    "ls",
    "mkdir",
    "mkfifo",
    "mknod",
    "mktemp",
    "mv",
    "realpath",
    "rm",
    "rmdir",
    "shred",
    "sync",
    "touch",
    "truncate",
    "vdir",
    "b2sum",
    "base32",
    "base64",
    "cat",
    "cksum",
    "comm",
    "csplit",
    "cut",
    "expand",
    "fmt",
    "fold",
    "head",
    "join",
    "md5sum",
    "nl",
    "numfmt",
    "od",
    "paste",
    "ptx",
    "pr",
    "sha1sum",
    "sha224sum",
    "sha256sum",
    "sha384sum",
    "sha512sum",
    "shuf",
    "sort",
    "split",
    "sum",
    "tac",
    "tail",
    "tr",
    "tsort",
    "unexpand",
    "uniq",
    "wc",
    "arch",
    "basename",
    "chroot",
    "date",
    "dirname",
    "du",
    "echo",
    "env",
    "expr",
    "factor",
    // "false", // keyword literal already
    "groups",
    "hostid",
    "id",
    "link",
    "logname",
    "nice",
    "nohup",
    "nproc",
    "pathchk",
    "pinky",
    "printenv",
    "printf",
    "pwd",
    "readlink",
    "runcon",
    "seq",
    "sleep",
    "stat",
    "stdbuf",
    "stty",
    "tee",
    "test",
    "timeout",
    // "true", // keyword literal already
    "tty",
    "uname",
    "unlink",
    "uptime",
    "users",
    "who",
    "whoami",
    "yes"
  ];
  return {
    name: "Bash",
    aliases: ["sh"],
    keywords: {
      $pattern: /\b[a-z][a-z0-9._-]+\b/,
      keyword: w,
      literal: C,
      built_in: [
        ...R,
        ...M,
        // Shell modifiers
        "set",
        "shopt",
        ...P,
        ...a
      ]
    },
    contains: [
      m,
      // to catch known shells and boost relevancy
      e.SHEBANG(),
      // to catch unknown shells but still highlight the shebang
      y,
      h,
      e.HASH_COMMENT_MODE,
      i,
      E,
      c,
      f,
      d,
      n
    ]
  };
}
function Tje(e) {
  const t = e.regex, n = e.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", l = "[a-zA-Z_]\\w*::", i = "<[^<>]+>", c = "(" + r + "|" + t.optional(l) + "[a-zA-Z_]\\w*" + t.optional(i) + ")", f = {
    className: "type",
    variants: [
      { begin: "\\b[a-z\\d_]*_t\\b" },
      { match: /\batomic_[a-z]{3,6}\b/ }
    ]
  }, d = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)", h = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [e.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + d + "|.)",
        end: "'",
        illegal: "."
      },
      e.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, g = {
    className: "number",
    variants: [
      { begin: "\\b(0b[01']+)" },
      { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)" },
      { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
    ],
    relevance: 0
  }, m = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      e.inherit(h, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      n,
      e.C_BLOCK_COMMENT_MODE
    ]
  }, y = {
    className: "title",
    begin: t.optional(l) + e.IDENT_RE,
    relevance: 0
  }, w = t.optional(l) + e.IDENT_RE + "\\s*\\(", R = {
    keyword: [
      "asm",
      "auto",
      "break",
      "case",
      "continue",
      "default",
      "do",
      "else",
      "enum",
      "extern",
      "for",
      "fortran",
      "goto",
      "if",
      "inline",
      "register",
      "restrict",
      "return",
      "sizeof",
      "struct",
      "switch",
      "typedef",
      "union",
      "volatile",
      "while",
      "_Alignas",
      "_Alignof",
      "_Atomic",
      "_Generic",
      "_Noreturn",
      "_Static_assert",
      "_Thread_local",
      // aliases
      "alignas",
      "alignof",
      "noreturn",
      "static_assert",
      "thread_local",
      // not a C keyword but is, for all intents and purposes, treated exactly like one.
      "_Pragma"
    ],
    type: [
      "float",
      "double",
      "signed",
      "unsigned",
      "int",
      "short",
      "long",
      "char",
      "void",
      "_Bool",
      "_Complex",
      "_Imaginary",
      "_Decimal32",
      "_Decimal64",
      "_Decimal128",
      // modifiers
      "const",
      "static",
      // aliases
      "complex",
      "bool",
      "imaginary"
    ],
    literal: "true false NULL",
    // TODO: apply hinting work similar to what was done in cpp.js
    built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
  }, M = [
    m,
    f,
    n,
    e.C_BLOCK_COMMENT_MODE,
    g,
    h
  ], P = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: R,
    contains: M.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: R,
        contains: M.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, a = {
    begin: "(" + c + "[\\*&\\s]+)+" + w,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: R,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: r,
        keywords: R,
        relevance: 0
      },
      {
        begin: w,
        returnBegin: !0,
        contains: [e.inherit(y, { className: "title.function" })],
        relevance: 0
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: R,
        relevance: 0,
        contains: [
          n,
          e.C_BLOCK_COMMENT_MODE,
          h,
          g,
          f,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: R,
            relevance: 0,
            contains: [
              "self",
              n,
              e.C_BLOCK_COMMENT_MODE,
              h,
              g,
              f
            ]
          }
        ]
      },
      f,
      n,
      e.C_BLOCK_COMMENT_MODE,
      m
    ]
  };
  return {
    name: "C",
    aliases: ["h"],
    keywords: R,
    // Until differentiations are added between `c` and `cpp`, `c` will
    // not be auto-detected to avoid auto-detect conflicts between C and C++
    disableAutodetect: !0,
    illegal: "</",
    contains: [].concat(
      P,
      a,
      M,
      [
        m,
        {
          begin: e.IDENT_RE + "::",
          keywords: R
        },
        {
          className: "class",
          beginKeywords: "enum class struct union",
          end: /[{;:<>=]/,
          contains: [
            { beginKeywords: "final class struct" },
            e.TITLE_MODE
          ]
        }
      ]
    ),
    exports: {
      preprocessor: m,
      strings: h,
      keywords: R
    }
  };
}
function Bje(e) {
  const t = e.regex, n = e.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", l = "[a-zA-Z_]\\w*::", i = "<[^<>]+>", c = "(?!struct)(" + r + "|" + t.optional(l) + "[a-zA-Z_]\\w*" + t.optional(i) + ")", f = {
    className: "type",
    begin: "\\b[a-z\\d_]*_t\\b"
  }, d = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)", h = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [e.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + d + "|.)",
        end: "'",
        illegal: "."
      },
      e.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, g = {
    className: "number",
    variants: [
      { begin: "\\b(0b[01']+)" },
      { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)" },
      { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
    ],
    relevance: 0
  }, m = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      e.inherit(h, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      n,
      e.C_BLOCK_COMMENT_MODE
    ]
  }, y = {
    className: "title",
    begin: t.optional(l) + e.IDENT_RE,
    relevance: 0
  }, w = t.optional(l) + e.IDENT_RE + "\\s*\\(", C = [
    "alignas",
    "alignof",
    "and",
    "and_eq",
    "asm",
    "atomic_cancel",
    "atomic_commit",
    "atomic_noexcept",
    "auto",
    "bitand",
    "bitor",
    "break",
    "case",
    "catch",
    "class",
    "co_await",
    "co_return",
    "co_yield",
    "compl",
    "concept",
    "const_cast|10",
    "consteval",
    "constexpr",
    "constinit",
    "continue",
    "decltype",
    "default",
    "delete",
    "do",
    "dynamic_cast|10",
    "else",
    "enum",
    "explicit",
    "export",
    "extern",
    "false",
    "final",
    "for",
    "friend",
    "goto",
    "if",
    "import",
    "inline",
    "module",
    "mutable",
    "namespace",
    "new",
    "noexcept",
    "not",
    "not_eq",
    "nullptr",
    "operator",
    "or",
    "or_eq",
    "override",
    "private",
    "protected",
    "public",
    "reflexpr",
    "register",
    "reinterpret_cast|10",
    "requires",
    "return",
    "sizeof",
    "static_assert",
    "static_cast|10",
    "struct",
    "switch",
    "synchronized",
    "template",
    "this",
    "thread_local",
    "throw",
    "transaction_safe",
    "transaction_safe_dynamic",
    "true",
    "try",
    "typedef",
    "typeid",
    "typename",
    "union",
    "using",
    "virtual",
    "volatile",
    "while",
    "xor",
    "xor_eq"
  ], E = [
    "bool",
    "char",
    "char16_t",
    "char32_t",
    "char8_t",
    "double",
    "float",
    "int",
    "long",
    "short",
    "void",
    "wchar_t",
    "unsigned",
    "signed",
    "const",
    "static"
  ], R = [
    "any",
    "auto_ptr",
    "barrier",
    "binary_semaphore",
    "bitset",
    "complex",
    "condition_variable",
    "condition_variable_any",
    "counting_semaphore",
    "deque",
    "false_type",
    "future",
    "imaginary",
    "initializer_list",
    "istringstream",
    "jthread",
    "latch",
    "lock_guard",
    "multimap",
    "multiset",
    "mutex",
    "optional",
    "ostringstream",
    "packaged_task",
    "pair",
    "promise",
    "priority_queue",
    "queue",
    "recursive_mutex",
    "recursive_timed_mutex",
    "scoped_lock",
    "set",
    "shared_future",
    "shared_lock",
    "shared_mutex",
    "shared_timed_mutex",
    "shared_ptr",
    "stack",
    "string_view",
    "stringstream",
    "timed_mutex",
    "thread",
    "true_type",
    "tuple",
    "unique_lock",
    "unique_ptr",
    "unordered_map",
    "unordered_multimap",
    "unordered_multiset",
    "unordered_set",
    "variant",
    "vector",
    "weak_ptr",
    "wstring",
    "wstring_view"
  ], M = [
    "abort",
    "abs",
    "acos",
    "apply",
    "as_const",
    "asin",
    "atan",
    "atan2",
    "calloc",
    "ceil",
    "cerr",
    "cin",
    "clog",
    "cos",
    "cosh",
    "cout",
    "declval",
    "endl",
    "exchange",
    "exit",
    "exp",
    "fabs",
    "floor",
    "fmod",
    "forward",
    "fprintf",
    "fputs",
    "free",
    "frexp",
    "fscanf",
    "future",
    "invoke",
    "isalnum",
    "isalpha",
    "iscntrl",
    "isdigit",
    "isgraph",
    "islower",
    "isprint",
    "ispunct",
    "isspace",
    "isupper",
    "isxdigit",
    "labs",
    "launder",
    "ldexp",
    "log",
    "log10",
    "make_pair",
    "make_shared",
    "make_shared_for_overwrite",
    "make_tuple",
    "make_unique",
    "malloc",
    "memchr",
    "memcmp",
    "memcpy",
    "memset",
    "modf",
    "move",
    "pow",
    "printf",
    "putchar",
    "puts",
    "realloc",
    "scanf",
    "sin",
    "sinh",
    "snprintf",
    "sprintf",
    "sqrt",
    "sscanf",
    "std",
    "stderr",
    "stdin",
    "stdout",
    "strcat",
    "strchr",
    "strcmp",
    "strcpy",
    "strcspn",
    "strlen",
    "strncat",
    "strncmp",
    "strncpy",
    "strpbrk",
    "strrchr",
    "strspn",
    "strstr",
    "swap",
    "tan",
    "tanh",
    "terminate",
    "to_underlying",
    "tolower",
    "toupper",
    "vfprintf",
    "visit",
    "vprintf",
    "vsprintf"
  ], o = {
    type: E,
    keyword: C,
    literal: [
      "NULL",
      "false",
      "nullopt",
      "nullptr",
      "true"
    ],
    built_in: ["_Pragma"],
    _type_hints: R
  }, s = {
    className: "function.dispatch",
    relevance: 0,
    keywords: {
      // Only for relevance, not highlighting.
      _hint: M
    },
    begin: t.concat(
      /\b/,
      /(?!decltype)/,
      /(?!if)/,
      /(?!for)/,
      /(?!switch)/,
      /(?!while)/,
      e.IDENT_RE,
      t.lookahead(/(<[^<>]+>|)\s*\(/)
    )
  }, p = [
    s,
    m,
    f,
    n,
    e.C_BLOCK_COMMENT_MODE,
    g,
    h
  ], O = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: o,
    contains: p.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: o,
        contains: p.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, x = {
    className: "function",
    begin: "(" + c + "[\\*&\\s]+)+" + w,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: o,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: r,
        keywords: o,
        relevance: 0
      },
      {
        begin: w,
        returnBegin: !0,
        contains: [y],
        relevance: 0
      },
      // needed because we do not have look-behind on the below rule
      // to prevent it from grabbing the final : in a :: pair
      {
        begin: /::/,
        relevance: 0
      },
      // initializers
      {
        begin: /:/,
        endsWithParent: !0,
        contains: [
          h,
          g
        ]
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: o,
        relevance: 0,
        contains: [
          n,
          e.C_BLOCK_COMMENT_MODE,
          h,
          g,
          f,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: o,
            relevance: 0,
            contains: [
              "self",
              n,
              e.C_BLOCK_COMMENT_MODE,
              h,
              g,
              f
            ]
          }
        ]
      },
      f,
      n,
      e.C_BLOCK_COMMENT_MODE,
      m
    ]
  };
  return {
    name: "C++",
    aliases: [
      "cc",
      "c++",
      "h++",
      "hpp",
      "hh",
      "hxx",
      "cxx"
    ],
    keywords: o,
    illegal: "</",
    classNameAliases: { "function.dispatch": "built_in" },
    contains: [].concat(
      O,
      x,
      s,
      p,
      [
        m,
        {
          // containers: ie, `vector <int> rooms (9);`
          begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function)\\s*<(?!<)",
          end: ">",
          keywords: o,
          contains: [
            "self",
            f
          ]
        },
        {
          begin: e.IDENT_RE + "::",
          keywords: o
        },
        {
          match: [
            // extra complexity to deal with `enum class` and `enum struct`
            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
            /\s+/,
            /\w+/
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    )
  };
}
function Ije(e) {
  const t = [
    "bool",
    "byte",
    "char",
    "decimal",
    "delegate",
    "double",
    "dynamic",
    "enum",
    "float",
    "int",
    "long",
    "nint",
    "nuint",
    "object",
    "sbyte",
    "short",
    "string",
    "ulong",
    "uint",
    "ushort"
  ], n = [
    "public",
    "private",
    "protected",
    "static",
    "internal",
    "protected",
    "abstract",
    "async",
    "extern",
    "override",
    "unsafe",
    "virtual",
    "new",
    "sealed",
    "partial"
  ], r = [
    "default",
    "false",
    "null",
    "true"
  ], l = [
    "abstract",
    "as",
    "base",
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "do",
    "else",
    "event",
    "explicit",
    "extern",
    "finally",
    "fixed",
    "for",
    "foreach",
    "goto",
    "if",
    "implicit",
    "in",
    "interface",
    "internal",
    "is",
    "lock",
    "namespace",
    "new",
    "operator",
    "out",
    "override",
    "params",
    "private",
    "protected",
    "public",
    "readonly",
    "record",
    "ref",
    "return",
    "sealed",
    "sizeof",
    "stackalloc",
    "static",
    "struct",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "unchecked",
    "unsafe",
    "using",
    "virtual",
    "void",
    "volatile",
    "while"
  ], i = [
    "add",
    "alias",
    "and",
    "ascending",
    "async",
    "await",
    "by",
    "descending",
    "equals",
    "from",
    "get",
    "global",
    "group",
    "init",
    "into",
    "join",
    "let",
    "nameof",
    "not",
    "notnull",
    "on",
    "or",
    "orderby",
    "partial",
    "remove",
    "select",
    "set",
    "unmanaged",
    "value|0",
    "var",
    "when",
    "where",
    "with",
    "yield"
  ], c = {
    keyword: l.concat(i),
    built_in: t,
    literal: r
  }, f = e.inherit(e.TITLE_MODE, { begin: "[a-zA-Z](\\.?\\w)*" }), d = {
    className: "number",
    variants: [
      { begin: "\\b(0b[01']+)" },
      { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)" },
      { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
    ],
    relevance: 0
  }, h = {
    className: "string",
    begin: '@"',
    end: '"',
    contains: [{ begin: '""' }]
  }, g = e.inherit(h, { illegal: /\n/ }), m = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: c
  }, y = e.inherit(m, { illegal: /\n/ }), w = {
    className: "string",
    begin: /\$"/,
    end: '"',
    illegal: /\n/,
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      e.BACKSLASH_ESCAPE,
      y
    ]
  }, C = {
    className: "string",
    begin: /\$@"/,
    end: '"',
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      { begin: '""' },
      m
    ]
  }, E = e.inherit(C, {
    illegal: /\n/,
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      { begin: '""' },
      y
    ]
  });
  m.contains = [
    C,
    w,
    h,
    e.APOS_STRING_MODE,
    e.QUOTE_STRING_MODE,
    d,
    e.C_BLOCK_COMMENT_MODE
  ], y.contains = [
    E,
    w,
    g,
    e.APOS_STRING_MODE,
    e.QUOTE_STRING_MODE,
    d,
    e.inherit(e.C_BLOCK_COMMENT_MODE, { illegal: /\n/ })
  ];
  const R = { variants: [
    C,
    w,
    h,
    e.APOS_STRING_MODE,
    e.QUOTE_STRING_MODE
  ] }, M = {
    begin: "<",
    end: ">",
    contains: [
      { beginKeywords: "in out" },
      f
    ]
  }, P = e.IDENT_RE + "(<" + e.IDENT_RE + "(\\s*,\\s*" + e.IDENT_RE + ")*>)?(\\[\\])?", a = {
    // prevents expressions like `@class` from incorrect flagging
    // `class` as a keyword
    begin: "@" + e.IDENT_RE,
    relevance: 0
  };
  return {
    name: "C#",
    aliases: [
      "cs",
      "c#"
    ],
    keywords: c,
    illegal: /::/,
    contains: [
      e.COMMENT(
        "///",
        "$",
        {
          returnBegin: !0,
          contains: [
            {
              className: "doctag",
              variants: [
                {
                  begin: "///",
                  relevance: 0
                },
                { begin: "<!--|-->" },
                {
                  begin: "</?",
                  end: ">"
                }
              ]
            }
          ]
        }
      ),
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: { keyword: "if else elif endif define undef warning error line region endregion pragma checksum" }
      },
      R,
      d,
      {
        beginKeywords: "class interface",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:,]/,
        contains: [
          { beginKeywords: "where class" },
          f,
          M,
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: "namespace",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          f,
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: "record",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          f,
          M,
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // [Attributes("")]
        className: "meta",
        begin: "^\\s*\\[(?=[\\w])",
        excludeBegin: !0,
        end: "\\]",
        excludeEnd: !0,
        contains: [
          {
            className: "string",
            begin: /"/,
            end: /"/
          }
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: "new return throw await else",
        relevance: 0
      },
      {
        className: "function",
        begin: "(" + P + "\\s+)+" + e.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
        returnBegin: !0,
        end: /\s*[{;=]/,
        excludeEnd: !0,
        keywords: c,
        contains: [
          // prevents these from being highlighted `title`
          {
            beginKeywords: n.join(" "),
            relevance: 0
          },
          {
            begin: e.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
            returnBegin: !0,
            contains: [
              e.TITLE_MODE,
              M
            ],
            relevance: 0
          },
          { match: /\(\)/ },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: c,
            relevance: 0,
            contains: [
              R,
              d,
              e.C_BLOCK_COMMENT_MODE
            ]
          },
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      a
    ]
  };
}
function Hje(e) {
  const t = {
    className: "subst",
    variants: [{ begin: "\\$[A-Za-z0-9_]+" }]
  }, n = {
    className: "subst",
    variants: [
      {
        begin: /\$\{/,
        end: /\}/
      }
    ],
    keywords: "true false null this is new super"
  }, r = {
    className: "string",
    variants: [
      {
        begin: "r'''",
        end: "'''"
      },
      {
        begin: 'r"""',
        end: '"""'
      },
      {
        begin: "r'",
        end: "'",
        illegal: "\\n"
      },
      {
        begin: 'r"',
        end: '"',
        illegal: "\\n"
      },
      {
        begin: "'''",
        end: "'''",
        contains: [
          e.BACKSLASH_ESCAPE,
          t,
          n
        ]
      },
      {
        begin: '"""',
        end: '"""',
        contains: [
          e.BACKSLASH_ESCAPE,
          t,
          n
        ]
      },
      {
        begin: "'",
        end: "'",
        illegal: "\\n",
        contains: [
          e.BACKSLASH_ESCAPE,
          t,
          n
        ]
      },
      {
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [
          e.BACKSLASH_ESCAPE,
          t,
          n
        ]
      }
    ]
  };
  n.contains = [
    e.C_NUMBER_MODE,
    r
  ];
  const l = [
    // dart:core
    "Comparable",
    "DateTime",
    "Duration",
    "Function",
    "Iterable",
    "Iterator",
    "List",
    "Map",
    "Match",
    "Object",
    "Pattern",
    "RegExp",
    "Set",
    "Stopwatch",
    "String",
    "StringBuffer",
    "StringSink",
    "Symbol",
    "Type",
    "Uri",
    "bool",
    "double",
    "int",
    "num",
    // dart:html
    "Element",
    "ElementList"
  ], i = l.map((d) => `${d}?`);
  return {
    name: "Dart",
    keywords: {
      keyword: [
        "abstract",
        "as",
        "assert",
        "async",
        "await",
        "break",
        "case",
        "catch",
        "class",
        "const",
        "continue",
        "covariant",
        "default",
        "deferred",
        "do",
        "dynamic",
        "else",
        "enum",
        "export",
        "extends",
        "extension",
        "external",
        "factory",
        "false",
        "final",
        "finally",
        "for",
        "Function",
        "get",
        "hide",
        "if",
        "implements",
        "import",
        "in",
        "inferface",
        "is",
        "late",
        "library",
        "mixin",
        "new",
        "null",
        "on",
        "operator",
        "part",
        "required",
        "rethrow",
        "return",
        "set",
        "show",
        "static",
        "super",
        "switch",
        "sync",
        "this",
        "throw",
        "true",
        "try",
        "typedef",
        "var",
        "void",
        "while",
        "with",
        "yield"
      ],
      built_in: l.concat(i).concat([
        // dart:core
        "Never",
        "Null",
        "dynamic",
        "print",
        // dart:html
        "document",
        "querySelector",
        "querySelectorAll",
        "window"
      ]),
      $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
    },
    contains: [
      r,
      e.COMMENT(
        /\/\*\*(?!\/)/,
        /\*\//,
        {
          subLanguage: "markdown",
          relevance: 0
        }
      ),
      e.COMMENT(
        /\/{3,} ?/,
        /$/,
        { contains: [
          {
            subLanguage: "markdown",
            begin: ".",
            end: "$",
            relevance: 0
          }
        ] }
      ),
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        className: "class",
        beginKeywords: "class interface",
        end: /\{/,
        excludeEnd: !0,
        contains: [
          { beginKeywords: "extends implements" },
          e.UNDERSCORE_TITLE_MODE
        ]
      },
      e.C_NUMBER_MODE,
      {
        className: "meta",
        begin: "@[A-Za-z]+"
      },
      {
        begin: "=>"
        // No markup, just a relevance booster
      }
    ]
  };
}
function Dje(e) {
  const t = e.regex;
  return {
    name: "Diff",
    aliases: ["patch"],
    contains: [
      {
        className: "meta",
        relevance: 10,
        match: t.either(
          /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/,
          /^\*\*\* +\d+,\d+ +\*\*\*\*$/,
          /^--- +\d+,\d+ +----$/
        )
      },
      {
        className: "comment",
        variants: [
          {
            begin: t.either(
              /Index: /,
              /^index/,
              /={3,}/,
              /^-{3}/,
              /^\*{3} /,
              /^\+{3}/,
              /^diff --git/
            ),
            end: /$/
          },
          { match: /^\*{15}$/ }
        ]
      },
      {
        className: "addition",
        begin: /^\+/,
        end: /$/
      },
      {
        className: "deletion",
        begin: /^-/,
        end: /$/
      },
      {
        className: "addition",
        begin: /^!/,
        end: /$/
      }
    ]
  };
}
function zje(e) {
  const i = {
    keyword: [
      "break",
      "case",
      "chan",
      "const",
      "continue",
      "default",
      "defer",
      "else",
      "fallthrough",
      "for",
      "func",
      "go",
      "goto",
      "if",
      "import",
      "interface",
      "map",
      "package",
      "range",
      "return",
      "select",
      "struct",
      "switch",
      "type",
      "var"
    ],
    type: [
      "bool",
      "byte",
      "complex64",
      "complex128",
      "error",
      "float32",
      "float64",
      "int8",
      "int16",
      "int32",
      "int64",
      "string",
      "uint8",
      "uint16",
      "uint32",
      "uint64",
      "int",
      "uint",
      "uintptr",
      "rune"
    ],
    literal: [
      "true",
      "false",
      "iota",
      "nil"
    ],
    built_in: [
      "append",
      "cap",
      "close",
      "complex",
      "copy",
      "imag",
      "len",
      "make",
      "new",
      "panic",
      "print",
      "println",
      "real",
      "recover",
      "delete"
    ]
  };
  return {
    name: "Go",
    aliases: ["golang"],
    keywords: i,
    illegal: "</",
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        className: "string",
        variants: [
          e.QUOTE_STRING_MODE,
          e.APOS_STRING_MODE,
          {
            begin: "`",
            end: "`"
          }
        ]
      },
      {
        className: "number",
        variants: [
          {
            begin: e.C_NUMBER_RE + "[i]",
            relevance: 1
          },
          e.C_NUMBER_MODE
        ]
      },
      {
        begin: /:=/
        // relevance booster
      },
      {
        className: "function",
        beginKeywords: "func",
        end: "\\s*(\\{|$)",
        excludeEnd: !0,
        contains: [
          e.TITLE_MODE,
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            endsParent: !0,
            keywords: i,
            illegal: /["']/
          }
        ]
      }
    ]
  };
}
function Fje(e) {
  const t = e.regex, n = "HTTP/(2|1\\.[01])", r = /[A-Za-z][A-Za-z0-9-]*/, l = {
    className: "attribute",
    begin: t.concat("^", r, "(?=\\:\\s)"),
    starts: { contains: [
      {
        className: "punctuation",
        begin: /: /,
        relevance: 0,
        starts: {
          end: "$",
          relevance: 0
        }
      }
    ] }
  }, i = [
    l,
    {
      begin: "\\n\\n",
      starts: {
        subLanguage: [],
        endsWithParent: !0
      }
    }
  ];
  return {
    name: "HTTP",
    aliases: ["https"],
    illegal: /\S/,
    contains: [
      // response
      {
        begin: "^(?=" + n + " \\d{3})",
        end: /$/,
        contains: [
          {
            className: "meta",
            begin: n
          },
          {
            className: "number",
            begin: "\\b\\d{3}\\b"
          }
        ],
        starts: {
          end: /\b\B/,
          illegal: /\S/,
          contains: i
        }
      },
      // request
      {
        begin: "(?=^[A-Z]+ (.*?) " + n + "$)",
        end: /$/,
        contains: [
          {
            className: "string",
            begin: " ",
            end: " ",
            excludeBegin: !0,
            excludeEnd: !0
          },
          {
            className: "meta",
            begin: n
          },
          {
            className: "keyword",
            begin: "[A-Z]+"
          }
        ],
        starts: {
          end: /\b\B/,
          illegal: /\S/,
          contains: i
        }
      },
      // to allow headers to work even without a preamble
      e.inherit(l, { relevance: 0 })
    ]
  };
}
function Vje(e) {
  const t = e.regex, n = {
    className: "number",
    relevance: 0,
    variants: [
      { begin: /([+-]+)?[\d]+_[\d_]+/ },
      { begin: e.NUMBER_RE }
    ]
  }, r = e.COMMENT();
  r.variants = [
    {
      begin: /;/,
      end: /$/
    },
    {
      begin: /#/,
      end: /$/
    }
  ];
  const l = {
    className: "variable",
    variants: [
      { begin: /\$[\w\d"][\w\d_]*/ },
      { begin: /\$\{(.*?)\}/ }
    ]
  }, i = {
    className: "literal",
    begin: /\bon|off|true|false|yes|no\b/
  }, c = {
    className: "string",
    contains: [e.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: "'''",
        end: "'''",
        relevance: 10
      },
      {
        begin: '"""',
        end: '"""',
        relevance: 10
      },
      {
        begin: '"',
        end: '"'
      },
      {
        begin: "'",
        end: "'"
      }
    ]
  }, f = {
    begin: /\[/,
    end: /\]/,
    contains: [
      r,
      i,
      l,
      c,
      n,
      "self"
    ],
    relevance: 0
  }, d = /[A-Za-z0-9_-]+/, h = /"(\\"|[^"])*"/, g = /'[^']*'/, m = t.either(
    d,
    h,
    g
  ), y = t.concat(
    m,
    "(\\s*\\.\\s*",
    m,
    ")*",
    t.lookahead(/\s*=\s*[^#\s]/)
  );
  return {
    name: "TOML, also INI",
    aliases: ["toml"],
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      r,
      {
        className: "section",
        begin: /\[+/,
        end: /\]+/
      },
      {
        begin: y,
        className: "attr",
        starts: {
          end: /$/,
          contains: [
            r,
            f,
            i,
            l,
            c,
            n
          ]
        }
      }
    ]
  };
}
var Qa = "[0-9](_*[0-9])*", to = `\\.(${Qa})`, no = "[0-9a-fA-F](_*[0-9a-fA-F])*", cq = {
  className: "number",
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${Qa})((${to})|\\.)?|(${to}))[eE][+-]?(${Qa})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${Qa})((${to})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${to})[fFdD]?\\b` },
    { begin: `\\b(${Qa})[fFdD]\\b` },
    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${no})\\.?|(${no})?\\.(${no}))[pP][+-]?(${Qa})[fFdD]?\\b` },
    // DecimalIntegerLiteral
    { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
    // HexIntegerLiteral
    { begin: `\\b0[xX](${no})[lL]?\\b` },
    // OctalIntegerLiteral
    { begin: "\\b0(_*[0-7])*[lL]?\\b" },
    // BinaryIntegerLiteral
    { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
  ],
  relevance: 0
};
function B2e(e, t, n) {
  return n === -1 ? "" : e.replace(t, (r) => B2e(e, t, n - 1));
}
function qje(e) {
  const t = e.regex, n = "[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*", r = n + B2e("(?:<" + n + "~~~(?:\\s*,\\s*" + n + "~~~)*>)?", /~~~/g, 2), d = {
    keyword: [
      "synchronized",
      "abstract",
      "private",
      "var",
      "static",
      "if",
      "const ",
      "for",
      "while",
      "strictfp",
      "finally",
      "protected",
      "import",
      "native",
      "final",
      "void",
      "enum",
      "else",
      "break",
      "transient",
      "catch",
      "instanceof",
      "volatile",
      "case",
      "assert",
      "package",
      "default",
      "public",
      "try",
      "switch",
      "continue",
      "throws",
      "protected",
      "public",
      "private",
      "module",
      "requires",
      "exports",
      "do",
      "sealed"
    ],
    literal: [
      "false",
      "true",
      "null"
    ],
    type: [
      "char",
      "boolean",
      "long",
      "float",
      "int",
      "byte",
      "short",
      "double"
    ],
    built_in: [
      "super",
      "this"
    ]
  }, h = {
    className: "meta",
    begin: "@" + n,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: ["self"]
        // allow nested () inside our annotation
      }
    ]
  }, g = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    keywords: d,
    relevance: 0,
    contains: [e.C_BLOCK_COMMENT_MODE],
    endsParent: !0
  };
  return {
    name: "Java",
    aliases: ["jsp"],
    keywords: d,
    illegal: /<\/|#/,
    contains: [
      e.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/,
              relevance: 0
            },
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      ),
      // relevance boost
      {
        begin: /import java\.[a-z]+\./,
        keywords: "import",
        relevance: 2
      },
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        begin: /"""/,
        end: /"""/,
        className: "string",
        contains: [e.BACKSLASH_ESCAPE]
      },
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      {
        match: [
          /\b(?:class|interface|enum|extends|implements|new)/,
          /\s+/,
          n
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        // Exceptions for hyphenated keywords
        match: /non-sealed/,
        scope: "keyword"
      },
      {
        begin: [
          t.concat(/(?!else)/, n),
          /\s+/,
          n,
          /\s+/,
          /=/
        ],
        className: {
          1: "type",
          3: "variable",
          5: "operator"
        }
      },
      {
        begin: [
          /record/,
          /\s+/,
          n
        ],
        className: {
          1: "keyword",
          3: "title.class"
        },
        contains: [
          g,
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: "new throw return else",
        relevance: 0
      },
      {
        begin: [
          "(?:" + r + "\\s+)",
          e.UNDERSCORE_IDENT_RE,
          /\s*(?=\()/
        ],
        className: { 2: "title.function" },
        keywords: d,
        contains: [
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            keywords: d,
            relevance: 0,
            contains: [
              h,
              e.APOS_STRING_MODE,
              e.QUOTE_STRING_MODE,
              cq,
              e.C_BLOCK_COMMENT_MODE
            ]
          },
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      cq,
      h
    ]
  };
}
const uq = "[A-Za-z$_][0-9A-Za-z$_]*", Uje = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends"
], Wje = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], I2e = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], H2e = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], D2e = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], Gje = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "module",
  "global"
  // Node.js
], Kje = [].concat(
  D2e,
  I2e,
  H2e
);
function Yje(e) {
  const t = e.regex, n = (F, { after: U }) => {
    const B = "</" + F[0].slice(1);
    return F.input.indexOf(B, U) !== -1;
  }, r = uq, l = {
    begin: "<>",
    end: "</>"
  }, i = /<[A-Za-z0-9\\._:-]+\s*\/>/, c = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (F, U) => {
      const B = F[0].length + F.index, L = F.input[B];
      if (
        // HTML should not include another raw `<` inside a tag
        // nested type?
        // `<Array<Array<number>>`, etc.
        L === "<" || // the , gives away that this is not HTML
        // `<T, A extends keyof T, V>`
        L === ","
      ) {
        U.ignoreMatch();
        return;
      }
      L === ">" && (n(F, { after: B }) || U.ignoreMatch());
      let q;
      if ((q = F.input.substr(B).match(/^\s+extends\s+/)) && q.index === 0) {
        U.ignoreMatch();
        return;
      }
    }
  }, f = {
    $pattern: uq,
    keyword: Uje,
    literal: Wje,
    built_in: Kje,
    "variable.language": Gje
  }, d = "[0-9](_?[0-9])*", h = `\\.(${d})`, g = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", m = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${g})((${h})|\\.)?|(${h}))[eE][+-]?(${d})\\b` },
      { begin: `\\b(${g})\\b((${h})\\b|\\.)?|(${h})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, y = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: f,
    contains: []
    // defined later
  }, w = {
    begin: "html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        e.BACKSLASH_ESCAPE,
        y
      ],
      subLanguage: "xml"
    }
  }, C = {
    begin: "css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        e.BACKSLASH_ESCAPE,
        y
      ],
      subLanguage: "css"
    }
  }, E = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      e.BACKSLASH_ESCAPE,
      y
    ]
  }, M = {
    className: "comment",
    variants: [
      e.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              begin: "(?=@[A-Za-z]+)",
              relevance: 0,
              contains: [
                {
                  className: "doctag",
                  begin: "@[A-Za-z]+"
                },
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: r + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      e.C_BLOCK_COMMENT_MODE,
      e.C_LINE_COMMENT_MODE
    ]
  }, P = [
    e.APOS_STRING_MODE,
    e.QUOTE_STRING_MODE,
    w,
    C,
    E,
    m
    // This is intentional:
    // See https://github.com/highlightjs/highlight.js/issues/3288
    // hljs.REGEXP_MODE
  ];
  y.contains = P.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: f,
    contains: [
      "self"
    ].concat(P)
  });
  const a = [].concat(M, y.contains), o = a.concat([
    // eat recursive parens in sub expressions
    {
      begin: /\(/,
      end: /\)/,
      keywords: f,
      contains: ["self"].concat(a)
    }
  ]), s = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: f,
    contains: o
  }, p = {
    variants: [
      // class Car extends vehicle
      {
        match: [
          /class/,
          /\s+/,
          r,
          /\s+/,
          /extends/,
          /\s+/,
          t.concat(r, "(", t.concat(/\./, r), ")*")
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          5: "keyword",
          7: "title.class.inherited"
        }
      },
      // class Car
      {
        match: [
          /class/,
          /\s+/,
          r
        ],
        scope: {
          1: "keyword",
          3: "title.class"
        }
      }
    ]
  }, O = {
    relevance: 0,
    match: t.either(
      // Hard coded exceptions
      /\bJSON/,
      // Float32Array, OutT
      /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
      // CSSFactory, CSSFactoryT
      /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
      // FPs, FPsT
      /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
      // P
      // single letters are not highlighted
      // BLAH
      // this will be flagged as a UPPER_CASE_CONSTANT instead
    ),
    className: "title.class",
    keywords: {
      _: [
        // se we still get relevance credit for JS library classes
        ...I2e,
        ...H2e
      ]
    }
  }, x = {
    label: "use_strict",
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use (strict|asm)['"]/
  }, N = {
    variants: [
      {
        match: [
          /function/,
          /\s+/,
          r,
          /(?=\s*\()/
        ]
      },
      // anonymous function
      {
        match: [
          /function/,
          /\s*(?=\()/
        ]
      }
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    label: "func.def",
    contains: [s],
    illegal: /%/
  }, T = {
    relevance: 0,
    match: /\b[A-Z][A-Z_0-9]+\b/,
    className: "variable.constant"
  };
  function $(F) {
    return t.concat("(?!", F.join("|"), ")");
  }
  const j = {
    match: t.concat(
      /\b/,
      $([
        ...D2e,
        "super"
      ]),
      r,
      t.lookahead(/\(/)
    ),
    className: "title.function",
    relevance: 0
  }, A = {
    begin: t.concat(/\./, t.lookahead(
      t.concat(r, /(?![0-9A-Za-z$_(])/)
    )),
    end: r,
    excludeBegin: !0,
    keywords: "prototype",
    className: "property",
    relevance: 0
  }, Z = {
    match: [
      /get|set/,
      /\s+/,
      r,
      /(?=\()/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        // eat to avoid empty params
        begin: /\(\)/
      },
      s
    ]
  }, G = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>", I = {
    match: [
      /const|var|let/,
      /\s+/,
      r,
      /\s*/,
      /=\s*/,
      /(async\s*)?/,
      // async is optional
      t.lookahead(G)
    ],
    keywords: "async",
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      s
    ]
  };
  return {
    name: "Javascript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: f,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: o, CLASS_REFERENCE: O },
    illegal: /#(?![$_A-z])/,
    contains: [
      e.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      x,
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      w,
      C,
      E,
      M,
      m,
      O,
      {
        className: "attr",
        begin: r + t.lookahead(":"),
        relevance: 0
      },
      I,
      {
        // "value" container
        begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [
          M,
          e.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: G,
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: f,
                    contains: o
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            match: /\s+/,
            relevance: 0
          },
          {
            // JSX
            variants: [
              { begin: l.begin, end: l.end },
              { match: i },
              {
                begin: c.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": c.isTrulyOpeningTag,
                end: c.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: c.begin,
                end: c.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ]
      },
      N,
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: "\\b(?!function)" + e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        label: "func.def",
        contains: [
          s,
          e.inherit(e.TITLE_MODE, { begin: r, className: "title.function" })
        ]
      },
      // catch ... so it won't trigger the property rule below
      {
        match: /\.\.\./,
        relevance: 0
      },
      A,
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        match: "\\$" + r,
        relevance: 0
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [s]
      },
      j,
      T,
      p,
      Z,
      {
        match: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
function Xje(e) {
  const t = {
    className: "attr",
    begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
    relevance: 1.01
  }, n = {
    match: /[{}[\],:]/,
    className: "punctuation",
    relevance: 0
  }, r = { beginKeywords: [
    "true",
    "false",
    "null"
  ].join(" ") };
  return {
    name: "JSON",
    contains: [
      t,
      n,
      e.QUOTE_STRING_MODE,
      r,
      e.C_NUMBER_MODE,
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE
    ],
    illegal: "\\S"
  };
}
var Ja = "[0-9](_*[0-9])*", ro = `\\.(${Ja})`, ao = "[0-9a-fA-F](_*[0-9a-fA-F])*", Qje = {
  className: "number",
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${Ja})((${ro})|\\.)?|(${ro}))[eE][+-]?(${Ja})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${Ja})((${ro})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${ro})[fFdD]?\\b` },
    { begin: `\\b(${Ja})[fFdD]\\b` },
    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${ao})\\.?|(${ao})?\\.(${ao}))[pP][+-]?(${Ja})[fFdD]?\\b` },
    // DecimalIntegerLiteral
    { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
    // HexIntegerLiteral
    { begin: `\\b0[xX](${ao})[lL]?\\b` },
    // OctalIntegerLiteral
    { begin: "\\b0(_*[0-7])*[lL]?\\b" },
    // BinaryIntegerLiteral
    { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
  ],
  relevance: 0
};
function Jje(e) {
  const t = {
    keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
    built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
    literal: "true false null"
  }, n = {
    className: "keyword",
    begin: /\b(break|continue|return|this)\b/,
    starts: { contains: [
      {
        className: "symbol",
        begin: /@\w+/
      }
    ] }
  }, r = {
    className: "symbol",
    begin: e.UNDERSCORE_IDENT_RE + "@"
  }, l = {
    className: "subst",
    begin: /\$\{/,
    end: /\}/,
    contains: [e.C_NUMBER_MODE]
  }, i = {
    className: "variable",
    begin: "\\$" + e.UNDERSCORE_IDENT_RE
  }, c = {
    className: "string",
    variants: [
      {
        begin: '"""',
        end: '"""(?=[^"])',
        contains: [
          i,
          l
        ]
      },
      // Can't use built-in modes easily, as we want to use STRING in the meta
      // context as 'meta-string' and there's no syntax to remove explicitly set
      // classNames in built-in modes.
      {
        begin: "'",
        end: "'",
        illegal: /\n/,
        contains: [e.BACKSLASH_ESCAPE]
      },
      {
        begin: '"',
        end: '"',
        illegal: /\n/,
        contains: [
          e.BACKSLASH_ESCAPE,
          i,
          l
        ]
      }
    ]
  };
  l.contains.push(c);
  const f = {
    className: "meta",
    begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + e.UNDERSCORE_IDENT_RE + ")?"
  }, d = {
    className: "meta",
    begin: "@" + e.UNDERSCORE_IDENT_RE,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: [e.inherit(c, { className: "string" })]
      }
    ]
  }, h = Qje, g = e.COMMENT(
    "/\\*",
    "\\*/",
    { contains: [e.C_BLOCK_COMMENT_MODE] }
  ), m = { variants: [
    {
      className: "type",
      begin: e.UNDERSCORE_IDENT_RE
    },
    {
      begin: /\(/,
      end: /\)/,
      contains: []
      // defined later
    }
  ] }, y = m;
  return y.variants[1].contains = [m], m.variants[1].contains = [y], {
    name: "Kotlin",
    aliases: [
      "kt",
      "kts"
    ],
    keywords: t,
    contains: [
      e.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      ),
      e.C_LINE_COMMENT_MODE,
      g,
      n,
      r,
      f,
      d,
      {
        className: "function",
        beginKeywords: "fun",
        end: "[(]|$",
        returnBegin: !0,
        excludeEnd: !0,
        keywords: t,
        relevance: 5,
        contains: [
          {
            begin: e.UNDERSCORE_IDENT_RE + "\\s*\\(",
            returnBegin: !0,
            relevance: 0,
            contains: [e.UNDERSCORE_TITLE_MODE]
          },
          {
            className: "type",
            begin: /</,
            end: />/,
            keywords: "reified",
            relevance: 0
          },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            endsParent: !0,
            keywords: t,
            relevance: 0,
            contains: [
              {
                begin: /:/,
                end: /[=,\/]/,
                endsWithParent: !0,
                contains: [
                  m,
                  e.C_LINE_COMMENT_MODE,
                  g
                ],
                relevance: 0
              },
              e.C_LINE_COMMENT_MODE,
              g,
              f,
              d,
              c,
              e.C_NUMBER_MODE
            ]
          },
          g
        ]
      },
      {
        className: "class",
        beginKeywords: "class interface trait",
        // remove 'trait' when removed from KEYWORDS
        end: /[:\{(]|$/,
        excludeEnd: !0,
        illegal: "extends implements",
        contains: [
          { beginKeywords: "public protected internal private constructor" },
          e.UNDERSCORE_TITLE_MODE,
          {
            className: "type",
            begin: /</,
            end: />/,
            excludeBegin: !0,
            excludeEnd: !0,
            relevance: 0
          },
          {
            className: "type",
            begin: /[,:]\s*/,
            end: /[<\(,]|$/,
            excludeBegin: !0,
            returnEnd: !0
          },
          f,
          d
        ]
      },
      c,
      {
        className: "meta",
        begin: "^#!/usr/bin/env",
        end: "$",
        illegal: `
`
      },
      h
    ]
  };
}
function eCe(e) {
  const t = {
    className: "built_in",
    begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
  }, n = /[a-zA-Z@][a-zA-Z0-9_]*/, f = {
    "variable.language": [
      "this",
      "super"
    ],
    $pattern: n,
    keyword: [
      "while",
      "export",
      "sizeof",
      "typedef",
      "const",
      "struct",
      "for",
      "union",
      "volatile",
      "static",
      "mutable",
      "if",
      "do",
      "return",
      "goto",
      "enum",
      "else",
      "break",
      "extern",
      "asm",
      "case",
      "default",
      "register",
      "explicit",
      "typename",
      "switch",
      "continue",
      "inline",
      "readonly",
      "assign",
      "readwrite",
      "self",
      "@synchronized",
      "id",
      "typeof",
      "nonatomic",
      "IBOutlet",
      "IBAction",
      "strong",
      "weak",
      "copy",
      "in",
      "out",
      "inout",
      "bycopy",
      "byref",
      "oneway",
      "__strong",
      "__weak",
      "__block",
      "__autoreleasing",
      "@private",
      "@protected",
      "@public",
      "@try",
      "@property",
      "@end",
      "@throw",
      "@catch",
      "@finally",
      "@autoreleasepool",
      "@synthesize",
      "@dynamic",
      "@selector",
      "@optional",
      "@required",
      "@encode",
      "@package",
      "@import",
      "@defs",
      "@compatibility_alias",
      "__bridge",
      "__bridge_transfer",
      "__bridge_retained",
      "__bridge_retain",
      "__covariant",
      "__contravariant",
      "__kindof",
      "_Nonnull",
      "_Nullable",
      "_Null_unspecified",
      "__FUNCTION__",
      "__PRETTY_FUNCTION__",
      "__attribute__",
      "getter",
      "setter",
      "retain",
      "unsafe_unretained",
      "nonnull",
      "nullable",
      "null_unspecified",
      "null_resettable",
      "class",
      "instancetype",
      "NS_DESIGNATED_INITIALIZER",
      "NS_UNAVAILABLE",
      "NS_REQUIRES_SUPER",
      "NS_RETURNS_INNER_POINTER",
      "NS_INLINE",
      "NS_AVAILABLE",
      "NS_DEPRECATED",
      "NS_ENUM",
      "NS_OPTIONS",
      "NS_SWIFT_UNAVAILABLE",
      "NS_ASSUME_NONNULL_BEGIN",
      "NS_ASSUME_NONNULL_END",
      "NS_REFINED_FOR_SWIFT",
      "NS_SWIFT_NAME",
      "NS_SWIFT_NOTHROW",
      "NS_DURING",
      "NS_HANDLER",
      "NS_ENDHANDLER",
      "NS_VALUERETURN",
      "NS_VOIDRETURN"
    ],
    literal: [
      "false",
      "true",
      "FALSE",
      "TRUE",
      "nil",
      "YES",
      "NO",
      "NULL"
    ],
    built_in: [
      "dispatch_once_t",
      "dispatch_queue_t",
      "dispatch_sync",
      "dispatch_async",
      "dispatch_once"
    ],
    type: [
      "int",
      "float",
      "char",
      "unsigned",
      "signed",
      "short",
      "long",
      "double",
      "wchar_t",
      "unichar",
      "void",
      "bool",
      "BOOL",
      "id|0",
      "_Bool"
    ]
  }, d = {
    $pattern: n,
    keyword: [
      "@interface",
      "@class",
      "@protocol",
      "@implementation"
    ]
  };
  return {
    name: "Objective-C",
    aliases: [
      "mm",
      "objc",
      "obj-c",
      "obj-c++",
      "objective-c++"
    ],
    keywords: f,
    illegal: "</",
    contains: [
      t,
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      e.C_NUMBER_MODE,
      e.QUOTE_STRING_MODE,
      e.APOS_STRING_MODE,
      {
        className: "string",
        variants: [
          {
            begin: '@"',
            end: '"',
            illegal: "\\n",
            contains: [e.BACKSLASH_ESCAPE]
          }
        ]
      },
      {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: { keyword: "if else elif endif define undef warning error line pragma ifdef ifndef include" },
        contains: [
          {
            begin: /\\\n/,
            relevance: 0
          },
          e.inherit(e.QUOTE_STRING_MODE, { className: "string" }),
          {
            className: "string",
            begin: /<.*?>/,
            end: /$/,
            illegal: "\\n"
          },
          e.C_LINE_COMMENT_MODE,
          e.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: "class",
        begin: "(" + d.keyword.join("|") + ")\\b",
        end: /(\{|$)/,
        excludeEnd: !0,
        keywords: d,
        contains: [e.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: "\\." + e.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  };
}
function tCe(e) {
  const t = e.regex, n = [
    "abs",
    "accept",
    "alarm",
    "and",
    "atan2",
    "bind",
    "binmode",
    "bless",
    "break",
    "caller",
    "chdir",
    "chmod",
    "chomp",
    "chop",
    "chown",
    "chr",
    "chroot",
    "close",
    "closedir",
    "connect",
    "continue",
    "cos",
    "crypt",
    "dbmclose",
    "dbmopen",
    "defined",
    "delete",
    "die",
    "do",
    "dump",
    "each",
    "else",
    "elsif",
    "endgrent",
    "endhostent",
    "endnetent",
    "endprotoent",
    "endpwent",
    "endservent",
    "eof",
    "eval",
    "exec",
    "exists",
    "exit",
    "exp",
    "fcntl",
    "fileno",
    "flock",
    "for",
    "foreach",
    "fork",
    "format",
    "formline",
    "getc",
    "getgrent",
    "getgrgid",
    "getgrnam",
    "gethostbyaddr",
    "gethostbyname",
    "gethostent",
    "getlogin",
    "getnetbyaddr",
    "getnetbyname",
    "getnetent",
    "getpeername",
    "getpgrp",
    "getpriority",
    "getprotobyname",
    "getprotobynumber",
    "getprotoent",
    "getpwent",
    "getpwnam",
    "getpwuid",
    "getservbyname",
    "getservbyport",
    "getservent",
    "getsockname",
    "getsockopt",
    "given",
    "glob",
    "gmtime",
    "goto",
    "grep",
    "gt",
    "hex",
    "if",
    "index",
    "int",
    "ioctl",
    "join",
    "keys",
    "kill",
    "last",
    "lc",
    "lcfirst",
    "length",
    "link",
    "listen",
    "local",
    "localtime",
    "log",
    "lstat",
    "lt",
    "ma",
    "map",
    "mkdir",
    "msgctl",
    "msgget",
    "msgrcv",
    "msgsnd",
    "my",
    "ne",
    "next",
    "no",
    "not",
    "oct",
    "open",
    "opendir",
    "or",
    "ord",
    "our",
    "pack",
    "package",
    "pipe",
    "pop",
    "pos",
    "print",
    "printf",
    "prototype",
    "push",
    "q|0",
    "qq",
    "quotemeta",
    "qw",
    "qx",
    "rand",
    "read",
    "readdir",
    "readline",
    "readlink",
    "readpipe",
    "recv",
    "redo",
    "ref",
    "rename",
    "require",
    "reset",
    "return",
    "reverse",
    "rewinddir",
    "rindex",
    "rmdir",
    "say",
    "scalar",
    "seek",
    "seekdir",
    "select",
    "semctl",
    "semget",
    "semop",
    "send",
    "setgrent",
    "sethostent",
    "setnetent",
    "setpgrp",
    "setpriority",
    "setprotoent",
    "setpwent",
    "setservent",
    "setsockopt",
    "shift",
    "shmctl",
    "shmget",
    "shmread",
    "shmwrite",
    "shutdown",
    "sin",
    "sleep",
    "socket",
    "socketpair",
    "sort",
    "splice",
    "split",
    "sprintf",
    "sqrt",
    "srand",
    "stat",
    "state",
    "study",
    "sub",
    "substr",
    "symlink",
    "syscall",
    "sysopen",
    "sysread",
    "sysseek",
    "system",
    "syswrite",
    "tell",
    "telldir",
    "tie",
    "tied",
    "time",
    "times",
    "tr",
    "truncate",
    "uc",
    "ucfirst",
    "umask",
    "undef",
    "unless",
    "unlink",
    "unpack",
    "unshift",
    "untie",
    "until",
    "use",
    "utime",
    "values",
    "vec",
    "wait",
    "waitpid",
    "wantarray",
    "warn",
    "when",
    "while",
    "write",
    "x|0",
    "xor",
    "y|0"
  ], r = /[dualxmsipngr]{0,12}/, l = {
    $pattern: /[\w.]+/,
    keyword: n.join(" ")
  }, i = {
    className: "subst",
    begin: "[$@]\\{",
    end: "\\}",
    keywords: l
  }, c = {
    begin: /->\{/,
    end: /\}/
    // contains defined later
  }, f = { variants: [
    { begin: /\$\d/ },
    { begin: t.concat(
      /[$%@](\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/,
      // negative look-ahead tries to avoid matching patterns that are not
      // Perl at all like $ident$, @ident@, etc.
      "(?![A-Za-z])(?![@$%])"
    ) },
    {
      begin: /[$%@][^\s\w{]/,
      relevance: 0
    }
  ] }, d = [
    e.BACKSLASH_ESCAPE,
    i,
    f
  ], h = [
    /!/,
    /\//,
    /\|/,
    /\?/,
    /'/,
    /"/,
    // valid but infrequent and weird
    /#/
    // valid but infrequent and weird
  ], g = (w, C, E = "\\1") => {
    const R = E === "\\1" ? E : t.concat(E, C);
    return t.concat(
      t.concat("(?:", w, ")"),
      C,
      /(?:\\.|[^\\\/])*?/,
      R,
      /(?:\\.|[^\\\/])*?/,
      E,
      r
    );
  }, m = (w, C, E) => t.concat(
    t.concat("(?:", w, ")"),
    C,
    /(?:\\.|[^\\\/])*?/,
    E,
    r
  ), y = [
    f,
    e.HASH_COMMENT_MODE,
    e.COMMENT(
      /^=\w/,
      /=cut/,
      { endsWithParent: !0 }
    ),
    c,
    {
      className: "string",
      contains: d,
      variants: [
        {
          begin: "q[qwxr]?\\s*\\(",
          end: "\\)",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\[",
          end: "\\]",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\{",
          end: "\\}",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\|",
          end: "\\|",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*<",
          end: ">",
          relevance: 5
        },
        {
          begin: "qw\\s+q",
          end: "q",
          relevance: 5
        },
        {
          begin: "'",
          end: "'",
          contains: [e.BACKSLASH_ESCAPE]
        },
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "`",
          end: "`",
          contains: [e.BACKSLASH_ESCAPE]
        },
        {
          begin: /\{\w+\}/,
          relevance: 0
        },
        {
          begin: "-?\\w+\\s*=>",
          relevance: 0
        }
      ]
    },
    {
      className: "number",
      begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
      relevance: 0
    },
    {
      // regexp container
      begin: "(\\/\\/|" + e.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
      keywords: "split return print reverse grep",
      relevance: 0,
      contains: [
        e.HASH_COMMENT_MODE,
        {
          className: "regexp",
          variants: [
            // allow matching common delimiters
            { begin: g("s|tr|y", t.either(...h, { capture: !0 })) },
            // and then paired delmis
            { begin: g("s|tr|y", "\\(", "\\)") },
            { begin: g("s|tr|y", "\\[", "\\]") },
            { begin: g("s|tr|y", "\\{", "\\}") }
          ],
          relevance: 2
        },
        {
          className: "regexp",
          variants: [
            {
              // could be a comment in many languages so do not count
              // as relevant
              begin: /(m|qr)\/\//,
              relevance: 0
            },
            // prefix is optional with /regex/
            { begin: m("(?:m|qr)?", /\//, /\//) },
            // allow matching common delimiters
            { begin: m("m|qr", t.either(...h, { capture: !0 }), /\1/) },
            // allow common paired delmins
            { begin: m("m|qr", /\(/, /\)/) },
            { begin: m("m|qr", /\[/, /\]/) },
            { begin: m("m|qr", /\{/, /\}/) }
          ]
        }
      ]
    },
    {
      className: "function",
      beginKeywords: "sub",
      end: "(\\s*\\(.*?\\))?[;{]",
      excludeEnd: !0,
      relevance: 5,
      contains: [e.TITLE_MODE]
    },
    {
      begin: "-\\w\\b",
      relevance: 0
    },
    {
      begin: "^__DATA__$",
      end: "^__END__$",
      subLanguage: "mojolicious",
      contains: [
        {
          begin: "^@@.*",
          end: "$",
          className: "comment"
        }
      ]
    }
  ];
  return i.contains = y, c.contains = y, {
    name: "Perl",
    aliases: [
      "pl",
      "pm"
    ],
    keywords: l,
    contains: y
  };
}
function nCe(e) {
  const t = e.regex, n = /(?![A-Za-z0-9])(?![$])/, r = t.concat(
    /[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/,
    n
  ), l = t.concat(
    /(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/,
    n
  ), i = {
    scope: "variable",
    match: "\\$+" + r
  }, c = {
    scope: "meta",
    variants: [
      { begin: /<\?php/, relevance: 10 },
      // boost for obvious PHP
      { begin: /<\?=/ },
      // less relevant per PSR-1 which says not to use short-tags
      { begin: /<\?/, relevance: 0.1 },
      { begin: /\?>/ }
      // end php tag
    ]
  }, f = {
    scope: "subst",
    variants: [
      { begin: /\$\w+/ },
      {
        begin: /\{\$/,
        end: /\}/
      }
    ]
  }, d = e.inherit(e.APOS_STRING_MODE, { illegal: null }), h = e.inherit(e.QUOTE_STRING_MODE, {
    illegal: null,
    contains: e.QUOTE_STRING_MODE.contains.concat(f)
  }), g = e.END_SAME_AS_BEGIN({
    begin: /<<<[ \t]*(\w+)\n/,
    end: /[ \t]*(\w+)\b/,
    contains: e.QUOTE_STRING_MODE.contains.concat(f)
  }), m = `[ 	
]`, y = {
    scope: "string",
    variants: [
      h,
      d,
      g
    ]
  }, w = {
    scope: "number",
    variants: [
      { begin: "\\b0[bB][01]+(?:_[01]+)*\\b" },
      // Binary w/ underscore support
      { begin: "\\b0[oO][0-7]+(?:_[0-7]+)*\\b" },
      // Octals w/ underscore support
      { begin: "\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b" },
      // Hex w/ underscore support
      // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
      { begin: "(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?" }
    ],
    relevance: 0
  }, C = [
    "false",
    "null",
    "true"
  ], E = [
    // Magic constants:
    // <https://www.php.net/manual/en/language.constants.predefined.php>
    "__CLASS__",
    "__DIR__",
    "__FILE__",
    "__FUNCTION__",
    "__COMPILER_HALT_OFFSET__",
    "__LINE__",
    "__METHOD__",
    "__NAMESPACE__",
    "__TRAIT__",
    // Function that look like language construct or language construct that look like function:
    // List of keywords that may not require parenthesis
    "die",
    "echo",
    "exit",
    "include",
    "include_once",
    "print",
    "require",
    "require_once",
    // These are not language construct (function) but operate on the currently-executing function and can access the current symbol table
    // 'compact extract func_get_arg func_get_args func_num_args get_called_class get_parent_class ' +
    // Other keywords:
    // <https://www.php.net/manual/en/reserved.php>
    // <https://www.php.net/manual/en/language.types.type-juggling.php>
    "array",
    "abstract",
    "and",
    "as",
    "binary",
    "bool",
    "boolean",
    "break",
    "callable",
    "case",
    "catch",
    "class",
    "clone",
    "const",
    "continue",
    "declare",
    "default",
    "do",
    "double",
    "else",
    "elseif",
    "empty",
    "enddeclare",
    "endfor",
    "endforeach",
    "endif",
    "endswitch",
    "endwhile",
    "enum",
    "eval",
    "extends",
    "final",
    "finally",
    "float",
    "for",
    "foreach",
    "from",
    "global",
    "goto",
    "if",
    "implements",
    "instanceof",
    "insteadof",
    "int",
    "integer",
    "interface",
    "isset",
    "iterable",
    "list",
    "match|0",
    "mixed",
    "new",
    "never",
    "object",
    "or",
    "private",
    "protected",
    "public",
    "readonly",
    "real",
    "return",
    "string",
    "switch",
    "throw",
    "trait",
    "try",
    "unset",
    "use",
    "var",
    "void",
    "while",
    "xor",
    "yield"
  ], R = [
    // Standard PHP library:
    // <https://www.php.net/manual/en/book.spl.php>
    "Error|0",
    "AppendIterator",
    "ArgumentCountError",
    "ArithmeticError",
    "ArrayIterator",
    "ArrayObject",
    "AssertionError",
    "BadFunctionCallException",
    "BadMethodCallException",
    "CachingIterator",
    "CallbackFilterIterator",
    "CompileError",
    "Countable",
    "DirectoryIterator",
    "DivisionByZeroError",
    "DomainException",
    "EmptyIterator",
    "ErrorException",
    "Exception",
    "FilesystemIterator",
    "FilterIterator",
    "GlobIterator",
    "InfiniteIterator",
    "InvalidArgumentException",
    "IteratorIterator",
    "LengthException",
    "LimitIterator",
    "LogicException",
    "MultipleIterator",
    "NoRewindIterator",
    "OutOfBoundsException",
    "OutOfRangeException",
    "OuterIterator",
    "OverflowException",
    "ParentIterator",
    "ParseError",
    "RangeException",
    "RecursiveArrayIterator",
    "RecursiveCachingIterator",
    "RecursiveCallbackFilterIterator",
    "RecursiveDirectoryIterator",
    "RecursiveFilterIterator",
    "RecursiveIterator",
    "RecursiveIteratorIterator",
    "RecursiveRegexIterator",
    "RecursiveTreeIterator",
    "RegexIterator",
    "RuntimeException",
    "SeekableIterator",
    "SplDoublyLinkedList",
    "SplFileInfo",
    "SplFileObject",
    "SplFixedArray",
    "SplHeap",
    "SplMaxHeap",
    "SplMinHeap",
    "SplObjectStorage",
    "SplObserver",
    "SplPriorityQueue",
    "SplQueue",
    "SplStack",
    "SplSubject",
    "SplTempFileObject",
    "TypeError",
    "UnderflowException",
    "UnexpectedValueException",
    "UnhandledMatchError",
    // Reserved interfaces:
    // <https://www.php.net/manual/en/reserved.interfaces.php>
    "ArrayAccess",
    "BackedEnum",
    "Closure",
    "Fiber",
    "Generator",
    "Iterator",
    "IteratorAggregate",
    "Serializable",
    "Stringable",
    "Throwable",
    "Traversable",
    "UnitEnum",
    "WeakReference",
    "WeakMap",
    // Reserved classes:
    // <https://www.php.net/manual/en/reserved.classes.php>
    "Directory",
    "__PHP_Incomplete_Class",
    "parent",
    "php_user_filter",
    "self",
    "static",
    "stdClass"
  ], P = {
    keyword: E,
    literal: ((j) => {
      const A = [];
      return j.forEach((Z) => {
        A.push(Z), Z.toLowerCase() === Z ? A.push(Z.toUpperCase()) : A.push(Z.toLowerCase());
      }), A;
    })(C),
    built_in: R
  }, a = (j) => j.map((A) => A.replace(/\|\d+$/, "")), o = { variants: [
    {
      match: [
        /new/,
        t.concat(m, "+"),
        // to prevent built ins from being confused as the class constructor call
        t.concat("(?!", a(R).join("\\b|"), "\\b)"),
        l
      ],
      scope: {
        1: "keyword",
        4: "title.class"
      }
    }
  ] }, s = t.concat(r, "\\b(?!\\()"), p = { variants: [
    {
      match: [
        t.concat(
          /::/,
          t.lookahead(/(?!class\b)/)
        ),
        s
      ],
      scope: { 2: "variable.constant" }
    },
    {
      match: [
        /::/,
        /class/
      ],
      scope: { 2: "variable.language" }
    },
    {
      match: [
        l,
        t.concat(
          /::/,
          t.lookahead(/(?!class\b)/)
        ),
        s
      ],
      scope: {
        1: "title.class",
        3: "variable.constant"
      }
    },
    {
      match: [
        l,
        t.concat(
          "::",
          t.lookahead(/(?!class\b)/)
        )
      ],
      scope: { 1: "title.class" }
    },
    {
      match: [
        l,
        /::/,
        /class/
      ],
      scope: {
        1: "title.class",
        3: "variable.language"
      }
    }
  ] }, O = {
    scope: "attr",
    match: t.concat(r, t.lookahead(":"), t.lookahead(/(?!::)/))
  }, x = {
    relevance: 0,
    begin: /\(/,
    end: /\)/,
    keywords: P,
    contains: [
      O,
      i,
      p,
      e.C_BLOCK_COMMENT_MODE,
      y,
      w,
      o
    ]
  }, N = {
    relevance: 0,
    match: [
      /\b/,
      // to prevent keywords from being confused as the function title
      t.concat("(?!fn\\b|function\\b|", a(E).join("\\b|"), "|", a(R).join("\\b|"), "\\b)"),
      r,
      t.concat(m, "*"),
      t.lookahead(/(?=\()/)
    ],
    scope: { 3: "title.function.invoke" },
    contains: [x]
  };
  x.contains.push(N);
  const T = [
    O,
    p,
    e.C_BLOCK_COMMENT_MODE,
    y,
    w,
    o
  ], $ = {
    begin: t.concat(/#\[\s*/, l),
    beginScope: "meta",
    end: /]/,
    endScope: "meta",
    keywords: {
      literal: C,
      keyword: [
        "new",
        "array"
      ]
    },
    contains: [
      {
        begin: /\[/,
        end: /]/,
        keywords: {
          literal: C,
          keyword: [
            "new",
            "array"
          ]
        },
        contains: [
          "self",
          ...T
        ]
      },
      ...T,
      {
        scope: "meta",
        match: l
      }
    ]
  };
  return {
    case_insensitive: !1,
    keywords: P,
    contains: [
      $,
      e.HASH_COMMENT_MODE,
      e.COMMENT("//", "$"),
      e.COMMENT(
        "/\\*",
        "\\*/",
        { contains: [
          {
            scope: "doctag",
            match: "@[A-Za-z]+"
          }
        ] }
      ),
      {
        match: /__halt_compiler\(\);/,
        keywords: "__halt_compiler",
        starts: {
          scope: "comment",
          end: e.MATCH_NOTHING_RE,
          contains: [
            {
              match: /\?>/,
              scope: "meta",
              endsParent: !0
            }
          ]
        }
      },
      c,
      {
        scope: "variable.language",
        match: /\$this\b/
      },
      i,
      N,
      p,
      {
        match: [
          /const/,
          /\s/,
          r
        ],
        scope: {
          1: "keyword",
          3: "variable.constant"
        }
      },
      o,
      {
        scope: "function",
        relevance: 0,
        beginKeywords: "fn function",
        end: /[;{]/,
        excludeEnd: !0,
        illegal: "[$%\\[]",
        contains: [
          { beginKeywords: "use" },
          e.UNDERSCORE_TITLE_MODE,
          {
            begin: "=>",
            // No markup, just a relevance booster
            endsParent: !0
          },
          {
            scope: "params",
            begin: "\\(",
            end: "\\)",
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: P,
            contains: [
              "self",
              i,
              p,
              e.C_BLOCK_COMMENT_MODE,
              y,
              w
            ]
          }
        ]
      },
      {
        scope: "class",
        variants: [
          {
            beginKeywords: "enum",
            illegal: /[($"]/
          },
          {
            beginKeywords: "class interface trait",
            illegal: /[:($"]/
          }
        ],
        relevance: 0,
        end: /\{/,
        excludeEnd: !0,
        contains: [
          { beginKeywords: "extends implements" },
          e.UNDERSCORE_TITLE_MODE
        ]
      },
      // both use and namespace still use "old style" rules (vs multi-match)
      // because the namespace name can include `\` and we still want each
      // element to be treated as its own *individual* title
      {
        beginKeywords: "namespace",
        relevance: 0,
        end: ";",
        illegal: /[.']/,
        contains: [e.inherit(e.UNDERSCORE_TITLE_MODE, { scope: "title.class" })]
      },
      {
        beginKeywords: "use",
        relevance: 0,
        end: ";",
        contains: [
          // TODO: title.function vs title.class
          {
            match: /\b(as|const|function)\b/,
            scope: "keyword"
          },
          // TODO: could be title.class or title.function
          e.UNDERSCORE_TITLE_MODE
        ]
      },
      y,
      w
    ]
  };
}
function rCe(e) {
  const t = "[ \\t\\f]*", n = "[ \\t\\f]+", r = t + "[:=]" + t, l = n, i = "(" + r + "|" + l + ")", c = "([^\\\\:= \\t\\f\\n]|\\\\.)+", f = {
    // skip DELIM
    end: i,
    relevance: 0,
    starts: {
      // value: everything until end of line (again, taking into account backslashes)
      className: "string",
      end: /$/,
      relevance: 0,
      contains: [
        { begin: "\\\\\\\\" },
        { begin: "\\\\\\n" }
      ]
    }
  };
  return {
    name: ".properties",
    disableAutodetect: !0,
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      e.COMMENT("^\\s*[!#]", "$"),
      // key: everything until whitespace or = or : (taking into account backslashes)
      // case of a key-value pair
      {
        returnBegin: !0,
        variants: [
          { begin: c + r },
          { begin: c + l }
        ],
        contains: [
          {
            className: "attr",
            begin: c,
            endsParent: !0
          }
        ],
        starts: f
      },
      // case of an empty key
      {
        className: "attr",
        begin: c + t + "$"
      }
    ]
  };
}
function aCe(e) {
  const t = e.regex, n = /[\p{XID_Start}_]\p{XID_Continue}*/u, r = [
    "and",
    "as",
    "assert",
    "async",
    "await",
    "break",
    "class",
    "continue",
    "def",
    "del",
    "elif",
    "else",
    "except",
    "finally",
    "for",
    "from",
    "global",
    "if",
    "import",
    "in",
    "is",
    "lambda",
    "nonlocal|10",
    "not",
    "or",
    "pass",
    "raise",
    "return",
    "try",
    "while",
    "with",
    "yield"
  ], f = {
    $pattern: /[A-Za-z]\w+|__\w+__/,
    keyword: r,
    built_in: [
      "__import__",
      "abs",
      "all",
      "any",
      "ascii",
      "bin",
      "bool",
      "breakpoint",
      "bytearray",
      "bytes",
      "callable",
      "chr",
      "classmethod",
      "compile",
      "complex",
      "delattr",
      "dict",
      "dir",
      "divmod",
      "enumerate",
      "eval",
      "exec",
      "filter",
      "float",
      "format",
      "frozenset",
      "getattr",
      "globals",
      "hasattr",
      "hash",
      "help",
      "hex",
      "id",
      "input",
      "int",
      "isinstance",
      "issubclass",
      "iter",
      "len",
      "list",
      "locals",
      "map",
      "max",
      "memoryview",
      "min",
      "next",
      "object",
      "oct",
      "open",
      "ord",
      "pow",
      "print",
      "property",
      "range",
      "repr",
      "reversed",
      "round",
      "set",
      "setattr",
      "slice",
      "sorted",
      "staticmethod",
      "str",
      "sum",
      "super",
      "tuple",
      "type",
      "vars",
      "zip"
    ],
    literal: [
      "__debug__",
      "Ellipsis",
      "False",
      "None",
      "NotImplemented",
      "True"
    ],
    type: [
      "Any",
      "Callable",
      "Coroutine",
      "Dict",
      "List",
      "Literal",
      "Generic",
      "Optional",
      "Sequence",
      "Set",
      "Tuple",
      "Type",
      "Union"
    ]
  }, d = {
    className: "meta",
    begin: /^(>>>|\.\.\.) /
  }, h = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: f,
    illegal: /#/
  }, g = {
    begin: /\{\{/,
    relevance: 0
  }, m = {
    className: "string",
    contains: [e.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
        end: /'''/,
        contains: [
          e.BACKSLASH_ESCAPE,
          d
        ],
        relevance: 10
      },
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
        end: /"""/,
        contains: [
          e.BACKSLASH_ESCAPE,
          d
        ],
        relevance: 10
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'''/,
        end: /'''/,
        contains: [
          e.BACKSLASH_ESCAPE,
          d,
          g,
          h
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"""/,
        end: /"""/,
        contains: [
          e.BACKSLASH_ESCAPE,
          d,
          g,
          h
        ]
      },
      {
        begin: /([uU]|[rR])'/,
        end: /'/,
        relevance: 10
      },
      {
        begin: /([uU]|[rR])"/,
        end: /"/,
        relevance: 10
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])'/,
        end: /'/
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])"/,
        end: /"/
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'/,
        end: /'/,
        contains: [
          e.BACKSLASH_ESCAPE,
          g,
          h
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"/,
        end: /"/,
        contains: [
          e.BACKSLASH_ESCAPE,
          g,
          h
        ]
      },
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE
    ]
  }, y = "[0-9](_?[0-9])*", w = `(\\b(${y}))?\\.(${y})|\\b(${y})\\.`, C = `\\b|${r.join("|")}`, E = {
    className: "number",
    relevance: 0,
    variants: [
      // exponentfloat, pointfloat
      // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
      // optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      // Note: no leading \b because floats can start with a decimal point
      // and we don't want to mishandle e.g. `fn(.5)`,
      // no trailing \b for pointfloat because it can end with a decimal point
      // and we don't want to mishandle e.g. `0..hex()`; this should be safe
      // because both MUST contain a decimal point and so cannot be confused with
      // the interior part of an identifier
      {
        begin: `(\\b(${y})|(${w}))[eE][+-]?(${y})[jJ]?(?=${C})`
      },
      {
        begin: `(${w})[jJ]?`
      },
      // decinteger, bininteger, octinteger, hexinteger
      // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
      // optionally "long" in Python 2
      // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
      // decinteger is optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${C})`
      },
      {
        begin: `\\b0[bB](_?[01])+[lL]?(?=${C})`
      },
      {
        begin: `\\b0[oO](_?[0-7])+[lL]?(?=${C})`
      },
      {
        begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${C})`
      },
      // imagnumber (digitpart-based)
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b(${y})[jJ](?=${C})`
      }
    ]
  }, R = {
    className: "comment",
    begin: t.lookahead(/# type:/),
    end: /$/,
    keywords: f,
    contains: [
      {
        // prevent keywords from coloring `type`
        begin: /# type:/
      },
      // comment within a datatype comment includes no keywords
      {
        begin: /#/,
        end: /\b\B/,
        endsWithParent: !0
      }
    ]
  }, M = {
    className: "params",
    variants: [
      // Exclude params in functions without params
      {
        className: "",
        begin: /\(\s*\)/,
        skip: !0
      },
      {
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: f,
        contains: [
          "self",
          d,
          E,
          m,
          e.HASH_COMMENT_MODE
        ]
      }
    ]
  };
  return h.contains = [
    m,
    E,
    d
  ], {
    name: "Python",
    aliases: [
      "py",
      "gyp",
      "ipython"
    ],
    unicodeRegex: !0,
    keywords: f,
    illegal: /(<\/|->|\?)|=>/,
    contains: [
      d,
      E,
      {
        // very common convention
        begin: /\bself\b/
      },
      {
        // eat "if" prior to string so that it won't accidentally be
        // labeled as an f-string
        beginKeywords: "if",
        relevance: 0
      },
      m,
      R,
      e.HASH_COMMENT_MODE,
      {
        match: [
          /\bdef/,
          /\s+/,
          n
        ],
        scope: {
          1: "keyword",
          3: "title.function"
        },
        contains: [M]
      },
      {
        variants: [
          {
            match: [
              /\bclass/,
              /\s+/,
              n,
              /\s*/,
              /\(\s*/,
              n,
              /\s*\)/
            ]
          },
          {
            match: [
              /\bclass/,
              /\s+/,
              n
            ]
          }
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          6: "title.class.inherited"
        }
      },
      {
        className: "meta",
        begin: /^[\t ]*@/,
        end: /(?=#)|$/,
        contains: [
          E,
          M,
          m
        ]
      }
    ]
  };
}
function lCe(e) {
  const t = e.regex, n = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)", r = t.either(
    /\b([A-Z]+[a-z0-9]+)+/,
    // ends in caps
    /\b([A-Z]+[a-z0-9]+)+[A-Z]+/
  ), l = t.concat(r, /(::\w+)*/), i = {
    "variable.constant": [
      "__FILE__",
      "__LINE__"
    ],
    "variable.language": [
      "self",
      "super"
    ],
    keyword: [
      "alias",
      "and",
      "attr_accessor",
      "attr_reader",
      "attr_writer",
      "begin",
      "BEGIN",
      "break",
      "case",
      "class",
      "defined",
      "do",
      "else",
      "elsif",
      "end",
      "END",
      "ensure",
      "for",
      "if",
      "in",
      "include",
      "module",
      "next",
      "not",
      "or",
      "redo",
      "require",
      "rescue",
      "retry",
      "return",
      "then",
      "undef",
      "unless",
      "until",
      "when",
      "while",
      "yield"
    ],
    built_in: [
      "proc",
      "lambda"
    ],
    literal: [
      "true",
      "false",
      "nil"
    ]
  }, c = {
    className: "doctag",
    begin: "@[A-Za-z]+"
  }, f = {
    begin: "#<",
    end: ">"
  }, d = [
    e.COMMENT(
      "#",
      "$",
      { contains: [c] }
    ),
    e.COMMENT(
      "^=begin",
      "^=end",
      {
        contains: [c],
        relevance: 10
      }
    ),
    e.COMMENT("^__END__", e.MATCH_NOTHING_RE)
  ], h = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: i
  }, g = {
    className: "string",
    contains: [
      e.BACKSLASH_ESCAPE,
      h
    ],
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      },
      {
        begin: /`/,
        end: /`/
      },
      {
        begin: /%[qQwWx]?\(/,
        end: /\)/
      },
      {
        begin: /%[qQwWx]?\[/,
        end: /\]/
      },
      {
        begin: /%[qQwWx]?\{/,
        end: /\}/
      },
      {
        begin: /%[qQwWx]?</,
        end: />/
      },
      {
        begin: /%[qQwWx]?\//,
        end: /\//
      },
      {
        begin: /%[qQwWx]?%/,
        end: /%/
      },
      {
        begin: /%[qQwWx]?-/,
        end: /-/
      },
      {
        begin: /%[qQwWx]?\|/,
        end: /\|/
      },
      // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
      // where ? is the last character of a preceding identifier, as in: `func?4`
      { begin: /\B\?(\\\d{1,3})/ },
      { begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/ },
      { begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/ },
      { begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/ },
      { begin: /\B\?\\(c|C-)[\x20-\x7e]/ },
      { begin: /\B\?\\?\S/ },
      // heredocs
      {
        // this guard makes sure that we have an entire heredoc and not a false
        // positive (auto-detect, etc.)
        begin: t.concat(
          /<<[-~]?'?/,
          t.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)
        ),
        contains: [
          e.END_SAME_AS_BEGIN({
            begin: /(\w+)/,
            end: /(\w+)/,
            contains: [
              e.BACKSLASH_ESCAPE,
              h
            ]
          })
        ]
      }
    ]
  }, m = "[1-9](_?[0-9])*|0", y = "[0-9](_?[0-9])*", w = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal integer/float, optionally exponential or rational, optionally imaginary
      { begin: `\\b(${m})(\\.(${y}))?([eE][+-]?(${y})|r)?i?\\b` },
      // explicit decimal/binary/octal/hexadecimal integer,
      // optionally rational and/or imaginary
      { begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b" },
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b" },
      // 0-prefixed implicit octal integer, optionally rational and/or imaginary
      { begin: "\\b0(_?[0-7])+r?i?\\b" }
    ]
  }, C = {
    variants: [
      {
        match: /\(\)/
      },
      {
        className: "params",
        begin: /\(/,
        end: /(?=\))/,
        excludeBegin: !0,
        endsParent: !0,
        keywords: i
      }
    ]
  }, a = [
    g,
    {
      variants: [
        {
          match: [
            /class\s+/,
            l,
            /\s+<\s+/,
            l
          ]
        },
        {
          match: [
            /class\s+/,
            l
          ]
        }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: i
    },
    {
      relevance: 0,
      match: [
        l,
        /\.new[ (]/
      ],
      scope: {
        1: "title.class"
      }
    },
    {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: "variable.constant"
    },
    {
      match: [
        /def/,
        /\s+/,
        n
      ],
      scope: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        C
      ]
    },
    {
      // swallow namespace qualifiers before symbols
      begin: e.IDENT_RE + "::"
    },
    {
      className: "symbol",
      begin: e.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
      relevance: 0
    },
    {
      className: "symbol",
      begin: ":(?!\\s)",
      contains: [
        g,
        { begin: n }
      ],
      relevance: 0
    },
    w,
    {
      // negative-look forward attempts to prevent false matches like:
      // @ident@ or $ident$ that might indicate this is not ruby at all
      className: "variable",
      begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
    },
    {
      className: "params",
      begin: /\|/,
      end: /\|/,
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0,
      // this could be a lot of things (in other languages) other than params
      keywords: i
    },
    {
      // regexp container
      begin: "(" + e.RE_STARTERS_RE + "|unless)\\s*",
      keywords: "unless",
      contains: [
        {
          className: "regexp",
          contains: [
            e.BACKSLASH_ESCAPE,
            h
          ],
          illegal: /\n/,
          variants: [
            {
              begin: "/",
              end: "/[a-z]*"
            },
            {
              begin: /%r\{/,
              end: /\}[a-z]*/
            },
            {
              begin: "%r\\(",
              end: "\\)[a-z]*"
            },
            {
              begin: "%r!",
              end: "![a-z]*"
            },
            {
              begin: "%r\\[",
              end: "\\][a-z]*"
            }
          ]
        }
      ].concat(f, d),
      relevance: 0
    }
  ].concat(f, d);
  h.contains = a, C.contains = a;
  const o = "[>?]>", s = "[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]", p = "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>", O = [
    {
      begin: /^\s*=>/,
      starts: {
        end: "$",
        contains: a
      }
    },
    {
      className: "meta.prompt",
      begin: "^(" + o + "|" + s + "|" + p + ")(?=[ ])",
      starts: {
        end: "$",
        keywords: i,
        contains: a
      }
    }
  ];
  return d.unshift(f), {
    name: "Ruby",
    aliases: [
      "rb",
      "gemspec",
      "podspec",
      "thor",
      "irb"
    ],
    keywords: i,
    illegal: /\/\*/,
    contains: [e.SHEBANG({ binary: "ruby" })].concat(O).concat(d).concat(a)
  };
}
function iCe(e) {
  const t = e.regex, n = {
    className: "title.function.invoke",
    relevance: 0,
    begin: t.concat(
      /\b/,
      /(?!let\b)/,
      e.IDENT_RE,
      t.lookahead(/\s*\(/)
    )
  }, r = "([ui](8|16|32|64|128|size)|f(32|64))?", l = [
    "abstract",
    "as",
    "async",
    "await",
    "become",
    "box",
    "break",
    "const",
    "continue",
    "crate",
    "do",
    "dyn",
    "else",
    "enum",
    "extern",
    "false",
    "final",
    "fn",
    "for",
    "if",
    "impl",
    "in",
    "let",
    "loop",
    "macro",
    "match",
    "mod",
    "move",
    "mut",
    "override",
    "priv",
    "pub",
    "ref",
    "return",
    "self",
    "Self",
    "static",
    "struct",
    "super",
    "trait",
    "true",
    "try",
    "type",
    "typeof",
    "unsafe",
    "unsized",
    "use",
    "virtual",
    "where",
    "while",
    "yield"
  ], i = [
    "true",
    "false",
    "Some",
    "None",
    "Ok",
    "Err"
  ], c = [
    // functions
    "drop ",
    // traits
    "Copy",
    "Send",
    "Sized",
    "Sync",
    "Drop",
    "Fn",
    "FnMut",
    "FnOnce",
    "ToOwned",
    "Clone",
    "Debug",
    "PartialEq",
    "PartialOrd",
    "Eq",
    "Ord",
    "AsRef",
    "AsMut",
    "Into",
    "From",
    "Default",
    "Iterator",
    "Extend",
    "IntoIterator",
    "DoubleEndedIterator",
    "ExactSizeIterator",
    "SliceConcatExt",
    "ToString",
    // macros
    "assert!",
    "assert_eq!",
    "bitflags!",
    "bytes!",
    "cfg!",
    "col!",
    "concat!",
    "concat_idents!",
    "debug_assert!",
    "debug_assert_eq!",
    "env!",
    "panic!",
    "file!",
    "format!",
    "format_args!",
    "include_bin!",
    "include_str!",
    "line!",
    "local_data_key!",
    "module_path!",
    "option_env!",
    "print!",
    "println!",
    "select!",
    "stringify!",
    "try!",
    "unimplemented!",
    "unreachable!",
    "vec!",
    "write!",
    "writeln!",
    "macro_rules!",
    "assert_ne!",
    "debug_assert_ne!"
  ], f = [
    "i8",
    "i16",
    "i32",
    "i64",
    "i128",
    "isize",
    "u8",
    "u16",
    "u32",
    "u64",
    "u128",
    "usize",
    "f32",
    "f64",
    "str",
    "char",
    "bool",
    "Box",
    "Option",
    "Result",
    "String",
    "Vec"
  ];
  return {
    name: "Rust",
    aliases: ["rs"],
    keywords: {
      $pattern: e.IDENT_RE + "!?",
      type: f,
      keyword: l,
      literal: i,
      built_in: c
    },
    illegal: "</",
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
      e.inherit(e.QUOTE_STRING_MODE, {
        begin: /b?"/,
        illegal: null
      }),
      {
        className: "string",
        variants: [
          { begin: /b?r(#*)"(.|\n)*?"\1(?!#)/ },
          { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
        ]
      },
      {
        className: "symbol",
        begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
      },
      {
        className: "number",
        variants: [
          { begin: "\\b0b([01_]+)" + r },
          { begin: "\\b0o([0-7_]+)" + r },
          { begin: "\\b0x([A-Fa-f0-9_]+)" + r },
          { begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + r }
        ],
        relevance: 0
      },
      {
        begin: [
          /fn/,
          /\s+/,
          e.UNDERSCORE_IDENT_RE
        ],
        className: {
          1: "keyword",
          3: "title.function"
        }
      },
      {
        className: "meta",
        begin: "#!?\\[",
        end: "\\]",
        contains: [
          {
            className: "string",
            begin: /"/,
            end: /"/
          }
        ]
      },
      {
        begin: [
          /let/,
          /\s+/,
          /(?:mut\s+)?/,
          e.UNDERSCORE_IDENT_RE
        ],
        className: {
          1: "keyword",
          3: "keyword",
          4: "variable"
        }
      },
      // must come before impl/for rule later
      {
        begin: [
          /for/,
          /\s+/,
          e.UNDERSCORE_IDENT_RE,
          /\s+/,
          /in/
        ],
        className: {
          1: "keyword",
          3: "variable",
          5: "keyword"
        }
      },
      {
        begin: [
          /type/,
          /\s+/,
          e.UNDERSCORE_IDENT_RE
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        begin: [
          /(?:trait|enum|struct|union|impl|for)/,
          /\s+/,
          e.UNDERSCORE_IDENT_RE
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        begin: e.IDENT_RE + "::",
        keywords: {
          keyword: "Self",
          built_in: c
        }
      },
      {
        className: "punctuation",
        begin: "->"
      },
      n
    ]
  };
}
function oCe(e) {
  const t = e.regex, n = {
    className: "meta",
    begin: "@[A-Za-z]+"
  }, r = {
    className: "subst",
    variants: [
      { begin: "\\$[A-Za-z0-9_]+" },
      {
        begin: /\$\{/,
        end: /\}/
      }
    ]
  }, l = {
    className: "string",
    variants: [
      {
        begin: '"""',
        end: '"""'
      },
      {
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [e.BACKSLASH_ESCAPE]
      },
      {
        begin: '[a-z]+"',
        end: '"',
        illegal: "\\n",
        contains: [
          e.BACKSLASH_ESCAPE,
          r
        ]
      },
      {
        className: "string",
        begin: '[a-z]+"""',
        end: '"""',
        contains: [r],
        relevance: 10
      }
    ]
  }, i = {
    className: "type",
    begin: "\\b[A-Z][A-Za-z0-9_]*",
    relevance: 0
  }, c = {
    className: "title",
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
    relevance: 0
  }, f = {
    className: "class",
    beginKeywords: "class object trait type",
    end: /[:={\[\n;]/,
    excludeEnd: !0,
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        beginKeywords: "extends with",
        relevance: 10
      },
      {
        begin: /\[/,
        end: /\]/,
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0,
        contains: [i]
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0,
        contains: [i]
      },
      c
    ]
  }, d = {
    className: "function",
    beginKeywords: "def",
    end: t.lookahead(/[:={\[(\n;]/),
    contains: [c]
  }, h = {
    begin: [
      /^\s*/,
      // Is first token on the line
      "extension",
      /\s+(?=[[(])/
      // followed by at least one space and `[` or `(`
    ],
    beginScope: { 2: "keyword" }
  }, g = [
    {
      begin: [
        /^\s*/,
        // Is first token on the line
        /end/,
        /\s+/,
        /(extension\b)?/
        // `extension` is the only marker that follows an `end` that cannot be captured by another rule.
      ],
      beginScope: {
        2: "keyword",
        4: "keyword"
      }
    }
  ], m = [
    { match: /\.inline\b/ },
    {
      begin: /\binline(?=\s)/,
      keywords: "inline"
    }
  ], y = {
    begin: [
      /\(\s*/,
      // Opening `(` of a parameter or argument list
      /using/,
      /\s+(?!\))/
      // Spaces not followed by `)`
    ],
    beginScope: { 2: "keyword" }
  };
  return {
    name: "Scala",
    keywords: {
      literal: "true false null",
      keyword: "type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given"
    },
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      l,
      i,
      d,
      f,
      e.C_NUMBER_MODE,
      h,
      g,
      ...m,
      y,
      n
    ]
  };
}
function sCe(e) {
  return {
    name: "Shell Session",
    aliases: [
      "console",
      "shellsession"
    ],
    contains: [
      {
        className: "meta.prompt",
        // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
        // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
        // echo /path/to/home > t.exe
        begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
        starts: {
          end: /[^\\](?=\s*$)/,
          subLanguage: "bash"
        }
      }
    ]
  };
}
function cCe(e) {
  const t = e.regex, n = e.COMMENT("--", "$"), r = {
    className: "string",
    variants: [
      {
        begin: /'/,
        end: /'/,
        contains: [{ begin: /''/ }]
      }
    ]
  }, l = {
    begin: /"/,
    end: /"/,
    contains: [{ begin: /""/ }]
  }, i = [
    "true",
    "false",
    // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
    // "null",
    "unknown"
  ], c = [
    "double precision",
    "large object",
    "with timezone",
    "without timezone"
  ], f = [
    "bigint",
    "binary",
    "blob",
    "boolean",
    "char",
    "character",
    "clob",
    "date",
    "dec",
    "decfloat",
    "decimal",
    "float",
    "int",
    "integer",
    "interval",
    "nchar",
    "nclob",
    "national",
    "numeric",
    "real",
    "row",
    "smallint",
    "time",
    "timestamp",
    "varchar",
    "varying",
    // modifier (character varying)
    "varbinary"
  ], d = [
    "add",
    "asc",
    "collation",
    "desc",
    "final",
    "first",
    "last",
    "view"
  ], h = [
    "abs",
    "acos",
    "all",
    "allocate",
    "alter",
    "and",
    "any",
    "are",
    "array",
    "array_agg",
    "array_max_cardinality",
    "as",
    "asensitive",
    "asin",
    "asymmetric",
    "at",
    "atan",
    "atomic",
    "authorization",
    "avg",
    "begin",
    "begin_frame",
    "begin_partition",
    "between",
    "bigint",
    "binary",
    "blob",
    "boolean",
    "both",
    "by",
    "call",
    "called",
    "cardinality",
    "cascaded",
    "case",
    "cast",
    "ceil",
    "ceiling",
    "char",
    "char_length",
    "character",
    "character_length",
    "check",
    "classifier",
    "clob",
    "close",
    "coalesce",
    "collate",
    "collect",
    "column",
    "commit",
    "condition",
    "connect",
    "constraint",
    "contains",
    "convert",
    "copy",
    "corr",
    "corresponding",
    "cos",
    "cosh",
    "count",
    "covar_pop",
    "covar_samp",
    "create",
    "cross",
    "cube",
    "cume_dist",
    "current",
    "current_catalog",
    "current_date",
    "current_default_transform_group",
    "current_path",
    "current_role",
    "current_row",
    "current_schema",
    "current_time",
    "current_timestamp",
    "current_path",
    "current_role",
    "current_transform_group_for_type",
    "current_user",
    "cursor",
    "cycle",
    "date",
    "day",
    "deallocate",
    "dec",
    "decimal",
    "decfloat",
    "declare",
    "default",
    "define",
    "delete",
    "dense_rank",
    "deref",
    "describe",
    "deterministic",
    "disconnect",
    "distinct",
    "double",
    "drop",
    "dynamic",
    "each",
    "element",
    "else",
    "empty",
    "end",
    "end_frame",
    "end_partition",
    "end-exec",
    "equals",
    "escape",
    "every",
    "except",
    "exec",
    "execute",
    "exists",
    "exp",
    "external",
    "extract",
    "false",
    "fetch",
    "filter",
    "first_value",
    "float",
    "floor",
    "for",
    "foreign",
    "frame_row",
    "free",
    "from",
    "full",
    "function",
    "fusion",
    "get",
    "global",
    "grant",
    "group",
    "grouping",
    "groups",
    "having",
    "hold",
    "hour",
    "identity",
    "in",
    "indicator",
    "initial",
    "inner",
    "inout",
    "insensitive",
    "insert",
    "int",
    "integer",
    "intersect",
    "intersection",
    "interval",
    "into",
    "is",
    "join",
    "json_array",
    "json_arrayagg",
    "json_exists",
    "json_object",
    "json_objectagg",
    "json_query",
    "json_table",
    "json_table_primitive",
    "json_value",
    "lag",
    "language",
    "large",
    "last_value",
    "lateral",
    "lead",
    "leading",
    "left",
    "like",
    "like_regex",
    "listagg",
    "ln",
    "local",
    "localtime",
    "localtimestamp",
    "log",
    "log10",
    "lower",
    "match",
    "match_number",
    "match_recognize",
    "matches",
    "max",
    "member",
    "merge",
    "method",
    "min",
    "minute",
    "mod",
    "modifies",
    "module",
    "month",
    "multiset",
    "national",
    "natural",
    "nchar",
    "nclob",
    "new",
    "no",
    "none",
    "normalize",
    "not",
    "nth_value",
    "ntile",
    "null",
    "nullif",
    "numeric",
    "octet_length",
    "occurrences_regex",
    "of",
    "offset",
    "old",
    "omit",
    "on",
    "one",
    "only",
    "open",
    "or",
    "order",
    "out",
    "outer",
    "over",
    "overlaps",
    "overlay",
    "parameter",
    "partition",
    "pattern",
    "per",
    "percent",
    "percent_rank",
    "percentile_cont",
    "percentile_disc",
    "period",
    "portion",
    "position",
    "position_regex",
    "power",
    "precedes",
    "precision",
    "prepare",
    "primary",
    "procedure",
    "ptf",
    "range",
    "rank",
    "reads",
    "real",
    "recursive",
    "ref",
    "references",
    "referencing",
    "regr_avgx",
    "regr_avgy",
    "regr_count",
    "regr_intercept",
    "regr_r2",
    "regr_slope",
    "regr_sxx",
    "regr_sxy",
    "regr_syy",
    "release",
    "result",
    "return",
    "returns",
    "revoke",
    "right",
    "rollback",
    "rollup",
    "row",
    "row_number",
    "rows",
    "running",
    "savepoint",
    "scope",
    "scroll",
    "search",
    "second",
    "seek",
    "select",
    "sensitive",
    "session_user",
    "set",
    "show",
    "similar",
    "sin",
    "sinh",
    "skip",
    "smallint",
    "some",
    "specific",
    "specifictype",
    "sql",
    "sqlexception",
    "sqlstate",
    "sqlwarning",
    "sqrt",
    "start",
    "static",
    "stddev_pop",
    "stddev_samp",
    "submultiset",
    "subset",
    "substring",
    "substring_regex",
    "succeeds",
    "sum",
    "symmetric",
    "system",
    "system_time",
    "system_user",
    "table",
    "tablesample",
    "tan",
    "tanh",
    "then",
    "time",
    "timestamp",
    "timezone_hour",
    "timezone_minute",
    "to",
    "trailing",
    "translate",
    "translate_regex",
    "translation",
    "treat",
    "trigger",
    "trim",
    "trim_array",
    "true",
    "truncate",
    "uescape",
    "union",
    "unique",
    "unknown",
    "unnest",
    "update",
    "upper",
    "user",
    "using",
    "value",
    "values",
    "value_of",
    "var_pop",
    "var_samp",
    "varbinary",
    "varchar",
    "varying",
    "versioning",
    "when",
    "whenever",
    "where",
    "width_bucket",
    "window",
    "with",
    "within",
    "without",
    "year"
  ], g = [
    "abs",
    "acos",
    "array_agg",
    "asin",
    "atan",
    "avg",
    "cast",
    "ceil",
    "ceiling",
    "coalesce",
    "corr",
    "cos",
    "cosh",
    "count",
    "covar_pop",
    "covar_samp",
    "cume_dist",
    "dense_rank",
    "deref",
    "element",
    "exp",
    "extract",
    "first_value",
    "floor",
    "json_array",
    "json_arrayagg",
    "json_exists",
    "json_object",
    "json_objectagg",
    "json_query",
    "json_table",
    "json_table_primitive",
    "json_value",
    "lag",
    "last_value",
    "lead",
    "listagg",
    "ln",
    "log",
    "log10",
    "lower",
    "max",
    "min",
    "mod",
    "nth_value",
    "ntile",
    "nullif",
    "percent_rank",
    "percentile_cont",
    "percentile_disc",
    "position",
    "position_regex",
    "power",
    "rank",
    "regr_avgx",
    "regr_avgy",
    "regr_count",
    "regr_intercept",
    "regr_r2",
    "regr_slope",
    "regr_sxx",
    "regr_sxy",
    "regr_syy",
    "row_number",
    "sin",
    "sinh",
    "sqrt",
    "stddev_pop",
    "stddev_samp",
    "substring",
    "substring_regex",
    "sum",
    "tan",
    "tanh",
    "translate",
    "translate_regex",
    "treat",
    "trim",
    "trim_array",
    "unnest",
    "upper",
    "value_of",
    "var_pop",
    "var_samp",
    "width_bucket"
  ], m = [
    "current_catalog",
    "current_date",
    "current_default_transform_group",
    "current_path",
    "current_role",
    "current_schema",
    "current_transform_group_for_type",
    "current_user",
    "session_user",
    "system_time",
    "system_user",
    "current_time",
    "localtime",
    "current_timestamp",
    "localtimestamp"
  ], y = [
    "create table",
    "insert into",
    "primary key",
    "foreign key",
    "not null",
    "alter table",
    "add constraint",
    "grouping sets",
    "on overflow",
    "character set",
    "respect nulls",
    "ignore nulls",
    "nulls first",
    "nulls last",
    "depth first",
    "breadth first"
  ], w = g, C = [
    ...h,
    ...d
  ].filter((a) => !g.includes(a)), E = {
    className: "variable",
    begin: /@[a-z0-9]+/
  }, R = {
    className: "operator",
    begin: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
    relevance: 0
  }, M = {
    begin: t.concat(/\b/, t.either(...w), /\s*\(/),
    relevance: 0,
    keywords: { built_in: w }
  };
  function P(a, {
    exceptions: o,
    when: s
  } = {}) {
    const p = s;
    return o = o || [], a.map((O) => O.match(/\|\d+$/) || o.includes(O) ? O : p(O) ? `${O}|0` : O);
  }
  return {
    name: "SQL",
    case_insensitive: !0,
    // does not include {} or HTML tags `</`
    illegal: /[{}]|<\//,
    keywords: {
      $pattern: /\b[\w\.]+/,
      keyword: P(C, { when: (a) => a.length < 3 }),
      literal: i,
      type: f,
      built_in: m
    },
    contains: [
      {
        begin: t.either(...y),
        relevance: 0,
        keywords: {
          $pattern: /[\w\.]+/,
          keyword: C.concat(y),
          literal: i,
          type: f
        }
      },
      {
        className: "type",
        begin: t.either(...c)
      },
      M,
      E,
      r,
      l,
      e.C_NUMBER_MODE,
      e.C_BLOCK_COMMENT_MODE,
      n,
      R
    ]
  };
}
function z2e(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function lo(e) {
  return Nt("(?=", e, ")");
}
function Nt(...e) {
  return e.map((n) => z2e(n)).join("");
}
function uCe(e) {
  const t = e[e.length - 1];
  return typeof t == "object" && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
}
function dn(...e) {
  return "(" + (uCe(e).capture ? "" : "?:") + e.map((r) => z2e(r)).join("|") + ")";
}
const wy = (e) => Nt(
  /\b/,
  e,
  /\w$/.test(e) ? /\b/ : /\B/
), fCe = [
  "Protocol",
  // contextual
  "Type"
  // contextual
].map(wy), fq = [
  "init",
  "self"
].map(wy), dCe = [
  "Any",
  "Self"
], tu = [
  // strings below will be fed into the regular `keywords` engine while regex
  // will result in additional modes being created to scan for those keywords to
  // avoid conflicts with other rules
  "actor",
  "associatedtype",
  "async",
  "await",
  /as\?/,
  // operator
  /as!/,
  // operator
  "as",
  // operator
  "break",
  "case",
  "catch",
  "class",
  "continue",
  "convenience",
  // contextual
  "default",
  "defer",
  "deinit",
  "didSet",
  // contextual
  "do",
  "dynamic",
  // contextual
  "else",
  "enum",
  "extension",
  "fallthrough",
  /fileprivate\(set\)/,
  "fileprivate",
  "final",
  // contextual
  "for",
  "func",
  "get",
  // contextual
  "guard",
  "if",
  "import",
  "indirect",
  // contextual
  "infix",
  // contextual
  /init\?/,
  /init!/,
  "inout",
  /internal\(set\)/,
  "internal",
  "in",
  "is",
  // operator
  "isolated",
  // contextual
  "nonisolated",
  // contextual
  "lazy",
  // contextual
  "let",
  "mutating",
  // contextual
  "nonmutating",
  // contextual
  /open\(set\)/,
  // contextual
  "open",
  // contextual
  "operator",
  "optional",
  // contextual
  "override",
  // contextual
  "postfix",
  // contextual
  "precedencegroup",
  "prefix",
  // contextual
  /private\(set\)/,
  "private",
  "protocol",
  /public\(set\)/,
  "public",
  "repeat",
  "required",
  // contextual
  "rethrows",
  "return",
  "set",
  // contextual
  "some",
  // contextual
  "static",
  "struct",
  "subscript",
  "super",
  "switch",
  "throws",
  "throw",
  /try\?/,
  // operator
  /try!/,
  // operator
  "try",
  // operator
  "typealias",
  /unowned\(safe\)/,
  // contextual
  /unowned\(unsafe\)/,
  // contextual
  "unowned",
  // contextual
  "var",
  "weak",
  // contextual
  "where",
  "while",
  "willSet"
  // contextual
], dq = [
  "false",
  "nil",
  "true"
], pCe = [
  "assignment",
  "associativity",
  "higherThan",
  "left",
  "lowerThan",
  "none",
  "right"
], gCe = [
  "#colorLiteral",
  "#column",
  "#dsohandle",
  "#else",
  "#elseif",
  "#endif",
  "#error",
  "#file",
  "#fileID",
  "#fileLiteral",
  "#filePath",
  "#function",
  "#if",
  "#imageLiteral",
  "#keyPath",
  "#line",
  "#selector",
  "#sourceLocation",
  "#warn_unqualified_access",
  "#warning"
], pq = [
  "abs",
  "all",
  "any",
  "assert",
  "assertionFailure",
  "debugPrint",
  "dump",
  "fatalError",
  "getVaList",
  "isKnownUniquelyReferenced",
  "max",
  "min",
  "numericCast",
  "pointwiseMax",
  "pointwiseMin",
  "precondition",
  "preconditionFailure",
  "print",
  "readLine",
  "repeatElement",
  "sequence",
  "stride",
  "swap",
  "swift_unboxFromSwiftValueWithType",
  "transcode",
  "type",
  "unsafeBitCast",
  "unsafeDowncast",
  "withExtendedLifetime",
  "withUnsafeMutablePointer",
  "withUnsafePointer",
  "withVaList",
  "withoutActuallyEscaping",
  "zip"
], F2e = dn(
  /[/=\-+!*%<>&|^~?]/,
  /[\u00A1-\u00A7]/,
  /[\u00A9\u00AB]/,
  /[\u00AC\u00AE]/,
  /[\u00B0\u00B1]/,
  /[\u00B6\u00BB\u00BF\u00D7\u00F7]/,
  /[\u2016-\u2017]/,
  /[\u2020-\u2027]/,
  /[\u2030-\u203E]/,
  /[\u2041-\u2053]/,
  /[\u2055-\u205E]/,
  /[\u2190-\u23FF]/,
  /[\u2500-\u2775]/,
  /[\u2794-\u2BFF]/,
  /[\u2E00-\u2E7F]/,
  /[\u3001-\u3003]/,
  /[\u3008-\u3020]/,
  /[\u3030]/
), V2e = dn(
  F2e,
  /[\u0300-\u036F]/,
  /[\u1DC0-\u1DFF]/,
  /[\u20D0-\u20FF]/,
  /[\uFE00-\uFE0F]/,
  /[\uFE20-\uFE2F]/
  // TODO: The following characters are also allowed, but the regex isn't supported yet.
  // /[\u{E0100}-\u{E01EF}]/u
), nu = Nt(F2e, V2e, "*"), q2e = dn(
  /[a-zA-Z_]/,
  /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/,
  /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
  /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/,
  /[\u1E00-\u1FFF]/,
  /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/,
  /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/,
  /[\u2C00-\u2DFF\u2E80-\u2FFF]/,
  /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/,
  /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/,
  /[\uFE47-\uFEFE\uFF00-\uFFFD]/
  // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
  // The following characters are also allowed, but the regexes aren't supported yet.
  // /[\u{10000}-\u{1FFFD}\u{20000-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}]/u,
  // /[\u{50000}-\u{5FFFD}\u{60000-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}]/u,
  // /[\u{90000}-\u{9FFFD}\u{A0000-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}]/u,
  // /[\u{D0000}-\u{DFFFD}\u{E0000-\u{EFFFD}]/u
), Ho = dn(
  q2e,
  /\d/,
  /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/
), Ar = Nt(q2e, Ho, "*"), ru = Nt(/[A-Z]/, Ho, "*"), hCe = [
  "autoclosure",
  Nt(/convention\(/, dn("swift", "block", "c"), /\)/),
  "discardableResult",
  "dynamicCallable",
  "dynamicMemberLookup",
  "escaping",
  "frozen",
  "GKInspectable",
  "IBAction",
  "IBDesignable",
  "IBInspectable",
  "IBOutlet",
  "IBSegueAction",
  "inlinable",
  "main",
  "nonobjc",
  "NSApplicationMain",
  "NSCopying",
  "NSManaged",
  Nt(/objc\(/, Ar, /\)/),
  "objc",
  "objcMembers",
  "propertyWrapper",
  "requires_stored_property_inits",
  "resultBuilder",
  "testable",
  "UIApplicationMain",
  "unknown",
  "usableFromInline"
], mCe = [
  "iOS",
  "iOSApplicationExtension",
  "macOS",
  "macOSApplicationExtension",
  "macCatalyst",
  "macCatalystApplicationExtension",
  "watchOS",
  "watchOSApplicationExtension",
  "tvOS",
  "tvOSApplicationExtension",
  "swift"
];
function vCe(e) {
  const t = {
    match: /\s+/,
    relevance: 0
  }, n = e.COMMENT(
    "/\\*",
    "\\*/",
    { contains: ["self"] }
  ), r = [
    e.C_LINE_COMMENT_MODE,
    n
  ], l = {
    match: [
      /\./,
      dn(...fCe, ...fq)
    ],
    className: { 2: "keyword" }
  }, i = {
    // Consume .keyword to prevent highlighting properties and methods as keywords.
    match: Nt(/\./, dn(...tu)),
    relevance: 0
  }, c = tu.filter((Le) => typeof Le == "string").concat(["_|0"]), f = tu.filter((Le) => typeof Le != "string").concat(dCe).map(wy), d = { variants: [
    {
      className: "keyword",
      match: dn(...f, ...fq)
    }
  ] }, h = {
    $pattern: dn(
      /\b\w+/,
      // regular keywords
      /#\w+/
      // number keywords
    ),
    keyword: c.concat(gCe),
    literal: dq
  }, g = [
    l,
    i,
    d
  ], m = {
    // Consume .built_in to prevent highlighting properties and methods.
    match: Nt(/\./, dn(...pq)),
    relevance: 0
  }, y = {
    className: "built_in",
    match: Nt(/\b/, dn(...pq), /(?=\()/)
  }, w = [
    m,
    y
  ], C = {
    // Prevent -> from being highlighting as an operator.
    match: /->/,
    relevance: 0
  }, E = {
    className: "operator",
    relevance: 0,
    variants: [
      { match: nu },
      {
        // dot-operator: only operators that start with a dot are allowed to use dots as
        // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
        // characters that may also include dots.
        match: `\\.(\\.|${V2e})+`
      }
    ]
  }, R = [
    C,
    E
  ], M = "([0-9]_*)+", P = "([0-9a-fA-F]_*)+", a = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal floating-point-literal (subsumes decimal-literal)
      { match: `\\b(${M})(\\.(${M}))?([eE][+-]?(${M}))?\\b` },
      // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
      { match: `\\b0x(${P})(\\.(${P}))?([pP][+-]?(${M}))?\\b` },
      // octal-literal
      { match: /\b0o([0-7]_*)+\b/ },
      // binary-literal
      { match: /\b0b([01]_*)+\b/ }
    ]
  }, o = (Le = "") => ({
    className: "subst",
    variants: [
      { match: Nt(/\\/, Le, /[0\\tnr"']/) },
      { match: Nt(/\\/, Le, /u\{[0-9a-fA-F]{1,8}\}/) }
    ]
  }), s = (Le = "") => ({
    className: "subst",
    match: Nt(/\\/, Le, /[\t ]*(?:[\r\n]|\r\n)/)
  }), p = (Le = "") => ({
    className: "subst",
    label: "interpol",
    begin: Nt(/\\/, Le, /\(/),
    end: /\)/
  }), O = (Le = "") => ({
    begin: Nt(Le, /"""/),
    end: Nt(/"""/, Le),
    contains: [
      o(Le),
      s(Le),
      p(Le)
    ]
  }), x = (Le = "") => ({
    begin: Nt(Le, /"/),
    end: Nt(/"/, Le),
    contains: [
      o(Le),
      p(Le)
    ]
  }), N = {
    className: "string",
    variants: [
      O(),
      O("#"),
      O("##"),
      O("###"),
      x(),
      x("#"),
      x("##"),
      x("###")
    ]
  }, T = { match: Nt(/`/, Ar, /`/) }, $ = {
    className: "variable",
    match: /\$\d+/
  }, j = {
    className: "variable",
    match: `\\$${Ho}+`
  }, A = [
    T,
    $,
    j
  ], Z = {
    match: /(@|#(un)?)available/,
    className: "keyword",
    starts: { contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: mCe,
        contains: [
          ...R,
          a,
          N
        ]
      }
    ] }
  }, G = {
    className: "keyword",
    match: Nt(/@/, dn(...hCe))
  }, I = {
    className: "meta",
    match: Nt(/@/, Ar)
  }, F = [
    Z,
    G,
    I
  ], U = {
    match: lo(/\b[A-Z]/),
    relevance: 0,
    contains: [
      {
        // Common Apple frameworks, for relevance boost
        className: "type",
        match: Nt(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, Ho, "+")
      },
      {
        // Type identifier
        className: "type",
        match: ru,
        relevance: 0
      },
      {
        // Optional type
        match: /[?!]+/,
        relevance: 0
      },
      {
        // Variadic parameter
        match: /\.\.\./,
        relevance: 0
      },
      {
        // Protocol composition
        match: Nt(/\s+&\s+/, lo(ru)),
        relevance: 0
      }
    ]
  }, B = {
    begin: /</,
    end: />/,
    keywords: h,
    contains: [
      ...r,
      ...g,
      ...F,
      C,
      U
    ]
  };
  U.contains.push(B);
  const L = {
    match: Nt(Ar, /\s*:/),
    keywords: "_|0",
    relevance: 0
  }, q = {
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: h,
    contains: [
      "self",
      L,
      ...r,
      ...g,
      ...w,
      ...R,
      a,
      N,
      ...A,
      ...F,
      U
    ]
  }, D = {
    begin: /</,
    end: />/,
    contains: [
      ...r,
      U
    ]
  }, _ = {
    begin: dn(
      lo(Nt(Ar, /\s*:/)),
      lo(Nt(Ar, /\s+/, Ar, /\s*:/))
    ),
    end: /:/,
    relevance: 0,
    contains: [
      {
        className: "keyword",
        match: /\b_\b/
      },
      {
        className: "params",
        match: Ar
      }
    ]
  }, re = {
    begin: /\(/,
    end: /\)/,
    keywords: h,
    contains: [
      _,
      ...r,
      ...g,
      ...R,
      a,
      N,
      ...F,
      U,
      q
    ],
    endsParent: !0,
    illegal: /["']/
  }, ue = {
    match: [
      /func/,
      /\s+/,
      dn(T.match, Ar, nu)
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      D,
      re,
      t
    ],
    illegal: [
      /\[/,
      /%/
    ]
  }, se = {
    match: [
      /\b(?:subscript|init[?!]?)/,
      /\s*(?=[<(])/
    ],
    className: { 1: "keyword" },
    contains: [
      D,
      re,
      t
    ],
    illegal: /\[|%/
  }, Re = {
    match: [
      /operator/,
      /\s+/,
      nu
    ],
    className: {
      1: "keyword",
      3: "title"
    }
  }, ft = {
    begin: [
      /precedencegroup/,
      /\s+/,
      ru
    ],
    className: {
      1: "keyword",
      3: "title"
    },
    contains: [U],
    keywords: [
      ...pCe,
      ...dq
    ],
    end: /}/
  };
  for (const Le of N.variants) {
    const Lt = Le.contains.find((Zt) => Zt.label === "interpol");
    Lt.keywords = h;
    const de = [
      ...g,
      ...w,
      ...R,
      a,
      N,
      ...A
    ];
    Lt.contains = [
      ...de,
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          "self",
          ...de
        ]
      }
    ];
  }
  return {
    name: "Swift",
    keywords: h,
    contains: [
      ...r,
      ue,
      se,
      {
        beginKeywords: "struct protocol class extension enum actor",
        end: "\\{",
        excludeEnd: !0,
        keywords: h,
        contains: [
          e.inherit(e.TITLE_MODE, {
            className: "title.class",
            begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
          }),
          ...g
        ]
      },
      Re,
      ft,
      {
        beginKeywords: "import",
        end: /$/,
        contains: [...r],
        relevance: 0
      },
      ...g,
      ...w,
      ...R,
      a,
      N,
      ...A,
      ...F,
      U,
      q
    ]
  };
}
const Do = "[A-Za-z$_][0-9A-Za-z$_]*", U2e = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends"
], W2e = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], G2e = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], K2e = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], Y2e = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], X2e = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "module",
  "global"
  // Node.js
], Q2e = [].concat(
  Y2e,
  G2e,
  K2e
);
function bCe(e) {
  const t = e.regex, n = (F, { after: U }) => {
    const B = "</" + F[0].slice(1);
    return F.input.indexOf(B, U) !== -1;
  }, r = Do, l = {
    begin: "<>",
    end: "</>"
  }, i = /<[A-Za-z0-9\\._:-]+\s*\/>/, c = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (F, U) => {
      const B = F[0].length + F.index, L = F.input[B];
      if (
        // HTML should not include another raw `<` inside a tag
        // nested type?
        // `<Array<Array<number>>`, etc.
        L === "<" || // the , gives away that this is not HTML
        // `<T, A extends keyof T, V>`
        L === ","
      ) {
        U.ignoreMatch();
        return;
      }
      L === ">" && (n(F, { after: B }) || U.ignoreMatch());
      let q;
      if ((q = F.input.substr(B).match(/^\s+extends\s+/)) && q.index === 0) {
        U.ignoreMatch();
        return;
      }
    }
  }, f = {
    $pattern: Do,
    keyword: U2e,
    literal: W2e,
    built_in: Q2e,
    "variable.language": X2e
  }, d = "[0-9](_?[0-9])*", h = `\\.(${d})`, g = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", m = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${g})((${h})|\\.)?|(${h}))[eE][+-]?(${d})\\b` },
      { begin: `\\b(${g})\\b((${h})\\b|\\.)?|(${h})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, y = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: f,
    contains: []
    // defined later
  }, w = {
    begin: "html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        e.BACKSLASH_ESCAPE,
        y
      ],
      subLanguage: "xml"
    }
  }, C = {
    begin: "css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        e.BACKSLASH_ESCAPE,
        y
      ],
      subLanguage: "css"
    }
  }, E = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      e.BACKSLASH_ESCAPE,
      y
    ]
  }, M = {
    className: "comment",
    variants: [
      e.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              begin: "(?=@[A-Za-z]+)",
              relevance: 0,
              contains: [
                {
                  className: "doctag",
                  begin: "@[A-Za-z]+"
                },
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: r + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      e.C_BLOCK_COMMENT_MODE,
      e.C_LINE_COMMENT_MODE
    ]
  }, P = [
    e.APOS_STRING_MODE,
    e.QUOTE_STRING_MODE,
    w,
    C,
    E,
    m
    // This is intentional:
    // See https://github.com/highlightjs/highlight.js/issues/3288
    // hljs.REGEXP_MODE
  ];
  y.contains = P.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: f,
    contains: [
      "self"
    ].concat(P)
  });
  const a = [].concat(M, y.contains), o = a.concat([
    // eat recursive parens in sub expressions
    {
      begin: /\(/,
      end: /\)/,
      keywords: f,
      contains: ["self"].concat(a)
    }
  ]), s = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: f,
    contains: o
  }, p = {
    variants: [
      // class Car extends vehicle
      {
        match: [
          /class/,
          /\s+/,
          r,
          /\s+/,
          /extends/,
          /\s+/,
          t.concat(r, "(", t.concat(/\./, r), ")*")
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          5: "keyword",
          7: "title.class.inherited"
        }
      },
      // class Car
      {
        match: [
          /class/,
          /\s+/,
          r
        ],
        scope: {
          1: "keyword",
          3: "title.class"
        }
      }
    ]
  }, O = {
    relevance: 0,
    match: t.either(
      // Hard coded exceptions
      /\bJSON/,
      // Float32Array, OutT
      /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
      // CSSFactory, CSSFactoryT
      /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
      // FPs, FPsT
      /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
      // P
      // single letters are not highlighted
      // BLAH
      // this will be flagged as a UPPER_CASE_CONSTANT instead
    ),
    className: "title.class",
    keywords: {
      _: [
        // se we still get relevance credit for JS library classes
        ...G2e,
        ...K2e
      ]
    }
  }, x = {
    label: "use_strict",
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use (strict|asm)['"]/
  }, N = {
    variants: [
      {
        match: [
          /function/,
          /\s+/,
          r,
          /(?=\s*\()/
        ]
      },
      // anonymous function
      {
        match: [
          /function/,
          /\s*(?=\()/
        ]
      }
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    label: "func.def",
    contains: [s],
    illegal: /%/
  }, T = {
    relevance: 0,
    match: /\b[A-Z][A-Z_0-9]+\b/,
    className: "variable.constant"
  };
  function $(F) {
    return t.concat("(?!", F.join("|"), ")");
  }
  const j = {
    match: t.concat(
      /\b/,
      $([
        ...Y2e,
        "super"
      ]),
      r,
      t.lookahead(/\(/)
    ),
    className: "title.function",
    relevance: 0
  }, A = {
    begin: t.concat(/\./, t.lookahead(
      t.concat(r, /(?![0-9A-Za-z$_(])/)
    )),
    end: r,
    excludeBegin: !0,
    keywords: "prototype",
    className: "property",
    relevance: 0
  }, Z = {
    match: [
      /get|set/,
      /\s+/,
      r,
      /(?=\()/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        // eat to avoid empty params
        begin: /\(\)/
      },
      s
    ]
  }, G = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>", I = {
    match: [
      /const|var|let/,
      /\s+/,
      r,
      /\s*/,
      /=\s*/,
      /(async\s*)?/,
      // async is optional
      t.lookahead(G)
    ],
    keywords: "async",
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      s
    ]
  };
  return {
    name: "Javascript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: f,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: o, CLASS_REFERENCE: O },
    illegal: /#(?![$_A-z])/,
    contains: [
      e.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      x,
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      w,
      C,
      E,
      M,
      m,
      O,
      {
        className: "attr",
        begin: r + t.lookahead(":"),
        relevance: 0
      },
      I,
      {
        // "value" container
        begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [
          M,
          e.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: G,
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: f,
                    contains: o
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            match: /\s+/,
            relevance: 0
          },
          {
            // JSX
            variants: [
              { begin: l.begin, end: l.end },
              { match: i },
              {
                begin: c.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": c.isTrulyOpeningTag,
                end: c.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: c.begin,
                end: c.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ]
      },
      N,
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: "\\b(?!function)" + e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        label: "func.def",
        contains: [
          s,
          e.inherit(e.TITLE_MODE, { begin: r, className: "title.function" })
        ]
      },
      // catch ... so it won't trigger the property rule below
      {
        match: /\.\.\./,
        relevance: 0
      },
      A,
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        match: "\\$" + r,
        relevance: 0
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [s]
      },
      j,
      T,
      p,
      Z,
      {
        match: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
function yCe(e) {
  const t = bCe(e), n = Do, r = [
    "any",
    "void",
    "number",
    "boolean",
    "string",
    "object",
    "never",
    "symbol",
    "bigint",
    "unknown"
  ], l = {
    beginKeywords: "namespace",
    end: /\{/,
    excludeEnd: !0,
    contains: [t.exports.CLASS_REFERENCE]
  }, i = {
    beginKeywords: "interface",
    end: /\{/,
    excludeEnd: !0,
    keywords: {
      keyword: "interface extends",
      built_in: r
    },
    contains: [t.exports.CLASS_REFERENCE]
  }, c = {
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use strict['"]/
  }, f = [
    "type",
    "namespace",
    "interface",
    "public",
    "private",
    "protected",
    "implements",
    "declare",
    "abstract",
    "readonly",
    "enum",
    "override"
  ], d = {
    $pattern: Do,
    keyword: U2e.concat(f),
    literal: W2e,
    built_in: Q2e.concat(r),
    "variable.language": X2e
  }, h = {
    className: "meta",
    begin: "@" + n
  }, g = (y, w, C) => {
    const E = y.contains.findIndex((R) => R.label === w);
    if (E === -1)
      throw new Error("can not find mode to replace");
    y.contains.splice(E, 1, C);
  };
  Object.assign(t.keywords, d), t.exports.PARAMS_CONTAINS.push(h), t.contains = t.contains.concat([
    h,
    l,
    i
  ]), g(t, "shebang", e.SHEBANG()), g(t, "use_strict", c);
  const m = t.contains.find((y) => y.label === "func.def");
  return m.relevance = 0, Object.assign(t, {
    name: "TypeScript",
    aliases: [
      "ts",
      "tsx"
    ]
  }), t;
}
function wCe(e) {
  const t = e.regex, n = t.concat(/[A-Z_]/, t.optional(/[A-Z0-9_.-]*:/), /[A-Z0-9_.-]*/), r = /[A-Za-z0-9._:-]+/, l = {
    className: "symbol",
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  }, i = {
    begin: /\s/,
    contains: [
      {
        className: "keyword",
        begin: /#?[a-z_][a-z1-9_-]+/,
        illegal: /\n/
      }
    ]
  }, c = e.inherit(i, {
    begin: /\(/,
    end: /\)/
  }), f = e.inherit(e.APOS_STRING_MODE, { className: "string" }), d = e.inherit(e.QUOTE_STRING_MODE, { className: "string" }), h = {
    endsWithParent: !0,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: "attr",
        begin: r,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: "string",
            endsParent: !0,
            variants: [
              {
                begin: /"/,
                end: /"/,
                contains: [l]
              },
              {
                begin: /'/,
                end: /'/,
                contains: [l]
              },
              { begin: /[^\s"'=<>`]+/ }
            ]
          }
        ]
      }
    ]
  };
  return {
    name: "HTML, XML",
    aliases: [
      "html",
      "xhtml",
      "rss",
      "atom",
      "xjb",
      "xsd",
      "xsl",
      "plist",
      "wsf",
      "svg"
    ],
    case_insensitive: !0,
    contains: [
      {
        className: "meta",
        begin: /<![a-z]/,
        end: />/,
        relevance: 10,
        contains: [
          i,
          d,
          f,
          c,
          {
            begin: /\[/,
            end: /\]/,
            contains: [
              {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                contains: [
                  i,
                  c,
                  d,
                  f
                ]
              }
            ]
          }
        ]
      },
      e.COMMENT(
        /<!--/,
        /-->/,
        { relevance: 10 }
      ),
      {
        begin: /<!\[CDATA\[/,
        end: /\]\]>/,
        relevance: 10
      },
      l,
      // xml processing instructions
      {
        className: "meta",
        end: /\?>/,
        variants: [
          {
            begin: /<\?xml/,
            relevance: 10,
            contains: [
              d
            ]
          },
          {
            begin: /<\?[a-z][a-z0-9]+/
          }
        ]
      },
      {
        className: "tag",
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */
        begin: /<style(?=\s|>)/,
        end: />/,
        keywords: { name: "style" },
        contains: [h],
        starts: {
          end: /<\/style>/,
          returnEnd: !0,
          subLanguage: [
            "css",
            "xml"
          ]
        }
      },
      {
        className: "tag",
        // See the comment in the <style tag about the lookahead pattern
        begin: /<script(?=\s|>)/,
        end: />/,
        keywords: { name: "script" },
        contains: [h],
        starts: {
          end: /<\/script>/,
          returnEnd: !0,
          subLanguage: [
            "javascript",
            "handlebars",
            "xml"
          ]
        }
      },
      // we need this for now for jSX
      {
        className: "tag",
        begin: /<>|<\/>/
      },
      // open tag
      {
        className: "tag",
        begin: t.concat(
          /</,
          t.lookahead(t.concat(
            n,
            // <tag/>
            // <tag>
            // <tag ...
            t.either(/\/>/, />/, /\s/)
          ))
        ),
        end: /\/?>/,
        contains: [
          {
            className: "name",
            begin: n,
            relevance: 0,
            starts: h
          }
        ]
      },
      // close tag
      {
        className: "tag",
        begin: t.concat(
          /<\//,
          t.lookahead(t.concat(
            n,
            />/
          ))
        ),
        contains: [
          {
            className: "name",
            begin: n,
            relevance: 0
          },
          {
            begin: />/,
            relevance: 0,
            endsParent: !0
          }
        ]
      }
    ]
  };
}
function OCe(e) {
  const t = "true false yes no null", n = "[\\w#;/?:@&=+$,.~*'()[\\]]+", r = {
    className: "attr",
    variants: [
      { begin: "\\w[\\w :\\/.-]*:(?=[ 	]|$)" },
      {
        // double quoted keys
        begin: '"\\w[\\w :\\/.-]*":(?=[ 	]|$)'
      },
      {
        // single quoted keys
        begin: "'\\w[\\w :\\/.-]*':(?=[ 	]|$)"
      }
    ]
  }, l = {
    className: "template-variable",
    variants: [
      {
        // jinja templates Ansible
        begin: /\{\{/,
        end: /\}\}/
      },
      {
        // Ruby i18n
        begin: /%\{/,
        end: /\}/
      }
    ]
  }, i = {
    className: "string",
    relevance: 0,
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      },
      { begin: /\S+/ }
    ],
    contains: [
      e.BACKSLASH_ESCAPE,
      l
    ]
  }, c = e.inherit(i, { variants: [
    {
      begin: /'/,
      end: /'/
    },
    {
      begin: /"/,
      end: /"/
    },
    { begin: /[^\s,{}[\]]+/ }
  ] }), f = "[0-9]{4}(-[0-9][0-9]){0,2}", d = "([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?", h = "(\\.[0-9]*)?", g = "([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?", m = {
    className: "number",
    begin: "\\b" + f + d + h + g + "\\b"
  }, y = {
    end: ",",
    endsWithParent: !0,
    excludeEnd: !0,
    keywords: t,
    relevance: 0
  }, w = {
    begin: /\{/,
    end: /\}/,
    contains: [y],
    illegal: "\\n",
    relevance: 0
  }, C = {
    begin: "\\[",
    end: "\\]",
    contains: [y],
    illegal: "\\n",
    relevance: 0
  }, E = [
    r,
    {
      className: "meta",
      begin: "^---\\s*$",
      relevance: 10
    },
    {
      // multi line string
      // Blocks start with a | or > followed by a newline
      //
      // Indentation of subsequent lines must be the same to
      // be considered part of the block
      className: "string",
      begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
    },
    {
      // Ruby/Rails erb
      begin: "<%[%=-]?",
      end: "[%-]?%>",
      subLanguage: "ruby",
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0
    },
    {
      // named tags
      className: "type",
      begin: "!\\w+!" + n
    },
    // https://yaml.org/spec/1.2/spec.html#id2784064
    {
      // verbatim tags
      className: "type",
      begin: "!<" + n + ">"
    },
    {
      // primary tags
      className: "type",
      begin: "!" + n
    },
    {
      // secondary tags
      className: "type",
      begin: "!!" + n
    },
    {
      // fragment id &ref
      className: "meta",
      begin: "&" + e.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // fragment reference *ref
      className: "meta",
      begin: "\\*" + e.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // array listing
      className: "bullet",
      // TODO: remove |$ hack when we have proper look-ahead support
      begin: "-(?=[ ]|$)",
      relevance: 0
    },
    e.HASH_COMMENT_MODE,
    {
      beginKeywords: t,
      keywords: { literal: t }
    },
    m,
    // numbers are any valid C-style number that
    // sit isolated from other words
    {
      className: "number",
      begin: e.C_NUMBER_RE + "\\b",
      relevance: 0
    },
    w,
    C,
    i
  ], R = [...E];
  return R.pop(), R.push(c), y.contains = R, {
    name: "YAML",
    case_insensitive: !0,
    aliases: ["yml"],
    contains: E
  };
}
var xCe = ige, ECe = zse, $Ce = 1, jCe = 2;
function CCe(e, t, n, r) {
  var l = n.length, i = l, c = !r;
  if (e == null)
    return !i;
  for (e = Object(e); l--; ) {
    var f = n[l];
    if (c && f[2] ? f[1] !== e[f[0]] : !(f[0] in e))
      return !1;
  }
  for (; ++l < i; ) {
    f = n[l];
    var d = f[0], h = e[d], g = f[1];
    if (c && f[2]) {
      if (h === void 0 && !(d in e))
        return !1;
    } else {
      var m = new xCe();
      if (r)
        var y = r(h, g, d, e, t, m);
      if (!(y === void 0 ? ECe(g, h, $Ce | jCe, r, m) : y))
        return !1;
    }
  }
  return !0;
}
var MCe = CCe, kCe = oge;
function PCe(e) {
  return e === e && !kCe(e);
}
var J2e = PCe, SCe = J2e, NCe = Fse;
function RCe(e) {
  for (var t = NCe(e), n = t.length; n--; ) {
    var r = t[n], l = e[r];
    t[n] = [r, l, SCe(l)];
  }
  return t;
}
var _Ce = RCe;
function ACe(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var e5e = ACe, LCe = MCe, ZCe = _Ce, TCe = e5e;
function BCe(e) {
  var t = ZCe(e);
  return t.length == 1 && t[0][2] ? TCe(t[0][0], t[0][1]) : function(n) {
    return n === e || LCe(n, e, t);
  };
}
var ICe = BCe, HCe = Vse;
function DCe(e, t, n) {
  var r = e == null ? void 0 : HCe(e, t);
  return r === void 0 ? n : r;
}
var zCe = DCe, FCe = zse, VCe = zCe, qCe = sge, UCe = qse, WCe = J2e, GCe = e5e, KCe = Use, YCe = 1, XCe = 2;
function QCe(e, t) {
  return UCe(e) && WCe(t) ? GCe(KCe(e), t) : function(n) {
    var r = VCe(n, e);
    return r === void 0 && r === t ? qCe(n, e) : FCe(t, r, YCe | XCe);
  };
}
var JCe = QCe;
function eMe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var tMe = eMe, nMe = Vse;
function rMe(e) {
  return function(t) {
    return nMe(t, e);
  };
}
var aMe = rMe, lMe = tMe, iMe = aMe, oMe = qse, sMe = Use;
function cMe(e) {
  return oMe(e) ? lMe(sMe(e)) : iMe(e);
}
var uMe = cMe, fMe = ICe, dMe = JCe, pMe = cge, gMe = Wse, hMe = uMe;
function mMe(e) {
  return typeof e == "function" ? e : e == null ? pMe : typeof e == "object" ? gMe(e) ? dMe(e[0], e[1]) : fMe(e) : hMe(e);
}
var vMe = mMe;
function bMe(e) {
  return function(t, n, r) {
    for (var l = -1, i = Object(t), c = r(t), f = c.length; f--; ) {
      var d = c[e ? f : ++l];
      if (n(i[d], d, i) === !1)
        break;
    }
    return t;
  };
}
var yMe = bMe, wMe = yMe, OMe = wMe(), xMe = OMe, EMe = xMe, $Me = Fse;
function jMe(e, t) {
  return e && EMe(e, t, $Me);
}
var CMe = jMe, MMe = Gse;
function kMe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!MMe(n))
      return e(n, r);
    for (var l = n.length, i = t ? l : -1, c = Object(n); (t ? i-- : ++i < l) && r(c[i], i, c) !== !1; )
      ;
    return n;
  };
}
var PMe = kMe, SMe = CMe, NMe = PMe, RMe = NMe(SMe), _Me = RMe, AMe = _Me, LMe = Gse;
function ZMe(e, t) {
  var n = -1, r = LMe(e) ? Array(e.length) : [];
  return AMe(e, function(l, i, c) {
    r[++n] = t(l, i, c);
  }), r;
}
var TMe = ZMe, BMe = uge, IMe = vMe, HMe = TMe, DMe = Wse;
function zMe(e, t) {
  var n = DMe(e) ? BMe : HMe;
  return n(e, IMe(t));
}
var FMe = zMe, VMe = fge, qMe = FMe;
function UMe(e, t) {
  return VMe(qMe(e, t), 1);
}
var WMe = UMe;
const gq = /* @__PURE__ */ ce(WMe);
var GMe = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.literal, r = t.overlap, l = n ? e : ["&"].concat(e);
  function i(c) {
    if (typeof c != "object" || c == null)
      return [];
    if (Array.isArray(c))
      return c.map(i);
    var f = {}, d = {}, h = {};
    return Object.keys(c).forEach(function(g) {
      var m = c[g];
      if (!Array.isArray(m) && n && (m = [m]), (n || Array.isArray(m)) && g.charCodeAt(0) !== 38) {
        var y = void 0;
        m.forEach(function(w, C) {
          if (!(r && y === w) && w != null)
            if (y = w, C === 0 && !n)
              h[g] = w;
            else if (f[l[C]] === void 0) {
              var E;
              f[l[C]] = (E = {}, E[g] = w, E);
            } else
              f[l[C]][g] = w;
        });
      } else
        typeof m == "object" ? d[g] = i(m) : h[g] = m;
    }), l.forEach(function(g) {
      f[g] && (h[g] = f[g]);
    }), Object.assign(h, d), h;
  }
  return function() {
    for (var c = arguments.length, f = Array(c), d = 0; d < c; d++)
      f[d] = arguments[d];
    return f.map(i);
  };
};
function hq(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function l4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hq(Object(n), !0).forEach(function(r) {
      Ot(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hq(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zo(e) {
  return zo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zo(e);
}
function Ot(e, t, n) {
  return (t = function(r) {
    var l = function(i, c) {
      if (typeof i != "object" || i === null)
        return i;
      var f = i[Symbol.toPrimitive];
      if (f !== void 0) {
        var d = f.call(i, c || "default");
        if (typeof d != "object")
          return d;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (c === "string" ? String : Number)(i);
    }(r, "string");
    return typeof l == "symbol" ? l : String(l);
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fa() {
  return fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fa.apply(this, arguments);
}
function Oy(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Be(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function Fo(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || t5e(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Gr(e) {
  return function(t) {
    if (Array.isArray(t))
      return i4(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || t5e(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function t5e(e, t) {
  if (e) {
    if (typeof e == "string")
      return i4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? i4(e, t) : void 0;
  }
}
function i4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var mq, vq, au, bq, yq, lu, KMe = 1500, wq = "Copied!", Oq = "Copy", YMe = (Ot(au = {}, S.Light, v(mq || (mq = Be([`
    color: `, `;
    background-color: `, `;

    &:focus,
    &:hover {
      color: `, `;

      &:before {
        background-color: `, `;
      }
    }
  `])), b.white, b.green.dark1, b.white, b.green.dark1)), Ot(au, S.Dark, v(vq || (vq = Be([`
    color: `, `;
    background-color: `, `;

    &:focus,
    &:hover {
      color: `, `;

      &:before {
        background-color: `, `;
      }
    }
  `])), b.gray.dark3, b.green.base, b.gray.dark3, b.green.base)), au), XMe = (Ot(lu = {}, S.Light, v(bq || (bq = Be([`
    align-self: center;
    color: `, `;
  `])), b.gray.base)), Ot(lu, S.Dark, v(yq || (yq = Be([`
    align-self: center;
    color: `, `;
  `])), b.gray.light1)), lu);
function n5e(e) {
  var t = e.onCopy, n = e.contents, r = Fo(ht(!1), 2), l = r[0], i = r[1], c = Fo(ht(!1), 2), f = c[0], d = c[1], h = Dn(null), g = K().theme, m = pge().portalContainer, y = function() {
    return d(!1);
  };
  return Dse(y, h, f), Tt(function() {
    if (h.current) {
      var w = new Wue(h.current, { text: function() {
        return n;
      }, container: m });
      if (l) {
        var C = setTimeout(function() {
          i(!1);
        }, KMe);
        return function() {
          return clearTimeout(C);
        };
      }
      return function() {
        return w.destroy();
      };
    }
  }, [h, n, l, m]), k.createElement(fd, { "data-testid": "code_copy-button_tooltip", open: f, setOpen: d, align: Zo.Top, justify: xn.Middle, trigger: k.createElement(v1, { "data-testid": "code_copy-button", ref: h, "aria-label": Oq, className: H(XMe[g], Ot({}, YMe[g], l)), onClick: function(w) {
    w.preventDefault(), t == null || t(), i(!0);
  }, onKeyDown: function(w) {
    switch (w.key) {
      case wr.Escape:
      case wr.Tab:
        y();
        break;
      case wr.Enter:
      case wr.Space:
        var C, E;
        w.preventDefault(), (C = h.current) === null || C === void 0 || C.click(), (E = h.current) === null || E === void 0 || E.focus();
    }
  }, onMouseEnter: function() {
    d(!0);
  }, onMouseLeave: function() {
    y();
  } }, l ? k.createElement(iOe, null) : k.createElement(sOe, null), l && k.createElement(Xpe, { role: "alert" }, wq)), shouldClose: function() {
    return !f;
  } }, l ? wq : Oq);
}
n5e.displayName = "CopyButton";
var xq, Eq, $q, jq, iu, Cq, Mq, QMe = ["children"], r5e = k.forwardRef(function(e, t) {
  var n = e.children, r = Oy(e, QMe);
  return k.createElement(ko, fa({}, r, { ref: t }), n);
});
r5e.displayName = "CustomSelectMenuButton";
var kq, Pq, Sq, Nq, ou, Rq, _q, Aq, su, Lq, Zq, Tq, cu, JMe = v(xq || (xq = Be([`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`]))), eke = v(Eq || (Eq = Be([`
  // Override default menuButton styles
  margin-top: 0;
  width: 100%;
  height: 100%;
  border-radius: 0px;
  border: 0;
  font-size: 12px;

  &:hover[aria-disabled='false'],
  &:focus,
  &:active {
    box-shadow: 0 0 0 0;
    border: 0;
  }

  // Override button defaults
  > *:last-child {
    grid-template-columns: 16px 1fr 16px;
    padding: 0 12px;
    > svg {
      width: 16px;
      height: 16px;
    }
  }
`]))), tke = (Ot(iu = {}, S.Light, v($q || ($q = Be([`
    background-color: `, `;
    border-right: 1px solid `, `;
    box-shadow: 0 0 0 0;

    &:hover[aria-disabled='false'],
    &:active,
    &:focus {
      border-right: 1px solid `, `;
    }

    &:hover[aria-disabled='false'] {
      background-color: `, `;
    }

    &:focus-visible {
      background-color: `, `;
    }
  `])), b.white, b.gray.light2, b.gray.light2, b.gray.light2, b.blue.light2)), Ot(iu, S.Dark, v(jq || (jq = Be([`
    background-color: `, `;
    border-right: 1px solid `, `;
    color: `, `;

    &:hover[aria-disabled='false'],
    &:focus,
    &:active {
      border-right: 1px solid `, `;
    }

    &:hover[aria-disabled='false'],
    &:active {
      background-color: `, `;
    }

    &:focus-visible {
      background-color: `, `;
    }
  `])), b.gray.dark2, b.gray.dark1, b.gray.light2, b.gray.dark1, b.gray.dark1, b.blue.light1)), iu), nke = v(Cq || (Cq = Be([`
  min-width: 144px;
  height: 100%;
`]))), Bq = v(Mq || (Mq = Be([`
  margin-right: `, `px;
`])), ee[3]);
function a5e(e) {
  var t, n = e.language, r = e.languageOptions, l = e.onChange, i = e.usePortal, c = e.portalClassName, f = e.portalContainer, d = e.scrollContainer, h = e.popoverZIndex, g = K(), m = g.theme, y = g.darkMode, w = Wu(n), C = H(Bq, v(kq || (kq = Be([`
      color: `, `;
    `])), y ? b.gray.light1 : b.gray.base)), E = k.createElement(Fxe, { className: C });
  n.image != null && (t = n.image, E = Dxe(t) || lr(t, "Icon") ? k.cloneElement(n.image, { className: C }) : k.cloneElement(n.image, { className: Bq }));
  var R = { popoverZIndex: h, usePortal: i, portalClassName: c, portalContainer: f, scrollContainer: d };
  return k.createElement("div", { className: JMe }, k.createElement(a4, fa({ darkMode: y, onChange: function(M) {
    if (M === "" && w !== void 0)
      return l(w);
    var P = r.find(function(a) {
      return a.displayName === M;
    });
    P !== void 0 && l(P);
  }, "aria-labelledby": "Language Picker", value: n == null ? void 0 : n.displayName, className: nke, allowDeselect: !1 }, R, { __INTERNAL__menuButtonSlot__: r5e, __INTERNAL__menuButtonSlotProps__: { className: H(eke, tke[m]), leftGlyph: E } }), r == null ? void 0 : r.map(function(M) {
    return k.createElement(t4, { key: M == null ? void 0 : M.displayName, value: M == null ? void 0 : M.displayName }, M == null ? void 0 : M.displayName);
  })));
}
a5e.displayName = "LanguageSwitcher";
var uu, rke = v(Pq || (Pq = Be([`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: `, `px;

  svg {
    width: 16px;
    height: 16px;
  }
`])), ee[1]), ake = (Ot(ou = {}, S.Light, v(Sq || (Sq = Be([`
    background-color: `, `;
  `])), b.white)), Ot(ou, S.Dark, v(Nq || (Nq = Be([`
    background-color: `, `;
  `])), b.gray.dark2)), ou), Iq = v(Rq || (Rq = Be([`
  flex-direction: column;
  padding: 6px;
  border-left: solid 1px;
`]))), lke = (Ot(su = {}, S.Light, H(Iq, v(_q || (_q = Be([`
      border-color: `, `;
    `])), b.gray.light2))), Ot(su, S.Dark, H(Iq, v(Aq || (Aq = Be([`
      border-color: `, `;
    `])), b.gray.dark2))), su), Hq = v(Lq || (Lq = Be([`
  flex-direction: row;
  border-bottom: 1px solid;
  justify-content: space-between;
  padding: 0;
  padding-right: 8px;
  height: 40px; // 28px (icon) + 2 x 6px (focus shadow). Can't use padding b/c switcher
`]))), ike = (Ot(cu = {}, S.Light, H(Hq, v(Zq || (Zq = Be([`
      border-color: `, `;
    `])), b.gray.light2))), Ot(cu, S.Dark, H(Hq, v(Tq || (Tq = Be([`
      border-color: `, `;
    `])), b.gray.dark1))), cu);
function l5e(e) {
  var t, n = e.language, r = e.languageOptions, l = e.contents, i = e.onChange, c = e.onCopy, f = e.showCopyButton, d = e.customActionButtons, h = e.showCustomActionButtons, g = e.usePortal, m = e.portalClassName, y = e.portalContainer, w = e.scrollContainer, C = e.popoverZIndex, E = e.className, R = K().theme, M = { popoverZIndex: C, usePortal: g, portalClassName: m, portalContainer: y, scrollContainer: w };
  return k.createElement("div", { className: H(rke, ake[R], (t = {}, Ot(t, lke[R], !n), Ot(t, ike[R], !!n), t), E), "data-testid": "leafygreen-code-panel" }, n !== void 0 && r !== void 0 && i !== void 0 && k.createElement(a5e, fa({ onChange: i, language: n, languageOptions: r }, M)), f && k.createElement(n5e, { onCopy: c, contents: l, withLanguageSwitcher: !!n }), h && k.createElement(k.Fragment, null, d == null ? void 0 : d.map(function(P) {
    return P;
  })));
}
l5e.displayName = "Panel";
var pn = (Ot(uu = {}, S.Light, { 0: b.gray.light3, 1: b.gray.light2, 2: b.gray.dark2, 3: b.black, 4: b.white, 5: "#D83713", 6: "#956d00", 7: "#12824D", 8: "#007ab8", 9: "#016ee9", 10: "#CC3887" }), Ot(uu, S.Dark, { 0: b.black, 1: b.gray.dark2, 2: b.gray.light1, 3: b.gray.light3, 4: b.gray.dark2, 5: "#FF6F44", 6: "#EDB210", 7: "#35DE7B", 8: "#a5e3ff", 9: "#2dc4ff", 10: "#FF7DC3" }), uu), oke = function(e) {
  return `
  .lg-highlight-hljs-`.concat(e, ` {
    
    .lg-highlight-keyword,
    .lg-highlight-keyword.lg-highlight-function,
    .lg-highlight-keyword.lg-highlight-class,
    .lg-highlight-selector-tag,
    .lg-highlight-selector-attr,
    .lg-highlight-selector-pseudo,
    .lg-highlight-selector-id,
    .lg-highlight-selector-class {
      color: `).concat(pn[e][10], `;
    }

    .lg-highlight-regexp,
    .lg-highlight-number,
    .lg-highlight-literal,
    .lg-highlight-function.lg-highlight-title {
      color: `).concat(pn[e][9], `;
    }

    .lg-highlight-quote,
    .lg-highlight-section,
    .lg-highlight-name {
      color: `).concat(pn[e][8], `;
    }

    .lg-highlight-string,
    .lg-highlight-addition {
      color: `).concat(pn[e][7], `;
    }

    .lg-highlight-meta,
    .lg-highlight-meta-string {
      color: `).concat(pn[e][6], `;
    }

    .lg-highlight-variable,
    .lg-highlight-deletion,
    .lg-highlight-symbol,
    .lg-highlight-bullet,
    .lg-highlight-meta,
    .lg-highlight-link,
    .lg-highlight-attr,
    .lg-highlight-attribute,
    .lg-highlight-language,
    .lg-highlight-template-variable,
    .lg-highlight-built_in,
    .lg-highlight-type,
    .lg-highlight-params {
      color: `).concat(pn[e][5], `
    }

    .lg-highlight-title,
    .lg-highlight-class.lg-highlight-title {
      color: `).concat(pn[e][3], `;
    }

    .lg-highlight-doctag,
    .lg-highlight-formula {
      color: `).concat(pn[e][3], `;
    }
  
    .lg-highlight-comment {
      color: `).concat(pn[e][2], `;
      font-style: italic;
    }
  
    .lg-highlight-string {
      font-weight: 600;
    }
    
    .lg-highlight-emphasis {
      font-style: italic;
    }
  
    .lg-highlight-strong {
      font-weight: `).concat(Y.bold, `;
    }
  }
`);
}, Dq, zq, Fq, Vq, ske = { javascript: Yje, typescript: yCe, c: Tje, cpp: Bje, csharp: Ije, go: zje, http: Fje, ini: Vje, java: qje, perl: tCe, php: nCe, properties: rCe, python: aCe, ruby: lCe, rust: iCe, scala: oCe, swift: vCe, kotlin: Jje, objectivec: eCe, dart: Hje, bash: Zje, shell: sCe, sql: cCe, yaml: OCe, json: Xje, diff: Dje, xml: wCe }, i5e = { JavaScript: "javascript", JS: "js", TypeScript: "typescript", TS: "ts", C: "c", Cpp: "cpp", Csharp: "csharp", Cs: "cs", Go: "go", Html: "xml", Http: "http", Ini: "ini", Java: "java", Perl: "perl", Php: "php", Properties: "properties", Python: "python", Ruby: "ruby", Rust: "rust", Scala: "scala", Swift: "swift", Kotlin: "kotlin", ObjectiveC: "objectivec", Dart: "dart", Bash: "bash", Shell: "shell", Sql: "sql", Yaml: "yaml", Json: "json", Graphql: "graphql", Diff: "diff", Xml: "xml" }, o5e = z9({ highlightLines: [], darkMode: !1 });
function qq() {
  for (var e = "lg-highlight-", t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.filter(function(l) {
    return Ir(l) && l.length > 0;
  }).map(function(l) {
    return l.startsWith(e) ? l : l.split(".").map(function(i) {
      return "".concat(e).concat(i);
    }).join(" ");
  }).join(" ");
}
function Uq() {
  for (var e = ["function", "class"], t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.filter(function(l) {
    return e.includes(l);
  });
}
function cke(e) {
  var t = e.kind, n = e.children;
  return k.createElement("span", { className: t }, n);
}
function S1(e) {
  return e != null && e instanceof Array;
}
function s5e(e) {
  return e != null && zo(e) === "object" && !(e instanceof Array);
}
function Ir(e) {
  return e != null && typeof e == "string";
}
function o4(e, t) {
  return e == null ? null : Ir(e) ? e : S1(e) ? e.map(o4) : s5e(e) ? k.createElement(cke, { key: t, kind: e.kind }, o4(e.children)) : e;
}
var Wq = v(Dq || (Dq = Be([`
  border-spacing: 0;
  vertical-align: top;
  padding: 0 `, `px;
`])), ee[3]);
function uke(e) {
  var t, n, r;
  return e ? (t = "transparent", n = "linear-gradient(90deg, ".concat(b.gray.dark3, ", ").concat(b.black, ")"), r = b.gray.dark3) : (t = b.yellow.light3, n = "none", r = b.yellow.light2), v(zq || (zq = Be([`
    background-color: `, `;
    background-image: `, `;
    // Fixes an issue in Safari where the gradient applied to the table row would be applied
    // to each cell in the row instead of being continuous across cells.
    background-attachment: fixed;

    // Selects all children of a highlighted row, and adds a border top
    & > td {
      border-top: 1px solid `, `;
    }

    // Selects following rows after a highlighted row, and adds a border top
    // We don't add border bottoms here to support consecutive highlighted rows.
    & + tr > td {
      border-top: 1px solid `, `;
    }

    // Remove borders between consecutive highlighted rows
    & + & > td {
      border-top: 0;
    }

    // If the highlighted row is the last child, then we add a border bottom
    &:last-child > td {
      border-bottom: 1px solid `, `;
    }
  `])), t, n, r, r, r);
}
function fke(e) {
  var t = e.lineNumber, n = e.highlighted, r = e.darkMode, l = e.children, i = r ? b.gray.light1 : b.gray.dark1, c = r ? b.gray.light3 : b.yellow.dark2;
  return k.createElement("tr", { className: H(Ot({}, uke(r), n)) }, t && k.createElement("td", { className: H(Wq, v(Fq || (Fq = Be([`
              user-select: none;
              text-align: right;
              padding-left: `, `px;
              padding-right: 0;
              color: `, `;
            `])), ee[3] - 1, n ? c : i)) }, t), k.createElement("td", { className: Wq }, l));
}
function c5e(e) {
  var t = (e ?? {}).children;
  return !(!S1(t) || t.length !== 1 || !Ir(t[0]));
}
function u5e(e, t) {
  if (typeof e == "string")
    return e;
  if ((n = e) != null && zo(n) === "object" && typeof n.kind == "string" && n.children instanceof Array)
    return u5e(e.children, t);
  var n;
  return gq(e, function r() {
    for (var l = arguments.length, i = new Array(l), c = 0; c < l; c++)
      i[c] = arguments[c];
    return i = i.filter(function(f) {
      return Ir(f) && f.length > 0;
    }), function(f) {
      var d, h;
      return Ir(f) ? i.length > 0 ? { kind: qq.apply(void 0, [t].concat(Gr(i), Gr(Uq(f)))), children: [f] } : f : ((d = f == null || (h = f.children) === null || h === void 0 ? void 0 : h.length) !== null && d !== void 0 ? d : 0) >= 1 ? gq(f.children, r.apply(void 0, [t, f.kind].concat(Gr(i)))) : c5e(f) ? { kind: qq.apply(void 0, [t, f.kind].concat(Gr(i), Gr(Uq.apply(void 0, Gr(f.children))))), children: f.children } : f;
    };
  }(t));
}
function f5e(e) {
  return S1(e) ? e.some(f5e) : Ir(e) ? e.includes(`
`) : !!s5e(e) && (((t = e.children) === null || t === void 0 ? void 0 : t.includes(`
`)) || Ir((n = e.children) === null || n === void 0 ? void 0 : n[0]) && e.children[0].includes(`
`));
  var t, n;
}
function dke(e) {
  var t = [], n = 0;
  t[n] == null && (t[n] = []);
  var r = function() {
    n++, t[n] = [];
  };
  return u5e(e).forEach(function(l) {
    f5e(l) ? Ir(l) ? l.split(`
`).forEach(function(i, c) {
      c > 0 && r(), i && t[n].push(i);
    }) : l.children[0].split(`
`).forEach(function(i, c) {
      c > 0 && r(), t[n].push({ kind: l.kind, children: [i] });
    }) : l && (Ir(l) || c5e(l)) && t[n].push(l);
  }), t;
}
function d5e(e) {
  for (var t = e.lines, n = jl(o5e), r = n.highlightLines, l = n.showLineNumbers, i = n.darkMode, c = n.lineNumberStart, f = Gr(t); ((d = f[0]) === null || d === void 0 ? void 0 : d.length) === 0; ) {
    var d;
    f.shift();
  }
  for (; ((h = f[f.length - 1]) === null || h === void 0 ? void 0 : h.length) === 0; ) {
    var h;
    f.pop();
  }
  return k.createElement(k.Fragment, null, f.map(function(g, m) {
    var y, w = m + (c ?? 1), C = function(R) {
      return r.some(function(M) {
        if ((P = M) != null && typeof P == "number")
          return R === M;
        var P;
        if (S1(M)) {
          var a = Gr(M).sort(function(o, s) {
            return o - s;
          });
          return R >= a[0] && R <= a[1];
        }
        return !1;
      });
    }(w);
    l && (y = w);
    var E = g != null && g.length ? g.map(o4) : k.createElement("div", { className: v(Vq || (Vq = Be([`
              display: inline-block;
            `]))) });
    return k.createElement(fke, { key: w, lineNumber: y, darkMode: i, highlighted: C }, E);
  }));
}
var Gq, Kq, Yq, pke = { "after:highlight": function(e) {
  var t = e._emitter.rootNode;
  e.react = k.createElement(d5e, { lines: dke(t.children) });
} }, N1 = l4(l4({}, i5e), {}, { None: "none" }), gke = ["children", "language", "showLineNumbers", "lineNumberStart", "highlightLines", "className"];
function hke(e) {
  return e !== "cs" && e !== "js" && e !== "ts";
}
var p5e = !1;
function mke() {
  p5e = !0, Object.values(S).forEach(function(t) {
    return Cge(oke(t));
  });
  var e = Object.values(i5e).filter(hke);
  e.forEach(function(t) {
    t === "graphql" ? Lje(hi) : hi.registerLanguage(t, ske[t]);
  }), hi.configure({ languages: e, tabReplace: "  " }), hi.addPlugin(pke);
}
var Xq, Qq, Jq, fu, eU, vke = v(Gq || (Gq = Be([`
  color: inherit;
  font-family: `, `;
`])), Q.code);
function s4(e) {
  var t = e.children, n = e.language, r = e.showLineNumbers, l = r !== void 0 && r, i = e.lineNumberStart, c = e.highlightLines, f = c === void 0 ? [] : c, d = e.className, h = Oy(e, gke);
  p5e || mke();
  var g = kt(function() {
    return n === N1.None ? null : hi.highlight(t, { language: n, ignoreIllegals: !0 });
  }, [n, t]), m = g === null ? k.createElement(d5e, { lines: t.split(`
`).map(function(M) {
    return M ? [M] : [];
  }) }) : g.react, y = K(), w = y.theme, C = y.darkMode, E = cn() === 14 ? V.code1 : V.code2, R = v(Kq || (Kq = Be([`
    font-size: `, `px;
    line-height: `, `px;
  `])), E.fontSize, E.lineHeight);
  return k.createElement(o5e.Provider, { value: { highlightLines: f, showLineNumbers: l, lineNumberStart: i, darkMode: C } }, k.createElement("code", fa({}, h, { className: H("lg-highlight-hljs-".concat(w), vke, R, n, d) }), k.createElement("table", { className: v(Yq || (Yq = Be([`
            border-spacing: 0;
          `]))) }, k.createElement("tbody", null, m))));
}
s4.displayName = "Syntax", s4.propTypes = { children: z.string.isRequired, language: z.oneOf(Object.values(N1)), className: z.string, darkMode: z.bool, showLineNumbers: z.bool, lineNumberStart: z.number, highlightLines: z.arrayOf(z.oneOfType([z.arrayOf(z.number), z.number])) };
var bke = v(Xq || (Xq = Be([`
  display: flex;
  align-items: center;
  justify-content: center;
  height: `, `px;
  padding-left: `, `px;
  padding-right: `, `px;
  border-radius: `, "px ", `px 0 0;
  font-family: `, `;
`])), 28, 12, 12, 4, 4, Q.default), yke = (Ot(fu = {}, S.Light, v(Qq || (Qq = Be([`
    color: `, `;
    background-color: `, `;
  `])), b.gray.dark2, pn.light[1])), Ot(fu, S.Dark, v(Jq || (Jq = Be([`
    color: `, `;
    background-color: `, `;
  `])), b.gray.light1, pn.dark[1])), fu), wke = v(eU || (eU = Be([`
  padding-left: `, `px;
  padding-right: `, `px;
  font-size: `, `px;
`])), 8, 8, V.body1.fontSize);
function c4(e) {
  var t = e.chromeTitle, n = t === void 0 ? "" : t, r = K().theme;
  return k.createElement("div", { className: H(bke, yke[r]) }, k.createElement("div", { className: wke }, n));
}
c4.displayName = "WindowChrome", c4.propTypes = { darkMode: z.bool, chromeTitle: z.string };
var tU, nU, du, rU, aU, lU, iU, oU, sU, cU, uU, fU, dU, pU, gU, hU, mU, Or = { None: "none", Left: "left", Right: "right", Both: "both" }, Oke = GMe(["@media only screen and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 2)", "@media only screen and (min-device-width: 813px) and (-webkit-min-device-pixel-ratio: 2)"]), xke = (Ot(du = {}, S.Light, v(tU || (tU = Be([`
    border: 1px solid `, `;
    border-radius: 12px;
    overflow: hidden;
  `])), pn[S.Light][1])), Ot(du, S.Dark, v(nU || (nU = Be([`
    border: 1px solid `, `;
    border-radius: 12px;
    overflow: hidden;
  `])), pn[S.Dark][1])), du), Eke = v(rU || (rU = Be([`
  position: relative;
  display: grid;
  grid-template-areas: 'code panel';
  grid-template-columns: auto 38px;
  border-radius: inherit;
  z-index: 0; // new stacking context
`]))), $ke = v(aU || (aU = Be([`
  // No panel, all code
  grid-template-areas: 'code code';
`]))), jke = v(lU || (lU = Be([`
  grid-template-areas: 'panel' 'code';
  grid-template-columns: unset;
`]))), Cke = v(iU || (iU = Be([`
  grid-area: code;
  overflow-x: auto;
  // Many applications have global styles that are adding a border and border radius to this element.
  border-radius: inherit;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 0;
  // We apply left / right padding in Syntax to support line highlighting
  padding-top: `, `px;
  padding-bottom: `, `px;
  margin: 0;
  position: relative;
  transition: box-shadow `, `ms ease-in-out;

  `, `

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px `, ` inset;
  }
`])), ee[2], ee[2], It.faster, Oke({ whiteSpace: ["pre", "pre-wrap", "pre"] }), b.blue.light1), Mke = v(oU || (oU = Be([`
  border-left: 0;
  border-radius: inherit;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
`]))), kke = v(sU || (sU = Be([`
  border-left: 0;
  border-radius: inherit;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
`]))), Pke = v(cU || (cU = Be([`
  display: flex;
  align-items: center;
  padding-top: `, `px;
  padding-bottom: `, `px;
`])), 6, 6), Ske = v(uU || (uU = Be([`
  z-index: 2; // Above the shadows
  grid-area: panel;
`])));
function Nke(e) {
  var t = pn[e];
  return v(fU || (fU = Be([`
    background-color: `, `;
    color: `, `;
  `])), t[0], t[3]);
}
var Rke = v(dU || (dU = Be([`
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    z-index: 1; // above the code
    top: 0;
    height: 100%;
    width: 40px;
    border-radius: 40%;
    box-shadow: unset;
    transition: box-shadow `, `ms ease-in-out;
  }
  &:before {
    grid-column: 1;
    left: -40px;
  }
  &:after {
    grid-column: 2; // Placed either under Panel, or on the right edge
  }
`])), It.faster), _ke = v(pU || (pU = Be([`
  &:after {
    grid-column: -1; // Placed on the right edge
  }
`]))), Ake = v(gU || (gU = Be([`
  &:before,
  &:after {
    grid-row: 2; // Placed on the top under the Picker Panel
  }
`])));
function Lke(e, t) {
  var n = t === S.Light ? "1px 0 10px 0 ".concat($r(0.75, "black")) : "15px 0px 15px 0 ".concat($r(0.7, "black")), r = t === S.Light ? "-1px 0px 10px ".concat($r(0.75, "black")) : "-15px 0px 15px 0 ".concat($r(0.7, "black"));
  return v(hU || (hU = Be([`
    &:before {
      `, `;
    }
    &:after {
      `, `;
    }
  `])), (e === Or.Both || e === Or.Left) && v(mU || (mU = Be([`
        box-shadow: `, `;
      `])), n), (e === Or.Both || e === Or.Right) && `
        box-shadow: `.concat(r, `;
      `));
}
var Zke = ["children", "className", "language", "darkMode", "showLineNumbers", "lineNumberStart", "showWindowChrome", "chromeTitle", "copyable", "onCopy", "highlightLines", "languageOptions", "onChange", "customActionButtons", "showCustomActionButtons", "usePortal", "portalClassName", "portalContainer", "scrollContainer", "popoverZIndex"];
function u4(e) {
  var t, n, r = e.children, l = r === void 0 ? "" : r, i = e.className, c = e.language, f = e.darkMode, d = e.showLineNumbers, h = d !== void 0 && d, g = e.lineNumberStart, m = g === void 0 ? 1 : g, y = e.showWindowChrome, w = y !== void 0 && y, C = e.chromeTitle, E = C === void 0 ? "" : C, R = e.copyable, M = R === void 0 || R, P = e.onCopy, a = e.highlightLines, o = a === void 0 ? [] : a, s = e.languageOptions, p = e.onChange, O = e.customActionButtons, x = O === void 0 ? [] : O, N = e.showCustomActionButtons, T = N !== void 0 && N, $ = e.usePortal, j = $ === void 0 || $, A = e.portalClassName, Z = e.portalContainer, G = e.scrollContainer, I = e.popoverZIndex, F = Oy(e, Zke), U = Dn(null), B = Fo(ht(Or.None), 2), L = B[0], q = B[1], D = Fo(ht(!1), 2), _ = D[0], re = D[1], ue = kt(function() {
    return l.trim().includes(`
`);
  }, [l]), se = K(f), Re = se.theme, ft = se.darkMode, Le = x.filter(function(at) {
    return lr(at, "IconButton") === !0;
  }), Lt = T && !!Le.length, de = s == null ? void 0 : s.find(function(at) {
    return at.displayName === c;
  }), Zt = !w && (M || !!de || Lt), Jt = de ? de.language : c, Ht = !!de;
  Tt(function() {
    re(M && Wue.isSupported());
  }, [M, w]), dge(function() {
    var at = U.current;
    at != null && at.scrollWidth > at.clientWidth && q(Or.Right);
  }, []);
  var Zn = k.createElement(s4, { showLineNumbers: h, lineNumberStart: m, language: Jt, highlightLines: o }, l), an = Uu(function(at) {
    var He = at.target, ot = He.scrollWidth, Dt = He.clientWidth;
    if (ot > Dt) {
      var Ut = at.target.scrollLeft, Kt = ot - Dt;
      Ut > 0 && Ut < Kt ? q(Or.Both) : Ut > 0 ? q(Or.Left) : Ut < Kt && q(Or.Right);
    }
  }, 50, { leading: !0 }), me = l4({ popoverZIndex: I }, j ? { usePortal: j, portalClassName: A, portalContainer: Z, scrollContainer: G } : { usePortal: j });
  return k.createElement(Fn, { darkMode: ft }, k.createElement("div", { className: xke[Re] }, w && k.createElement(c4, { chromeTitle: E }), k.createElement("div", { className: H(Eke, Rke, Lke(L, Re), (t = {}, Ot(t, jke, Ht), Ot(t, Ake, Ht), Ot(t, $ke, !Zt), Ot(t, _ke, !Zt), t)) }, k.createElement("pre", fa({}, F, { className: H(Cke, Nke(Re), (n = {}, Ot(n, kke, Ht), Ot(n, Mke, !Zt), Ot(n, Pke, !ue), n), i), onScroll: function(at) {
    at.persist(), an(at);
  }, ref: U, tabIndex: L !== Or.None ? 0 : -1 }), Zn), Zt && k.createElement(l5e, fa({ className: H(Ske), language: de, languageOptions: s, onChange: p, contents: l, onCopy: P, showCopyButton: _, isMultiline: ue, customActionButtons: Le, showCustomActionButtons: Lt }, me)))));
}
u4.displayName = "Code", u4.propTypes = { children: z.string.isRequired, language: z.oneOfType([z.oneOf(Object.values(N1)), z.string]), darkMode: z.bool, className: z.string, showLineNumbers: z.bool, lineNumberStart: z.number, showWindowChrome: z.bool, chromeTitle: z.string, highlightLines: z.arrayOf(z.oneOfType([z.arrayOf(z.number), z.number])) };
function vU(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bU(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vU(Object(n), !0).forEach(function(r) {
      Bke(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vU(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Tke(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Bke(e, t, n) {
  return (t = Tke(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function f4() {
  return f4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, f4.apply(this, arguments);
}
function g5e(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var yU, pu, gu, Ike = ["children"], Hke = { a: function(e) {
  var t = e.children, n = e.href;
  return k.createElement(Xwe, { href: n }, t);
}, code: function(e) {
  var t, n, r = e.inline, l = e.children, i = e.className, c = l.join(`
`);
  if (r)
    return k.createElement(g2, null, c);
  var f = (t = i == null || (n = i.match(/language-(.+)/)) === null || n === void 0 ? void 0 : n[1]) !== null && t !== void 0 ? t : "none";
  return Object.values(N1).includes(f) || (console.warn("Unknown code language: ".concat(f, '. Using the default language of "none" instead.')), f = "none"), k.createElement(u4, { language: f }, c);
}, h1: function(e) {
  var t = e.children;
  return k.createElement(Hue, null, t);
}, h2: function(e) {
  var t = e.children;
  return k.createElement(Due, null, t);
}, h3: function(e) {
  var t = e.children;
  return k.createElement(zue, null, t);
}, p: function(e) {
  var t = e.children, n = g5e(e, Ike);
  return k.createElement(Iue, n, t);
} }, Dke = v(yU || (pu = [`
  h1 + *,
  h2 + *,
  h3 + * {
    margin-top: `, `px;
  }

  p + p {
    margin-top: `, `px;
  }
`], gu || (gu = pu.slice(0)), yU = Object.freeze(Object.defineProperties(pu, { raw: { value: Object.freeze(gu) } }))), ee[3], ee[2]), zke = ["children", "className", "components", "darkMode", "baseFontSize"], h5e = function(e) {
  var t = e.children, n = e.className, r = e.components, l = e.darkMode, i = e.baseFontSize, c = g5e(e, zke), f = K(l).darkMode, d = La(i) === 13 ? 14 : 16;
  return k.createElement(Fn, { darkMode: f, baseFontSize: d }, k.createElement(Aue, f4({ components: bU(bU({}, Hke), r), className: H(Dke, n) }, c), t));
};
h5e.displayName = "LGMarkdown";
function Fke(e) {
  return function(t) {
    if (Array.isArray(t))
      return hu(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return hu(t, n);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
        return Array.from(t);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return hu(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function hu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var li = /* @__PURE__ */ new Map(), m5e = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = function(r) {
    var l, i, c = ((l = (i = li.get(r)) === null || i === void 0 ? void 0 : i.length) !== null && l !== void 0 ? l : 0).toString().padStart(4, "0");
    return "lg-ui".concat(r ? "-".concat(r) : "", "-").concat(c);
  }(e);
  if (li.has(e)) {
    var n = li.get(e);
    li.set(e, [t].concat(Fke(n)));
  } else
    li.set(e, [t]);
  return t;
}, xt = { Light: "light", Dark: "dark" };
el(console.error), el(console.warn), el(console.log);
var v5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p);
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(v5e);
var Vke = v5e.exports;
const qke = /* @__PURE__ */ ce(Vke);
var b5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p);
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(b5e);
var Uke = b5e.exports;
const Wke = /* @__PURE__ */ ce(Uke);
var y5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p);
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(y5e);
var Gke = y5e.exports;
const Kke = /* @__PURE__ */ ce(Gke);
function Yke(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Xe(e, t, n) {
  return (t = Yke(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rn.apply(this, arguments);
}
function hr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Ce(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function Xke(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return wU(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return wU(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function wU(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var OU, xU, EU, $U, jU, CU, MU, kU, Bl = v(OU || (OU = Ce([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), w5e = Xe(Xe({}, W.Body1, v(xU || (xU = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(EU || (EU = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), Qke = Xe(Xe({}, W.Body1, v($U || ($U = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(jU || (jU = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), R1 = Xe(Xe({}, xt.Light, v(CU || (CU = Ce([`
    color: `, `;
  `])), b.black)), xt.Dark, v(MU || (MU = Ce([`
    color: `, `;
  `])), b.gray.light2)), Il = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, Jke = ["baseFontSize", "darkMode", "className", "weight", "as"], xy = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = hr(e, Jke), h = K(n).theme, g = Il(t), m = ne(f).Component, y = v(kU || (kU = Ce([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, Rn({ className: H(Bl, w5e[g], R1[h], y, r) }, d));
});
xy.displayName = "Body";
var PU, SU, NU, RU, _U, AU, LU, ZU, TU, BU, ePe = { label: "lg-label", description: "lg-description" };
v(PU || (PU = Ce([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Xe(Xe({}, xt.Light, v(SU || (SU = Ce([`
    color: `, `;
  `])), b.gray.dark1)), xt.Dark, v(NU || (NU = Ce([`
    color: `, `;
  `])), b.gray.light1));
Xe(Xe({}, xt.Light, v(RU || (RU = Ce([`
    color: `, `;
  `])), b.gray.base)), xt.Dark, v(_U || (_U = Ce([`
    color: `, `;
  `])), b.gray.dark1));
Xe(Xe({}, W.Body1, v(AU || (AU = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(LU || (LU = Ce([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var IU, HU, DU, zU, FU;
Xe(Xe({}, xt.Light, v(ZU || (ZU = Ce([`
    color: `, `;
  `])), b.gray.dark1)), xt.Dark, v(TU || (TU = Ce([`
    color: `, `;
  `])), b.gray.light1));
v(BU || (BU = Ce([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var VU, qU, UU, WU, GU, KU, tPe = v(IU || (IU = Ce([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), nPe = Xe(Xe({}, xt.Light, v(HU || (HU = Ce([`
    color: `, `;
  `])), b.red.base)), xt.Dark, v(DU || (DU = Ce([`
    color: `, `;
  `])), b.red.light1)), rPe = Xe(Xe({}, W.Body1, v(zU || (zU = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(FU || (FU = Ce([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), aPe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = hr(e, aPe), f = K(r).theme, d = Il(), h = ne(n).Component;
  return k.createElement(h, Rn({}, c, { className: H(tPe, nPe[f], rPe[d], i) }), l);
});
var lPe = v(VU || (VU = Ce([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), iPe = Xe(Xe({}, xt.Light, v(qU || (qU = Ce([`
    color: `, `;
  `])), b.green.dark2)), xt.Dark, v(UU || (UU = Ce([`
    color: `, `;
  `])), b.gray.light2)), oPe = ["darkMode", "className", "as"], sPe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = hr(e, oPe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Rn({ className: H(Bl, lPe, iPe[c], n) }, i));
});
sPe.displayName = "H1";
var YU, cPe = v(WU || (WU = Ce([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), uPe = Xe(Xe({}, xt.Light, v(GU || (GU = Ce([`
    color: `, `;
  `])), b.green.dark2)), xt.Dark, v(KU || (KU = Ce([`
    color: `, `;
  `])), b.gray.light2)), fPe = ["darkMode", "className", "as"], dPe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = hr(e, fPe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Rn({ className: H(Bl, cPe, uPe[c], n) }, i));
});
dPe.displayName = "H2";
var XU, QU, JU, eW, tW, nW, rW, aW, lW, iW, pPe = v(YU || (YU = Ce([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), gPe = ["darkMode", "className", "as"], hPe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = hr(e, gPe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Rn({ className: H(Bl, pPe, R1[c], n) }, i));
});
hPe.displayName = "H3";
var oW, sW, cW, hl = m5e(), mPe = v(XU || (XU = Ce([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, hl), vPe = Xe(Xe({}, xt.Light, v(QU || (QU = Ce([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, hl, b.gray.light2, b.gray.light1)), xt.Dark, v(JU || (JU = Ce([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, hl, b.gray.dark2, b.gray.dark1)), bPe = Xe(Xe({}, xt.Light, v(eW || (eW = Ce([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), hl, it[xt.Light].default, b.blue.base)), xt.Dark, v(tW || (tW = Ce([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), hl, it[xt.Dark].default, b.blue.base)), yPe = Xe(Xe({}, xt.Light, v(nW || (nW = Ce([`
    color: `, `;
  `])), b.blue.base)), xt.Dark, v(rW || (rW = Ce([`
    color: `, `;
  `])), b.blue.light1)), wPe = v(aW || (aW = Ce([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), OPe = v(lW || (lW = Ce([`
  white-space: nowrap;
`]))), xPe = v(iW || (iW = Ce([`
  white-space: normal;
`]))), EPe = ["children", "className", "darkMode", "baseFontSize", "as"], uW = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = hr(e, EPe), g = K(c).theme, m = Il(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? OPe : xPe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(Qke[m], mPe, vPe[g], bPe[g], w, Xe({}, yPe[g], C), i) }, l);
  return C ? k.createElement(y, Rn({ className: H(hl, wPe, i) }, h), E) : k.cloneElement(E, h);
});
uW.displayName = "InlineCode", uW.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var fW, dW, pW, gW, hW, mW, vW;
v(oW || (oW = Ce([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Xe(Xe({}, xt.Light, v(sW || (sW = Ce([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), xt.Dark, v(cW || (cW = Ce([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var bW, yW, wW, $Pe = v(fW || (fW = Ce([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), jPe = Xe(Xe({}, xt.Light, v(dW || (dW = Ce([`
    color: `, `;
  `])), b.black)), xt.Dark, v(pW || (pW = Ce([`
    color: `, `;
  `])), b.gray.light2)), CPe = Xe(Xe({}, xt.Light, v(gW || (gW = Ce([`
    color: `, `;
  `])), b.gray.base)), xt.Dark, v(hW || (hW = Ce([`
    color: `, `;
  `])), b.gray.dark1)), MPe = Xe(Xe({}, W.Body1, v(mW || (mW = Ce([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(vW || (vW = Ce([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), kPe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], PPe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? ePe.label : h, m = hr(e, kPe), y = K(n).theme, w = Il(t), C = ne(d).Component;
  return k.createElement(C, Rn({ "data-lgid": g, className: H($Pe, jPe[y], MPe[w], Xe({}, CPe[y], c), r) }, m), l);
});
PPe.displayName = "Label";
var OW, xW, EW, $W, jW, CW, Ey = m5e(), O5e = v(bW || (bW = Ce([`
  font-family: `, `;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), x5e = Xe(Xe({}, xt.Light, v(yW || (yW = Ce([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), xt.Dark, v(wW || (wW = Ce([`
    color: `, `;
    font-weight: `, `;

    &:hover {
      text-decoration-color: `, `;
    }

    &:focus {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), E5e = function(e) {
  if (e)
    return w5e[e];
}, SPe = v(OW || (OW = Ce([`
  gap: `, `px;
`])), ee[100]), NPe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = hr(e, NPe), d = K(i).theme, h = Il(l), g = nt(c, f, "span").Component;
  return k.createElement(g, Rn({ className: H(Ey, O5e, E5e(h), x5e[d], SPe, r), ref: t }, f), k.createElement(qke, { role: "presentation" }), n);
});
var RPe = v(xW || (xW = Ce([`
  transform: translate3d(3px, 0, 0);
`]))), _Pe = v(EW || (EW = Ce([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;

  .`, `:hover & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Ey), APe = v($W || ($W = Ce([`
  position: relative;
  bottom: 4px;
  left: -1px;
  height: 12px;
`]))), LPe = "hover", ZPe = "persist", MW = "none", TPe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? MW : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = hr(e, TPe), y = Xke(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Il(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== MW && (E = k.createElement(Wke, { role: "presentation", size: 12, className: H(Xe(Xe({}, _Pe, i === LPe), RPe, i === ZPe)) })) : E = k.createElement(Kke, { role: "presentation", className: APe }), k.createElement(P, Rn({ className: H(Ey, O5e, E5e(M), x5e[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var BPe = v(jW || (jW = Ce([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), IPe = ["darkMode", "className", "as"], HPe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = hr(e, IPe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Rn({ className: H(Bl, BPe, R1[c], n) }, i));
});
HPe.displayName = "Overline";
var DPe = v(CW || (CW = Ce([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), zPe = ["darkMode", "className", "as"], FPe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = hr(e, zPe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Rn({ className: H(Bl, DPe, R1[c], n) }, i));
});
FPe.displayName = "Subtitle";
var kW;
v(kW || (kW = Ce([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function VPe(e) {
  return function(t) {
    if (Array.isArray(t))
      return mu(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return mu(t, n);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
        return Array.from(t);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return mu(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function mu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var ii = /* @__PURE__ */ new Map(), qPe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = function(r) {
    var l, i, c = ((l = (i = ii.get(r)) === null || i === void 0 ? void 0 : i.length) !== null && l !== void 0 ? l : 0).toString().padStart(4, "0");
    return "lg-ui".concat(r ? "-".concat(r) : "", "-").concat(c);
  }(e);
  if (ii.has(e)) {
    var n = ii.get(e);
    ii.set(e, [t].concat(VPe(n)));
  } else
    ii.set(e, [t]);
  return t;
}, Vo = { Light: "light", Dark: "dark" };
el(console.error), el(console.warn), el(console.log);
function UPe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r);
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Wa(e, t, n) {
  return (t = UPe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function d4() {
  return d4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d4.apply(this, arguments);
}
function $5e(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var PW, p4 = { Small: "small", Default: "default", Large: "large", XLarge: "xlarge" }, WPe = { small: 14, default: 16, large: 20, xlarge: 24 }, GPe = ["className", "size", "fill", "title", "aria-labelledby", "aria-label", "role"];
function KPe(e, t) {
  var n = function(r) {
    var l, i, c = r.className, f = r.size, d = f === void 0 ? p4.Default : f, h = r.fill, g = r.title, m = r["aria-labelledby"], y = r["aria-label"], w = r.role, C = w === void 0 ? "img" : w, E = $5e(r, GPe), R = v(PW || (l = [`
      color: `, `;
    `], i || (i = l.slice(0)), PW = Object.freeze(Object.defineProperties(l, { raw: { value: Object.freeze(i) } }))), h), M = typeof d == "number" ? d : WPe[d];
    return C !== "img" && C !== "presentation" && console.warn("Please provide a valid role to this component. Valid options are 'img' and 'presentation'. If you'd like the Icon to be accessible to screen readers please use 'img', otherwise set the role to 'presentation'."), k.createElement(t, d4({ className: H(Wa({}, R, h != null), c), height: M, width: M, role: C }, function(P, a, o) {
      var s, p = o["aria-label"], O = o["aria-labelledby"], x = o.title;
      switch (P) {
        case "img":
          return p || O || x ? Wa(Wa(Wa({}, "aria-labelledby", O), "aria-label", p), "title", x) : { "aria-label": (s = a, "".concat(s.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
        case "presentation":
          return { "aria-hidden": !0, alt: "" };
      }
    }(C, e, Wa(Wa({ title: g }, "aria-label", y), "aria-labelledby", m)), E));
  };
  return n.displayName = e, n.isGlyph = !0, n.propTypes = { fill: z.string, size: z.oneOfType([z.oneOf(Object.values(p4)), z.number]), className: z.string }, n;
}
var SW, YPe = ["glyph"];
function XPe(e) {
  var t = function(n) {
    var r = n.glyph, l = $5e(n, YPe), i = e[r];
    if (i)
      return k.createElement(i, l);
    var c = Object.keys(e).find(function(f) {
      return Cr(f) === Cr(r);
    });
    return console.error("Error in Icon", 'Could not find glyph named "'.concat(r, '" in the icon set.'), c && 'Did you mean "'.concat(c, '?"')), k.createElement(k.Fragment, null);
  };
  return t.displayName = "Icon", t.isGlyph = !0, t.propTypes = { glyph: z.oneOf(Object.keys(e)).isRequired, size: z.oneOfType([z.oneOf(Object.values(p4)), z.number]) }, t;
}
function g4() {
  return g4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g4.apply(this, arguments);
}
var NW;
function h4() {
  return h4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h4.apply(this, arguments);
}
var RW;
function m4() {
  return m4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m4.apply(this, arguments);
}
var _W;
function v4() {
  return v4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v4.apply(this, arguments);
}
var AW;
function b4() {
  return b4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b4.apply(this, arguments);
}
var LW;
function y4() {
  return y4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y4.apply(this, arguments);
}
var ZW;
function w4() {
  return w4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w4.apply(this, arguments);
}
var TW;
function O4() {
  return O4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O4.apply(this, arguments);
}
var BW;
function x4() {
  return x4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x4.apply(this, arguments);
}
var IW;
function E4() {
  return E4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E4.apply(this, arguments);
}
var HW;
function $4() {
  return $4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $4.apply(this, arguments);
}
var DW;
function j4() {
  return j4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j4.apply(this, arguments);
}
var zW;
function C4() {
  return C4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C4.apply(this, arguments);
}
var FW;
function M4() {
  return M4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M4.apply(this, arguments);
}
var VW, qW;
function k4() {
  return k4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k4.apply(this, arguments);
}
var UW, WW, GW;
function P4() {
  return P4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P4.apply(this, arguments);
}
var KW, YW;
function S4() {
  return S4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S4.apply(this, arguments);
}
var XW, QW;
function N4() {
  return N4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N4.apply(this, arguments);
}
var JW;
function R4() {
  return R4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R4.apply(this, arguments);
}
var eG;
function _4() {
  return _4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _4.apply(this, arguments);
}
var tG;
function A4() {
  return A4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A4.apply(this, arguments);
}
var nG;
function L4() {
  return L4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L4.apply(this, arguments);
}
var rG;
function Z4() {
  return Z4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z4.apply(this, arguments);
}
var aG;
function T4() {
  return T4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T4.apply(this, arguments);
}
var lG;
function B4() {
  return B4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B4.apply(this, arguments);
}
var iG;
function I4() {
  return I4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I4.apply(this, arguments);
}
var oG;
function H4() {
  return H4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H4.apply(this, arguments);
}
var sG;
function D4() {
  return D4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D4.apply(this, arguments);
}
var cG;
function z4() {
  return z4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z4.apply(this, arguments);
}
var uG;
function F4() {
  return F4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F4.apply(this, arguments);
}
var fG;
function V4() {
  return V4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V4.apply(this, arguments);
}
var dG, pG;
function q4() {
  return q4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q4.apply(this, arguments);
}
var gG, hG;
function U4() {
  return U4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U4.apply(this, arguments);
}
var mG;
function W4() {
  return W4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W4.apply(this, arguments);
}
var vG;
function G4() {
  return G4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G4.apply(this, arguments);
}
var bG, yG;
function K4() {
  return K4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K4.apply(this, arguments);
}
var wG;
function Y4() {
  return Y4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y4.apply(this, arguments);
}
var OG;
function X4() {
  return X4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X4.apply(this, arguments);
}
var xG;
function Q4() {
  return Q4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q4.apply(this, arguments);
}
var EG;
function J4() {
  return J4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J4.apply(this, arguments);
}
var $G;
function ev() {
  return ev = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ev.apply(this, arguments);
}
var jG;
function tv() {
  return tv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tv.apply(this, arguments);
}
var CG;
function nv() {
  return nv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nv.apply(this, arguments);
}
var MG, kG, PG;
function rv() {
  return rv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rv.apply(this, arguments);
}
var SG;
function av() {
  return av = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, av.apply(this, arguments);
}
var NG;
function lv() {
  return lv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lv.apply(this, arguments);
}
var RG;
function iv() {
  return iv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, iv.apply(this, arguments);
}
var _G;
function ov() {
  return ov = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ov.apply(this, arguments);
}
var AG;
function sv() {
  return sv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sv.apply(this, arguments);
}
var LG;
function cv() {
  return cv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cv.apply(this, arguments);
}
var ZG;
function uv() {
  return uv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uv.apply(this, arguments);
}
var TG;
function fv() {
  return fv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fv.apply(this, arguments);
}
var BG, IG;
function dv() {
  return dv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dv.apply(this, arguments);
}
var HG;
function pv() {
  return pv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pv.apply(this, arguments);
}
var DG;
function gv() {
  return gv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gv.apply(this, arguments);
}
var zG, FG;
function hv() {
  return hv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hv.apply(this, arguments);
}
var VG;
function mv() {
  return mv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mv.apply(this, arguments);
}
var qG;
function vv() {
  return vv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vv.apply(this, arguments);
}
var UG, WG;
function bv() {
  return bv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bv.apply(this, arguments);
}
var GG;
function yv() {
  return yv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yv.apply(this, arguments);
}
var KG;
function wv() {
  return wv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wv.apply(this, arguments);
}
var YG;
function Ov() {
  return Ov = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ov.apply(this, arguments);
}
var XG;
function xv() {
  return xv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xv.apply(this, arguments);
}
var QG;
function Ev() {
  return Ev = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ev.apply(this, arguments);
}
var JG;
function $v() {
  return $v = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $v.apply(this, arguments);
}
var eK;
function jv() {
  return jv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jv.apply(this, arguments);
}
var tK, nK;
function Cv() {
  return Cv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cv.apply(this, arguments);
}
var rK;
function Mv() {
  return Mv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mv.apply(this, arguments);
}
var aK;
function kv() {
  return kv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kv.apply(this, arguments);
}
var lK, iK;
function Pv() {
  return Pv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pv.apply(this, arguments);
}
var oK;
function Sv() {
  return Sv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sv.apply(this, arguments);
}
var sK, cK;
function Nv() {
  return Nv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nv.apply(this, arguments);
}
var uK;
function Rv() {
  return Rv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rv.apply(this, arguments);
}
var fK;
function _v() {
  return _v = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _v.apply(this, arguments);
}
var dK, pK;
function Av() {
  return Av = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Av.apply(this, arguments);
}
var gK, hK;
function Lv() {
  return Lv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lv.apply(this, arguments);
}
var mK;
function Zv() {
  return Zv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zv.apply(this, arguments);
}
var vK, bK;
function Tv() {
  return Tv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tv.apply(this, arguments);
}
var yK;
function Bv() {
  return Bv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bv.apply(this, arguments);
}
var wK, OK;
function Iv() {
  return Iv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Iv.apply(this, arguments);
}
var xK;
function Hv() {
  return Hv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hv.apply(this, arguments);
}
var EK;
function Dv() {
  return Dv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dv.apply(this, arguments);
}
var $K, jK;
function zv() {
  return zv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zv.apply(this, arguments);
}
var CK, MK;
function Fv() {
  return Fv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fv.apply(this, arguments);
}
var kK;
function Vv() {
  return Vv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vv.apply(this, arguments);
}
var PK;
function qv() {
  return qv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qv.apply(this, arguments);
}
var SK;
function Uv() {
  return Uv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uv.apply(this, arguments);
}
var NK;
function Wv() {
  return Wv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wv.apply(this, arguments);
}
var RK;
function Gv() {
  return Gv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gv.apply(this, arguments);
}
var _K;
function Kv() {
  return Kv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kv.apply(this, arguments);
}
var AK, LK;
function Yv() {
  return Yv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yv.apply(this, arguments);
}
var ZK;
function Xv() {
  return Xv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xv.apply(this, arguments);
}
var TK, BK;
function Qv() {
  return Qv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qv.apply(this, arguments);
}
var IK, HK;
function Jv() {
  return Jv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jv.apply(this, arguments);
}
var DK;
function e6() {
  return e6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e6.apply(this, arguments);
}
var zK;
function t6() {
  return t6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t6.apply(this, arguments);
}
var FK, VK;
function n6() {
  return n6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n6.apply(this, arguments);
}
var qK, UK;
function r6() {
  return r6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r6.apply(this, arguments);
}
var WK;
function a6() {
  return a6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a6.apply(this, arguments);
}
var GK, KK;
function l6() {
  return l6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, l6.apply(this, arguments);
}
var YK;
function i6() {
  return i6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, i6.apply(this, arguments);
}
var XK, QK;
function o6() {
  return o6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, o6.apply(this, arguments);
}
var JK;
function s6() {
  return s6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, s6.apply(this, arguments);
}
var eY;
function c6() {
  return c6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, c6.apply(this, arguments);
}
var tY;
function u6() {
  return u6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, u6.apply(this, arguments);
}
var nY;
function f6() {
  return f6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, f6.apply(this, arguments);
}
var rY;
function d6() {
  return d6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d6.apply(this, arguments);
}
var aY, lY;
function p6() {
  return p6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, p6.apply(this, arguments);
}
var iY;
function g6() {
  return g6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g6.apply(this, arguments);
}
var oY, sY;
function h6() {
  return h6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h6.apply(this, arguments);
}
var cY, uY;
function m6() {
  return m6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m6.apply(this, arguments);
}
var fY;
function v6() {
  return v6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v6.apply(this, arguments);
}
var dY;
function b6() {
  return b6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b6.apply(this, arguments);
}
var pY;
function y6() {
  return y6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y6.apply(this, arguments);
}
var gY;
function w6() {
  return w6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w6.apply(this, arguments);
}
var hY;
function O6() {
  return O6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O6.apply(this, arguments);
}
var mY;
function x6() {
  return x6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x6.apply(this, arguments);
}
var vY, bY;
function E6() {
  return E6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E6.apply(this, arguments);
}
var yY, wY, OY;
function $6() {
  return $6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $6.apply(this, arguments);
}
var xY, EY;
function j6() {
  return j6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j6.apply(this, arguments);
}
var $Y;
function C6() {
  return C6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C6.apply(this, arguments);
}
var jY;
function M6() {
  return M6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M6.apply(this, arguments);
}
var CY;
function k6() {
  return k6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k6.apply(this, arguments);
}
var MY;
function P6() {
  return P6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P6.apply(this, arguments);
}
var kY;
function S6() {
  return S6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S6.apply(this, arguments);
}
var PY;
function N6() {
  return N6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N6.apply(this, arguments);
}
var SY;
function R6() {
  return R6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R6.apply(this, arguments);
}
var NY;
function _6() {
  return _6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _6.apply(this, arguments);
}
var RY;
function A6() {
  return A6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A6.apply(this, arguments);
}
var _Y;
function L6() {
  return L6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L6.apply(this, arguments);
}
var AY;
function Z6() {
  return Z6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z6.apply(this, arguments);
}
var LY;
function T6() {
  return T6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T6.apply(this, arguments);
}
var ZY;
function B6() {
  return B6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B6.apply(this, arguments);
}
var TY;
function I6() {
  return I6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I6.apply(this, arguments);
}
var BY;
function H6() {
  return H6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H6.apply(this, arguments);
}
var IY;
function D6() {
  return D6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D6.apply(this, arguments);
}
var HY;
function z6() {
  return z6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z6.apply(this, arguments);
}
var DY;
function F6() {
  return F6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F6.apply(this, arguments);
}
var zY;
function V6() {
  return V6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V6.apply(this, arguments);
}
var FY;
function q6() {
  return q6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q6.apply(this, arguments);
}
var VY, qY, UY;
function U6() {
  return U6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U6.apply(this, arguments);
}
var WY;
function W6() {
  return W6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W6.apply(this, arguments);
}
var GY;
function G6() {
  return G6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G6.apply(this, arguments);
}
var KY;
function K6() {
  return K6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K6.apply(this, arguments);
}
var YY;
function Y6() {
  return Y6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y6.apply(this, arguments);
}
var XY;
function X6() {
  return X6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X6.apply(this, arguments);
}
var QY;
function Q6() {
  return Q6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q6.apply(this, arguments);
}
var JY;
function J6() {
  return J6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J6.apply(this, arguments);
}
var eX;
function e7() {
  return e7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e7.apply(this, arguments);
}
var tX;
function t7() {
  return t7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t7.apply(this, arguments);
}
var nX;
function n7() {
  return n7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n7.apply(this, arguments);
}
var rX;
function r7() {
  return r7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r7.apply(this, arguments);
}
var aX;
function a7() {
  return a7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a7.apply(this, arguments);
}
var lX;
function l7() {
  return l7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, l7.apply(this, arguments);
}
var iX, oX;
function i7() {
  return i7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, i7.apply(this, arguments);
}
var sX;
function o7() {
  return o7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, o7.apply(this, arguments);
}
var cX;
function s7() {
  return s7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, s7.apply(this, arguments);
}
var uX = { ActivityFeed: function(e) {
  return u.createElement("svg", g4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SW || (SW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 13V7h4.5A1.5 1.5 0 0 0 7 5.5V1h2a2 2 0 0 1 2 2v4.515a2.5 2.5 0 0 0-2.612 1.602l-1.06 2.808A2.501 2.501 0 0 0 5.59 15H3a2 2 0 0 1-2-2ZM4.914 1h.92v3.833a1 1 0 0 1-1 1H1v-.919a1 1 0 0 1 .293-.707L2.5 3l1.707-1.707A1 1 0 0 1 4.914 1ZM10.8 9.003a1 1 0 0 1 .904.784l.61 2.792.508-.714a1 1 0 0 1 .814-.42H15a1 1 0 0 1 0 2h-.848l-1.519 2.135a1 1 0 0 1-1.792-.367l-.371-1.701-.444 1.175a1 1 0 0 1-.935.646H8a1 1 0 1 1 0-2h.4l1.392-3.686a1 1 0 0 1 1.008-.644Z", clipRule: "evenodd" })));
}, AddFile: function(e) {
  return u.createElement("svg", h4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NW || (NW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 7v6a2 2 0 0 0 2 2h5.968a2.25 2.25 0 0 1 .794-4.238A2.251 2.251 0 0 1 11 8.984V3a2 2 0 0 0-2-2H7v4.5A1.5 1.5 0 0 1 5.5 7H1Zm8 6a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0-1 1ZM5.833 1h-.919a1 1 0 0 0-.707.293L2.5 3 1.293 4.207A1 1 0 0 0 1 4.914v.92h3.833a1 1 0 0 0 1-1V1Z", clipRule: "evenodd" })));
}, AllProducts: function(e) {
  return u.createElement("svg", m4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RW || (RW = u.createElement("path", { fill: "currentColor", d: "M2.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM6.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 2.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM2.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM7.5 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM10.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM3.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM6.5 11.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" })));
}, Apps: function(e) {
  return u.createElement("svg", v4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _W || (_W = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3H3v4h4V3Zm0 6H3v4h4V9Zm2-6h4v4H9V3Zm4 6H9v4h4V9Z", clipRule: "evenodd" })));
}, Array: function(e) {
  return u.createElement("svg", b4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AW || (AW = u.createElement("path", { fill: "currentColor", d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V3h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM13.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12V3H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4Z" })));
}, ArrowDown: function(e) {
  return u.createElement("svg", y4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LW || (LW = u.createElement("path", { fill: "currentColor", d: "M9.168 3v6.944l1.535-1.535a1 1 0 0 1 1.414 0l.239.24a1 1 0 0 1 0 1.414l-3.383 3.382c-.008.01-.017.018-.026.027l-.239.24a1 1 0 0 1-1.414 0L3.643 10.06a1 1 0 0 1 0-1.414l.239-.239a1 1 0 0 1 1.414 0L6.83 9.941V3a1 1 0 0 1 1-1h.338a1 1 0 0 1 1 1Z" })));
}, ArrowLeft: function(e) {
  return u.createElement("svg", w4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZW || (ZW = u.createElement("path", { fill: "currentColor", d: "M13 6.832H6.056L7.59 5.297a1 1 0 0 0 0-1.414l-.24-.239a1 1 0 0 0-1.414 0L2.555 7.027c-.01.008-.018.017-.027.026l-.24.239a1 1 0 0 0 0 1.414l3.652 3.651a1 1 0 0 0 1.414 0l.239-.239a1 1 0 0 0 0-1.414L6.059 9.17H13a1 1 0 0 0 1-1v-.338a1 1 0 0 0-1-1Z" })));
}, ArrowRight: function(e) {
  return u.createElement("svg", O4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TW || (TW = u.createElement("path", { fill: "currentColor", d: "M3 6.832h6.944L8.41 5.297a1 1 0 0 1 0-1.414l.24-.239a1 1 0 0 1 1.414 0l3.382 3.383c.01.008.018.017.027.026l.24.239a1 1 0 0 1 0 1.414l-3.652 3.651a1 1 0 0 1-1.414 0l-.239-.239a1 1 0 0 1 0-1.414L9.941 9.17H3a1 1 0 0 1-1-1v-.338a1 1 0 0 1 1-1Z" })));
}, ArrowUp: function(e) {
  return u.createElement("svg", x4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BW || (BW = u.createElement("path", { fill: "currentColor", d: "M9.168 13V6.056l1.535 1.535a1 1 0 0 0 1.414 0l.239-.24a1 1 0 0 0 0-1.414L8.973 2.555a1.023 1.023 0 0 0-.026-.027l-.239-.24a1 1 0 0 0-1.414 0L3.643 5.94a1 1 0 0 0 0 1.414l.239.239a1 1 0 0 0 1.414 0L6.83 6.059V13a1 1 0 0 0 1 1h.338a1 1 0 0 0 1-1Z" })));
}, Beaker: function(e) {
  return u.createElement("svg", E4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IW || (IW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.953 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C6.333 1 6.473 1 6.753 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219C9.573 3 9.433 3 9.153 3h-2.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219c-.054-.107-.054-.247-.054-.527v-.4Zm.056 2.47c-.056.108-.056.25-.056.535V6l-3.007 5.412c-.663 1.193-.994 1.79-.932 2.277a1.5 1.5 0 0 0 .6 1.02C3.01 15 3.693 15 5.057 15h5.791c1.365 0 2.047 0 2.444-.291a1.5 1.5 0 0 0 .6-1.02c.062-.488-.27-1.084-.932-2.277L9.953 6V4.805c0-.285 0-.427-.056-.535a.5.5 0 0 0-.214-.214C9.575 4 9.433 4 9.148 4h-2.39c-.285 0-.427 0-.536.056a.5.5 0 0 0-.213.214ZM9.333 9l-3.03.5-1.287 2.31c-.218.392-.327.588-.309.748a.5.5 0 0 0 .205.348c.13.094.355.094.802.094h4.48c.447 0 .67 0 .801-.094a.5.5 0 0 0 .205-.348c.019-.16-.09-.355-.307-.746L9.333 9Z", clipRule: "evenodd" })));
}, Bell: function(e) {
  return u.createElement("svg", $4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HW || (HW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.625 6.138a4.656 4.656 0 0 0-3.268-3.925C9.228 1.52 8.67 1 8 1c-.67 0-1.228.52-1.357 1.213a4.656 4.656 0 0 0-3.268 3.925l-.452 3.963h.026a.95.95 0 0 0 0 1.899h10.102a.95.95 0 0 0 0-1.899h.026l-.452-3.963ZM8 15a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z", clipRule: "evenodd" })));
}, Biometric: function(e) {
  return u.createElement("svg", j4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DW || (DW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 1A5.5 5.5 0 0 0 2 6.5v3A5.5 5.5 0 0 0 7.5 15h1A5.5 5.5 0 0 0 14 9.5v-3A5.5 5.5 0 0 0 8.5 1h-1Zm1.074 6.75a.574.574 0 1 0-1.148 0v2.457a.574.574 0 0 0 1.148 0V7.75ZM8 5.338A2.412 2.412 0 0 0 5.588 7.75v2.566a.994.994 0 0 1-.291.704.574.574 0 1 0 .812.812c.402-.402.628-.947.628-1.516V7.75a1.264 1.264 0 1 1 2.527 0v2.648c0 .412-.233.79-.602.973a.574.574 0 0 0 .514 1.028 2.237 2.237 0 0 0 1.236-2V7.75A2.412 2.412 0 0 0 8 5.338ZM4.899 7.75A3.101 3.101 0 0 1 9.64 5.117a.574.574 0 1 0 .609-.974A4.25 4.25 0 0 0 3.75 7.75v2.297a.574.574 0 1 0 1.149 0V7.75Zm6.887-1.932a.574.574 0 1 0-1.023.522c.216.423.338.901.338 1.41v1.378a.574.574 0 1 0 1.149 0V7.75c0-.695-.167-1.352-.464-1.932Z", clipRule: "evenodd" })));
}, Boolean: function(e) {
  return u.createElement("svg", C4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zW || (zW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm4 6a4 4 0 0 1-4 4V4a4 4 0 0 1 4 4Z", clipRule: "evenodd" })));
}, Building: function(e) {
  return u.createElement("svg", M4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FW || (FW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v13H6v-2H4v2H1v-4h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1V5h4.5a.5.5 0 0 0 0-1H1V2Zm8 9h4.5a.5.5 0 0 0 0-1H9V8h4.5a.5.5 0 0 0 0-1H9V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10h-2v-2h-2v2H9v-4Z", clipRule: "evenodd" })));
}, Bulb: function(e) {
  return u.createElement("svg", k4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VW || (VW = u.createElement("path", { fill: "currentColor", d: "M12.331 8.5a5 5 0 1 0-8.612.086L5.408 11.5a1 1 0 0 0 .866.499H6.5V6a1.5 1.5 0 1 1 3 0v6h.224a1 1 0 0 0 .863-.496L12.34 8.5h-.009Z" })), qW || (qW = u.createElement("path", { fill: "currentColor", d: "M7.5 6v6h1V6a.5.5 0 0 0-1 0ZM10 14v-1H6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z" })));
}, Calendar: function(e) {
  return u.createElement("svg", P4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UW || (UW = u.createElement("path", { fill: "currentColor", d: "M4 2a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0V2Z" })), WW || (WW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 3H7a2 2 0 1 1-4 0 2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 2 2 0 1 1-4 0Zm3 4H9v3h3V7Z", clipRule: "evenodd" })), GW || (GW = u.createElement("path", { fill: "currentColor", d: "M10 3a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1Z" })));
}, Camera: function(e) {
  return u.createElement("svg", S4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KW || (KW = u.createElement("path", { fill: "currentColor", d: "M10.25 8.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })), YW || (YW = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.585 3.33a1.5 1.5 0 0 1 1.342-.83h4.146a1.5 1.5 0 0 1 1.342.83l.309.617a1 1 0 0 0 .894.553h.882A1.5 1.5 0 0 1 15 6v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V6a1.5 1.5 0 0 1 1.5-1.5h.882a1 1 0 0 0 .894-.553l.31-.618ZM11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", clipRule: "evenodd" })));
}, Cap: function(e) {
  return u.createElement("svg", N4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XW || (XW = u.createElement("path", { fill: "currentColor", d: "M2.97 8.008v2.3l.001.092-.002.262c0 1.926 2.535 2.838 5 2.838 2.466 0 5-.912 5-2.838 0-.085 0-.168-.002-.25.002-.035.002-.07.002-.105V8.001L8.706 9.787a2 2 0 0 1-1.554-.004L2.969 8.008Z" })), QW || (QW = u.createElement("path", { fill: "currentColor", d: "M7.565 2.583a1 1 0 0 1 .794-.002l6.35 2.732a.5.5 0 0 1-.004.92L8.35 8.896a1 1 0 0 1-.778-.001L1.305 6.233a.5.5 0 0 1-.005-.919l6.265-2.73ZM13.97 7.626v1.477a1 1 0 1 0 1 0V7.207l-1 .419Z" })));
}, CaretDown: function(e) {
  return u.createElement("svg", R4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JW || (JW = u.createElement("path", { fill: "currentColor", d: "M8.679 10.796a.554.554 0 0 1-.858 0L4.64 6.976C4.32 6.594 4.582 6 5.069 6h6.362c.487 0 .748.594.43.976l-3.182 3.82Z" })));
}, CaretLeft: function(e) {
  return u.createElement("svg", _4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eG || (eG = u.createElement("path", { fill: "currentColor", d: "M5.204 8.679a.553.553 0 0 1 0-.858l3.82-3.181c.382-.319.976-.058.976.429v6.362c0 .487-.594.748-.976.43l-3.82-3.182Z" })));
}, CaretRight: function(e) {
  return u.createElement("svg", A4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tG || (tG = u.createElement("path", { fill: "currentColor", d: "M10.796 7.321a.554.554 0 0 1 0 .858l-3.82 3.181c-.382.319-.976.058-.976-.429V4.57c0-.487.594-.748.976-.43l3.82 3.182Z" })));
}, CaretUp: function(e) {
  return u.createElement("svg", L4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nG || (nG = u.createElement("path", { fill: "currentColor", d: "M7.321 5.204a.553.553 0 0 1 .858 0l3.181 3.82c.319.382.058.976-.429.976H4.57c-.487 0-.748-.594-.43-.976l3.182-3.82Z" })));
}, ChartFilled: function(e) {
  return u.createElement("svg", Z4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rG || (rG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H3Zm8.25 2a.75.75 0 0 0-.75.75v6.25H12V5.25a.75.75 0 0 0-.75-.75ZM7.5 7.25a.75.75 0 0 1 1.5 0v4.25H7.5V7.25ZM5.25 9a.75.75 0 0 0-.75.75v1.75H6V9.75A.75.75 0 0 0 5.25 9Z", clipRule: "evenodd" })));
}, Charts: function(e) {
  return u.createElement("svg", T4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aG || (aG = u.createElement("path", { fill: "currentColor", d: "M11.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10ZM7.5 14a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1ZM2.5 14a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1Z" })));
}, Checkmark: function(e) {
  return u.createElement("svg", B4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lG || (lG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.306 9.05 5.455-5.455a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-7.067 7.068a1 1 0 0 1-1.5-.098l-3.049-3.97a1 1 0 0 1 .184-1.402l.595-.457a1.25 1.25 0 0 1 1.753.23L6.306 9.05Z", clipRule: "evenodd" })));
}, CheckmarkWithCircle: function(e) {
  return u.createElement("svg", I4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iG || (iG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.448-10.104a.997.997 0 1 1 1.508 1.306l-4.572 5.28a1 1 0 0 1-1.64-.07l-1.82-2.868a1 1 0 1 1 1.69-1.07l1.1 1.734 3.734-4.312Z", clipRule: "evenodd" })));
}, ChevronDown: function(e) {
  return u.createElement("svg", H4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oG || (oG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.636 5.364a1 1 0 0 0 0 1.414l4.95 4.95.707.707a1 1 0 0 0 1.414 0l.707-.707 4.95-4.95a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L8 8.899 3.757 4.657a1 1 0 0 0-1.414 0l-.707.707Z", clipRule: "evenodd" })));
}, ChevronLeft: function(e) {
  return u.createElement("svg", D4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sG || (sG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.778 1.636a1 1 0 0 0-1.414 0l-4.95 4.95-.707.707a1 1 0 0 0 0 1.414l.707.707 4.95 4.95a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L7.243 8l4.242-4.243a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, ChevronRight: function(e) {
  return u.createElement("svg", z4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cG || (cG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.364 14.364a1 1 0 0 0 1.414 0l4.95-4.95.707-.707a1 1 0 0 0 0-1.414l-.707-.707-4.95-4.95a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L8.899 8l-4.242 4.243a1 1 0 0 0 0 1.414l.707.707Z", clipRule: "evenodd" })));
}, ChevronUp: function(e) {
  return u.createElement("svg", F4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uG || (uG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.364 10.778a1 1 0 0 0 0-1.414l-4.95-4.95-.707-.707a1 1 0 0 0-1.414 0l-.707.707-4.95 4.95a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0L8 7.243l4.243 4.242a1 1 0 0 0 1.414 0l.707-.707Z", clipRule: "evenodd" })));
}, Clock: function(e) {
  return u.createElement("svg", V4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fG || (fG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.25a.75.75 0 0 1 1.5 0v3.16l1.744 1.526a.75.75 0 0 1-.988 1.128L7.511 8.818a.761.761 0 0 1-.19-.25.747.747 0 0 1-.071-.318v-3.5Z", clipRule: "evenodd" })));
}, ClockWithArrow: function(e) {
  return u.createElement("svg", q4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dG || (dG = u.createElement("path", { fill: "currentColor", d: "M13 8a5 5 0 0 1-7.304 4.438c-.348-.18-.787-.13-1.038.172l-.33.398c-.276.33-.22.828.152 1.044a7 7 0 1 0-1.452-10.98L1.97 2.146a.584.584 0 0 0-.964.521l.455 3.252c.04.287.285.51.576.511H5.32a.58.58 0 0 0 .387-1.018l-1.168-1.02A5 5 0 0 1 13 8Z" })), pG || (pG = u.createElement("path", { fill: "currentColor", d: "M7.25 5.25a.75.75 0 0 1 1.5 0v2.668l1.68 1.524a.75.75 0 1 1-.988 1.129L7.507 8.815a.758.758 0 0 1-.257-.565v-3Z" })));
}, Clone: function(e) {
  return u.createElement("svg", U4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gG || (gG = u.createElement("path", { fill: "currentColor", d: "M5.5 12a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v4Z" })), hG || (hG = u.createElement("path", { fill: "currentColor", d: "M4.25 10H3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.75h-2V4h-5v4h.75v2Z" })));
}, Cloud: function(e) {
  return u.createElement("svg", W4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mG || (mG = u.createElement("path", { fill: "currentColor", d: "M12.571 8.143c0 1.775-.899 3.34-2.267 4.264l-.014.01a5.12 5.12 0 0 1-2.861.869H2.857a2.857 2.857 0 0 1-.545-5.663 5.144 5.144 0 0 1 10.26.52ZM13.821 8.143a6.38 6.38 0 0 1-2.358 4.96 3.429 3.429 0 1 0 2.17-6.506c.123.494.188 1.013.188 1.546Z" })));
}, Code: function(e) {
  return u.createElement("svg", G4({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vG || (vG = u.createElement("path", { fill: "currentColor", d: "M6.11 13.262a.5.5 0 0 0 .395.586l.737.143a.5.5 0 0 0 .585-.396L9.926 2.738a.5.5 0 0 0-.396-.586l-.737-.143a.5.5 0 0 0-.585.396L6.109 13.262ZM1.36 7.246 3.976 5.11a.507.507 0 0 1 .704.063l.64.752a.483.483 0 0 1-.064.69L3.562 7.998 5.256 9.38c.212.173.24.482.064.69l-.64.752a.507.507 0 0 1-.704.062L1.36 8.75A.971.971 0 0 1 1 7.998c0-.29.132-.566.36-.752ZM14.636 7.246 12.02 5.11a.507.507 0 0 0-.704.063l-.64.752a.483.483 0 0 0 .064.69l1.694 1.382L10.74 9.38a.483.483 0 0 0-.064.69l.64.752a.507.507 0 0 0 .704.062l2.616-2.134a.971.971 0 0 0 .36-.752.971.971 0 0 0-.36-.752Z" })));
}, CodeBlock: function(e) {
  return u.createElement("svg", K4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bG || (bG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4H3v8h10V4ZM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Z", clipRule: "evenodd" })), yG || (yG = u.createElement("path", { fill: "currentColor", d: "M4.221 7.421 6.256 5.78a.398.398 0 0 1 .548.048l.498.578a.368.368 0 0 1-.05.53L5.934 8l1.318 1.063c.165.133.187.37.05.53l-.498.58a.398.398 0 0 1-.548.047L4.221 8.58A.744.744 0 0 1 3.941 8c0-.224.103-.436.28-.579ZM11.779 7.421 9.744 5.78a.398.398 0 0 0-.548.048l-.498.578a.368.368 0 0 0 .05.53L10.066 8 8.748 9.063a.368.368 0 0 0-.05.53l.498.58c.138.159.383.18.548.047l2.035-1.641a.744.744 0 0 0 .28-.579.744.744 0 0 0-.28-.579Z" })));
}, Colon: function(e) {
  return u.createElement("svg", Y4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wG || (wG = u.createElement("path", { fill: "currentColor", d: "M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
}, Connect: function(e) {
  return u.createElement("svg", X4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), OG || (OG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.867 8.898a4.048 4.048 0 0 0 .687-4.8l1.275-1.275a.584.584 0 0 0 0-.826l-.826-.826a.584.584 0 0 0-.826 0l-1.29 1.29a4.048 4.048 0 0 0-4.734.722L5.277 5.058a.323.323 0 0 0-.041.035L3.182 7.148a4.048 4.048 0 0 0-.72 4.738l-1.29 1.29a.584.584 0 0 0 0 .827l.825.826a.584.584 0 0 0 .826 0l1.278-1.278a4.048 4.048 0 0 0 4.795-.689l1.876-1.875a.324.324 0 0 0 .041-.035l2.054-2.054ZM6.561 6.776 4.685 8.65a1.916 1.916 0 0 0 0 2.707c.747.746 1.961.747 2.707 0l2.055-2.054a.321.321 0 0 1 .04-.035l1.877-1.875a1.916 1.916 0 0 0 0-2.707 1.916 1.916 0 0 0-2.707 0L6.602 6.74a.32.32 0 0 1-.04.035Z", clipRule: "evenodd" })));
}, Copy: function(e) {
  return u.createElement("svg", Q4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xG || (xG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 5.714v4.572C1 11.233 1.768 12 2.714 12H5.75V7.11c0-.566.227-1.108.63-1.504l2.294-2.252c.1-.099.21-.186.326-.262v-.378C9 1.768 8.232 1 7.286 1H5.8v3.429c0 .71-.576 1.285-1.286 1.285H1Zm8-.928L7.257 6.498A.857.857 0 0 0 7 7.11v.688h3.01a.857.857 0 0 0 .857-.858V4h-.717a.857.857 0 0 0-.6.246l-.55.54ZM4.867 1H4.15a.857.857 0 0 0-.601.246L1.257 3.498A.857.857 0 0 0 1 4.11v.688h3.01a.857.857 0 0 0 .857-.858V1ZM7 12V8.714H10.514c.71 0 1.286-.575 1.286-1.285V4h1.486C14.233 4 15 4.768 15 5.714v7.572c0 .947-.768 1.714-1.714 1.714H8.714A1.714 1.714 0 0 1 7 13.286V12Z", clipRule: "evenodd" })));
}, CreditCard: function(e) {
  return u.createElement("svg", J4({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EG || (EG = u.createElement("path", { fill: "currentColor", d: "M3 3a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2H3ZM15 7H1v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7Z" })));
}, CurlyBraces: function(e) {
  return u.createElement("svg", ev({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $G || ($G = u.createElement("path", { fill: "currentColor", d: "M3 3.544a2.5 2.5 0 0 1 2.5-2.5h1a.5.5 0 0 1 .5.5v1.105a.353.353 0 0 1-.353.353h-.79A.858.858 0 0 0 5 3.86v2.802a1.5 1.5 0 0 1-.816 1.335A1.5 1.5 0 0 1 5 9.332v2.803c0 .473.384.857.858.857h.789c.195 0 .353.158.353.353v1.105a.5.5 0 0 1-.5.5h-1a2.5 2.5 0 0 1-2.5-2.5v-1.956a1.5 1.5 0 0 0-1.5-1.5.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-1.95ZM13 12.45a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1-.5-.5v-1.105c0-.195.158-.353.353-.353h.79a.858.858 0 0 0 .857-.858V9.332a1.5 1.5 0 0 1 .816-1.335A1.5 1.5 0 0 1 11 6.662V3.859a.858.858 0 0 0-.858-.857h-.789A.353.353 0 0 1 9 2.65V1.544a.5.5 0 0 1 .5-.5h1a2.5 2.5 0 0 1 2.5 2.5V5.5A1.5 1.5 0 0 0 14.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0-1.5 1.5v1.95Z" })));
}, Cursor: function(e) {
  return u.createElement("svg", tv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jG || (jG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m8.534 8.534.473-.27 2.389-1.366-6.748-2.25 2.25 6.748 1.366-2.389.27-.473ZM10 10l4.48-2.563c.734-.333.678-1.393-.086-1.648L3.169 2.047A.887.887 0 0 0 2.047 3.17l3.742 11.225c.255.764 1.315.82 1.648.086L10 10Z", clipRule: "evenodd" })));
}, Dashboard: function(e) {
  return u.createElement("svg", nv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CG || (CG = u.createElement("path", { fill: "currentColor", d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6ZM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6ZM7 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3ZM2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z" })));
}, Database: function(e) {
  return u.createElement("svg", rv({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MG || (MG = u.createElement("path", { fill: "currentColor", d: "M13.5 4.452c0 .09 0 .177-.002.262l.002.094v.23c0 .3-.136.588-.433.87-.302.289-.75.548-1.305.765-1.11.434-2.541.656-3.762.656-1.22 0-2.652-.222-3.762-.656-.555-.217-1.003-.476-1.305-.764-.297-.283-.433-.571-.433-.872v-.229c0-.035 0-.07.002-.105a12.886 12.886 0 0 1-.002-.251C2.5 2.517 5.288 1.6 8 1.6s5.5.917 5.5 2.852Z" })), kG || (kG = u.createElement("path", { fill: "currentColor", d: "M2.5 6.747v1.957c0 .3.136.589.433.871.302.288.75.548 1.305.765 1.11.433 2.541.656 3.762.656 1.22 0 2.652-.223 3.762-.656.555-.217 1.003-.477 1.305-.765.297-.282.433-.57.433-.87V6.746c-.392.318-.88.575-1.405.78-1.236.483-2.784.719-4.095.719-1.31 0-2.859-.236-4.095-.72-.525-.204-1.013-.461-1.405-.779Z" })), PG || (PG = u.createElement("path", { fill: "currentColor", d: "M12.095 11.194c.525-.205 1.013-.462 1.405-.78v.811c0 .035 0 .07-.002.105l.002.251c0 1.936-2.788 2.852-5.5 2.852s-5.5-.916-5.5-2.852c0-.088 0-.176.002-.262a2.322 2.322 0 0 1-.002-.094v-.811c.392.318.88.575 1.405.78 1.236.483 2.784.718 4.095.718 1.31 0 2.859-.235 4.095-.719Z" })));
}, Diagram: function(e) {
  return u.createElement("svg", av({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SG || (SG = u.createElement("path", { fill: "currentColor", d: "M6 2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H8.5v2h4.75a.75.75 0 0 1 .75.75V10h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H13V8H8.5v2H9a.75.75 0 0 1 .75.75v1.5A.75.75 0 0 1 9 13H7a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 7 10h.5V8H3v2h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H2V7.75A.75.75 0 0 1 2.75 7H7.5V5h-.75A.75.75 0 0 1 6 4.25v-1.5Z" })));
}, Diagram2: function(e) {
  return u.createElement("svg", lv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NG || (NG = u.createElement("path", { fill: "currentColor", d: "M10.72 1c-.398 0-.72.336-.72.75V2H7.48a.49.49 0 0 0-.48.5V7H5v-.25C5 6.336 4.678 6 4.28 6H1.72c-.398 0-.72.336-.72.75v1.5c0 .414.322.75.72.75h2.56c.398 0 .72-.336.72-.75V8h2v4.5c0 .276.215.5.48.5H10v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V12H8V8h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V7H8V3h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06Z" })));
}, Diagram3: function(e) {
  return u.createElement("svg", iv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), RG || (RG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.75 1a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 5 3.25v-1.5A.75.75 0 0 0 4.25 1h-2.5Zm9.25.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm0 9a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm-10 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5ZM6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z", clipRule: "evenodd" })));
}, Disconnect: function(e) {
  return u.createElement("svg", ov({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _G || (_G = u.createElement("path", { fill: "currentColor", d: "M7.093 3.671a.317.317 0 0 1 0-.448L8.14 2.175a4.024 4.024 0 0 1 5.685 0 4.024 4.024 0 0 1 0 5.685l-1.048 1.047a.317.317 0 0 1-.448 0L11.28 7.86a.317.317 0 0 1 0-.449l1.048-1.047a1.906 1.906 0 0 0 0-2.693 1.906 1.906 0 0 0-2.693 0L8.59 4.718a.317.317 0 0 1-.449 0L7.093 3.671ZM1.293 1.293a1.001 1.001 0 0 1 1.416 0l11.998 11.998a1.001 1.001 0 0 1-1.416 1.416l-3.159-3.16-2.272 2.277a4.024 4.024 0 0 1-5.685 0 4.024 4.024 0 0 1 0-5.684l2.273-2.277L1.293 2.71a1.001 1.001 0 0 1 0-1.416Zm4.65 6.066L3.672 9.636a1.906 1.906 0 0 0 0 2.693c.743.742 1.95.742 2.693 0l2.272-2.277-2.692-2.693Z" })));
}, Download: function(e) {
  return u.createElement("svg", sv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AG || (AG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.524 2.575v5.557h1.712c.706 0 1.033.783.5 1.196l-3.237 2.506a.832.832 0 0 1-.998 0L4.265 9.328c-.534-.413-.207-1.196.499-1.196h1.611V2.575a1.575 1.575 0 0 1 3.15 0ZM2.5 11h1.8l2.405 1.862a2.132 2.132 0 0 0 2.59 0L11.7 11h1.8a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3Z", clipRule: "evenodd" })));
}, Drag: function(e) {
  return u.createElement("svg", cv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LG || (LG = u.createElement("path", { fill: "currentColor", d: "M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
}, Edit: function(e) {
  return u.createElement("svg", uv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZG || (ZG = u.createElement("path", { fill: "currentColor", d: "M10.922.681a.963.963 0 0 1 1.362 0l1.363 1.363a.963.963 0 0 1 0 1.362L12.284 4.77 9.56 2.044 8.538 3.066l2.724 2.725-7.153 7.153-3.747 1.022 1.022-3.747L10.922.68Z" })));
}, Ellipsis: function(e) {
  return u.createElement("svg", fv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TG || (TG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6.75 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", clipRule: "evenodd" })));
}, Email: function(e) {
  return u.createElement("svg", dv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BG || (BG = u.createElement("path", { fill: "currentColor", d: "m2.494 4 4.714 5.05a1.068 1.068 0 0 0 1.584 0L13.505 4H2.494ZM1.133 4.256A2.12 2.12 0 0 0 1 5v6c0 .369.093.715.256 1.011L4.814 8.2l-3.68-3.944Z" })), IG || (IG = u.createElement("path", { fill: "currentColor", d: "M2.867 13c-.348 0-.674-.102-.953-.28l3.56-3.813 1.219 1.306a1.78 1.78 0 0 0 2.64 0l1.346-1.443 3.575 3.83c-.313.251-.7.4-1.12.4H2.866ZM14.84 11.813c.103-.248.16-.523.16-.813V5c0-.255-.045-.5-.126-.724l-3.535 3.787 3.5 3.75Z" })));
}, Eraser: function(e) {
  return u.createElement("svg", pv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HG || (HG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.381 1.934a2.014 2.014 0 0 1 2.817 0l3.228 3.228a2.014 2.014 0 0 1 0 2.817l-5.258 5.258h5.289c.29 0 .526.235.526.526v.35c0 .292-.235.527-.526.527h-9.51a.702.702 0 0 1-.495-.205l-2.878-2.877a2.014 2.014 0 0 1 0-2.817l6.807-6.807ZM8.1 12.32a.5.5 0 0 0 0-.707L4.747 8.26a.5.5 0 0 0-.707 0L2.566 9.733a.612.612 0 0 0 0 .832l2.518 2.518a.527.527 0 0 0 .372.154h1.51c.139 0 .273-.056.372-.155l.762-.762Z", clipRule: "evenodd" })));
}, Escalation: function(e) {
  return u.createElement("svg", gv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DG || (DG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.361 4.423a.556.556 0 0 0-.26-.97L5.146 2.009a.556.556 0 0 0-.636.69l1.787 6.672a.556.556 0 0 0 .896.28l6.168-5.228ZM2.911 2.102a.556.556 0 0 0-.392.68l3.163 11.806a.556.556 0 1 0 1.074-.287L3.592 2.493a.556.556 0 0 0-.68-.392Z", clipRule: "evenodd" })));
}, Export: function(e) {
  return u.createElement("svg", hv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zG || (zG = u.createElement("path", { fill: "currentColor", d: "M14.623 5.186a.278.278 0 0 0 0-.385l-2.805-2.915a.277.277 0 0 0-.477.192v1.424A6.5 6.5 0 0 0 5 10v.1a1.5 1.5 0 0 0 3 0V10a3.5 3.5 0 0 1 3.34-3.496v1.405c0 .25.305.373.478.193l2.805-2.916Z" })), FG || (FG = u.createElement("path", { fill: "currentColor", d: "M6.5 3.879a.75.75 0 0 0-.75-.75H4a2 2 0 0 0-2 2v6.864a2 2 0 0 0 2 2h6.864a2 2 0 0 0 2-2V10.05a.75.75 0 0 0-1.5 0v1.943a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V5.129a.5.5 0 0 1 .5-.5h1.75a.75.75 0 0 0 .75-.75Z" })));
}, Favorite: function(e) {
  return u.createElement("svg", mv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VG || (VG = u.createElement("path", { fill: "currentColor", d: "M7.538 1.11a.5.5 0 0 1 .924 0l1.537 3.696a.5.5 0 0 0 .421.306l3.99.32a.5.5 0 0 1 .285.878l-3.04 2.604a.5.5 0 0 0-.16.496l.928 3.893a.5.5 0 0 1-.747.542L8.261 11.76a.5.5 0 0 0-.522 0l-3.415 2.086a.5.5 0 0 1-.747-.542l.928-3.893a.5.5 0 0 0-.16-.496L1.304 6.31a.5.5 0 0 1 .285-.878l3.99-.32A.5.5 0 0 0 6 4.806L7.538 1.11Z" })));
}, Federation: function(e) {
  return u.createElement("svg", vv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qG || (qG = u.createElement("path", { fill: "currentColor", d: "M8 0c1.6 0 2.8 1.3 2.8 3 0 1.5-1 2.7-2.3 3v2.1l3.1 2.4c.4-.3 1-.5 1.5-.5 1.6 0 2.8 1.3 2.8 3s-1.3 3-2.8 3c-1.6 0-2.8-1.3-2.8-3 0-.7.2-1.3.6-1.8L8 9l-2.9 2.2c.4.5.6 1.1.6 1.8 0 1.7-1.3 3-2.8 3C1.4 16 0 14.7 0 13s1.3-3 2.8-3c.6 0 1.1.2 1.5.5l3.1-2.4V5.9C6.2 5.7 5.2 4.5 5.2 3c0-1.7 1.2-3 2.8-3Zm0 5c.8 0 1.9-.8 1.9-2C9.9 1.9 9 1 8 1c-1 0-1.9.9-1.9 2 0 1.2 1 2 1.9 2Zm-5.2 6c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.8-2-1.9-2Zm10.4 0c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.9-2-1.9-2Z" })));
}, File: function(e) {
  return u.createElement("svg", bv({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), UG || (UG = u.createElement("path", { fill: "currentColor", d: "M3 13V7h4.5A1.5 1.5 0 0 0 9 5.5V1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" })), WG || (WG = u.createElement("path", { fill: "currentColor", d: "M7.833 1h-.919a1 1 0 0 0-.707.293L3.293 4.207A1 1 0 0 0 3 4.914v.92h3.833a1 1 0 0 0 1-1V1Z" })));
}, Filter: function(e) {
  return u.createElement("svg", yv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GG || (GG = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 6.148-3.8-3.94C1.797 1.79 2.044 1 2.576 1h10.848c.532 0 .779.79.377 1.208L10 6.148v5.625a.5.5 0 0 1-.17.376l-3 2.625a.5.5 0 0 1-.83-.376v-8.25Z", clipRule: "evenodd" })));
}, FullScreenEnter: function(e) {
  return u.createElement("svg", xv({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XG || (XG = u.createElement("path", { fill: "currentColor", d: "M1.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM15 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM1.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM14.5 14a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, FullScreenExit: function(e) {
  return u.createElement("svg", Ev({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), QG || (QG = u.createElement("path", { fill: "currentColor", d: "M10.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM6 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM10.5 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM5.5 7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, Folder: function(e) {
  return u.createElement("svg", wv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KG || (KG = u.createElement("path", { fill: "currentColor", d: "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1 1 1 0 0 0-1-1H2Z" })));
}, Format: function(e) {
  return u.createElement("svg", Ov({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YG || (YG = u.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm1 3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H3Zm4-7a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z" })));
}, Gauge: function(e) {
  return u.createElement("svg", $v({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JG || (JG = u.createElement("path", { fill: "currentColor", d: "M1.041 10.251c-.044.412.296.749.71.749h2.494c.414 0 .74-.34.843-.742A3.006 3.006 0 0 1 8.791 8.1l2.99-2.991a7 7 0 0 0-10.74 5.142ZM13.297 6.422l-2.842 2.842c.213.3.368.638.459.994.102.401.429.742.843.742h2.494c.414 0 .754-.337.71-.749a7.001 7.001 0 0 0-1.664-3.829Z" })));
}, GlobeAmericas: function(e) {
  return u.createElement("svg", jv({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eK || (eK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-5.301 4.699A4.73 4.73 0 0 1 5 11.683V10L3.257 8.257A4.75 4.75 0 0 1 8 3.25V4.5L6.5 6v1l-.5.5-.5-.5-1 1 .5.5h2.5L8 9v1l-1 1 1.699 1.699Zm4.047-4.496a4.73 4.73 0 0 0-.924-3.025L10.5 6.5V9h1.25l.996-.797Z", clipRule: "evenodd" })));
}, GovernmentBuilding: function(e) {
  return u.createElement("svg", Cv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tK || (tK = u.createElement("path", { fill: "currentColor", d: "M11 5V4a3 3 0 0 0-6 0v1h6Z" })), nK || (nK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 6a.5.5 0 0 0 0 1H2v6h-.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H14V7h.5a.5.5 0 0 0 0-1h-13Zm3 2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3ZM8 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 8Zm2.5.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z", clipRule: "evenodd" })));
}, Hash: function(e) {
  return u.createElement("svg", Mv({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rK || (rK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.616 1.5a.5.5 0 0 0-.492.413L9.668 4.5h-2.47l.426-2.413A.5.5 0 0 0 7.13 1.5H6.116a.5.5 0 0 0-.492.413L5.168 4.5H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.815l-.53 3H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.933l-.425 2.413A.5.5 0 0 0 4 14.5h1.016a.5.5 0 0 0 .492-.413l.456-2.587h2.47l-.426 2.413a.5.5 0 0 0 .492.587h1.016a.5.5 0 0 0 .492-.413l.456-2.587H13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.683l.529-3H13.5A.5.5 0 0 0 14 6V5a.5.5 0 0 0-.5-.5h-1.802l.426-2.413a.5.5 0 0 0-.492-.587h-1.016Zm-4.3 8h2.47l.529-3h-2.47l-.528 3Z", clipRule: "evenodd" })));
}, Highlight: function(e) {
  return u.createElement("svg", kv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aK || (aK = u.createElement("path", { fill: "currentColor", d: "M8.853 12.031A.1.1 0 0 1 8.926 12h5.824a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25H7.231a.1.1 0 0 1-.072-.168l1.694-1.8ZM4.019 9.193l.375-.374L7.576 12l-.375.375a1 1 0 0 1-.779.29l-.574-.04a1 1 0 0 0-.778.29l-.141.14-1.591-1.59.141-.142a1 1 0 0 0 .29-.778l-.04-.573a1 1 0 0 1 .29-.779ZM11.433 1.779a1 1 0 0 1 1.415 0l1.767 1.768a1 1 0 0 1 0 1.414L8.28 11.296 5.098 8.114l6.335-6.335ZM2.632 12.167l1.593 1.593-.17.172a.25.25 0 0 1-.178.074H1.386a.25.25 0 0 1-.176-.428l1.422-1.41Z" })));
}, Home: function(e) {
  return u.createElement("svg", Pv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lK || (lK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.687 1.751a.5.5 0 0 1 .626 0l6.433 5.164a.5.5 0 0 1 .069.713l-.644.761a.5.5 0 0 1-.697.065L8.316 4.257a.5.5 0 0 0-.632 0L2.526 8.454a.5.5 0 0 1-.697-.065l-.644-.76a.5.5 0 0 1 .07-.714l6.432-5.164Z", clipRule: "evenodd" })), iK || (iK = u.createElement("path", { fill: "currentColor", d: "M7.688 5.25a.5.5 0 0 1 .624 0l4.5 3.6a.5.5 0 0 1 .188.39v4.26a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9.24a.5.5 0 0 1 .188-.39l4.5-3.6Z" })));
}, HorizontalDrag: function(e) {
  return u.createElement("svg", Sv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oK || (oK = u.createElement("path", { fill: "currentColor", d: "M4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" })));
}, Import: function(e) {
  return u.createElement("svg", Nv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sK || (sK = u.createElement("path", { fill: "currentColor", d: "M11.623 8.799a.278.278 0 0 0 0-.385L8.818 5.498a.277.277 0 0 0-.477.193v1.405A3.5 3.5 0 0 1 5 3.6v-.1a1.5 1.5 0 1 0-3 0v.1a6.5 6.5 0 0 0 6.34 6.498v1.424c0 .25.305.372.478.192L11.623 8.8Z" })), cK || (cK = u.createElement("path", { fill: "currentColor", d: "M3.95 11a.75.75 0 0 1 1.5 0v1.75a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V5.886a.5.5 0 0 0-.5-.5h-1.943a.75.75 0 0 1 0-1.5h1.943a2 2 0 0 1 2 2v6.864a2 2 0 0 1-2 2H5.95a2 2 0 0 1-2-2V11Z" })));
}, ImportantWithCircle: function(e) {
  return u.createElement("svg", Rv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uK || (uK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 4.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, InfoWithCircle: function(e) {
  return u.createElement("svg", _v({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fK || (fK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 0 1 1 1v4h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7h-.5a.5.5 0 0 1 0-1H8Z", clipRule: "evenodd" })));
}, InternalEmployee: function(e) {
  return u.createElement("svg", Av({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dK || (dK = u.createElement("path", { fill: "currentColor", d: "M6.5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h8.774l-.003-.05-.03-.022s-2.834-2.213-1.27-5.622c-.263-.055-.56.005-.814.144A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), pK || (pK = u.createElement("path", { fill: "currentColor", d: "M12.746 7.003c-.36-.448-.672-.903-.736-.998a.016.016 0 0 0-.023 0c-.063.095-.373.55-.732.998-3.084 4.137.486 6.925.486 6.925l.03.021c.026.431.093 1.051.093 1.051h.266s.067-.617.093-1.05l.03-.025c.004.003 3.577-2.785.493-6.922ZM12 13.87s-.16-.144-.203-.217v-.007l.193-4.505c0-.014.02-.014.02 0l.193 4.505v.007a1.522 1.522 0 0 1-.203.217Z" })));
}, InviteUser: function(e) {
  return u.createElement("svg", Lv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gK || (gK = u.createElement("path", { fill: "currentColor", d: "M8.418 7.428a3.5 3.5 0 1 0-3.836-5.856 3.5 3.5 0 0 0 3.836 5.856ZM3.091 8.562c.308-.357.838-.339 1.252-.112.64.35 1.375.55 2.157.55s1.517-.2 2.157-.55c.414-.227.944-.245 1.252.112.11.128.214.263.31.403A1.996 1.996 0 0 0 9.5 10.5 2 2 0 0 0 8.177 14H2v-2.5c0-1.123.411-2.15 1.091-2.938Z" })), hK || (hK = u.createElement("path", { fill: "currentColor", d: "M10.5 10.5a.998.998 0 0 1 1-1 1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1Z" })));
}, Key: function(e) {
  return u.createElement("svg", Zv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mK || (mK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.015 10.03c.652 0 1.267-.155 1.811-.43l1.512 1.51-.921.921a.669.669 0 0 0 0 .946l.827.827a.669.669 0 0 0 .946 0l.92-.92.75.749a1.254 1.254 0 0 0 1.773-1.773L9.599 7.827a4.015 4.015 0 1 0-3.584 2.204Zm-.753-3.513a1.255 1.255 0 1 0 0-2.51 1.255 1.255 0 0 0 0 2.51Z", clipRule: "evenodd" })));
}, Laptop: function(e) {
  return u.createElement("svg", Tv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vK || (vK = u.createElement("path", { fill: "currentColor", d: "M5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 6ZM5.5 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })), bK || (bK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a1 1 0 0 0-1 1v7.813l-.29.49a.91.91 0 0 0-.068.1L1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.642-1.096a.901.901 0 0 0-.067-.1L14 11.313V3.5a1 1 0 0 0-1-1H3ZM12.5 4h-9v6.5h9V4Z", clipRule: "evenodd" })));
}, LightningBolt: function(e) {
  return u.createElement("svg", Bv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yK || (yK = u.createElement("path", { fill: "currentColor", d: "M9.223 1.993c0-.497-.66-.68-.922-.256l-4.227 6.85a.493.493 0 0 0 .423.75h2.28v4.67c0 .497.66.68.921.257l4.228-6.852a.492.492 0 0 0-.424-.75h-2.28V1.993Z" })));
}, Link: function(e) {
  return u.createElement("svg", Iv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wK || (wK = u.createElement("path", { fill: "currentColor", d: "M6.039 9.953a3.596 3.596 0 0 1-.327-.38l1.45-1.445a1.553 1.553 0 0 0 2.496.423l2.885-2.87a1.57 1.57 0 0 0 .01-2.213 1.553 1.553 0 0 0-2.203-.01l-.379.377A.995.995 0 0 1 8.56 3.83a1.005 1.005 0 0 1 .006-1.418l.38-.377a3.542 3.542 0 0 1 5.024.023 3.58 3.58 0 0 1-.022 5.047l-2.884 2.871a3.542 3.542 0 0 1-5.025-.022Z" })), OK || (OK = u.createElement("path", { fill: "currentColor", d: "M9.961 6.047c.12.12.228.248.327.38l-1.45 1.445a1.553 1.553 0 0 0-2.496-.423l-2.885 2.87a1.57 1.57 0 0 0-.01 2.213 1.553 1.553 0 0 0 2.203.01l.379-.377a.995.995 0 0 1 1.411.006 1.005 1.005 0 0 1-.006 1.418l-.38.377a3.542 3.542 0 0 1-5.024-.023 3.58 3.58 0 0 1 .022-5.047l2.884-2.871a3.542 3.542 0 0 1 5.025.022Z" })));
}, List: function(e) {
  return u.createElement("svg", Hv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xK || (xK = u.createElement("path", { fill: "currentColor", d: "M3.125 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.125 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.875 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM6.625 3a1 1 0 0 0 0 2h6.5a1 1 0 1 0 0-2h-6.5ZM5.625 8a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1ZM6.625 11a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2h-6.5Z" })));
}, Lock: function(e) {
  return u.createElement("svg", Dv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), EK || (EK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7V5a4 4 0 1 1 8 0v2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm2-2a2 2 0 1 1 4 0v2H6V5Zm2.587 5.81A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, LogIn: function(e) {
  return u.createElement("svg", zv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $K || ($K = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 13a1 1 0 0 1-1 1H9.75a.75.75 0 0 1-.75-.75v-.5a.75.75 0 0 1 .75-.75H13V4H9.75A.75.75 0 0 1 9 3.25v-.5A.75.75 0 0 1 9.75 2H14a1 1 0 0 1 1 1v10Z", clipRule: "evenodd" })), jK || (jK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.505 11.884 3.202-3.202a1 1 0 0 0 0-1.414L6.505 4.066a.75.75 0 0 0-1.06 0l-.354.353a.75.75 0 0 0 0 1.061L6.611 7H1.75a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75h4.81l-1.469 1.47a.75.75 0 0 0 0 1.06l.354.354a.75.75 0 0 0 1.06 0Z", clipRule: "evenodd" })));
}, LogOut: function(e) {
  return u.createElement("svg", Fv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CK || (CK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 3c0-.552.446-1 .995-1h4.23c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75H3.49v8h3.235c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75h-4.23a.998.998 0 0 1-.995-1V3Z", clipRule: "evenodd" })), MK || (MK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11.022 11.909 3.187-3.202a1.003 1.003 0 0 0 0-1.414L11.022 4.09a.744.744 0 0 0-1.056 0l-.352.354a.753.753 0 0 0 0 1.06l1.513 1.52H6.29a.748.748 0 0 0-.746.75v.5c0 .414.334.75.746.75h4.788l-1.463 1.47a.753.753 0 0 0 0 1.06l.352.354a.744.744 0 0 0 1.056 0Z", clipRule: "evenodd" })));
}, MagnifyingGlass: function(e) {
  return u.createElement("svg", Vv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kK || (kK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.323 9.819a5.302 5.302 0 0 0 6.463.805l4.144 4.144a1.3 1.3 0 1 0 1.838-1.838l-4.144-4.144a5.302 5.302 0 0 0-8.3-6.463 5.3 5.3 0 0 0 0 7.496ZM7.98 4.162A2.7 2.7 0 1 1 4.162 7.98 2.7 2.7 0 0 1 7.98 4.162Z", clipRule: "evenodd" })));
}, Megaphone: function(e) {
  return u.createElement("svg", qv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PK || (PK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 3 5.725-1.636A1 1 0 0 1 13 2.326v7.348a1 1 0 0 1-1.275.962L6 9H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3Zm-.657 7H3v5h2.98a1 1 0 0 0 .918-1.396L5.343 10ZM16 6a2 2 0 0 1-2 2V4a2 2 0 0 1 2 2Z", clipRule: "evenodd" })));
}, Menu: function(e) {
  return u.createElement("svg", Uv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SK || (SK = u.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
}, Minus: function(e) {
  return u.createElement("svg", Wv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NK || (NK = u.createElement("path", { fill: "currentColor", d: "M3 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3Z" })));
}, Mobile: function(e) {
  return u.createElement("svg", Gv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), RK || (RK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H5v10h6V3ZM5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z", clipRule: "evenodd" })));
}, Moon: function(e) {
  return u.createElement("svg", Kv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _K || (_K = u.createElement("path", { fill: "currentColor", d: "M13.787 10.074a.713.713 0 0 0-.864-.116c-.125.077-.26.135-.394.192-1.766.72-3.888-.21-4.704-2.208-.73-1.795-.086-3.734 1.344-4.617a.72.72 0 0 0 .317-.807A.709.709 0 0 0 8.795 2H8.67c-3.312 0-6 2.688-6 6s2.688 6 6 6a6.003 6.003 0 0 0 5.232-3.062.715.715 0 0 0-.125-.864h.01Z" })));
}, MultiDirectionArrow: function(e) {
  return u.createElement("svg", Yv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), AK || (AK = u.createElement("path", { fill: "currentColor", d: "M5 8.573v4.854c0 .53-.608.774-.928.374L2.13 11.374a.607.607 0 0 1 0-.748l1.943-2.427c.32-.4.928-.155.928.374Z" })), LK || (LK = u.createElement("path", { fill: "currentColor", d: "M5 10h7.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5v-2ZM11 7.427V2.573c0-.53.608-.775.928-.374l1.943 2.427a.607.607 0 0 1 0 .748l-1.943 2.427c-.32.4-.928.155-.928-.374ZM3 4.5a.5.5 0 0 1 .5-.5H11v2H3.5a.5.5 0 0 1-.5-.5v-1Z" })));
}, MultiLayers: function(e) {
  return u.createElement("svg", Xv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZK || (ZK = u.createElement("path", { fill: "currentColor", d: "m12.431 9.745-.26-.121.26-.122a1.99 1.99 0 0 0 .758-.597c.197-.252.311-.576.311-.9 0-.324-.114-.637-.311-.9a2.073 2.073 0 0 0-.758-.597l-.29-.142.217-.101c.301-.142.571-.344.758-.597.197-.253.311-.577.311-.9 0-.324-.114-.638-.311-.9a2.073 2.073 0 0 0-.758-.598L9.194 1.763A2.9 2.9 0 0 0 7.97 1.5c-.415 0-.84.08-1.225.263L3.57 3.27c-.301.142-.57.344-.758.597a1.483 1.483 0 0 0-.311.9c0 .324.114.638.311.901.197.253.457.455.758.597l.29.142-.217.1c-.301.142-.571.345-.758.598a1.483 1.483 0 0 0-.311.9c0 .324.114.637.311.9.197.253.457.456.758.597l.259.122-.26.121c-.3.142-.57.344-.757.597a1.484 1.484 0 0 0-.311.9c0 .324.114.638.311.9.197.254.457.456.758.598l3.165 1.497c.384.182.809.263 1.224.263.415 0 .84-.08 1.225-.263l3.165-1.497c.3-.142.57-.344.757-.597.197-.253.312-.577.312-.9 0-.324-.114-.638-.312-.901a2.073 2.073 0 0 0-.757-.597h.01Zm-4.39 3.248c-.207 0-.404-.04-.54-.112l-3.164-1.497c-.114-.05-.166-.111-.187-.132l.02-.02.167-.111 1.36-.637 1.13.536c.384.182.81.263 1.225.263.415 0 .84-.081 1.224-.263l1.132-.536 1.359.637c.114.05.166.111.187.131l-.021.02-.166.112-3.165 1.497a1.28 1.28 0 0 1-.54.112h-.02ZM4.14 8.005l.02-.02.166-.111 1.318-.628 1.1.516c.384.182.81.263 1.225.263.415 0 .84-.08 1.224-.263l1.173-.556 1.39.657c.115.051.167.112.187.132l-.02.02-.166.111-3.165 1.498a1.28 1.28 0 0 1-.54.111c-.208 0-.405-.04-.54-.111L4.347 8.126c-.114-.05-.166-.11-.187-.131l-.02.01Zm-.073-3.237.02-.02.167-.112L7.419 3.14a1.28 1.28 0 0 1 .54-.111c.207 0 .404.04.54.11l3.164 1.498c.114.05.166.111.187.132l-.02.02-.167.111-3.165 1.497a1.28 1.28 0 0 1-.54.112c-.207 0-.404-.04-.54-.112L4.255 4.9c-.114-.05-.166-.111-.187-.131Z" })));
}, NavCollapse: function(e) {
  return u.createElement("svg", Qv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TK || (TK = u.createElement("path", { fill: "currentColor", d: "M11.39 4.818a.5.5 0 0 0-.708 0L7.854 7.646a.5.5 0 0 0 0 .708l2.828 2.828a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L9.62 8l2.122-2.121a.5.5 0 0 0 0-.707l-.354-.354Z" })), BK || (BK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm1 1.5H4A1.5 1.5 0 0 0 2.5 4v8A1.5 1.5 0 0 0 4 13.5h1v-11Zm1.5 0v11H12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 12 2.5H6.5Z", clipRule: "evenodd" })));
}, NavExpand: function(e) {
  return u.createElement("svg", Jv({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IK || (IK = u.createElement("path", { fill: "currentColor", d: "M4.61 4.818a.5.5 0 0 1 .708 0l2.828 2.828a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L6.38 8 4.257 5.879a.5.5 0 0 1 0-.707l.354-.354Z" })), HK || (HK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8Zm-1 1.5h1A1.5 1.5 0 0 1 13.5 4v8a1.5 1.5 0 0 1-1.5 1.5h-1v-11Zm-1.5 0v11H4A1.5 1.5 0 0 1 2.5 12V4A1.5 1.5 0 0 1 4 2.5h5.5Z", clipRule: "evenodd" })));
}, NoFilter: function(e) {
  return u.createElement("svg", e6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DK || (DK = u.createElement("path", { fill: "currentColor", d: "M2.606 1.204a1 1 0 0 0-1.313 1.503L7 8.414v5.984a.5.5 0 0 0 .83.376l2.949-2.58 2.512 2.511a1 1 0 0 0 1.414-1.414l-1.818-1.818-.006.006L2.606 1.204ZM10.573 7.15A.25.25 0 0 0 11 6.972v-.825l3.8-3.94C15.202 1.79 14.957 1 14.425 1H5.027a.25.25 0 0 0-.176.427l5.722 5.722Z" })));
}, NotAllowed: function(e) {
  return u.createElement("svg", t6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zK || (zK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.75 8a3.75 3.75 0 0 1-5.485 3.326l5.06-5.06c.272.518.425 1.108.425 1.734ZM4.674 9.735l5.06-5.06a3.75 3.75 0 0 0-5.06 5.06ZM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z", clipRule: "evenodd" })));
}, Note: function(e) {
  return u.createElement("svg", n6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FK || (FK = u.createElement("path", { fill: "currentColor", d: "M4.5 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM4.5 8.75A.75.75 0 0 1 5.25 8h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" })), VK || (VK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m15 10-4 4H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6Zm-2-6H3v8h7v-2a1 1 0 0 1 1-1h2V4Z", clipRule: "evenodd" })));
}, OpenNewTab: function(e) {
  return u.createElement("svg", r6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qK || (qK = u.createElement("path", { fill: "currentColor", d: "M13.823 2.45a.278.278 0 0 0-.272-.273l-4.045-.079a.277.277 0 0 0-.201.474l1.08 1.08-2.45 2.452a1.395 1.395 0 0 0-.148.174L5.999 8.065a1.369 1.369 0 1 0 1.936 1.936l1.787-1.788c.061-.043.12-.093.174-.147l2.451-2.452 1.081 1.081a.277.277 0 0 0 .474-.201l-.079-4.045Z" })), UK || (UK = u.createElement("path", { fill: "currentColor", d: "M7.25 3.129a.75.75 0 0 1 0 1.5H4a.5.5 0 0 0-.5.5v6.864a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0v3.243a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.129a2 2 0 0 1 2-2h3.25Z" })));
}, Pause: function(e) {
  return u.createElement("svg", a6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WK || (WK = u.createElement("path", { fill: "currentColor", d: "M4.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1ZM10.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1Z" })));
}, Person: function(e) {
  return u.createElement("svg", l6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GK || (GK = u.createElement("path", { fill: "currentColor", d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })), KK || (KK = u.createElement("path", { fill: "currentColor", d: "M8 8c-.708 0-1.367-.21-1.918-.572A4.483 4.483 0 0 1 8 7c.686 0 1.336.154 1.918.428C9.368 7.79 8.708 8 8 8ZM4.591 8.562c.308-.357.838-.339 1.252-.112C6.483 8.8 7.218 9 8 9s1.517-.2 2.158-.55c.413-.227.943-.245 1.251.112A4.482 4.482 0 0 1 12.5 11.5V14h-9v-2.5c0-1.123.411-2.15 1.091-2.938Z" })));
}, PersonGroup: function(e) {
  return u.createElement("svg", i6({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YK || (YK = u.createElement("path", { fill: "currentColor", d: "M4.808 8.923a2.962 2.962 0 1 0 0-5.923 2.962 2.962 0 0 0 0 5.923ZM2.982 9.304c-.35-.192-.798-.207-1.059.095A3.793 3.793 0 0 0 1 11.885V14h7.615v-2.115c0-.95-.347-1.819-.923-2.486-.26-.302-.708-.287-1.059-.095a3.79 3.79 0 0 1-1.825.465 3.79 3.79 0 0 1-1.826-.465ZM9.615 11.885V13H15v-1.906c0-.734-.274-1.405-.727-1.92-.206-.234-.559-.222-.835-.074-.427.23-.917.36-1.438.36-.521 0-1.011-.13-1.438-.36-.276-.148-.63-.16-.835.073-.21.239-.38.51-.504.806.252.585.392 1.23.392 1.906ZM14.333 6.288c0 1.264-1.044 2.289-2.333 2.289-1.289 0-2.333-1.025-2.333-2.289C9.667 5.025 10.71 4 12 4c1.289 0 2.333 1.025 2.333 2.288Z" })));
}, PersonWithLock: function(e) {
  return u.createElement("svg", o6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XK || (XK = u.createElement("path", { fill: "currentColor", d: "M10 4.5A3.497 3.497 0 0 1 6.5 8a3.484 3.484 0 0 1-1.918-.572A3.5 3.5 0 1 1 10 4.5ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h6v-2.5c0-.445.194-.845.502-1.12.033-.82.393-1.554.954-2.076-.259-.051-.55.01-.799.146A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), QK || (QK = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 10.5v.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5v-.5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 0-1 1v.5h2v-.5a1 1 0 0 0-1-1Z", clipRule: "evenodd" })));
}, Pin: function(e) {
  return u.createElement("svg", s6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JK || (JK = u.createElement("path", { fill: "currentColor", d: "M10 8.5V3.3h.683a.65.65 0 1 0 0-1.3H5.317a.65.65 0 1 0 0 1.3H6v5.2L4.383 9.55a.843.843 0 0 0 .46 1.55h2.624v3.367a.533.533 0 0 0 1.066 0V11.1h2.624a.843.843 0 0 0 .46-1.55L10 8.5Z" })));
}, Play: function(e) {
  return u.createElement("svg", c6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eY || (eY = u.createElement("path", { fill: "currentColor", d: "M13.779 6.704a1.5 1.5 0 0 1 0 2.592l-7.523 4.388A1.5 1.5 0 0 1 4 12.388V3.612a1.5 1.5 0 0 1 2.256-1.296l7.523 4.388Z" })));
}, Plus: function(e) {
  return u.createElement("svg", u6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tY || (tY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v3.5H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9.5H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9.5V3a1 1 0 0 0-1-1h-1Z", clipRule: "evenodd" })));
}, PlusWithCircle: function(e) {
  return u.createElement("svg", f6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nY || (nY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z", clipRule: "evenodd" })));
}, Primary: function(e) {
  return u.createElement("svg", d6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rY || (rY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3-8.307C11 5.172 9.918 4 8.433 4H6v8h1.495V9.386h.938C9.918 9.386 11 8.214 11 6.693Zm-1.454 0c0 .653-.453 1.16-1.134 1.16h-.917v-2.32h.917c.68 0 1.134.506 1.134 1.16Z", clipRule: "evenodd" })));
}, Project: function(e) {
  return u.createElement("svg", p6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aY || (aY = u.createElement("path", { fill: "currentColor", d: "M1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 4V2Z" })), lY || (lY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 5.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75H2.75ZM6.25 7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1h-3.5Z", clipRule: "evenodd" })));
}, QuestionMarkWithCircle: function(e) {
  return u.createElement("svg", g6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iY || (iY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.932 5.612C7.054 5.298 7.425 5 7.942 5 8.615 5 9 5.478 9 5.875c0 .162-.057.33-.172.476a.985.985 0 0 1-.242.216l-.016.01a1.141 1.141 0 0 1-.098.054c-.59.286-1.53.967-1.53 2.119V9a1 1 0 0 0 2 0c0-.035.011-.12.138-.27a2.66 2.66 0 0 1 .587-.48 3 3 0 0 0 .726-.656A2.742 2.742 0 0 0 11 5.875C11 4.201 9.54 3 7.941 3c-1.275 0-2.43.745-2.873 1.888a1 1 0 1 0 1.864.724ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, Read: function(e) {
  return u.createElement("svg", h6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oY || (oY = u.createElement("path", { fill: "currentColor", d: "M10.011 8.762V4.185h-1.39c-.574 0-.84-.645-.406-.985l2.63-2.063a.669.669 0 0 1 .81 0l2.63 2.063c.433.34.168.985-.405.985h-1.31v4.577c0 .716-.572 1.297-1.28 1.297-.706 0-1.279-.58-1.279-1.297ZM8.823 9.158c-.814.19-1.677.283-2.448.283-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.2-.079.383-.164.548-.254a2.53 2.53 0 0 1-1.434-1.91Z" })), sY || (sY = u.createElement("path", { fill: "currentColor", d: "M6.787 3.479a10.514 10.514 0 0 0-.412-.008c-2.404 0-4.875.823-4.875 2.562 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.768 0 1.63-.101 2.418-.299V5.421H8.62c-.767 0-1.428-.45-1.706-1.125-.107-.26-.15-.54-.128-.817ZM11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729Z" })));
}, Recommended: function(e) {
  return u.createElement("svg", m6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cY || (cY = u.createElement("path", { fill: "currentColor", d: "m8.148 5.458-.944 1.968V9.59h2.099a.5.5 0 0 0 .491-.407l.223-1.182a.5.5 0 0 0-.491-.593h-.638a.623.623 0 0 1-.61-.636V5.708a.302.302 0 0 0-.13-.25Z" })), uY || (uY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.538 1.554a.75.75 0 0 0-1.076 0L6.4 2.648a.75.75 0 0 1-.615.224L4.27 2.716a.75.75 0 0 0-.824.692l-.11 1.52a.75.75 0 0 1-.328.567l-1.261.856a.75.75 0 0 0-.187 1.06l.893 1.235a.75.75 0 0 1 .113.644l-.416 1.467a.75.75 0 0 0 .538.932l1.478.373a.75.75 0 0 1 .501.42l.624 1.39a.75.75 0 0 0 1.011.369l1.372-.665a.75.75 0 0 1 .654 0l1.372.665a.75.75 0 0 0 1.011-.368l.624-1.391a.75.75 0 0 1 .5-.42l1.48-.373a.75.75 0 0 0 .537-.932l-.416-1.467a.75.75 0 0 1 .114-.644l.892-1.235a.75.75 0 0 0-.187-1.06l-1.261-.856a.75.75 0 0 1-.327-.566l-.11-1.52a.75.75 0 0 0-.825-.693l-1.517.156a.75.75 0 0 1-.614-.224L8.538 1.554Zm-1.064 3.28a.577.577 0 0 1 .518-.334c.639 0 1.157.54 1.157 1.208V6.5h.98c.549 0 .96.523.854 1.085l-.412 2.182a.881.881 0 0 1-.854.733H5.435c-.24 0-.435-.294-.435-.546V7.591c0-.251.195-.455.435-.455h.898c.013 0 .027 0 .04.002a.702.702 0 0 1 .03-.072l1.071-2.232Z", clipRule: "evenodd" })));
}, Redo: function(e) {
  return u.createElement("svg", v6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fY || (fY = u.createElement("path", { fill: "currentColor", d: "M4.018 9.402c-.05.328-.313.598-.645.598h-.8c-.331 0-.603-.27-.57-.6a5.996 5.996 0 0 1 2.543-4.325A5.997 5.997 0 0 1 7.974 4h.028c2.699 0 4.95 1.718 5.467 4h1.414c.541 0 .792.672.383 1.026l-2.482 2.15a.585.585 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.92 8h1.446c-.468-1.085-1.68-2-3.364-2a3.98 3.98 0 0 0-2.543.89 3.996 3.996 0 0 0-1.441 2.512Z" })));
}, Refresh: function(e) {
  return u.createElement("svg", b6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dY || (dY = u.createElement("path", { fill: "currentColor", d: "M8.033 2c2.699 0 4.95 1.718 5.467 4h1.414c.542 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.951 6h1.447c-.469-1.085-1.68-2-3.365-2-1.026 0-1.877.34-2.491.85-.243.202-.618.203-.817-.043l-.61-.754a.468.468 0 0 1 .044-.651C5.163 2.534 6.53 2 8.033 2ZM3.95 6.843a.584.584 0 0 0-.765 0L.703 8.992a.584.584 0 0 0 .383 1.026h1.418C3.03 12.291 5.275 14 7.967 14c1.505 0 2.87-.534 3.874-1.402a.468.468 0 0 0 .044-.65l-.61-.755c-.2-.246-.574-.245-.817-.043-.614.51-1.465.85-2.49.85-1.676 0-2.883-.904-3.358-1.982H6.05a.584.584 0 0 0 .383-1.026L3.95 6.842Z" })));
}, Relationship: function(e) {
  return u.createElement("svg", y6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pY || (pY = u.createElement("path", { fill: "currentColor", d: "M.5 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6a2.5 2.5 0 0 1 2.5 2.5v5A1.5 1.5 0 0 0 10 12h1.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H10a2.5 2.5 0 0 1-2.5-2.5v-5A1.5 1.5 0 0 0 6 4H4.5v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2Z" })));
}, ReplicaSet: function(e) {
  return u.createElement("svg", w6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gY || (gY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.39 7.713A3.488 3.488 0 0 1 8 8c-.494 0-.964-.102-1.39-.287L5.264 9.729a2.5 2.5 0 1 1-1.08-.634L5.57 7.02a3.5 3.5 0 1 1 4.86 0l1.385 2.076A2.501 2.501 0 0 1 15 11.5a2.5 2.5 0 1 1-4.265-1.77L9.391 7.712ZM9.75 4.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, Resize: function(e) {
  return u.createElement("svg", O6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hY || (hY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.77 5.72a.75.75 0 0 1 0 1.06l-7.991 8a.749.749 0 1 1-1.06-1.06l7.992-8a.749.749 0 0 1 1.06 0ZM14.78 10.22a.75.75 0 0 1 0 1.06l-3.496 3.5a.749.749 0 1 1-1.06-1.06l3.497-3.5a.749.749 0 0 1 1.06 0Z", clipRule: "evenodd" })));
}, Return: function(e) {
  return u.createElement("svg", x6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mY || (mY = u.createElement("path", { fill: "currentColor", d: "M5 2a1 1 0 0 0 0 2h5a2.5 2.5 0 0 1 0 5H5.203l1.448-1.24a1 1 0 1 0-1.302-1.52l-3.5 3a1 1 0 0 0 0 1.52l3.5 3a1 1 0 0 0 1.302-1.52L5.203 11H10a4.5 4.5 0 1 0 0-9H5Z" })));
}, Save: function(e) {
  return u.createElement("svg", E6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vY || (vY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 2 3.04 2 3.6 2h7.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l1.062 1.063c.173.173.26.26.322.36.055.09.095.188.12.29.027.115.027.237.027.482V12.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.2.102-.46.109-.954.109V9.284c0-.126 0-.25-.008-.353a1.01 1.01 0 0 0-.101-.385 1 1 0 0 0-.437-.437 1.01 1.01 0 0 0-.385-.1C11.465 8 11.342 8 11.216 8H4.784c-.126 0-.249 0-.353.008a1.01 1.01 0 0 0-.385.101 1 1 0 0 0-.437.437 1.01 1.01 0 0 0-.1.385c-.009.104-.009.227-.009.353V14c-.494 0-.753-.007-.954-.109a1 1 0 0 1-.437-.437C2 13.24 2 12.96 2 12.4V3.6Zm2-.1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z", clipRule: "evenodd" })), bY || (bY = u.createElement("path", { fill: "currentColor", d: "M11.5 9.3V14h-7V9.3c0-.148 0-.23.005-.288v-.006h.007C4.571 9 4.652 9 4.8 9h6.4c.148 0 .23 0 .288.005h.006v.007c.006.059.006.14.006.288Z" })));
}, Serverless: function(e) {
  return u.createElement("svg", C6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $Y || ($Y = u.createElement("path", { fill: "currentColor", d: "M2.132 10.849a5.5 5.5 0 1 1 8.4-6.571 4 4 0 0 1 4.398 6.444 1 1 0 0 1-.15.192l-1.77 1.898a1.995 1.995 0 0 1-1.51.688H7.792a2.5 2.5 0 1 1 0-2H11.5l1.166-1.25H8.5a3.75 3.75 0 0 0-6.368.599Z" })));
}, ShardedCluster: function(e) {
  return u.createElement("svg", k6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), CY || (CY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 2.75a1.75 1.75 0 0 1-2.123 1.71l-.619.866a3.497 3.497 0 0 1 1.186 2.049h1.17a1.75 1.75 0 1 1 0 1.25h-1.17a3.497 3.497 0 0 1-1.186 2.05l.619.865a1.75 1.75 0 1 1-1.046.686l-.662-.926a3.495 3.495 0 0 1-2.331.002l-.664.93a1.75 1.75 0 1 1-1.043-.69l.616-.863a3.497 3.497 0 0 1-1.191-2.054h-1.17a1.75 1.75 0 1 1 0-1.25h1.17c.147-.819.58-1.54 1.191-2.054l-.616-.863a1.75 1.75 0 1 1 1.043-.69l.664.93A3.494 3.494 0 0 1 8 4.5c.41 0 .803.07 1.17.2l.66-.926A1.75 1.75 0 1 1 13 2.75ZM9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, SearchIndex: function(e) {
  return u.createElement("svg", $6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yY || (yY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.816 12.754a2.786 2.786 0 0 0 3.396.424l1.622 1.622a.683.683 0 1 0 .966-.966l-1.622-1.622a2.786 2.786 0 1 0-4.362.542Zm2.972-2.972a1.419 1.419 0 1 1-2.006 2.006 1.419 1.419 0 0 1 2.006-2.006Z", clipRule: "evenodd" })), wY || (wY = u.createElement("path", { fill: "currentColor", d: "M12 3.667c0 .083 0 .165-.002.245L12 4v.214c0 .281-.124.55-.393.815-.275.27-.682.512-1.187.715-1.01.405-2.31.613-3.42.613-1.11 0-2.41-.208-3.42-.613-.505-.203-.912-.446-1.187-.715C2.123 4.765 2 4.495 2 4.214V4c0-.033 0-.066.002-.099A12.44 12.44 0 0 1 2 3.667C2 1.857 4.534 1 7 1s5 .857 5 2.667Z" })), OY || (OY = u.createElement("path", { fill: "currentColor", d: "M2 5.813v1.83c0 .28.124.55.393.815.275.269.682.511 1.187.714 1.01.406 2.31.614 3.42.614l.134-.001A3.785 3.785 0 0 1 12 7.2V5.812c-.357.297-.8.537-1.277.729-1.124.452-2.532.672-3.723.672-1.191 0-2.599-.22-3.723-.672C2.8 6.35 2.357 6.11 2 5.813ZM7 10.643h.003c-.03.816.201 1.64.696 2.334-.232.015-.466.023-.699.023-2.466 0-5-.857-5-2.667 0-.083 0-.165.002-.245A2.229 2.229 0 0 1 2 10v-.758c.357.297.8.537 1.277.729 1.124.451 2.532.672 3.723.672Z" })));
}, Secondary: function(e) {
  return u.createElement("svg", j6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xY || (xY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z", clipRule: "evenodd" })), EY || (EY = u.createElement("path", { fill: "currentColor", d: "M11 9.67C11 11.112 9.786 12 8.117 12 6.337 12 5.07 10.897 5 9.395h1.972c.07.674.594.996 1.2.996.594 0 .897-.245.897-.613 0-.399-.262-.598-.869-.767l-1.297-.367c-1.2-.337-1.751-1.257-1.751-2.376C5.152 4.95 6.2 4 7.924 4c1.517 0 2.676.889 2.786 2.421H8.807c-.097-.582-.497-.781-.91-.781-.483 0-.814.214-.814.582 0 .43.372.598.786.705l1.214.368C10.434 7.678 11 8.475 11 9.671Z" })));
}, Settings: function(e) {
  return u.createElement("svg", M6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jY || (jY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.207 1.067a.75.75 0 0 0-.89.247l-.374.506a6.214 6.214 0 0 0-1.894.002l-.375-.506a.75.75 0 0 0-.89-.246l-1.126.467a.75.75 0 0 0-.454.804l.093.623c-.505.37-.958.82-1.338 1.34l-.623-.093a.75.75 0 0 0-.803.455l-.466 1.127a.75.75 0 0 0 .247.89l.506.374a6.214 6.214 0 0 0 .002 1.893l-.506.376a.75.75 0 0 0-.246.89l.467 1.126a.75.75 0 0 0 .804.454l.623-.093c.37.505.82.958 1.34 1.338l-.093.623a.75.75 0 0 0 .455.803l1.127.466a.75.75 0 0 0 .89-.247l.374-.506a6.218 6.218 0 0 0 1.894-.002l.375.506a.75.75 0 0 0 .89.246l1.126-.467a.75.75 0 0 0 .454-.804l-.093-.623c.505-.37.958-.82 1.338-1.34l.623.093a.75.75 0 0 0 .803-.455l.466-1.127a.75.75 0 0 0-.247-.89l-.506-.374a6.218 6.218 0 0 0-.002-1.894l.506-.375a.75.75 0 0 0 .246-.89l-.467-1.126a.75.75 0 0 0-.804-.454l-.623.093a6.214 6.214 0 0 0-1.34-1.338l.093-.623a.75.75 0 0 0-.455-.803l-1.127-.466Zm.334 7.984A2.75 2.75 0 1 1 5.46 6.949a2.75 2.75 0 0 1 5.082 2.102Z", clipRule: "evenodd" })));
}, Shell: function(e) {
  return u.createElement("svg", P6({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), MY || (MY = u.createElement("path", { fill: "currentColor", d: "m1.8 5.2 3.4 2.2-3.79 2.526a.5.5 0 0 0-.142.688l.557.86a.5.5 0 0 0 .697.145L7.5 8.3c.3-.2.5-.5.5-.8 0-.3-.2-.6-.4-.8L2.522 3.284a.5.5 0 0 0-.699.143l-.547.847a.5.5 0 0 0 .155.695L1.8 5.2ZM6.7 13a.5.5 0 0 0 .5.5h7.7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.2a.5.5 0 0 0-.5.5v1Z" })));
}, SMS: function(e) {
  return u.createElement("svg", S6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kY || (kY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7.755L4.23 14.831c-.488.392-1.23.058-1.23-.555V12a2 2 0 0 1-2-2V4Zm2 .75A.75.75 0 0 1 3.75 4h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 4.75Zm0 3A.75.75 0 0 1 3.75 7h5.5a.75.75 0 1 1 0 1.5h-5.5A.75.75 0 0 1 3 7.75Z", clipRule: "evenodd" })));
}, SortAscending: function(e) {
  return u.createElement("svg", N6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), PY || (PY = u.createElement("path", { fill: "currentColor", d: "M4.45 1.143a.584.584 0 0 0-.765 0L1.203 3.292a.584.584 0 0 0 .383 1.026h1.312v9.352a1.169 1.169 0 1 0 2.338 0V4.318H6.55a.584.584 0 0 0 .383-1.026L4.45 1.142ZM8 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, SortDescending: function(e) {
  return u.createElement("svg", R6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), SY || (SY = u.createElement("path", { fill: "currentColor", d: "M4.45 14.696a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.025h1.312V2.168a1.169 1.169 0 1 1 2.338 0v9.351H6.55c.541 0 .792.673.383 1.027L4.45 14.696ZM8 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, Sparkle: function(e) {
  return u.createElement("svg", _6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), NY || (NY = u.createElement("path", { fill: "currentColor", d: "m6.273 2.893-.998 2.995c-.1.3-.336.536-.636.637l-2.995.998a.503.503 0 0 0 0 .954l2.995.998c.3.1.536.336.636.637l.998 2.995a.503.503 0 0 0 .955 0l.998-2.995c.1-.3.336-.536.636-.637l2.995-.998a.503.503 0 0 0 0-.954l-2.995-.998c-.3-.1-.536-.336-.636-.637l-.998-2.995a.503.503 0 0 0-.955 0ZM12.547 1.172l-.231.693c-.1.3-.336.536-.636.636l-.694.231c-.229.077-.229.401 0 .477l.694.231c.3.1.536.336.636.637l.23.693c.077.229.402.229.478 0l.231-.693c.1-.3.336-.536.636-.637l.693-.23c.23-.077.23-.401 0-.478l-.693-.23c-.3-.1-.536-.337-.636-.637l-.231-.693a.251.251 0 0 0-.477 0ZM12.547 11.23l-.231.693c-.1.3-.336.536-.636.636l-.694.232c-.229.076-.229.4 0 .477l.694.23c.3.1.536.337.636.637l.23.693c.077.23.402.23.478 0l.231-.693c.1-.3.336-.536.636-.636l.693-.231c.23-.077.23-.401 0-.477l-.693-.232c-.3-.1-.536-.335-.636-.636l-.231-.693a.251.251 0 0 0-.477 0Z" })));
}, SplitHorizontal: function(e) {
  return u.createElement("svg", A6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), RY || (RY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8Zm-2-4.5V3H3v3.5h10Zm-10 1V11h10V7.5H3Z", clipRule: "evenodd" })));
}, SplitVertical: function(e) {
  return u.createElement("svg", L6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), _Y || (_Y = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM7.5 3H3v8h4.5V3Zm1 8H13V3H8.5v8Z", clipRule: "evenodd" })));
}, Stitch: function(e) {
  return u.createElement("svg", Z6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), AY || (AY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h16v16H0V0Zm14 4V2H2v2h12Zm0 10V5H2v9h12ZM8 6v7H6V6h2Zm5 0v4H9V6h4ZM5 8v5H3V8h2Zm8 3v2H9v-2h4Z" })));
}, String: function(e) {
  return u.createElement("svg", T6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), LY || (LY = u.createElement("path", { fill: "currentColor", d: "M10.69 14H5.31l-.15-.137v-.754l.15-.138h.602c.376 0 .753-.342.753-.685V3.5h-.903c-2.05 0-2.54.729-2.671 1.826l-.15.137h-.828L2 5.326l.282-3.189.15-.137h11.135l.15.137L14 5.326l-.113.137h-.827l-.15-.137c-.133-1.097-.622-1.826-2.672-1.826h-.903v8.786c0 .343.377.685.753.685h.602l.15.138v.754l-.15.137Z" })));
}, Sun: function(e) {
  return u.createElement("svg", B6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ZY || (ZY = u.createElement("path", { fill: "currentColor", d: "M12.24 10.83a.996.996 0 1 0-1.41 1.41l.71.71a.996.996 0 1 0 1.41-1.41l-.71-.71ZM8 12c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55-.45-1-1-1ZM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM14 7h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1ZM3.76 10.83l-.71.71a.996.996 0 1 0 1.41 1.41l.71-.71a.996.996 0 1 0-1.41-1.41ZM8 4c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1ZM3.76 5.17a.996.996 0 1 0 1.41-1.41l-.71-.71a.996.996 0 1 0-1.41 1.41l.71.71ZM4 8c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1ZM12.24 5.17l.71-.71a.996.996 0 1 0-1.41-1.41l-.71.71a.996.996 0 1 0 1.41 1.41Z" })));
}, Support: function(e) {
  return u.createElement("svg", I6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), TY || (TY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7a3 3 0 0 1 6 0v2.5c0 1.51-.957 2.798-2.298 3.288a1 1 0 1 0 .265.967 4.512 4.512 0 0 0 2.787-2.785c.08.02.161.03.246.03h.5a2.5 2.5 0 0 0 .406-4.967 5.002 5.002 0 0 0-9.813 0A2.5 2.5 0 0 0 3.5 11H4a1 1 0 0 0 1-1V7Z", clipRule: "evenodd" })));
}, Sweep: function(e) {
  return u.createElement("svg", H6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), BY || (BY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 14.465 4 12.734c.292.169.631.266.999.266h2v2H5a3.982 3.982 0 0 1-2-.535ZM9 15v-2h2c.368 0 .707-.097.999-.266L13 14.464A3.982 3.982 0 0 1 11 15H9Zm6-8h-2V5c0-.368-.097-.707-.266-.999L14.464 3c.341.588.536 1.271.536 2v2ZM7 1H5c-.729 0-1.412.195-2 .535L4 3.266C4.293 3.097 4.632 3 5 3h2V1ZM1 9h2v2c0 .368.097.707.266.999L1.536 13A3.982 3.982 0 0 1 1 11V9Zm0-2h2V5c0-.368.097-.707.266-.999L1.536 3A3.982 3.982 0 0 0 1 5v2Zm8-6v2h2c.368 0 .707.097.999.266L13 1.536A3.982 3.982 0 0 0 11 1H9Zm6 8h-2v2c0 .368-.097.707-.266.999L14.464 13c.341-.588.536-1.271.536-2V9Z", clipRule: "evenodd" })));
}, Table: function(e) {
  return u.createElement("svg", D6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), IY || (IY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3.25C1 2.56 1.56 2 2.25 2h11.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 14 1 13.44 1 12.75v-9.5Zm2 4.12V4h4.37v3.37H3Zm0 1.25V12h4.37V8.62H3ZM8.62 12H13V8.62H8.62V12ZM13 7.37V4H8.62v3.37H13Z", clipRule: "evenodd" })));
}, Tag: function(e) {
  return u.createElement("svg", z6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), HY || (HY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m9.707 14.293 4.586-4.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 7.586 2H3a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, ThumbsDown: function(e) {
  return u.createElement("svg", F6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), DY || (DY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.019 15c.511 0 .98-.28 1.208-.724l2.501-4.837c.026-.05.05-.102.07-.155.03.003.06.004.092.004h2.094c.561 0 1.016-.441 1.016-.985V3.182C15 2.638 14.545 2 13.984 2H3.993C3.023 2 2.188 2.666 2 3.589L1.04 8.316c-.247 1.217.713 2.35 1.993 2.35H5.32v1.717C5.32 13.828 6.528 15 8.019 15Zm1.84-6.34-2.205 4.265a.642.642 0 0 1-.303-.542v-2.307c0-.762-.637-1.379-1.422-1.379H3.644a.5.5 0 0 1-.49-.6l.758-3.727a.5.5 0 0 1 .49-.4h5.456v4.69Z", clipRule: "evenodd" })));
}, ThumbsUp: function(e) {
  return u.createElement("svg", V6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zY || (zY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.981 1c-.511 0-.98.28-1.208.724L4.272 6.56c-.026.05-.05.102-.07.155a1.06 1.06 0 0 0-.092-.004H2.016c-.561 0-1.016.441-1.016.985v5.121C1 13.362 1.455 14 2.016 14h9.991c.97 0 1.805-.665 1.993-1.589l.961-4.727c.248-1.217-.713-2.35-1.993-2.35H10.68V3.616C10.68 2.172 9.472 1 7.981 1Zm-1.84 6.34 2.205-4.265a.642.642 0 0 1 .303.542v2.307c0 .762.637 1.379 1.422 1.379h2.285a.5.5 0 0 1 .49.6l-.758 3.727a.5.5 0 0 1-.49.4H6.142V7.34Z", clipRule: "evenodd" })));
}, TimeSeries: function(e) {
  return u.createElement("svg", q6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), FY || (FY = u.createElement("path", { fill: "currentColor", d: "M7.023 1.518c.513.024.957.363 1.12.853L9.38 6.108l1.56-2.092a1.24 1.24 0 0 1 1.872-.134l1.897 1.91c.388.39.388 1.023 0 1.413l-.377.354a.99.99 0 0 1-1.405 0l-.86-.89-2.122 2.847a1.239 1.239 0 0 1-2.172-.355L6.798 6.22 6.11 7.774c-.2.451-.644.742-1.135.742H1.994a.997.997 0 0 1-.994-1v-.5c0-.552.445-1 .994-1h2.174l1.66-3.758a1.242 1.242 0 0 1 1.195-.74ZM14 12a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h12Z" })));
}, TimeSeriesCollection: function(e) {
  return u.createElement("svg", U6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), VY || (VY = u.createElement("path", { fill: "currentColor", d: "M13.6 10.383H15c.6 0 1 .499 1 1.098 0 .598-.4.998-1 .998h-.9l-1.5 2.096c-.2.3-.6.499-1 .399-.4-.1-.7-.4-.8-.799l-.4-1.696-.4 1.197c-.1.3-.5.6-.9.6H8c-.6 0-1-.4-1-.999s.4-.998 1-.998h.4l1.4-3.693c.1-.4.6-.599 1-.599s.8.4.9.699l.6 2.794.5-.698c.2-.2.5-.4.8-.4Z" })), qY || (qY = u.createElement("path", { fill: "currentColor", d: "M1.929 1A.922.922 0 0 0 1 1.915v9.15c0 .505.416.915.929.915H5.84c.101-.173.225-.336.374-.485.322-.321.71-.526 1.118-.63l1.043-2.75c.208-.678.706-1.086 1.107-1.3A2.846 2.846 0 0 1 10.8 6.49c.682 0 1.214.323 1.531.591.318.269.635.66.792 1.131l.026.079.133.617a2.24 2.24 0 0 1 .318-.023h.4v-5.14a.922.922 0 0 0-.929-.915H7.5a.922.922 0 0 1-.929-.915A.922.922 0 0 0 5.643 1H1.929Z" })), UY || (UY = u.createElement("path", { fill: "currentColor", d: "M10.95 8.005a.699.699 0 0 0-.066-.012l.065.012Z" })));
}, Trash: function(e) {
  return u.createElement("svg", W6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), WY || (WY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2a1 1 0 0 1 1 1v1H2V3a1 1 0 0 1 1-1h2Zm9 3H2l1.678 8.392A2 2 0 0 0 5.64 15h4.72a2 2 0 0 0 1.962-1.608L14 5Z", clipRule: "evenodd" })));
}, Undo: function(e) {
  return u.createElement("svg", G6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), GY || (GY = u.createElement("path", { fill: "currentColor", d: "M11.981 9.402c.05.328.313.598.645.598h.8c.331 0 .603-.27.57-.6a5.996 5.996 0 0 0-2.543-4.325A5.997 5.997 0 0 0 8.026 4h-.029C5.298 4 3.047 5.718 2.53 8H1.116a.584.584 0 0 0-.383 1.026l2.482 2.15c.22.19.545.19.765 0l2.482-2.15A.584.584 0 0 0 6.079 8H4.632c.47-1.085 1.68-2 3.365-2a3.98 3.98 0 0 1 2.543.89 3.996 3.996 0 0 1 1.441 2.512Z" })));
}, University: function(e) {
  return u.createElement("svg", K6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), KY || (KY = u.createElement("path", { fill: "currentColor", d: "M8.5 4.613c0-.383.191-.74.51-.953a6.87 6.87 0 0 1 2.145-.949l2.406-.601a.353.353 0 0 1 .439.342v7.88c0 .238 0 .357-.043.453a.5.5 0 0 1-.176.211c-.087.06-.204.081-.438.123l-3.9.71c-.324.058-.486.088-.612.042a.5.5 0 0 1-.264-.22c-.067-.116-.067-.28-.067-.61V4.613ZM2 2.452c0-.23.216-.398.439-.342l2.407.601a6.87 6.87 0 0 1 2.144.95c.319.211.51.569.51.952v6.428c0 .33 0 .494-.067.61a.5.5 0 0 1-.264.22c-.126.046-.288.016-.612-.043l-3.9-.709c-.234-.042-.35-.063-.438-.123a.5.5 0 0 1-.176-.21C2 10.688 2 10.57 2 10.331v-7.88ZM2.008 12.41a.5.5 0 0 1 .581-.402l5.143.935c.177.032.359.032.536 0l5.143-.935a.5.5 0 0 1 .178.984l-4.134.752c-.163.434-.753.756-1.455.756-.702 0-1.292-.322-1.455-.756l-4.134-.752a.5.5 0 0 1-.403-.581Z" })));
}, Unlock: function(e) {
  return u.createElement("svg", Y6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), YY || (YY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.157 4.221A2 2 0 0 1 10 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1V5a4 4 0 0 0-7.822-1.182C3.982 4.45 4.538 5 5.2 5c.442 0 .785-.372.957-.779Zm2.43 6.589A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, Unsorted: function(e) {
  return u.createElement("svg", X6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), XY || (XY = u.createElement("path", { fill: "currentColor", d: "M3.685 1.143c.22-.19.545-.19.765 0l2.482 2.149a.584.584 0 0 1-.383 1.026H5.236v7.364H6.55c.541 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.026h1.312V4.318H1.586a.584.584 0 0 1-.383-1.026l2.482-2.15ZM8 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H9ZM8 11a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" })));
}, UpDownCarets: function(e) {
  return u.createElement("svg", Q6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), QY || (QY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.527 1.21a.638.638 0 0 1 .948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562Zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 0 1-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654Z" })));
}, Upload: function(e) {
  return u.createElement("svg", J6({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), JY || (JY = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.297 11v.938a4 4 0 1 0-.764-7.66A5.501 5.501 0 0 0 0 6.5a5.5 5.5 0 0 0 5.797 5.492V11h-.403c-1.395 0-2.08-1.7-1.075-2.667L7.472 5.3a1.55 1.55 0 0 1 2.15 0l3.152 3.034C13.78 9.301 13.094 11 11.7 11h-.402ZM8.339 6.2a.3.3 0 0 1 .416 0l3.152 3.034a.3.3 0 0 1-.208.516h-1.652v3.75a1.5 1.5 0 0 1-3 0V9.75H5.394a.3.3 0 0 1-.208-.516L8.339 6.2Z", clipRule: "evenodd" })));
}, VerticalEllipsis: function(e) {
  return u.createElement("svg", e7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eX || (eX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM7.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", clipRule: "evenodd" })));
}, Visibility: function(e) {
  return u.createElement("svg", t7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tX || (tX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2.008c3.934 0 6.473 3.129 7.455 4.583l.043.064C15.713 6.97 16 7.391 16 8s-.287 1.03-.502 1.345l-.043.064c-.982 1.454-3.521 4.583-7.455 4.583S1.527 10.863.545 9.41l-.043-.064C.287 9.03 0 8.609 0 8s.287-1.03.502-1.345l.043-.064C1.527 5.137 4.066 2.008 8 2.008ZM9.13 4.13A5.147 5.147 0 0 0 8 4.005C5.75 4.005 3.927 5.794 3.927 8c0 2.206 1.824 3.995 4.073 3.995 2.25 0 4.073-1.789 4.073-3.995 0-2.206-1.824-3.995-4.073-3.995.378 0 .756.045 1.13.126ZM8 10.996c1.687 0 3.055-1.341 3.055-2.996S9.687 5.004 8 5.004 4.945 6.345 4.945 8 6.313 10.996 8 10.996Z", clipRule: "evenodd" })));
}, VisibilityOff: function(e) {
  return u.createElement("svg", n7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nX || (nX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.601 1.266a1.03 1.03 0 0 0-1.433.049L1.704 13.486a.987.987 0 0 0 .062 1.407 1.03 1.03 0 0 0 1.433-.049l1.793-1.904A7.348 7.348 0 0 0 8 13.587c3.934 0 6.473-3.133 7.455-4.59l.043-.063c.215-.316.502-.737.502-1.347s-.287-1.03-.502-1.346l-.043-.065a12.85 12.85 0 0 0-1.949-2.275l1.157-1.228a.987.987 0 0 0-.062-1.407Zm-2.93 4.585-.764.81c.096.292.148.603.148.926 0 1.657-1.368 3-3.055 3-.246 0-.485-.028-.714-.082l-.763.81c.458.176.956.272 1.477.272 2.25 0 4.073-1.79 4.073-4 0-.622-.145-1.211-.403-1.736ZM8 1.587c.919 0 1.762.171 2.526.452L8.98 3.68A5.13 5.13 0 0 0 8 3.587c-2.25 0-4.073 1.79-4.073 4 0 .435.07.853.201 1.245l-1.985 2.107A13.06 13.06 0 0 1 .545 8.998l-.043-.064C.287 8.618 0 8.197 0 7.587s.287-1.03.502-1.346l.043-.065C1.527 4.72 4.066 1.587 8 1.587Zm0 2c.327 0 .654.034.978.095l-.016.017A4.155 4.155 0 0 0 8 3.587Zm0 1c.041 0 .083 0 .124.002L4.966 7.942a2.978 2.978 0 0 1-.02-.355c0-1.657 1.367-3 3.054-3Z", clipRule: "evenodd" })));
}, Warning: function(e) {
  return u.createElement("svg", r7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rX || (rX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.864 1.514a.983.983 0 0 0-1.728 0L1.122 12.539A.987.987 0 0 0 1.986 14h12.028a.987.987 0 0 0 .864-1.461L8.864 1.514ZM7 5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V5Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, Wizard: function(e) {
  return u.createElement("svg", a7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aX || (aX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.327 3.277c.188-.38-.236-.8-.618-.613l-2.513 1.223a.461.461 0 0 1-.523-.095L7.603 1.74c-.314-.313-.829-.062-.75.365l.517 2.808a.421.421 0 0 1-.228.46L4.63 6.596c-.383.186-.277.761.154.839l2.832.513a.477.477 0 0 1 .382.379l.517 2.808c.079.427.659.532.846.153l1.234-2.492a.427.427 0 0 1 .464-.225l2.832.512c.43.078.683-.432.368-.744l-2.07-2.052a.452.452 0 0 1-.095-.519l1.233-2.491ZM7 10.5c.353-.35.312-.958-.091-1.359-.404-.4-1.017-.44-1.37-.09L1.84 12.713c-.353.35-.312.958.092 1.358.403.4 1.017.44 1.37.09L7 10.5Z", clipRule: "evenodd" })));
}, Wrench: function(e) {
  return u.createElement("svg", l7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lX || (lX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.625 9.75a4.374 4.374 0 0 0 4.206-5.584c-.085-.295-.449-.36-.665-.145l-2.1 2.1a.44.44 0 0 1-.184.11c-.078.024-.157-.013-.215-.07L9.84 4.332c-.058-.058-.095-.137-.071-.215a.44.44 0 0 1 .11-.184l2.1-2.1c.216-.216.147-.58-.145-.664a4.374 4.374 0 0 0-5.385 5.512.32.32 0 0 1-.077.32l-4.828 4.829a1.857 1.857 0 0 0 2.625 2.625l4.828-4.828a.32.32 0 0 1 .323-.075c.412.129.851.197 1.305.197ZM2.75 14.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z", clipRule: "evenodd" })));
}, Write: function(e) {
  return u.createElement("svg", i7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iX || (iX = u.createElement("path", { fill: "currentColor", d: "M8.71 3.75a9.487 9.487 0 0 0-2.335-.28c-2.404 0-4.875.824-4.875 2.563 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.267 0 .546-.013.828-.037a1.76 1.76 0 0 1-.288-1.818 1.826 1.826 0 0 1 1.706-1.125h.09V3.75ZM8.068 9.305c-.578.091-1.158.136-1.693.136-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.22-.086.42-.18.598-.282a1.85 1.85 0 0 1-.209-.141l-2.03-1.594Z" })), oX || (oX = u.createElement("path", { fill: "currentColor", d: "M11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729ZM12.489 2.297v4.576h1.39c.574 0 .84.646.406.986l-2.63 2.063a.668.668 0 0 1-.81 0l-2.63-2.063c-.433-.34-.168-.986.406-.986H9.93V2.297C9.93 1.58 10.502 1 11.21 1c.706 0 1.279.58 1.279 1.297Z" })));
}, X: function(e) {
  return u.createElement("svg", o7({ xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sX || (sX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.203 3.404a1 1 0 0 0-1.414 0L8.314 5.879 5.839 3.404a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L6.192 8l-2.474 2.475a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l2.475-2.475 2.475 2.475a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L10.435 8l2.475-2.475a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, XWithCircle: function(e) {
  return u.createElement("svg", s7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cX || (cX = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.414-9.828a1 1 0 1 1 1.414 1.414L9.414 8l1.414 1.414a1 1 0 1 1-1.414 1.414L8 9.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L6.586 8 5.172 6.586a1 1 0 0 1 1.414-1.414L8 6.586l1.414-1.414Z", clipRule: "evenodd" })));
} }, QPe = Object.keys(uX).reduce(function(e, t) {
  return e[t] = KPe(t, uX[t]), e;
}, {}), JPe = XPe(QPe);
function fX(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fX(Object(n), !0).forEach(function(r) {
      Xt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fX(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function eSe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r);
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Xt(e, t, n) {
  return (t = eSe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ka() {
  return ka = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ka.apply(this, arguments);
}
function Eo(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function en(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function tSe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r !== 0)
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return dX(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return dX(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function dX(e, t) {
  t > e.length && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var pX, gX, hX, mX, vX, bX, yX, wX, OX, xX, EX, $X, jX, CX, MX, kX, PX, SX, $y = qPe("lg-chat-rich-link"), nSe = v(pX || (pX = en([`
  box-shadow: none;
  padding: `, `px;
  border-radius: `, `px;
  text-decoration: none;
  min-height: `, `px;
  min-width: 100px;

  & .`, ` {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`])), ee[200], ee[200], ee[900], $y), rSe = Xt(Xt({}, Vo.Dark, v(gX || (gX = en([`
    background-color: `, `;

    &:hover {
      box-shadow: 0 0 0 3px `, `;
    }
  `])), b.gray.dark4, b.gray.dark2)), Vo.Light, v(hX || (hX = en([`
    background-color: `, `;

    &:hover {
      box-shadow: 0 0 0 3px `, `;
    }
  `])), b.gray.light3, b.gray.light2)), aSe = v(mX || (mX = en([`
  // Extra padding to make room for the absolutely positioned badge
  // We have to account for the badge as well as "fake padding" from the "bottom" and "left" attributes.
  // 1. "fake padding" below the badge (spacing[200])
  // 2. badge height (18)
  // 3. "fake padding" on top of the badge (spacing[200])
  padding-bottom: calc(`, "px + 18px + ", `px);
`])), ee[200], ee[200]), lSe = function(e) {
  return v(vX || (vX = en([`
  background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)),
    url(`, `);
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  border-radius: `, `px;
  min-height: `, `px;

  & .`, ` {
    color: `, `;
  }
`])), e, ee[200], ee[900], $y, b.white);
}, NX = "gray", RX = "blue", _X = "green", AX = "purple", LX = "red", ZX = "yellow", iSe = v(bX || (bX = en([`
  display: inline-flex;
  gap: `, `px;
  align-items: center;
  border-radius: `, `px;
  padding: 0px `, `px;
  position: absolute;
  bottom: `, `px;
  left: `, `px;
`])), ee[150], ee[100], ee[150], ee[200], ee[200]), oSe = Xt(Xt({}, Vo.Dark, Xt(Xt(Xt(Xt(Xt(Xt({}, NX, v(yX || (yX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.gray.dark1, b.gray.light3, b.gray.light3)), RX, v(wX || (wX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.blue.dark3, b.blue.light2, b.blue.light2)), _X, v(OX || (OX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.green.dark3, b.green.light2, b.green.light2)), LX, v(xX || (xX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.red.dark3, b.red.light2, b.red.light2)), AX, v(EX || (EX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.purple.dark3, b.purple.light2, b.purple.light2)), ZX, v($X || ($X = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.yellow.dark3, b.yellow.light2, b.yellow.light2))), Vo.Light, Xt(Xt(Xt(Xt(Xt(Xt({}, NX, v(jX || (jX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.gray.light2, b.gray.dark1, b.black)), RX, v(CX || (CX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.blue.light3, b.blue.dark2, b.blue.dark1)), _X, v(MX || (MX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.green.light3, b.green.dark2, b.green.dark3)), LX, v(kX || (kX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.red.light3, b.red.dark2, b.red.dark3)), AX, v(PX || (PX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.purple.light3, b.purple.dark2, b.purple.dark3)), ZX, v(SX || (SX = en([`
      background-color: `, `;
      & svg {
        color: `, `;
      }
      & p {
        color: `, `;
      }
    `])), b.yellow.light3, b.yellow.dark2, b.yellow.dark3))), sSe = function(e) {
  var t = e.darkMode, n = e.glyph, r = e.color, l = r === void 0 ? "gray" : r, i = e.label, c = K(t).theme;
  return k.createElement("div", { className: H(iSe, oSe[c][l]) }, n ? k.createElement(JPe, { glyph: n }) : null, k.createElement(xy, null, i));
};
function cSe(e) {
  return function(t) {
    return k.createElement(jy, ka({}, e, t));
  };
}
var TX, uSe = Object.entries({ Blog: { badgeColor: "green", badgeLabel: "Blog", badgeGlyph: "SMS" }, Book: { badgeColor: "yellow", badgeLabel: "Book", badgeGlyph: "University" }, Code: { badgeColor: "gray", badgeLabel: "Code", badgeGlyph: "CodeBlock" }, Docs: { badgeColor: "blue", badgeLabel: "Docs", badgeGlyph: "Note" }, Learn: { badgeColor: "red", badgeLabel: "Learn", badgeGlyph: "Cap" }, Video: { badgeColor: "red", badgeLabel: "Video", badgeGlyph: "Play" }, Website: { badgeColor: "purple", badgeLabel: "Website", badgeGlyph: "Laptop" } }).reduce(function(e, t) {
  var n = tSe(t, 2), r = n[0], l = n[1];
  return yi(yi({}, e), {}, Xt({}, r, cSe(l)));
}, {}), fSe = ["darkMode"], dSe = ["variant"], pSe = ["children", "imageUrl", "badgeGlyph", "badgeLabel", "badgeColor", "href"], jy = wn(function(e, t) {
  var n, r = e.darkMode, l = Eo(e, fSe), i = K(r), c = i.darkMode, f = i.theme;
  if ("variant" in l) {
    var d = l.variant, h = Eo(l, dSe), g = uSe[d];
    return k.createElement(g, ka({ darkMode: c }, h));
  }
  var m = yi(yi({}, { badgeGlyph: void 0, badgeLabel: void 0, badgeColor: void 0 }), l), y = m.children, w = m.imageUrl, C = m.badgeGlyph, E = m.badgeLabel, R = m.badgeColor, M = m.href, P = Eo(m, pSe), a = E !== void 0, o = ((n = w == null ? void 0 : w.length) !== null && n !== void 0 ? n : -1) > 0;
  return k.createElement(n2, ka({ darkMode: c, ref: t, className: H(nSe, rSe[f], Xt(Xt({}, aSe, a), lSe(w ?? ""), o)), as: "a" }, yi({ target: "_blank", href: M }, P)), k.createElement(xy, { className: $y, darkMode: c }, y), a ? k.createElement(sSe, { darkMode: c, color: R, label: E, glyph: C }) : null);
});
jy.displayName = "RichLink";
var gSe = v(TX || (TX = en([`
  display: grid;
  gap: `, `px;
  grid-template-columns: repeat(2, 1fr);

  @container (min-width: 360px) {
    grid-template-columns: repeat(3, 1fr);
  }
`])), ee[200]), hSe = ["links", "darkMode"];
function j5e(e) {
  var t = e.links, n = e.darkMode, r = Eo(e, hSe), l = K(n).darkMode;
  return k.createElement(Fn, { darkMode: l }, k.createElement("div", ka({ className: H(gSe) }, r), t.map(function(i) {
    return k.createElement(jy, ka({ key: i.href }, i));
  })));
}
j5e.displayName = "RichLinksArea";
function mSe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r);
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Qt(e, t, n) {
  return (t = mSe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function da() {
  return da = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, da.apply(this, arguments);
}
function zi(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Gt(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function C5e(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r !== 0)
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return BX(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return BX(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function BX(e, t) {
  t > e.length && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var IX, HX, DX, vSe = v(IX || (IX = Gt([`
  // Remove the Banner's left border wedge
  &:before {
    content: '';
    background: transparent;
  }
  // Customize the border
  border-width: `, `px;
  border-radius: `, `px;

  max-width: fit-content;
  padding: `, "px ", `px;
`])), ee[25], ee[600], ee[200], ee[300]), bSe = v(HX || (HX = Gt([`
  border-radius: `, `px;
`])), ee[300]), ySe = ["className", "darkMode", "children", "variant"];
function M5e(e) {
  var t = e.className;
  e.darkMode;
  var n = e.children, r = e.variant, l = r === void 0 ? "info" : r, i = zi(e, ySe), c = Dn(null), f = C5e(ht(!1), 2), d = f[0], h = f[1], g = cn();
  return Tt(function() {
    if (c.current) {
      var m = g === 14 ? 38 : 46;
      h(c.current.clientHeight > m);
    }
  }, [n, g]), k.createElement(a2, da({ ref: c, className: H(vSe, Qt({}, bSe, d), t), variant: l }, i), n);
}
M5e.displayName = "MessageBanner";
var wSe = v(DX || (DX = Gt([`
  margin-bottom: `, `px;
`])), ee[400]);
function OSe(e) {
  var t = e.verifier, n = e.verifiedAt, r = e.learnMoreUrl, l = kt(function() {
    var i = ["Verified"];
    if (t && i.push("by ".concat(t)), n) {
      var c = n.toLocaleDateString(void 0, { year: "numeric", month: "long", day: "numeric" });
      i.push("on ".concat(c));
    }
    return i.join(" ");
  }, [t, n]);
  return k.createElement(M5e, { className: wSe, variant: "success" }, l, r ? k.createElement(k.Fragment, null, " | ", k.createElement(u7e, { href: r }, "Learn More")) : null);
}
var zX, FX, VX, qX, UX, Cy = "primary", k5e = "secondary", xSe = v(zX || (zX = Gt([`
  border-radius: 12px;
  padding: `, `px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  /* Card Shadow */
  box-shadow: 0px 4px 10px -4px `, `4D; // 4D is 30% opacity

  position: relative;

  display: flex;
  flex-direction: column;
  gap: `, `px;
`])), ee[4], b.black, ee[200]), ESe = Qt(Qt({}, Cy, Qt(Qt({}, S.Dark, v(FX || (FX = Gt([`
      background-color: `, `;
    `])), b.green.dark3)), S.Light, v(VX || (VX = Gt([`
      background-color: `, `;
    `])), b.green.light3))), k5e, Qt(Qt({}, S.Dark, v(qX || (qX = Gt([`
      background-color: `, `;
    `])), b.gray.dark3)), S.Light, v(UX || (UX = Gt([`
      background-color: `, `;
    `])), b.white))), $Se = ["children", "className", "variant", "darkMode"];
function P5e(e) {
  var t = e.children, n = e.className, r = e.variant, l = r === void 0 ? Cy : r, i = e.darkMode, c = zi(e, $Se), f = K(i).theme;
  return k.createElement("div", da({ className: H(xSe, ESe[l][f], n) }, c), t);
}
P5e.displayName = "MessageContainer";
var WX, GX, KX, YX, S5e = { Markdown: "markdown", Text: "text" }, jSe = ["children", "sourceType", "baseFontSize", "markdownProps"];
function My(e) {
  var t = e.children, n = e.sourceType, r = e.baseFontSize, l = e.markdownProps, i = zi(e, jSe), c = null;
  return n === S5e.Markdown ? c = k.createElement(h5e, da({ baseFontSize: r }, i, l), t) : c = t, k.createElement("div", i, c);
}
My.displayName = "MessageContent";
var XX, QX, JX, eQ, tQ, nQ, rQ, aQ, lQ, iQ, CSe = v(WX || (WX = Gt([`
  container-type: inline-size;
  margin-bottom: `, `px;
`])), ee[200]), MSe = Qt(Qt({}, S.Dark, v(GX || (GX = Gt([`
    border: 1px solid `, `;
  `])), b.gray.dark2)), S.Light, v(KX || (KX = Gt([`
    border: 1px solid `, `;
  `])), b.gray.light2)), kSe = v(YX || (YX = Gt([`
  margin-bottom: `, `px;
`])), ee[200]), PSe = ["darkMode", "headingText", "links"];
function N5e(e) {
  var t = e.darkMode, n = e.headingText, r = n === void 0 ? "Related Resources" : n, l = e.links, i = zi(e, PSe), c = K(t).theme;
  return k.createElement("div", da({ className: H(CSe) }, i), k.createElement("hr", { className: H(MSe[c]) }), k.createElement(Wce, { className: H(kSe) }, r), k.createElement(j5e, { links: l }));
}
N5e.displayName = "MessageLinks";
var oQ = gt("lg-message"), vu = gt("lg-message"), sQ = gt("lg-message-avatar"), SSe = v(XX || (XX = Gt([`
  display: flex;
  gap: `, `px;
  align-items: flex-end;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: `, `px;
  }
`])), ee[200], ee[3]), NSe = v(QX || (QX = Gt([`
  justify-content: flex-end;
`]))), RSe = v(JX || (JX = Gt([`
  gap: `, `px;
`])), ee[3]), _Se = v(eQ || (eQ = Gt([`
  &:not(:last-child) {
    margin-bottom: `, `px;
  }
`])), ee[4]), cQ = v(tQ || (tQ = Gt([`
  display: none;
`]))), uQ = v(nQ || (nQ = Gt([`
  display: block;
  visibility: hidden;
`]))), ASe = v(rQ || (rQ = Gt([`
  max-width: `, `px;
`])), il.Tablet), fQ = v(aQ || (aQ = Gt([`
  // Left wedge
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: `, `px;
    height: 100%;
    border-radius: 24px 0px 0px 24px;
  }
`])), ee[200]), LSe = Qt(Qt({}, S.Dark, v(lQ || (lQ = Gt([`
    `, `
    &:before {
      background-color: `, `;
    }
  `])), fQ, b.green.base)), S.Light, v(iQ || (iQ = Gt([`
    `, `
    &:before {
      background-color: `, `;
    }
  `])), fQ, b.green.dark2)), ZSe = "right", TSe = "left", BSe = ["isSender", "sourceType", "avatar", "align", "messageBody", "className", "children", "componentOverrides", "links", "linksHeading", "markdownProps", "verified", "darkMode", "baseFontSize"], R5e = wn(function(e, t) {
  var n, r, l, i = e.isSender, c = i === void 0 || i, f = e.sourceType, d = e.avatar, h = e.align, g = e.messageBody, m = e.className, y = e.children, w = e.componentOverrides, C = e.links, E = e.linksHeading, R = e.markdownProps, M = e.verified, P = e.darkMode, a = e.baseFontSize, o = zi(e, BSe), s = Jse().containerWidth, p = Dn(null), O = t || p, x = K(P), N = x.darkMode, T = x.theme, $ = h === ZSe || !h && c, j = h === TSe || !h && !c, A = C5e(ht(!0), 2), Z = A[0], G = A[1], I = function() {
    return !!s && s < il.Tablet;
  }, F = a ?? (I() ? W.Body1 : W.Body2);
  Tt(function() {
    if (O.current)
      if (O.current.nextElementSibling && O.current.nextElementSibling.classList.contains(oQ)) {
        var B = c && !O.current.nextElementSibling.classList.contains(vu), L = !c && O.current.nextElementSibling.classList.contains(vu);
        G(B || L);
      } else
        G(!0);
  }, [O.current]);
  var U = M !== void 0;
  return k.createElement(Fn, { darkMode: N }, k.createElement("div", da({ className: H(SSe, oQ, Qt(Qt(Qt(Qt({}, vu, c), NSe, $), RSe, !I()), _Se, !!s && s >= il.Desktop), m), ref: O }, o), k.createElement("div", { className: H(sQ, Qt(Qt({}, cQ, $ && I()), uQ, $ && !I() || !Z)) }, d), k.createElement("div", { className: ASe }, k.createElement(Sc, { as: (n = w == null ? void 0 : w.MessageContainer) !== null && n !== void 0 ? n : P5e, variant: c ? Cy : k5e, className: H(Qt({}, LSe[T], U)) }, U ? k.createElement(OSe, M) : null, k.createElement(Sc, da({ as: (r = w == null ? void 0 : w.MessageContent) !== null && r !== void 0 ? r : My, sourceType: f, baseFontSize: F }, R), g ?? ""), C ? k.createElement(Sc, { as: (l = w == null ? void 0 : w.MessageLinks) !== null && l !== void 0 ? l : N5e, headingText: E, links: C }) : null, y)), k.createElement("div", { className: H(sQ, Qt(Qt({}, cQ, j && I()), uQ, j && !I() || !Z)) }, d)));
});
R5e.displayName = "Message";
var _5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(_5e);
var ISe = _5e.exports;
const HSe = /* @__PURE__ */ ce(ISe);
var A5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(A5e);
var DSe = A5e.exports;
const zSe = /* @__PURE__ */ ce(DSe);
var L5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(L5e);
var FSe = L5e.exports;
const VSe = /* @__PURE__ */ ce(FSe);
function qSe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Qe(e, t, n) {
  return (t = qSe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _n() {
  return _n = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _n.apply(this, arguments);
}
function mr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Me(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function USe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return dQ(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return dQ(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function dQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var pQ, gQ, hQ, mQ, vQ, bQ, yQ, wQ, Hl = v(pQ || (pQ = Me([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), Z5e = Qe(Qe({}, W.Body1, v(gQ || (gQ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(hQ || (hQ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), WSe = Qe(Qe({}, W.Body1, v(mQ || (mQ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(vQ || (vQ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), _1 = Qe(Qe({}, S.Light, v(bQ || (bQ = Me([`
    color: `, `;
  `])), b.black)), S.Dark, v(yQ || (yQ = Me([`
    color: `, `;
  `])), b.gray.light2)), Dl = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, GSe = ["baseFontSize", "darkMode", "className", "weight", "as"], ky = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = mr(e, GSe), h = K(n).theme, g = Dl(t), m = ne(f).Component, y = v(wQ || (wQ = Me([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, _n({ className: H(Hl, Z5e[g], _1[h], y, r) }, d));
});
ky.displayName = "Body";
var OQ, xQ, EQ, $Q, jQ, CQ, MQ, kQ, PQ, SQ, KSe = { label: "lg-label", description: "lg-description" };
v(OQ || (OQ = Me([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Qe(Qe({}, S.Light, v(xQ || (xQ = Me([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(EQ || (EQ = Me([`
    color: `, `;
  `])), b.gray.light1));
Qe(Qe({}, S.Light, v($Q || ($Q = Me([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(jQ || (jQ = Me([`
    color: `, `;
  `])), b.gray.dark1));
Qe(Qe({}, W.Body1, v(CQ || (CQ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(MQ || (MQ = Me([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var NQ, RQ, _Q, AQ, LQ;
Qe(Qe({}, S.Light, v(kQ || (kQ = Me([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(PQ || (PQ = Me([`
    color: `, `;
  `])), b.gray.light1));
v(SQ || (SQ = Me([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var ZQ, TQ, BQ, IQ, HQ, DQ, YSe = v(NQ || (NQ = Me([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), XSe = Qe(Qe({}, S.Light, v(RQ || (RQ = Me([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(_Q || (_Q = Me([`
    color: `, `;
  `])), b.red.light1)), QSe = Qe(Qe({}, W.Body1, v(AQ || (AQ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(LQ || (LQ = Me([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), JSe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = mr(e, JSe), f = K(r).theme, d = Dl(), h = ne(n).Component;
  return k.createElement(h, _n({}, c, { className: H(YSe, XSe[f], QSe[d], i) }), l);
});
var eNe = v(ZQ || (ZQ = Me([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), tNe = Qe(Qe({}, S.Light, v(TQ || (TQ = Me([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(BQ || (BQ = Me([`
    color: `, `;
  `])), b.gray.light2)), nNe = ["darkMode", "className", "as"], rNe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = mr(e, nNe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, _n({ className: H(Hl, eNe, tNe[c], n) }, i));
});
rNe.displayName = "H1";
var zQ, aNe = v(IQ || (IQ = Me([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), lNe = Qe(Qe({}, S.Light, v(HQ || (HQ = Me([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(DQ || (DQ = Me([`
    color: `, `;
  `])), b.gray.light2)), iNe = ["darkMode", "className", "as"], oNe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = mr(e, iNe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, _n({ className: H(Hl, aNe, lNe[c], n) }, i));
});
oNe.displayName = "H2";
var FQ, VQ, qQ, UQ, WQ, GQ, KQ, YQ, XQ, QQ, sNe = v(zQ || (zQ = Me([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), cNe = ["darkMode", "className", "as"], uNe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = mr(e, cNe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, _n({ className: H(Hl, sNe, _1[c], n) }, i));
});
uNe.displayName = "H3";
var JQ, eJ, tJ, ml = gt(), fNe = v(FQ || (FQ = Me([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, ml), dNe = Qe(Qe({}, S.Light, v(VQ || (VQ = Me([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, ml, b.gray.light2, b.gray.light1)), S.Dark, v(qQ || (qQ = Me([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, ml, b.gray.dark2, b.gray.dark1)), pNe = Qe(Qe({}, S.Light, v(UQ || (UQ = Me([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ml, it[S.Light].default, b.blue.base)), S.Dark, v(WQ || (WQ = Me([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ml, it[S.Dark].default, b.blue.base)), gNe = Qe(Qe({}, S.Light, v(GQ || (GQ = Me([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(KQ || (KQ = Me([`
    color: `, `;
  `])), b.blue.light1)), hNe = v(YQ || (YQ = Me([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), mNe = v(XQ || (XQ = Me([`
  white-space: nowrap;
`]))), vNe = v(QQ || (QQ = Me([`
  white-space: normal;
`]))), bNe = ["children", "className", "darkMode", "baseFontSize", "as"], nJ = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = mr(e, bNe), g = K(c).theme, m = Dl(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? mNe : vNe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(WSe[m], fNe, dNe[g], pNe[g], w, Qe({}, gNe[g], C), i) }, l);
  return C ? k.createElement(y, _n({ className: H(ml, hNe, i) }, h), E) : k.cloneElement(E, h);
});
nJ.displayName = "InlineCode", nJ.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var rJ, aJ, lJ, iJ, oJ, sJ, cJ;
v(JQ || (JQ = Me([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Qe(Qe({}, S.Light, v(eJ || (eJ = Me([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(tJ || (tJ = Me([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var uJ, fJ, dJ, yNe = v(rJ || (rJ = Me([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), wNe = Qe(Qe({}, S.Light, v(aJ || (aJ = Me([`
    color: `, `;
  `])), b.black)), S.Dark, v(lJ || (lJ = Me([`
    color: `, `;
  `])), b.gray.light2)), ONe = Qe(Qe({}, S.Light, v(iJ || (iJ = Me([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(oJ || (oJ = Me([`
    color: `, `;
  `])), b.gray.dark1)), xNe = Qe(Qe({}, W.Body1, v(sJ || (sJ = Me([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(cJ || (cJ = Me([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), ENe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], $Ne = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? KSe.label : h, m = mr(e, ENe), y = K(n).theme, w = Dl(t), C = ne(d).Component;
  return k.createElement(C, _n({ "data-lgid": g, className: H(yNe, wNe[y], xNe[w], Qe({}, ONe[y], c), r) }, m), l);
});
$Ne.displayName = "Label";
var pJ, gJ, hJ, mJ, vJ, bJ, qo = gt(), T5e = v(uJ || (uJ = Me([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), B5e = Qe(Qe({}, S.Light, v(fJ || (fJ = Me([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(dJ || (dJ = Me([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), I5e = function(e) {
  if (e)
    return Z5e[e];
}, jNe = v(pJ || (pJ = Me([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), CNe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = mr(e, CNe), d = K(i).theme, h = Dl(l), g = nt(c, f, "span").Component;
  return k.createElement(g, _n({ className: H(qo, T5e, I5e(h), B5e[d], jNe, r), ref: t }, f), k.createElement(HSe, { role: "presentation" }), n);
});
var MNe = v(gJ || (gJ = Me([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), kNe = v(hJ || (hJ = Me([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), qo, qo), PNe = v(mJ || (mJ = Me([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), SNe = "hover", NNe = "persist", yJ = "none", RNe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? yJ : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = mr(e, RNe), y = USe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Dl(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== yJ && (E = k.createElement(zSe, { role: "presentation", size: 12, className: H(Qe(Qe({}, kNe, i === SNe), MNe, i === NNe)) })) : E = k.createElement(VSe, { role: "presentation", className: PNe }), k.createElement(P, _n({ className: H(qo, T5e, I5e(M), B5e[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var _Ne = v(vJ || (vJ = Me([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), ANe = ["darkMode", "className", "as"], LNe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = mr(e, ANe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, _n({ className: H(Hl, _Ne, _1[c], n) }, i));
});
LNe.displayName = "Overline";
var ZNe = v(bJ || (bJ = Me([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), TNe = ["darkMode", "className", "as"], BNe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = mr(e, TNe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, _n({ className: H(Hl, ZNe, _1[c], n) }, i));
});
BNe.displayName = "Subtitle";
var wJ;
v(wJ || (wJ = Me([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function INe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function pa(e, t, n) {
  return (t = INe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function c7() {
  return c7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, c7.apply(this, arguments);
}
function HNe(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function kr(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var OJ, xJ, EJ, $J, jJ, CJ, H5e = z9({ hasSelectedPrompt: !1 });
function u7(e) {
  var t = e.hasSelectedPrompt, n = e.children;
  return k.createElement(H5e.Provider, { value: { hasSelectedPrompt: t } }, n);
}
u7.displayName = "MessagePromptsProvider", u7.propTypes = { children: z.node };
var MJ, kJ, PJ, SJ, DNe = v(OJ || (OJ = kr([`
  display: block;
  padding: `, "px ", `px;
  margin-bottom: `, `px;
  border: 1px solid `, `;
  border-radius: 12px;
  transition: all `, `ms ease;
  box-shadow: none;
  outline: none;
  text-align: left;
  &:not(:last-of-type) {
    margin-bottom: `, `px;
  }
  &[aria-disabled='false'][aria-pressed='false'] {
    cursor: pointer;
  }
`])), ee[2], ee[3], ee[2], b.green.dark1, It.slower, ee[1]), zNe = pa(pa({}, S.Dark, v(xJ || (xJ = kr([`
    background: `, `;
    color: `, `;

    &[aria-pressed='false'][aria-disabled='false']:hover {
      box-shadow: `, `;
    }

    &[aria-pressed='false'][aria-disabled='false']:focus-visible {
      box-shadow: `, `;
    }
  `])), b.black, b.gray.light2, gn.dark.green, it.dark.default)), S.Light, v(EJ || (EJ = kr([`
    background: `, `;
    color: `, `;

    &[aria-pressed='false'][aria-disabled='false']:hover {
      box-shadow: `, `;
    }

    &[aria-pressed='false'][aria-disabled='false']:focus-visible {
      box-shadow: `, `;
    }
  `])), b.white, b.gray.dark3, gn.light.green, it.light.default)), FNe = pa(pa({}, S.Dark, v($J || ($J = kr([`
    border-color: `, `;
    color: `, `;
    background: `, `;
  `])), b.gray.dark1, b.gray.dark1, b.gray.dark3)), S.Light, v(jJ || (jJ = kr([`
    border-color: `, `;
    color: `, `;
  `])), b.gray.base, b.gray.base)), VNe = v(CJ || (CJ = kr([`
  box-shadow: 0 0 0 2px `, `;
`])), b.green.dark1), D5e = wn(function(e, t) {
  var n = e.children, r = e.onClick, l = e.disabled, i = e.selected, c = e.className, f = e.darkMode, d = jl(H5e).hasSelectedPrompt, h = K(f).theme, g = l ?? (!i && d);
  return k.createElement("button", { className: H(DNe, zNe[h], pa(pa({}, FNe[h], g), VNe, i), c), onClick: g ? void 0 : r, "aria-disabled": !!g, "aria-pressed": !!i, tabIndex: i || g ? 0 : 1, ref: t }, k.createElement(ky, { style: { color: "inherit" } }, n));
});
D5e.displayName = "MessagePrompt";
var qNe = v(MJ || (MJ = kr([`
  margin-bottom: `, `px;
  transition: opacity `, `ms ease-in;
`])), ee[4], It.slower), UNe = v(kJ || (kJ = kr([`
  margin-bottom: `, `px;
`])), ee[2]), WNe = pa(pa({}, S.Dark, v(PJ || (PJ = kr([`
    color: `, `;
  `])), b.gray.light1)), S.Light, v(SJ || (SJ = kr([`
    color: `, `;
  `])), b.gray.dark1)), GNe = ["children", "label", "darkMode"], z5e = wn(function(e, t) {
  var n = e.children, r = e.label, l = e.darkMode, i = HNe(e, GNe), c = K(l).theme, f = k.Children.toArray(n).some(function(d) {
    return lr(d, "MessagePrompt") && d.props.selected;
  });
  return k.createElement(u7, { hasSelectedPrompt: f }, k.createElement("div", null, r && k.createElement(ky, { className: H(UNe, WNe[c]) }, r), k.createElement("div", c7({ className: qNe, ref: t }, i), n)));
});
z5e.displayName = "MessagePrompts";
var F5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ThumbsDown", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.01852 15C8.53023 15 8.99812 14.7199 9.22744 14.2764L11.728 9.43945C11.7542 9.38879 11.7773 9.33683 11.7972 9.28386C11.8277 9.28652 11.8584 9.28788 11.8896 9.28788L13.9843 9.28788C14.5453 9.28788 15 8.84694 15 8.30303L15 3.18182C15 2.6379 14.5453 2 13.9844 2L11.8896 2C11.6144 2 11 2 11 2C11 2 10.3639 2 9.85827 2L3.99311 2C3.02273 2 2.18787 2.66552 2.00017 3.5887L1.03904 8.31597C0.791531 9.53331 1.7524 10.6667 3.03198 10.6667L5.31958 10.6667L5.31958 12.3829C5.31958 13.8283 6.52794 15 8.01852 15ZM9.85827 8.66091L7.65371 12.9252C7.47137 12.8096 7.35088 12.6099 7.35088 12.3829L7.35088 10.0758C7.35088 9.31427 6.71427 8.69697 5.92897 8.69697L3.64387 8.69697C3.32769 8.69697 3.09089 8.40718 3.15389 8.09735L3.9117 4.37008C3.95907 4.1371 4.16394 3.9697 4.40168 3.9697L9.85827 3.9697L9.85827 8.66091Z", fill: "currentColor" }));
    };
    return P.displayName = "ThumbsDown", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(F5e);
var KNe = F5e.exports;
const YNe = /* @__PURE__ */ ce(KNe);
var V5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ThumbsUp", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.98148 1C7.46977 1 7.00188 1.28007 6.77256 1.72365L4.27198 6.56054C4.24579 6.61121 4.22269 6.66317 4.20275 6.71614C4.17234 6.71348 4.14155 6.71212 4.11043 6.71212H2.01565C1.45472 6.71212 1 7.15306 1 7.69697V12.8182C1 13.3621 1.45472 14 2.01565 14H4.11043C4.38564 14 5 14 5 14C5 14 5.63614 14 6.14173 14H12.0069C12.9773 14 13.8121 13.3345 13.9998 12.4113L14.961 7.68402C15.2085 6.46669 14.2476 5.33333 12.968 5.33333H10.6804V3.61709C10.6804 2.17171 9.47206 1 7.98148 1ZM6.14173 7.33909L8.34629 3.0748C8.52863 3.19038 8.64912 3.39009 8.64912 3.61709V5.92424C8.64912 6.68572 9.28573 7.30303 10.071 7.30303H12.3561C12.6723 7.30303 12.9091 7.59282 12.8461 7.90265L12.0883 11.6299C12.0409 11.8629 11.8361 12.0303 11.5983 12.0303L6.14173 12.0303V7.33909Z", fill: "currentColor" }));
    };
    return P.displayName = "ThumbsUp", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(V5e);
var XNe = V5e.exports;
const QNe = /* @__PURE__ */ ce(XNe);
var q5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(q5e);
var JNe = q5e.exports;
const eRe = /* @__PURE__ */ ce(JNe);
var U5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(U5e);
var tRe = U5e.exports;
const nRe = /* @__PURE__ */ ce(tRe);
var W5e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(W5e);
var rRe = W5e.exports;
const aRe = /* @__PURE__ */ ce(rRe);
function lRe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ze(e, t, n) {
  return (t = lRe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function bn() {
  return bn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bn.apply(this, arguments);
}
function Kn(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function ke(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function iRe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return NJ(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return NJ(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function NJ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var RJ, _J, AJ, LJ, ZJ, TJ, BJ, IJ, zl = v(RJ || (RJ = ke([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), G5e = ze(ze({}, W.Body1, v(_J || (_J = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(AJ || (AJ = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), oRe = ze(ze({}, W.Body1, v(LJ || (LJ = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(ZJ || (ZJ = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), A1 = ze(ze({}, S.Light, v(TJ || (TJ = ke([`
    color: `, `;
  `])), b.black)), S.Dark, v(BJ || (BJ = ke([`
    color: `, `;
  `])), b.gray.light2)), Ia = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, sRe = ["baseFontSize", "darkMode", "className", "weight", "as"], cRe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = Kn(e, sRe), h = K(n).theme, g = Ia(t), m = ne(f).Component, y = v(IJ || (IJ = ke([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, bn({ className: H(zl, G5e[g], A1[h], y, r) }, d));
});
cRe.displayName = "Body";
var HJ, DJ, zJ, FJ, VJ, qJ, UJ, WJ, GJ, KJ, K5e = { label: "lg-label", description: "lg-description" }, uRe = v(HJ || (HJ = ke([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular), fRe = ze(ze({}, S.Light, v(DJ || (DJ = ke([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(zJ || (zJ = ke([`
    color: `, `;
  `])), b.gray.light1)), dRe = ze(ze({}, S.Light, v(FJ || (FJ = ke([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(VJ || (VJ = ke([`
    color: `, `;
  `])), b.gray.dark1)), pRe = ze(ze({}, W.Body1, v(qJ || (qJ = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(UJ || (UJ = ke([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), gRe = ["baseFontSize", "data-lgid", "darkMode", "disabled", "children", "className"], Y5e = function(e) {
  var t = e.baseFontSize, n = e["data-lgid"], r = n === void 0 ? K5e.description : n, l = e.darkMode, i = e.disabled, c = i !== void 0 && i, f = e.children, d = e.className, h = Kn(e, gRe), g = K(l).theme, m = Ia(t);
  return k.createElement("p", bn({ "data-lgid": r, className: H(uRe, fRe[g], pRe[m], ze({}, dRe[g], c), d) }, h), f);
};
Y5e.displayName = "Description";
var YJ, XJ, QJ, JJ, eee;
ze(ze({}, S.Light, v(WJ || (WJ = ke([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(GJ || (GJ = ke([`
    color: `, `;
  `])), b.gray.light1));
v(KJ || (KJ = ke([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var tee, nee, ree, aee, lee, iee, hRe = v(YJ || (YJ = ke([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), mRe = ze(ze({}, S.Light, v(XJ || (XJ = ke([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(QJ || (QJ = ke([`
    color: `, `;
  `])), b.red.light1)), vRe = ze(ze({}, W.Body1, v(JJ || (JJ = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(eee || (eee = ke([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), bRe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = Kn(e, bRe), f = K(r).theme, d = Ia(), h = ne(n).Component;
  return k.createElement(h, bn({}, c, { className: H(hRe, mRe[f], vRe[d], i) }), l);
});
var yRe = v(tee || (tee = ke([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), wRe = ze(ze({}, S.Light, v(nee || (nee = ke([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(ree || (ree = ke([`
    color: `, `;
  `])), b.gray.light2)), ORe = ["darkMode", "className", "as"], xRe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = Kn(e, ORe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, bn({ className: H(zl, yRe, wRe[c], n) }, i));
});
xRe.displayName = "H1";
var oee, ERe = v(aee || (aee = ke([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), $Re = ze(ze({}, S.Light, v(lee || (lee = ke([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(iee || (iee = ke([`
    color: `, `;
  `])), b.gray.light2)), jRe = ["darkMode", "className", "as"], CRe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = Kn(e, jRe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, bn({ className: H(zl, ERe, $Re[c], n) }, i));
});
CRe.displayName = "H2";
var see, cee, uee, fee, dee, pee, gee, hee, mee, vee, MRe = v(oee || (oee = ke([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), kRe = ["darkMode", "className", "as"], PRe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = Kn(e, kRe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, bn({ className: H(zl, MRe, A1[c], n) }, i));
});
PRe.displayName = "H3";
var bee, yee, wee, vl = gt(), SRe = v(see || (see = ke([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, vl), NRe = ze(ze({}, S.Light, v(cee || (cee = ke([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, vl, b.gray.light2, b.gray.light1)), S.Dark, v(uee || (uee = ke([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, vl, b.gray.dark2, b.gray.dark1)), RRe = ze(ze({}, S.Light, v(fee || (fee = ke([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), vl, it[S.Light].default, b.blue.base)), S.Dark, v(dee || (dee = ke([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), vl, it[S.Dark].default, b.blue.base)), _Re = ze(ze({}, S.Light, v(pee || (pee = ke([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(gee || (gee = ke([`
    color: `, `;
  `])), b.blue.light1)), ARe = v(hee || (hee = ke([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), LRe = v(mee || (mee = ke([`
  white-space: nowrap;
`]))), ZRe = v(vee || (vee = ke([`
  white-space: normal;
`]))), TRe = ["children", "className", "darkMode", "baseFontSize", "as"], Oee = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = Kn(e, TRe), g = K(c).theme, m = Ia(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? LRe : ZRe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(oRe[m], SRe, NRe[g], RRe[g], w, ze({}, _Re[g], C), i) }, l);
  return C ? k.createElement(y, bn({ className: H(vl, ARe, i) }, h), E) : k.cloneElement(E, h);
});
Oee.displayName = "InlineCode", Oee.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var xee, Eee, $ee, jee, Cee, Mee, kee;
v(bee || (bee = ke([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
ze(ze({}, S.Light, v(yee || (yee = ke([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(wee || (wee = ke([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var Pee, See, Nee, BRe = v(xee || (xee = ke([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), IRe = ze(ze({}, S.Light, v(Eee || (Eee = ke([`
    color: `, `;
  `])), b.black)), S.Dark, v($ee || ($ee = ke([`
    color: `, `;
  `])), b.gray.light2)), HRe = ze(ze({}, S.Light, v(jee || (jee = ke([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(Cee || (Cee = ke([`
    color: `, `;
  `])), b.gray.dark1)), DRe = ze(ze({}, W.Body1, v(Mee || (Mee = ke([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(kee || (kee = ke([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), zRe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], FRe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? K5e.label : h, m = Kn(e, zRe), y = K(n).theme, w = Ia(t), C = ne(d).Component;
  return k.createElement(C, bn({ "data-lgid": g, className: H(BRe, IRe[y], DRe[w], ze({}, HRe[y], c), r) }, m), l);
});
FRe.displayName = "Label";
var Ree, _ee, Aee, Lee, Zee, Tee, Uo = gt(), X5e = v(Pee || (Pee = ke([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), Q5e = ze(ze({}, S.Light, v(See || (See = ke([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(Nee || (Nee = ke([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), J5e = function(e) {
  if (e)
    return G5e[e];
}, VRe = v(Ree || (Ree = ke([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), qRe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = Kn(e, qRe), d = K(i).theme, h = Ia(l), g = nt(c, f, "span").Component;
  return k.createElement(g, bn({ className: H(Uo, X5e, J5e(h), Q5e[d], VRe, r), ref: t }, f), k.createElement(eRe, { role: "presentation" }), n);
});
var URe = v(_ee || (_ee = ke([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), WRe = v(Aee || (Aee = ke([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Uo, Uo), GRe = v(Lee || (Lee = ke([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), KRe = "hover", YRe = "persist", Bee = "none", XRe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? Bee : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = Kn(e, XRe), y = iRe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Ia(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== Bee && (E = k.createElement(nRe, { role: "presentation", size: 12, className: H(ze(ze({}, WRe, i === KRe), URe, i === YRe)) })) : E = k.createElement(aRe, { role: "presentation", className: GRe }), k.createElement(P, bn({ className: H(Uo, X5e, J5e(M), Q5e[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var QRe = v(Zee || (Zee = ke([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), JRe = ["darkMode", "className", "as"], e_e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = Kn(e, JRe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, bn({ className: H(zl, QRe, A1[c], n) }, i));
});
e_e.displayName = "Overline";
var t_e = v(Tee || (Tee = ke([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), n_e = ["darkMode", "className", "as"], r_e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = Kn(e, n_e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, bn({ className: H(zl, t_e, A1[c], n) }, i));
});
r_e.displayName = "Subtitle";
var Iee;
v(Iee || (Iee = ke([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function a_e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Pa(e, t, n) {
  return (t = a_e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wo() {
  return Wo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wo.apply(this, arguments);
}
function efe(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Pr(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function l_e(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Hee(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return Hee(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Hee(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Dee, zee, Fee, Vee, qee, Uee, Wee, Gee, Kee, Yee, i_e = Pa(Pa({}, S.Dark, v(Dee || (Dee = Pr([`
    border-color: `, `;
    background: `, `;
    &:hover {
      border-color: `, `;
      background: `, `;
      box-shadow: none;
    }
  `])), b.white, b.gray.light2, b.white, b.gray.light2)), S.Light, v(zee || (zee = Pr([`
    background: `, `;
    &:hover {
      background: `, `; // override default hover
      box-shadow: none;
    }
    &:focus-visible {
      box-shadow: none;
    }
  `])), b.black, b.black)), o_e = v(Fee || (Fee = Pr([`
  overflow: hidden; // for ripple
  display: flex;
  height: 28px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border: 1px solid;
`]))), s_e = Pa(Pa({}, S.Dark, v(Vee || (Vee = Pr([`
    border: 1px solid `, `;
    background: `, `;
    &:hover {
      box-shadow: `, `;
      background: `, `;
    }
    &:focus-visible {
      box-shadow: `, `;
      background: `, `;
    }
  `])), b.gray.dark1, b.gray.dark2, gn.dark.gray, b.gray.dark1, it.dark.default, b.gray.dark1)), S.Light, v(qee || (qee = Pr([`
    border: 1px solid `, `;
    background: `, `;
    &:hover {
      box-shadow: `, `;
    }
    &:focus-visible {
      box-shadow: `, `;
    }
  `])), b.gray.dark1, b.gray.light3, gn.light.gray, it.light.default)), c_e = v(Uee || (Uee = Pr([`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  height: 100%;
  cursor: pointer;
`])));
v(Wee || (Wee = Pr([`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 5px;
`])));
var u_e = ["id", "className", "name", "children", "darkMode", "checked"], f7 = wn(function(e, t) {
  var n = e.id, r = e.className, l = e.name, i = e.children, c = e.darkMode, f = e.checked, d = efe(e, u_e), h = K(c).theme;
  return k.createElement("div", { className: H(o_e, s_e[h], Pa({}, i_e[h], f), r), ref: t, tabIndex: 0 }, k.createElement("input", Wo({ id: n, type: "radio", name: l, defaultChecked: f, "aria-checked": f, hidden: !0 }, d)), k.createElement("label", { htmlFor: n, className: c_e }, i));
});
f7.displayName = "RadioButton";
var f_e = v(Gee || (Gee = Pr([`
  display: flex;
  align-items: center;
  gap: 12px;
`]))), d_e = v(Kee || (Kee = Pr([`
  display: flex;
  align-items: center;
  gap: 4px;
`]))), Xee = function(e, t) {
  return e ? t ? b.black : b.gray.light2 : t ? b.gray.light3 : b.gray.dark1;
}, Qee = v(Yee || (Yee = Pr([`
  display: none;
`]))), p_e = ["description", "className", "value", "onChange", "darkMode", "hideThumbsDown", "hideThumbsUp"], tfe = wn(function(e, t) {
  var n = e.description, r = n === void 0 ? "How was the response?" : n, l = e.className, i = e.value, c = e.onChange, f = e.darkMode, d = e.hideThumbsDown, h = e.hideThumbsUp, g = efe(e, p_e), m = i !== void 0, y = l_e(ht(), 2), w = y[0], C = y[1], E = K(f).darkMode, R = m ? i === "liked" : w === "liked", M = m ? i === "disliked" : w === "disliked", P = Hn({ prefix: "message-rating" }), a = function(o) {
    c(o), m || C(o.target.value);
  };
  return k.createElement(Fn, { darkMode: E }, k.createElement("div", Wo({ className: H(f_e, l) }, g, { ref: t }), k.createElement(Y5e, null, r), k.createElement("div", { className: d_e }, k.createElement(f7, { id: "like-".concat(P), "aria-label": "Thumbs up this message", name: P, value: "liked", onChange: a, checked: R, className: H(Pa({}, Qee, h)) }, k.createElement(QNe, { fill: Xee(E, R) })), k.createElement(f7, { id: "dislike-".concat(P), name: P, value: "disliked", "aria-label": "Thumbs down this message", onChange: a, checked: M, className: H(Pa({}, Qee, d)) }, k.createElement(YNe, { fill: Xee(E, M) })))));
});
tfe.displayName = "MessageRating";
function g_e() {
  return jl(_ge);
}
var nfe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "X", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2028 3.40381C11.8123 3.01329 11.1791 3.01329 10.7886 3.40381L8.3137 5.87869L5.83883 3.40381C5.44831 3.01329 4.81514 3.01329 4.42462 3.40381L3.71751 4.11092C3.32699 4.50144 3.32699 5.13461 3.71751 5.52513L6.19238 8.00001L3.71751 10.4749C3.32699 10.8654 3.32699 11.4986 3.71751 11.8891L4.42462 12.5962C4.81514 12.9867 5.44831 12.9867 5.83883 12.5962L8.3137 10.1213L10.7886 12.5962C11.1791 12.9867 11.8123 12.9867 12.2028 12.5962L12.9099 11.8891C13.3004 11.4986 13.3004 10.8654 12.9099 10.4749L10.435 8.00001L12.9099 5.52513C13.3004 5.13461 13.3004 4.50144 12.9099 4.11092L12.2028 3.40381Z", fill: "currentColor" }));
    };
    return P.displayName = "X", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(nfe);
var h_e = nfe.exports;
const m_e = /* @__PURE__ */ ce(h_e);
function v_e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ga(e, t, n) {
  return (t = v_e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function d7() {
  return d7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d7.apply(this, arguments);
}
function rfe(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
var Jee, p7 = { Small: "small", Default: "default", Large: "large", XLarge: "xlarge" }, b_e = { small: 14, default: 16, large: 20, xlarge: 24 }, y_e = ["className", "size", "fill", "title", "aria-labelledby", "aria-label", "role"];
function w_e(e, t) {
  var n = function(r) {
    var l, i, c = r.className, f = r.size, d = f === void 0 ? p7.Default : f, h = r.fill, g = r.title, m = r["aria-labelledby"], y = r["aria-label"], w = r.role, C = w === void 0 ? "img" : w, E = rfe(r, y_e), R = v(Jee || (l = [`
      color: `, `;
    `], i || (i = l.slice(0)), Jee = Object.freeze(Object.defineProperties(l, { raw: { value: Object.freeze(i) } }))), h), M = typeof d == "number" ? d : b_e[d];
    return C !== "img" && C !== "presentation" && console.warn("Please provide a valid role to this component. Valid options are 'img' and 'presentation'. If you'd like the Icon to be accessible to screen readers please use 'img', otherwise set the role to 'presentation'."), k.createElement(t, d7({ className: H(Ga({}, R, h != null), c), height: M, width: M, role: C }, function(P, a, o) {
      var s, p = o["aria-label"], O = o["aria-labelledby"], x = o.title;
      switch (P) {
        case "img":
          return p || O || x ? Ga(Ga(Ga({}, "aria-labelledby", O), "aria-label", p), "title", x) : { "aria-label": (s = a, "".concat(s.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
        case "presentation":
          return { "aria-hidden": !0, alt: "" };
      }
    }(C, e, Ga(Ga({ title: g }, "aria-label", y), "aria-labelledby", m)), E));
  };
  return n.displayName = e, n.isGlyph = !0, n.propTypes = { fill: z.string, size: z.oneOfType([z.oneOf(Object.values(p7)), z.number]), className: z.string }, n;
}
var ete, O_e = ["glyph"];
function x_e(e) {
  var t = function(n) {
    var r = n.glyph, l = rfe(n, O_e), i = e[r];
    if (i)
      return k.createElement(i, l);
    var c = Object.keys(e).find(function(f) {
      return Cr(f) === Cr(r);
    });
    return console.error("Error in Icon", 'Could not find glyph named "'.concat(r, '" in the icon set.'), c && 'Did you mean "'.concat(c, '?"')), k.createElement(k.Fragment, null);
  };
  return t.displayName = "Icon", t.isGlyph = !0, t.propTypes = { glyph: z.oneOf(Object.keys(e)).isRequired, size: z.oneOfType([z.oneOf(Object.values(p7)), z.number]) }, t;
}
function g7() {
  return g7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g7.apply(this, arguments);
}
var tte;
function h7() {
  return h7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h7.apply(this, arguments);
}
var nte;
function m7() {
  return m7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m7.apply(this, arguments);
}
var rte;
function v7() {
  return v7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v7.apply(this, arguments);
}
var ate;
function b7() {
  return b7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b7.apply(this, arguments);
}
var lte;
function y7() {
  return y7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y7.apply(this, arguments);
}
var ite;
function w7() {
  return w7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w7.apply(this, arguments);
}
var ote;
function O7() {
  return O7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O7.apply(this, arguments);
}
var ste;
function x7() {
  return x7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x7.apply(this, arguments);
}
var cte;
function E7() {
  return E7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E7.apply(this, arguments);
}
var ute;
function $7() {
  return $7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $7.apply(this, arguments);
}
var fte;
function j7() {
  return j7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j7.apply(this, arguments);
}
var dte;
function C7() {
  return C7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C7.apply(this, arguments);
}
var pte;
function M7() {
  return M7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M7.apply(this, arguments);
}
var gte, hte;
function k7() {
  return k7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k7.apply(this, arguments);
}
var mte, vte, bte;
function P7() {
  return P7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P7.apply(this, arguments);
}
var yte, wte;
function S7() {
  return S7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S7.apply(this, arguments);
}
var Ote, xte;
function N7() {
  return N7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N7.apply(this, arguments);
}
var Ete;
function R7() {
  return R7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R7.apply(this, arguments);
}
var $te;
function _7() {
  return _7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _7.apply(this, arguments);
}
var jte;
function A7() {
  return A7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A7.apply(this, arguments);
}
var Cte;
function L7() {
  return L7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L7.apply(this, arguments);
}
var Mte;
function Z7() {
  return Z7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z7.apply(this, arguments);
}
var kte;
function T7() {
  return T7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T7.apply(this, arguments);
}
var Pte;
function B7() {
  return B7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B7.apply(this, arguments);
}
var Ste;
function I7() {
  return I7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I7.apply(this, arguments);
}
var Nte;
function H7() {
  return H7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H7.apply(this, arguments);
}
var Rte;
function D7() {
  return D7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D7.apply(this, arguments);
}
var _te;
function z7() {
  return z7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z7.apply(this, arguments);
}
var Ate;
function F7() {
  return F7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F7.apply(this, arguments);
}
var Lte;
function V7() {
  return V7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V7.apply(this, arguments);
}
var Zte, Tte;
function q7() {
  return q7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q7.apply(this, arguments);
}
var Bte, Ite;
function U7() {
  return U7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U7.apply(this, arguments);
}
var Hte;
function W7() {
  return W7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W7.apply(this, arguments);
}
var Dte;
function G7() {
  return G7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G7.apply(this, arguments);
}
var zte, Fte;
function K7() {
  return K7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K7.apply(this, arguments);
}
var Vte;
function Y7() {
  return Y7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y7.apply(this, arguments);
}
var qte;
function X7() {
  return X7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X7.apply(this, arguments);
}
var Ute;
function Q7() {
  return Q7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q7.apply(this, arguments);
}
var Wte;
function J7() {
  return J7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J7.apply(this, arguments);
}
var Gte;
function eb() {
  return eb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, eb.apply(this, arguments);
}
var Kte;
function tb() {
  return tb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tb.apply(this, arguments);
}
var Yte;
function nb() {
  return nb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nb.apply(this, arguments);
}
var Xte, Qte, Jte;
function rb() {
  return rb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rb.apply(this, arguments);
}
var ene;
function ab() {
  return ab = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ab.apply(this, arguments);
}
var tne;
function lb() {
  return lb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lb.apply(this, arguments);
}
var nne;
function ib() {
  return ib = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ib.apply(this, arguments);
}
var rne;
function ob() {
  return ob = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ob.apply(this, arguments);
}
var ane;
function sb() {
  return sb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sb.apply(this, arguments);
}
var lne;
function cb() {
  return cb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cb.apply(this, arguments);
}
var ine;
function ub() {
  return ub = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ub.apply(this, arguments);
}
var one;
function fb() {
  return fb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fb.apply(this, arguments);
}
var sne, cne;
function db() {
  return db = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, db.apply(this, arguments);
}
var une;
function pb() {
  return pb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pb.apply(this, arguments);
}
var fne, dne;
function gb() {
  return gb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gb.apply(this, arguments);
}
var pne;
function hb() {
  return hb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hb.apply(this, arguments);
}
var gne;
function mb() {
  return mb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mb.apply(this, arguments);
}
var hne, mne;
function vb() {
  return vb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vb.apply(this, arguments);
}
var vne;
function bb() {
  return bb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bb.apply(this, arguments);
}
var bne;
function yb() {
  return yb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yb.apply(this, arguments);
}
var yne;
function wb() {
  return wb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wb.apply(this, arguments);
}
var wne;
function Ob() {
  return Ob = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ob.apply(this, arguments);
}
var One;
function xb() {
  return xb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xb.apply(this, arguments);
}
var xne;
function Eb() {
  return Eb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Eb.apply(this, arguments);
}
var Ene, $ne;
function $b() {
  return $b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $b.apply(this, arguments);
}
var jne;
function jb() {
  return jb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jb.apply(this, arguments);
}
var Cne;
function Cb() {
  return Cb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cb.apply(this, arguments);
}
var Mne, kne;
function Mb() {
  return Mb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mb.apply(this, arguments);
}
var Pne;
function kb() {
  return kb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kb.apply(this, arguments);
}
var Sne, Nne;
function Pb() {
  return Pb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pb.apply(this, arguments);
}
var Rne;
function Sb() {
  return Sb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sb.apply(this, arguments);
}
var _ne;
function Nb() {
  return Nb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nb.apply(this, arguments);
}
var Ane, Lne;
function Rb() {
  return Rb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rb.apply(this, arguments);
}
var Zne, Tne;
function _b() {
  return _b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _b.apply(this, arguments);
}
var Bne;
function Ab() {
  return Ab = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ab.apply(this, arguments);
}
var Ine, Hne;
function Lb() {
  return Lb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lb.apply(this, arguments);
}
var Dne;
function Zb() {
  return Zb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zb.apply(this, arguments);
}
var zne, Fne;
function Tb() {
  return Tb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tb.apply(this, arguments);
}
var Vne;
function Bb() {
  return Bb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bb.apply(this, arguments);
}
var qne;
function Ib() {
  return Ib = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ib.apply(this, arguments);
}
var Une, Wne;
function Hb() {
  return Hb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hb.apply(this, arguments);
}
var Gne, Kne;
function Db() {
  return Db = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Db.apply(this, arguments);
}
var Yne;
function zb() {
  return zb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zb.apply(this, arguments);
}
var Xne;
function Fb() {
  return Fb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fb.apply(this, arguments);
}
var Qne;
function Vb() {
  return Vb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vb.apply(this, arguments);
}
var Jne;
function qb() {
  return qb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qb.apply(this, arguments);
}
var ere;
function Ub() {
  return Ub = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ub.apply(this, arguments);
}
var tre, nre;
function Wb() {
  return Wb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wb.apply(this, arguments);
}
var rre;
function Gb() {
  return Gb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gb.apply(this, arguments);
}
var are, lre;
function Kb() {
  return Kb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kb.apply(this, arguments);
}
var ire, ore;
function Yb() {
  return Yb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yb.apply(this, arguments);
}
var sre;
function Xb() {
  return Xb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xb.apply(this, arguments);
}
var cre;
function Qb() {
  return Qb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qb.apply(this, arguments);
}
var ure, fre;
function Jb() {
  return Jb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jb.apply(this, arguments);
}
var dre, pre;
function e8() {
  return e8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e8.apply(this, arguments);
}
var gre;
function t8() {
  return t8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t8.apply(this, arguments);
}
var hre, mre;
function n8() {
  return n8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n8.apply(this, arguments);
}
var vre;
function r8() {
  return r8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r8.apply(this, arguments);
}
var bre, yre;
function a8() {
  return a8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a8.apply(this, arguments);
}
var wre;
function l8() {
  return l8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, l8.apply(this, arguments);
}
var Ore;
function i8() {
  return i8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, i8.apply(this, arguments);
}
var xre;
function o8() {
  return o8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, o8.apply(this, arguments);
}
var Ere;
function s8() {
  return s8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, s8.apply(this, arguments);
}
var $re;
function c8() {
  return c8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, c8.apply(this, arguments);
}
var jre, Cre;
function u8() {
  return u8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, u8.apply(this, arguments);
}
var Mre;
function f8() {
  return f8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, f8.apply(this, arguments);
}
var kre, Pre;
function d8() {
  return d8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d8.apply(this, arguments);
}
var Sre, Nre;
function p8() {
  return p8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, p8.apply(this, arguments);
}
var Rre;
function g8() {
  return g8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g8.apply(this, arguments);
}
var _re;
function h8() {
  return h8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h8.apply(this, arguments);
}
var Are;
function m8() {
  return m8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, m8.apply(this, arguments);
}
var Lre;
function v8() {
  return v8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v8.apply(this, arguments);
}
var Zre;
function b8() {
  return b8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b8.apply(this, arguments);
}
var Tre;
function y8() {
  return y8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y8.apply(this, arguments);
}
var Bre, Ire;
function w8() {
  return w8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, w8.apply(this, arguments);
}
var Hre, Dre, zre;
function O8() {
  return O8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, O8.apply(this, arguments);
}
var Fre, Vre;
function x8() {
  return x8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, x8.apply(this, arguments);
}
var qre;
function E8() {
  return E8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E8.apply(this, arguments);
}
var Ure;
function $8() {
  return $8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $8.apply(this, arguments);
}
var Wre;
function j8() {
  return j8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j8.apply(this, arguments);
}
var Gre;
function C8() {
  return C8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, C8.apply(this, arguments);
}
var Kre;
function M8() {
  return M8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M8.apply(this, arguments);
}
var Yre;
function k8() {
  return k8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k8.apply(this, arguments);
}
var Xre;
function P8() {
  return P8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, P8.apply(this, arguments);
}
var Qre;
function S8() {
  return S8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S8.apply(this, arguments);
}
var Jre;
function N8() {
  return N8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N8.apply(this, arguments);
}
var eae;
function R8() {
  return R8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R8.apply(this, arguments);
}
var tae;
function _8() {
  return _8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _8.apply(this, arguments);
}
var nae;
function A8() {
  return A8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A8.apply(this, arguments);
}
var rae;
function L8() {
  return L8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L8.apply(this, arguments);
}
var aae;
function Z8() {
  return Z8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Z8.apply(this, arguments);
}
var lae;
function T8() {
  return T8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, T8.apply(this, arguments);
}
var iae;
function B8() {
  return B8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, B8.apply(this, arguments);
}
var oae;
function I8() {
  return I8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I8.apply(this, arguments);
}
var sae;
function H8() {
  return H8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H8.apply(this, arguments);
}
var cae;
function D8() {
  return D8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D8.apply(this, arguments);
}
var uae, fae, dae;
function z8() {
  return z8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z8.apply(this, arguments);
}
var pae;
function F8() {
  return F8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, F8.apply(this, arguments);
}
var gae;
function V8() {
  return V8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V8.apply(this, arguments);
}
var hae;
function q8() {
  return q8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q8.apply(this, arguments);
}
var mae;
function U8() {
  return U8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U8.apply(this, arguments);
}
var vae;
function W8() {
  return W8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W8.apply(this, arguments);
}
var bae;
function G8() {
  return G8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G8.apply(this, arguments);
}
var yae;
function K8() {
  return K8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K8.apply(this, arguments);
}
var wae;
function Y8() {
  return Y8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Y8.apply(this, arguments);
}
var Oae;
function X8() {
  return X8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X8.apply(this, arguments);
}
var xae;
function Q8() {
  return Q8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q8.apply(this, arguments);
}
var Eae;
function J8() {
  return J8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J8.apply(this, arguments);
}
var $ae;
function e9() {
  return e9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e9.apply(this, arguments);
}
var jae;
function t9() {
  return t9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t9.apply(this, arguments);
}
var Cae, Mae;
function n9() {
  return n9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n9.apply(this, arguments);
}
var kae;
function r9() {
  return r9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, r9.apply(this, arguments);
}
var Pae;
function a9() {
  return a9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a9.apply(this, arguments);
}
var Sae = { ActivityFeed: function(e) {
  return u.createElement("svg", g7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ete || (ete = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 13V7h4.5A1.5 1.5 0 0 0 7 5.5V1h2a2 2 0 0 1 2 2v4.515a2.5 2.5 0 0 0-2.612 1.602l-1.06 2.808A2.501 2.501 0 0 0 5.59 15H3a2 2 0 0 1-2-2ZM4.914 1h.92v3.833a1 1 0 0 1-1 1H1v-.919a1 1 0 0 1 .293-.707L2.5 3l1.707-1.707A1 1 0 0 1 4.914 1ZM10.8 9.003a1 1 0 0 1 .904.784l.61 2.792.508-.714a1 1 0 0 1 .814-.42H15a1 1 0 0 1 0 2h-.848l-1.519 2.135a1 1 0 0 1-1.792-.367l-.371-1.701-.444 1.175a1 1 0 0 1-.935.646H8a1 1 0 1 1 0-2h.4l1.392-3.686a1 1 0 0 1 1.008-.644Z", clipRule: "evenodd" })));
}, AddFile: function(e) {
  return u.createElement("svg", h7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tte || (tte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 7v6a2 2 0 0 0 2 2h5.968a2.25 2.25 0 0 1 .794-4.238A2.251 2.251 0 0 1 11 8.984V3a2 2 0 0 0-2-2H7v4.5A1.5 1.5 0 0 1 5.5 7H1Zm8 6a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0-1 1ZM5.833 1h-.919a1 1 0 0 0-.707.293L2.5 3 1.293 4.207A1 1 0 0 0 1 4.914v.92h3.833a1 1 0 0 0 1-1V1Z", clipRule: "evenodd" })));
}, AllProducts: function(e) {
  return u.createElement("svg", m7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nte || (nte = u.createElement("path", { fill: "currentColor", d: "M2.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM6.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 2.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM2.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM7.5 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM10.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM3.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM6.5 11.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" })));
}, Apps: function(e) {
  return u.createElement("svg", v7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rte || (rte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3H3v4h4V3Zm0 6H3v4h4V9Zm2-6h4v4H9V3Zm4 6H9v4h4V9Z", clipRule: "evenodd" })));
}, Array: function(e) {
  return u.createElement("svg", b7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ate || (ate = u.createElement("path", { fill: "currentColor", d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V3h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM13.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12V3H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4Z" })));
}, ArrowDown: function(e) {
  return u.createElement("svg", y7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lte || (lte = u.createElement("path", { fill: "currentColor", d: "M9.168 3v6.944l1.535-1.535a1 1 0 0 1 1.414 0l.239.24a1 1 0 0 1 0 1.414l-3.383 3.382c-.008.01-.017.018-.026.027l-.239.24a1 1 0 0 1-1.414 0L3.643 10.06a1 1 0 0 1 0-1.414l.239-.239a1 1 0 0 1 1.414 0L6.83 9.941V3a1 1 0 0 1 1-1h.338a1 1 0 0 1 1 1Z" })));
}, ArrowLeft: function(e) {
  return u.createElement("svg", w7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ite || (ite = u.createElement("path", { fill: "currentColor", d: "M13 6.832H6.056L7.59 5.297a1 1 0 0 0 0-1.414l-.24-.239a1 1 0 0 0-1.414 0L2.555 7.027c-.01.008-.018.017-.027.026l-.24.239a1 1 0 0 0 0 1.414l3.652 3.651a1 1 0 0 0 1.414 0l.239-.239a1 1 0 0 0 0-1.414L6.059 9.17H13a1 1 0 0 0 1-1v-.338a1 1 0 0 0-1-1Z" })));
}, ArrowRight: function(e) {
  return u.createElement("svg", O7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ote || (ote = u.createElement("path", { fill: "currentColor", d: "M3 6.832h6.944L8.41 5.297a1 1 0 0 1 0-1.414l.24-.239a1 1 0 0 1 1.414 0l3.382 3.383c.01.008.018.017.027.026l.24.239a1 1 0 0 1 0 1.414l-3.652 3.651a1 1 0 0 1-1.414 0l-.239-.239a1 1 0 0 1 0-1.414L9.941 9.17H3a1 1 0 0 1-1-1v-.338a1 1 0 0 1 1-1Z" })));
}, ArrowUp: function(e) {
  return u.createElement("svg", x7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ste || (ste = u.createElement("path", { fill: "currentColor", d: "M9.168 13V6.056l1.535 1.535a1 1 0 0 0 1.414 0l.239-.24a1 1 0 0 0 0-1.414L8.973 2.555a1.023 1.023 0 0 0-.026-.027l-.239-.24a1 1 0 0 0-1.414 0L3.643 5.94a1 1 0 0 0 0 1.414l.239.239a1 1 0 0 0 1.414 0L6.83 6.059V13a1 1 0 0 0 1 1h.338a1 1 0 0 0 1-1Z" })));
}, Beaker: function(e) {
  return u.createElement("svg", E7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cte || (cte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.953 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C6.333 1 6.473 1 6.753 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219C9.573 3 9.433 3 9.153 3h-2.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219c-.054-.107-.054-.247-.054-.527v-.4Zm.056 2.47c-.056.108-.056.25-.056.535V6l-3.007 5.412c-.663 1.193-.994 1.79-.932 2.277a1.5 1.5 0 0 0 .6 1.02C3.01 15 3.693 15 5.057 15h5.791c1.365 0 2.047 0 2.444-.291a1.5 1.5 0 0 0 .6-1.02c.062-.488-.27-1.084-.932-2.277L9.953 6V4.805c0-.285 0-.427-.056-.535a.5.5 0 0 0-.214-.214C9.575 4 9.433 4 9.148 4h-2.39c-.285 0-.427 0-.536.056a.5.5 0 0 0-.213.214ZM9.333 9l-3.03.5-1.287 2.31c-.218.392-.327.588-.309.748a.5.5 0 0 0 .205.348c.13.094.355.094.802.094h4.48c.447 0 .67 0 .801-.094a.5.5 0 0 0 .205-.348c.019-.16-.09-.355-.307-.746L9.333 9Z", clipRule: "evenodd" })));
}, Bell: function(e) {
  return u.createElement("svg", $7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ute || (ute = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.625 6.138a4.656 4.656 0 0 0-3.268-3.925C9.228 1.52 8.67 1 8 1c-.67 0-1.228.52-1.357 1.213a4.656 4.656 0 0 0-3.268 3.925l-.452 3.963h.026a.95.95 0 0 0 0 1.899h10.102a.95.95 0 0 0 0-1.899h.026l-.452-3.963ZM8 15a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z", clipRule: "evenodd" })));
}, Biometric: function(e) {
  return u.createElement("svg", j7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fte || (fte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 1A5.5 5.5 0 0 0 2 6.5v3A5.5 5.5 0 0 0 7.5 15h1A5.5 5.5 0 0 0 14 9.5v-3A5.5 5.5 0 0 0 8.5 1h-1Zm1.074 6.75a.574.574 0 1 0-1.148 0v2.457a.574.574 0 0 0 1.148 0V7.75ZM8 5.338A2.412 2.412 0 0 0 5.588 7.75v2.566a.994.994 0 0 1-.291.704.574.574 0 1 0 .812.812c.402-.402.628-.947.628-1.516V7.75a1.264 1.264 0 1 1 2.527 0v2.648c0 .412-.233.79-.602.973a.574.574 0 0 0 .514 1.028 2.237 2.237 0 0 0 1.236-2V7.75A2.412 2.412 0 0 0 8 5.338ZM4.899 7.75A3.101 3.101 0 0 1 9.64 5.117a.574.574 0 1 0 .609-.974A4.25 4.25 0 0 0 3.75 7.75v2.297a.574.574 0 1 0 1.149 0V7.75Zm6.887-1.932a.574.574 0 1 0-1.023.522c.216.423.338.901.338 1.41v1.378a.574.574 0 1 0 1.149 0V7.75c0-.695-.167-1.352-.464-1.932Z", clipRule: "evenodd" })));
}, Boolean: function(e) {
  return u.createElement("svg", C7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dte || (dte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm4 6a4 4 0 0 1-4 4V4a4 4 0 0 1 4 4Z", clipRule: "evenodd" })));
}, Building: function(e) {
  return u.createElement("svg", M7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pte || (pte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v13H6v-2H4v2H1v-4h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1V5h4.5a.5.5 0 0 0 0-1H1V2Zm8 9h4.5a.5.5 0 0 0 0-1H9V8h4.5a.5.5 0 0 0 0-1H9V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10h-2v-2h-2v2H9v-4Z", clipRule: "evenodd" })));
}, Bulb: function(e) {
  return u.createElement("svg", k7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gte || (gte = u.createElement("path", { fill: "currentColor", d: "M12.331 8.5a5 5 0 1 0-8.612.086L5.408 11.5a1 1 0 0 0 .866.499H6.5V6a1.5 1.5 0 1 1 3 0v6h.224a1 1 0 0 0 .863-.496L12.34 8.5h-.009Z" })), hte || (hte = u.createElement("path", { fill: "currentColor", d: "M7.5 6v6h1V6a.5.5 0 0 0-1 0ZM10 14v-1H6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z" })));
}, Calendar: function(e) {
  return u.createElement("svg", P7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mte || (mte = u.createElement("path", { fill: "currentColor", d: "M4 2a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0V2Z" })), vte || (vte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 3H7a2 2 0 1 1-4 0 2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 2 2 0 1 1-4 0Zm3 4H9v3h3V7Z", clipRule: "evenodd" })), bte || (bte = u.createElement("path", { fill: "currentColor", d: "M10 3a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1Z" })));
}, Camera: function(e) {
  return u.createElement("svg", S7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yte || (yte = u.createElement("path", { fill: "currentColor", d: "M10.25 8.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })), wte || (wte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.585 3.33a1.5 1.5 0 0 1 1.342-.83h4.146a1.5 1.5 0 0 1 1.342.83l.309.617a1 1 0 0 0 .894.553h.882A1.5 1.5 0 0 1 15 6v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V6a1.5 1.5 0 0 1 1.5-1.5h.882a1 1 0 0 0 .894-.553l.31-.618ZM11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", clipRule: "evenodd" })));
}, Cap: function(e) {
  return u.createElement("svg", N7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ote || (Ote = u.createElement("path", { fill: "currentColor", d: "M2.97 8.008v2.3l.001.092-.002.262c0 1.926 2.535 2.838 5 2.838 2.466 0 5-.912 5-2.838 0-.085 0-.168-.002-.25.002-.035.002-.07.002-.105V8.001L8.706 9.787a2 2 0 0 1-1.554-.004L2.969 8.008Z" })), xte || (xte = u.createElement("path", { fill: "currentColor", d: "M7.565 2.583a1 1 0 0 1 .794-.002l6.35 2.732a.5.5 0 0 1-.004.92L8.35 8.896a1 1 0 0 1-.778-.001L1.305 6.233a.5.5 0 0 1-.005-.919l6.265-2.73ZM13.97 7.626v1.477a1 1 0 1 0 1 0V7.207l-1 .419Z" })));
}, CaretDown: function(e) {
  return u.createElement("svg", R7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ete || (Ete = u.createElement("path", { fill: "currentColor", d: "M8.679 10.796a.554.554 0 0 1-.858 0L4.64 6.976C4.32 6.594 4.582 6 5.069 6h6.362c.487 0 .748.594.43.976l-3.182 3.82Z" })));
}, CaretLeft: function(e) {
  return u.createElement("svg", _7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $te || ($te = u.createElement("path", { fill: "currentColor", d: "M5.204 8.679a.553.553 0 0 1 0-.858l3.82-3.181c.382-.319.976-.058.976.429v6.362c0 .487-.594.748-.976.43l-3.82-3.182Z" })));
}, CaretRight: function(e) {
  return u.createElement("svg", A7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jte || (jte = u.createElement("path", { fill: "currentColor", d: "M10.796 7.321a.554.554 0 0 1 0 .858l-3.82 3.181c-.382.319-.976.058-.976-.429V4.57c0-.487.594-.748.976-.43l3.82 3.182Z" })));
}, CaretUp: function(e) {
  return u.createElement("svg", L7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Cte || (Cte = u.createElement("path", { fill: "currentColor", d: "M7.321 5.204a.553.553 0 0 1 .858 0l3.181 3.82c.319.382.058.976-.429.976H4.57c-.487 0-.748-.594-.43-.976l3.182-3.82Z" })));
}, ChartFilled: function(e) {
  return u.createElement("svg", Z7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Mte || (Mte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H3Zm8.25 2a.75.75 0 0 0-.75.75v6.25H12V5.25a.75.75 0 0 0-.75-.75ZM7.5 7.25a.75.75 0 0 1 1.5 0v4.25H7.5V7.25ZM5.25 9a.75.75 0 0 0-.75.75v1.75H6V9.75A.75.75 0 0 0 5.25 9Z", clipRule: "evenodd" })));
}, Charts: function(e) {
  return u.createElement("svg", T7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kte || (kte = u.createElement("path", { fill: "currentColor", d: "M11.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10ZM7.5 14a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1ZM2.5 14a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1Z" })));
}, Checkmark: function(e) {
  return u.createElement("svg", B7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Pte || (Pte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.306 9.05 5.455-5.455a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-7.067 7.068a1 1 0 0 1-1.5-.098l-3.049-3.97a1 1 0 0 1 .184-1.402l.595-.457a1.25 1.25 0 0 1 1.753.23L6.306 9.05Z", clipRule: "evenodd" })));
}, CheckmarkWithCircle: function(e) {
  return u.createElement("svg", I7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ste || (Ste = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.448-10.104a.997.997 0 1 1 1.508 1.306l-4.572 5.28a1 1 0 0 1-1.64-.07l-1.82-2.868a1 1 0 1 1 1.69-1.07l1.1 1.734 3.734-4.312Z", clipRule: "evenodd" })));
}, ChevronDown: function(e) {
  return u.createElement("svg", H7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Nte || (Nte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.636 5.364a1 1 0 0 0 0 1.414l4.95 4.95.707.707a1 1 0 0 0 1.414 0l.707-.707 4.95-4.95a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L8 8.899 3.757 4.657a1 1 0 0 0-1.414 0l-.707.707Z", clipRule: "evenodd" })));
}, ChevronLeft: function(e) {
  return u.createElement("svg", D7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Rte || (Rte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.778 1.636a1 1 0 0 0-1.414 0l-4.95 4.95-.707.707a1 1 0 0 0 0 1.414l.707.707 4.95 4.95a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L7.243 8l4.242-4.243a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, ChevronRight: function(e) {
  return u.createElement("svg", z7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _te || (_te = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.364 14.364a1 1 0 0 0 1.414 0l4.95-4.95.707-.707a1 1 0 0 0 0-1.414l-.707-.707-4.95-4.95a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L8.899 8l-4.242 4.243a1 1 0 0 0 0 1.414l.707.707Z", clipRule: "evenodd" })));
}, ChevronUp: function(e) {
  return u.createElement("svg", F7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ate || (Ate = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.364 10.778a1 1 0 0 0 0-1.414l-4.95-4.95-.707-.707a1 1 0 0 0-1.414 0l-.707.707-4.95 4.95a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0L8 7.243l4.243 4.242a1 1 0 0 0 1.414 0l.707-.707Z", clipRule: "evenodd" })));
}, Clock: function(e) {
  return u.createElement("svg", V7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Lte || (Lte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.25a.75.75 0 0 1 1.5 0v3.16l1.744 1.526a.75.75 0 0 1-.988 1.128L7.511 8.818a.761.761 0 0 1-.19-.25.747.747 0 0 1-.071-.318v-3.5Z", clipRule: "evenodd" })));
}, ClockWithArrow: function(e) {
  return u.createElement("svg", q7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Zte || (Zte = u.createElement("path", { fill: "currentColor", d: "M13 8a5 5 0 0 1-7.304 4.438c-.348-.18-.787-.13-1.038.172l-.33.398c-.276.33-.22.828.152 1.044a7 7 0 1 0-1.452-10.98L1.97 2.146a.584.584 0 0 0-.964.521l.455 3.252c.04.287.285.51.576.511H5.32a.58.58 0 0 0 .387-1.018l-1.168-1.02A5 5 0 0 1 13 8Z" })), Tte || (Tte = u.createElement("path", { fill: "currentColor", d: "M7.25 5.25a.75.75 0 0 1 1.5 0v2.668l1.68 1.524a.75.75 0 1 1-.988 1.129L7.507 8.815a.758.758 0 0 1-.257-.565v-3Z" })));
}, Clone: function(e) {
  return u.createElement("svg", U7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Bte || (Bte = u.createElement("path", { fill: "currentColor", d: "M5.5 12a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v4Z" })), Ite || (Ite = u.createElement("path", { fill: "currentColor", d: "M4.25 10H3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.75h-2V4h-5v4h.75v2Z" })));
}, Cloud: function(e) {
  return u.createElement("svg", W7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Hte || (Hte = u.createElement("path", { fill: "currentColor", d: "M12.571 8.143c0 1.775-.899 3.34-2.267 4.264l-.014.01a5.12 5.12 0 0 1-2.861.869H2.857a2.857 2.857 0 0 1-.545-5.663 5.144 5.144 0 0 1 10.26.52ZM13.821 8.143a6.38 6.38 0 0 1-2.358 4.96 3.429 3.429 0 1 0 2.17-6.506c.123.494.188 1.013.188 1.546Z" })));
}, Code: function(e) {
  return u.createElement("svg", G7({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Dte || (Dte = u.createElement("path", { fill: "currentColor", d: "M6.11 13.262a.5.5 0 0 0 .395.586l.737.143a.5.5 0 0 0 .585-.396L9.926 2.738a.5.5 0 0 0-.396-.586l-.737-.143a.5.5 0 0 0-.585.396L6.109 13.262ZM1.36 7.246 3.976 5.11a.507.507 0 0 1 .704.063l.64.752a.483.483 0 0 1-.064.69L3.562 7.998 5.256 9.38c.212.173.24.482.064.69l-.64.752a.507.507 0 0 1-.704.062L1.36 8.75A.971.971 0 0 1 1 7.998c0-.29.132-.566.36-.752ZM14.636 7.246 12.02 5.11a.507.507 0 0 0-.704.063l-.64.752a.483.483 0 0 0 .064.69l1.694 1.382L10.74 9.38a.483.483 0 0 0-.064.69l.64.752a.507.507 0 0 0 .704.062l2.616-2.134a.971.971 0 0 0 .36-.752.971.971 0 0 0-.36-.752Z" })));
}, CodeBlock: function(e) {
  return u.createElement("svg", K7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zte || (zte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4H3v8h10V4ZM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Z", clipRule: "evenodd" })), Fte || (Fte = u.createElement("path", { fill: "currentColor", d: "M4.221 7.421 6.256 5.78a.398.398 0 0 1 .548.048l.498.578a.368.368 0 0 1-.05.53L5.934 8l1.318 1.063c.165.133.187.37.05.53l-.498.58a.398.398 0 0 1-.548.047L4.221 8.58A.744.744 0 0 1 3.941 8c0-.224.103-.436.28-.579ZM11.779 7.421 9.744 5.78a.398.398 0 0 0-.548.048l-.498.578a.368.368 0 0 0 .05.53L10.066 8 8.748 9.063a.368.368 0 0 0-.05.53l.498.58c.138.159.383.18.548.047l2.035-1.641a.744.744 0 0 0 .28-.579.744.744 0 0 0-.28-.579Z" })));
}, Colon: function(e) {
  return u.createElement("svg", Y7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Vte || (Vte = u.createElement("path", { fill: "currentColor", d: "M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
}, Connect: function(e) {
  return u.createElement("svg", X7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qte || (qte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.867 8.898a4.048 4.048 0 0 0 .687-4.8l1.275-1.275a.584.584 0 0 0 0-.826l-.826-.826a.584.584 0 0 0-.826 0l-1.29 1.29a4.048 4.048 0 0 0-4.734.722L5.277 5.058a.323.323 0 0 0-.041.035L3.182 7.148a4.048 4.048 0 0 0-.72 4.738l-1.29 1.29a.584.584 0 0 0 0 .827l.825.826a.584.584 0 0 0 .826 0l1.278-1.278a4.048 4.048 0 0 0 4.795-.689l1.876-1.875a.324.324 0 0 0 .041-.035l2.054-2.054ZM6.561 6.776 4.685 8.65a1.916 1.916 0 0 0 0 2.707c.747.746 1.961.747 2.707 0l2.055-2.054a.321.321 0 0 1 .04-.035l1.877-1.875a1.916 1.916 0 0 0 0-2.707 1.916 1.916 0 0 0-2.707 0L6.602 6.74a.32.32 0 0 1-.04.035Z", clipRule: "evenodd" })));
}, Copy: function(e) {
  return u.createElement("svg", Q7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ute || (Ute = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 5.714v4.572C1 11.233 1.768 12 2.714 12H5.75V7.11c0-.566.227-1.108.63-1.504l2.294-2.252c.1-.099.21-.186.326-.262v-.378C9 1.768 8.232 1 7.286 1H5.8v3.429c0 .71-.576 1.285-1.286 1.285H1Zm8-.928L7.257 6.498A.857.857 0 0 0 7 7.11v.688h3.01a.857.857 0 0 0 .857-.858V4h-.717a.857.857 0 0 0-.6.246l-.55.54ZM4.867 1H4.15a.857.857 0 0 0-.601.246L1.257 3.498A.857.857 0 0 0 1 4.11v.688h3.01a.857.857 0 0 0 .857-.858V1ZM7 12V8.714H10.514c.71 0 1.286-.575 1.286-1.285V4h1.486C14.233 4 15 4.768 15 5.714v7.572c0 .947-.768 1.714-1.714 1.714H8.714A1.714 1.714 0 0 1 7 13.286V12Z", clipRule: "evenodd" })));
}, CreditCard: function(e) {
  return u.createElement("svg", J7({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Wte || (Wte = u.createElement("path", { fill: "currentColor", d: "M3 3a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2H3ZM15 7H1v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7Z" })));
}, CurlyBraces: function(e) {
  return u.createElement("svg", eb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Gte || (Gte = u.createElement("path", { fill: "currentColor", d: "M3 3.544a2.5 2.5 0 0 1 2.5-2.5h1a.5.5 0 0 1 .5.5v1.105a.353.353 0 0 1-.353.353h-.79A.858.858 0 0 0 5 3.86v2.802a1.5 1.5 0 0 1-.816 1.335A1.5 1.5 0 0 1 5 9.332v2.803c0 .473.384.857.858.857h.789c.195 0 .353.158.353.353v1.105a.5.5 0 0 1-.5.5h-1a2.5 2.5 0 0 1-2.5-2.5v-1.956a1.5 1.5 0 0 0-1.5-1.5.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-1.95ZM13 12.45a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1-.5-.5v-1.105c0-.195.158-.353.353-.353h.79a.858.858 0 0 0 .857-.858V9.332a1.5 1.5 0 0 1 .816-1.335A1.5 1.5 0 0 1 11 6.662V3.859a.858.858 0 0 0-.858-.857h-.789A.353.353 0 0 1 9 2.65V1.544a.5.5 0 0 1 .5-.5h1a2.5 2.5 0 0 1 2.5 2.5V5.5A1.5 1.5 0 0 0 14.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0-1.5 1.5v1.95Z" })));
}, Cursor: function(e) {
  return u.createElement("svg", tb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Kte || (Kte = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m8.534 8.534.473-.27 2.389-1.366-6.748-2.25 2.25 6.748 1.366-2.389.27-.473ZM10 10l4.48-2.563c.734-.333.678-1.393-.086-1.648L3.169 2.047A.887.887 0 0 0 2.047 3.17l3.742 11.225c.255.764 1.315.82 1.648.086L10 10Z", clipRule: "evenodd" })));
}, Dashboard: function(e) {
  return u.createElement("svg", nb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Yte || (Yte = u.createElement("path", { fill: "currentColor", d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6ZM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6ZM7 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3ZM2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z" })));
}, Database: function(e) {
  return u.createElement("svg", rb({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Xte || (Xte = u.createElement("path", { fill: "currentColor", d: "M13.5 4.452c0 .09 0 .177-.002.262l.002.094v.23c0 .3-.136.588-.433.87-.302.289-.75.548-1.305.765-1.11.434-2.541.656-3.762.656-1.22 0-2.652-.222-3.762-.656-.555-.217-1.003-.476-1.305-.764-.297-.283-.433-.571-.433-.872v-.229c0-.035 0-.07.002-.105a12.886 12.886 0 0 1-.002-.251C2.5 2.517 5.288 1.6 8 1.6s5.5.917 5.5 2.852Z" })), Qte || (Qte = u.createElement("path", { fill: "currentColor", d: "M2.5 6.747v1.957c0 .3.136.589.433.871.302.288.75.548 1.305.765 1.11.433 2.541.656 3.762.656 1.22 0 2.652-.223 3.762-.656.555-.217 1.003-.477 1.305-.765.297-.282.433-.57.433-.87V6.746c-.392.318-.88.575-1.405.78-1.236.483-2.784.719-4.095.719-1.31 0-2.859-.236-4.095-.72-.525-.204-1.013-.461-1.405-.779Z" })), Jte || (Jte = u.createElement("path", { fill: "currentColor", d: "M12.095 11.194c.525-.205 1.013-.462 1.405-.78v.811c0 .035 0 .07-.002.105l.002.251c0 1.936-2.788 2.852-5.5 2.852s-5.5-.916-5.5-2.852c0-.088 0-.176.002-.262a2.322 2.322 0 0 1-.002-.094v-.811c.392.318.88.575 1.405.78 1.236.483 2.784.718 4.095.718 1.31 0 2.859-.235 4.095-.719Z" })));
}, Diagram: function(e) {
  return u.createElement("svg", ab({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ene || (ene = u.createElement("path", { fill: "currentColor", d: "M6 2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H8.5v2h4.75a.75.75 0 0 1 .75.75V10h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H13V8H8.5v2H9a.75.75 0 0 1 .75.75v1.5A.75.75 0 0 1 9 13H7a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 7 10h.5V8H3v2h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H2V7.75A.75.75 0 0 1 2.75 7H7.5V5h-.75A.75.75 0 0 1 6 4.25v-1.5Z" })));
}, Diagram2: function(e) {
  return u.createElement("svg", lb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tne || (tne = u.createElement("path", { fill: "currentColor", d: "M10.72 1c-.398 0-.72.336-.72.75V2H7.48a.49.49 0 0 0-.48.5V7H5v-.25C5 6.336 4.678 6 4.28 6H1.72c-.398 0-.72.336-.72.75v1.5c0 .414.322.75.72.75h2.56c.398 0 .72-.336.72-.75V8h2v4.5c0 .276.215.5.48.5H10v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V12H8V8h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V7H8V3h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06Z" })));
}, Diagram3: function(e) {
  return u.createElement("svg", ib({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), nne || (nne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.75 1a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 5 3.25v-1.5A.75.75 0 0 0 4.25 1h-2.5Zm9.25.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm0 9a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm-10 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5ZM6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z", clipRule: "evenodd" })));
}, Disconnect: function(e) {
  return u.createElement("svg", ob({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rne || (rne = u.createElement("path", { fill: "currentColor", d: "M7.093 3.671a.317.317 0 0 1 0-.448L8.14 2.175a4.024 4.024 0 0 1 5.685 0 4.024 4.024 0 0 1 0 5.685l-1.048 1.047a.317.317 0 0 1-.448 0L11.28 7.86a.317.317 0 0 1 0-.449l1.048-1.047a1.906 1.906 0 0 0 0-2.693 1.906 1.906 0 0 0-2.693 0L8.59 4.718a.317.317 0 0 1-.449 0L7.093 3.671ZM1.293 1.293a1.001 1.001 0 0 1 1.416 0l11.998 11.998a1.001 1.001 0 0 1-1.416 1.416l-3.159-3.16-2.272 2.277a4.024 4.024 0 0 1-5.685 0 4.024 4.024 0 0 1 0-5.684l2.273-2.277L1.293 2.71a1.001 1.001 0 0 1 0-1.416Zm4.65 6.066L3.672 9.636a1.906 1.906 0 0 0 0 2.693c.743.742 1.95.742 2.693 0l2.272-2.277-2.692-2.693Z" })));
}, Download: function(e) {
  return u.createElement("svg", sb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ane || (ane = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.524 2.575v5.557h1.712c.706 0 1.033.783.5 1.196l-3.237 2.506a.832.832 0 0 1-.998 0L4.265 9.328c-.534-.413-.207-1.196.499-1.196h1.611V2.575a1.575 1.575 0 0 1 3.15 0ZM2.5 11h1.8l2.405 1.862a2.132 2.132 0 0 0 2.59 0L11.7 11h1.8a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3Z", clipRule: "evenodd" })));
}, Drag: function(e) {
  return u.createElement("svg", cb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lne || (lne = u.createElement("path", { fill: "currentColor", d: "M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
}, Edit: function(e) {
  return u.createElement("svg", ub({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ine || (ine = u.createElement("path", { fill: "currentColor", d: "M10.922.681a.963.963 0 0 1 1.362 0l1.363 1.363a.963.963 0 0 1 0 1.362L12.284 4.77 9.56 2.044 8.538 3.066l2.724 2.725-7.153 7.153-3.747 1.022 1.022-3.747L10.922.68Z" })));
}, Ellipsis: function(e) {
  return u.createElement("svg", fb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), one || (one = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6.75 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", clipRule: "evenodd" })));
}, Email: function(e) {
  return u.createElement("svg", db({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sne || (sne = u.createElement("path", { fill: "currentColor", d: "m2.494 4 4.714 5.05a1.068 1.068 0 0 0 1.584 0L13.505 4H2.494ZM1.133 4.256A2.12 2.12 0 0 0 1 5v6c0 .369.093.715.256 1.011L4.814 8.2l-3.68-3.944Z" })), cne || (cne = u.createElement("path", { fill: "currentColor", d: "M2.867 13c-.348 0-.674-.102-.953-.28l3.56-3.813 1.219 1.306a1.78 1.78 0 0 0 2.64 0l1.346-1.443 3.575 3.83c-.313.251-.7.4-1.12.4H2.866ZM14.84 11.813c.103-.248.16-.523.16-.813V5c0-.255-.045-.5-.126-.724l-3.535 3.787 3.5 3.75Z" })));
}, Escalation: function(e) {
  return u.createElement("svg", pb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), une || (une = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.361 4.423a.556.556 0 0 0-.26-.97L5.146 2.009a.556.556 0 0 0-.636.69l1.787 6.672a.556.556 0 0 0 .896.28l6.168-5.228ZM2.911 2.102a.556.556 0 0 0-.392.68l3.163 11.806a.556.556 0 1 0 1.074-.287L3.592 2.493a.556.556 0 0 0-.68-.392Z", clipRule: "evenodd" })));
}, Export: function(e) {
  return u.createElement("svg", gb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), fne || (fne = u.createElement("path", { fill: "currentColor", d: "M14.623 5.186a.278.278 0 0 0 0-.385l-2.805-2.915a.277.277 0 0 0-.477.192v1.424A6.5 6.5 0 0 0 5 10v.1a1.5 1.5 0 0 0 3 0V10a3.5 3.5 0 0 1 3.34-3.496v1.405c0 .25.305.373.478.193l2.805-2.916Z" })), dne || (dne = u.createElement("path", { fill: "currentColor", d: "M6.5 3.879a.75.75 0 0 0-.75-.75H4a2 2 0 0 0-2 2v6.864a2 2 0 0 0 2 2h6.864a2 2 0 0 0 2-2V10.05a.75.75 0 0 0-1.5 0v1.943a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V5.129a.5.5 0 0 1 .5-.5h1.75a.75.75 0 0 0 .75-.75Z" })));
}, Favorite: function(e) {
  return u.createElement("svg", hb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pne || (pne = u.createElement("path", { fill: "currentColor", d: "M7.538 1.11a.5.5 0 0 1 .924 0l1.537 3.696a.5.5 0 0 0 .421.306l3.99.32a.5.5 0 0 1 .285.878l-3.04 2.604a.5.5 0 0 0-.16.496l.928 3.893a.5.5 0 0 1-.747.542L8.261 11.76a.5.5 0 0 0-.522 0l-3.415 2.086a.5.5 0 0 1-.747-.542l.928-3.893a.5.5 0 0 0-.16-.496L1.304 6.31a.5.5 0 0 1 .285-.878l3.99-.32A.5.5 0 0 0 6 4.806L7.538 1.11Z" })));
}, Federation: function(e) {
  return u.createElement("svg", mb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gne || (gne = u.createElement("path", { fill: "currentColor", d: "M8 0c1.6 0 2.8 1.3 2.8 3 0 1.5-1 2.7-2.3 3v2.1l3.1 2.4c.4-.3 1-.5 1.5-.5 1.6 0 2.8 1.3 2.8 3s-1.3 3-2.8 3c-1.6 0-2.8-1.3-2.8-3 0-.7.2-1.3.6-1.8L8 9l-2.9 2.2c.4.5.6 1.1.6 1.8 0 1.7-1.3 3-2.8 3C1.4 16 0 14.7 0 13s1.3-3 2.8-3c.6 0 1.1.2 1.5.5l3.1-2.4V5.9C6.2 5.7 5.2 4.5 5.2 3c0-1.7 1.2-3 2.8-3Zm0 5c.8 0 1.9-.8 1.9-2C9.9 1.9 9 1 8 1c-1 0-1.9.9-1.9 2 0 1.2 1 2 1.9 2Zm-5.2 6c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.8-2-1.9-2Zm10.4 0c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.9-2-1.9-2Z" })));
}, File: function(e) {
  return u.createElement("svg", vb({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hne || (hne = u.createElement("path", { fill: "currentColor", d: "M3 13V7h4.5A1.5 1.5 0 0 0 9 5.5V1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" })), mne || (mne = u.createElement("path", { fill: "currentColor", d: "M7.833 1h-.919a1 1 0 0 0-.707.293L3.293 4.207A1 1 0 0 0 3 4.914v.92h3.833a1 1 0 0 0 1-1V1Z" })));
}, Filter: function(e) {
  return u.createElement("svg", bb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vne || (vne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 6.148-3.8-3.94C1.797 1.79 2.044 1 2.576 1h10.848c.532 0 .779.79.377 1.208L10 6.148v5.625a.5.5 0 0 1-.17.376l-3 2.625a.5.5 0 0 1-.83-.376v-8.25Z", clipRule: "evenodd" })));
}, FullScreenEnter: function(e) {
  return u.createElement("svg", wb({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yne || (yne = u.createElement("path", { fill: "currentColor", d: "M1.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM15 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM1.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM14.5 14a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, FullScreenExit: function(e) {
  return u.createElement("svg", Ob({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wne || (wne = u.createElement("path", { fill: "currentColor", d: "M10.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM6 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM10.5 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM5.5 7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, Folder: function(e) {
  return u.createElement("svg", yb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bne || (bne = u.createElement("path", { fill: "currentColor", d: "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1 1 1 0 0 0-1-1H2Z" })));
}, Gauge: function(e) {
  return u.createElement("svg", xb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), One || (One = u.createElement("path", { fill: "currentColor", d: "M1.041 10.251c-.044.412.296.749.71.749h2.494c.414 0 .74-.34.843-.742A3.006 3.006 0 0 1 8.791 8.1l2.99-2.991a7 7 0 0 0-10.74 5.142ZM13.297 6.422l-2.842 2.842c.213.3.368.638.459.994.102.401.429.742.843.742h2.494c.414 0 .754-.337.71-.749a7.001 7.001 0 0 0-1.664-3.829Z" })));
}, GlobeAmericas: function(e) {
  return u.createElement("svg", Eb({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xne || (xne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-5.301 4.699A4.73 4.73 0 0 1 5 11.683V10L3.257 8.257A4.75 4.75 0 0 1 8 3.25V4.5L6.5 6v1l-.5.5-.5-.5-1 1 .5.5h2.5L8 9v1l-1 1 1.699 1.699Zm4.047-4.496a4.73 4.73 0 0 0-.924-3.025L10.5 6.5V9h1.25l.996-.797Z", clipRule: "evenodd" })));
}, GovernmentBuilding: function(e) {
  return u.createElement("svg", $b({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ene || (Ene = u.createElement("path", { fill: "currentColor", d: "M11 5V4a3 3 0 0 0-6 0v1h6Z" })), $ne || ($ne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 6a.5.5 0 0 0 0 1H2v6h-.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H14V7h.5a.5.5 0 0 0 0-1h-13Zm3 2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3ZM8 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 8Zm2.5.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z", clipRule: "evenodd" })));
}, Hash: function(e) {
  return u.createElement("svg", jb({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jne || (jne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.616 1.5a.5.5 0 0 0-.492.413L9.668 4.5h-2.47l.426-2.413A.5.5 0 0 0 7.13 1.5H6.116a.5.5 0 0 0-.492.413L5.168 4.5H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.815l-.53 3H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.933l-.425 2.413A.5.5 0 0 0 4 14.5h1.016a.5.5 0 0 0 .492-.413l.456-2.587h2.47l-.426 2.413a.5.5 0 0 0 .492.587h1.016a.5.5 0 0 0 .492-.413l.456-2.587H13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.683l.529-3H13.5A.5.5 0 0 0 14 6V5a.5.5 0 0 0-.5-.5h-1.802l.426-2.413a.5.5 0 0 0-.492-.587h-1.016Zm-4.3 8h2.47l.529-3h-2.47l-.528 3Z", clipRule: "evenodd" })));
}, Highlight: function(e) {
  return u.createElement("svg", Cb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Cne || (Cne = u.createElement("path", { fill: "currentColor", d: "M8.853 12.031A.1.1 0 0 1 8.926 12h5.824a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25H7.231a.1.1 0 0 1-.072-.168l1.694-1.8ZM4.019 9.193l.375-.374L7.576 12l-.375.375a1 1 0 0 1-.779.29l-.574-.04a1 1 0 0 0-.778.29l-.141.14-1.591-1.59.141-.142a1 1 0 0 0 .29-.778l-.04-.573a1 1 0 0 1 .29-.779ZM11.433 1.779a1 1 0 0 1 1.415 0l1.767 1.768a1 1 0 0 1 0 1.414L8.28 11.296 5.098 8.114l6.335-6.335ZM2.632 12.167l1.593 1.593-.17.172a.25.25 0 0 1-.178.074H1.386a.25.25 0 0 1-.176-.428l1.422-1.41Z" })));
}, Home: function(e) {
  return u.createElement("svg", Mb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Mne || (Mne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.687 1.751a.5.5 0 0 1 .626 0l6.433 5.164a.5.5 0 0 1 .069.713l-.644.761a.5.5 0 0 1-.697.065L8.316 4.257a.5.5 0 0 0-.632 0L2.526 8.454a.5.5 0 0 1-.697-.065l-.644-.76a.5.5 0 0 1 .07-.714l6.432-5.164Z", clipRule: "evenodd" })), kne || (kne = u.createElement("path", { fill: "currentColor", d: "M7.688 5.25a.5.5 0 0 1 .624 0l4.5 3.6a.5.5 0 0 1 .188.39v4.26a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9.24a.5.5 0 0 1 .188-.39l4.5-3.6Z" })));
}, HorizontalDrag: function(e) {
  return u.createElement("svg", kb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Pne || (Pne = u.createElement("path", { fill: "currentColor", d: "M4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" })));
}, Import: function(e) {
  return u.createElement("svg", Pb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Sne || (Sne = u.createElement("path", { fill: "currentColor", d: "M11.623 8.799a.278.278 0 0 0 0-.385L8.818 5.498a.277.277 0 0 0-.477.193v1.405A3.5 3.5 0 0 1 5 3.6v-.1a1.5 1.5 0 1 0-3 0v.1a6.5 6.5 0 0 0 6.34 6.498v1.424c0 .25.305.372.478.192L11.623 8.8Z" })), Nne || (Nne = u.createElement("path", { fill: "currentColor", d: "M3.95 11a.75.75 0 0 1 1.5 0v1.75a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V5.886a.5.5 0 0 0-.5-.5h-1.943a.75.75 0 0 1 0-1.5h1.943a2 2 0 0 1 2 2v6.864a2 2 0 0 1-2 2H5.95a2 2 0 0 1-2-2V11Z" })));
}, ImportantWithCircle: function(e) {
  return u.createElement("svg", Sb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Rne || (Rne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 4.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, InfoWithCircle: function(e) {
  return u.createElement("svg", Nb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _ne || (_ne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 0 1 1 1v4h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7h-.5a.5.5 0 0 1 0-1H8Z", clipRule: "evenodd" })));
}, InternalEmployee: function(e) {
  return u.createElement("svg", Rb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ane || (Ane = u.createElement("path", { fill: "currentColor", d: "M6.5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h8.774l-.003-.05-.03-.022s-2.834-2.213-1.27-5.622c-.263-.055-.56.005-.814.144A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), Lne || (Lne = u.createElement("path", { fill: "currentColor", d: "M12.746 7.003c-.36-.448-.672-.903-.736-.998a.016.016 0 0 0-.023 0c-.063.095-.373.55-.732.998-3.084 4.137.486 6.925.486 6.925l.03.021c.026.431.093 1.051.093 1.051h.266s.067-.617.093-1.05l.03-.025c.004.003 3.577-2.785.493-6.922ZM12 13.87s-.16-.144-.203-.217v-.007l.193-4.505c0-.014.02-.014.02 0l.193 4.505v.007a1.522 1.522 0 0 1-.203.217Z" })));
}, InviteUser: function(e) {
  return u.createElement("svg", _b({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Zne || (Zne = u.createElement("path", { fill: "currentColor", d: "M8.418 7.428a3.5 3.5 0 1 0-3.836-5.856 3.5 3.5 0 0 0 3.836 5.856ZM3.091 8.562c.308-.357.838-.339 1.252-.112.64.35 1.375.55 2.157.55s1.517-.2 2.157-.55c.414-.227.944-.245 1.252.112.11.128.214.263.31.403A1.996 1.996 0 0 0 9.5 10.5 2 2 0 0 0 8.177 14H2v-2.5c0-1.123.411-2.15 1.091-2.938Z" })), Tne || (Tne = u.createElement("path", { fill: "currentColor", d: "M10.5 10.5a.998.998 0 0 1 1-1 1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1Z" })));
}, Key: function(e) {
  return u.createElement("svg", Ab({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Bne || (Bne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.015 10.03c.652 0 1.267-.155 1.811-.43l1.512 1.51-.921.921a.669.669 0 0 0 0 .946l.827.827a.669.669 0 0 0 .946 0l.92-.92.75.749a1.254 1.254 0 0 0 1.773-1.773L9.599 7.827a4.015 4.015 0 1 0-3.584 2.204Zm-.753-3.513a1.255 1.255 0 1 0 0-2.51 1.255 1.255 0 0 0 0 2.51Z", clipRule: "evenodd" })));
}, Laptop: function(e) {
  return u.createElement("svg", Lb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ine || (Ine = u.createElement("path", { fill: "currentColor", d: "M5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 6ZM5.5 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })), Hne || (Hne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a1 1 0 0 0-1 1v7.813l-.29.49a.91.91 0 0 0-.068.1L1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.642-1.096a.901.901 0 0 0-.067-.1L14 11.313V3.5a1 1 0 0 0-1-1H3ZM12.5 4h-9v6.5h9V4Z", clipRule: "evenodd" })));
}, LightningBolt: function(e) {
  return u.createElement("svg", Zb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Dne || (Dne = u.createElement("path", { fill: "currentColor", d: "M9.223 1.993c0-.497-.66-.68-.922-.256l-4.227 6.85a.493.493 0 0 0 .423.75h2.28v4.67c0 .497.66.68.921.257l4.228-6.852a.492.492 0 0 0-.424-.75h-2.28V1.993Z" })));
}, Link: function(e) {
  return u.createElement("svg", Tb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zne || (zne = u.createElement("path", { fill: "currentColor", d: "M6.039 9.953a3.596 3.596 0 0 1-.327-.38l1.45-1.445a1.553 1.553 0 0 0 2.496.423l2.885-2.87a1.57 1.57 0 0 0 .01-2.213 1.553 1.553 0 0 0-2.203-.01l-.379.377A.995.995 0 0 1 8.56 3.83a1.005 1.005 0 0 1 .006-1.418l.38-.377a3.542 3.542 0 0 1 5.024.023 3.58 3.58 0 0 1-.022 5.047l-2.884 2.871a3.542 3.542 0 0 1-5.025-.022Z" })), Fne || (Fne = u.createElement("path", { fill: "currentColor", d: "M9.961 6.047c.12.12.228.248.327.38l-1.45 1.445a1.553 1.553 0 0 0-2.496-.423l-2.885 2.87a1.57 1.57 0 0 0-.01 2.213 1.553 1.553 0 0 0 2.203.01l.379-.377a.995.995 0 0 1 1.411.006 1.005 1.005 0 0 1-.006 1.418l-.38.377a3.542 3.542 0 0 1-5.024-.023 3.58 3.58 0 0 1 .022-5.047l2.884-2.871a3.542 3.542 0 0 1 5.025.022Z" })));
}, List: function(e) {
  return u.createElement("svg", Bb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Vne || (Vne = u.createElement("path", { fill: "currentColor", d: "M3.125 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.125 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.875 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM6.625 3a1 1 0 0 0 0 2h6.5a1 1 0 1 0 0-2h-6.5ZM5.625 8a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1ZM6.625 11a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2h-6.5Z" })));
}, Lock: function(e) {
  return u.createElement("svg", Ib({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qne || (qne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7V5a4 4 0 1 1 8 0v2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm2-2a2 2 0 1 1 4 0v2H6V5Zm2.587 5.81A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, LogIn: function(e) {
  return u.createElement("svg", Hb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Une || (Une = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3a1 1 0 0 1 1-1h4.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H3v8h3.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H2a1 1 0 0 1-1-1V3Z", clipRule: "evenodd" })), Wne || (Wne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.495 4.116 6.293 7.318a1 1 0 0 0 0 1.414l3.202 3.202a.75.75 0 0 0 1.06 0l.354-.353a.75.75 0 0 0 0-1.061L9.389 9h4.861a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75H9.44l1.469-1.47a.75.75 0 0 0 0-1.06l-.354-.354a.75.75 0 0 0-1.06 0Z", clipRule: "evenodd" })));
}, LogOut: function(e) {
  return u.createElement("svg", Db({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Gne || (Gne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 3c0-.552.446-1 .995-1h4.23c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75H3.49v8h3.235c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75h-4.23a.998.998 0 0 1-.995-1V3Z", clipRule: "evenodd" })), Kne || (Kne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11.022 11.909 3.187-3.202a1.003 1.003 0 0 0 0-1.414L11.022 4.09a.744.744 0 0 0-1.056 0l-.352.354a.753.753 0 0 0 0 1.06l1.513 1.52H6.29a.748.748 0 0 0-.746.75v.5c0 .414.334.75.746.75h4.788l-1.463 1.47a.753.753 0 0 0 0 1.06l.352.354a.744.744 0 0 0 1.056 0Z", clipRule: "evenodd" })));
}, MagnifyingGlass: function(e) {
  return u.createElement("svg", zb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Yne || (Yne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.323 9.819a5.302 5.302 0 0 0 6.463.805l4.144 4.144a1.3 1.3 0 1 0 1.838-1.838l-4.144-4.144a5.302 5.302 0 0 0-8.3-6.463 5.3 5.3 0 0 0 0 7.496ZM7.98 4.162A2.7 2.7 0 1 1 4.162 7.98 2.7 2.7 0 0 1 7.98 4.162Z", clipRule: "evenodd" })));
}, Megaphone: function(e) {
  return u.createElement("svg", Fb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Xne || (Xne = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 3 5.725-1.636A1 1 0 0 1 13 2.326v7.348a1 1 0 0 1-1.275.962L6 9H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3Zm-.657 7H3v5h2.98a1 1 0 0 0 .918-1.396L5.343 10ZM16 6a2 2 0 0 1-2 2V4a2 2 0 0 1 2 2Z", clipRule: "evenodd" })));
}, Menu: function(e) {
  return u.createElement("svg", Vb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Qne || (Qne = u.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
}, Minus: function(e) {
  return u.createElement("svg", qb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Jne || (Jne = u.createElement("path", { fill: "currentColor", d: "M3 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3Z" })));
}, Mobile: function(e) {
  return u.createElement("svg", Ub({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ere || (ere = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H5v10h6V3ZM5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z", clipRule: "evenodd" })));
}, MultiDirectionArrow: function(e) {
  return u.createElement("svg", Wb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), tre || (tre = u.createElement("path", { fill: "currentColor", d: "M5 8.573v4.854c0 .53-.608.774-.928.374L2.13 11.374a.607.607 0 0 1 0-.748l1.943-2.427c.32-.4.928-.155.928.374Z" })), nre || (nre = u.createElement("path", { fill: "currentColor", d: "M5 10h7.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5v-2ZM11 7.427V2.573c0-.53.608-.775.928-.374l1.943 2.427a.607.607 0 0 1 0 .748l-1.943 2.427c-.32.4-.928.155-.928-.374ZM3 4.5a.5.5 0 0 1 .5-.5H11v2H3.5a.5.5 0 0 1-.5-.5v-1Z" })));
}, MultiLayers: function(e) {
  return u.createElement("svg", Gb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rre || (rre = u.createElement("path", { fill: "currentColor", d: "m12.431 9.745-.26-.121.26-.122a1.99 1.99 0 0 0 .758-.597c.197-.252.311-.576.311-.9 0-.324-.114-.637-.311-.9a2.073 2.073 0 0 0-.758-.597l-.29-.142.217-.101c.301-.142.571-.344.758-.597.197-.253.311-.577.311-.9 0-.324-.114-.638-.311-.9a2.073 2.073 0 0 0-.758-.598L9.194 1.763A2.9 2.9 0 0 0 7.97 1.5c-.415 0-.84.08-1.225.263L3.57 3.27c-.301.142-.57.344-.758.597a1.483 1.483 0 0 0-.311.9c0 .324.114.638.311.901.197.253.457.455.758.597l.29.142-.217.1c-.301.142-.571.345-.758.598a1.483 1.483 0 0 0-.311.9c0 .324.114.637.311.9.197.253.457.456.758.597l.259.122-.26.121c-.3.142-.57.344-.757.597a1.484 1.484 0 0 0-.311.9c0 .324.114.638.311.9.197.254.457.456.758.598l3.165 1.497c.384.182.809.263 1.224.263.415 0 .84-.08 1.225-.263l3.165-1.497c.3-.142.57-.344.757-.597.197-.253.312-.577.312-.9 0-.324-.114-.638-.312-.901a2.073 2.073 0 0 0-.757-.597h.01Zm-4.39 3.248c-.207 0-.404-.04-.54-.112l-3.164-1.497c-.114-.05-.166-.111-.187-.132l.02-.02.167-.111 1.36-.637 1.13.536c.384.182.81.263 1.225.263.415 0 .84-.081 1.224-.263l1.132-.536 1.359.637c.114.05.166.111.187.131l-.021.02-.166.112-3.165 1.497a1.28 1.28 0 0 1-.54.112h-.02ZM4.14 8.005l.02-.02.166-.111 1.318-.628 1.1.516c.384.182.81.263 1.225.263.415 0 .84-.08 1.224-.263l1.173-.556 1.39.657c.115.051.167.112.187.132l-.02.02-.166.111-3.165 1.498a1.28 1.28 0 0 1-.54.111c-.208 0-.405-.04-.54-.111L4.347 8.126c-.114-.05-.166-.11-.187-.131l-.02.01Zm-.073-3.237.02-.02.167-.112L7.419 3.14a1.28 1.28 0 0 1 .54-.111c.207 0 .404.04.54.11l3.164 1.498c.114.05.166.111.187.132l-.02.02-.167.111-3.165 1.497a1.28 1.28 0 0 1-.54.112c-.207 0-.404-.04-.54-.112L4.255 4.9c-.114-.05-.166-.111-.187-.131Z" })));
}, NavCollapse: function(e) {
  return u.createElement("svg", Kb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), are || (are = u.createElement("path", { fill: "currentColor", d: "M11.39 4.818a.5.5 0 0 0-.708 0L7.854 7.646a.5.5 0 0 0 0 .708l2.828 2.828a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L9.62 8l2.122-2.121a.5.5 0 0 0 0-.707l-.354-.354Z" })), lre || (lre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm1 1.5H4A1.5 1.5 0 0 0 2.5 4v8A1.5 1.5 0 0 0 4 13.5h1v-11Zm1.5 0v11H12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 12 2.5H6.5Z", clipRule: "evenodd" })));
}, NavExpand: function(e) {
  return u.createElement("svg", Yb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ire || (ire = u.createElement("path", { fill: "currentColor", d: "M4.61 4.818a.5.5 0 0 1 .708 0l2.828 2.828a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L6.38 8 4.257 5.879a.5.5 0 0 1 0-.707l.354-.354Z" })), ore || (ore = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8Zm-1 1.5h1A1.5 1.5 0 0 1 13.5 4v8a1.5 1.5 0 0 1-1.5 1.5h-1v-11Zm-1.5 0v11H4A1.5 1.5 0 0 1 2.5 12V4A1.5 1.5 0 0 1 4 2.5h5.5Z", clipRule: "evenodd" })));
}, NoFilter: function(e) {
  return u.createElement("svg", Xb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sre || (sre = u.createElement("path", { fill: "currentColor", d: "M2.606 1.204a1 1 0 0 0-1.313 1.503L7 8.414v5.984a.5.5 0 0 0 .83.376l2.949-2.58 2.512 2.511a1 1 0 0 0 1.414-1.414l-1.818-1.818-.006.006L2.606 1.204ZM10.573 7.15A.25.25 0 0 0 11 6.972v-.825l3.8-3.94C15.202 1.79 14.957 1 14.425 1H5.027a.25.25 0 0 0-.176.427l5.722 5.722Z" })));
}, NotAllowed: function(e) {
  return u.createElement("svg", Qb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cre || (cre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.75 8a3.75 3.75 0 0 1-5.485 3.326l5.06-5.06c.272.518.425 1.108.425 1.734ZM4.674 9.735l5.06-5.06a3.75 3.75 0 0 0-5.06 5.06ZM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z", clipRule: "evenodd" })));
}, Note: function(e) {
  return u.createElement("svg", Jb({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ure || (ure = u.createElement("path", { fill: "currentColor", d: "M4.5 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM4.5 8.75A.75.75 0 0 1 5.25 8h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" })), fre || (fre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m15 10-4 4H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6Zm-2-6H3v8h7v-2a1 1 0 0 1 1-1h2V4Z", clipRule: "evenodd" })));
}, OpenNewTab: function(e) {
  return u.createElement("svg", e8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), dre || (dre = u.createElement("path", { fill: "currentColor", d: "M13.823 2.45a.278.278 0 0 0-.272-.273l-4.045-.079a.277.277 0 0 0-.201.474l1.08 1.08-2.45 2.452a1.395 1.395 0 0 0-.148.174L5.999 8.065a1.369 1.369 0 1 0 1.936 1.936l1.787-1.788c.061-.043.12-.093.174-.147l2.451-2.452 1.081 1.081a.277.277 0 0 0 .474-.201l-.079-4.045Z" })), pre || (pre = u.createElement("path", { fill: "currentColor", d: "M7.25 3.129a.75.75 0 0 1 0 1.5H4a.5.5 0 0 0-.5.5v6.864a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0v3.243a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.129a2 2 0 0 1 2-2h3.25Z" })));
}, Pause: function(e) {
  return u.createElement("svg", t8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gre || (gre = u.createElement("path", { fill: "currentColor", d: "M4.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1ZM10.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1Z" })));
}, Person: function(e) {
  return u.createElement("svg", n8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hre || (hre = u.createElement("path", { fill: "currentColor", d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })), mre || (mre = u.createElement("path", { fill: "currentColor", d: "M8 8c-.708 0-1.367-.21-1.918-.572A4.483 4.483 0 0 1 8 7c.686 0 1.336.154 1.918.428C9.368 7.79 8.708 8 8 8ZM4.591 8.562c.308-.357.838-.339 1.252-.112C6.483 8.8 7.218 9 8 9s1.517-.2 2.158-.55c.413-.227.943-.245 1.251.112A4.482 4.482 0 0 1 12.5 11.5V14h-9v-2.5c0-1.123.411-2.15 1.091-2.938Z" })));
}, PersonGroup: function(e) {
  return u.createElement("svg", r8({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vre || (vre = u.createElement("path", { fill: "currentColor", d: "M4.808 8.923a2.962 2.962 0 1 0 0-5.923 2.962 2.962 0 0 0 0 5.923ZM2.982 9.304c-.35-.192-.798-.207-1.059.095A3.793 3.793 0 0 0 1 11.885V14h7.615v-2.115c0-.95-.347-1.819-.923-2.486-.26-.302-.708-.287-1.059-.095a3.79 3.79 0 0 1-1.825.465 3.79 3.79 0 0 1-1.826-.465ZM9.615 11.885V13H15v-1.906c0-.734-.274-1.405-.727-1.92-.206-.234-.559-.222-.835-.074-.427.23-.917.36-1.438.36-.521 0-1.011-.13-1.438-.36-.276-.148-.63-.16-.835.073-.21.239-.38.51-.504.806.252.585.392 1.23.392 1.906ZM14.333 6.288c0 1.264-1.044 2.289-2.333 2.289-1.289 0-2.333-1.025-2.333-2.289C9.667 5.025 10.71 4 12 4c1.289 0 2.333 1.025 2.333 2.288Z" })));
}, PersonWithLock: function(e) {
  return u.createElement("svg", a8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bre || (bre = u.createElement("path", { fill: "currentColor", d: "M10 4.5A3.497 3.497 0 0 1 6.5 8a3.484 3.484 0 0 1-1.918-.572A3.5 3.5 0 1 1 10 4.5ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h6v-2.5c0-.445.194-.845.502-1.12.033-.82.393-1.554.954-2.076-.259-.051-.55.01-.799.146A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), yre || (yre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 10.5v.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5v-.5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 0-1 1v.5h2v-.5a1 1 0 0 0-1-1Z", clipRule: "evenodd" })));
}, Pin: function(e) {
  return u.createElement("svg", l8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wre || (wre = u.createElement("path", { fill: "currentColor", d: "M10 8.5V3.3h.683a.65.65 0 1 0 0-1.3H5.317a.65.65 0 1 0 0 1.3H6v5.2L4.383 9.55a.843.843 0 0 0 .46 1.55h2.624v3.367a.533.533 0 0 0 1.066 0V11.1h2.624a.843.843 0 0 0 .46-1.55L10 8.5Z" })));
}, Play: function(e) {
  return u.createElement("svg", i8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ore || (Ore = u.createElement("path", { fill: "currentColor", d: "M13.779 6.704a1.5 1.5 0 0 1 0 2.592l-7.523 4.388A1.5 1.5 0 0 1 4 12.388V3.612a1.5 1.5 0 0 1 2.256-1.296l7.523 4.388Z" })));
}, Plus: function(e) {
  return u.createElement("svg", o8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xre || (xre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v3.5H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9.5H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9.5V3a1 1 0 0 0-1-1h-1Z", clipRule: "evenodd" })));
}, PlusWithCircle: function(e) {
  return u.createElement("svg", s8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ere || (Ere = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z", clipRule: "evenodd" })));
}, Primary: function(e) {
  return u.createElement("svg", c8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $re || ($re = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3-8.307C11 5.172 9.918 4 8.433 4H6v8h1.495V9.386h.938C9.918 9.386 11 8.214 11 6.693Zm-1.454 0c0 .653-.453 1.16-1.134 1.16h-.917v-2.32h.917c.68 0 1.134.506 1.134 1.16Z", clipRule: "evenodd" })));
}, Project: function(e) {
  return u.createElement("svg", u8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jre || (jre = u.createElement("path", { fill: "currentColor", d: "M1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 4V2Z" })), Cre || (Cre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 5.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75H2.75ZM6.25 7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1h-3.5Z", clipRule: "evenodd" })));
}, QuestionMarkWithCircle: function(e) {
  return u.createElement("svg", f8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Mre || (Mre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.932 5.612C7.054 5.298 7.425 5 7.942 5 8.615 5 9 5.478 9 5.875c0 .162-.057.33-.172.476a.985.985 0 0 1-.242.216l-.016.01a1.141 1.141 0 0 1-.098.054c-.59.286-1.53.967-1.53 2.119V9a1 1 0 0 0 2 0c0-.035.011-.12.138-.27a2.66 2.66 0 0 1 .587-.48 3 3 0 0 0 .726-.656A2.742 2.742 0 0 0 11 5.875C11 4.201 9.54 3 7.941 3c-1.275 0-2.43.745-2.873 1.888a1 1 0 1 0 1.864.724ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, Read: function(e) {
  return u.createElement("svg", d8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kre || (kre = u.createElement("path", { fill: "currentColor", d: "M10.011 8.762V4.185h-1.39c-.574 0-.84-.645-.406-.985l2.63-2.063a.669.669 0 0 1 .81 0l2.63 2.063c.433.34.168.985-.405.985h-1.31v4.577c0 .716-.572 1.297-1.28 1.297-.706 0-1.279-.58-1.279-1.297ZM8.823 9.158c-.814.19-1.677.283-2.448.283-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.2-.079.383-.164.548-.254a2.53 2.53 0 0 1-1.434-1.91Z" })), Pre || (Pre = u.createElement("path", { fill: "currentColor", d: "M6.787 3.479a10.514 10.514 0 0 0-.412-.008c-2.404 0-4.875.823-4.875 2.562 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.768 0 1.63-.101 2.418-.299V5.421H8.62c-.767 0-1.428-.45-1.706-1.125-.107-.26-.15-.54-.128-.817ZM11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729Z" })));
}, Recommended: function(e) {
  return u.createElement("svg", p8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Sre || (Sre = u.createElement("path", { fill: "currentColor", d: "m8.148 5.458-.944 1.968V9.59h2.099a.5.5 0 0 0 .491-.407l.223-1.182a.5.5 0 0 0-.491-.593h-.638a.623.623 0 0 1-.61-.636V5.708a.302.302 0 0 0-.13-.25Z" })), Nre || (Nre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.538 1.554a.75.75 0 0 0-1.076 0L6.4 2.648a.75.75 0 0 1-.615.224L4.27 2.716a.75.75 0 0 0-.824.692l-.11 1.52a.75.75 0 0 1-.328.567l-1.261.856a.75.75 0 0 0-.187 1.06l.893 1.235a.75.75 0 0 1 .113.644l-.416 1.467a.75.75 0 0 0 .538.932l1.478.373a.75.75 0 0 1 .501.42l.624 1.39a.75.75 0 0 0 1.011.369l1.372-.665a.75.75 0 0 1 .654 0l1.372.665a.75.75 0 0 0 1.011-.368l.624-1.391a.75.75 0 0 1 .5-.42l1.48-.373a.75.75 0 0 0 .537-.932l-.416-1.467a.75.75 0 0 1 .114-.644l.892-1.235a.75.75 0 0 0-.187-1.06l-1.261-.856a.75.75 0 0 1-.327-.566l-.11-1.52a.75.75 0 0 0-.825-.693l-1.517.156a.75.75 0 0 1-.614-.224L8.538 1.554Zm-1.064 3.28a.577.577 0 0 1 .518-.334c.639 0 1.157.54 1.157 1.208V6.5h.98c.549 0 .96.523.854 1.085l-.412 2.182a.881.881 0 0 1-.854.733H5.435c-.24 0-.435-.294-.435-.546V7.591c0-.251.195-.455.435-.455h.898c.013 0 .027 0 .04.002a.702.702 0 0 1 .03-.072l1.071-2.232Z", clipRule: "evenodd" })));
}, Redo: function(e) {
  return u.createElement("svg", g8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Rre || (Rre = u.createElement("path", { fill: "currentColor", d: "M4.018 9.402c-.05.328-.313.598-.645.598h-.8c-.331 0-.603-.27-.57-.6a5.996 5.996 0 0 1 2.543-4.325A5.997 5.997 0 0 1 7.974 4h.028c2.699 0 4.95 1.718 5.467 4h1.414c.541 0 .792.672.383 1.026l-2.482 2.15a.585.585 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.92 8h1.446c-.468-1.085-1.68-2-3.364-2a3.98 3.98 0 0 0-2.543.89 3.996 3.996 0 0 0-1.441 2.512Z" })));
}, Refresh: function(e) {
  return u.createElement("svg", h8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _re || (_re = u.createElement("path", { fill: "currentColor", d: "M8.033 2c2.699 0 4.95 1.718 5.467 4h1.414c.542 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.951 6h1.447c-.469-1.085-1.68-2-3.365-2-1.026 0-1.877.34-2.491.85-.243.202-.618.203-.817-.043l-.61-.754a.468.468 0 0 1 .044-.651C5.163 2.534 6.53 2 8.033 2ZM3.95 6.843a.584.584 0 0 0-.765 0L.703 8.992a.584.584 0 0 0 .383 1.026h1.418C3.03 12.291 5.275 14 7.967 14c1.505 0 2.87-.534 3.874-1.402a.468.468 0 0 0 .044-.65l-.61-.755c-.2-.246-.574-.245-.817-.043-.614.51-1.465.85-2.49.85-1.676 0-2.883-.904-3.358-1.982H6.05a.584.584 0 0 0 .383-1.026L3.95 6.842Z" })));
}, Relationship: function(e) {
  return u.createElement("svg", m8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Are || (Are = u.createElement("path", { fill: "currentColor", d: "M.5 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6a2.5 2.5 0 0 1 2.5 2.5v5A1.5 1.5 0 0 0 10 12h1.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H10a2.5 2.5 0 0 1-2.5-2.5v-5A1.5 1.5 0 0 0 6 4H4.5v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2Z" })));
}, ReplicaSet: function(e) {
  return u.createElement("svg", v8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Lre || (Lre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.39 7.713A3.488 3.488 0 0 1 8 8c-.494 0-.964-.102-1.39-.287L5.264 9.729a2.5 2.5 0 1 1-1.08-.634L5.57 7.02a3.5 3.5 0 1 1 4.86 0l1.385 2.076A2.501 2.501 0 0 1 15 11.5a2.5 2.5 0 1 1-4.265-1.77L9.391 7.712ZM9.75 4.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, Resize: function(e) {
  return u.createElement("svg", b8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Zre || (Zre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.77 5.72a.75.75 0 0 1 0 1.06l-7.991 8a.749.749 0 1 1-1.06-1.06l7.992-8a.749.749 0 0 1 1.06 0ZM14.78 10.22a.75.75 0 0 1 0 1.06l-3.496 3.5a.749.749 0 1 1-1.06-1.06l3.497-3.5a.749.749 0 0 1 1.06 0Z", clipRule: "evenodd" })));
}, Return: function(e) {
  return u.createElement("svg", y8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Tre || (Tre = u.createElement("path", { fill: "currentColor", d: "M5 2a1 1 0 0 0 0 2h5a2.5 2.5 0 0 1 0 5H5.203l1.448-1.24a1 1 0 1 0-1.302-1.52l-3.5 3a1 1 0 0 0 0 1.52l3.5 3a1 1 0 0 0 1.302-1.52L5.203 11H10a4.5 4.5 0 1 0 0-9H5Z" })));
}, Save: function(e) {
  return u.createElement("svg", w8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Bre || (Bre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 2 3.04 2 3.6 2h7.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l1.062 1.063c.173.173.26.26.322.36.055.09.095.188.12.29.027.115.027.237.027.482V12.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.2.102-.46.109-.954.109V9.284c0-.126 0-.25-.008-.353a1.01 1.01 0 0 0-.101-.385 1 1 0 0 0-.437-.437 1.01 1.01 0 0 0-.385-.1C11.465 8 11.342 8 11.216 8H4.784c-.126 0-.249 0-.353.008a1.01 1.01 0 0 0-.385.101 1 1 0 0 0-.437.437 1.01 1.01 0 0 0-.1.385c-.009.104-.009.227-.009.353V14c-.494 0-.753-.007-.954-.109a1 1 0 0 1-.437-.437C2 13.24 2 12.96 2 12.4V3.6Zm2-.1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z", clipRule: "evenodd" })), Ire || (Ire = u.createElement("path", { fill: "currentColor", d: "M11.5 9.3V14h-7V9.3c0-.148 0-.23.005-.288v-.006h.007C4.571 9 4.652 9 4.8 9h6.4c.148 0 .23 0 .288.005h.006v.007c.006.059.006.14.006.288Z" })));
}, Serverless: function(e) {
  return u.createElement("svg", E8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qre || (qre = u.createElement("path", { fill: "currentColor", d: "M2.132 10.849a5.5 5.5 0 1 1 8.4-6.571 4 4 0 0 1 4.398 6.444 1 1 0 0 1-.15.192l-1.77 1.898a1.995 1.995 0 0 1-1.51.688H7.792a2.5 2.5 0 1 1 0-2H11.5l1.166-1.25H8.5a3.75 3.75 0 0 0-6.368.599Z" })));
}, ShardedCluster: function(e) {
  return u.createElement("svg", j8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Wre || (Wre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 2.75a1.75 1.75 0 0 1-2.123 1.71l-.619.866a3.497 3.497 0 0 1 1.186 2.049h1.17a1.75 1.75 0 1 1 0 1.25h-1.17a3.497 3.497 0 0 1-1.186 2.05l.619.865a1.75 1.75 0 1 1-1.046.686l-.662-.926a3.495 3.495 0 0 1-2.331.002l-.664.93a1.75 1.75 0 1 1-1.043-.69l.616-.863a3.497 3.497 0 0 1-1.191-2.054h-1.17a1.75 1.75 0 1 1 0-1.25h1.17c.147-.819.58-1.54 1.191-2.054l-.616-.863a1.75 1.75 0 1 1 1.043-.69l.664.93A3.494 3.494 0 0 1 8 4.5c.41 0 .803.07 1.17.2l.66-.926A1.75 1.75 0 1 1 13 2.75ZM9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, SearchIndex: function(e) {
  return u.createElement("svg", O8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Hre || (Hre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.816 12.754a2.786 2.786 0 0 0 3.396.424l1.622 1.622a.683.683 0 1 0 .966-.966l-1.622-1.622a2.786 2.786 0 1 0-4.362.542Zm2.972-2.972a1.419 1.419 0 1 1-2.006 2.006 1.419 1.419 0 0 1 2.006-2.006Z", clipRule: "evenodd" })), Dre || (Dre = u.createElement("path", { fill: "currentColor", d: "M12 3.667c0 .083 0 .165-.002.245L12 4v.214c0 .281-.124.55-.393.815-.275.27-.682.512-1.187.715-1.01.405-2.31.613-3.42.613-1.11 0-2.41-.208-3.42-.613-.505-.203-.912-.446-1.187-.715C2.123 4.765 2 4.495 2 4.214V4c0-.033 0-.066.002-.099A12.44 12.44 0 0 1 2 3.667C2 1.857 4.534 1 7 1s5 .857 5 2.667Z" })), zre || (zre = u.createElement("path", { fill: "currentColor", d: "M2 5.813v1.83c0 .28.124.55.393.815.275.269.682.511 1.187.714 1.01.406 2.31.614 3.42.614l.134-.001A3.785 3.785 0 0 1 12 7.2V5.812c-.357.297-.8.537-1.277.729-1.124.452-2.532.672-3.723.672-1.191 0-2.599-.22-3.723-.672C2.8 6.35 2.357 6.11 2 5.813ZM7 10.643h.003c-.03.816.201 1.64.696 2.334-.232.015-.466.023-.699.023-2.466 0-5-.857-5-2.667 0-.083 0-.165.002-.245A2.229 2.229 0 0 1 2 10v-.758c.357.297.8.537 1.277.729 1.124.451 2.532.672 3.723.672Z" })));
}, Secondary: function(e) {
  return u.createElement("svg", x8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Fre || (Fre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z", clipRule: "evenodd" })), Vre || (Vre = u.createElement("path", { fill: "currentColor", d: "M11 9.67C11 11.112 9.786 12 8.117 12 6.337 12 5.07 10.897 5 9.395h1.972c.07.674.594.996 1.2.996.594 0 .897-.245.897-.613 0-.399-.262-.598-.869-.767l-1.297-.367c-1.2-.337-1.751-1.257-1.751-2.376C5.152 4.95 6.2 4 7.924 4c1.517 0 2.676.889 2.786 2.421H8.807c-.097-.582-.497-.781-.91-.781-.483 0-.814.214-.814.582 0 .43.372.598.786.705l1.214.368C10.434 7.678 11 8.475 11 9.671Z" })));
}, Settings: function(e) {
  return u.createElement("svg", $8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ure || (Ure = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.207 1.067a.75.75 0 0 0-.89.247l-.374.506a6.214 6.214 0 0 0-1.894.002l-.375-.506a.75.75 0 0 0-.89-.246l-1.126.467a.75.75 0 0 0-.454.804l.093.623c-.505.37-.958.82-1.338 1.34l-.623-.093a.75.75 0 0 0-.803.455l-.466 1.127a.75.75 0 0 0 .247.89l.506.374a6.214 6.214 0 0 0 .002 1.893l-.506.376a.75.75 0 0 0-.246.89l.467 1.126a.75.75 0 0 0 .804.454l.623-.093c.37.505.82.958 1.34 1.338l-.093.623a.75.75 0 0 0 .455.803l1.127.466a.75.75 0 0 0 .89-.247l.374-.506a6.218 6.218 0 0 0 1.894-.002l.375.506a.75.75 0 0 0 .89.246l1.126-.467a.75.75 0 0 0 .454-.804l-.093-.623c.505-.37.958-.82 1.338-1.34l.623.093a.75.75 0 0 0 .803-.455l.466-1.127a.75.75 0 0 0-.247-.89l-.506-.374a6.218 6.218 0 0 0-.002-1.894l.506-.375a.75.75 0 0 0 .246-.89l-.467-1.126a.75.75 0 0 0-.804-.454l-.623.093a6.214 6.214 0 0 0-1.34-1.338l.093-.623a.75.75 0 0 0-.455-.803l-1.127-.466Zm.334 7.984A2.75 2.75 0 1 1 5.46 6.949a2.75 2.75 0 0 1 5.082 2.102Z", clipRule: "evenodd" })));
}, Shell: function(e) {
  return u.createElement("svg", C8({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Gre || (Gre = u.createElement("path", { fill: "currentColor", d: "m1.8 5.2 3.4 2.2-3.79 2.526a.5.5 0 0 0-.142.688l.557.86a.5.5 0 0 0 .697.145L7.5 8.3c.3-.2.5-.5.5-.8 0-.3-.2-.6-.4-.8L2.522 3.284a.5.5 0 0 0-.699.143l-.547.847a.5.5 0 0 0 .155.695L1.8 5.2ZM6.7 13a.5.5 0 0 0 .5.5h7.7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.2a.5.5 0 0 0-.5.5v1Z" })));
}, SMS: function(e) {
  return u.createElement("svg", M8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Kre || (Kre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7.755L4.23 14.831c-.488.392-1.23.058-1.23-.555V12a2 2 0 0 1-2-2V4Zm2 .75A.75.75 0 0 1 3.75 4h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 4.75Zm0 3A.75.75 0 0 1 3.75 7h5.5a.75.75 0 1 1 0 1.5h-5.5A.75.75 0 0 1 3 7.75Z", clipRule: "evenodd" })));
}, SortAscending: function(e) {
  return u.createElement("svg", k8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Yre || (Yre = u.createElement("path", { fill: "currentColor", d: "M4.45 1.143a.584.584 0 0 0-.765 0L1.203 3.292a.584.584 0 0 0 .383 1.026h1.312v9.352a1.169 1.169 0 1 0 2.338 0V4.318H6.55a.584.584 0 0 0 .383-1.026L4.45 1.142ZM8 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, SortDescending: function(e) {
  return u.createElement("svg", P8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Xre || (Xre = u.createElement("path", { fill: "currentColor", d: "M4.45 14.696a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.025h1.312V2.168a1.169 1.169 0 1 1 2.338 0v9.351H6.55c.541 0 .792.673.383 1.027L4.45 14.696ZM8 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, Sparkle: function(e) {
  return u.createElement("svg", S8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Qre || (Qre = u.createElement("path", { fill: "currentColor", d: "m6.273 2.893-.998 2.995c-.1.3-.336.536-.636.637l-2.995.998a.503.503 0 0 0 0 .954l2.995.998c.3.1.536.336.636.637l.998 2.995a.503.503 0 0 0 .955 0l.998-2.995c.1-.3.336-.536.636-.637l2.995-.998a.503.503 0 0 0 0-.954l-2.995-.998c-.3-.1-.536-.336-.636-.637l-.998-2.995a.503.503 0 0 0-.955 0ZM12.547 1.172l-.231.693c-.1.3-.336.536-.636.636l-.694.231c-.229.077-.229.401 0 .477l.694.231c.3.1.536.336.636.637l.23.693c.077.229.402.229.478 0l.231-.693c.1-.3.336-.536.636-.637l.693-.23c.23-.077.23-.401 0-.478l-.693-.23c-.3-.1-.536-.337-.636-.637l-.231-.693a.251.251 0 0 0-.477 0ZM12.547 11.23l-.231.693c-.1.3-.336.536-.636.636l-.694.232c-.229.076-.229.4 0 .477l.694.23c.3.1.536.337.636.637l.23.693c.077.23.402.23.478 0l.231-.693c.1-.3.336-.536.636-.636l.693-.231c.23-.077.23-.401 0-.477l-.693-.232c-.3-.1-.536-.335-.636-.636l-.231-.693a.251.251 0 0 0-.477 0Z" })));
}, SplitHorizontal: function(e) {
  return u.createElement("svg", N8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), Jre || (Jre = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8Zm-2-4.5V3H3v3.5h10Zm-10 1V11h10V7.5H3Z", clipRule: "evenodd" })));
}, SplitVertical: function(e) {
  return u.createElement("svg", R8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), eae || (eae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM7.5 3H3v8h4.5V3Zm1 8H13V3H8.5v8Z", clipRule: "evenodd" })));
}, Stitch: function(e) {
  return u.createElement("svg", _8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), tae || (tae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h16v16H0V0Zm14 4V2H2v2h12Zm0 10V5H2v9h12ZM8 6v7H6V6h2Zm5 0v4H9V6h4ZM5 8v5H3V8h2Zm8 3v2H9v-2h4Z" })));
}, String: function(e) {
  return u.createElement("svg", A8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nae || (nae = u.createElement("path", { fill: "currentColor", d: "M10.69 14H5.31l-.15-.137v-.754l.15-.138h.602c.376 0 .753-.342.753-.685V3.5h-.903c-2.05 0-2.54.729-2.671 1.826l-.15.137h-.828L2 5.326l.282-3.189.15-.137h11.135l.15.137L14 5.326l-.113.137h-.827l-.15-.137c-.133-1.097-.622-1.826-2.672-1.826h-.903v8.786c0 .343.377.685.753.685h.602l.15.138v.754l-.15.137Z" })));
}, Support: function(e) {
  return u.createElement("svg", L8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rae || (rae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7a3 3 0 0 1 6 0v2.5c0 1.51-.957 2.798-2.298 3.288a1 1 0 1 0 .265.967 4.512 4.512 0 0 0 2.787-2.785c.08.02.161.03.246.03h.5a2.5 2.5 0 0 0 .406-4.967 5.002 5.002 0 0 0-9.813 0A2.5 2.5 0 0 0 3.5 11H4a1 1 0 0 0 1-1V7Z", clipRule: "evenodd" })));
}, Sweep: function(e) {
  return u.createElement("svg", Z8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), aae || (aae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 14.465 4 12.734c.292.169.631.266.999.266h2v2H5a3.982 3.982 0 0 1-2-.535ZM9 15v-2h2c.368 0 .707-.097.999-.266L13 14.464A3.982 3.982 0 0 1 11 15H9Zm6-8h-2V5c0-.368-.097-.707-.266-.999L14.464 3c.341.588.536 1.271.536 2v2ZM7 1H5c-.729 0-1.412.195-2 .535L4 3.266C4.293 3.097 4.632 3 5 3h2V1ZM1 9h2v2c0 .368.097.707.266.999L1.536 13A3.982 3.982 0 0 1 1 11V9Zm0-2h2V5c0-.368.097-.707.266-.999L1.536 3A3.982 3.982 0 0 0 1 5v2Zm8-6v2h2c.368 0 .707.097.999.266L13 1.536A3.982 3.982 0 0 0 11 1H9Zm6 8h-2v2c0 .368-.097.707-.266.999L14.464 13c.341-.588.536-1.271.536-2V9Z", clipRule: "evenodd" })));
}, Table: function(e) {
  return u.createElement("svg", T8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), lae || (lae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3.25C1 2.56 1.56 2 2.25 2h11.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 14 1 13.44 1 12.75v-9.5Zm2 4.12V4h4.37v3.37H3Zm0 1.25V12h4.37V8.62H3ZM8.62 12H13V8.62H8.62V12ZM13 7.37V4H8.62v3.37H13Z", clipRule: "evenodd" })));
}, Tag: function(e) {
  return u.createElement("svg", B8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), iae || (iae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m9.707 14.293 4.586-4.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 7.586 2H3a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, ThumbsDown: function(e) {
  return u.createElement("svg", I8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), oae || (oae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.019 15c.511 0 .98-.28 1.208-.724l2.501-4.837c.026-.05.05-.102.07-.155.03.003.06.004.092.004h2.094c.561 0 1.016-.441 1.016-.985V3.182C15 2.638 14.545 2 13.984 2H3.993C3.023 2 2.188 2.666 2 3.589L1.04 8.316c-.247 1.217.713 2.35 1.993 2.35H5.32v1.717C5.32 13.828 6.528 15 8.019 15Zm1.84-6.34-2.205 4.265a.642.642 0 0 1-.303-.542v-2.307c0-.762-.637-1.379-1.422-1.379H3.644a.5.5 0 0 1-.49-.6l.758-3.727a.5.5 0 0 1 .49-.4h5.456v4.69Z", clipRule: "evenodd" })));
}, ThumbsUp: function(e) {
  return u.createElement("svg", H8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), sae || (sae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.981 1c-.511 0-.98.28-1.208.724L4.272 6.56c-.026.05-.05.102-.07.155a1.06 1.06 0 0 0-.092-.004H2.016c-.561 0-1.016.441-1.016.985v5.121C1 13.362 1.455 14 2.016 14h9.991c.97 0 1.805-.665 1.993-1.589l.961-4.727c.248-1.217-.713-2.35-1.993-2.35H10.68V3.616C10.68 2.172 9.472 1 7.981 1Zm-1.84 6.34 2.205-4.265a.642.642 0 0 1 .303.542v2.307c0 .762.637 1.379 1.422 1.379h2.285a.5.5 0 0 1 .49.6l-.758 3.727a.5.5 0 0 1-.49.4H6.142V7.34Z", clipRule: "evenodd" })));
}, TimeSeries: function(e) {
  return u.createElement("svg", D8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cae || (cae = u.createElement("path", { fill: "currentColor", d: "M7.023 1.518c.513.024.957.363 1.12.853L9.38 6.108l1.56-2.092a1.24 1.24 0 0 1 1.872-.134l1.897 1.91c.388.39.388 1.023 0 1.413l-.377.354a.99.99 0 0 1-1.405 0l-.86-.89-2.122 2.847a1.239 1.239 0 0 1-2.172-.355L6.798 6.22 6.11 7.774c-.2.451-.644.742-1.135.742H1.994a.997.997 0 0 1-.994-1v-.5c0-.552.445-1 .994-1h2.174l1.66-3.758a1.242 1.242 0 0 1 1.195-.74ZM14 12a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h12Z" })));
}, TimeSeriesCollection: function(e) {
  return u.createElement("svg", z8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), uae || (uae = u.createElement("path", { fill: "currentColor", d: "M13.6 10.383H15c.6 0 1 .499 1 1.098 0 .598-.4.998-1 .998h-.9l-1.5 2.096c-.2.3-.6.499-1 .399-.4-.1-.7-.4-.8-.799l-.4-1.696-.4 1.197c-.1.3-.5.6-.9.6H8c-.6 0-1-.4-1-.999s.4-.998 1-.998h.4l1.4-3.693c.1-.4.6-.599 1-.599s.8.4.9.699l.6 2.794.5-.698c.2-.2.5-.4.8-.4Z" })), fae || (fae = u.createElement("path", { fill: "currentColor", d: "M1.929 1A.922.922 0 0 0 1 1.915v9.15c0 .505.416.915.929.915H5.84c.101-.173.225-.336.374-.485.322-.321.71-.526 1.118-.63l1.043-2.75c.208-.678.706-1.086 1.107-1.3A2.846 2.846 0 0 1 10.8 6.49c.682 0 1.214.323 1.531.591.318.269.635.66.792 1.131l.026.079.133.617a2.24 2.24 0 0 1 .318-.023h.4v-5.14a.922.922 0 0 0-.929-.915H7.5a.922.922 0 0 1-.929-.915A.922.922 0 0 0 5.643 1H1.929Z" })), dae || (dae = u.createElement("path", { fill: "currentColor", d: "M10.95 8.005a.699.699 0 0 0-.066-.012l.065.012Z" })));
}, Trash: function(e) {
  return u.createElement("svg", F8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), pae || (pae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2a1 1 0 0 1 1 1v1H2V3a1 1 0 0 1 1-1h2Zm9 3H2l1.678 8.392A2 2 0 0 0 5.64 15h4.72a2 2 0 0 0 1.962-1.608L14 5Z", clipRule: "evenodd" })));
}, Undo: function(e) {
  return u.createElement("svg", V8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gae || (gae = u.createElement("path", { fill: "currentColor", d: "M11.981 9.402c.05.328.313.598.645.598h.8c.331 0 .603-.27.57-.6a5.996 5.996 0 0 0-2.543-4.325A5.997 5.997 0 0 0 8.026 4h-.029C5.298 4 3.047 5.718 2.53 8H1.116a.584.584 0 0 0-.383 1.026l2.482 2.15c.22.19.545.19.765 0l2.482-2.15A.584.584 0 0 0 6.079 8H4.632c.47-1.085 1.68-2 3.365-2a3.98 3.98 0 0 1 2.543.89 3.996 3.996 0 0 1 1.441 2.512Z" })));
}, University: function(e) {
  return u.createElement("svg", q8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hae || (hae = u.createElement("path", { fill: "currentColor", d: "M8.5 4.613c0-.383.191-.74.51-.953a6.87 6.87 0 0 1 2.145-.949l2.406-.601a.353.353 0 0 1 .439.342v7.88c0 .238 0 .357-.043.453a.5.5 0 0 1-.176.211c-.087.06-.204.081-.438.123l-3.9.71c-.324.058-.486.088-.612.042a.5.5 0 0 1-.264-.22c-.067-.116-.067-.28-.067-.61V4.613ZM2 2.452c0-.23.216-.398.439-.342l2.407.601a6.87 6.87 0 0 1 2.144.95c.319.211.51.569.51.952v6.428c0 .33 0 .494-.067.61a.5.5 0 0 1-.264.22c-.126.046-.288.016-.612-.043l-3.9-.709c-.234-.042-.35-.063-.438-.123a.5.5 0 0 1-.176-.21C2 10.688 2 10.57 2 10.331v-7.88ZM2.008 12.41a.5.5 0 0 1 .581-.402l5.143.935c.177.032.359.032.536 0l5.143-.935a.5.5 0 0 1 .178.984l-4.134.752c-.163.434-.753.756-1.455.756-.702 0-1.292-.322-1.455-.756l-4.134-.752a.5.5 0 0 1-.403-.581Z" })));
}, Unlock: function(e) {
  return u.createElement("svg", U8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), mae || (mae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.157 4.221A2 2 0 0 1 10 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1V5a4 4 0 0 0-7.822-1.182C3.982 4.45 4.538 5 5.2 5c.442 0 .785-.372.957-.779Zm2.43 6.589A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, Unsorted: function(e) {
  return u.createElement("svg", W8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vae || (vae = u.createElement("path", { fill: "currentColor", d: "M3.685 1.143c.22-.19.545-.19.765 0l2.482 2.149a.584.584 0 0 1-.383 1.026H5.236v7.364H6.55c.541 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.026h1.312V4.318H1.586a.584.584 0 0 1-.383-1.026l2.482-2.15ZM8 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H9ZM8 11a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" })));
}, UpDownCarets: function(e) {
  return u.createElement("svg", G8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), bae || (bae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.527 1.21a.638.638 0 0 1 .948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562Zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 0 1-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654Z" })));
}, Upload: function(e) {
  return u.createElement("svg", K8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), yae || (yae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.297 11v.938a4 4 0 1 0-.764-7.66A5.501 5.501 0 0 0 0 6.5a5.5 5.5 0 0 0 5.797 5.492V11h-.403c-1.395 0-2.08-1.7-1.075-2.667L7.472 5.3a1.55 1.55 0 0 1 2.15 0l3.152 3.034C13.78 9.301 13.094 11 11.7 11h-.402ZM8.339 6.2a.3.3 0 0 1 .416 0l3.152 3.034a.3.3 0 0 1-.208.516h-1.652v3.75a1.5 1.5 0 0 1-3 0V9.75H5.394a.3.3 0 0 1-.208-.516L8.339 6.2Z", clipRule: "evenodd" })));
}, VerticalEllipsis: function(e) {
  return u.createElement("svg", Y8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), wae || (wae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM7.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", clipRule: "evenodd" })));
}, Visibility: function(e) {
  return u.createElement("svg", X8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Oae || (Oae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2.008c3.934 0 6.473 3.129 7.455 4.583l.043.064C15.713 6.97 16 7.391 16 8s-.287 1.03-.502 1.345l-.043.064c-.982 1.454-3.521 4.583-7.455 4.583S1.527 10.863.545 9.41l-.043-.064C.287 9.03 0 8.609 0 8s.287-1.03.502-1.345l.043-.064C1.527 5.137 4.066 2.008 8 2.008ZM9.13 4.13A5.147 5.147 0 0 0 8 4.005C5.75 4.005 3.927 5.794 3.927 8c0 2.206 1.824 3.995 4.073 3.995 2.25 0 4.073-1.789 4.073-3.995 0-2.206-1.824-3.995-4.073-3.995.378 0 .756.045 1.13.126ZM8 10.996c1.687 0 3.055-1.341 3.055-2.996S9.687 5.004 8 5.004 4.945 6.345 4.945 8 6.313 10.996 8 10.996Z", clipRule: "evenodd" })));
}, VisibilityOff: function(e) {
  return u.createElement("svg", Q8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xae || (xae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.601 1.266a1.03 1.03 0 0 0-1.433.049L1.704 13.486a.987.987 0 0 0 .062 1.407 1.03 1.03 0 0 0 1.433-.049l1.793-1.904A7.348 7.348 0 0 0 8 13.587c3.934 0 6.473-3.133 7.455-4.59l.043-.063c.215-.316.502-.737.502-1.347s-.287-1.03-.502-1.346l-.043-.065a12.85 12.85 0 0 0-1.949-2.275l1.157-1.228a.987.987 0 0 0-.062-1.407Zm-2.93 4.585-.764.81c.096.292.148.603.148.926 0 1.657-1.368 3-3.055 3-.246 0-.485-.028-.714-.082l-.763.81c.458.176.956.272 1.477.272 2.25 0 4.073-1.79 4.073-4 0-.622-.145-1.211-.403-1.736ZM8 1.587c.919 0 1.762.171 2.526.452L8.98 3.68A5.13 5.13 0 0 0 8 3.587c-2.25 0-4.073 1.79-4.073 4 0 .435.07.853.201 1.245l-1.985 2.107A13.06 13.06 0 0 1 .545 8.998l-.043-.064C.287 8.618 0 8.197 0 7.587s.287-1.03.502-1.346l.043-.065C1.527 4.72 4.066 1.587 8 1.587Zm0 2c.327 0 .654.034.978.095l-.016.017A4.155 4.155 0 0 0 8 3.587Zm0 1c.041 0 .083 0 .124.002L4.966 7.942a2.978 2.978 0 0 1-.02-.355c0-1.657 1.367-3 3.054-3Z", clipRule: "evenodd" })));
}, Warning: function(e) {
  return u.createElement("svg", J8({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Eae || (Eae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.864 1.514a.983.983 0 0 0-1.728 0L1.122 12.539A.987.987 0 0 0 1.986 14h12.028a.987.987 0 0 0 .864-1.461L8.864 1.514ZM7 5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V5Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, Wizard: function(e) {
  return u.createElement("svg", e9({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $ae || ($ae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.327 3.277c.188-.38-.236-.8-.618-.613l-2.513 1.223a.461.461 0 0 1-.523-.095L7.603 1.74c-.314-.313-.829-.062-.75.365l.517 2.808a.421.421 0 0 1-.228.46L4.63 6.596c-.383.186-.277.761.154.839l2.832.513a.477.477 0 0 1 .382.379l.517 2.808c.079.427.659.532.846.153l1.234-2.492a.427.427 0 0 1 .464-.225l2.832.512c.43.078.683-.432.368-.744l-2.07-2.052a.452.452 0 0 1-.095-.519l1.233-2.491ZM7 10.5c.353-.35.312-.958-.091-1.359-.404-.4-1.017-.44-1.37-.09L1.84 12.713c-.353.35-.312.958.092 1.358.403.4 1.017.44 1.37.09L7 10.5Z", clipRule: "evenodd" })));
}, Wrench: function(e) {
  return u.createElement("svg", t9({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), jae || (jae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.625 9.75a4.374 4.374 0 0 0 4.206-5.584c-.085-.295-.449-.36-.665-.145l-2.1 2.1a.44.44 0 0 1-.184.11c-.078.024-.157-.013-.215-.07L9.84 4.332c-.058-.058-.095-.137-.071-.215a.44.44 0 0 1 .11-.184l2.1-2.1c.216-.216.147-.58-.145-.664a4.374 4.374 0 0 0-5.385 5.512.32.32 0 0 1-.077.32l-4.828 4.829a1.857 1.857 0 0 0 2.625 2.625l4.828-4.828a.32.32 0 0 1 .323-.075c.412.129.851.197 1.305.197ZM2.75 14.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z", clipRule: "evenodd" })));
}, Write: function(e) {
  return u.createElement("svg", n9({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Cae || (Cae = u.createElement("path", { fill: "currentColor", d: "M8.71 3.75a9.487 9.487 0 0 0-2.335-.28c-2.404 0-4.875.824-4.875 2.563 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.267 0 .546-.013.828-.037a1.76 1.76 0 0 1-.288-1.818 1.826 1.826 0 0 1 1.706-1.125h.09V3.75ZM8.068 9.305c-.578.091-1.158.136-1.693.136-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.22-.086.42-.18.598-.282a1.85 1.85 0 0 1-.209-.141l-2.03-1.594Z" })), Mae || (Mae = u.createElement("path", { fill: "currentColor", d: "M11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729ZM12.489 2.297v4.576h1.39c.574 0 .84.646.406.986l-2.63 2.063a.668.668 0 0 1-.81 0l-2.63-2.063c-.433-.34-.168-.986.406-.986H9.93V2.297C9.93 1.58 10.502 1 11.21 1c.706 0 1.279.58 1.279 1.297Z" })));
}, X: function(e) {
  return u.createElement("svg", r9({ xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kae || (kae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.203 3.404a1 1 0 0 0-1.414 0L8.314 5.879 5.839 3.404a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L6.192 8l-2.474 2.475a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l2.475-2.475 2.475 2.475a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L10.435 8l2.475-2.475a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, XWithCircle: function(e) {
  return u.createElement("svg", a9({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Pae || (Pae = u.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.414-9.828a1 1 0 1 1 1.414 1.414L9.414 8l1.414 1.414a1 1 0 1 1-1.414 1.414L8 9.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L6.586 8 5.172 6.586a1 1 0 0 1 1.414-1.414L8 6.586l1.414-1.414Z", clipRule: "evenodd" })));
} }, E_e = Object.keys(Sae).reduce(function(e, t) {
  return e[t] = w_e(t, Sae[t]), e;
}, {}), Nae = x_e(E_e), afe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(afe);
var $_e = afe.exports;
const j_e = /* @__PURE__ */ ce($_e);
var lfe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(lfe);
var C_e = lfe.exports;
const M_e = /* @__PURE__ */ ce(C_e);
var ife = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(ife);
var k_e = ife.exports;
const P_e = /* @__PURE__ */ ce(k_e);
function S_e(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Fe(e, t, n) {
  return (t = S_e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yn() {
  return yn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yn.apply(this, arguments);
}
function Yn(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Pe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function N_e(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Rae(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return Rae(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Rae(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var _ae, Aae, Lae, Zae, Tae, Bae, Iae, Hae, Fl = v(_ae || (_ae = Pe([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), ofe = Fe(Fe({}, W.Body1, v(Aae || (Aae = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Lae || (Lae = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), R_e = Fe(Fe({}, W.Body1, v(Zae || (Zae = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(Tae || (Tae = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), L1 = Fe(Fe({}, S.Light, v(Bae || (Bae = Pe([`
    color: `, `;
  `])), b.black)), S.Dark, v(Iae || (Iae = Pe([`
    color: `, `;
  `])), b.gray.light2)), ma = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, __e = ["baseFontSize", "darkMode", "className", "weight", "as"], sfe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = Yn(e, __e), h = K(n).theme, g = ma(t), m = ne(f).Component, y = v(Hae || (Hae = Pe([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, yn({ className: H(Fl, ofe[g], L1[h], y, r) }, d));
});
sfe.displayName = "Body";
var Dae, zae, Fae, Vae, qae, Uae, Wae, Gae, Kae, Yae, cfe = { label: "lg-label", description: "lg-description" }, A_e = v(Dae || (Dae = Pe([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular), L_e = Fe(Fe({}, S.Light, v(zae || (zae = Pe([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(Fae || (Fae = Pe([`
    color: `, `;
  `])), b.gray.light1)), Z_e = Fe(Fe({}, S.Light, v(Vae || (Vae = Pe([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(qae || (qae = Pe([`
    color: `, `;
  `])), b.gray.dark1)), T_e = Fe(Fe({}, W.Body1, v(Uae || (Uae = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Wae || (Wae = Pe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), B_e = ["baseFontSize", "data-lgid", "darkMode", "disabled", "children", "className"], ufe = function(e) {
  var t = e.baseFontSize, n = e["data-lgid"], r = n === void 0 ? cfe.description : n, l = e.darkMode, i = e.disabled, c = i !== void 0 && i, f = e.children, d = e.className, h = Yn(e, B_e), g = K(l).theme, m = ma(t);
  return k.createElement("p", yn({ "data-lgid": r, className: H(A_e, L_e[g], T_e[m], Fe({}, Z_e[g], c), d) }, h), f);
};
ufe.displayName = "Description";
var Xae, Qae, Jae, ele, tle;
Fe(Fe({}, S.Light, v(Gae || (Gae = Pe([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(Kae || (Kae = Pe([`
    color: `, `;
  `])), b.gray.light1));
v(Yae || (Yae = Pe([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var nle, rle, ale, lle, ile, ole, I_e = v(Xae || (Xae = Pe([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), H_e = Fe(Fe({}, S.Light, v(Qae || (Qae = Pe([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(Jae || (Jae = Pe([`
    color: `, `;
  `])), b.red.light1)), D_e = Fe(Fe({}, W.Body1, v(ele || (ele = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(tle || (tle = Pe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), z_e = ["as", "darkMode", "children", "className"], F_e = te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = Yn(e, z_e), f = K(r).theme, d = ma(), h = ne(n).Component;
  return k.createElement(h, yn({}, c, { className: H(I_e, H_e[f], D_e[d], i) }), l);
}), V_e = v(nle || (nle = Pe([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), q_e = Fe(Fe({}, S.Light, v(rle || (rle = Pe([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(ale || (ale = Pe([`
    color: `, `;
  `])), b.gray.light2)), U_e = ["darkMode", "className", "as"], W_e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = Yn(e, U_e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, yn({ className: H(Fl, V_e, q_e[c], n) }, i));
});
W_e.displayName = "H1";
var sle, G_e = v(lle || (lle = Pe([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), K_e = Fe(Fe({}, S.Light, v(ile || (ile = Pe([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(ole || (ole = Pe([`
    color: `, `;
  `])), b.gray.light2)), Y_e = ["darkMode", "className", "as"], X_e = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = Yn(e, Y_e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, yn({ className: H(Fl, G_e, K_e[c], n) }, i));
});
X_e.displayName = "H2";
var cle, ule, fle, dle, ple, gle, hle, mle, vle, ble, Q_e = v(sle || (sle = Pe([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), J_e = ["darkMode", "className", "as"], eAe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = Yn(e, J_e), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, yn({ className: H(Fl, Q_e, L1[c], n) }, i));
});
eAe.displayName = "H3";
var yle, wle, Ole, bl = gt(), tAe = v(cle || (cle = Pe([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, bl), nAe = Fe(Fe({}, S.Light, v(ule || (ule = Pe([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, bl, b.gray.light2, b.gray.light1)), S.Dark, v(fle || (fle = Pe([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, bl, b.gray.dark2, b.gray.dark1)), rAe = Fe(Fe({}, S.Light, v(dle || (dle = Pe([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), bl, it[S.Light].default, b.blue.base)), S.Dark, v(ple || (ple = Pe([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), bl, it[S.Dark].default, b.blue.base)), aAe = Fe(Fe({}, S.Light, v(gle || (gle = Pe([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(hle || (hle = Pe([`
    color: `, `;
  `])), b.blue.light1)), lAe = v(mle || (mle = Pe([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), iAe = v(vle || (vle = Pe([`
  white-space: nowrap;
`]))), oAe = v(ble || (ble = Pe([`
  white-space: normal;
`]))), sAe = ["children", "className", "darkMode", "baseFontSize", "as"], xle = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = Yn(e, sAe), g = K(c).theme, m = ma(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? iAe : oAe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(R_e[m], tAe, nAe[g], rAe[g], w, Fe({}, aAe[g], C), i) }, l);
  return C ? k.createElement(y, yn({ className: H(bl, lAe, i) }, h), E) : k.cloneElement(E, h);
});
xle.displayName = "InlineCode", xle.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var Ele, $le, jle, Cle, Mle, kle, Ple;
v(yle || (yle = Pe([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Fe(Fe({}, S.Light, v(wle || (wle = Pe([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(Ole || (Ole = Pe([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var Sle, Nle, Rle, cAe = v(Ele || (Ele = Pe([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), uAe = Fe(Fe({}, S.Light, v($le || ($le = Pe([`
    color: `, `;
  `])), b.black)), S.Dark, v(jle || (jle = Pe([`
    color: `, `;
  `])), b.gray.light2)), fAe = Fe(Fe({}, S.Light, v(Cle || (Cle = Pe([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(Mle || (Mle = Pe([`
    color: `, `;
  `])), b.gray.dark1)), dAe = Fe(Fe({}, W.Body1, v(kle || (kle = Pe([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Ple || (Ple = Pe([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), pAe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], ffe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? cfe.label : h, m = Yn(e, pAe), y = K(n).theme, w = ma(t), C = ne(d).Component;
  return k.createElement(C, yn({ "data-lgid": g, className: H(cAe, uAe[y], dAe[w], Fe({}, fAe[y], c), r) }, m), l);
});
ffe.displayName = "Label";
var _le, Ale, Lle, Zle, Tle, Ble, Go = gt(), dfe = v(Sle || (Sle = Pe([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), pfe = Fe(Fe({}, S.Light, v(Nle || (Nle = Pe([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(Rle || (Rle = Pe([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), gfe = function(e) {
  if (e)
    return ofe[e];
}, gAe = v(_le || (_le = Pe([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), hAe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = Yn(e, hAe), d = K(i).theme, h = ma(l), g = nt(c, f, "span").Component;
  return k.createElement(g, yn({ className: H(Go, dfe, gfe(h), pfe[d], gAe, r), ref: t }, f), k.createElement(j_e, { role: "presentation" }), n);
});
var mAe = v(Ale || (Ale = Pe([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), vAe = v(Lle || (Lle = Pe([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Go, Go), bAe = v(Zle || (Zle = Pe([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), yAe = "hover", wAe = "persist", Ile = "none", OAe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? Ile : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = Yn(e, OAe), y = N_e(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = ma(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== Ile && (E = k.createElement(M_e, { role: "presentation", size: 12, className: H(Fe(Fe({}, vAe, i === yAe), mAe, i === wAe)) })) : E = k.createElement(P_e, { role: "presentation", className: bAe }), k.createElement(P, yn({ className: H(Go, dfe, gfe(M), pfe[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var xAe = v(Tle || (Tle = Pe([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), EAe = ["darkMode", "className", "as"], $Ae = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = Yn(e, EAe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, yn({ className: H(Fl, xAe, L1[c], n) }, i));
});
$Ae.displayName = "Overline";
var jAe = v(Ble || (Ble = Pe([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), CAe = ["darkMode", "className", "as"], MAe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = Yn(e, CAe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, yn({ className: H(Fl, jAe, L1[c], n) }, i));
});
MAe.displayName = "Subtitle";
var Hle;
v(Hle || (Hle = Pe([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var io = "lg-form_field", l9 = { root: io, errorMessage: "".concat(io, "-error_message"), successMessage: "".concat(io, "-success_message"), optional: "".concat(io, "-optional") };
function Dle(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function i9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dle(Object(n), !0).forEach(function(r) {
      pt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dle(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kAe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function pt(e, t, n) {
  return (t = kAe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ko() {
  return Ko = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ko.apply(this, arguments);
}
function o9(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function dt(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var zle, Fle, Vle, qle, Ule, Wle, Gle, Kle, Yle, Xle, Qle, Jle, eie, tie, nie, rie, aie, lie, iie, oie, sie, cie, uie, fie, die, pie, gie, hie, mie, vie, bie, yie, wie, Oie, xie, jr = { None: "none", Error: "error", Valid: "valid" }, PAe = { disabled: !1, size: un.Default, state: jr.None }, hfe = k.createContext(PAe), SAe = function(e) {
  var t = e.value, n = e.children;
  return k.createElement(hfe.Provider, { value: t }, n);
}, NAe = function() {
  return jl(hfe);
}, RAe = v(qle || (qle = dt([`
  display: flex;
  flex-direction: column;
`]))), _Ae = v(Ule || (Ule = dt([`
  margin-bottom: `, `px;
`])), ee[100]), AAe = v(Wle || (Wle = dt([`
  margin-top: `, `px;
  display: flex;
  align-items: center;
  gap: `, `px;
`])), ee[100], ee[100]), LAe = pt(pt({}, S.Light, v(Gle || (Gle = dt([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(Kle || (Kle = dt([`
    color: `, `;
  `])), b.red.light1)), ZAe = pt(pt({}, S.Light, v(Yle || (Yle = dt([`
    color: `, `;
  `])), b.green.dark1)), S.Dark, v(Xle || (Xle = dt([`
    color: `, `;
  `])), b.green.base)), TAe = ["label", "description", "state", "id", "disabled"], BAe = ["label", "description", "children", "baseFontSize", "state", "size", "disabled", "errorMessage", "successMessage", "className", "darkMode", "optional", "id"], mfe = wn(function(e, t) {
  var n = e.label, r = e.description, l = e.children, i = e.baseFontSize, c = e.state, f = c === void 0 ? jr.None : c, d = e.size, h = d === void 0 ? un.Default : d, g = e.disabled, m = g !== void 0 && g, y = e.errorMessage, w = e.successMessage, C = e.className, E = e.darkMode, R = e.optional, M = e.id, P = o9(e, BAe), a = K().theme, o = function(Z) {
    var G = Z.baseFontSize, I = Z.size;
    return I === un.XSmall || I === un.Small ? v(zle || (zle = dt([`
      font-size: `, `px;
      line-height: `, `px;
    `])), V.body1.fontSize, V.body1.lineHeight) : I === un.Default ? v(Fle || (Fle = dt([`
      font-size: `, `px;
      line-height: `, `px;
    `])), G, V.body1.lineHeight) : I === un.Large ? v(Vle || (Vle = dt([`
      font-size: 18px;
      line-height: 24px;
    `]))) : void 0;
  }({ baseFontSize: ma(i), size: h }), s = function(Z) {
    var G, I = Z.label, F = Z.description, U = Z.state, B = Z.id, L = Z.disabled, q = o9(Z, TAe), D = Hn({ prefix: "lg-form-field-label" }), _ = Hn({ prefix: "lg-form-field-description" }), re = Hn({ prefix: "lg-form-field-description" }), ue = Hn({ prefix: "lg-form-field-input" }), se = B ?? ue, Re = U === jr.Error, ft = I ? D : q["aria-labelledby"], Le = I || ft ? void 0 : q["aria-label"];
    return { labelId: D, descriptionId: _, errorId: re, inputId: se, inputProps: { id: se, "aria-labelledby": ft, "aria-describedby": "".concat(F ? _ : "", " ").concat(Re ? re : "").trim(), "aria-label": Le, "aria-disabled": L, readOnly: L, "aria-invalid": (G = q["aria-invalid"]) !== null && G !== void 0 ? G : Re } };
  }(i9({ label: n, description: r, state: f, id: M, disabled: m }, P)), p = s.labelId, O = s.descriptionId, x = s.errorId, N = s.inputId, T = s.inputProps, $ = f === jr.Error, j = f === jr.Valid, A = ($ || j) && !m;
  return k.createElement(Fn, { darkMode: E }, k.createElement(SAe, { value: { disabled: m, size: h, state: f, inputProps: T, optional: R } }, k.createElement("div", Ko({ className: H(o, C), ref: t }, P), k.createElement("div", { className: H(RAe, pt({}, _Ae, !(!n && !r))) }, n && k.createElement(ffe, { "data-testid": "lg-form_field-label", className: o, htmlFor: N, id: p, disabled: m }, n), r && k.createElement(ufe, { "data-testid": "lg-form_field-description", className: o, id: O, disabled: m }, r)), l, A && k.createElement("div", { className: AAe }, $ && k.createElement(k.Fragment, null, k.createElement(Nae, { "aria-hidden": !0, title: "Error", glyph: "Warning", className: LAe[a] }), k.createElement(F_e, { "data-testid": "lg-form_field-error_message", "data-lgid": l9.errorMessage, className: o, id: x }, y)), j && k.createElement(k.Fragment, null, k.createElement(Nae, { "aria-hidden": !0, title: "Valid", glyph: "Checkmark", className: ZAe[a] }), k.createElement(sfe, { "data-testid": "lg-form_field-success_message", "data-lgid": l9.successMessage, className: o }, w))))));
});
mfe.displayName = "FormField";
var yl = gt("form-field-input"), Z1 = gt("form-field-icon"), Kr = function(e) {
  return "0 0 0 100px ".concat(e, " inset");
}, IAe = v(Qle || (Qle = dt([`
  display: flex;
  align-items: center;
  gap: `, `px;
  font-size: inherit;
  line-height: inherit;
  font-family: `, `;
  width: 100%;
  height: 36px;
  font-weight: `, `;
  border: 1px solid;
  z-index: 1;
  outline: none;
  border-radius: 6px;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
  z-index: 0;

  & .`, ` {
    font-family: `, `;
    color: inherit;
    background-color: inherit;
    font-size: inherit;
    line-height: inherit;
    outline: none;
    border: none;
  }

  & .`, ` svg,
  & svg {
    min-height: 16px;
    min-width: 16px;
  }
`])), ee[1], Q.default, Y.regular, It.default, yl, Q.default, Z1), Eie = pt(pt({}, S.Light, v(Jle || (Jle = dt([`
    color: `, `;
    background: `, `;
    border: 1px solid `, `;

    &:hover,
    &:active {
      &:not(:focus) {
        box-shadow: `, `;
      }
    }

    & .`, ` {
      &:-webkit-autofill {
        color: `, `;
        background: `, `;
        border: 1px solid `, `;
        -webkit-text-fill-color: `, `;
        box-shadow: `, `;

        &:focus {
          box-shadow: `, `,
            `, `;
          border-color: `, `;
        }

        &:hover:not(:focus) {
          box-shadow: `, `,
            `, `;
        }
      }

      &::placeholder {
        color: `, `;
        font-weight: `, `;
      }
    }
  `])), b.black, b.white, b.gray.base, gn.light.gray, yl, b.black, b.white, b.gray.base, b.black, Kr(b.white), Kr(b.white), it.light.input, b.white, Kr(b.white), gn.light.gray, b.gray.base, Y.regular)), S.Dark, v(eie || (eie = dt([`
    color: `, `;
    background-color: `, `;
    border: 1px solid `, `;

    &:hover,
    &:active {
      &:not(:focus) {
        box-shadow: `, `;
      }
    }

    & .`, ` {
      &:-webkit-autofill {
        border: 1px solid `, `;
        color: `, `;
        background: `, `;
        -webkit-text-fill-color: `, `;
        box-shadow: `, `;

        &:focus {
          box-shadow: `, `,
            `, `;
          border-color: `, `;
        }

        &:hover:not(:focus) {
          box-shadow: `, `,
            `, `;
        }
      }

      &::placeholder {
        color: `, `;
        font-weight: `, `;
      }
    }
  `])), b.gray.light3, b.gray.dark4, b.gray.base, gn.dark.gray, yl, b.gray.base, b.gray.light3, b.gray.dark4, b.gray.light3, Kr(b.gray.dark4), Kr(b.gray.dark4), it.dark.input, b.blue.light1, Kr(b.gray.dark4), gn.dark.gray, b.gray.dark1, Y.regular)), $ie = function(e) {
  return v(tie || (tie = dt([`
  @supports selector(:has(a, b)) {
    &:focus-within:not(:has(.`, `:focus)) {
      `, `
    }
  }

  /* Fallback for when "has" is unsupported */
  @supports not selector(:has(a, b)) {
    &:focus-within {
      `, `
    }
  }
`])), Z1, e, e);
}, HAe = pt(pt({}, S.Light, $ie(`
     {
      box-shadow: `.concat(it.light.input, `;
      border-color: `).concat(b.white, `;
    }
  `))), S.Dark, $ie(`
     {
      box-shadow: `.concat(it.dark.input, `;
      border-color: `).concat(b.gray.dark4, `;
    }
  `))), oo = "&:has(button.".concat(Z1, ")"), DAe = pt(pt(pt(pt({}, un.XSmall, v(nie || (nie = dt([`
    height: 22px;
    padding-inline: `, `px;

    `, ` {
      padding-inline-end: `, `px;
    }
  `])), ee[200], oo, ee[100])), un.Small, v(rie || (rie = dt([`
    height: 28px;
    padding-inline: `, `px;

    `, ` {
      padding-inline-end: `, `px;
    }
  `])), ee[200], oo, ee[100])), un.Default, v(aie || (aie = dt([`
    height: 36px;
    padding-inline: `, `px;

    `, ` {
      padding-inline-end: `, `px;
    }
  `])), ee[300], oo, ee[150])), un.Large, v(lie || (lie = dt([`
    height: 48px;
    padding-inline: `, `px;

    `, ` {
      padding-inline-end: `, `px;
    }
  `])), ee[300], oo, ee[200])), zAe = pt(pt(pt({}, jr.Error, pt(pt({}, S.Light, v(iie || (iie = dt([`
      border-color: `, `;

      &:hover,
      &:active {
        &:not(:focus) {
          box-shadow: `, `;
        }
      }
    `])), b.red.base, gn.light.red)), S.Dark, v(oie || (oie = dt([`
      border-color: `, `;

      &:hover,
      &:active {
        &:not(:focus) {
          box-shadow: `, `;
        }
      }
    `])), b.red.light1, gn.dark.red))), jr.None, pt(pt({}, S.Light, v(sie || (sie = dt([""])))), S.Dark, v(cie || (cie = dt([""]))))), jr.Valid, pt(pt({}, S.Light, v(uie || (uie = dt([`
      border-color: `, `;

      &:hover,
      &:active {
        &:not(:focus) {
          box-shadow: `, `;
        }
      }
    `])), b.green.dark1, gn.light.green)), S.Dark, v(fie || (fie = dt([`
      border-color: `, `;

      &:hover,
      &:active {
        &:not(:focus) {
          box-shadow: `, `;
        }
      }
    `])), b.green.dark1, gn.dark.green))), FAe = pt(pt({}, S.Light, v(die || (die = dt([`
    cursor: not-allowed;
    background-color: `, `;
    border-color: `, `;

    &:hover,
    &:active {
      &:not(:focus) {
        box-shadow: inherit;
      }
    }

    & .`, ` {
      cursor: not-allowed;
      pointer-events: none;
      color: `, `;

      &::placeholder {
        color: inherit;
      }

      &:-webkit-autofill {
        &,
        &:hover,
        &:focus {
          appearance: none;
          border: 1px solid `, `;
          -webkit-text-fill-color: `, `;
          box-shadow: `, `;
        }

        &:hover:not(:focus) {
          box-shadow: inherit;
        }
      }
    }
  `])), b.gray.light2, b.gray.light1, yl, b.gray.base, b.gray.base, b.gray.base, Kr(b.gray.light2))), S.Dark, v(pie || (pie = dt([`
    cursor: not-allowed;
    color: `, `;
    background-color: `, `;
    border-color: `, `;

    &:hover,
    &:active {
      &:not(:focus) {
        box-shadow: inherit;
      }
    }

    & .`, ` {
      cursor: not-allowed;
      pointer-events: none;
      color: `, `;

      &:-webkit-autofill {
        &,
        &:hover,
        &:focus {
          appearance: none;
          border: 1px solid `, `;
          -webkit-text-fill-color: `, `;
          box-shadow: `, `;
        }

        &:hover:not(:focus) {
          box-shadow: inherit;
        }
      }

      &::placeholder {
        color: inherit;
      }
    }
  `])), b.gray.dark2, b.gray.dark3, b.gray.dark2, yl, b.gray.dark2, b.gray.dark1, b.gray.dark1, Kr(b.gray.dark2))), VAe = v(gie || (gie = dt([`
  width: 100%;
`]))), qAe = v(hie || (hie = dt([`
  display: flex;
  align-items: center;
  gap: `, `px;
`])), ee[100]), UAe = pt(pt({}, S.Light, v(mie || (mie = dt([`
    color: `, `;
  `])), b.gray.light1)), S.Dark, v(vie || (vie = dt([`
    color: `, `;
  `])), b.gray.dark2)), WAe = pt(pt({}, S.Light, v(bie || (bie = dt([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(yie || (yie = dt([`
    color: `, `;
  `])), b.gray.base)), GAe = v(wie || (wie = dt([`
  font-size: 12px;
  line-height: 12px;
  font-style: italic;
  font-weight: `, `;
  display: flex;
  align-items: center;
  > p {
    margin: 0;
  }
`])), Y.regular), KAe = pt(pt({}, S.Light, v(Oie || (Oie = dt([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(xie || (xie = dt([`
    color: `, `;
  `])), b.gray.base)), YAe = ["contentEnd", "className", "children"], vfe = wn(function(e, t) {
  var n = e.contentEnd, r = e.className, l = e.children, i = o9(e, YAe), c = K().theme, f = NAe(), d = f.disabled, h = f.size, g = f.state, m = f.inputProps, y = f.optional, w = function(M) {
    var P = M.disabled, a = M.size, o = M.state, s = M.theme;
    return H(IAe, Eie[s], DAe[a], pt(pt({}, H(Eie[s], zAe[o][s], HAe[s]), !P), FAe[s], P));
  }({ disabled: d, size: h ?? un.Default, state: g, theme: c }), C = k.cloneElement(l, i9(i9({}, m), {}, { className: H(yl, l.props.className) })), E = g === jr.None && !d && y, R = E || n;
  return k.createElement("div", Ko({}, i, { ref: t, className: H(w, r) }), k.createElement("div", { className: VAe }, C), R && k.createElement("div", { className: qAe }, E && k.createElement("div", { "data-lgid": l9.optional, className: H(GAe, KAe[c]) }, k.createElement("p", null, "Optional")), n && k.cloneElement(n, { className: H(Z1, WAe[c], pt({}, UAe[c], d), n.props.className) })));
});
vfe.displayName = "FormFieldInputWrapper";
var bfe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(bfe);
var XAe = bfe.exports;
const QAe = /* @__PURE__ */ ce(XAe);
var yfe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(yfe);
var JAe = yfe.exports;
const eLe = /* @__PURE__ */ ce(JAe);
var wfe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(wfe);
var tLe = wfe.exports;
const nLe = /* @__PURE__ */ ce(tLe);
function rLe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Je(e, t, n) {
  return (t = rLe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function An() {
  return An = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, An.apply(this, arguments);
}
function vr(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Se(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function aLe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return jie(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return jie(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function jie(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Cie, Mie, kie, Pie, Sie, Nie, Rie, _ie, Vl = v(Cie || (Cie = Se([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), Ofe = Je(Je({}, W.Body1, v(Mie || (Mie = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(kie || (kie = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), lLe = Je(Je({}, W.Body1, v(Pie || (Pie = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(Sie || (Sie = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), T1 = Je(Je({}, S.Light, v(Nie || (Nie = Se([`
    color: `, `;
  `])), b.black)), S.Dark, v(Rie || (Rie = Se([`
    color: `, `;
  `])), b.gray.light2)), Ha = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, iLe = ["baseFontSize", "darkMode", "className", "weight", "as"], oLe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = vr(e, iLe), h = K(n).theme, g = Ha(t), m = ne(f).Component, y = v(_ie || (_ie = Se([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, An({ className: H(Vl, Ofe[g], T1[h], y, r) }, d));
});
oLe.displayName = "Body";
var Aie, Lie, Zie, Tie, Bie, Iie, Hie, Die, zie, Fie, sLe = { label: "lg-label", description: "lg-description" };
v(Aie || (Aie = Se([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
Je(Je({}, S.Light, v(Lie || (Lie = Se([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(Zie || (Zie = Se([`
    color: `, `;
  `])), b.gray.light1));
Je(Je({}, S.Light, v(Tie || (Tie = Se([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(Bie || (Bie = Se([`
    color: `, `;
  `])), b.gray.dark1));
Je(Je({}, W.Body1, v(Iie || (Iie = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Hie || (Hie = Se([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var Vie, qie, Uie, Wie, Gie;
Je(Je({}, S.Light, v(Die || (Die = Se([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(zie || (zie = Se([`
    color: `, `;
  `])), b.gray.light1));
v(Fie || (Fie = Se([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var Kie, Yie, Xie, Qie, Jie, eoe, cLe = v(Vie || (Vie = Se([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), uLe = Je(Je({}, S.Light, v(qie || (qie = Se([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(Uie || (Uie = Se([`
    color: `, `;
  `])), b.red.light1)), fLe = Je(Je({}, W.Body1, v(Wie || (Wie = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(Gie || (Gie = Se([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), dLe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = vr(e, dLe), f = K(r).theme, d = Ha(), h = ne(n).Component;
  return k.createElement(h, An({}, c, { className: H(cLe, uLe[f], fLe[d], i) }), l);
});
var pLe = v(Kie || (Kie = Se([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), gLe = Je(Je({}, S.Light, v(Yie || (Yie = Se([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(Xie || (Xie = Se([`
    color: `, `;
  `])), b.gray.light2)), hLe = ["darkMode", "className", "as"], mLe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = vr(e, hLe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, An({ className: H(Vl, pLe, gLe[c], n) }, i));
});
mLe.displayName = "H1";
var toe, vLe = v(Qie || (Qie = Se([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), bLe = Je(Je({}, S.Light, v(Jie || (Jie = Se([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(eoe || (eoe = Se([`
    color: `, `;
  `])), b.gray.light2)), yLe = ["darkMode", "className", "as"], wLe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = vr(e, yLe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, An({ className: H(Vl, vLe, bLe[c], n) }, i));
});
wLe.displayName = "H2";
var noe, roe, aoe, loe, ioe, ooe, soe, coe, uoe, foe, OLe = v(toe || (toe = Se([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), xLe = ["darkMode", "className", "as"], ELe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = vr(e, xLe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, An({ className: H(Vl, OLe, T1[c], n) }, i));
});
ELe.displayName = "H3";
var doe, poe, goe, wl = gt(), $Le = v(noe || (noe = Se([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, wl), jLe = Je(Je({}, S.Light, v(roe || (roe = Se([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, wl, b.gray.light2, b.gray.light1)), S.Dark, v(aoe || (aoe = Se([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, wl, b.gray.dark2, b.gray.dark1)), CLe = Je(Je({}, S.Light, v(loe || (loe = Se([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), wl, it[S.Light].default, b.blue.base)), S.Dark, v(ioe || (ioe = Se([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), wl, it[S.Dark].default, b.blue.base)), MLe = Je(Je({}, S.Light, v(ooe || (ooe = Se([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(soe || (soe = Se([`
    color: `, `;
  `])), b.blue.light1)), kLe = v(coe || (coe = Se([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), PLe = v(uoe || (uoe = Se([`
  white-space: nowrap;
`]))), SLe = v(foe || (foe = Se([`
  white-space: normal;
`]))), NLe = ["children", "className", "darkMode", "baseFontSize", "as"], hoe = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = vr(e, NLe), g = K(c).theme, m = Ha(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? PLe : SLe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(lLe[m], $Le, jLe[g], CLe[g], w, Je({}, MLe[g], C), i) }, l);
  return C ? k.createElement(y, An({ className: H(wl, kLe, i) }, h), E) : k.cloneElement(E, h);
});
hoe.displayName = "InlineCode", hoe.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var moe, voe, boe, yoe, woe, Ooe, xoe;
v(doe || (doe = Se([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
Je(Je({}, S.Light, v(poe || (poe = Se([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(goe || (goe = Se([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var Eoe, $oe, joe, RLe = v(moe || (moe = Se([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), _Le = Je(Je({}, S.Light, v(voe || (voe = Se([`
    color: `, `;
  `])), b.black)), S.Dark, v(boe || (boe = Se([`
    color: `, `;
  `])), b.gray.light2)), ALe = Je(Je({}, S.Light, v(yoe || (yoe = Se([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(woe || (woe = Se([`
    color: `, `;
  `])), b.gray.dark1)), LLe = Je(Je({}, W.Body1, v(Ooe || (Ooe = Se([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(xoe || (xoe = Se([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), ZLe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], TLe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? sLe.label : h, m = vr(e, ZLe), y = K(n).theme, w = Ha(t), C = ne(d).Component;
  return k.createElement(C, An({ "data-lgid": g, className: H(RLe, _Le[y], LLe[w], Je({}, ALe[y], c), r) }, m), l);
});
TLe.displayName = "Label";
var Coe, Moe, koe, Poe, Soe, Noe, Yo = gt(), xfe = v(Eoe || (Eoe = Se([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), Efe = Je(Je({}, S.Light, v($oe || ($oe = Se([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(joe || (joe = Se([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), $fe = function(e) {
  if (e)
    return Ofe[e];
}, BLe = v(Coe || (Coe = Se([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), ILe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = vr(e, ILe), d = K(i).theme, h = Ha(l), g = nt(c, f, "span").Component;
  return k.createElement(g, An({ className: H(Yo, xfe, $fe(h), Efe[d], BLe, r), ref: t }, f), k.createElement(QAe, { role: "presentation" }), n);
});
var HLe = v(Moe || (Moe = Se([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), DLe = v(koe || (koe = Se([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Yo, Yo), zLe = v(Poe || (Poe = Se([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), FLe = "hover", VLe = "persist", Roe = "none", qLe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? Roe : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = vr(e, qLe), y = aLe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Ha(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== Roe && (E = k.createElement(eLe, { role: "presentation", size: 12, className: H(Je(Je({}, DLe, i === FLe), HLe, i === VLe)) })) : E = k.createElement(nLe, { role: "presentation", className: zLe }), k.createElement(P, An({ className: H(Yo, xfe, $fe(M), Efe[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var ULe = v(Soe || (Soe = Se([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), WLe = ["darkMode", "className", "as"], GLe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = vr(e, WLe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, An({ className: H(Vl, ULe, T1[c], n) }, i));
});
GLe.displayName = "Overline";
var KLe = v(Noe || (Noe = Se([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), YLe = ["darkMode", "className", "as"], XLe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = vr(e, YLe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, An({ className: H(Vl, KLe, T1[c], n) }, i));
});
XLe.displayName = "Subtitle";
var _oe;
v(_oe || (_oe = Se([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var ga = {}, Py = { exports: {} };
Py.exports;
(function(e) {
  const n = (i = 0) => (c) => `\x1B[${38 + i};5;${c}m`, r = (i = 0) => (c, f, d) => `\x1B[${38 + i};2;${c};${f};${d}m`;
  function l() {
    const i = /* @__PURE__ */ new Map(), c = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        overline: [53, 55],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    c.color.gray = c.color.blackBright, c.bgColor.bgGray = c.bgColor.bgBlackBright, c.color.grey = c.color.blackBright, c.bgColor.bgGrey = c.bgColor.bgBlackBright;
    for (const [f, d] of Object.entries(c)) {
      for (const [h, g] of Object.entries(d))
        c[h] = {
          open: `\x1B[${g[0]}m`,
          close: `\x1B[${g[1]}m`
        }, d[h] = c[h], i.set(g[0], g[1]);
      Object.defineProperty(c, f, {
        value: d,
        enumerable: !1
      });
    }
    return Object.defineProperty(c, "codes", {
      value: i,
      enumerable: !1
    }), c.color.close = "\x1B[39m", c.bgColor.close = "\x1B[49m", c.color.ansi256 = n(), c.color.ansi16m = r(), c.bgColor.ansi256 = n(10), c.bgColor.ansi16m = r(10), Object.defineProperties(c, {
      rgbToAnsi256: {
        value: (f, d, h) => f === d && d === h ? f < 8 ? 16 : f > 248 ? 231 : Math.round((f - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(f / 255 * 5) + 6 * Math.round(d / 255 * 5) + Math.round(h / 255 * 5),
        enumerable: !1
      },
      hexToRgb: {
        value: (f) => {
          const d = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(f.toString(16));
          if (!d)
            return [0, 0, 0];
          let { colorString: h } = d.groups;
          h.length === 3 && (h = h.split("").map((m) => m + m).join(""));
          const g = Number.parseInt(h, 16);
          return [
            g >> 16 & 255,
            g >> 8 & 255,
            g & 255
          ];
        },
        enumerable: !1
      },
      hexToAnsi256: {
        value: (f) => c.rgbToAnsi256(...c.hexToRgb(f)),
        enumerable: !1
      }
    }), c;
  }
  Object.defineProperty(e, "exports", {
    enumerable: !0,
    get: l
  });
})(Py);
var jfe = Py.exports, Dr = {};
Object.defineProperty(Dr, "__esModule", {
  value: !0
});
Dr.printIteratorEntries = JLe;
Dr.printIteratorValues = eZe;
Dr.printListItems = tZe;
Dr.printObjectProperties = nZe;
const QLe = (e, t) => {
  const n = Object.keys(e).sort(t);
  return Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach((r) => {
    Object.getOwnPropertyDescriptor(e, r).enumerable && n.push(r);
  }), n;
};
function JLe(e, t, n, r, l, i, c = ": ") {
  let f = "", d = e.next();
  if (!d.done) {
    f += t.spacingOuter;
    const h = n + t.indent;
    for (; !d.done; ) {
      const g = i(
        d.value[0],
        t,
        h,
        r,
        l
      ), m = i(
        d.value[1],
        t,
        h,
        r,
        l
      );
      f += h + g + c + m, d = e.next(), d.done ? t.min || (f += ",") : f += "," + t.spacingInner;
    }
    f += t.spacingOuter + n;
  }
  return f;
}
function eZe(e, t, n, r, l, i) {
  let c = "", f = e.next();
  if (!f.done) {
    c += t.spacingOuter;
    const d = n + t.indent;
    for (; !f.done; )
      c += d + i(f.value, t, d, r, l), f = e.next(), f.done ? t.min || (c += ",") : c += "," + t.spacingInner;
    c += t.spacingOuter + n;
  }
  return c;
}
function tZe(e, t, n, r, l, i) {
  let c = "";
  if (e.length) {
    c += t.spacingOuter;
    const f = n + t.indent;
    for (let d = 0; d < e.length; d++)
      c += f, d in e && (c += i(e[d], t, f, r, l)), d < e.length - 1 ? c += "," + t.spacingInner : t.min || (c += ",");
    c += t.spacingOuter + n;
  }
  return c;
}
function nZe(e, t, n, r, l, i) {
  let c = "";
  const f = QLe(e, t.compareKeys);
  if (f.length) {
    c += t.spacingOuter;
    const d = n + t.indent;
    for (let h = 0; h < f.length; h++) {
      const g = f[h], m = i(g, t, d, r, l), y = i(e[g], t, d, r, l);
      c += d + m + ": " + y, h < f.length - 1 ? c += "," + t.spacingInner : t.min || (c += ",");
    }
    c += t.spacingOuter + n;
  }
  return c;
}
var aa = {};
Object.defineProperty(aa, "__esModule", {
  value: !0
});
aa.test = aa.serialize = aa.default = void 0;
var Aoe = Dr, Xo = function() {
  return typeof globalThis < "u" ? globalThis : typeof Xo < "u" ? Xo : typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
}(), bu = Xo["jest-symbol-do-not-touch"] || Xo.Symbol;
const rZe = typeof bu == "function" && bu.for ? bu.for("jest.asymmetricMatcher") : 1267621, so = " ", Cfe = (e, t, n, r, l, i) => {
  const c = e.toString();
  return c === "ArrayContaining" || c === "ArrayNotContaining" ? ++r > t.maxDepth ? "[" + c + "]" : c + so + "[" + (0, Aoe.printListItems)(
    e.sample,
    t,
    n,
    r,
    l,
    i
  ) + "]" : c === "ObjectContaining" || c === "ObjectNotContaining" ? ++r > t.maxDepth ? "[" + c + "]" : c + so + "{" + (0, Aoe.printObjectProperties)(
    e.sample,
    t,
    n,
    r,
    l,
    i
  ) + "}" : c === "StringMatching" || c === "StringNotMatching" || c === "StringContaining" || c === "StringNotContaining" ? c + so + i(e.sample, t, n, r, l) : e.toAsymmetricMatcher();
};
aa.serialize = Cfe;
const Mfe = (e) => e && e.$$typeof === rZe;
aa.test = Mfe;
const aZe = {
  serialize: Cfe,
  test: Mfe
};
var lZe = aZe;
aa.default = lZe;
var la = {}, iZe = ({ onlyFirst: e = !1 } = {}) => {
  const t = [
    "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
    "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
  ].join("|");
  return new RegExp(t, e ? void 0 : "g");
};
Object.defineProperty(la, "__esModule", {
  value: !0
});
la.test = la.serialize = la.default = void 0;
var kfe = Pfe(iZe), St = Pfe(jfe);
function Pfe(e) {
  return e && e.__esModule ? e : { default: e };
}
const oZe = (e) => e.replace((0, kfe.default)(), (t) => {
  switch (t) {
    case St.default.red.close:
    case St.default.green.close:
    case St.default.cyan.close:
    case St.default.gray.close:
    case St.default.white.close:
    case St.default.yellow.close:
    case St.default.bgRed.close:
    case St.default.bgGreen.close:
    case St.default.bgYellow.close:
    case St.default.inverse.close:
    case St.default.dim.close:
    case St.default.bold.close:
    case St.default.reset.open:
    case St.default.reset.close:
      return "</>";
    case St.default.red.open:
      return "<red>";
    case St.default.green.open:
      return "<green>";
    case St.default.cyan.open:
      return "<cyan>";
    case St.default.gray.open:
      return "<gray>";
    case St.default.white.open:
      return "<white>";
    case St.default.yellow.open:
      return "<yellow>";
    case St.default.bgRed.open:
      return "<bgRed>";
    case St.default.bgGreen.open:
      return "<bgGreen>";
    case St.default.bgYellow.open:
      return "<bgYellow>";
    case St.default.inverse.open:
      return "<inverse>";
    case St.default.dim.open:
      return "<dim>";
    case St.default.bold.open:
      return "<bold>";
    default:
      return "";
  }
}), Sfe = (e) => typeof e == "string" && !!e.match((0, kfe.default)());
la.test = Sfe;
const Nfe = (e, t, n, r, l, i) => i(oZe(e), t, n, r, l);
la.serialize = Nfe;
const sZe = {
  serialize: Nfe,
  test: Sfe
};
var cZe = sZe;
la.default = cZe;
var ia = {};
Object.defineProperty(ia, "__esModule", {
  value: !0
});
ia.test = ia.serialize = ia.default = void 0;
var Loe = Dr;
const uZe = " ", Rfe = ["DOMStringMap", "NamedNodeMap"], fZe = /^(HTML\w*Collection|NodeList)$/, dZe = (e) => Rfe.indexOf(e) !== -1 || fZe.test(e), _fe = (e) => e && e.constructor && !!e.constructor.name && dZe(e.constructor.name);
ia.test = _fe;
const pZe = (e) => e.constructor.name === "NamedNodeMap", Afe = (e, t, n, r, l, i) => {
  const c = e.constructor.name;
  return ++r > t.maxDepth ? "[" + c + "]" : (t.min ? "" : c + uZe) + (Rfe.indexOf(c) !== -1 ? "{" + (0, Loe.printObjectProperties)(
    pZe(e) ? Array.from(e).reduce((f, d) => (f[d.name] = d.value, f), {}) : { ...e },
    t,
    n,
    r,
    l,
    i
  ) + "}" : "[" + (0, Loe.printListItems)(
    Array.from(e),
    t,
    n,
    r,
    l,
    i
  ) + "]");
};
ia.serialize = Afe;
const gZe = {
  serialize: Afe,
  test: _fe
};
var hZe = gZe;
ia.default = hZe;
var oa = {}, ln = {}, Sy = {};
Object.defineProperty(Sy, "__esModule", {
  value: !0
});
Sy.default = mZe;
function mZe(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
Object.defineProperty(ln, "__esModule", {
  value: !0
});
ln.printText = ln.printProps = ln.printElementAsLeaf = ln.printElement = ln.printComment = ln.printChildren = void 0;
var Lfe = vZe(Sy);
function vZe(e) {
  return e && e.__esModule ? e : { default: e };
}
const bZe = (e, t, n, r, l, i, c) => {
  const f = r + n.indent, d = n.colors;
  return e.map((h) => {
    const g = t[h];
    let m = c(g, n, f, l, i);
    return typeof g != "string" && (m.indexOf(`
`) !== -1 && (m = n.spacingOuter + f + m + n.spacingOuter + r), m = "{" + m + "}"), n.spacingInner + r + d.prop.open + h + d.prop.close + "=" + d.value.open + m + d.value.close;
  }).join("");
};
ln.printProps = bZe;
const yZe = (e, t, n, r, l, i) => e.map(
  (c) => t.spacingOuter + n + (typeof c == "string" ? Zfe(c, t) : i(c, t, n, r, l))
).join("");
ln.printChildren = yZe;
const Zfe = (e, t) => {
  const n = t.colors.content;
  return n.open + (0, Lfe.default)(e) + n.close;
};
ln.printText = Zfe;
const wZe = (e, t) => {
  const n = t.colors.comment;
  return n.open + "<!--" + (0, Lfe.default)(e) + "-->" + n.close;
};
ln.printComment = wZe;
const OZe = (e, t, n, r, l) => {
  const i = r.colors.tag;
  return i.open + "<" + e + (t && i.close + t + r.spacingOuter + l + i.open) + (n ? ">" + i.close + n + r.spacingOuter + l + i.open + "</" + e : (t && !r.min ? "" : " ") + "/") + ">" + i.close;
};
ln.printElement = OZe;
const xZe = (e, t) => {
  const n = t.colors.tag;
  return n.open + "<" + e + n.close + " …" + n.open + " />" + n.close;
};
ln.printElementAsLeaf = xZe;
Object.defineProperty(oa, "__esModule", {
  value: !0
});
oa.test = oa.serialize = oa.default = void 0;
var Ka = ln;
const EZe = 1, Tfe = 3, Bfe = 8, Ife = 11, $Ze = /^((HTML|SVG)\w*)?Element$/, jZe = (e) => {
  try {
    return typeof e.hasAttribute == "function" && e.hasAttribute("is");
  } catch {
    return !1;
  }
}, CZe = (e) => {
  const t = e.constructor.name, { nodeType: n, tagName: r } = e, l = typeof r == "string" && r.includes("-") || jZe(e);
  return n === EZe && ($Ze.test(t) || l) || n === Tfe && t === "Text" || n === Bfe && t === "Comment" || n === Ife && t === "DocumentFragment";
}, Hfe = (e) => {
  var t;
  return (e == null || (t = e.constructor) === null || t === void 0 ? void 0 : t.name) && CZe(e);
};
oa.test = Hfe;
function MZe(e) {
  return e.nodeType === Tfe;
}
function kZe(e) {
  return e.nodeType === Bfe;
}
function yu(e) {
  return e.nodeType === Ife;
}
const Dfe = (e, t, n, r, l, i) => {
  if (MZe(e))
    return (0, Ka.printText)(e.data, t);
  if (kZe(e))
    return (0, Ka.printComment)(e.data, t);
  const c = yu(e) ? "DocumentFragment" : e.tagName.toLowerCase();
  return ++r > t.maxDepth ? (0, Ka.printElementAsLeaf)(c, t) : (0, Ka.printElement)(
    c,
    (0, Ka.printProps)(
      yu(e) ? [] : Array.from(e.attributes).map((f) => f.name).sort(),
      yu(e) ? {} : Array.from(e.attributes).reduce((f, d) => (f[d.name] = d.value, f), {}),
      t,
      n + t.indent,
      r,
      l,
      i
    ),
    (0, Ka.printChildren)(
      Array.prototype.slice.call(e.childNodes || e.children),
      t,
      n + t.indent,
      r,
      l,
      i
    ),
    t,
    n
  );
};
oa.serialize = Dfe;
const PZe = {
  serialize: Dfe,
  test: Hfe
};
var SZe = PZe;
oa.default = SZe;
var sa = {};
Object.defineProperty(sa, "__esModule", {
  value: !0
});
sa.test = sa.serialize = sa.default = void 0;
var Si = Dr;
const NZe = "@@__IMMUTABLE_ITERABLE__@@", RZe = "@@__IMMUTABLE_LIST__@@", _Ze = "@@__IMMUTABLE_KEYED__@@", AZe = "@@__IMMUTABLE_MAP__@@", Zoe = "@@__IMMUTABLE_ORDERED__@@", LZe = "@@__IMMUTABLE_RECORD__@@", ZZe = "@@__IMMUTABLE_SEQ__@@", TZe = "@@__IMMUTABLE_SET__@@", BZe = "@@__IMMUTABLE_STACK__@@", Ol = (e) => "Immutable." + e, B1 = (e) => "[" + e + "]", Ni = " ", Toe = "…", IZe = (e, t, n, r, l, i, c) => ++r > t.maxDepth ? B1(Ol(c)) : Ol(c) + Ni + "{" + (0, Si.printIteratorEntries)(
  e.entries(),
  t,
  n,
  r,
  l,
  i
) + "}";
function HZe(e) {
  let t = 0;
  return {
    next() {
      if (t < e._keys.length) {
        const n = e._keys[t++];
        return {
          done: !1,
          value: [n, e.get(n)]
        };
      }
      return {
        done: !0,
        value: void 0
      };
    }
  };
}
const DZe = (e, t, n, r, l, i) => {
  const c = Ol(e._name || "Record");
  return ++r > t.maxDepth ? B1(c) : c + Ni + "{" + (0, Si.printIteratorEntries)(
    HZe(e),
    t,
    n,
    r,
    l,
    i
  ) + "}";
}, zZe = (e, t, n, r, l, i) => {
  const c = Ol("Seq");
  return ++r > t.maxDepth ? B1(c) : e[_Ze] ? c + Ni + "{" + // from Immutable collection of entries or from ECMAScript object
  (e._iter || e._object ? (0, Si.printIteratorEntries)(
    e.entries(),
    t,
    n,
    r,
    l,
    i
  ) : Toe) + "}" : c + Ni + "[" + (e._iter || // from Immutable collection of values
  e._array || // from ECMAScript array
  e._collection || // from ECMAScript collection in immutable v4
  e._iterable ? (0, Si.printIteratorValues)(
    e.values(),
    t,
    n,
    r,
    l,
    i
  ) : Toe) + "]";
}, wu = (e, t, n, r, l, i, c) => ++r > t.maxDepth ? B1(Ol(c)) : Ol(c) + Ni + "[" + (0, Si.printIteratorValues)(
  e.values(),
  t,
  n,
  r,
  l,
  i
) + "]", zfe = (e, t, n, r, l, i) => e[AZe] ? IZe(
  e,
  t,
  n,
  r,
  l,
  i,
  e[Zoe] ? "OrderedMap" : "Map"
) : e[RZe] ? wu(
  e,
  t,
  n,
  r,
  l,
  i,
  "List"
) : e[TZe] ? wu(
  e,
  t,
  n,
  r,
  l,
  i,
  e[Zoe] ? "OrderedSet" : "Set"
) : e[BZe] ? wu(
  e,
  t,
  n,
  r,
  l,
  i,
  "Stack"
) : e[ZZe] ? zZe(e, t, n, r, l, i) : DZe(e, t, n, r, l, i);
sa.serialize = zfe;
const Ffe = (e) => e && (e[NZe] === !0 || e[LZe] === !0);
sa.test = Ffe;
const FZe = {
  serialize: zfe,
  test: Ffe
};
var VZe = FZe;
sa.default = VZe;
var ca = {}, s9 = { exports: {} }, Ct = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Boe;
function qZe() {
  if (Boe)
    return Ct;
  Boe = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, l = 60114, i = 60109, c = 60110, f = 60112, d = 60113, h = 60120, g = 60115, m = 60116, y = 60121, w = 60122, C = 60117, E = 60129, R = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var M = Symbol.for;
    e = M("react.element"), t = M("react.portal"), n = M("react.fragment"), r = M("react.strict_mode"), l = M("react.profiler"), i = M("react.provider"), c = M("react.context"), f = M("react.forward_ref"), d = M("react.suspense"), h = M("react.suspense_list"), g = M("react.memo"), m = M("react.lazy"), y = M("react.block"), w = M("react.server.block"), C = M("react.fundamental"), E = M("react.debug_trace_mode"), R = M("react.legacy_hidden");
  }
  function P(A) {
    if (typeof A == "object" && A !== null) {
      var Z = A.$$typeof;
      switch (Z) {
        case e:
          switch (A = A.type, A) {
            case n:
            case l:
            case r:
            case d:
            case h:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case c:
                case f:
                case m:
                case g:
                case i:
                  return A;
                default:
                  return Z;
              }
          }
        case t:
          return Z;
      }
    }
  }
  var a = i, o = e, s = f, p = n, O = m, x = g, N = t, T = l, $ = r, j = d;
  return Ct.ContextConsumer = c, Ct.ContextProvider = a, Ct.Element = o, Ct.ForwardRef = s, Ct.Fragment = p, Ct.Lazy = O, Ct.Memo = x, Ct.Portal = N, Ct.Profiler = T, Ct.StrictMode = $, Ct.Suspense = j, Ct.isAsyncMode = function() {
    return !1;
  }, Ct.isConcurrentMode = function() {
    return !1;
  }, Ct.isContextConsumer = function(A) {
    return P(A) === c;
  }, Ct.isContextProvider = function(A) {
    return P(A) === i;
  }, Ct.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === e;
  }, Ct.isForwardRef = function(A) {
    return P(A) === f;
  }, Ct.isFragment = function(A) {
    return P(A) === n;
  }, Ct.isLazy = function(A) {
    return P(A) === m;
  }, Ct.isMemo = function(A) {
    return P(A) === g;
  }, Ct.isPortal = function(A) {
    return P(A) === t;
  }, Ct.isProfiler = function(A) {
    return P(A) === l;
  }, Ct.isStrictMode = function(A) {
    return P(A) === r;
  }, Ct.isSuspense = function(A) {
    return P(A) === d;
  }, Ct.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === n || A === l || A === E || A === r || A === d || A === h || A === R || typeof A == "object" && A !== null && (A.$$typeof === m || A.$$typeof === g || A.$$typeof === i || A.$$typeof === c || A.$$typeof === f || A.$$typeof === C || A.$$typeof === y || A[0] === w);
  }, Ct.typeOf = P, Ct;
}
var Mt = {}, Ioe;
function UZe() {
  return Ioe || (Ioe = 1, In.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, l = 60114, i = 60109, c = 60110, f = 60112, d = 60113, h = 60120, g = 60115, m = 60116, y = 60121, w = 60122, C = 60117, E = 60129, R = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var M = Symbol.for;
      e = M("react.element"), t = M("react.portal"), n = M("react.fragment"), r = M("react.strict_mode"), l = M("react.profiler"), i = M("react.provider"), c = M("react.context"), f = M("react.forward_ref"), d = M("react.suspense"), h = M("react.suspense_list"), g = M("react.memo"), m = M("react.lazy"), y = M("react.block"), w = M("react.server.block"), C = M("react.fundamental"), M("react.scope"), M("react.opaque.id"), E = M("react.debug_trace_mode"), M("react.offscreen"), R = M("react.legacy_hidden");
    }
    var P = !1;
    function a(de) {
      return !!(typeof de == "string" || typeof de == "function" || de === n || de === l || de === E || de === r || de === d || de === h || de === R || P || typeof de == "object" && de !== null && (de.$$typeof === m || de.$$typeof === g || de.$$typeof === i || de.$$typeof === c || de.$$typeof === f || de.$$typeof === C || de.$$typeof === y || de[0] === w));
    }
    function o(de) {
      if (typeof de == "object" && de !== null) {
        var Zt = de.$$typeof;
        switch (Zt) {
          case e:
            var Jt = de.type;
            switch (Jt) {
              case n:
              case l:
              case r:
              case d:
              case h:
                return Jt;
              default:
                var Ht = Jt && Jt.$$typeof;
                switch (Ht) {
                  case c:
                  case f:
                  case m:
                  case g:
                  case i:
                    return Ht;
                  default:
                    return Zt;
                }
            }
          case t:
            return Zt;
        }
      }
    }
    var s = c, p = i, O = e, x = f, N = n, T = m, $ = g, j = t, A = l, Z = r, G = d, I = !1, F = !1;
    function U(de) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(de) {
      return F || (F = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(de) {
      return o(de) === c;
    }
    function q(de) {
      return o(de) === i;
    }
    function D(de) {
      return typeof de == "object" && de !== null && de.$$typeof === e;
    }
    function _(de) {
      return o(de) === f;
    }
    function re(de) {
      return o(de) === n;
    }
    function ue(de) {
      return o(de) === m;
    }
    function se(de) {
      return o(de) === g;
    }
    function Re(de) {
      return o(de) === t;
    }
    function ft(de) {
      return o(de) === l;
    }
    function Le(de) {
      return o(de) === r;
    }
    function Lt(de) {
      return o(de) === d;
    }
    Mt.ContextConsumer = s, Mt.ContextProvider = p, Mt.Element = O, Mt.ForwardRef = x, Mt.Fragment = N, Mt.Lazy = T, Mt.Memo = $, Mt.Portal = j, Mt.Profiler = A, Mt.StrictMode = Z, Mt.Suspense = G, Mt.isAsyncMode = U, Mt.isConcurrentMode = B, Mt.isContextConsumer = L, Mt.isContextProvider = q, Mt.isElement = D, Mt.isForwardRef = _, Mt.isFragment = re, Mt.isLazy = ue, Mt.isMemo = se, Mt.isPortal = Re, Mt.isProfiler = ft, Mt.isStrictMode = Le, Mt.isSuspense = Lt, Mt.isValidElementType = a, Mt.typeOf = o;
  }()), Mt;
}
In.env.NODE_ENV === "production" ? s9.exports = qZe() : s9.exports = UZe();
var WZe = s9.exports;
Object.defineProperty(ca, "__esModule", {
  value: !0
});
ca.test = ca.serialize = ca.default = void 0;
var wa = GZe(WZe), co = ln;
function Vfe(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Vfe = function(r) {
    return r ? n : t;
  })(e);
}
function GZe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Vfe(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var c = l ? Object.getOwnPropertyDescriptor(e, i) : null;
      c && (c.get || c.set) ? Object.defineProperty(r, i, c) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
const qfe = (e, t = []) => (Array.isArray(e) ? e.forEach((n) => {
  qfe(n, t);
}) : e != null && e !== !1 && t.push(e), t), Hoe = (e) => {
  const t = e.type;
  if (typeof t == "string")
    return t;
  if (typeof t == "function")
    return t.displayName || t.name || "Unknown";
  if (wa.isFragment(e))
    return "React.Fragment";
  if (wa.isSuspense(e))
    return "React.Suspense";
  if (typeof t == "object" && t !== null) {
    if (wa.isContextProvider(e))
      return "Context.Provider";
    if (wa.isContextConsumer(e))
      return "Context.Consumer";
    if (wa.isForwardRef(e)) {
      if (t.displayName)
        return t.displayName;
      const n = t.render.displayName || t.render.name || "";
      return n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef";
    }
    if (wa.isMemo(e)) {
      const n = t.displayName || t.type.displayName || t.type.name || "";
      return n !== "" ? "Memo(" + n + ")" : "Memo";
    }
  }
  return "UNDEFINED";
}, KZe = (e) => {
  const { props: t } = e;
  return Object.keys(t).filter((n) => n !== "children" && t[n] !== void 0).sort();
}, Ufe = (e, t, n, r, l, i) => ++r > t.maxDepth ? (0, co.printElementAsLeaf)(Hoe(e), t) : (0, co.printElement)(
  Hoe(e),
  (0, co.printProps)(
    KZe(e),
    e.props,
    t,
    n + t.indent,
    r,
    l,
    i
  ),
  (0, co.printChildren)(
    qfe(e.props.children),
    t,
    n + t.indent,
    r,
    l,
    i
  ),
  t,
  n
);
ca.serialize = Ufe;
const Wfe = (e) => e != null && wa.isElement(e);
ca.test = Wfe;
const YZe = {
  serialize: Ufe,
  test: Wfe
};
var XZe = YZe;
ca.default = XZe;
var ua = {};
Object.defineProperty(ua, "__esModule", {
  value: !0
});
ua.test = ua.serialize = ua.default = void 0;
var uo = ln, Qo = function() {
  return typeof globalThis < "u" ? globalThis : typeof Qo < "u" ? Qo : typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
}(), Ou = Qo["jest-symbol-do-not-touch"] || Qo.Symbol;
const QZe = typeof Ou == "function" && Ou.for ? Ou.for("react.test.json") : 245830487, JZe = (e) => {
  const { props: t } = e;
  return t ? Object.keys(t).filter((n) => t[n] !== void 0).sort() : [];
}, Gfe = (e, t, n, r, l, i) => ++r > t.maxDepth ? (0, uo.printElementAsLeaf)(e.type, t) : (0, uo.printElement)(
  e.type,
  e.props ? (0, uo.printProps)(
    JZe(e),
    e.props,
    t,
    n + t.indent,
    r,
    l,
    i
  ) : "",
  e.children ? (0, uo.printChildren)(
    e.children,
    t,
    n + t.indent,
    r,
    l,
    i
  ) : "",
  t,
  n
);
ua.serialize = Gfe;
const Kfe = (e) => e && e.$$typeof === QZe;
ua.test = Kfe;
const eTe = {
  serialize: Gfe,
  test: Kfe
};
var tTe = eTe;
ua.default = tTe;
Object.defineProperty(ga, "__esModule", {
  value: !0
});
ga.default = ga.DEFAULT_OPTIONS = void 0;
var nTe = ga.format = ode, Yfe = ga.plugins = void 0, rTe = va(jfe), oi = Dr, aTe = va(
  aa
), lTe = va(la), iTe = va(ia), oTe = va(oa), sTe = va(sa), cTe = va(ca), uTe = va(
  ua
);
function va(e) {
  return e && e.__esModule ? e : { default: e };
}
const Xfe = Object.prototype.toString, fTe = Date.prototype.toISOString, dTe = Error.prototype.toString, Doe = RegExp.prototype.toString, xu = (e) => typeof e.constructor == "function" && e.constructor.name || "Object", pTe = (e) => typeof window < "u" && e === window, gTe = /^Symbol\((.*)\)(.*)$/, hTe = /\n/gi;
class Qfe extends Error {
  constructor(t, n) {
    super(t), this.stack = n, this.name = this.constructor.name;
  }
}
function mTe(e) {
  return e === "[object Array]" || e === "[object ArrayBuffer]" || e === "[object DataView]" || e === "[object Float32Array]" || e === "[object Float64Array]" || e === "[object Int8Array]" || e === "[object Int16Array]" || e === "[object Int32Array]" || e === "[object Uint8Array]" || e === "[object Uint8ClampedArray]" || e === "[object Uint16Array]" || e === "[object Uint32Array]";
}
function vTe(e) {
  return Object.is(e, -0) ? "-0" : String(e);
}
function bTe(e) {
  return `${e}n`;
}
function zoe(e, t) {
  return t ? "[Function " + (e.name || "anonymous") + "]" : "[Function]";
}
function Foe(e) {
  return String(e).replace(gTe, "Symbol($1)");
}
function Voe(e) {
  return "[" + dTe.call(e) + "]";
}
function Jfe(e, t, n, r) {
  if (e === !0 || e === !1)
    return "" + e;
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const l = typeof e;
  if (l === "number")
    return vTe(e);
  if (l === "bigint")
    return bTe(e);
  if (l === "string")
    return r ? '"' + e.replace(/"|\\/g, "\\$&") + '"' : '"' + e + '"';
  if (l === "function")
    return zoe(e, t);
  if (l === "symbol")
    return Foe(e);
  const i = Xfe.call(e);
  return i === "[object WeakMap]" ? "WeakMap {}" : i === "[object WeakSet]" ? "WeakSet {}" : i === "[object Function]" || i === "[object GeneratorFunction]" ? zoe(e, t) : i === "[object Symbol]" ? Foe(e) : i === "[object Date]" ? isNaN(+e) ? "Date { NaN }" : fTe.call(e) : i === "[object Error]" ? Voe(e) : i === "[object RegExp]" ? n ? Doe.call(e).replace(/[\\^$*+?.()|[\]{}]/g, "\\$&") : Doe.call(e) : e instanceof Error ? Voe(e) : null;
}
function ede(e, t, n, r, l, i) {
  if (l.indexOf(e) !== -1)
    return "[Circular]";
  l = l.slice(), l.push(e);
  const c = ++r > t.maxDepth, f = t.min;
  if (t.callToJSON && !c && e.toJSON && typeof e.toJSON == "function" && !i)
    return Yr(e.toJSON(), t, n, r, l, !0);
  const d = Xfe.call(e);
  return d === "[object Arguments]" ? c ? "[Arguments]" : (f ? "" : "Arguments ") + "[" + (0, oi.printListItems)(
    e,
    t,
    n,
    r,
    l,
    Yr
  ) + "]" : mTe(d) ? c ? "[" + e.constructor.name + "]" : (f || !t.printBasicPrototype && e.constructor.name === "Array" ? "" : e.constructor.name + " ") + "[" + (0, oi.printListItems)(
    e,
    t,
    n,
    r,
    l,
    Yr
  ) + "]" : d === "[object Map]" ? c ? "[Map]" : "Map {" + (0, oi.printIteratorEntries)(
    e.entries(),
    t,
    n,
    r,
    l,
    Yr,
    " => "
  ) + "}" : d === "[object Set]" ? c ? "[Set]" : "Set {" + (0, oi.printIteratorValues)(
    e.values(),
    t,
    n,
    r,
    l,
    Yr
  ) + "}" : c || pTe(e) ? "[" + xu(e) + "]" : (f || !t.printBasicPrototype && xu(e) === "Object" ? "" : xu(e) + " ") + "{" + (0, oi.printObjectProperties)(
    e,
    t,
    n,
    r,
    l,
    Yr
  ) + "}";
}
function yTe(e) {
  return e.serialize != null;
}
function tde(e, t, n, r, l, i) {
  let c;
  try {
    c = yTe(e) ? e.serialize(t, n, r, l, i, Yr) : e.print(
      t,
      (f) => Yr(f, n, r, l, i),
      (f) => {
        const d = r + n.indent;
        return d + f.replace(hTe, `
` + d);
      },
      {
        edgeSpacing: n.spacingOuter,
        min: n.min,
        spacing: n.spacingInner
      },
      n.colors
    );
  } catch (f) {
    throw new Qfe(f.message, f.stack);
  }
  if (typeof c != "string")
    throw new Error(
      `pretty-format: Plugin must return type "string" but instead returned "${typeof c}".`
    );
  return c;
}
function nde(e, t) {
  for (let n = 0; n < e.length; n++)
    try {
      if (e[n].test(t))
        return e[n];
    } catch (r) {
      throw new Qfe(r.message, r.stack);
    }
  return null;
}
function Yr(e, t, n, r, l, i) {
  const c = nde(t.plugins, e);
  if (c !== null)
    return tde(c, e, t, n, r, l);
  const f = Jfe(
    e,
    t.printFunctionName,
    t.escapeRegex,
    t.escapeString
  );
  return f !== null ? f : ede(
    e,
    t,
    n,
    r,
    l,
    i
  );
}
const Ny = {
  comment: "gray",
  content: "reset",
  prop: "yellow",
  tag: "cyan",
  value: "green"
}, rde = Object.keys(Ny), tr = {
  callToJSON: !0,
  compareKeys: void 0,
  escapeRegex: !1,
  escapeString: !0,
  highlight: !1,
  indent: 2,
  maxDepth: 1 / 0,
  min: !1,
  plugins: [],
  printBasicPrototype: !0,
  printFunctionName: !0,
  theme: Ny
};
ga.DEFAULT_OPTIONS = tr;
function wTe(e) {
  if (Object.keys(e).forEach((t) => {
    if (!tr.hasOwnProperty(t))
      throw new Error(`pretty-format: Unknown option "${t}".`);
  }), e.min && e.indent !== void 0 && e.indent !== 0)
    throw new Error(
      'pretty-format: Options "min" and "indent" cannot be used together.'
    );
  if (e.theme !== void 0) {
    if (e.theme === null)
      throw new Error('pretty-format: Option "theme" must not be null.');
    if (typeof e.theme != "object")
      throw new Error(
        `pretty-format: Option "theme" must be of type "object" but instead received "${typeof e.theme}".`
      );
  }
}
const OTe = (e) => rde.reduce((t, n) => {
  const r = e.theme && e.theme[n] !== void 0 ? e.theme[n] : Ny[n], l = r && rTe.default[r];
  if (l && typeof l.close == "string" && typeof l.open == "string")
    t[n] = l;
  else
    throw new Error(
      `pretty-format: Option "theme" has a key "${n}" whose value "${r}" is undefined in ansi-styles.`
    );
  return t;
}, /* @__PURE__ */ Object.create(null)), xTe = () => rde.reduce((e, t) => (e[t] = {
  close: "",
  open: ""
}, e), /* @__PURE__ */ Object.create(null)), ade = (e) => e && e.printFunctionName !== void 0 ? e.printFunctionName : tr.printFunctionName, lde = (e) => e && e.escapeRegex !== void 0 ? e.escapeRegex : tr.escapeRegex, ide = (e) => e && e.escapeString !== void 0 ? e.escapeString : tr.escapeString, qoe = (e) => {
  var t;
  return {
    callToJSON: e && e.callToJSON !== void 0 ? e.callToJSON : tr.callToJSON,
    colors: e && e.highlight ? OTe(e) : xTe(),
    compareKeys: e && typeof e.compareKeys == "function" ? e.compareKeys : tr.compareKeys,
    escapeRegex: lde(e),
    escapeString: ide(e),
    indent: e && e.min ? "" : ETe(
      e && e.indent !== void 0 ? e.indent : tr.indent
    ),
    maxDepth: e && e.maxDepth !== void 0 ? e.maxDepth : tr.maxDepth,
    min: e && e.min !== void 0 ? e.min : tr.min,
    plugins: e && e.plugins !== void 0 ? e.plugins : tr.plugins,
    printBasicPrototype: (t = e == null ? void 0 : e.printBasicPrototype) !== null && t !== void 0 ? t : !0,
    printFunctionName: ade(e),
    spacingInner: e && e.min ? " " : `
`,
    spacingOuter: e && e.min ? "" : `
`
  };
};
function ETe(e) {
  return new Array(e + 1).join(" ");
}
function ode(e, t) {
  if (t && (wTe(t), t.plugins)) {
    const r = nde(t.plugins, e);
    if (r !== null)
      return tde(r, e, qoe(t), "", 0, []);
  }
  const n = Jfe(
    e,
    ade(t),
    lde(t),
    ide(t)
  );
  return n !== null ? n : ede(e, qoe(t), "", 0, []);
}
const $Te = {
  AsymmetricMatcher: aTe.default,
  ConvertAnsi: lTe.default,
  DOMCollection: iTe.default,
  DOMElement: oTe.default,
  Immutable: sTe.default,
  ReactElement: cTe.default,
  ReactTestComponent: uTe.default
};
Yfe = ga.plugins = $Te;
var jTe = ode;
ga.default = jTe;
var CTe = Object.prototype.toString;
function Uoe(e) {
  return typeof e == "function" || CTe.call(e) === "[object Function]";
}
function MTe(e) {
  var t = Number(e);
  return isNaN(t) ? 0 : t === 0 || !isFinite(t) ? t : (t > 0 ? 1 : -1) * Math.floor(Math.abs(t));
}
var kTe = Math.pow(2, 53) - 1;
function PTe(e) {
  var t = MTe(e);
  return Math.min(Math.max(t, 0), kTe);
}
function nr(e, t) {
  var n = Array, r = Object(e);
  if (e == null)
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  if (typeof t < "u" && !Uoe(t))
    throw new TypeError("Array.from: when provided, the second argument must be a function");
  for (var l = PTe(r.length), i = Uoe(n) ? Object(new n(l)) : new Array(l), c = 0, f; c < l; )
    f = r[c], t ? i[c] = t(f, c) : i[c] = f, c += 1;
  return i.length = l, i;
}
function Ri(e) {
  "@babel/helpers - typeof";
  return Ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ri(e);
}
function STe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Woe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, sde(r.key), r);
  }
}
function NTe(e, t, n) {
  return t && Woe(e.prototype, t), n && Woe(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function RTe(e, t, n) {
  return t = sde(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sde(e) {
  var t = _Te(e, "string");
  return Ri(t) === "symbol" ? t : String(t);
}
function _Te(e, t) {
  if (Ri(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ri(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ATe = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    STe(this, e), RTe(this, "items", void 0), this.items = t;
  }
  return NTe(e, [{
    key: "add",
    value: function(n) {
      return this.has(n) === !1 && this.items.push(n), this;
    }
  }, {
    key: "clear",
    value: function() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function(n) {
      var r = this.items.length;
      return this.items = this.items.filter(function(l) {
        return l !== n;
      }), r !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function(n) {
      var r = this;
      this.items.forEach(function(l) {
        n(l, l, r);
      });
    }
  }, {
    key: "has",
    value: function(n) {
      return this.items.indexOf(n) !== -1;
    }
  }, {
    key: "size",
    get: function() {
      return this.items.length;
    }
  }]), e;
}();
const LTe = typeof Set > "u" ? Set : ATe;
function on(e) {
  var t;
  return (
    // eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (t = e.localName) !== null && t !== void 0 ? t : (
      // eslint-disable-next-line no-restricted-properties -- required for the fallback
      e.tagName.toLowerCase()
    )
  );
}
var ZTe = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
}, TTe = {
  caption: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  code: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  deletion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  emphasis: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  generic: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  paragraph: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  presentation: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  strong: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  subscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  superscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"])
};
function BTe(e, t) {
  return [
    "aria-atomic",
    "aria-busy",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    // "disabled",
    "aria-dropeffect",
    // "errormessage",
    "aria-flowto",
    "aria-grabbed",
    // "haspopup",
    "aria-hidden",
    // "invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-live",
    "aria-owns",
    "aria-relevant",
    "aria-roledescription"
  ].some(function(n) {
    var r;
    return e.hasAttribute(n) && !((r = TTe[t]) !== null && r !== void 0 && r.has(n));
  });
}
function cde(e, t) {
  return BTe(e, t);
}
function ITe(e) {
  var t = DTe(e);
  if (t === null || t === "presentation") {
    var n = HTe(e);
    if (t !== "presentation" || cde(e, n || ""))
      return n;
  }
  return t;
}
function HTe(e) {
  var t = ZTe[on(e)];
  if (t !== void 0)
    return t;
  switch (on(e)) {
    case "a":
    case "area":
    case "link":
      if (e.hasAttribute("href"))
        return "link";
      break;
    case "img":
      return e.getAttribute("alt") === "" && !cde(e, "img") ? "presentation" : "img";
    case "input": {
      var n = e, r = n.type;
      switch (r) {
        case "button":
        case "image":
        case "reset":
        case "submit":
          return "button";
        case "checkbox":
        case "radio":
          return r;
        case "range":
          return "slider";
        case "email":
        case "tel":
        case "text":
        case "url":
          return e.hasAttribute("list") ? "combobox" : "textbox";
        case "search":
          return e.hasAttribute("list") ? "combobox" : "searchbox";
        case "number":
          return "spinbutton";
        default:
          return null;
      }
    }
    case "select":
      return e.hasAttribute("multiple") || e.size > 1 ? "listbox" : "combobox";
  }
  return null;
}
function DTe(e) {
  var t = e.getAttribute("role");
  if (t !== null) {
    var n = t.trim().split(" ")[0];
    if (n.length > 0)
      return n;
  }
  return null;
}
function zt(e) {
  return e !== null && e.nodeType === e.ELEMENT_NODE;
}
function ude(e) {
  return zt(e) && on(e) === "caption";
}
function $o(e) {
  return zt(e) && on(e) === "input";
}
function zTe(e) {
  return zt(e) && on(e) === "optgroup";
}
function FTe(e) {
  return zt(e) && on(e) === "select";
}
function VTe(e) {
  return zt(e) && on(e) === "table";
}
function qTe(e) {
  return zt(e) && on(e) === "textarea";
}
function UTe(e) {
  var t = e.ownerDocument === null ? e : e.ownerDocument, n = t.defaultView;
  if (n === null)
    throw new TypeError("no window available");
  return n;
}
function WTe(e) {
  return zt(e) && on(e) === "fieldset";
}
function GTe(e) {
  return zt(e) && on(e) === "legend";
}
function KTe(e) {
  return zt(e) && on(e) === "slot";
}
function YTe(e) {
  return zt(e) && e.ownerSVGElement !== void 0;
}
function XTe(e) {
  return zt(e) && on(e) === "svg";
}
function QTe(e) {
  return YTe(e) && on(e) === "title";
}
function Jo(e, t) {
  if (zt(e) && e.hasAttribute(t)) {
    var n = e.getAttribute(t).split(" "), r = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return n.map(function(l) {
      return r.getElementById(l);
    }).filter(
      function(l) {
        return l !== null;
      }
      // TODO: why does this not narrow?
    );
  }
  return [];
}
function Lr(e, t) {
  return zt(e) ? t.indexOf(ITe(e)) !== -1 : !1;
}
function JTe(e) {
  return e.trim().replace(/\s\s+/g, " ");
}
function eBe(e, t) {
  if (!zt(e))
    return !1;
  if (e.hasAttribute("hidden") || e.getAttribute("aria-hidden") === "true")
    return !0;
  var n = t(e);
  return n.getPropertyValue("display") === "none" || n.getPropertyValue("visibility") === "hidden";
}
function tBe(e) {
  return Lr(e, ["button", "combobox", "listbox", "textbox"]) || fde(e, "range");
}
function fde(e, t) {
  if (!zt(e))
    return !1;
  switch (t) {
    case "range":
      return Lr(e, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(t, "'. This is likely a bug :("));
  }
}
function Goe(e, t) {
  var n = nr(e.querySelectorAll(t));
  return Jo(e, "aria-owns").forEach(function(r) {
    n.push.apply(n, nr(r.querySelectorAll(t)));
  }), n;
}
function nBe(e) {
  return FTe(e) ? e.selectedOptions || Goe(e, "[selected]") : Goe(e, '[aria-selected="true"]');
}
function rBe(e) {
  return Lr(e, ["none", "presentation"]);
}
function aBe(e) {
  return ude(e);
}
function lBe(e) {
  return Lr(e, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
function iBe(e) {
  return !1;
}
function oBe(e) {
  return $o(e) || qTe(e) ? e.value : e.textContent || "";
}
function Koe(e) {
  var t = e.getPropertyValue("content");
  return /^["'].*["']$/.test(t) ? t.slice(1, -1) : "";
}
function dde(e) {
  var t = on(e);
  return t === "button" || t === "input" && e.getAttribute("type") !== "hidden" || t === "meter" || t === "output" || t === "progress" || t === "select" || t === "textarea";
}
function pde(e) {
  if (dde(e))
    return e;
  var t = null;
  return e.childNodes.forEach(function(n) {
    if (t === null && zt(n)) {
      var r = pde(n);
      r !== null && (t = r);
    }
  }), t;
}
function sBe(e) {
  if (e.control !== void 0)
    return e.control;
  var t = e.getAttribute("for");
  return t !== null ? e.ownerDocument.getElementById(t) : pde(e);
}
function cBe(e) {
  var t = e.labels;
  if (t === null)
    return t;
  if (t !== void 0)
    return nr(t);
  if (!dde(e))
    return null;
  var n = e.ownerDocument;
  return nr(n.querySelectorAll("label")).filter(function(r) {
    return sBe(r) === e;
  });
}
function uBe(e) {
  var t = e.assignedNodes();
  return t.length === 0 ? nr(e.childNodes) : t;
}
function gde(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = new LTe(), r = UTe(e), l = t.compute, i = l === void 0 ? "name" : l, c = t.computedStyleSupportsPseudoElements, f = c === void 0 ? t.getComputedStyle !== void 0 : c, d = t.getComputedStyle, h = d === void 0 ? r.getComputedStyle.bind(r) : d, g = t.hidden, m = g === void 0 ? !1 : g;
  function y(M, P) {
    var a = "";
    if (zt(M) && f) {
      var o = h(M, "::before"), s = Koe(o);
      a = "".concat(s, " ").concat(a);
    }
    var p = KTe(M) ? uBe(M) : nr(M.childNodes).concat(Jo(M, "aria-owns"));
    if (p.forEach(function(N) {
      var T = R(N, {
        isEmbeddedInLabel: P.isEmbeddedInLabel,
        isReferenced: !1,
        recursion: !0
      }), $ = zt(N) ? h(N).getPropertyValue("display") : "inline", j = $ !== "inline" ? " " : "";
      a += "".concat(j).concat(T).concat(j);
    }), zt(M) && f) {
      var O = h(M, "::after"), x = Koe(O);
      a = "".concat(a, " ").concat(x);
    }
    return a.trim();
  }
  function w(M, P) {
    var a = M.getAttributeNode(P);
    return a !== null && !n.has(a) && a.value.trim() !== "" ? (n.add(a), a.value) : null;
  }
  function C(M) {
    return zt(M) ? w(M, "title") : null;
  }
  function E(M) {
    if (!zt(M))
      return null;
    if (WTe(M)) {
      n.add(M);
      for (var P = nr(M.childNodes), a = 0; a < P.length; a += 1) {
        var o = P[a];
        if (GTe(o))
          return R(o, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (VTe(M)) {
      n.add(M);
      for (var s = nr(M.childNodes), p = 0; p < s.length; p += 1) {
        var O = s[p];
        if (ude(O))
          return R(O, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (XTe(M)) {
      n.add(M);
      for (var x = nr(M.childNodes), N = 0; N < x.length; N += 1) {
        var T = x[N];
        if (QTe(T))
          return T.textContent;
      }
      return null;
    } else if (on(M) === "img" || on(M) === "area") {
      var $ = w(M, "alt");
      if ($ !== null)
        return $;
    } else if (zTe(M)) {
      var j = w(M, "label");
      if (j !== null)
        return j;
    }
    if ($o(M) && (M.type === "button" || M.type === "submit" || M.type === "reset")) {
      var A = w(M, "value");
      if (A !== null)
        return A;
      if (M.type === "submit")
        return "Submit";
      if (M.type === "reset")
        return "Reset";
    }
    var Z = cBe(M);
    if (Z !== null && Z.length !== 0)
      return n.add(M), nr(Z).map(function(U) {
        return R(U, {
          isEmbeddedInLabel: !0,
          isReferenced: !1,
          recursion: !0
        });
      }).filter(function(U) {
        return U.length > 0;
      }).join(" ");
    if ($o(M) && M.type === "image") {
      var G = w(M, "alt");
      if (G !== null)
        return G;
      var I = w(M, "title");
      return I !== null ? I : "Submit Query";
    }
    if (Lr(M, ["button"])) {
      var F = y(M, {
        isEmbeddedInLabel: !1,
        isReferenced: !1
      });
      if (F !== "")
        return F;
    }
    return null;
  }
  function R(M, P) {
    if (n.has(M))
      return "";
    if (!m && eBe(M, h) && !P.isReferenced)
      return n.add(M), "";
    var a = zt(M) ? M.getAttributeNode("aria-labelledby") : null, o = a !== null && !n.has(a) ? Jo(M, "aria-labelledby") : [];
    if (i === "name" && !P.isReferenced && o.length > 0)
      return n.add(a), o.map(function($) {
        return R($, {
          isEmbeddedInLabel: P.isEmbeddedInLabel,
          isReferenced: !0,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: !1
        });
      }).join(" ");
    var s = P.recursion && tBe(M) && i === "name";
    if (!s) {
      var p = (zt(M) && M.getAttribute("aria-label") || "").trim();
      if (p !== "" && i === "name")
        return n.add(M), p;
      if (!rBe(M)) {
        var O = E(M);
        if (O !== null)
          return n.add(M), O;
      }
    }
    if (Lr(M, ["menu"]))
      return n.add(M), "";
    if (s || P.isEmbeddedInLabel || P.isReferenced) {
      if (Lr(M, ["combobox", "listbox"])) {
        n.add(M);
        var x = nBe(M);
        return x.length === 0 ? $o(M) ? M.value : "" : nr(x).map(function($) {
          return R($, {
            isEmbeddedInLabel: P.isEmbeddedInLabel,
            isReferenced: !1,
            recursion: !0
          });
        }).join(" ");
      }
      if (fde(M, "range"))
        return n.add(M), M.hasAttribute("aria-valuetext") ? M.getAttribute("aria-valuetext") : M.hasAttribute("aria-valuenow") ? M.getAttribute("aria-valuenow") : M.getAttribute("value") || "";
      if (Lr(M, ["textbox"]))
        return n.add(M), oBe(M);
    }
    if (lBe(M) || zt(M) && P.isReferenced || aBe(M) || iBe()) {
      var N = y(M, {
        isEmbeddedInLabel: P.isEmbeddedInLabel,
        isReferenced: !1
      });
      if (N !== "")
        return n.add(M), N;
    }
    if (M.nodeType === M.TEXT_NODE)
      return n.add(M), M.textContent || "";
    if (P.recursion)
      return n.add(M), y(M, {
        isEmbeddedInLabel: P.isEmbeddedInLabel,
        isReferenced: !1
      });
    var T = C(M);
    return T !== null ? (n.add(M), T) : (n.add(M), "");
  }
  return JTe(R(e, {
    isEmbeddedInLabel: !1,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: i === "description",
    recursion: !1
  }));
}
function _i(e) {
  "@babel/helpers - typeof";
  return _i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _i(e);
}
function Yoe(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xoe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yoe(Object(n), !0).forEach(function(r) {
      fBe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yoe(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fBe(e, t, n) {
  return t = dBe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dBe(e) {
  var t = pBe(e, "string");
  return _i(t) === "symbol" ? t : String(t);
}
function pBe(e, t) {
  if (_i(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (_i(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hde(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Jo(e, "aria-describedby").map(function(l) {
    return gde(l, Xoe(Xoe({}, t), {}, {
      compute: "description"
    }));
  }).join(" ");
  if (n === "") {
    var r = e.getAttribute("title");
    n = r === null ? "" : r;
  }
  return n;
}
function gBe(e) {
  return Lr(e, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}
function Ry(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return gBe(e) ? "" : gde(e, t);
}
var ar = {}, I1 = {}, Da = {}, H1 = {};
Object.defineProperty(H1, "__esModule", {
  value: !0
});
H1.default = void 0;
function hBe() {
  var e = this, t = 0, n = {
    "@@iterator": function() {
      return n;
    },
    next: function() {
      if (t < e.length) {
        var l = e[t];
        return t = t + 1, {
          done: !1,
          value: l
        };
      } else
        return {
          done: !0
        };
    }
  };
  return n;
}
var mBe = hBe;
H1.default = mBe;
Object.defineProperty(Da, "__esModule", {
  value: !0
});
Da.default = yBe;
var vBe = bBe(H1);
function bBe(e) {
  return e && e.__esModule ? e : { default: e };
}
function c9(e) {
  "@babel/helpers - typeof";
  return c9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c9(e);
}
function yBe(e, t) {
  return typeof Symbol == "function" && c9(Symbol.iterator) === "symbol" && Object.defineProperty(e, Symbol.iterator, {
    value: vBe.default.bind(t)
  }), e;
}
Object.defineProperty(I1, "__esModule", {
  value: !0
});
I1.default = void 0;
var wBe = OBe(Da);
function OBe(e) {
  return e && e.__esModule ? e : { default: e };
}
function Eu(e, t) {
  return $Be(e) || EBe(e, t) || mde(e, t) || xBe();
}
function xBe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EBe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, i = !1, c, f;
    try {
      for (n = n.call(e); !(l = (c = n.next()).done) && (r.push(c.value), !(t && r.length === t)); l = !0)
        ;
    } catch (d) {
      i = !0, f = d;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (i)
          throw f;
      }
    }
    return r;
  }
}
function $Be(e) {
  if (Array.isArray(e))
    return e;
}
function jBe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = mde(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, l = function() {
      };
      return { s: l, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(h) {
        throw h;
      }, f: l };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, c = !1, f;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var h = n.next();
    return i = h.done, h;
  }, e: function(h) {
    c = !0, f = h;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (c)
        throw f;
    }
  } };
}
function mde(e, t) {
  if (e) {
    if (typeof e == "string")
      return Qoe(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Qoe(e, t);
  }
}
function Qoe(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Ya = [["aria-activedescendant", {
  type: "id"
}], ["aria-atomic", {
  type: "boolean"
}], ["aria-autocomplete", {
  type: "token",
  values: ["inline", "list", "both", "none"]
}], ["aria-busy", {
  type: "boolean"
}], ["aria-checked", {
  type: "tristate"
}], ["aria-colcount", {
  type: "integer"
}], ["aria-colindex", {
  type: "integer"
}], ["aria-colspan", {
  type: "integer"
}], ["aria-controls", {
  type: "idlist"
}], ["aria-current", {
  type: "token",
  values: ["page", "step", "location", "date", "time", !0, !1]
}], ["aria-describedby", {
  type: "idlist"
}], ["aria-details", {
  type: "id"
}], ["aria-disabled", {
  type: "boolean"
}], ["aria-dropeffect", {
  type: "tokenlist",
  values: ["copy", "execute", "link", "move", "none", "popup"]
}], ["aria-errormessage", {
  type: "id"
}], ["aria-expanded", {
  type: "boolean",
  allowundefined: !0
}], ["aria-flowto", {
  type: "idlist"
}], ["aria-grabbed", {
  type: "boolean",
  allowundefined: !0
}], ["aria-haspopup", {
  type: "token",
  values: [!1, !0, "menu", "listbox", "tree", "grid", "dialog"]
}], ["aria-hidden", {
  type: "boolean",
  allowundefined: !0
}], ["aria-invalid", {
  type: "token",
  values: ["grammar", !1, "spelling", !0]
}], ["aria-keyshortcuts", {
  type: "string"
}], ["aria-label", {
  type: "string"
}], ["aria-labelledby", {
  type: "idlist"
}], ["aria-level", {
  type: "integer"
}], ["aria-live", {
  type: "token",
  values: ["assertive", "off", "polite"]
}], ["aria-modal", {
  type: "boolean"
}], ["aria-multiline", {
  type: "boolean"
}], ["aria-multiselectable", {
  type: "boolean"
}], ["aria-orientation", {
  type: "token",
  values: ["vertical", "undefined", "horizontal"]
}], ["aria-owns", {
  type: "idlist"
}], ["aria-placeholder", {
  type: "string"
}], ["aria-posinset", {
  type: "integer"
}], ["aria-pressed", {
  type: "tristate"
}], ["aria-readonly", {
  type: "boolean"
}], ["aria-relevant", {
  type: "tokenlist",
  values: ["additions", "all", "removals", "text"]
}], ["aria-required", {
  type: "boolean"
}], ["aria-roledescription", {
  type: "string"
}], ["aria-rowcount", {
  type: "integer"
}], ["aria-rowindex", {
  type: "integer"
}], ["aria-rowspan", {
  type: "integer"
}], ["aria-selected", {
  type: "boolean",
  allowundefined: !0
}], ["aria-setsize", {
  type: "integer"
}], ["aria-sort", {
  type: "token",
  values: ["ascending", "descending", "none", "other"]
}], ["aria-valuemax", {
  type: "number"
}], ["aria-valuemin", {
  type: "number"
}], ["aria-valuenow", {
  type: "number"
}], ["aria-valuetext", {
  type: "string"
}]], u9 = {
  entries: function() {
    return Ya;
  },
  forEach: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = jBe(Ya), l;
    try {
      for (r.s(); !(l = r.n()).done; ) {
        var i = Eu(l.value, 2), c = i[0], f = i[1];
        t.call(n, f, c, Ya);
      }
    } catch (d) {
      r.e(d);
    } finally {
      r.f();
    }
  },
  get: function(t) {
    var n = Ya.find(function(r) {
      return r[0] === t;
    });
    return n && n[1];
  },
  has: function(t) {
    return !!u9.get(t);
  },
  keys: function() {
    return Ya.map(function(t) {
      var n = Eu(t, 1), r = n[0];
      return r;
    });
  },
  values: function() {
    return Ya.map(function(t) {
      var n = Eu(t, 2), r = n[1];
      return r;
    });
  }
}, CBe = (0, wBe.default)(u9, u9.entries());
I1.default = CBe;
var D1 = {};
Object.defineProperty(D1, "__esModule", {
  value: !0
});
D1.default = void 0;
var MBe = kBe(Da);
function kBe(e) {
  return e && e.__esModule ? e : { default: e };
}
function $u(e, t) {
  return NBe(e) || SBe(e, t) || vde(e, t) || PBe();
}
function PBe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SBe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, i = !1, c, f;
    try {
      for (n = n.call(e); !(l = (c = n.next()).done) && (r.push(c.value), !(t && r.length === t)); l = !0)
        ;
    } catch (d) {
      i = !0, f = d;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (i)
          throw f;
      }
    }
    return r;
  }
}
function NBe(e) {
  if (Array.isArray(e))
    return e;
}
function RBe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = vde(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, l = function() {
      };
      return { s: l, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(h) {
        throw h;
      }, f: l };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, c = !1, f;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var h = n.next();
    return i = h.done, h;
  }, e: function(h) {
    c = !0, f = h;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (c)
        throw f;
    }
  } };
}
function vde(e, t) {
  if (e) {
    if (typeof e == "string")
      return Joe(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Joe(e, t);
  }
}
function Joe(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Xa = [["a", {
  reserved: !1
}], ["abbr", {
  reserved: !1
}], ["acronym", {
  reserved: !1
}], ["address", {
  reserved: !1
}], ["applet", {
  reserved: !1
}], ["area", {
  reserved: !1
}], ["article", {
  reserved: !1
}], ["aside", {
  reserved: !1
}], ["audio", {
  reserved: !1
}], ["b", {
  reserved: !1
}], ["base", {
  reserved: !0
}], ["bdi", {
  reserved: !1
}], ["bdo", {
  reserved: !1
}], ["big", {
  reserved: !1
}], ["blink", {
  reserved: !1
}], ["blockquote", {
  reserved: !1
}], ["body", {
  reserved: !1
}], ["br", {
  reserved: !1
}], ["button", {
  reserved: !1
}], ["canvas", {
  reserved: !1
}], ["caption", {
  reserved: !1
}], ["center", {
  reserved: !1
}], ["cite", {
  reserved: !1
}], ["code", {
  reserved: !1
}], ["col", {
  reserved: !0
}], ["colgroup", {
  reserved: !0
}], ["content", {
  reserved: !1
}], ["data", {
  reserved: !1
}], ["datalist", {
  reserved: !1
}], ["dd", {
  reserved: !1
}], ["del", {
  reserved: !1
}], ["details", {
  reserved: !1
}], ["dfn", {
  reserved: !1
}], ["dialog", {
  reserved: !1
}], ["dir", {
  reserved: !1
}], ["div", {
  reserved: !1
}], ["dl", {
  reserved: !1
}], ["dt", {
  reserved: !1
}], ["em", {
  reserved: !1
}], ["embed", {
  reserved: !1
}], ["fieldset", {
  reserved: !1
}], ["figcaption", {
  reserved: !1
}], ["figure", {
  reserved: !1
}], ["font", {
  reserved: !1
}], ["footer", {
  reserved: !1
}], ["form", {
  reserved: !1
}], ["frame", {
  reserved: !1
}], ["frameset", {
  reserved: !1
}], ["h1", {
  reserved: !1
}], ["h2", {
  reserved: !1
}], ["h3", {
  reserved: !1
}], ["h4", {
  reserved: !1
}], ["h5", {
  reserved: !1
}], ["h6", {
  reserved: !1
}], ["head", {
  reserved: !0
}], ["header", {
  reserved: !1
}], ["hgroup", {
  reserved: !1
}], ["hr", {
  reserved: !1
}], ["html", {
  reserved: !0
}], ["i", {
  reserved: !1
}], ["iframe", {
  reserved: !1
}], ["img", {
  reserved: !1
}], ["input", {
  reserved: !1
}], ["ins", {
  reserved: !1
}], ["kbd", {
  reserved: !1
}], ["keygen", {
  reserved: !1
}], ["label", {
  reserved: !1
}], ["legend", {
  reserved: !1
}], ["li", {
  reserved: !1
}], ["link", {
  reserved: !0
}], ["main", {
  reserved: !1
}], ["map", {
  reserved: !1
}], ["mark", {
  reserved: !1
}], ["marquee", {
  reserved: !1
}], ["menu", {
  reserved: !1
}], ["menuitem", {
  reserved: !1
}], ["meta", {
  reserved: !0
}], ["meter", {
  reserved: !1
}], ["nav", {
  reserved: !1
}], ["noembed", {
  reserved: !0
}], ["noscript", {
  reserved: !0
}], ["object", {
  reserved: !1
}], ["ol", {
  reserved: !1
}], ["optgroup", {
  reserved: !1
}], ["option", {
  reserved: !1
}], ["output", {
  reserved: !1
}], ["p", {
  reserved: !1
}], ["param", {
  reserved: !0
}], ["picture", {
  reserved: !0
}], ["pre", {
  reserved: !1
}], ["progress", {
  reserved: !1
}], ["q", {
  reserved: !1
}], ["rp", {
  reserved: !1
}], ["rt", {
  reserved: !1
}], ["rtc", {
  reserved: !1
}], ["ruby", {
  reserved: !1
}], ["s", {
  reserved: !1
}], ["samp", {
  reserved: !1
}], ["script", {
  reserved: !0
}], ["section", {
  reserved: !1
}], ["select", {
  reserved: !1
}], ["small", {
  reserved: !1
}], ["source", {
  reserved: !0
}], ["spacer", {
  reserved: !1
}], ["span", {
  reserved: !1
}], ["strike", {
  reserved: !1
}], ["strong", {
  reserved: !1
}], ["style", {
  reserved: !0
}], ["sub", {
  reserved: !1
}], ["summary", {
  reserved: !1
}], ["sup", {
  reserved: !1
}], ["table", {
  reserved: !1
}], ["tbody", {
  reserved: !1
}], ["td", {
  reserved: !1
}], ["textarea", {
  reserved: !1
}], ["tfoot", {
  reserved: !1
}], ["th", {
  reserved: !1
}], ["thead", {
  reserved: !1
}], ["time", {
  reserved: !1
}], ["title", {
  reserved: !0
}], ["tr", {
  reserved: !1
}], ["track", {
  reserved: !0
}], ["tt", {
  reserved: !1
}], ["u", {
  reserved: !1
}], ["ul", {
  reserved: !1
}], ["var", {
  reserved: !1
}], ["video", {
  reserved: !1
}], ["wbr", {
  reserved: !1
}], ["xmp", {
  reserved: !1
}]], f9 = {
  entries: function() {
    return Xa;
  },
  forEach: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = RBe(Xa), l;
    try {
      for (r.s(); !(l = r.n()).done; ) {
        var i = $u(l.value, 2), c = i[0], f = i[1];
        t.call(n, f, c, Xa);
      }
    } catch (d) {
      r.e(d);
    } finally {
      r.f();
    }
  },
  get: function(t) {
    var n = Xa.find(function(r) {
      return r[0] === t;
    });
    return n && n[1];
  },
  has: function(t) {
    return !!f9.get(t);
  },
  keys: function() {
    return Xa.map(function(t) {
      var n = $u(t, 1), r = n[0];
      return r;
    });
  },
  values: function() {
    return Xa.map(function(t) {
      var n = $u(t, 2), r = n[1];
      return r;
    });
  }
}, _Be = (0, MBe.default)(f9, f9.entries());
D1.default = _Be;
var ql = {}, z1 = {}, F1 = {};
Object.defineProperty(F1, "__esModule", {
  value: !0
});
F1.default = void 0;
var ABe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menuitem"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget"]]
}, LBe = ABe;
F1.default = LBe;
var V1 = {};
Object.defineProperty(V1, "__esModule", {
  value: !0
});
V1.default = void 0;
var ZBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-disabled": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget"]]
}, TBe = ZBe;
V1.default = TBe;
var q1 = {};
Object.defineProperty(q1, "__esModule", {
  value: !0
});
q1.default = void 0;
var BBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null
  },
  relatedConcepts: [{
    concept: {
      name: "input"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget"]]
}, IBe = BBe;
q1.default = IBe;
var U1 = {};
Object.defineProperty(U1, "__esModule", {
  value: !0
});
U1.default = void 0;
var HBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, DBe = HBe;
U1.default = DBe;
var W1 = {};
Object.defineProperty(W1, "__esModule", {
  value: !0
});
W1.default = void 0;
var zBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, FBe = zBe;
W1.default = FBe;
var G1 = {};
Object.defineProperty(G1, "__esModule", {
  value: !0
});
G1.default = void 0;
var VBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: [],
  prohibitedProps: [],
  props: {
    "aria-atomic": null,
    "aria-busy": null,
    "aria-controls": null,
    "aria-current": null,
    "aria-describedby": null,
    "aria-details": null,
    "aria-dropeffect": null,
    "aria-flowto": null,
    "aria-grabbed": null,
    "aria-hidden": null,
    "aria-keyshortcuts": null,
    "aria-label": null,
    "aria-labelledby": null,
    "aria-live": null,
    "aria-owns": null,
    "aria-relevant": null,
    "aria-roledescription": null
  },
  relatedConcepts: [{
    concept: {
      name: "rel"
    },
    module: "HTML"
  }, {
    concept: {
      name: "role"
    },
    module: "XHTML"
  }, {
    concept: {
      name: "type"
    },
    module: "Dublin Core"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
}, qBe = VBe;
G1.default = qBe;
var K1 = {};
Object.defineProperty(K1, "__esModule", {
  value: !0
});
K1.default = void 0;
var UBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "frontmatter"
    },
    module: "DTB"
  }, {
    concept: {
      name: "level"
    },
    module: "DTB"
  }, {
    concept: {
      name: "level"
    },
    module: "SMIL"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, WBe = UBe;
K1.default = WBe;
var Y1 = {};
Object.defineProperty(Y1, "__esModule", {
  value: !0
});
Y1.default = void 0;
var GBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, KBe = GBe;
Y1.default = KBe;
var X1 = {};
Object.defineProperty(X1, "__esModule", {
  value: !0
});
X1.default = void 0;
var YBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "group"]]
}, XBe = YBe;
X1.default = XBe;
var Q1 = {};
Object.defineProperty(Q1, "__esModule", {
  value: !0
});
Q1.default = void 0;
var QBe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype"]]
}, JBe = QBe;
Q1.default = JBe;
var J1 = {};
Object.defineProperty(J1, "__esModule", {
  value: !0
});
J1.default = void 0;
var eIe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype"]]
}, tIe = eIe;
J1.default = tIe;
var e0 = {};
Object.defineProperty(e0, "__esModule", {
  value: !0
});
e0.default = void 0;
var nIe = {
  abstract: !0,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-modal": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype"]]
}, rIe = nIe;
e0.default = rIe;
Object.defineProperty(z1, "__esModule", {
  value: !0
});
z1.default = void 0;
var aIe = Xn(F1), lIe = Xn(V1), iIe = Xn(q1), oIe = Xn(U1), sIe = Xn(W1), cIe = Xn(G1), uIe = Xn(K1), fIe = Xn(Y1), dIe = Xn(X1), pIe = Xn(Q1), gIe = Xn(J1), hIe = Xn(e0);
function Xn(e) {
  return e && e.__esModule ? e : { default: e };
}
var mIe = [["command", aIe.default], ["composite", lIe.default], ["input", iIe.default], ["landmark", oIe.default], ["range", sIe.default], ["roletype", cIe.default], ["section", uIe.default], ["sectionhead", fIe.default], ["select", dIe.default], ["structure", pIe.default], ["widget", gIe.default], ["window", hIe.default]], vIe = mIe;
z1.default = vIe;
var t0 = {}, n0 = {};
Object.defineProperty(n0, "__esModule", {
  value: !0
});
n0.default = void 0;
var bIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-atomic": "true",
    "aria-live": "assertive"
  },
  relatedConcepts: [{
    concept: {
      name: "alert"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, yIe = bIe;
n0.default = yIe;
var r0 = {};
Object.defineProperty(r0, "__esModule", {
  value: !0
});
r0.default = void 0;
var wIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "alert"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "alert"], ["roletype", "window", "dialog"]]
}, OIe = wIe;
r0.default = OIe;
var a0 = {};
Object.defineProperty(a0, "__esModule", {
  value: !0
});
a0.default = void 0;
var xIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "Device Independence Delivery Unit"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, EIe = xIe;
a0.default = EIe;
var l0 = {};
Object.defineProperty(l0, "__esModule", {
  value: !0
});
l0.default = void 0;
var $Ie = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      name: "article"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "document"]]
}, jIe = $Ie;
l0.default = jIe;
var i0 = {};
Object.defineProperty(i0, "__esModule", {
  value: !0
});
i0.default = void 0;
var CIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ["direct descendant of document"],
      name: "header"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, MIe = CIe;
i0.default = MIe;
var o0 = {};
Object.defineProperty(o0, "__esModule", {
  value: !0
});
o0.default = void 0;
var kIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, PIe = kIe;
o0.default = PIe;
var s0 = {};
Object.defineProperty(s0, "__esModule", {
  value: !0
});
s0.default = void 0;
var SIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-pressed": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-pressed"
      }, {
        name: "type",
        value: "checkbox"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "aria-expanded",
        value: "false"
      }],
      name: "summary"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "aria-expanded",
        value: "true"
      }],
      constraints: ["direct descendant of details element with the open attribute defined"],
      name: "summary"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "button"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "image"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "reset"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "submit"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      name: "button"
    },
    module: "HTML"
  }, {
    concept: {
      name: "trigger"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command"]]
}, NIe = SIe;
s0.default = NIe;
var c0 = {};
Object.defineProperty(c0, "__esModule", {
  value: !0
});
c0.default = void 0;
var RIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: ["figure", "grid", "table"],
  requiredContextRole: ["figure", "grid", "table"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, _Ie = RIe;
c0.default = _Ie;
var u0 = {};
Object.defineProperty(u0, "__esModule", {
  value: !0
});
u0.default = void 0;
var AIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-colindex": null,
    "aria-colspan": null,
    "aria-rowindex": null,
    "aria-rowspan": null
  },
  relatedConcepts: [{
    concept: {
      constraints: ["descendant of table"],
      name: "td"
    },
    module: "HTML"
  }],
  requireContextRole: ["row"],
  requiredContextRole: ["row"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, LIe = AIe;
u0.default = LIe;
var f0 = {};
Object.defineProperty(f0, "__esModule", {
  value: !0
});
f0.default = void 0;
var ZIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-checked": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "checkbox"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      name: "option"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input"]]
}, TIe = ZIe;
f0.default = TIe;
var d0 = {};
Object.defineProperty(d0, "__esModule", {
  value: !0
});
d0.default = void 0;
var BIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, IIe = BIe;
d0.default = IIe;
var p0 = {};
Object.defineProperty(p0, "__esModule", {
  value: !0
});
p0.default = void 0;
var HIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-sort": null
  },
  relatedConcepts: [{
    attributes: [{
      name: "scope",
      value: "col"
    }],
    concept: {
      name: "th"
    },
    module: "HTML"
  }],
  requireContextRole: ["row"],
  requiredContextRole: ["row"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widget", "gridcell"], ["roletype", "structure", "sectionhead"]]
}, DIe = HIe;
p0.default = DIe;
var g0 = {};
Object.defineProperty(g0, "__esModule", {
  value: !0
});
g0.default = void 0;
var zIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-autocomplete": null,
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-expanded": "false",
    "aria-haspopup": "listbox"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "email"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "search"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "tel"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "text"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "url"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "url"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "multiple"
      }, {
        constraints: ["undefined"],
        name: "size"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "multiple"
      }, {
        name: "size",
        value: 1
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      name: "select"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-controls": null,
    "aria-expanded": "false"
  },
  superClass: [["roletype", "widget", "input"]]
}, FIe = zIe;
g0.default = FIe;
var h0 = {};
Object.defineProperty(h0, "__esModule", {
  value: !0
});
h0.default = void 0;
var VIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "aside"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, qIe = VIe;
h0.default = qIe;
var m0 = {};
Object.defineProperty(m0, "__esModule", {
  value: !0
});
m0.default = void 0;
var UIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ["direct descendant of document"],
      name: "footer"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, WIe = UIe;
m0.default = WIe;
var v0 = {};
Object.defineProperty(v0, "__esModule", {
  value: !0
});
v0.default = void 0;
var GIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "dd"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, KIe = GIe;
v0.default = KIe;
var b0 = {};
Object.defineProperty(b0, "__esModule", {
  value: !0
});
b0.default = void 0;
var YIe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, XIe = YIe;
b0.default = XIe;
var y0 = {};
Object.defineProperty(y0, "__esModule", {
  value: !0
});
y0.default = void 0;
var QIe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "dialog"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "window"]]
}, JIe = QIe;
y0.default = JIe;
var w0 = {};
Object.defineProperty(w0, "__esModule", {
  value: !0
});
w0.default = void 0;
var eHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    module: "DAISY Guide"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "list"]]
}, tHe = eHe;
w0.default = tHe;
var O0 = {};
Object.defineProperty(O0, "__esModule", {
  value: !0
});
O0.default = void 0;
var nHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "Device Independence Delivery Unit"
    }
  }, {
    concept: {
      name: "body"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, rHe = nHe;
O0.default = rHe;
var x0 = {};
Object.defineProperty(x0, "__esModule", {
  value: !0
});
x0.default = void 0;
var aHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, lHe = aHe;
x0.default = lHe;
var E0 = {};
Object.defineProperty(E0, "__esModule", {
  value: !0
});
E0.default = void 0;
var iHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["article"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "list"]]
}, oHe = iHe;
E0.default = oHe;
var $0 = {};
Object.defineProperty($0, "__esModule", {
  value: !0
});
$0.default = void 0;
var sHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "figure"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, cHe = sHe;
$0.default = cHe;
var j0 = {};
Object.defineProperty(j0, "__esModule", {
  value: !0
});
j0.default = void 0;
var uHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-label"
      }],
      name: "form"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-labelledby"
      }],
      name: "form"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "name"
      }],
      name: "form"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, fHe = uHe;
j0.default = fHe;
var C0 = {};
Object.defineProperty(C0, "__esModule", {
  value: !0
});
C0.default = void 0;
var dHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "span"
    },
    module: "HTML"
  }, {
    concept: {
      name: "div"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, pHe = dHe;
C0.default = pHe;
var M0 = {};
Object.defineProperty(M0, "__esModule", {
  value: !0
});
M0.default = void 0;
var gHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-multiselectable": null,
    "aria-readonly": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "role",
        value: "grid"
      }],
      name: "table"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["row"], ["row", "rowgroup"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "table"]]
}, hHe = gHe;
M0.default = hHe;
var k0 = {};
Object.defineProperty(k0, "__esModule", {
  value: !0
});
k0.default = void 0;
var mHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-selected": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "role",
        value: "gridcell"
      }],
      name: "td"
    },
    module: "HTML"
  }],
  requireContextRole: ["row"],
  requiredContextRole: ["row"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "cell"], ["roletype", "widget"]]
}, vHe = mHe;
k0.default = vHe;
var P0 = {};
Object.defineProperty(P0, "__esModule", {
  value: !0
});
P0.default = void 0;
var bHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-disabled": null
  },
  relatedConcepts: [{
    concept: {
      name: "details"
    },
    module: "HTML"
  }, {
    concept: {
      name: "fieldset"
    },
    module: "HTML"
  }, {
    concept: {
      name: "optgroup"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, yHe = bHe;
P0.default = yHe;
var S0 = {};
Object.defineProperty(S0, "__esModule", {
  value: !0
});
S0.default = void 0;
var wHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-level": "2"
  },
  relatedConcepts: [{
    concept: {
      name: "h1"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h2"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h3"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h4"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h5"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h6"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-level": "2"
  },
  superClass: [["roletype", "structure", "sectionhead"]]
}, OHe = wHe;
S0.default = OHe;
var N0 = {};
Object.defineProperty(N0, "__esModule", {
  value: !0
});
N0.default = void 0;
var xHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "alt"
      }],
      name: "img"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "alt"
      }],
      name: "img"
    },
    module: "HTML"
  }, {
    concept: {
      name: "imggroup"
    },
    module: "DTB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, EHe = xHe;
N0.default = EHe;
var R0 = {};
Object.defineProperty(R0, "__esModule", {
  value: !0
});
R0.default = void 0;
var $He = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, jHe = $He;
R0.default = jHe;
var _0 = {};
Object.defineProperty(_0, "__esModule", {
  value: !0
});
_0.default = void 0;
var CHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "href"
      }],
      name: "a"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "href"
      }],
      name: "area"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "href"
      }],
      name: "link"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command"]]
}, MHe = CHe;
_0.default = MHe;
var A0 = {};
Object.defineProperty(A0, "__esModule", {
  value: !0
});
A0.default = void 0;
var kHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menu"
    },
    module: "HTML"
  }, {
    concept: {
      name: "ol"
    },
    module: "HTML"
  }, {
    concept: {
      name: "ul"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["listitem"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, PHe = kHe;
A0.default = PHe;
var L0 = {};
Object.defineProperty(L0, "__esModule", {
  value: !0
});
L0.default = void 0;
var SHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-invalid": null,
    "aria-multiselectable": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-orientation": "vertical"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: [">1"],
        name: "size"
      }, {
        name: "multiple"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: [">1"],
        name: "size"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "multiple"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      name: "datalist"
    },
    module: "HTML"
  }, {
    concept: {
      name: "list"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "select"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["option", "group"], ["option"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
}, NHe = SHe;
L0.default = NHe;
var Z0 = {};
Object.defineProperty(Z0, "__esModule", {
  value: !0
});
Z0.default = void 0;
var RHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-level": null,
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      constraints: ["direct descendant of ol, ul or menu"],
      name: "li"
    },
    module: "HTML"
  }, {
    concept: {
      name: "item"
    },
    module: "XForms"
  }],
  requireContextRole: ["directory", "list"],
  requiredContextRole: ["directory", "list"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, _He = RHe;
Z0.default = _He;
var T0 = {};
Object.defineProperty(T0, "__esModule", {
  value: !0
});
T0.default = void 0;
var AHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-live": "polite"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, LHe = AHe;
T0.default = LHe;
var B0 = {};
Object.defineProperty(B0, "__esModule", {
  value: !0
});
B0.default = void 0;
var ZHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "main"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, THe = ZHe;
B0.default = THe;
var I0 = {};
Object.defineProperty(I0, "__esModule", {
  value: !0
});
I0.default = void 0;
var BHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, IHe = BHe;
I0.default = IHe;
var H0 = {};
Object.defineProperty(H0, "__esModule", {
  value: !0
});
H0.default = void 0;
var HHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "math"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, DHe = HHe;
H0.default = DHe;
var D0 = {};
Object.defineProperty(D0, "__esModule", {
  value: !0
});
D0.default = void 0;
var zHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": "vertical"
  },
  relatedConcepts: [{
    concept: {
      name: "MENU"
    },
    module: "JAPI"
  }, {
    concept: {
      name: "list"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "select"
    },
    module: "XForms"
  }, {
    concept: {
      name: "sidebar"
    },
    module: "DTB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckbox"], ["menuitemradio"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
}, FHe = zHe;
D0.default = FHe;
var z0 = {};
Object.defineProperty(z0, "__esModule", {
  value: !0
});
z0.default = void 0;
var VHe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": "horizontal"
  },
  relatedConcepts: [{
    concept: {
      name: "toolbar"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckbox"], ["menuitemradio"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select", "menu"], ["roletype", "structure", "section", "group", "select", "menu"]]
}, qHe = VHe;
z0.default = qHe;
var F0 = {};
Object.defineProperty(F0, "__esModule", {
  value: !0
});
F0.default = void 0;
var UHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      name: "MENU_ITEM"
    },
    module: "JAPI"
  }, {
    concept: {
      name: "listitem"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "menuitem"
    },
    module: "HTML"
  }, {
    concept: {
      name: "option"
    },
    module: "ARIA"
  }],
  requireContextRole: ["group", "menu", "menubar"],
  requiredContextRole: ["group", "menu", "menubar"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command"]]
}, WHe = UHe;
F0.default = WHe;
var V0 = {};
Object.defineProperty(V0, "__esModule", {
  value: !0
});
V0.default = void 0;
var GHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menuitem"
    },
    module: "ARIA"
  }],
  requireContextRole: ["group", "menu", "menubar"],
  requiredContextRole: ["group", "menu", "menubar"],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input", "checkbox"], ["roletype", "widget", "command", "menuitem"]]
}, KHe = GHe;
V0.default = KHe;
var q0 = {};
Object.defineProperty(q0, "__esModule", {
  value: !0
});
q0.default = void 0;
var YHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menuitem"
    },
    module: "ARIA"
  }],
  requireContextRole: ["group", "menu", "menubar"],
  requiredContextRole: ["group", "menu", "menubar"],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input", "checkbox", "menuitemcheckbox"], ["roletype", "widget", "command", "menuitem", "menuitemcheckbox"], ["roletype", "widget", "input", "radio"]]
}, XHe = YHe;
q0.default = XHe;
var U0 = {};
Object.defineProperty(U0, "__esModule", {
  value: !0
});
U0.default = void 0;
var QHe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-valuetext": null,
    "aria-valuemax": "100",
    "aria-valuemin": "0"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-valuenow": null
  },
  superClass: [["roletype", "structure", "range"]]
}, JHe = QHe;
U0.default = JHe;
var W0 = {};
Object.defineProperty(W0, "__esModule", {
  value: !0
});
W0.default = void 0;
var eDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "nav"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, tDe = eDe;
W0.default = tDe;
var G0 = {};
Object.defineProperty(G0, "__esModule", {
  value: !0
});
G0.default = void 0;
var nDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
}, rDe = nDe;
G0.default = rDe;
var K0 = {};
Object.defineProperty(K0, "__esModule", {
  value: !0
});
K0.default = void 0;
var aDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, lDe = aDe;
K0.default = lDe;
var Y0 = {};
Object.defineProperty(Y0, "__esModule", {
  value: !0
});
Y0.default = void 0;
var iDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-checked": null,
    "aria-posinset": null,
    "aria-setsize": null,
    "aria-selected": "false"
  },
  relatedConcepts: [{
    concept: {
      name: "item"
    },
    module: "XForms"
  }, {
    concept: {
      name: "listitem"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "option"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-selected": "false"
  },
  superClass: [["roletype", "widget", "input"]]
}, oDe = iDe;
Y0.default = oDe;
var X0 = {};
Object.defineProperty(X0, "__esModule", {
  value: !0
});
X0.default = void 0;
var sDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, cDe = sDe;
X0.default = cDe;
var Q0 = {};
Object.defineProperty(Q0, "__esModule", {
  value: !0
});
Q0.default = void 0;
var uDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, fDe = uDe;
Q0.default = fDe;
var J0 = {};
Object.defineProperty(J0, "__esModule", {
  value: !0
});
J0.default = void 0;
var dDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-valuetext": null
  },
  relatedConcepts: [{
    concept: {
      name: "progress"
    },
    module: "HTML"
  }, {
    concept: {
      name: "status"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
}, pDe = dDe;
J0.default = pDe;
var es = {};
Object.defineProperty(es, "__esModule", {
  value: !0
});
es.default = void 0;
var gDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-checked": null,
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "radio"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input"]]
}, hDe = gDe;
es.default = hDe;
var ts = {};
Object.defineProperty(ts, "__esModule", {
  value: !0
});
ts.default = void 0;
var mDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null
  },
  relatedConcepts: [{
    concept: {
      name: "list"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["radio"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
}, vDe = mDe;
ts.default = vDe;
var ns = {};
Object.defineProperty(ns, "__esModule", {
  value: !0
});
ns.default = void 0;
var bDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-label"
      }],
      name: "section"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-labelledby"
      }],
      name: "section"
    },
    module: "HTML"
  }, {
    concept: {
      name: "Device Independence Glossart perceivable unit"
    }
  }, {
    concept: {
      name: "frame"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, yDe = bDe;
ns.default = yDe;
var rs = {};
Object.defineProperty(rs, "__esModule", {
  value: !0
});
rs.default = void 0;
var wDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-colindex": null,
    "aria-expanded": null,
    "aria-level": null,
    "aria-posinset": null,
    "aria-rowindex": null,
    "aria-selected": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      name: "tr"
    },
    module: "HTML"
  }],
  requireContextRole: ["grid", "rowgroup", "table", "treegrid"],
  requiredContextRole: ["grid", "rowgroup", "table", "treegrid"],
  requiredOwnedElements: [["cell"], ["columnheader"], ["gridcell"], ["rowheader"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "group"], ["roletype", "widget"]]
}, ODe = wDe;
rs.default = ODe;
var as = {};
Object.defineProperty(as, "__esModule", {
  value: !0
});
as.default = void 0;
var xDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "tbody"
    },
    module: "HTML"
  }, {
    concept: {
      name: "tfoot"
    },
    module: "HTML"
  }, {
    concept: {
      name: "thead"
    },
    module: "HTML"
  }],
  requireContextRole: ["grid", "table", "treegrid"],
  requiredContextRole: ["grid", "table", "treegrid"],
  requiredOwnedElements: [["row"]],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, EDe = xDe;
as.default = EDe;
var ls = {};
Object.defineProperty(ls, "__esModule", {
  value: !0
});
ls.default = void 0;
var $De = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-sort": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "scope",
        value: "row"
      }],
      name: "th"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "scope",
        value: "rowgroup"
      }],
      name: "th"
    },
    module: "HTML"
  }],
  requireContextRole: ["row", "rowgroup"],
  requiredContextRole: ["row", "rowgroup"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widget", "gridcell"], ["roletype", "structure", "sectionhead"]]
}, jDe = $De;
ls.default = jDe;
var is = {};
Object.defineProperty(is, "__esModule", {
  value: !0
});
is.default = void 0;
var CDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-valuetext": null,
    "aria-orientation": "vertical",
    "aria-valuemax": "100",
    "aria-valuemin": "0"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-controls": null,
    "aria-valuenow": null
  },
  superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
}, MDe = CDe;
is.default = MDe;
var os = {};
Object.defineProperty(os, "__esModule", {
  value: !0
});
os.default = void 0;
var kDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, PDe = kDe;
os.default = PDe;
var ss = {};
Object.defineProperty(ss, "__esModule", {
  value: !0
});
ss.default = void 0;
var SDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "search"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "input", "textbox"]]
}, NDe = SDe;
ss.default = NDe;
var cs = {};
Object.defineProperty(cs, "__esModule", {
  value: !0
});
cs.default = void 0;
var RDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-orientation": "horizontal",
    "aria-valuemax": "100",
    "aria-valuemin": "0",
    "aria-valuenow": null,
    "aria-valuetext": null
  },
  relatedConcepts: [{
    concept: {
      name: "hr"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
}, _De = RDe;
cs.default = _De;
var us = {};
Object.defineProperty(us, "__esModule", {
  value: !0
});
us.default = void 0;
var ADe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-haspopup": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-valuetext": null,
    "aria-orientation": "horizontal",
    "aria-valuemax": "100",
    "aria-valuemin": "0"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "range"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-valuenow": null
  },
  superClass: [["roletype", "widget", "input"], ["roletype", "structure", "range"]]
}, LDe = ADe;
us.default = LDe;
var fs = {};
Object.defineProperty(fs, "__esModule", {
  value: !0
});
fs.default = void 0;
var ZDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-valuetext": null,
    "aria-valuenow": "0"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "number"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"], ["roletype", "widget", "input"], ["roletype", "structure", "range"]]
}, TDe = ZDe;
fs.default = TDe;
var ds = {};
Object.defineProperty(ds, "__esModule", {
  value: !0
});
ds.default = void 0;
var BDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-atomic": "true",
    "aria-live": "polite"
  },
  relatedConcepts: [{
    concept: {
      name: "output"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, IDe = BDe;
ds.default = IDe;
var ps = {};
Object.defineProperty(ps, "__esModule", {
  value: !0
});
ps.default = void 0;
var HDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, DDe = HDe;
ps.default = DDe;
var gs = {};
Object.defineProperty(gs, "__esModule", {
  value: !0
});
gs.default = void 0;
var zDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, FDe = zDe;
gs.default = FDe;
var hs = {};
Object.defineProperty(hs, "__esModule", {
  value: !0
});
hs.default = void 0;
var VDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, qDe = VDe;
hs.default = qDe;
var ms = {};
Object.defineProperty(ms, "__esModule", {
  value: !0
});
ms.default = void 0;
var UDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "button"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input", "checkbox"]]
}, WDe = UDe;
ms.default = WDe;
var vs = {};
Object.defineProperty(vs, "__esModule", {
  value: !0
});
vs.default = void 0;
var GDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-posinset": null,
    "aria-setsize": null,
    "aria-selected": "false"
  },
  relatedConcepts: [],
  requireContextRole: ["tablist"],
  requiredContextRole: ["tablist"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "sectionhead"], ["roletype", "widget"]]
}, KDe = GDe;
vs.default = KDe;
var bs = {};
Object.defineProperty(bs, "__esModule", {
  value: !0
});
bs.default = void 0;
var YDe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-colcount": null,
    "aria-rowcount": null
  },
  relatedConcepts: [{
    concept: {
      name: "table"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["row"], ["row", "rowgroup"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, XDe = YDe;
bs.default = XDe;
var ys = {};
Object.defineProperty(ys, "__esModule", {
  value: !0
});
ys.default = void 0;
var QDe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-level": null,
    "aria-multiselectable": null,
    "aria-orientation": "horizontal"
  },
  relatedConcepts: [{
    module: "DAISY",
    concept: {
      name: "guide"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["tab"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"]]
}, JDe = QDe;
ys.default = JDe;
var ws = {};
Object.defineProperty(ws, "__esModule", {
  value: !0
});
ws.default = void 0;
var eze = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, tze = eze;
ws.default = tze;
var Os = {};
Object.defineProperty(Os, "__esModule", {
  value: !0
});
Os.default = void 0;
var nze = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "dfn"
    },
    module: "HTML"
  }, {
    concept: {
      name: "dt"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, rze = nze;
Os.default = rze;
var xs = {};
Object.defineProperty(xs, "__esModule", {
  value: !0
});
xs.default = void 0;
var aze = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-autocomplete": null,
    "aria-errormessage": null,
    "aria-haspopup": null,
    "aria-invalid": null,
    "aria-multiline": null,
    "aria-placeholder": null,
    "aria-readonly": null,
    "aria-required": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "type"
      }, {
        constraints: ["undefined"],
        name: "list"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "email"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "tel"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "text"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "url"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      name: "input"
    },
    module: "XForms"
  }, {
    concept: {
      name: "textarea"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "input"]]
}, lze = aze;
xs.default = lze;
var Es = {};
Object.defineProperty(Es, "__esModule", {
  value: !0
});
Es.default = void 0;
var ize = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, oze = ize;
Es.default = oze;
var $s = {};
Object.defineProperty($s, "__esModule", {
  value: !0
});
$s.default = void 0;
var sze = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "status"]]
}, cze = sze;
$s.default = cze;
var js = {};
Object.defineProperty(js, "__esModule", {
  value: !0
});
js.default = void 0;
var uze = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": "horizontal"
  },
  relatedConcepts: [{
    concept: {
      name: "menubar"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "group"]]
}, fze = uze;
js.default = fze;
var Cs = {};
Object.defineProperty(Cs, "__esModule", {
  value: !0
});
Cs.default = void 0;
var dze = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, pze = dze;
Cs.default = pze;
var Ms = {};
Object.defineProperty(Ms, "__esModule", {
  value: !0
});
Ms.default = void 0;
var gze = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-multiselectable": null,
    "aria-required": null,
    "aria-orientation": "vertical"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["treeitem", "group"], ["treeitem"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
}, hze = gze;
Ms.default = hze;
var ks = {};
Object.defineProperty(ks, "__esModule", {
  value: !0
});
ks.default = void 0;
var mze = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["row"], ["row", "rowgroup"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "grid"], ["roletype", "structure", "section", "table", "grid"], ["roletype", "widget", "composite", "select", "tree"], ["roletype", "structure", "section", "group", "select", "tree"]]
}, vze = mze;
ks.default = vze;
var Ps = {};
Object.defineProperty(Ps, "__esModule", {
  value: !0
});
Ps.default = void 0;
var bze = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-expanded": null,
    "aria-haspopup": null
  },
  relatedConcepts: [],
  requireContextRole: ["group", "tree"],
  requiredContextRole: ["group", "tree"],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-selected": null
  },
  superClass: [["roletype", "structure", "section", "listitem"], ["roletype", "widget", "input", "option"]]
}, yze = bze;
Ps.default = yze;
Object.defineProperty(t0, "__esModule", {
  value: !0
});
t0.default = void 0;
var wze = ie(n0), Oze = ie(r0), xze = ie(a0), Eze = ie(l0), $ze = ie(i0), jze = ie(o0), Cze = ie(s0), Mze = ie(c0), kze = ie(u0), Pze = ie(f0), Sze = ie(d0), Nze = ie(p0), Rze = ie(g0), _ze = ie(h0), Aze = ie(m0), Lze = ie(v0), Zze = ie(b0), Tze = ie(y0), Bze = ie(w0), Ize = ie(O0), Hze = ie(x0), Dze = ie(E0), zze = ie($0), Fze = ie(j0), Vze = ie(C0), qze = ie(M0), Uze = ie(k0), Wze = ie(P0), Gze = ie(S0), Kze = ie(N0), Yze = ie(R0), Xze = ie(_0), Qze = ie(A0), Jze = ie(L0), eFe = ie(Z0), tFe = ie(T0), nFe = ie(B0), rFe = ie(I0), aFe = ie(H0), lFe = ie(D0), iFe = ie(z0), oFe = ie(F0), sFe = ie(V0), cFe = ie(q0), uFe = ie(U0), fFe = ie(W0), dFe = ie(G0), pFe = ie(K0), gFe = ie(Y0), hFe = ie(X0), mFe = ie(Q0), vFe = ie(J0), bFe = ie(es), yFe = ie(ts), wFe = ie(ns), OFe = ie(rs), xFe = ie(as), EFe = ie(ls), $Fe = ie(is), jFe = ie(os), CFe = ie(ss), MFe = ie(cs), kFe = ie(us), PFe = ie(fs), SFe = ie(ds), NFe = ie(ps), RFe = ie(gs), _Fe = ie(hs), AFe = ie(ms), LFe = ie(vs), ZFe = ie(bs), TFe = ie(ys), BFe = ie(ws), IFe = ie(Os), HFe = ie(xs), DFe = ie(Es), zFe = ie($s), FFe = ie(js), VFe = ie(Cs), qFe = ie(Ms), UFe = ie(ks), WFe = ie(Ps);
function ie(e) {
  return e && e.__esModule ? e : { default: e };
}
var GFe = [["alert", wze.default], ["alertdialog", Oze.default], ["application", xze.default], ["article", Eze.default], ["banner", $ze.default], ["blockquote", jze.default], ["button", Cze.default], ["caption", Mze.default], ["cell", kze.default], ["checkbox", Pze.default], ["code", Sze.default], ["columnheader", Nze.default], ["combobox", Rze.default], ["complementary", _ze.default], ["contentinfo", Aze.default], ["definition", Lze.default], ["deletion", Zze.default], ["dialog", Tze.default], ["directory", Bze.default], ["document", Ize.default], ["emphasis", Hze.default], ["feed", Dze.default], ["figure", zze.default], ["form", Fze.default], ["generic", Vze.default], ["grid", qze.default], ["gridcell", Uze.default], ["group", Wze.default], ["heading", Gze.default], ["img", Kze.default], ["insertion", Yze.default], ["link", Xze.default], ["list", Qze.default], ["listbox", Jze.default], ["listitem", eFe.default], ["log", tFe.default], ["main", nFe.default], ["marquee", rFe.default], ["math", aFe.default], ["menu", lFe.default], ["menubar", iFe.default], ["menuitem", oFe.default], ["menuitemcheckbox", sFe.default], ["menuitemradio", cFe.default], ["meter", uFe.default], ["navigation", fFe.default], ["none", dFe.default], ["note", pFe.default], ["option", gFe.default], ["paragraph", hFe.default], ["presentation", mFe.default], ["progressbar", vFe.default], ["radio", bFe.default], ["radiogroup", yFe.default], ["region", wFe.default], ["row", OFe.default], ["rowgroup", xFe.default], ["rowheader", EFe.default], ["scrollbar", $Fe.default], ["search", jFe.default], ["searchbox", CFe.default], ["separator", MFe.default], ["slider", kFe.default], ["spinbutton", PFe.default], ["status", SFe.default], ["strong", NFe.default], ["subscript", RFe.default], ["superscript", _Fe.default], ["switch", AFe.default], ["tab", LFe.default], ["table", ZFe.default], ["tablist", TFe.default], ["tabpanel", BFe.default], ["term", IFe.default], ["textbox", HFe.default], ["time", DFe.default], ["timer", zFe.default], ["toolbar", FFe.default], ["tooltip", VFe.default], ["tree", qFe.default], ["treegrid", UFe.default], ["treeitem", WFe.default]], KFe = GFe;
t0.default = KFe;
var Ss = {}, Ns = {};
Object.defineProperty(Ns, "__esModule", {
  value: !0
});
Ns.default = void 0;
var YFe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "abstract [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, XFe = YFe;
Ns.default = XFe;
var Rs = {};
Object.defineProperty(Rs, "__esModule", {
  value: !0
});
Rs.default = void 0;
var QFe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "acknowledgments [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, JFe = QFe;
Rs.default = JFe;
var _s = {};
Object.defineProperty(_s, "__esModule", {
  value: !0
});
_s.default = void 0;
var eVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "afterword [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, tVe = eVe;
_s.default = tVe;
var As = {};
Object.defineProperty(As, "__esModule", {
  value: !0
});
As.default = void 0;
var nVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "appendix [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, rVe = nVe;
As.default = rVe;
var Ls = {};
Object.defineProperty(Ls, "__esModule", {
  value: !0
});
Ls.default = void 0;
var aVe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "content"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "referrer [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
}, lVe = aVe;
Ls.default = lVe;
var Zs = {};
Object.defineProperty(Zs, "__esModule", {
  value: !0
});
Zs.default = void 0;
var iVe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "EPUB biblioentry [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: ["doc-bibliography"],
  requiredContextRole: ["doc-bibliography"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "listitem"]]
}, oVe = iVe;
Zs.default = oVe;
var Ts = {};
Object.defineProperty(Ts, "__esModule", {
  value: !0
});
Ts.default = void 0;
var sVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "bibliography [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["doc-biblioentry"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, cVe = sVe;
Ts.default = cVe;
var Bs = {};
Object.defineProperty(Bs, "__esModule", {
  value: !0
});
Bs.default = void 0;
var uVe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "biblioref [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
}, fVe = uVe;
Bs.default = fVe;
var Is = {};
Object.defineProperty(Is, "__esModule", {
  value: !0
});
Is.default = void 0;
var dVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "chapter [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, pVe = dVe;
Is.default = pVe;
var Hs = {};
Object.defineProperty(Hs, "__esModule", {
  value: !0
});
Hs.default = void 0;
var gVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "colophon [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, hVe = gVe;
Hs.default = hVe;
var Ds = {};
Object.defineProperty(Ds, "__esModule", {
  value: !0
});
Ds.default = void 0;
var mVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "conclusion [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, vVe = mVe;
Ds.default = vVe;
var zs = {};
Object.defineProperty(zs, "__esModule", {
  value: !0
});
zs.default = void 0;
var bVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "cover [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "img"]]
}, yVe = bVe;
zs.default = yVe;
var Fs = {};
Object.defineProperty(Fs, "__esModule", {
  value: !0
});
Fs.default = void 0;
var wVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "credit [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, OVe = wVe;
Fs.default = OVe;
var Vs = {};
Object.defineProperty(Vs, "__esModule", {
  value: !0
});
Vs.default = void 0;
var xVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "credits [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, EVe = xVe;
Vs.default = EVe;
var qs = {};
Object.defineProperty(qs, "__esModule", {
  value: !0
});
qs.default = void 0;
var $Ve = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "dedication [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, jVe = $Ve;
qs.default = jVe;
var Us = {};
Object.defineProperty(Us, "__esModule", {
  value: !0
});
Us.default = void 0;
var CVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "rearnote [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: ["doc-endnotes"],
  requiredContextRole: ["doc-endnotes"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "listitem"]]
}, MVe = CVe;
Us.default = MVe;
var Ws = {};
Object.defineProperty(Ws, "__esModule", {
  value: !0
});
Ws.default = void 0;
var kVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "rearnotes [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["doc-endnote"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, PVe = kVe;
Ws.default = PVe;
var Gs = {};
Object.defineProperty(Gs, "__esModule", {
  value: !0
});
Gs.default = void 0;
var SVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "epigraph [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, NVe = SVe;
Gs.default = NVe;
var Ks = {};
Object.defineProperty(Ks, "__esModule", {
  value: !0
});
Ks.default = void 0;
var RVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "epilogue [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, _Ve = RVe;
Ks.default = _Ve;
var Ys = {};
Object.defineProperty(Ys, "__esModule", {
  value: !0
});
Ys.default = void 0;
var AVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "errata [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, LVe = AVe;
Ys.default = LVe;
var Xs = {};
Object.defineProperty(Xs, "__esModule", {
  value: !0
});
Xs.default = void 0;
var ZVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, TVe = ZVe;
Xs.default = TVe;
var Qs = {};
Object.defineProperty(Qs, "__esModule", {
  value: !0
});
Qs.default = void 0;
var BVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "footnote [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, IVe = BVe;
Qs.default = IVe;
var Js = {};
Object.defineProperty(Js, "__esModule", {
  value: !0
});
Js.default = void 0;
var HVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "foreword [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, DVe = HVe;
Js.default = DVe;
var ec = {};
Object.defineProperty(ec, "__esModule", {
  value: !0
});
ec.default = void 0;
var zVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "glossary [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["definition"], ["term"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, FVe = zVe;
ec.default = FVe;
var tc = {};
Object.defineProperty(tc, "__esModule", {
  value: !0
});
tc.default = void 0;
var VVe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "glossref [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
}, qVe = VVe;
tc.default = qVe;
var nc = {};
Object.defineProperty(nc, "__esModule", {
  value: !0
});
nc.default = void 0;
var UVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "index [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
}, WVe = UVe;
nc.default = WVe;
var rc = {};
Object.defineProperty(rc, "__esModule", {
  value: !0
});
rc.default = void 0;
var GVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "introduction [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, KVe = GVe;
rc.default = KVe;
var ac = {};
Object.defineProperty(ac, "__esModule", {
  value: !0
});
ac.default = void 0;
var YVe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "noteref [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
}, XVe = YVe;
ac.default = XVe;
var lc = {};
Object.defineProperty(lc, "__esModule", {
  value: !0
});
lc.default = void 0;
var QVe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "notice [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "note"]]
}, JVe = QVe;
lc.default = JVe;
var ic = {};
Object.defineProperty(ic, "__esModule", {
  value: !0
});
ic.default = void 0;
var eqe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "pagebreak [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "separator"]]
}, tqe = eqe;
ic.default = tqe;
var oc = {};
Object.defineProperty(oc, "__esModule", {
  value: !0
});
oc.default = void 0;
var nqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "page-list [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
}, rqe = nqe;
oc.default = rqe;
var sc = {};
Object.defineProperty(sc, "__esModule", {
  value: !0
});
sc.default = void 0;
var aqe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "part [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, lqe = aqe;
sc.default = lqe;
var cc = {};
Object.defineProperty(cc, "__esModule", {
  value: !0
});
cc.default = void 0;
var iqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "preface [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, oqe = iqe;
cc.default = oqe;
var uc = {};
Object.defineProperty(uc, "__esModule", {
  value: !0
});
uc.default = void 0;
var sqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "prologue [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
}, cqe = sqe;
uc.default = cqe;
var fc = {};
Object.defineProperty(fc, "__esModule", {
  value: !0
});
fc.default = void 0;
var uqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "pullquote [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["none"]]
}, fqe = uqe;
fc.default = fqe;
var dc = {};
Object.defineProperty(dc, "__esModule", {
  value: !0
});
dc.default = void 0;
var dqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "qna [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
}, pqe = dqe;
dc.default = pqe;
var pc = {};
Object.defineProperty(pc, "__esModule", {
  value: !0
});
pc.default = void 0;
var gqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "subtitle [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "sectionhead"]]
}, hqe = gqe;
pc.default = hqe;
var gc = {};
Object.defineProperty(gc, "__esModule", {
  value: !0
});
gc.default = void 0;
var mqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "help [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "note"]]
}, vqe = mqe;
gc.default = vqe;
var hc = {};
Object.defineProperty(hc, "__esModule", {
  value: !0
});
hc.default = void 0;
var bqe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "toc [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
}, yqe = bqe;
hc.default = yqe;
Object.defineProperty(Ss, "__esModule", {
  value: !0
});
Ss.default = void 0;
var wqe = st(Ns), Oqe = st(Rs), xqe = st(_s), Eqe = st(As), $qe = st(Ls), jqe = st(Zs), Cqe = st(Ts), Mqe = st(Bs), kqe = st(Is), Pqe = st(Hs), Sqe = st(Ds), Nqe = st(zs), Rqe = st(Fs), _qe = st(Vs), Aqe = st(qs), Lqe = st(Us), Zqe = st(Ws), Tqe = st(Gs), Bqe = st(Ks), Iqe = st(Ys), Hqe = st(Xs), Dqe = st(Qs), zqe = st(Js), Fqe = st(ec), Vqe = st(tc), qqe = st(nc), Uqe = st(rc), Wqe = st(ac), Gqe = st(lc), Kqe = st(ic), Yqe = st(oc), Xqe = st(sc), Qqe = st(cc), Jqe = st(uc), eUe = st(fc), tUe = st(dc), nUe = st(pc), rUe = st(gc), aUe = st(hc);
function st(e) {
  return e && e.__esModule ? e : { default: e };
}
var lUe = [["doc-abstract", wqe.default], ["doc-acknowledgments", Oqe.default], ["doc-afterword", xqe.default], ["doc-appendix", Eqe.default], ["doc-backlink", $qe.default], ["doc-biblioentry", jqe.default], ["doc-bibliography", Cqe.default], ["doc-biblioref", Mqe.default], ["doc-chapter", kqe.default], ["doc-colophon", Pqe.default], ["doc-conclusion", Sqe.default], ["doc-cover", Nqe.default], ["doc-credit", Rqe.default], ["doc-credits", _qe.default], ["doc-dedication", Aqe.default], ["doc-endnote", Lqe.default], ["doc-endnotes", Zqe.default], ["doc-epigraph", Tqe.default], ["doc-epilogue", Bqe.default], ["doc-errata", Iqe.default], ["doc-example", Hqe.default], ["doc-footnote", Dqe.default], ["doc-foreword", zqe.default], ["doc-glossary", Fqe.default], ["doc-glossref", Vqe.default], ["doc-index", qqe.default], ["doc-introduction", Uqe.default], ["doc-noteref", Wqe.default], ["doc-notice", Gqe.default], ["doc-pagebreak", Kqe.default], ["doc-pagelist", Yqe.default], ["doc-part", Xqe.default], ["doc-preface", Qqe.default], ["doc-prologue", Jqe.default], ["doc-pullquote", eUe.default], ["doc-qna", tUe.default], ["doc-subtitle", nUe.default], ["doc-tip", rUe.default], ["doc-toc", aUe.default]], iUe = lUe;
Ss.default = iUe;
var mc = {}, vc = {};
Object.defineProperty(vc, "__esModule", {
  value: !0
});
vc.default = void 0;
var oUe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    module: "GRAPHICS",
    concept: {
      name: "graphics-object"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "img"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "article"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "document"]]
}, sUe = oUe;
vc.default = sUe;
var bc = {};
Object.defineProperty(bc, "__esModule", {
  value: !0
});
bc.default = void 0;
var cUe = {
  abstract: !1,
  accessibleNameRequired: !1,
  baseConcepts: [],
  childrenPresentational: !1,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    module: "GRAPHICS",
    concept: {
      name: "graphics-document"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "group"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "img"
    }
  }, {
    module: "GRAPHICS",
    concept: {
      name: "graphics-symbol"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "group"]]
}, uUe = cUe;
bc.default = uUe;
var yc = {};
Object.defineProperty(yc, "__esModule", {
  value: !0
});
yc.default = void 0;
var fUe = {
  abstract: !1,
  accessibleNameRequired: !0,
  baseConcepts: [],
  childrenPresentational: !0,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "img"]]
}, dUe = fUe;
yc.default = dUe;
Object.defineProperty(mc, "__esModule", {
  value: !0
});
mc.default = void 0;
var pUe = _y(vc), gUe = _y(bc), hUe = _y(yc);
function _y(e) {
  return e && e.__esModule ? e : { default: e };
}
var mUe = [["graphics-document", pUe.default], ["graphics-object", gUe.default], ["graphics-symbol", hUe.default]], vUe = mUe;
mc.default = vUe;
Object.defineProperty(ql, "__esModule", {
  value: !0
});
ql.default = void 0;
var bUe = Fi(z1), yUe = Fi(t0), wUe = Fi(Ss), OUe = Fi(mc), xUe = Fi(Da);
function Fi(e) {
  return e && e.__esModule ? e : { default: e };
}
function EUe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function d9(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = bde(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, l = function() {
      };
      return { s: l, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(h) {
        throw h;
      }, f: l };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, c = !1, f;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var h = n.next();
    return i = h.done, h;
  }, e: function(h) {
    c = !0, f = h;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (c)
        throw f;
    }
  } };
}
function wi(e, t) {
  return CUe(e) || jUe(e, t) || bde(e, t) || $Ue();
}
function $Ue() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bde(e, t) {
  if (e) {
    if (typeof e == "string")
      return e1e(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return e1e(e, t);
  }
}
function e1e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jUe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, i = !1, c, f;
    try {
      for (n = n.call(e); !(l = (c = n.next()).done) && (r.push(c.value), !(t && r.length === t)); l = !0)
        ;
    } catch (d) {
      i = !0, f = d;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (i)
          throw f;
      }
    }
    return r;
  }
}
function CUe(e) {
  if (Array.isArray(e))
    return e;
}
var Xr = [].concat(bUe.default, yUe.default, wUe.default, OUe.default);
Xr.forEach(function(e) {
  var t = wi(e, 2), n = t[1], r = d9(n.superClass), l;
  try {
    for (r.s(); !(l = r.n()).done; ) {
      var i = l.value, c = d9(i), f;
      try {
        var d = function() {
          var g = f.value, m = Xr.find(function(R) {
            var M = wi(R, 1), P = M[0];
            return P === g;
          });
          if (m)
            for (var y = m[1], w = 0, C = Object.keys(y.props); w < C.length; w++) {
              var E = C[w];
              Object.prototype.hasOwnProperty.call(n.props, E) || Object.assign(n.props, EUe({}, E, y.props[E]));
            }
        };
        for (c.s(); !(f = c.n()).done; )
          d();
      } catch (h) {
        c.e(h);
      } finally {
        c.f();
      }
    }
  } catch (h) {
    r.e(h);
  } finally {
    r.f();
  }
});
var p9 = {
  entries: function() {
    return Xr;
  },
  forEach: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = d9(Xr), l;
    try {
      for (r.s(); !(l = r.n()).done; ) {
        var i = wi(l.value, 2), c = i[0], f = i[1];
        t.call(n, f, c, Xr);
      }
    } catch (d) {
      r.e(d);
    } finally {
      r.f();
    }
  },
  get: function(t) {
    var n = Xr.find(function(r) {
      return r[0] === t;
    });
    return n && n[1];
  },
  has: function(t) {
    return !!p9.get(t);
  },
  keys: function() {
    return Xr.map(function(t) {
      var n = wi(t, 1), r = n[0];
      return r;
    });
  },
  values: function() {
    return Xr.map(function(t) {
      var n = wi(t, 2), r = n[1];
      return r;
    });
  }
}, MUe = (0, xUe.default)(p9, p9.entries());
ql.default = MUe;
var wc = {}, kUe = Zi(), PUe = ece, SUe = function() {
  var t = PUe();
  return kUe(
    Object,
    { assign: t },
    { assign: function() {
      return Object.assign !== t;
    } }
  ), t;
}, NUe = Zi(), RUe = U9, _Ue = Age, yde = ece, AUe = SUe, LUe = RUe.apply(yde()), wde = function(t, n) {
  return LUe(Object, arguments);
};
NUe(wde, {
  getPolyfill: yde,
  implementation: _Ue,
  shim: AUe
});
var ZUe = wde, Ai = function() {
  return typeof (function() {
  }).name == "string";
}, Oi = Object.getOwnPropertyDescriptor;
if (Oi)
  try {
    Oi([], "length");
  } catch {
    Oi = null;
  }
Ai.functionsHaveConfigurableNames = function() {
  if (!Ai() || !Oi)
    return !1;
  var t = Oi(function() {
  }, "name");
  return !!t && !!t.configurable;
};
var TUe = Function.prototype.bind;
Ai.boundFunctionsHaveNames = function() {
  return Ai() && typeof TUe == "function" && (function() {
  }).bind().name !== "";
};
var BUe = Ai, t1e = Bge, IUe = Tge(), HUe = BUe.functionsHaveConfigurableNames(), DUe = TypeError, zUe = function(t, n) {
  if (typeof t != "function")
    throw new DUe("`fn` is not a function");
  var r = arguments.length > 2 && !!arguments[2];
  return (!r || HUe) && (IUe ? t1e(t, "name", n, !0, !0) : t1e(t, "name", n)), t;
}, FUe = zUe, VUe = W9, qUe = Object, Ode = FUe(function() {
  if (this == null || this !== qUe(this))
    throw new VUe("RegExp.prototype.flags getter called on non-object");
  var t = "";
  return this.hasIndices && (t += "d"), this.global && (t += "g"), this.ignoreCase && (t += "i"), this.multiline && (t += "m"), this.dotAll && (t += "s"), this.unicode && (t += "u"), this.unicodeSets && (t += "v"), this.sticky && (t += "y"), t;
}, "get flags", !0), UUe = Ode, WUe = Zi().supportsDescriptors, GUe = Object.getOwnPropertyDescriptor, xde = function() {
  if (WUe && /a/mig.flags === "gim") {
    var t = GUe(RegExp.prototype, "flags");
    if (t && typeof t.get == "function" && typeof RegExp.prototype.dotAll == "boolean" && typeof RegExp.prototype.hasIndices == "boolean") {
      var n = "", r = {};
      if (Object.defineProperty(r, "hasIndices", {
        get: function() {
          n += "d";
        }
      }), Object.defineProperty(r, "sticky", {
        get: function() {
          n += "y";
        }
      }), n === "dy")
        return t.get;
    }
  }
  return UUe;
}, KUe = Zi().supportsDescriptors, YUe = xde, XUe = Object.getOwnPropertyDescriptor, QUe = Object.defineProperty, JUe = TypeError, n1e = Object.getPrototypeOf, eWe = /a/, tWe = function() {
  if (!KUe || !n1e)
    throw new JUe("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
  var t = YUe(), n = n1e(eWe), r = XUe(n, "flags");
  return (!r || r.get !== t) && QUe(n, "flags", {
    configurable: !0,
    enumerable: !1,
    get: t
  }), t;
}, nWe = Zi(), rWe = U9, aWe = Ode, Ede = xde, lWe = tWe, $de = rWe(Ede());
nWe($de, {
  getPolyfill: Ede,
  implementation: aWe,
  shim: lWe
});
var iWe = $de, jo = { exports: {} };
const oWe = {}, sWe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oWe
}, Symbol.toStringTag, { value: "Module" })), cWe = /* @__PURE__ */ Upe(sWe);
var Ay = typeof Map == "function" && Map.prototype, ju = Object.getOwnPropertyDescriptor && Ay ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, e1 = Ay && ju && typeof ju.get == "function" ? ju.get : null, r1e = Ay && Map.prototype.forEach, Ly = typeof Set == "function" && Set.prototype, Cu = Object.getOwnPropertyDescriptor && Ly ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, t1 = Ly && Cu && typeof Cu.get == "function" ? Cu.get : null, a1e = Ly && Set.prototype.forEach, uWe = typeof WeakMap == "function" && WeakMap.prototype, xi = uWe ? WeakMap.prototype.has : null, fWe = typeof WeakSet == "function" && WeakSet.prototype, Ei = fWe ? WeakSet.prototype.has : null, dWe = typeof WeakRef == "function" && WeakRef.prototype, l1e = dWe ? WeakRef.prototype.deref : null, pWe = Boolean.prototype.valueOf, gWe = Object.prototype.toString, hWe = Function.prototype.toString, mWe = String.prototype.match, Zy = String.prototype.slice, ra = String.prototype.replace, vWe = String.prototype.toUpperCase, i1e = String.prototype.toLowerCase, jde = RegExp.prototype.test, o1e = Array.prototype.concat, xr = Array.prototype.join, bWe = Array.prototype.slice, s1e = Math.floor, g9 = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Mu = Object.getOwnPropertySymbols, h9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, xl = typeof Symbol == "function" && typeof Symbol.iterator == "object", sn = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === xl || "symbol") ? Symbol.toStringTag : null, Cde = Object.prototype.propertyIsEnumerable, c1e = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function u1e(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || jde.call(/e/, t))
    return t;
  var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var r = e < 0 ? -s1e(-e) : s1e(e);
    if (r !== e) {
      var l = String(r), i = Zy.call(t, l.length + 1);
      return ra.call(l, n, "$&_") + "." + ra.call(ra.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ra.call(t, n, "$&_");
}
var m9 = cWe, f1e = m9.custom, d1e = kde(f1e) ? f1e : null, yWe = function e(t, n, r, l) {
  var i = n || {};
  if (Qr(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (Qr(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var c = Qr(i, "customInspect") ? i.customInspect : !0;
  if (typeof c != "boolean" && c !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (Qr(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (Qr(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var f = i.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return Sde(t, i);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var d = String(t);
    return f ? u1e(t, d) : d;
  }
  if (typeof t == "bigint") {
    var h = String(t) + "n";
    return f ? u1e(t, h) : h;
  }
  var g = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof r > "u" && (r = 0), r >= g && g > 0 && typeof t == "object")
    return v9(t) ? "[Array]" : "[Object]";
  var m = TWe(i, r);
  if (typeof l > "u")
    l = [];
  else if (Pde(l, t) >= 0)
    return "[Circular]";
  function y(A, Z, G) {
    if (Z && (l = bWe.call(l), l.push(Z)), G) {
      var I = {
        depth: i.depth
      };
      return Qr(i, "quoteStyle") && (I.quoteStyle = i.quoteStyle), e(A, I, r + 1, l);
    }
    return e(A, i, r + 1, l);
  }
  if (typeof t == "function" && !p1e(t)) {
    var w = kWe(t), C = fo(t, y);
    return "[Function" + (w ? ": " + w : " (anonymous)") + "]" + (C.length > 0 ? " { " + xr.call(C, ", ") + " }" : "");
  }
  if (kde(t)) {
    var E = xl ? ra.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : h9.call(t);
    return typeof t == "object" && !xl ? si(E) : E;
  }
  if (AWe(t)) {
    for (var R = "<" + i1e.call(String(t.nodeName)), M = t.attributes || [], P = 0; P < M.length; P++)
      R += " " + M[P].name + "=" + Mde(wWe(M[P].value), "double", i);
    return R += ">", t.childNodes && t.childNodes.length && (R += "..."), R += "</" + i1e.call(String(t.nodeName)) + ">", R;
  }
  if (v9(t)) {
    if (t.length === 0)
      return "[]";
    var a = fo(t, y);
    return m && !ZWe(a) ? "[" + b9(a, m) + "]" : "[ " + xr.call(a, ", ") + " ]";
  }
  if (xWe(t)) {
    var o = fo(t, y);
    return !("cause" in Error.prototype) && "cause" in t && !Cde.call(t, "cause") ? "{ [" + String(t) + "] " + xr.call(o1e.call("[cause]: " + y(t.cause), o), ", ") + " }" : o.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + xr.call(o, ", ") + " }";
  }
  if (typeof t == "object" && c) {
    if (d1e && typeof t[d1e] == "function" && m9)
      return m9(t, { depth: g - r });
    if (c !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (PWe(t)) {
    var s = [];
    return r1e && r1e.call(t, function(A, Z) {
      s.push(y(Z, t, !0) + " => " + y(A, t));
    }), g1e("Map", e1.call(t), s, m);
  }
  if (RWe(t)) {
    var p = [];
    return a1e && a1e.call(t, function(A) {
      p.push(y(A, t));
    }), g1e("Set", t1.call(t), p, m);
  }
  if (SWe(t))
    return ku("WeakMap");
  if (_We(t))
    return ku("WeakSet");
  if (NWe(t))
    return ku("WeakRef");
  if ($We(t))
    return si(y(Number(t)));
  if (CWe(t))
    return si(y(g9.call(t)));
  if (jWe(t))
    return si(pWe.call(t));
  if (EWe(t))
    return si(y(String(t)));
  if (typeof window < "u" && t === window)
    return "{ [object Window] }";
  if (t === pe)
    return "{ [object globalThis] }";
  if (!OWe(t) && !p1e(t)) {
    var O = fo(t, y), x = c1e ? c1e(t) === Object.prototype : t instanceof Object || t.constructor === Object, N = t instanceof Object ? "" : "null prototype", T = !x && sn && Object(t) === t && sn in t ? Zy.call(ba(t), 8, -1) : N ? "Object" : "", $ = x || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", j = $ + (T || N ? "[" + xr.call(o1e.call([], T || [], N || []), ": ") + "] " : "");
    return O.length === 0 ? j + "{}" : m ? j + "{" + b9(O, m) + "}" : j + "{ " + xr.call(O, ", ") + " }";
  }
  return String(t);
};
function Mde(e, t, n) {
  var r = (n.quoteStyle || t) === "double" ? '"' : "'";
  return r + e + r;
}
function wWe(e) {
  return ra.call(String(e), /"/g, "&quot;");
}
function v9(e) {
  return ba(e) === "[object Array]" && (!sn || !(typeof e == "object" && sn in e));
}
function OWe(e) {
  return ba(e) === "[object Date]" && (!sn || !(typeof e == "object" && sn in e));
}
function p1e(e) {
  return ba(e) === "[object RegExp]" && (!sn || !(typeof e == "object" && sn in e));
}
function xWe(e) {
  return ba(e) === "[object Error]" && (!sn || !(typeof e == "object" && sn in e));
}
function EWe(e) {
  return ba(e) === "[object String]" && (!sn || !(typeof e == "object" && sn in e));
}
function $We(e) {
  return ba(e) === "[object Number]" && (!sn || !(typeof e == "object" && sn in e));
}
function jWe(e) {
  return ba(e) === "[object Boolean]" && (!sn || !(typeof e == "object" && sn in e));
}
function kde(e) {
  if (xl)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !h9)
    return !1;
  try {
    return h9.call(e), !0;
  } catch {
  }
  return !1;
}
function CWe(e) {
  if (!e || typeof e != "object" || !g9)
    return !1;
  try {
    return g9.call(e), !0;
  } catch {
  }
  return !1;
}
var MWe = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function Qr(e, t) {
  return MWe.call(e, t);
}
function ba(e) {
  return gWe.call(e);
}
function kWe(e) {
  if (e.name)
    return e.name;
  var t = mWe.call(hWe.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function Pde(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var n = 0, r = e.length; n < r; n++)
    if (e[n] === t)
      return n;
  return -1;
}
function PWe(e) {
  if (!e1 || !e || typeof e != "object")
    return !1;
  try {
    e1.call(e);
    try {
      t1.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function SWe(e) {
  if (!xi || !e || typeof e != "object")
    return !1;
  try {
    xi.call(e, xi);
    try {
      Ei.call(e, Ei);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function NWe(e) {
  if (!l1e || !e || typeof e != "object")
    return !1;
  try {
    return l1e.call(e), !0;
  } catch {
  }
  return !1;
}
function RWe(e) {
  if (!t1 || !e || typeof e != "object")
    return !1;
  try {
    t1.call(e);
    try {
      e1.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function _We(e) {
  if (!Ei || !e || typeof e != "object")
    return !1;
  try {
    Ei.call(e, Ei);
    try {
      xi.call(e, xi);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function AWe(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function Sde(e, t) {
  if (e.length > t.maxStringLength) {
    var n = e.length - t.maxStringLength, r = "... " + n + " more character" + (n > 1 ? "s" : "");
    return Sde(Zy.call(e, 0, t.maxStringLength), t) + r;
  }
  var l = ra.call(ra.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, LWe);
  return Mde(l, "single", t);
}
function LWe(e) {
  var t = e.charCodeAt(0), n = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + vWe.call(t.toString(16));
}
function si(e) {
  return "Object(" + e + ")";
}
function ku(e) {
  return e + " { ? }";
}
function g1e(e, t, n, r) {
  var l = r ? b9(n, r) : xr.call(n, ", ");
  return e + " (" + t + ") {" + l + "}";
}
function ZWe(e) {
  for (var t = 0; t < e.length; t++)
    if (Pde(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function TWe(e, t) {
  var n;
  if (e.indent === "	")
    n = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    n = xr.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: n,
    prev: xr.call(Array(t + 1), n)
  };
}
function b9(e, t) {
  if (e.length === 0)
    return "";
  var n = `
` + t.prev + t.base;
  return n + xr.call(e, "," + n) + `
` + t.prev;
}
function fo(e, t) {
  var n = v9(e), r = [];
  if (n) {
    r.length = e.length;
    for (var l = 0; l < e.length; l++)
      r[l] = Qr(e, l) ? t(e[l], e) : "";
  }
  var i = typeof Mu == "function" ? Mu(e) : [], c;
  if (xl) {
    c = {};
    for (var f = 0; f < i.length; f++)
      c["$" + i[f]] = i[f];
  }
  for (var d in e)
    Qr(e, d) && (n && String(Number(d)) === d && d < e.length || xl && c["$" + d] instanceof Symbol || (jde.call(/[^\w$]/, d) ? r.push(t(d, e) + ": " + t(e[d], e)) : r.push(d + ": " + t(e[d], e))));
  if (typeof Mu == "function")
    for (var h = 0; h < i.length; h++)
      Cde.call(e, i[h]) && r.push("[" + t(i[h]) + "]: " + t(e[i[h]], e));
  return r;
}
var Nde = Ti, Ul = Hr, BWe = yWe, IWe = W9, po = Nde("%WeakMap%", !0), go = Nde("%Map%", !0), HWe = Ul("WeakMap.prototype.get", !0), DWe = Ul("WeakMap.prototype.set", !0), zWe = Ul("WeakMap.prototype.has", !0), FWe = Ul("Map.prototype.get", !0), VWe = Ul("Map.prototype.set", !0), qWe = Ul("Map.prototype.has", !0), Ty = function(e, t) {
  for (var n = e, r; (r = n.next) !== null; n = r)
    if (r.key === t)
      return n.next = r.next, r.next = e.next, e.next = r, r;
}, UWe = function(e, t) {
  var n = Ty(e, t);
  return n && n.value;
}, WWe = function(e, t, n) {
  var r = Ty(e, t);
  r ? r.value = n : e.next = {
    // eslint-disable-line no-param-reassign
    key: t,
    next: e.next,
    value: n
  };
}, GWe = function(e, t) {
  return !!Ty(e, t);
}, Rde = function() {
  var t, n, r, l = {
    assert: function(i) {
      if (!l.has(i))
        throw new IWe("Side channel does not contain " + BWe(i));
    },
    get: function(i) {
      if (po && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return HWe(t, i);
      } else if (go) {
        if (n)
          return FWe(n, i);
      } else if (r)
        return UWe(r, i);
    },
    has: function(i) {
      if (po && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return zWe(t, i);
      } else if (go) {
        if (n)
          return qWe(n, i);
      } else if (r)
        return GWe(r, i);
      return !1;
    },
    set: function(i, c) {
      po && i && (typeof i == "object" || typeof i == "function") ? (t || (t = new po()), DWe(t, i, c)) : go ? (n || (n = new go()), VWe(n, i, c)) : (r || (r = { key: {}, next: null }), WWe(r, i, c));
    }
  };
  return l;
}, KWe = Ige, ci = Rde(), _r = W9, By = {
  assert: function(e, t) {
    if (!e || typeof e != "object" && typeof e != "function")
      throw new _r("`O` is not an object");
    if (typeof t != "string")
      throw new _r("`slot` must be a string");
    if (ci.assert(e), !By.has(e, t))
      throw new _r("`" + t + "` is not present on `O`");
  },
  get: function(e, t) {
    if (!e || typeof e != "object" && typeof e != "function")
      throw new _r("`O` is not an object");
    if (typeof t != "string")
      throw new _r("`slot` must be a string");
    var n = ci.get(e);
    return n && n["$" + t];
  },
  has: function(e, t) {
    if (!e || typeof e != "object" && typeof e != "function")
      throw new _r("`O` is not an object");
    if (typeof t != "string")
      throw new _r("`slot` must be a string");
    var n = ci.get(e);
    return !!n && KWe(n, "$" + t);
  },
  set: function(e, t, n) {
    if (!e || typeof e != "object" && typeof e != "function")
      throw new _r("`O` is not an object");
    if (typeof t != "string")
      throw new _r("`slot` must be a string");
    var r = ci.get(e);
    r || (r = {}, ci.set(e, r)), r["$" + t] = n;
  }
};
Object.freeze && Object.freeze(By);
var YWe = By, ui = YWe, XWe = SyntaxError, h1e = typeof StopIteration == "object" ? StopIteration : null, QWe = function(t) {
  if (!h1e)
    throw new XWe("this environment lacks StopIteration");
  ui.set(t, "[[Done]]", !1);
  var n = {
    next: function() {
      var l = ui.get(this, "[[Iterator]]"), i = ui.get(l, "[[Done]]");
      try {
        return {
          done: i,
          value: i ? void 0 : l.next()
        };
      } catch (c) {
        if (ui.set(l, "[[Done]]", !0), c !== h1e)
          throw c;
        return {
          done: !0,
          value: void 0
        };
      }
    }
  };
  return ui.set(n, "[[Iterator]]", t), n;
}, JWe = {}.toString, _de = Array.isArray || function(e) {
  return JWe.call(e) == "[object Array]";
}, eGe = String.prototype.valueOf, tGe = function(t) {
  try {
    return eGe.call(t), !0;
  } catch {
    return !1;
  }
}, nGe = Object.prototype.toString, rGe = "[object String]", aGe = Bi(), Ade = function(t) {
  return typeof t == "string" ? !0 : typeof t != "object" ? !1 : aGe ? tGe(t) : nGe.call(t) === rGe;
}, Iy = typeof Map == "function" && Map.prototype ? Map : null, lGe = typeof Set == "function" && Set.prototype ? Set : null, n1;
Iy || (n1 = function(t) {
  return !1;
});
var Lde = Iy ? Map.prototype.has : null, m1e = lGe ? Set.prototype.has : null;
!n1 && !Lde && (n1 = function(t) {
  return !1;
});
var Zde = n1 || function(t) {
  if (!t || typeof t != "object")
    return !1;
  try {
    if (Lde.call(t), m1e)
      try {
        m1e.call(t);
      } catch {
        return !0;
      }
    return t instanceof Iy;
  } catch {
  }
  return !1;
}, iGe = typeof Map == "function" && Map.prototype ? Map : null, Hy = typeof Set == "function" && Set.prototype ? Set : null, r1;
Hy || (r1 = function(t) {
  return !1;
});
var v1e = iGe ? Map.prototype.has : null, Tde = Hy ? Set.prototype.has : null;
!r1 && !Tde && (r1 = function(t) {
  return !1;
});
var Bde = r1 || function(t) {
  if (!t || typeof t != "object")
    return !1;
  try {
    if (Tde.call(t), v1e)
      try {
        v1e.call(t);
      } catch {
        return !0;
      }
    return t instanceof Hy;
  } catch {
  }
  return !1;
}, b1e = nce, y1e = QWe;
if (tce() || Hge()) {
  var Pu = Symbol.iterator;
  jo.exports = function(t) {
    if (t != null && typeof t[Pu] < "u")
      return t[Pu]();
    if (b1e(t))
      return Array.prototype[Pu].call(t);
  };
} else {
  var oGe = _de, sGe = Ade, w1e = Ti, cGe = w1e("%Map%", !0), uGe = w1e("%Set%", !0), Jn = Hr, O1e = Jn("Array.prototype.push"), x1e = Jn("String.prototype.charCodeAt"), fGe = Jn("String.prototype.slice"), dGe = function(t, n) {
    var r = t.length;
    if (n + 1 >= r)
      return n + 1;
    var l = x1e(t, n);
    if (l < 55296 || l > 56319)
      return n + 1;
    var i = x1e(t, n + 1);
    return i < 56320 || i > 57343 ? n + 1 : n + 2;
  }, Su = function(t) {
    var n = 0;
    return {
      next: function() {
        var l = n >= t.length, i;
        return l || (i = t[n], n += 1), {
          done: l,
          value: i
        };
      }
    };
  }, E1e = function(t, n) {
    if (oGe(t) || b1e(t))
      return Su(t);
    if (sGe(t)) {
      var r = 0;
      return {
        next: function() {
          var i = dGe(t, r), c = fGe(t, r, i);
          return r = i, {
            done: i > t.length,
            value: c
          };
        }
      };
    }
    if (n && typeof t["_es6-shim iterator_"] < "u")
      return t["_es6-shim iterator_"]();
  };
  if (!cGe && !uGe)
    jo.exports = function(t) {
      if (t != null)
        return E1e(t, !0);
    };
  else {
    var pGe = Zde, gGe = Bde, $1e = Jn("Map.prototype.forEach", !0), j1e = Jn("Set.prototype.forEach", !0);
    if (typeof In > "u" || !In.versions || !In.versions.node)
      var C1e = Jn("Map.prototype.iterator", !0), M1e = Jn("Set.prototype.iterator", !0);
    var k1e = Jn("Map.prototype.@@iterator", !0) || Jn("Map.prototype._es6-shim iterator_", !0), P1e = Jn("Set.prototype.@@iterator", !0) || Jn("Set.prototype._es6-shim iterator_", !0), hGe = function(t) {
      if (pGe(t)) {
        if (C1e)
          return y1e(C1e(t));
        if (k1e)
          return k1e(t);
        if ($1e) {
          var n = [];
          return $1e(t, function(l, i) {
            O1e(n, [i, l]);
          }), Su(n);
        }
      }
      if (gGe(t)) {
        if (M1e)
          return y1e(M1e(t));
        if (P1e)
          return P1e(t);
        if (j1e) {
          var r = [];
          return j1e(t, function(l) {
            O1e(r, l);
          }), Su(r);
        }
      }
    };
    jo.exports = function(t) {
      return hGe(t) || E1e(t);
    };
  }
}
var mGe = jo.exports, vGe = U9, Ide = Hr, bGe = Ti, y9 = bGe("%ArrayBuffer%", !0), Co = Ide("ArrayBuffer.prototype.byteLength", !0), yGe = Ide("Object.prototype.toString"), S1e = !!y9 && !Co && new y9(0).slice, N1e = !!S1e && vGe(S1e), Hde = Co || N1e ? function(t) {
  if (!t || typeof t != "object")
    return !1;
  try {
    return Co ? Co(t) : N1e(t, 0), !0;
  } catch {
    return !1;
  }
} : y9 ? function(t) {
  return yGe(t) === "[object ArrayBuffer]";
} : function(t) {
  return !1;
}, wGe = Date.prototype.getDay, OGe = function(t) {
  try {
    return wGe.call(t), !0;
  } catch {
    return !1;
  }
}, xGe = Object.prototype.toString, EGe = "[object Date]", $Ge = Bi(), jGe = function(t) {
  return typeof t != "object" || t === null ? !1 : $Ge ? OGe(t) : xGe.call(t) === EGe;
}, w9 = Hr, Dde = Bi(), zde, Fde, O9, x9;
if (Dde) {
  zde = w9("Object.prototype.hasOwnProperty"), Fde = w9("RegExp.prototype.exec"), O9 = {};
  var Nu = function() {
    throw O9;
  };
  x9 = {
    toString: Nu,
    valueOf: Nu
  }, typeof Symbol.toPrimitive == "symbol" && (x9[Symbol.toPrimitive] = Nu);
}
var CGe = w9("Object.prototype.toString"), MGe = Object.getOwnPropertyDescriptor, kGe = "[object RegExp]", PGe = Dde ? function(t) {
  if (!t || typeof t != "object")
    return !1;
  var n = MGe(t, "lastIndex"), r = n && zde(n, "value");
  if (!r)
    return !1;
  try {
    Fde(t, x9);
  } catch (l) {
    return l === O9;
  }
} : function(t) {
  return !t || typeof t != "object" && typeof t != "function" ? !1 : CGe(t) === kGe;
}, SGe = Hr, R1e = SGe("SharedArrayBuffer.prototype.byteLength", !0), NGe = R1e ? function(t) {
  if (!t || typeof t != "object")
    return !1;
  try {
    return R1e(t), !0;
  } catch {
    return !1;
  }
} : function(t) {
  return !1;
}, RGe = Number.prototype.toString, _Ge = function(t) {
  try {
    return RGe.call(t), !0;
  } catch {
    return !1;
  }
}, AGe = Object.prototype.toString, LGe = "[object Number]", ZGe = Bi(), TGe = function(t) {
  return typeof t == "number" ? !0 : typeof t != "object" ? !1 : ZGe ? _Ge(t) : AGe.call(t) === LGe;
}, Vde = Hr, BGe = Vde("Boolean.prototype.toString"), IGe = Vde("Object.prototype.toString"), HGe = function(t) {
  try {
    return BGe(t), !0;
  } catch {
    return !1;
  }
}, DGe = "[object Boolean]", zGe = Bi(), FGe = function(t) {
  return typeof t == "boolean" ? !0 : t === null || typeof t != "object" ? !1 : zGe && Symbol.toStringTag in t ? HGe(t) : IGe(t) === DGe;
}, E9 = { exports: {} }, VGe = Object.prototype.toString, qGe = tce();
if (qGe) {
  var UGe = Symbol.prototype.toString, WGe = /^Symbol\(.*\)$/, GGe = function(t) {
    return typeof t.valueOf() != "symbol" ? !1 : WGe.test(UGe.call(t));
  };
  E9.exports = function(t) {
    if (typeof t == "symbol")
      return !0;
    if (VGe.call(t) !== "[object Symbol]")
      return !1;
    try {
      return GGe(t);
    } catch {
      return !1;
    }
  };
} else
  E9.exports = function(t) {
    return !1;
  };
var KGe = E9.exports, $9 = { exports: {} }, _1e = typeof BigInt < "u" && BigInt, YGe = function() {
  return typeof _1e == "function" && typeof BigInt == "function" && typeof _1e(42) == "bigint" && typeof BigInt(42) == "bigint";
}, XGe = YGe();
if (XGe) {
  var QGe = BigInt.prototype.valueOf, JGe = function(t) {
    try {
      return QGe.call(t), !0;
    } catch {
    }
    return !1;
  };
  $9.exports = function(t) {
    return t === null || typeof t > "u" || typeof t == "boolean" || typeof t == "string" || typeof t == "number" || typeof t == "symbol" || typeof t == "function" ? !1 : typeof t == "bigint" ? !0 : JGe(t);
  };
} else
  $9.exports = function(t) {
    return !1;
  };
var eKe = $9.exports, tKe = Ade, nKe = TGe, rKe = FGe, aKe = KGe, lKe = eKe, iKe = function(t) {
  if (t == null || typeof t != "object" && typeof t != "function")
    return null;
  if (tKe(t))
    return "String";
  if (nKe(t))
    return "Number";
  if (rKe(t))
    return "Boolean";
  if (aKe(t))
    return "Symbol";
  if (lKe(t))
    return "BigInt";
}, a1 = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap : null, A1e = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet : null, l1;
a1 || (l1 = function(t) {
  return !1;
});
var j9 = a1 ? a1.prototype.has : null, Ru = A1e ? A1e.prototype.has : null;
!l1 && !j9 && (l1 = function(t) {
  return !1;
});
var oKe = l1 || function(t) {
  if (!t || typeof t != "object")
    return !1;
  try {
    if (j9.call(t, j9), Ru)
      try {
        Ru.call(t, Ru);
      } catch {
        return !0;
      }
    return t instanceof a1;
  } catch {
  }
  return !1;
}, C9 = { exports: {} }, sKe = Ti, qde = Hr, cKe = sKe("%WeakSet%", !0), _u = qde("WeakSet.prototype.has", !0);
if (_u) {
  var Au = qde("WeakMap.prototype.has", !0);
  C9.exports = function(t) {
    if (!t || typeof t != "object")
      return !1;
    try {
      if (_u(t, _u), Au)
        try {
          Au(t, Au);
        } catch {
          return !0;
        }
      return t instanceof cKe;
    } catch {
    }
    return !1;
  };
} else
  C9.exports = function(t) {
    return !1;
  };
var uKe = C9.exports, fKe = Zde, dKe = Bde, pKe = oKe, gKe = uKe, hKe = function(t) {
  if (t && typeof t == "object") {
    if (fKe(t))
      return "Map";
    if (dKe(t))
      return "Set";
    if (pKe(t))
      return "WeakMap";
    if (gKe(t))
      return "WeakSet";
  }
  return !1;
}, mKe = Hr, L1e = mKe("ArrayBuffer.prototype.byteLength", !0), vKe = Hde, bKe = function(t) {
  return vKe(t) ? L1e ? L1e(t) : t.byteLength : NaN;
}, Ude = ZUe, Sr = Hr, Z1e = iWe, yKe = Ti, El = mGe, wKe = Rde, T1e = Lge(), B1e = nce, I1e = _de, H1e = Hde, D1e = jGe, z1e = PGe, F1e = NGe, V1e = Zge, q1e = iKe, U1e = hKe, W1e = Dge, G1e = bKe, K1e = Sr("SharedArrayBuffer.prototype.byteLength", !0), Y1e = Sr("Date.prototype.getTime"), Lu = Object.getPrototypeOf, X1e = Sr("Object.prototype.toString"), i1 = yKe("%Set%", !0), M9 = Sr("Map.prototype.has", !0), o1 = Sr("Map.prototype.get", !0), Q1e = Sr("Map.prototype.size", !0), s1 = Sr("Set.prototype.add", !0), Wde = Sr("Set.prototype.delete", !0), c1 = Sr("Set.prototype.has", !0), Mo = Sr("Set.prototype.size", !0);
function J1e(e, t, n, r) {
  for (var l = El(e), i; (i = l.next()) && !i.done; )
    if (or(t, i.value, n, r))
      return Wde(e, i.value), !0;
  return !1;
}
function Gde(e) {
  if (typeof e > "u")
    return null;
  if (typeof e != "object")
    return typeof e == "symbol" ? !1 : typeof e == "string" || typeof e == "number" ? +e == +e : !0;
}
function OKe(e, t, n, r, l, i) {
  var c = Gde(n);
  if (c != null)
    return c;
  var f = o1(t, c), d = Ude({}, l, { strict: !1 });
  return typeof f > "u" && !M9(t, c) || !or(r, f, d, i) ? !1 : !M9(e, c) && or(r, f, d, i);
}
function xKe(e, t, n) {
  var r = Gde(n);
  return r ?? (c1(t, r) && !c1(e, r));
}
function e0e(e, t, n, r, l, i) {
  for (var c = El(e), f, d; (f = c.next()) && !f.done; )
    if (d = f.value, // eslint-disable-next-line no-use-before-define
    or(n, d, l, i) && or(r, o1(t, d), l, i))
      return Wde(e, d), !0;
  return !1;
}
function or(e, t, n, r) {
  var l = n || {};
  if (l.strict ? T1e(e, t) : e === t)
    return !0;
  var i = q1e(e), c = q1e(t);
  if (i !== c)
    return !1;
  if (!e || !t || typeof e != "object" && typeof t != "object")
    return l.strict ? T1e(e, t) : e == t;
  var f = r.has(e), d = r.has(t), h;
  if (f && d) {
    if (r.get(e) === r.get(t))
      return !0;
  } else
    h = {};
  return f || r.set(e, h), d || r.set(t, h), jKe(e, t, l, r);
}
function t0e(e) {
  return !e || typeof e != "object" || typeof e.length != "number" || typeof e.copy != "function" || typeof e.slice != "function" || e.length > 0 && typeof e[0] != "number" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}
function EKe(e, t, n, r) {
  if (Mo(e) !== Mo(t))
    return !1;
  for (var l = El(e), i = El(t), c, f, d; (c = l.next()) && !c.done; )
    if (c.value && typeof c.value == "object")
      d || (d = new i1()), s1(d, c.value);
    else if (!c1(t, c.value)) {
      if (n.strict || !xKe(e, t, c.value))
        return !1;
      d || (d = new i1()), s1(d, c.value);
    }
  if (d) {
    for (; (f = i.next()) && !f.done; )
      if (f.value && typeof f.value == "object") {
        if (!J1e(d, f.value, n.strict, r))
          return !1;
      } else if (!n.strict && !c1(e, f.value) && !J1e(d, f.value, n.strict, r))
        return !1;
    return Mo(d) === 0;
  }
  return !0;
}
function $Ke(e, t, n, r) {
  if (Q1e(e) !== Q1e(t))
    return !1;
  for (var l = El(e), i = El(t), c, f, d, h, g, m; (c = l.next()) && !c.done; )
    if (h = c.value[0], g = c.value[1], h && typeof h == "object")
      d || (d = new i1()), s1(d, h);
    else if (m = o1(t, h), typeof m > "u" && !M9(t, h) || !or(g, m, n, r)) {
      if (n.strict || !OKe(e, t, h, g, n, r))
        return !1;
      d || (d = new i1()), s1(d, h);
    }
  if (d) {
    for (; (f = i.next()) && !f.done; )
      if (h = f.value[0], m = f.value[1], h && typeof h == "object") {
        if (!e0e(d, e, h, m, n, r))
          return !1;
      } else if (!n.strict && (!e.has(h) || !or(o1(e, h), m, n, r)) && !e0e(d, e, h, m, Ude({}, n, { strict: !1 }), r))
        return !1;
    return Mo(d) === 0;
  }
  return !0;
}
function jKe(e, t, n, r) {
  var l, i;
  if (typeof e != typeof t || e == null || t == null || X1e(e) !== X1e(t) || B1e(e) !== B1e(t))
    return !1;
  var c = I1e(e), f = I1e(t);
  if (c !== f)
    return !1;
  var d = e instanceof Error, h = t instanceof Error;
  if (d !== h || (d || h) && (e.name !== t.name || e.message !== t.message))
    return !1;
  var g = z1e(e), m = z1e(t);
  if (g !== m || (g || m) && (e.source !== t.source || Z1e(e) !== Z1e(t)))
    return !1;
  var y = D1e(e), w = D1e(t);
  if (y !== w || (y || w) && Y1e(e) !== Y1e(t) || n.strict && Lu && Lu(e) !== Lu(t))
    return !1;
  var C = W1e(e), E = W1e(t);
  if (C !== E)
    return !1;
  if (C || E) {
    if (e.length !== t.length)
      return !1;
    for (l = 0; l < e.length; l++)
      if (e[l] !== t[l])
        return !1;
    return !0;
  }
  var R = t0e(e), M = t0e(t);
  if (R !== M)
    return !1;
  if (R || M) {
    if (e.length !== t.length)
      return !1;
    for (l = 0; l < e.length; l++)
      if (e[l] !== t[l])
        return !1;
    return !0;
  }
  var P = H1e(e), a = H1e(t);
  if (P !== a)
    return !1;
  if (P || a)
    return G1e(e) !== G1e(t) ? !1 : typeof Uint8Array == "function" && or(new Uint8Array(e), new Uint8Array(t), n, r);
  var o = F1e(e), s = F1e(t);
  if (o !== s)
    return !1;
  if (o || s)
    return K1e(e) !== K1e(t) ? !1 : typeof Uint8Array == "function" && or(new Uint8Array(e), new Uint8Array(t), n, r);
  if (typeof e != typeof t)
    return !1;
  var p = V1e(e), O = V1e(t);
  if (p.length !== O.length)
    return !1;
  for (p.sort(), O.sort(), l = p.length - 1; l >= 0; l--)
    if (p[l] != O[l])
      return !1;
  for (l = p.length - 1; l >= 0; l--)
    if (i = p[l], !or(e[i], t[i], n, r))
      return !1;
  var x = U1e(e), N = U1e(t);
  return x !== N ? !1 : x === "Set" || N === "Set" ? EKe(e, t, n, r) : x === "Map" ? $Ke(e, t, n, r) : !0;
}
var CKe = function(t, n, r) {
  return or(t, n, r, wKe());
};
Object.defineProperty(wc, "__esModule", {
  value: !0
});
wc.default = void 0;
var MKe = Dy(CKe), kKe = Dy(Da), Kde = Dy(ql);
function Dy(e) {
  return e && e.__esModule ? e : { default: e };
}
function Zu(e, t) {
  return NKe(e) || SKe(e, t) || Yde(e, t) || PKe();
}
function PKe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SKe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, i = !1, c, f;
    try {
      for (n = n.call(e); !(l = (c = n.next()).done) && (r.push(c.value), !(t && r.length === t)); l = !0)
        ;
    } catch (d) {
      i = !0, f = d;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (i)
          throw f;
      }
    }
    return r;
  }
}
function NKe(e) {
  if (Array.isArray(e))
    return e;
}
function RKe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Yde(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, l = function() {
      };
      return { s: l, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(h) {
        throw h;
      }, f: l };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, c = !1, f;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var h = n.next();
    return i = h.done, h;
  }, e: function(h) {
    c = !0, f = h;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (c)
        throw f;
    }
  } };
}
function Yde(e, t) {
  if (e) {
    if (typeof e == "string")
      return n0e(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return n0e(e, t);
  }
}
function n0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Jr = [], r0e = Kde.default.keys();
for (var Tu = 0; Tu < r0e.length; Tu++) {
  var Bu = r0e[Tu], Iu = Kde.default.get(Bu);
  if (Iu)
    for (var a0e = [].concat(Iu.baseConcepts, Iu.relatedConcepts), Hu = 0; Hu < a0e.length; Hu++) {
      var l0e = a0e[Hu];
      if (l0e.module === "HTML") {
        var Du = l0e.concept;
        Du && function() {
          var e = JSON.stringify(Du), t = Jr.find(function(i) {
            return JSON.stringify(i[0]) === e;
          }), n = void 0;
          t ? n = t[1] : n = [];
          for (var r = !0, l = 0; l < n.length; l++)
            if (n[l] === Bu) {
              r = !1;
              break;
            }
          r && n.push(Bu), Jr.push([Du, n]);
        }();
      }
    }
}
var k9 = {
  entries: function() {
    return Jr;
  },
  forEach: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = RKe(Jr), l;
    try {
      for (r.s(); !(l = r.n()).done; ) {
        var i = Zu(l.value, 2), c = i[0], f = i[1];
        t.call(n, f, c, Jr);
      }
    } catch (d) {
      r.e(d);
    } finally {
      r.f();
    }
  },
  get: function(t) {
    var n = Jr.find(function(r) {
      return (0, MKe.default)(t, r[0]);
    });
    return n && n[1];
  },
  has: function(t) {
    return !!k9.get(t);
  },
  keys: function() {
    return Jr.map(function(t) {
      var n = Zu(t, 1), r = n[0];
      return r;
    });
  },
  values: function() {
    return Jr.map(function(t) {
      var n = Zu(t, 2), r = n[1];
      return r;
    });
  }
}, _Ke = (0, kKe.default)(k9, k9.entries());
wc.default = _Ke;
var Oc = {};
Object.defineProperty(Oc, "__esModule", {
  value: !0
});
Oc.default = void 0;
var AKe = Qde(Da), Xde = Qde(ql);
function Qde(e) {
  return e && e.__esModule ? e : { default: e };
}
function zu(e, t) {
  return TKe(e) || ZKe(e, t) || Jde(e, t) || LKe();
}
function LKe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ZKe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, i = !1, c, f;
    try {
      for (n = n.call(e); !(l = (c = n.next()).done) && (r.push(c.value), !(t && r.length === t)); l = !0)
        ;
    } catch (d) {
      i = !0, f = d;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (i)
          throw f;
      }
    }
    return r;
  }
}
function TKe(e) {
  if (Array.isArray(e))
    return e;
}
function BKe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Jde(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, l = function() {
      };
      return { s: l, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(h) {
        throw h;
      }, f: l };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, c = !1, f;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var h = n.next();
    return i = h.done, h;
  }, e: function(h) {
    c = !0, f = h;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (c)
        throw f;
    }
  } };
}
function Jde(e, t) {
  if (e) {
    if (typeof e == "string")
      return i0e(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return i0e(e, t);
  }
}
function i0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var ea = [], epe = Xde.default.keys(), IKe = function(t) {
  var n = epe[t], r = Xde.default.get(n);
  if (r)
    for (var l = [].concat(r.baseConcepts, r.relatedConcepts), i = 0; i < l.length; i++) {
      var c = l[i];
      if (c.module === "HTML") {
        var f = c.concept;
        if (f) {
          var d = ea.find(function(g) {
            return g[0] === n;
          }), h = void 0;
          d ? h = d[1] : h = [], h.push(f), ea.push([n, h]);
        }
      }
    }
};
for (var Fu = 0; Fu < epe.length; Fu++)
  IKe(Fu);
var P9 = {
  entries: function() {
    return ea;
  },
  forEach: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = BKe(ea), l;
    try {
      for (r.s(); !(l = r.n()).done; ) {
        var i = zu(l.value, 2), c = i[0], f = i[1];
        t.call(n, f, c, ea);
      }
    } catch (d) {
      r.e(d);
    } finally {
      r.f();
    }
  },
  get: function(t) {
    var n = ea.find(function(r) {
      return r[0] === t;
    });
    return n && n[1];
  },
  has: function(t) {
    return !!P9.get(t);
  },
  keys: function() {
    return ea.map(function(t) {
      var n = zu(t, 1), r = n[0];
      return r;
    });
  },
  values: function() {
    return ea.map(function(t) {
      var n = zu(t, 2), r = n[1];
      return r;
    });
  }
}, HKe = (0, AKe.default)(P9, P9.entries());
Oc.default = HKe;
Object.defineProperty(ar, "__esModule", {
  value: !0
});
var er = ar.roles = npe = ar.roleElements = tpe = ar.elementRoles = ar.dom = ar.aria = void 0, DKe = Vi(I1), zKe = Vi(D1), FKe = Vi(ql), VKe = Vi(wc), qKe = Vi(Oc);
function Vi(e) {
  return e && e.__esModule ? e : { default: e };
}
var UKe = DKe.default;
ar.aria = UKe;
var WKe = zKe.default;
ar.dom = WKe;
var GKe = FKe.default;
er = ar.roles = GKe;
var KKe = VKe.default, tpe = ar.elementRoles = KKe, YKe = qKe.default, npe = ar.roleElements = YKe, zy = { exports: {} };
zy.exports;
(function(e) {
  var t = function() {
    var n = String.fromCharCode, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", i = {};
    function c(d, h) {
      if (!i[d]) {
        i[d] = {};
        for (var g = 0; g < d.length; g++)
          i[d][d.charAt(g)] = g;
      }
      return i[d][h];
    }
    var f = {
      compressToBase64: function(d) {
        if (d == null)
          return "";
        var h = f._compress(d, 6, function(g) {
          return r.charAt(g);
        });
        switch (h.length % 4) {
          default:
          case 0:
            return h;
          case 1:
            return h + "===";
          case 2:
            return h + "==";
          case 3:
            return h + "=";
        }
      },
      decompressFromBase64: function(d) {
        return d == null ? "" : d == "" ? null : f._decompress(d.length, 32, function(h) {
          return c(r, d.charAt(h));
        });
      },
      compressToUTF16: function(d) {
        return d == null ? "" : f._compress(d, 15, function(h) {
          return n(h + 32);
        }) + " ";
      },
      decompressFromUTF16: function(d) {
        return d == null ? "" : d == "" ? null : f._decompress(d.length, 16384, function(h) {
          return d.charCodeAt(h) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(d) {
        for (var h = f.compress(d), g = new Uint8Array(h.length * 2), m = 0, y = h.length; m < y; m++) {
          var w = h.charCodeAt(m);
          g[m * 2] = w >>> 8, g[m * 2 + 1] = w % 256;
        }
        return g;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(d) {
        if (d == null)
          return f.decompress(d);
        for (var h = new Array(d.length / 2), g = 0, m = h.length; g < m; g++)
          h[g] = d[g * 2] * 256 + d[g * 2 + 1];
        var y = [];
        return h.forEach(function(w) {
          y.push(n(w));
        }), f.decompress(y.join(""));
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(d) {
        return d == null ? "" : f._compress(d, 6, function(h) {
          return l.charAt(h);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(d) {
        return d == null ? "" : d == "" ? null : (d = d.replace(/ /g, "+"), f._decompress(d.length, 32, function(h) {
          return c(l, d.charAt(h));
        }));
      },
      compress: function(d) {
        return f._compress(d, 16, function(h) {
          return n(h);
        });
      },
      _compress: function(d, h, g) {
        if (d == null)
          return "";
        var m, y, w = {}, C = {}, E = "", R = "", M = "", P = 2, a = 3, o = 2, s = [], p = 0, O = 0, x;
        for (x = 0; x < d.length; x += 1)
          if (E = d.charAt(x), Object.prototype.hasOwnProperty.call(w, E) || (w[E] = a++, C[E] = !0), R = M + E, Object.prototype.hasOwnProperty.call(w, R))
            M = R;
          else {
            if (Object.prototype.hasOwnProperty.call(C, M)) {
              if (M.charCodeAt(0) < 256) {
                for (m = 0; m < o; m++)
                  p = p << 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++;
                for (y = M.charCodeAt(0), m = 0; m < 8; m++)
                  p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
              } else {
                for (y = 1, m = 0; m < o; m++)
                  p = p << 1 | y, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = 0;
                for (y = M.charCodeAt(0), m = 0; m < 16; m++)
                  p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
              }
              P--, P == 0 && (P = Math.pow(2, o), o++), delete C[M];
            } else
              for (y = w[M], m = 0; m < o; m++)
                p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
            P--, P == 0 && (P = Math.pow(2, o), o++), w[R] = a++, M = String(E);
          }
        if (M !== "") {
          if (Object.prototype.hasOwnProperty.call(C, M)) {
            if (M.charCodeAt(0) < 256) {
              for (m = 0; m < o; m++)
                p = p << 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++;
              for (y = M.charCodeAt(0), m = 0; m < 8; m++)
                p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
            } else {
              for (y = 1, m = 0; m < o; m++)
                p = p << 1 | y, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = 0;
              for (y = M.charCodeAt(0), m = 0; m < 16; m++)
                p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
            }
            P--, P == 0 && (P = Math.pow(2, o), o++), delete C[M];
          } else
            for (y = w[M], m = 0; m < o; m++)
              p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
          P--, P == 0 && (P = Math.pow(2, o), o++);
        }
        for (y = 2, m = 0; m < o; m++)
          p = p << 1 | y & 1, O == h - 1 ? (O = 0, s.push(g(p)), p = 0) : O++, y = y >> 1;
        for (; ; )
          if (p = p << 1, O == h - 1) {
            s.push(g(p));
            break;
          } else
            O++;
        return s.join("");
      },
      decompress: function(d) {
        return d == null ? "" : d == "" ? null : f._decompress(d.length, 32768, function(h) {
          return d.charCodeAt(h);
        });
      },
      _decompress: function(d, h, g) {
        var m = [], y = 4, w = 4, C = 3, E = "", R = [], M, P, a, o, s, p, O, x = { val: g(0), position: h, index: 1 };
        for (M = 0; M < 3; M += 1)
          m[M] = M;
        for (a = 0, s = Math.pow(2, 2), p = 1; p != s; )
          o = x.val & x.position, x.position >>= 1, x.position == 0 && (x.position = h, x.val = g(x.index++)), a |= (o > 0 ? 1 : 0) * p, p <<= 1;
        switch (a) {
          case 0:
            for (a = 0, s = Math.pow(2, 8), p = 1; p != s; )
              o = x.val & x.position, x.position >>= 1, x.position == 0 && (x.position = h, x.val = g(x.index++)), a |= (o > 0 ? 1 : 0) * p, p <<= 1;
            O = n(a);
            break;
          case 1:
            for (a = 0, s = Math.pow(2, 16), p = 1; p != s; )
              o = x.val & x.position, x.position >>= 1, x.position == 0 && (x.position = h, x.val = g(x.index++)), a |= (o > 0 ? 1 : 0) * p, p <<= 1;
            O = n(a);
            break;
          case 2:
            return "";
        }
        for (m[3] = O, P = O, R.push(O); ; ) {
          if (x.index > d)
            return "";
          for (a = 0, s = Math.pow(2, C), p = 1; p != s; )
            o = x.val & x.position, x.position >>= 1, x.position == 0 && (x.position = h, x.val = g(x.index++)), a |= (o > 0 ? 1 : 0) * p, p <<= 1;
          switch (O = a) {
            case 0:
              for (a = 0, s = Math.pow(2, 8), p = 1; p != s; )
                o = x.val & x.position, x.position >>= 1, x.position == 0 && (x.position = h, x.val = g(x.index++)), a |= (o > 0 ? 1 : 0) * p, p <<= 1;
              m[w++] = n(a), O = w - 1, y--;
              break;
            case 1:
              for (a = 0, s = Math.pow(2, 16), p = 1; p != s; )
                o = x.val & x.position, x.position >>= 1, x.position == 0 && (x.position = h, x.val = g(x.index++)), a |= (o > 0 ? 1 : 0) * p, p <<= 1;
              m[w++] = n(a), O = w - 1, y--;
              break;
            case 2:
              return R.join("");
          }
          if (y == 0 && (y = Math.pow(2, C), C++), m[O])
            E = m[O];
          else if (O === w)
            E = P + P.charAt(0);
          else
            return null;
          R.push(E), m[w++] = P + E.charAt(0), y--, P = E, y == 0 && (y = Math.pow(2, C), C++);
        }
      }
    };
    return f;
  }();
  e != null ? e.exports = t : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("LZString", function() {
    return t;
  });
})(zy);
var XKe = zy.exports;
const QKe = /* @__PURE__ */ ce(XKe);
function rpe(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const JKe = (e, t, n, r, l, i, c) => {
  const f = r + n.indent, d = n.colors;
  return e.map((h) => {
    const g = t[h];
    let m = c(g, n, f, l, i);
    return typeof g != "string" && (m.indexOf(`
`) !== -1 && (m = n.spacingOuter + f + m + n.spacingOuter + r), m = "{" + m + "}"), n.spacingInner + r + d.prop.open + h + d.prop.close + "=" + d.value.open + m + d.value.close;
  }).join("");
}, eYe = 3, tYe = (e, t, n, r, l, i) => e.map((c) => {
  const f = typeof c == "string" ? ape(c, t) : i(c, t, n, r, l);
  return f === "" && typeof c == "object" && c !== null && c.nodeType !== eYe ? "" : t.spacingOuter + n + f;
}).join(""), ape = (e, t) => {
  const n = t.colors.content;
  return n.open + rpe(e) + n.close;
}, nYe = (e, t) => {
  const n = t.colors.comment;
  return n.open + "<!--" + rpe(e) + "-->" + n.close;
}, rYe = (e, t, n, r, l) => {
  const i = r.colors.tag;
  return i.open + "<" + e + (t && i.close + t + r.spacingOuter + l + i.open) + (n ? ">" + i.close + n + r.spacingOuter + l + i.open + "</" + e : (t && !r.min ? "" : " ") + "/") + ">" + i.close;
}, aYe = (e, t) => {
  const n = t.colors.tag;
  return n.open + "<" + e + n.close + " …" + n.open + " />" + n.close;
}, lYe = 1, lpe = 3, ipe = 8, ope = 11, iYe = /^((HTML|SVG)\w*)?Element$/, oYe = (e) => {
  const t = e.constructor.name, {
    nodeType: n,
    tagName: r
  } = e, l = typeof r == "string" && r.includes("-") || typeof e.hasAttribute == "function" && e.hasAttribute("is");
  return n === lYe && (iYe.test(t) || l) || n === lpe && t === "Text" || n === ipe && t === "Comment" || n === ope && t === "DocumentFragment";
};
function sYe(e) {
  return e.nodeType === lpe;
}
function cYe(e) {
  return e.nodeType === ipe;
}
function Vu(e) {
  return e.nodeType === ope;
}
function uYe(e) {
  return {
    test: (t) => {
      var n;
      return (t == null || (n = t.constructor) == null ? void 0 : n.name) && oYe(t);
    },
    serialize: (t, n, r, l, i, c) => {
      if (sYe(t))
        return ape(t.data, n);
      if (cYe(t))
        return nYe(t.data, n);
      const f = Vu(t) ? "DocumentFragment" : t.tagName.toLowerCase();
      return ++l > n.maxDepth ? aYe(f, n) : rYe(f, JKe(Vu(t) ? [] : Array.from(t.attributes).map((d) => d.name).sort(), Vu(t) ? {} : Array.from(t.attributes).reduce((d, h) => (d[h.name] = h.value, d), {}), n, r + n.indent, l, i, c), tYe(Array.prototype.slice.call(t.childNodes || t.children).filter(e), n, r + n.indent, l, i, c), n, r);
    }
  };
}
let spe = null, Fy = null, Vy = null;
try {
  const e = module && module.require;
  Fy = e.call(module, "fs").readFileSync, Vy = e.call(module, "@babel/code-frame").codeFrameColumns, spe = e.call(module, "chalk");
} catch {
}
function fYe(e) {
  const t = e.indexOf("(") + 1, n = e.indexOf(")"), r = e.slice(t, n), l = r.split(":"), [i, c, f] = [l[0], parseInt(l[1], 10), parseInt(l[2], 10)];
  let d = "";
  try {
    d = Fy(i, "utf-8");
  } catch {
    return "";
  }
  const h = Vy(d, {
    start: {
      line: c,
      column: f
    }
  }, {
    highlightCode: !0,
    linesBelow: 0
  });
  return spe.dim(r) + `
` + h + `
`;
}
function dYe() {
  if (!Fy || !Vy)
    return "";
  const t = new Error().stack.split(`
`).slice(1).find((n) => !n.includes("node_modules/"));
  return fYe(t);
}
const cpe = 3;
function qu() {
  return typeof jest < "u" && jest !== null ? (
    // legacy timers
    setTimeout._isMockFunction === !0 || // modern timers
    // eslint-disable-next-line prefer-object-has-own -- not supported by our support matrix
    Object.prototype.hasOwnProperty.call(setTimeout, "clock")
  ) : !1;
}
function qy() {
  if (typeof window > "u")
    throw new Error("Could not find default container");
  return window.document;
}
function pYe(e) {
  if (e.defaultView)
    return e.defaultView;
  if (e.ownerDocument && e.ownerDocument.defaultView)
    return e.ownerDocument.defaultView;
  if (e.window)
    return e.window;
  throw e.ownerDocument && e.ownerDocument.defaultView === null ? new Error("It looks like the window object is not available for the provided node.") : e.then instanceof Function ? new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?") : Array.isArray(e) ? new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?") : typeof e.debug == "function" && typeof e.logTestingPlaygroundURL == "function" ? new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?") : new Error("The given node is not an Element, the node type is: " + typeof e + ".");
}
function zr(e) {
  if (!e || typeof e.querySelector != "function" || typeof e.querySelectorAll != "function")
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + t(e) + ".");
  function t(n) {
    return typeof n == "object" ? n === null ? "null" : n.constructor.name : typeof n;
  }
}
const gYe = () => {
  let e;
  try {
    var t, n;
    e = JSON.parse((t = In) == null || (n = t.env) == null ? void 0 : n.COLORS);
  } catch {
  }
  return typeof e == "boolean" ? e : typeof In < "u" && In.versions !== void 0 && In.versions.node !== void 0;
}, {
  DOMCollection: hYe
} = Yfe, mYe = 1, vYe = 8;
function bYe(e) {
  return e.nodeType !== vYe && (e.nodeType !== mYe || !e.matches(At().defaultIgnore));
}
function u1(e, t, n) {
  if (n === void 0 && (n = {}), e || (e = qy().body), typeof t != "number" && (t = typeof In < "u" && In.env.DEBUG_PRINT_LIMIT || 7e3), t === 0)
    return "";
  e.documentElement && (e = e.documentElement);
  let r = typeof e;
  if (r === "object" ? r = e.constructor.name : e = {}, !("outerHTML" in e))
    throw new TypeError("Expected an element or document but got " + r);
  const {
    filterNode: l = bYe,
    ...i
  } = n, c = nTe(e, {
    plugins: [uYe(l), hYe],
    printFunctionName: !1,
    highlight: gYe(),
    ...i
  });
  return t !== void 0 && e.outerHTML.length > t ? c.slice(0, t) + "..." : c;
}
const o0e = function() {
  const e = dYe();
  console.log(e ? u1(...arguments) + `

` + e : u1(...arguments));
};
let f1 = {
  testIdAttribute: "data-testid",
  asyncUtilTimeout: 1e3,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: (e) => e(),
  unstable_advanceTimersWrapper: (e) => e(),
  eventWrapper: (e) => e(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: !1,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: "script, style",
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: !1,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: !1,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(e, t) {
    const n = u1(t), r = new Error([e, "Ignored nodes: comments, " + f1.defaultIgnore + `
` + n].filter(Boolean).join(`

`));
    return r.name = "TestingLibraryElementError", r;
  },
  _disableExpensiveErrorDiagnostics: !1,
  computedStyleSupportsPseudoElements: !1
};
function yYe(e) {
  try {
    return f1._disableExpensiveErrorDiagnostics = !0, e();
  } finally {
    f1._disableExpensiveErrorDiagnostics = !1;
  }
}
function At() {
  return f1;
}
const wYe = ["button", "meter", "output", "progress", "select", "textarea", "input"];
function upe(e) {
  return wYe.includes(e.nodeName.toLowerCase()) ? "" : e.nodeType === cpe ? e.textContent : Array.from(e.childNodes).map((t) => upe(t)).join("");
}
function S9(e) {
  let t;
  return e.tagName.toLowerCase() === "label" ? t = upe(e) : t = e.value || e.textContent, t;
}
function fpe(e) {
  if (e.labels !== void 0) {
    var t;
    return (t = e.labels) != null ? t : [];
  }
  if (!OYe(e))
    return [];
  const n = e.ownerDocument.querySelectorAll("label");
  return Array.from(n).filter((r) => r.control === e);
}
function OYe(e) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(e.tagName) || e.tagName === "INPUT" && e.getAttribute("type") !== "hidden";
}
function dpe(e, t, n) {
  let {
    selector: r = "*"
  } = n === void 0 ? {} : n;
  const l = t.getAttribute("aria-labelledby"), i = l ? l.split(" ") : [];
  return i.length ? i.map((c) => {
    const f = e.querySelector('[id="' + c + '"]');
    return f ? {
      content: S9(f),
      formControl: null
    } : {
      content: "",
      formControl: null
    };
  }) : Array.from(fpe(t)).map((c) => {
    const f = S9(c), d = "button, input, meter, output, progress, select, textarea", h = Array.from(c.querySelectorAll(d)).filter((g) => g.matches(r))[0];
    return {
      content: f,
      formControl: h
    };
  });
}
function ppe(e) {
  if (e == null)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
      "It looks like " + e + " was passed instead of a matcher. Did you do something like getByText(" + e + ")?"
    );
}
function Wl(e, t, n, r) {
  if (typeof e != "string")
    return !1;
  ppe(n);
  const l = r(e);
  return typeof n == "string" || typeof n == "number" ? l.toLowerCase().includes(n.toString().toLowerCase()) : typeof n == "function" ? n(l, t) : hpe(n, l);
}
function Zr(e, t, n, r) {
  if (typeof e != "string")
    return !1;
  ppe(n);
  const l = r(e);
  return n instanceof Function ? n(l, t) : n instanceof RegExp ? hpe(n, l) : l === String(n);
}
function gpe(e) {
  let {
    trim: t = !0,
    collapseWhitespace: n = !0
  } = e === void 0 ? {} : e;
  return (r) => {
    let l = r;
    return l = t ? l.trim() : l, l = n ? l.replace(/\s+/g, " ") : l, l;
  };
}
function za(e) {
  let {
    trim: t,
    collapseWhitespace: n,
    normalizer: r
  } = e;
  if (!r)
    return gpe({
      trim: t,
      collapseWhitespace: n
    });
  if (typeof t < "u" || typeof n < "u")
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhitespace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  return r;
}
function hpe(e, t) {
  const n = e.test(t);
  return e.global && e.lastIndex !== 0 && (console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp."), e.lastIndex = 0), n;
}
function xc(e) {
  return e.matches("input[type=submit], input[type=button], input[type=reset]") ? e.value : Array.from(e.childNodes).filter((t) => t.nodeType === cpe && !!t.textContent).map((t) => t.textContent).join("");
}
const xYe = EYe(tpe);
function mpe(e) {
  return e.hidden === !0 || e.getAttribute("aria-hidden") === "true" || e.ownerDocument.defaultView.getComputedStyle(e).display === "none";
}
function Uy(e, t) {
  t === void 0 && (t = {});
  const {
    isSubtreeInaccessible: n = mpe
  } = t;
  if (e.ownerDocument.defaultView.getComputedStyle(e).visibility === "hidden")
    return !0;
  let l = e;
  for (; l; ) {
    if (n(l))
      return !0;
    l = l.parentElement;
  }
  return !1;
}
function Wy(e) {
  for (const {
    match: t,
    roles: n
  } of xYe)
    if (t(e))
      return [...n];
  return [];
}
function EYe(e) {
  function t(c) {
    let {
      name: f,
      attributes: d
    } = c;
    return "" + f + d.map((h) => {
      let {
        name: g,
        value: m,
        constraints: y = []
      } = h;
      return y.indexOf("undefined") !== -1 ? ":not([" + g + "])" : m ? "[" + g + '="' + m + '"]' : "[" + g + "]";
    }).join("");
  }
  function n(c) {
    let {
      attributes: f = []
    } = c;
    return f.length;
  }
  function r(c, f) {
    let {
      specificity: d
    } = c, {
      specificity: h
    } = f;
    return h - d;
  }
  function l(c) {
    let {
      attributes: f = []
    } = c;
    const d = f.findIndex((g) => g.value && g.name === "type" && g.value === "text");
    d >= 0 && (f = [...f.slice(0, d), ...f.slice(d + 1)]);
    const h = t({
      ...c,
      attributes: f
    });
    return (g) => d >= 0 && g.type !== "text" ? !1 : g.matches(h);
  }
  let i = [];
  for (const [c, f] of e.entries())
    i = [...i, {
      match: l(c),
      roles: Array.from(f),
      specificity: n(c)
    }];
  return i.sort(r);
}
function $Ye(e, t) {
  let {
    hidden: n = !1
  } = t === void 0 ? {} : t;
  function r(l) {
    return [l, ...Array.from(l.children).reduce((i, c) => [...i, ...r(c)], [])];
  }
  return r(e).filter((l) => n === !1 ? Uy(l) === !1 : !0).reduce((l, i) => {
    let c = [];
    return i.hasAttribute("role") ? c = i.getAttribute("role").split(" ").slice(0, 1) : c = Wy(i), c.reduce((f, d) => Array.isArray(f[d]) ? {
      ...f,
      [d]: [...f[d], i]
    } : {
      ...f,
      [d]: [i]
    }, l);
  }, {});
}
function jYe(e, t) {
  let {
    hidden: n,
    includeDescription: r
  } = t;
  const l = $Ye(e, {
    hidden: n
  });
  return Object.entries(l).filter((i) => {
    let [c] = i;
    return c !== "generic";
  }).map((i) => {
    let [c, f] = i;
    const d = "-".repeat(50), h = f.map((g) => {
      const m = 'Name "' + Ry(g, {
        computedStyleSupportsPseudoElements: At().computedStyleSupportsPseudoElements
      }) + `":
`, y = u1(g.cloneNode(!1));
      if (r) {
        const w = 'Description "' + hde(g, {
          computedStyleSupportsPseudoElements: At().computedStyleSupportsPseudoElements
        }) + `":
`;
        return "" + m + w + y;
      }
      return "" + m + y;
    }).join(`

`);
    return c + `:

` + h + `

` + d;
  }).join(`
`);
}
function CYe(e) {
  return e.tagName === "OPTION" ? e.selected : qi(e, "aria-selected");
}
function MYe(e) {
  return e.getAttribute("aria-busy") === "true";
}
function kYe(e) {
  if (!("indeterminate" in e && e.indeterminate))
    return "checked" in e ? e.checked : qi(e, "aria-checked");
}
function PYe(e) {
  return qi(e, "aria-pressed");
}
function SYe(e) {
  var t, n;
  return (t = (n = qi(e, "aria-current")) != null ? n : e.getAttribute("aria-current")) != null ? t : !1;
}
function NYe(e) {
  return qi(e, "aria-expanded");
}
function qi(e, t) {
  const n = e.getAttribute(t);
  if (n === "true")
    return !0;
  if (n === "false")
    return !1;
}
function RYe(e) {
  const t = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  return e.getAttribute("aria-level") && Number(e.getAttribute("aria-level")) || t[e.tagName];
}
function _Ye(e) {
  const t = e.getAttribute("aria-valuenow");
  return t === null ? void 0 : +t;
}
function AYe(e) {
  const t = e.getAttribute("aria-valuemax");
  return t === null ? void 0 : +t;
}
function LYe(e) {
  const t = e.getAttribute("aria-valuemin");
  return t === null ? void 0 : +t;
}
function ZYe(e) {
  const t = e.getAttribute("aria-valuetext");
  return t === null ? void 0 : t;
}
const s0e = gpe();
function TYe(e) {
  return e.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}
function c0e(e) {
  return new RegExp(TYe(e.toLowerCase()), "i");
}
function Ur(e, t, n, r) {
  let {
    variant: l,
    name: i
  } = r, c = "";
  const f = {}, d = [["Role", "TestId"].includes(e) ? n : c0e(n)];
  i && (f.name = c0e(i)), e === "Role" && Uy(t) && (f.hidden = !0, c = `Element is inaccessible. This means that the element and all its children are invisible to screen readers.
    If you are using the aria-hidden prop, make sure this is the right choice for your case.
    `), Object.keys(f).length > 0 && d.push(f);
  const h = l + "By" + e;
  return {
    queryName: e,
    queryMethod: h,
    queryArgs: d,
    variant: l,
    warning: c,
    toString() {
      c && console.warn(c);
      let [g, m] = d;
      return g = typeof g == "string" ? "'" + g + "'" : g, m = m ? ", { " + Object.entries(m).map((y) => {
        let [w, C] = y;
        return w + ": " + C;
      }).join(", ") + " }" : "", h + "(" + g + m + ")";
    }
  };
}
function Wr(e, t, n) {
  return n && (!t || t.toLowerCase() === e.toLowerCase());
}
function N9(e, t, n) {
  var r, l;
  if (t === void 0 && (t = "get"), e.matches(At().defaultIgnore))
    return;
  const i = (r = e.getAttribute("role")) != null ? r : (l = Wy(e)) == null ? void 0 : l[0];
  if (i !== "generic" && Wr("Role", n, i))
    return Ur("Role", e, i, {
      variant: t,
      name: Ry(e, {
        computedStyleSupportsPseudoElements: At().computedStyleSupportsPseudoElements
      })
    });
  const c = dpe(document, e).map((y) => y.content).join(" ");
  if (Wr("LabelText", n, c))
    return Ur("LabelText", e, c, {
      variant: t
    });
  const f = e.getAttribute("placeholder");
  if (Wr("PlaceholderText", n, f))
    return Ur("PlaceholderText", e, f, {
      variant: t
    });
  const d = s0e(xc(e));
  if (Wr("Text", n, d))
    return Ur("Text", e, d, {
      variant: t
    });
  if (Wr("DisplayValue", n, e.value))
    return Ur("DisplayValue", e, s0e(e.value), {
      variant: t
    });
  const h = e.getAttribute("alt");
  if (Wr("AltText", n, h))
    return Ur("AltText", e, h, {
      variant: t
    });
  const g = e.getAttribute("title");
  if (Wr("Title", n, g))
    return Ur("Title", e, g, {
      variant: t
    });
  const m = e.getAttribute(At().testIdAttribute);
  if (Wr("TestId", n, m))
    return Ur("TestId", e, m, {
      variant: t
    });
}
function ho(e, t) {
  e.stack = t.stack.replace(t.message, e.message);
}
function BYe(e, t) {
  let {
    container: n = qy(),
    timeout: r = At().asyncUtilTimeout,
    showOriginalStackTrace: l = At().showOriginalStackTrace,
    stackTraceError: i,
    interval: c = 50,
    onTimeout: f = (h) => (h.message = At().getElementError(h.message, n).message, h),
    mutationObserverOptions: d = {
      subtree: !0,
      childList: !0,
      attributes: !0,
      characterData: !0
    }
  } = t;
  if (typeof e != "function")
    throw new TypeError("Received `callback` arg must be a function");
  return new Promise(async (h, g) => {
    let m, y, w, C = !1, E = "idle";
    const R = setTimeout(s, r), M = qu();
    if (M) {
      const {
        unstable_advanceTimersWrapper: p
      } = At();
      for (o(); !C; ) {
        if (!qu()) {
          const O = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          l || ho(O, i), g(O);
          return;
        }
        if (await p(async () => {
          jest.advanceTimersByTime(c);
        }), o(), C)
          break;
      }
    } else {
      try {
        zr(n);
      } catch (O) {
        g(O);
        return;
      }
      y = setInterval(a, c);
      const {
        MutationObserver: p
      } = pYe(n);
      w = new p(a), w.observe(n, d), o();
    }
    function P(p, O) {
      C = !0, clearTimeout(R), M || (clearInterval(y), w.disconnect()), p ? g(p) : h(O);
    }
    function a() {
      if (qu()) {
        const p = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        return l || ho(p, i), g(p);
      } else
        return o();
    }
    function o() {
      if (E !== "pending")
        try {
          const p = yYe(e);
          typeof (p == null ? void 0 : p.then) == "function" ? (E = "pending", p.then((O) => {
            E = "resolved", P(null, O);
          }, (O) => {
            E = "rejected", m = O;
          })) : P(null, p);
        } catch (p) {
          m = p;
        }
    }
    function s() {
      let p;
      m ? (p = m, !l && p.name === "TestingLibraryElementError" && ho(p, i)) : (p = new Error("Timed out in waitFor."), l || ho(p, i)), P(f(p), null);
    }
  });
}
function IYe(e, t) {
  const n = new Error("STACK_TRACE_MESSAGE");
  return At().asyncWrapper(() => BYe(e, {
    stackTraceError: n,
    ...t
  }));
}
function vpe(e, t) {
  return At().getElementError(e, t);
}
function HYe(e, t) {
  return vpe(e + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", t);
}
function Ui(e, t, n, r) {
  let {
    exact: l = !0,
    collapseWhitespace: i,
    trim: c,
    normalizer: f
  } = r === void 0 ? {} : r;
  const d = l ? Zr : Wl, h = za({
    collapseWhitespace: i,
    trim: c,
    normalizer: f
  });
  return Array.from(t.querySelectorAll("[" + e + "]")).filter((g) => d(g.getAttribute(e), g, n, h));
}
function d1(e, t) {
  return function(n) {
    for (var r = arguments.length, l = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      l[i - 1] = arguments[i];
    const c = e(n, ...l);
    if (c.length > 1) {
      const f = c.map((d) => vpe(null, d).message).join(`

`);
      throw HYe(t(n, ...l) + `

Here are the matching elements:

` + f, n);
    }
    return c[0] || null;
  };
}
function bpe(e, t) {
  return At().getElementError(`A better query is available, try this:
` + e.toString() + `
`, t);
}
function DYe(e, t) {
  return function(n) {
    for (var r = arguments.length, l = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      l[i - 1] = arguments[i];
    const c = e(n, ...l);
    if (!c.length)
      throw At().getElementError(t(n, ...l), n);
    return c;
  };
}
function p1(e) {
  return (t, n, r, l) => IYe(() => e(t, n, r), {
    container: t,
    ...l
  });
}
const al = (e, t, n) => function(r) {
  for (var l = arguments.length, i = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
    i[c - 1] = arguments[c];
  const f = e(r, ...i), [{
    suggest: d = At().throwSuggestions
  } = {}] = i.slice(-1);
  if (f && d) {
    const h = N9(f, n);
    if (h && !t.endsWith(h.queryName))
      throw bpe(h.toString(), r);
  }
  return f;
}, zn = (e, t, n) => function(r) {
  for (var l = arguments.length, i = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
    i[c - 1] = arguments[c];
  const f = e(r, ...i), [{
    suggest: d = At().throwSuggestions
  } = {}] = i.slice(-1);
  if (f.length && d) {
    const h = [...new Set(f.map((g) => {
      var m;
      return (m = N9(g, n)) == null ? void 0 : m.toString();
    }))];
    if (
      // only want to suggest if all the els have the same suggestion.
      h.length === 1 && !t.endsWith(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
        N9(f[0], n).queryName
      )
    )
      throw bpe(h[0], r);
  }
  return f;
};
function ya(e, t, n) {
  const r = al(d1(e, t), e.name, "query"), l = DYe(e, n), i = d1(l, t), c = al(i, e.name, "get"), f = zn(l, e.name.replace("query", "get"), "getAll"), d = p1(zn(l, e.name, "findAll")), h = p1(al(i, e.name, "find"));
  return [r, f, c, d, h];
}
function zYe(e) {
  return Array.from(e.querySelectorAll("label,input")).map((t) => ({
    node: t,
    textToMatch: S9(t)
  })).filter((t) => {
    let {
      textToMatch: n
    } = t;
    return n !== null;
  });
}
const FYe = function(e, t, n) {
  let {
    exact: r = !0,
    trim: l,
    collapseWhitespace: i,
    normalizer: c
  } = n === void 0 ? {} : n;
  const f = r ? Zr : Wl, d = za({
    collapseWhitespace: i,
    trim: l,
    normalizer: c
  });
  return zYe(e).filter((g) => {
    let {
      node: m,
      textToMatch: y
    } = g;
    return f(y, m, t, d);
  }).map((g) => {
    let {
      node: m
    } = g;
    return m;
  });
}, Li = function(e, t, n) {
  let {
    selector: r = "*",
    exact: l = !0,
    collapseWhitespace: i,
    trim: c,
    normalizer: f
  } = n === void 0 ? {} : n;
  zr(e);
  const d = l ? Zr : Wl, h = za({
    collapseWhitespace: i,
    trim: c,
    normalizer: f
  }), g = Array.from(e.querySelectorAll("*")).filter((m) => fpe(m).length || m.hasAttribute("aria-labelledby")).reduce((m, y) => {
    const w = dpe(e, y, {
      selector: r
    });
    w.filter((E) => !!E.formControl).forEach((E) => {
      d(E.content, E.formControl, t, h) && E.formControl && m.push(E.formControl);
    });
    const C = w.filter((E) => !!E.content).map((E) => E.content);
    return d(C.join(" "), y, t, h) && m.push(y), C.length > 1 && C.forEach((E, R) => {
      d(E, y, t, h) && m.push(y);
      const M = [...C];
      M.splice(R, 1), M.length > 1 && d(M.join(" "), y, t, h) && m.push(y);
    }), m;
  }, []).concat(Ui("aria-label", e, t, {
    exact: l,
    normalizer: h
  }));
  return Array.from(new Set(g)).filter((m) => m.matches(r));
}, Sa = function(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), l = 2; l < n; l++)
    r[l - 2] = arguments[l];
  const i = Li(e, t, ...r);
  if (!i.length) {
    const c = FYe(e, t, ...r);
    if (c.length) {
      const f = c.map((d) => VYe(e, d)).filter((d) => !!d);
      throw f.length ? At().getElementError(f.map((d) => "Found a label with the text of: " + t + ", however the element associated with this label (<" + d + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + d + " />, you can use aria-label or aria-labelledby instead.").join(`

`), e) : At().getElementError("Found a label with the text of: " + t + `, however no form control was found associated to that label. Make sure you're using the "for" attribute or "aria-labelledby" attribute correctly.`, e);
    } else
      throw At().getElementError("Unable to find a label with the text of: " + t, e);
  }
  return i;
};
function VYe(e, t) {
  const n = t.getAttribute("for");
  if (!n)
    return null;
  const r = e.querySelector('[id="' + n + '"]');
  return r ? r.tagName.toLowerCase() : null;
}
const ype = (e, t) => "Found multiple elements with the text of: " + t, qYe = al(d1(Li, ype), Li.name, "query"), wpe = d1(Sa, ype), UYe = p1(zn(Sa, Sa.name, "findAll")), WYe = p1(al(wpe, Sa.name, "find")), GYe = zn(Sa, Sa.name, "getAll"), KYe = al(wpe, Sa.name, "get"), YYe = zn(Li, Li.name, "queryAll"), R9 = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return zr(t[0]), Ui("placeholder", ...t);
}, XYe = (e, t) => "Found multiple elements with the placeholder text of: " + t, QYe = (e, t) => "Unable to find an element with the placeholder text of: " + t, JYe = zn(R9, R9.name, "queryAll"), [eXe, tXe, nXe, rXe, aXe] = ya(R9, XYe, QYe), _9 = function(e, t, n) {
  let {
    selector: r = "*",
    exact: l = !0,
    collapseWhitespace: i,
    trim: c,
    ignore: f = At().defaultIgnore,
    normalizer: d
  } = n === void 0 ? {} : n;
  zr(e);
  const h = l ? Zr : Wl, g = za({
    collapseWhitespace: i,
    trim: c,
    normalizer: d
  });
  let m = [];
  return typeof e.matches == "function" && e.matches(r) && (m = [e]), [...m, ...Array.from(e.querySelectorAll(r))].filter((y) => !f || !y.matches(f)).filter((y) => h(xc(y), y, t, g));
}, lXe = (e, t) => "Found multiple elements with the text: " + t, iXe = function(e, t, n) {
  n === void 0 && (n = {});
  const {
    collapseWhitespace: r,
    trim: l,
    normalizer: i,
    selector: c
  } = n, d = za({
    collapseWhitespace: r,
    trim: l,
    normalizer: i
  })(t.toString()), h = d !== t.toString(), g = (c ?? "*") !== "*";
  return "Unable to find an element with the text: " + (h ? d + " (normalized from '" + t + "')" : t) + (g ? ", which matches selector '" + c + "'" : "") + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
}, oXe = zn(_9, _9.name, "queryAll"), [sXe, cXe, uXe, fXe, dXe] = ya(_9, lXe, iXe), A9 = function(e, t, n) {
  let {
    exact: r = !0,
    collapseWhitespace: l,
    trim: i,
    normalizer: c
  } = n === void 0 ? {} : n;
  zr(e);
  const f = r ? Zr : Wl, d = za({
    collapseWhitespace: l,
    trim: i,
    normalizer: c
  });
  return Array.from(e.querySelectorAll("input,textarea,select")).filter((h) => h.tagName === "SELECT" ? Array.from(h.options).filter((m) => m.selected).some((m) => f(xc(m), m, t, d)) : f(h.value, h, t, d));
}, pXe = (e, t) => "Found multiple elements with the display value: " + t + ".", gXe = (e, t) => "Unable to find an element with the display value: " + t + ".", hXe = zn(A9, A9.name, "queryAll"), [mXe, vXe, bXe, yXe, wXe] = ya(A9, pXe, gXe), OXe = /^(img|input|area|.+-.+)$/i, L9 = function(e, t, n) {
  return n === void 0 && (n = {}), zr(e), Ui("alt", e, t, n).filter((r) => OXe.test(r.tagName));
}, xXe = (e, t) => "Found multiple elements with the alt text: " + t, EXe = (e, t) => "Unable to find an element with the alt text: " + t, $Xe = zn(L9, L9.name, "queryAll"), [jXe, CXe, MXe, kXe, PXe] = ya(L9, xXe, EXe), SXe = (e) => {
  var t;
  return e.tagName.toLowerCase() === "title" && ((t = e.parentElement) == null ? void 0 : t.tagName.toLowerCase()) === "svg";
}, Z9 = function(e, t, n) {
  let {
    exact: r = !0,
    collapseWhitespace: l,
    trim: i,
    normalizer: c
  } = n === void 0 ? {} : n;
  zr(e);
  const f = r ? Zr : Wl, d = za({
    collapseWhitespace: l,
    trim: i,
    normalizer: c
  });
  return Array.from(e.querySelectorAll("[title], svg > title")).filter((h) => f(h.getAttribute("title"), h, t, d) || SXe(h) && f(xc(h), h, t, d));
}, NXe = (e, t) => "Found multiple elements with the title: " + t + ".", RXe = (e, t) => "Unable to find an element with the title: " + t + ".", _Xe = zn(Z9, Z9.name, "queryAll"), [AXe, LXe, ZXe, TXe, BXe] = ya(Z9, NXe, RXe), T9 = function(e, t, n) {
  let {
    hidden: r = At().defaultHidden,
    name: l,
    description: i,
    queryFallbacks: c = !1,
    selected: f,
    busy: d,
    checked: h,
    pressed: g,
    current: m,
    level: y,
    expanded: w,
    value: {
      now: C,
      min: E,
      max: R,
      text: M
    } = {}
  } = n === void 0 ? {} : n;
  if (zr(e), f !== void 0) {
    var P;
    if (((P = er.get(t)) == null ? void 0 : P.props["aria-selected"]) === void 0)
      throw new Error('"aria-selected" is not supported on role "' + t + '".');
  }
  if (d !== void 0) {
    var a;
    if (((a = er.get(t)) == null ? void 0 : a.props["aria-busy"]) === void 0)
      throw new Error('"aria-busy" is not supported on role "' + t + '".');
  }
  if (h !== void 0) {
    var o;
    if (((o = er.get(t)) == null ? void 0 : o.props["aria-checked"]) === void 0)
      throw new Error('"aria-checked" is not supported on role "' + t + '".');
  }
  if (g !== void 0) {
    var s;
    if (((s = er.get(t)) == null ? void 0 : s.props["aria-pressed"]) === void 0)
      throw new Error('"aria-pressed" is not supported on role "' + t + '".');
  }
  if (m !== void 0) {
    var p;
    if (((p = er.get(t)) == null ? void 0 : p.props["aria-current"]) === void 0)
      throw new Error('"aria-current" is not supported on role "' + t + '".');
  }
  if (y !== void 0 && t !== "heading")
    throw new Error('Role "' + t + '" cannot have "level" property.');
  if (C !== void 0) {
    var O;
    if (((O = er.get(t)) == null ? void 0 : O.props["aria-valuenow"]) === void 0)
      throw new Error('"aria-valuenow" is not supported on role "' + t + '".');
  }
  if (R !== void 0) {
    var x;
    if (((x = er.get(t)) == null ? void 0 : x.props["aria-valuemax"]) === void 0)
      throw new Error('"aria-valuemax" is not supported on role "' + t + '".');
  }
  if (E !== void 0) {
    var N;
    if (((N = er.get(t)) == null ? void 0 : N.props["aria-valuemin"]) === void 0)
      throw new Error('"aria-valuemin" is not supported on role "' + t + '".');
  }
  if (M !== void 0) {
    var T;
    if (((T = er.get(t)) == null ? void 0 : T.props["aria-valuetext"]) === void 0)
      throw new Error('"aria-valuetext" is not supported on role "' + t + '".');
  }
  if (w !== void 0) {
    var $;
    if ((($ = er.get(t)) == null ? void 0 : $.props["aria-expanded"]) === void 0)
      throw new Error('"aria-expanded" is not supported on role "' + t + '".');
  }
  const j = /* @__PURE__ */ new WeakMap();
  function A(Z) {
    return j.has(Z) || j.set(Z, mpe(Z)), j.get(Z);
  }
  return Array.from(e.querySelectorAll(
    // Only query elements that can be matched by the following filters
    IXe(t)
  )).filter((Z) => {
    if (Z.hasAttribute("role")) {
      const F = Z.getAttribute("role");
      if (c)
        return F.split(" ").filter(Boolean).some((B) => B === t);
      const [U] = F.split(" ");
      return U === t;
    }
    return Wy(Z).some((F) => F === t);
  }).filter((Z) => {
    if (f !== void 0)
      return f === CYe(Z);
    if (d !== void 0)
      return d === MYe(Z);
    if (h !== void 0)
      return h === kYe(Z);
    if (g !== void 0)
      return g === PYe(Z);
    if (m !== void 0)
      return m === SYe(Z);
    if (w !== void 0)
      return w === NYe(Z);
    if (y !== void 0)
      return y === RYe(Z);
    if (C !== void 0 || R !== void 0 || E !== void 0 || M !== void 0) {
      let I = !0;
      if (C !== void 0 && I && (I = C === _Ye(Z)), R !== void 0 && I && (I = R === AYe(Z)), E !== void 0 && I && (I = E === LYe(Z)), M !== void 0) {
        var G;
        I && (I = Zr((G = ZYe(Z)) != null ? G : null, Z, M, (F) => F));
      }
      return I;
    }
    return !0;
  }).filter((Z) => l === void 0 ? !0 : Zr(Ry(Z, {
    computedStyleSupportsPseudoElements: At().computedStyleSupportsPseudoElements
  }), Z, l, (G) => G)).filter((Z) => i === void 0 ? !0 : Zr(hde(Z, {
    computedStyleSupportsPseudoElements: At().computedStyleSupportsPseudoElements
  }), Z, i, (G) => G)).filter((Z) => r === !1 ? Uy(Z, {
    isSubtreeInaccessible: A
  }) === !1 : !0);
};
function IXe(e) {
  var t;
  const n = '*[role~="' + e + '"]', r = (t = npe.get(e)) != null ? t : /* @__PURE__ */ new Set(), l = new Set(Array.from(r).map((i) => {
    let {
      name: c
    } = i;
    return c;
  }));
  return [n].concat(Array.from(l)).join(",");
}
const Ope = (e) => {
  let t = "";
  return e === void 0 ? t = "" : typeof e == "string" ? t = ' and name "' + e + '"' : t = " and name `" + e + "`", t;
}, HXe = function(e, t, n) {
  let {
    name: r
  } = n === void 0 ? {} : n;
  return 'Found multiple elements with the role "' + t + '"' + Ope(r);
}, DXe = function(e, t, n) {
  let {
    hidden: r = At().defaultHidden,
    name: l,
    description: i
  } = n === void 0 ? {} : n;
  if (At()._disableExpensiveErrorDiagnostics)
    return 'Unable to find role="' + t + '"' + Ope(l);
  let c = "";
  Array.from(e.children).forEach((g) => {
    c += jYe(g, {
      hidden: r,
      includeDescription: i !== void 0
    });
  });
  let f;
  c.length === 0 ? r === !1 ? f = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, then set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole" : f = "There are no available roles." : f = (`
Here are the ` + (r === !1 ? "accessible" : "available") + ` roles:

  ` + c.replace(/\n/g, `
  `).replace(/\n\s\s\n/g, `

`) + `
`).trim();
  let d = "";
  l === void 0 ? d = "" : typeof l == "string" ? d = ' and name "' + l + '"' : d = " and name `" + l + "`";
  let h = "";
  return i === void 0 ? h = "" : typeof i == "string" ? h = ' and description "' + i + '"' : h = " and description `" + i + "`", (`
Unable to find an ` + (r === !1 ? "accessible " : "") + 'element with the role "' + t + '"' + d + h + `

` + f).trim();
}, zXe = zn(T9, T9.name, "queryAll"), [FXe, VXe, qXe, UXe, WXe] = ya(T9, HXe, DXe), Gy = () => At().testIdAttribute, B9 = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return zr(t[0]), Ui(Gy(), ...t);
}, GXe = (e, t) => "Found multiple elements by: [" + Gy() + '="' + t + '"]', KXe = (e, t) => "Unable to find an element by: [" + Gy() + '="' + t + '"]', YXe = zn(B9, B9.name, "queryAll"), [XXe, QXe, JXe, eQe, tQe] = ya(B9, GXe, KXe);
var I9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  queryAllByLabelText: YYe,
  queryByLabelText: qYe,
  getAllByLabelText: GYe,
  getByLabelText: KYe,
  findAllByLabelText: UYe,
  findByLabelText: WYe,
  queryByPlaceholderText: eXe,
  queryAllByPlaceholderText: JYe,
  getByPlaceholderText: nXe,
  getAllByPlaceholderText: tXe,
  findAllByPlaceholderText: rXe,
  findByPlaceholderText: aXe,
  queryByText: sXe,
  queryAllByText: oXe,
  getByText: uXe,
  getAllByText: cXe,
  findAllByText: fXe,
  findByText: dXe,
  queryByDisplayValue: mXe,
  queryAllByDisplayValue: hXe,
  getByDisplayValue: bXe,
  getAllByDisplayValue: vXe,
  findAllByDisplayValue: yXe,
  findByDisplayValue: wXe,
  queryByAltText: jXe,
  queryAllByAltText: $Xe,
  getByAltText: MXe,
  getAllByAltText: CXe,
  findAllByAltText: kXe,
  findByAltText: PXe,
  queryByTitle: AXe,
  queryAllByTitle: _Xe,
  getByTitle: ZXe,
  getAllByTitle: LXe,
  findAllByTitle: TXe,
  findByTitle: BXe,
  queryByRole: FXe,
  queryAllByRole: zXe,
  getAllByRole: VXe,
  getByRole: qXe,
  findAllByRole: UXe,
  findByRole: WXe,
  queryByTestId: XXe,
  queryAllByTestId: YXe,
  getByTestId: JXe,
  getAllByTestId: QXe,
  findAllByTestId: eQe,
  findByTestId: tQe
});
function xpe(e, t, n) {
  return t === void 0 && (t = I9), n === void 0 && (n = {}), Object.keys(t).reduce((r, l) => {
    const i = t[l];
    return r[l] = i.bind(null, e), r;
  }, n);
}
const nQe = {
  // Clipboard Events
  copy: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  cut: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  paste: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  compositionStart: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  compositionUpdate: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  keyPress: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  keyUp: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  // Focus Events
  focus: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  blur: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  focusIn: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  focusOut: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  // Form Events
  change: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  input: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  invalid: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !0
    }
  },
  submit: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  reset: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  // Mouse Events
  click: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      button: 0,
      composed: !0
    }
  },
  contextMenu: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dblClick: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  drag: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragEnd: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragEnter: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragExit: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragLeave: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragOver: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragStart: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  drop: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseDown: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseEnter: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseLeave: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseMove: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseOut: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseOver: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseUp: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Selection Events
  select: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // Touch Events
  touchCancel: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  touchEnd: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  touchMove: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  touchStart: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // UI Events
  resize: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  scroll: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Wheel Events
  wheel: {
    EventType: "WheelEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Media Events
  abort: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  canPlay: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  canPlayThrough: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  durationChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  emptied: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  encrypted: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  ended: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadedData: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadedMetadata: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadStart: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pause: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  play: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  playing: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  progress: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  rateChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  seeked: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  seeking: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  stalled: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  suspend: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  timeUpdate: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  volumeChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  waiting: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  error: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Animation Events
  animationStart: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  animationEnd: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  animationIteration: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  transitionEnd: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  transitionRun: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  transitionStart: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // pointer events
  pointerOver: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerEnter: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pointerDown: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerMove: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerUp: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerCancel: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  pointerOut: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerLeave: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  gotPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  lostPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  // history events
  popState: {
    EventType: "PopStateEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // window events
  offline: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  online: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  }
}, rQe = {
  doubleClick: "dblClick"
};
Object.keys(nQe).forEach((e) => {
  e.toLowerCase();
});
Object.keys(rQe).forEach((e) => {
});
function aQe(e) {
  return e.replace(/[ \t]*[\n][ \t]*/g, `
`);
}
function lQe(e) {
  return QKe.compressToEncodedURIComponent(aQe(e));
}
function iQe(e) {
  return "https://testing-playground.com/#markup=" + lQe(e);
}
const oQe = (e, t, n) => Array.isArray(e) ? e.forEach((r) => o0e(r, t, n)) : o0e(e, t, n), sQe = function(e) {
  if (e === void 0 && (e = qy().body), !e || !("innerHTML" in e)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  if (!e.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const t = iQe(e.innerHTML);
  return console.log(`Open this URL in your browser

` + t), t;
}, u0e = {
  debug: oQe,
  logTestingPlaygroundURL: sQe
};
typeof document < "u" && document.body ? xpe(document.body, I9, u0e) : Object.keys(I9).reduce((e, t) => (e[t] = () => {
  throw new TypeError("For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error");
}, e), u0e);
function g1(e) {
  return g1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, g1(e);
}
function cQe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return f0e(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return f0e(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function f0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var H9 = "data-lgid", Epe = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    if (!r || typeof r.querySelector != "function" || typeof r.querySelectorAll != "function")
      throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got ".concat((l = r, g1(l) === "object" ? l === null ? "null" : l.constructor.name : g1(l)), "."));
    var l;
  }(t[0]), Ui.apply(void 0, [H9].concat(t));
}, Wi = cQe(ya(Epe, function(e, t) {
  return "Found multiple elements by: [".concat(H9, '="').concat(t, '"]');
}, function(e, t) {
  return "Unable to find an element by: [".concat(H9, '="').concat(t, '"]');
}), 5), uQe = Wi[0], fQe = Wi[1], dQe = Wi[2], pQe = Wi[3], gQe = Wi[4], hQe = Object.freeze({ __proto__: null, findAllByTestId: pQe, findByTestId: gQe, getAllByTestId: fQe, getByTestId: dQe, queryAllByTestId: Epe, queryByTestId: uQe }), $pe = function() {
  var e = function() {
    if (typeof window < "u")
      return window.document;
  }();
  if (!e)
    return { findByLgId: void 0, getByLgId: void 0, queryByLgId: void 0 };
  var t = xpe(e.body, hQe);
  return { findByLgId: t.findByTestId, getByLgId: t.getByTestId, queryByLgId: t.queryByTestId };
}();
$pe.findByLgId;
$pe.getByLgId;
function d0e(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function p0e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? d0e(Object(n), !0).forEach(function(r) {
      vQe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d0e(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function mQe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function vQe(e, t, n) {
  return (t = mQe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function bQe(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function jpe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function yQe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return g0e(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return g0e(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function g0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var h0e, m0e, wQe = "lg-text_area", OQe = v(h0e || (h0e = jpe([`
  height: auto;
  display: flex;
  padding: 0;
`]))), xQe = v(m0e || (m0e = jpe([`
  width: 100%;
  min-height: `, `px;
  display: flex;
  resize: none;
  padding: `, "px ", `px;
`])), 64, ee[200], ee[300]), Cpe = jr, EQe = ["label", "description", "className", "errorMessage", "successMessage", "darkMode", "disabled", "state", "id", "value", "onChange", "onBlur", "handleValidation", "aria-label", "aria-labelledby", "aria-invalid", "baseFontSize", "data-lgid", "defaultValue"], D9 = wn(function(e, t) {
  var n = e.label, r = e.description, l = e.className, i = e.errorMessage, c = i === void 0 ? "This input needs your attention" : i, f = e.successMessage, d = f === void 0 ? "Success" : f, h = e.darkMode, g = e.disabled, m = g !== void 0 && g, y = e.state, w = y === void 0 ? Cpe.None : y, C = e.id, E = e.value, R = e.onChange, M = e.onBlur, P = e.handleValidation, a = e["aria-label"], o = e["aria-labelledby"], s = e["aria-invalid"], p = e.baseFontSize, O = e["data-lgid"], x = O === void 0 ? wQe : O, N = e.defaultValue, T = N === void 0 ? "" : N, $ = bQe(e, EQe), j = Ha(p), A = Hn({ prefix: "textarea", id: C }), Z = K(h).darkMode, G = typeof E == "string", I = yQe(ht(T), 2), F = I[0], U = I[1], B = G ? E : F, L = gge(P);
  n || o || console.error("For screen-reader accessibility, label or aria-labelledby must be provided to TextArea.");
  var q = p0e({ baseFontSize: j, className: l, darkMode: Z, "data-lgid": x, description: r, disabled: m, errorMessage: c, id: A, label: n, state: w, successMessage: d }, { "aria-invalid": s, "aria-label": a, "aria-labelledby": o }), D = p0e({ className: xQe, onBlur: function(_) {
    M && M(_), L.onBlur(_);
  }, onChange: function(_) {
    R && R(_), G || U(_.target.value), L.onChange(_);
  }, ref: t, title: n ?? void 0, value: B }, $);
  return k.createElement(mfe, q, k.createElement(vfe, { className: OQe }, k.createElement("textarea", D)));
});
D9.displayName = "TextArea", D9.propTypes = { id: z.string, darkMode: z.bool, label: z.string, description: z.string, errorMessage: z.string, successMessage: z.string, state: z.oneOf(Object.values(Cpe)) };
var Mpe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowLeft", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowLeft", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Mpe);
var $Qe = Mpe.exports;
const jQe = /* @__PURE__ */ ce($Qe);
var kpe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "ArrowRight", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return P.displayName = "ArrowRight", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(kpe);
var CQe = kpe.exports;
const MQe = /* @__PURE__ */ ce(CQe);
var Ppe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "OpenNewTab", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), f.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return P.displayName = "OpenNewTab", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Ppe);
var kQe = Ppe.exports;
const PQe = /* @__PURE__ */ ce(kQe);
function SQe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function et(e, t, n) {
  return (t = SQe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ln.apply(this, arguments);
}
function br(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function Ne(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function NQe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return v0e(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return v0e(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function v0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var b0e, y0e, w0e, O0e, x0e, E0e, $0e, j0e, Gl = v(b0e || (b0e = Ne([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), Q.default, b.black), Spe = et(et({}, W.Body1, v(y0e || (y0e = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(w0e || (w0e = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body2.fontSize, V.body2.lineHeight)), RQe = et(et({}, W.Body1, v(O0e || (O0e = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code1.fontSize, V.code1.lineHeight)), W.Body2, v(x0e || (x0e = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.code2.fontSize, V.code2.lineHeight)), Ec = et(et({}, S.Light, v(E0e || (E0e = Ne([`
    color: `, `;
  `])), b.black)), S.Dark, v($0e || ($0e = Ne([`
    color: `, `;
  `])), b.gray.light2)), Kl = function(e) {
  var t = cn();
  return e ? e === 16 ? W.Body2 : W.Body1 : t === 16 ? W.Body2 : W.Body1;
}, _Qe = ["baseFontSize", "darkMode", "className", "weight", "as"], Npe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.weight, i = l === void 0 ? "regular" : l, c = e.as, f = c === void 0 ? "p" : c, d = br(e, _Qe), h = K(n).theme, g = Kl(t), m = ne(f).Component, y = v(j0e || (j0e = Ne([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), Y[i], Y.bold);
  return k.createElement(m, Ln({ className: H(Gl, Spe[g], Ec[h], y, r) }, d));
});
Npe.displayName = "Body";
var C0e, M0e, k0e, P0e, S0e, N0e, R0e, _0e, A0e, L0e, AQe = { label: "lg-label", description: "lg-description" };
v(C0e || (C0e = Ne([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), Q.default, Y.regular);
et(et({}, S.Light, v(M0e || (M0e = Ne([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(k0e || (k0e = Ne([`
    color: `, `;
  `])), b.gray.light1));
et(et({}, S.Light, v(P0e || (P0e = Ne([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(S0e || (S0e = Ne([`
    color: `, `;
  `])), b.gray.dark1));
et(et({}, W.Body1, v(N0e || (N0e = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(R0e || (R0e = Ne([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize));
var Z0e, T0e, B0e, I0e, H0e;
et(et({}, S.Light, v(_0e || (_0e = Ne([`
    color: `, `;
  `])), b.gray.dark1)), S.Dark, v(A0e || (A0e = Ne([`
    color: `, `;
  `])), b.gray.light1));
v(L0e || (L0e = Ne([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var D0e, z0e, F0e, V0e, q0e, U0e, LQe = v(Z0e || (Z0e = Ne([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), Q.default, Y.regular), ZQe = et(et({}, S.Light, v(T0e || (T0e = Ne([`
    color: `, `;
  `])), b.red.base)), S.Dark, v(B0e || (B0e = Ne([`
    color: `, `;
  `])), b.red.light1)), TQe = et(et({}, W.Body1, v(I0e || (I0e = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(H0e || (H0e = Ne([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), BQe = ["as", "darkMode", "children", "className"];
te(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, l = e.children, i = e.className, c = br(e, BQe), f = K(r).theme, d = Kl(), h = ne(n).Component;
  return k.createElement(h, Ln({}, c, { className: H(LQe, ZQe[f], TQe[d], i) }), l);
});
var IQe = v(D0e || (D0e = Ne([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), Y.regular, Q.serif), HQe = et(et({}, S.Light, v(z0e || (z0e = Ne([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(F0e || (F0e = Ne([`
    color: `, `;
  `])), b.gray.light2)), DQe = ["darkMode", "className", "as"], zQe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h1" : r, i = br(e, DQe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Ln({ className: H(Gl, IQe, HQe[c], n) }, i));
});
zQe.displayName = "H1";
var W0e, FQe = v(V0e || (V0e = Ne([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), Y.regular, Q.serif), VQe = et(et({}, S.Light, v(q0e || (q0e = Ne([`
    color: `, `;
  `])), b.green.dark2)), S.Dark, v(U0e || (U0e = Ne([`
    color: `, `;
  `])), b.gray.light2)), qQe = ["darkMode", "className", "as"], UQe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h2" : r, i = br(e, qQe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Ln({ className: H(Gl, FQe, VQe[c], n) }, i));
});
UQe.displayName = "H2";
var G0e, K0e, Y0e, X0e, Q0e, J0e, ese, tse, nse, rse, WQe = v(W0e || (W0e = Ne([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), Y.medium), GQe = ["darkMode", "className", "as"], KQe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h3" : r, i = br(e, GQe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Ln({ className: H(Gl, WQe, Ec[c], n) }, i));
});
KQe.displayName = "H3";
var ase, lse, ise, $l = gt(), YQe = v(G0e || (G0e = Ne([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), Q.code, $l), XQe = et(et({}, S.Light, v(K0e || (K0e = Ne([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.light3, b.gray.light2, b.gray.dark3, $l, b.gray.light2, b.gray.light1)), S.Dark, v(Y0e || (Y0e = Ne([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), b.gray.dark2, b.gray.light1, $l, b.gray.dark2, b.gray.dark1)), QQe = et(et({}, S.Light, v(X0e || (X0e = Ne([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), $l, it[S.Light].default, b.blue.base)), S.Dark, v(Q0e || (Q0e = Ne([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), $l, it[S.Dark].default, b.blue.base)), JQe = et(et({}, S.Light, v(J0e || (J0e = Ne([`
    color: `, `;
  `])), b.blue.base)), S.Dark, v(ese || (ese = Ne([`
    color: `, `;
  `])), b.blue.light1)), eJe = v(tse || (tse = Ne([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), tJe = v(nse || (nse = Ne([`
  white-space: nowrap;
`]))), nJe = v(rse || (rse = Ne([`
  white-space: normal;
`]))), rJe = ["children", "className", "darkMode", "baseFontSize", "as"], ose = tt(function(e, t) {
  var n, r, l = e.children, i = e.className, c = e.darkMode, f = e.baseFontSize, d = e.as, h = br(e, rJe), g = K(c).theme, m = Kl(f), y = nt(d, h, "code").Component, w = ((n = typeof l == "string" && ((r = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? tJe : nJe, C = y !== "code", E = k.createElement("code", { ref: t, className: H(RQe[m], YQe, XQe[g], QQe[g], w, et({}, JQe[g], C), i) }, l);
  return C ? k.createElement(y, Ln({ className: H($l, eJe, i) }, h), E) : k.cloneElement(E, h);
});
ose.displayName = "InlineCode", ose.propTypes = { children: z.node, className: z.string, darkMode: z.bool, baseFontSize: z.oneOf(Object.values(W)) };
var sse, cse, use, fse, dse, pse, gse;
v(ase || (ase = Ne([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), Q.code);
et(et({}, S.Light, v(lse || (lse = Ne([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.black, b.gray.dark3, b.white)), S.Dark, v(ise || (ise = Ne([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), b.gray.light2, b.gray.base, b.gray.dark3));
var hse, mse, vse, aJe = v(sse || (sse = Ne([`
  font-family: `, `;
  font-weight: `, `;
`])), Q.default, Y.bold), lJe = et(et({}, S.Light, v(cse || (cse = Ne([`
    color: `, `;
  `])), b.black)), S.Dark, v(use || (use = Ne([`
    color: `, `;
  `])), b.gray.light2)), iJe = et(et({}, S.Light, v(fse || (fse = Ne([`
    color: `, `;
  `])), b.gray.base)), S.Dark, v(dse || (dse = Ne([`
    color: `, `;
  `])), b.gray.dark1)), oJe = et(et({}, W.Body1, v(pse || (pse = Ne([`
    font-size: `, `px;
    line-height: `, `px;
  `])), V.body1.fontSize, V.body1.lineHeight)), W.Body2, v(gse || (gse = Ne([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), V.body2.fontSize)), sJe = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], Rpe = te(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, l = e.children, i = e.disabled, c = i !== void 0 && i, f = e.as, d = f === void 0 ? "label" : f, h = e["data-lgid"], g = h === void 0 ? AQe.label : h, m = br(e, sJe), y = K(n).theme, w = Kl(t), C = ne(d).Component;
  return k.createElement(C, Ln({ "data-lgid": g, className: H(aJe, lJe[y], oJe[w], et({}, iJe[y], c), r) }, m), l);
});
Rpe.displayName = "Label";
var bse, yse, wse, Ose, xse, Ese, h1 = gt(), _pe = v(hse || (hse = Ne([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), Q.default, It.default), Ape = et(et({}, S.Light, v(mse || (mse = Ne([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.base, Y.regular, b.gray.light2, b.blue.base)), S.Dark, v(vse || (vse = Ne([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), b.blue.light1, Y.bold, b.gray.dark2, b.blue.base)), Lpe = function(e) {
  if (e)
    return Spe[e];
}, cJe = v(bse || (bse = Ne([`
  gap: `, `px;
  display: inline-flex;
`])), ee[100]), uJe = ["children", "className", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.baseFontSize, i = e.darkMode, c = e.as, f = br(e, uJe), d = K(i).theme, h = Kl(l), g = nt(c, f, "span").Component;
  return k.createElement(g, Ln({ className: H(h1, _pe, Lpe(h), Ape[d], cJe, r), ref: t }, f), k.createElement(jQe, { role: "presentation" }), n);
});
var fJe = v(yse || (yse = Ne([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), dJe = v(wse || (wse = Ne([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), h1, h1), pJe = v(Ose || (Ose = Ne([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), gJe = "hover", hJe = "persist", $se = "none", mJe = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
tt(function(e, t) {
  var n = e.children, r = e.className, l = e.arrowAppearance, i = l === void 0 ? $se : l, c = e.hideExternalIcon, f = c !== void 0 && c, d = e.baseFontSize, h = e.darkMode, g = e.as, m = br(e, mJe), y = NQe(ht(""), 2), w = y[0], C = y[1];
  Tt(function() {
    C(window.location.hostname);
  }, []);
  var E, R = K(h).theme, M = Kl(d), P = nt(g, m, "span").Component, a = kt(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : w;
  }, [m, w]), o = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (o.target = m.target, o.rel = m.rel) : P === "a" && (a === w ? o.target = "_self" : (o.target = "_blank", o.rel = "noopener noreferrer")), o.target !== "_blank" || f ? i !== $se && (E = k.createElement(MQe, { role: "presentation", size: 12, className: H(et(et({}, dJe, i === gJe), fJe, i === hJe)) })) : E = k.createElement(PQe, { role: "presentation", className: pJe }), k.createElement(P, Ln({ className: H(h1, _pe, Lpe(M), Ape[R], r), ref: t }, o, m), k.createElement("span", null, n), E);
});
var vJe = v(xse || (xse = Ne([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), Y.bold), bJe = ["darkMode", "className", "as"], yJe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "div" : r, i = br(e, bJe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Ln({ className: H(Gl, vJe, Ec[c], n) }, i));
});
yJe.displayName = "Overline";
var wJe = v(Ese || (Ese = Ne([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), Y.bold), OJe = ["darkMode", "className", "as"], xJe = te(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, l = r === void 0 ? "h6" : r, i = br(e, OJe), c = K(t).theme, f = ne(l).Component;
  return k.createElement(f, Ln({ className: H(Gl, wJe, Ec[c], n) }, i));
});
xJe.displayName = "Subtitle";
var jse;
v(jse || (jse = Ne([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var Zpe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (p === "string" ? String : Number)(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "CheckmarkWithCircle", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.4485 4.89583C10.8275 4.45816 11.4983 4.43411 11.9077 4.84352C12.2777 5.21345 12.2989 5.80633 11.9564 6.2018L7.38365 11.4818C7.31367 11.5739 7.22644 11.6552 7.12309 11.7208C6.65669 12.0166 6.03882 11.8783 5.74302 11.4119L3.9245 8.54448C3.6287 8.07809 3.767 7.46021 4.2334 7.16442C4.69979 6.86863 5.31767 7.00693 5.61346 7.47332L6.71374 9.20819L10.4485 4.89583Z", fill: "currentColor" }));
    };
    return P.displayName = "CheckmarkWithCircle", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Zpe);
var EJe = Zpe.exports;
const $Je = /* @__PURE__ */ ce(EJe);
function jJe(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var l = n[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Cse(e, t, n) {
  return (t = jJe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ll() {
  return ll = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ll.apply(this, arguments);
}
function CJe(e, t) {
  if (e == null)
    return {};
  var n, r, l = function(c, f) {
    if (c == null)
      return {};
    var d, h, g = {}, m = Object.keys(c);
    for (h = 0; h < m.length; h++)
      d = m[h], f.indexOf(d) >= 0 || (g[d] = c[d]);
    return g;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (l[n] = e[n]);
  }
  return l;
}
function sr(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function MJe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var l = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (l != null) {
      var i, c, f, d, h = [], g = !0, m = !1;
      try {
        if (f = (l = l.call(n)).next, r === 0) {
          if (Object(l) !== l)
            return;
          g = !1;
        } else
          for (; !(g = (i = f.call(l)).done) && (h.push(i.value), h.length !== r); g = !0)
            ;
      } catch (y) {
        m = !0, c = y;
      } finally {
        try {
          if (!g && l.return != null && (d = l.return(), Object(d) !== d))
            return;
        } finally {
          if (m)
            throw c;
        }
      }
      return h;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Mse(n, r);
      var l = Object.prototype.toString.call(n).slice(8, -1);
      if (l === "Object" && n.constructor && (l = n.constructor.name), l === "Map" || l === "Set")
        return Array.from(n);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
        return Mse(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Mse(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var kse, Pse, Sse, Nse, Rse, _se, Ase, Lse, Zse, Tse, Bse, kJe = v(kse || (kse = sr([`
  display: flex;
  gap: `, `px;
  align-items: center;
`])), ee[1]), PJe = v(Pse || (Pse = sr([`
  color: `, `;
`])), b.gray.dark1), SJe = function(e) {
  var t = e.submittedMessage;
  return k.createElement("div", { className: kJe }, k.createElement($Je, { color: b.green.dark1 }), k.createElement(Npe, { className: PJe }, t));
}, NJe = v(Sse || (Sse = sr([`
  width: 100%;
`]))), RJe = v(Nse || (Nse = sr([`
  display: flex;
  justify-content: end;
`]))), _Je = v(Rse || (Rse = sr([`
  flex: 1;
  padding-top: 3px; // to match icon button padding
`]))), AJe = v(_se || (_se = sr([`
  margin-top: `, `px;
`])), ee[100]), LJe = v(Ase || (Ase = sr([`
  margin-top: `, `px;
  display: flex;
  gap: `, `px;
  justify-content: end;
`])), ee[200], ee[2]), Ky = wn(function(e, t) {
  var n = e.label, r = e.cancelButtonText, l = r === void 0 ? "Cancel" : r, i = e.onCancel, c = e.cancelButtonProps, f = e.submitButtonText, d = f === void 0 ? "Submit" : f, h = e.submitButtonProps, g = e.isSubmitted, m = e.submittedMessage, y = m === void 0 ? "Submitted! Thanks for your feedback." : m, w = e.onSubmit, C = e.darkMode, E = e.onClose, R = e.textareaProps, M = K(C).darkMode, P = Hn({ prefix: "lg-chat-imf-input" }), a = Hn({ prefix: "lg-chat-imf-label" }), o = Dn(null), s = function() {
    var N, T;
    return ((R == null ? void 0 : R.value) === void 0 || (R == null ? void 0 : R.value.length) < 1) && ((o == null || (N = o.current) === null || N === void 0 ? void 0 : N.value) === void 0 || (o == null || (T = o.current) === null || T === void 0 ? void 0 : T.value.length) < 1);
  }, p = MJe(ht(s()), 2), O = p[0], x = p[1];
  return k.createElement(Fn, { darkMode: M }, k.createElement("div", { ref: t }, g ? k.createElement(SJe, { submittedMessage: y }) : k.createElement("form", { className: NJe, onSubmit: function(N) {
    N.preventDefault(), w == null || w(N);
  } }, k.createElement("div", { className: RJe }, k.createElement(Rpe, { id: a, className: _Je }, n), E && k.createElement(v1, { "aria-label": "Close feedback window", onClick: E }, k.createElement(m_e, null))), k.createElement(D9, ll({ id: P, "aria-labelledby": a, autoFocus: !0, className: AJe }, R, { ref: function(N) {
    R != null && R.ref && (R.ref.current = N), o.current = N;
  }, onChange: function(N) {
    var T;
    x(s()), R == null || (T = R.onChange) === null || T === void 0 || T.call(R, N);
  } })), k.createElement("div", { className: LJe }, k.createElement(ko, ll({ type: "button", variant: "default", size: "small", onClick: i }, c), l), k.createElement(ko, ll({ type: "submit", variant: "primary", size: "small", disabled: !!O }, h), d)))));
});
Ky.displayName = "InlineMessageFeedback";
var ZJe = v(Lse || (Lse = sr([`
  width: 372px;
  border-radius: 16px;
  border: 1px solid;
`]))), TJe = v(Zse || (Zse = sr([`
  padding: `, `px;
`])), ee[3]), BJe = Cse(Cse({}, S.Dark, v(Tse || (Tse = sr([`
    background-color: `, `;
    border-color: `, `;
  `])), b.gray.dark3, b.gray.dark2)), S.Light, v(Bse || (Bse = sr([`
    background-color: `, `;
    border-color: `, `;
  `])), b.black, b.black)), IJe = ["darkMode", "cancelButtonText", "onCancel", "cancelButtonProps", "submitButtonText", "submitButtonProps", "onSubmit", "textareaProps", "onClose", "label"], HJe = wn(function(e, t) {
  var n = e.darkMode, r = e.cancelButtonText, l = e.onCancel, i = e.cancelButtonProps, c = e.submitButtonText, f = e.submitButtonProps, d = e.onSubmit, h = e.textareaProps, g = e.onClose, m = e.label, y = CJe(e, IJe), w = K(n).theme;
  return k.createElement(Fn, { darkMode: !0 }, k.createElement(q9, ll({ ref: t, spacing: ee[3] }, y, { className: H(ZJe, BJe[w]) }), k.createElement("div", { className: TJe }, k.createElement(Ky, { cancelButtonText: r, onCancel: l, cancelButtonProps: i, submitButtonText: c, submitButtonProps: f, onSubmit: d, textareaProps: h, onClose: g, label: m }))));
});
HJe.displayName = "PopoverMessageFeedback";
var Tpe = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(k, ge, he);
  })(pe, function(n, r, l) {
    function i(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function c(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var o = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(s) {
        if (s !== "default") {
          var p = Object.getOwnPropertyDescriptor(a, s);
          Object.defineProperty(o, s, p.get ? p : { enumerable: !0, get: function() {
            return a[s];
          } });
        }
      }), o.default = a, Object.freeze(o);
    }
    var f = c(n), d = i(r);
    function h(a) {
      var o = function(s, p) {
        if (typeof s != "object" || !s)
          return s;
        var O = s[Symbol.toPrimitive];
        if (O !== void 0) {
          var x = O.call(s, p);
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(s);
      }(a, "string");
      return typeof o == "symbol" ? o : o + "";
    }
    function g(a, o, s) {
      return (o = h(o)) in a ? Object.defineProperty(a, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : a[o] = s, a;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s = arguments[o];
          for (var p in s)
            Object.prototype.hasOwnProperty.call(s, p) && (a[p] = s[p]);
        }
        return a;
      }, m.apply(this, arguments);
    }
    function y(a, o) {
      if (a == null)
        return {};
      var s, p, O = function(N, T) {
        if (N == null)
          return {};
        var $, j, A = {}, Z = Object.keys(N);
        for (j = 0; j < Z.length; j++)
          $ = Z[j], T.indexOf($) >= 0 || (A[$] = N[$]);
        return A;
      }(a, o);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (p = 0; p < x.length; p++)
          s = x[p], o.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(a, s) && (O[s] = a[s]);
      }
      return O;
    }
    function w(a, o) {
      return o || (o = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(o) } }));
    }
    var C, E, R = { small: 14, default: 16, large: 20, xlarge: 24 }, M = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], P = function(a) {
      var o = a.className, s = a.size, p = s === void 0 ? 16 : s, O = a.title, x = a["aria-label"], N = a["aria-labelledby"], T = a.fill, $ = a.role, j = $ === void 0 ? "img" : $, A = y(a, M), Z = l.css(C || (C = w([`
        color: `, `;
      `])), T), G = l.css(E || (E = w([`
        flex-shrink: 0;
      `]))), I = function(F, U, B) {
        var L, q = B["aria-label"], D = B["aria-labelledby"], _ = B.title;
        switch (F) {
          case "img":
            return q || D || _ ? g(g(g({}, "aria-labelledby", D), "aria-label", q), "title", _) : { "aria-label": (L = U, "".concat(L.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(j, "Warning", g(g({ title: O }, "aria-label", x), "aria-labelledby", N));
      return f.createElement("svg", m({ className: l.cx(g({}, Z, T != null), G, o), height: typeof p == "number" ? p : R[p], width: typeof p == "number" ? p : R[p], role: j }, I, A, { viewBox: "0 0 16 16" }), f.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8639 1.51357C8.49039 0.828811 7.50961 0.828811 7.1361 1.51357L1.12218 12.5388C0.763263 13.1968 1.23814 14 1.98608 14H14.0139C14.7619 14 15.2367 13.1968 14.8778 12.5388L8.8639 1.51357ZM7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z", fill: "currentColor" }));
    };
    return P.displayName = "Warning", P.isGlyph = !0, P.propTypes = { fill: d.default.string, size: d.default.oneOfType([d.default.number, d.default.string]), className: d.default.string }, P;
  });
})(Tpe);
var DJe = Tpe.exports;
const zJe = /* @__PURE__ */ ce(DJe), Bpe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return UJe;
    if (typeof e == "function")
      return $c(e);
    if (typeof e == "object")
      return Array.isArray(e) ? FJe(e) : VJe(e);
    if (typeof e == "string")
      return qJe(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function FJe(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Bpe(e[n]);
  return $c(r);
  function r(...l) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, l))
        return !0;
    return !1;
  }
}
function VJe(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return $c(n);
  function n(r) {
    const l = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in e)
      if (l[i] !== t[i])
        return !1;
    return !0;
  }
}
function qJe(e) {
  return $c(t);
  function t(n) {
    return n && n.type === e;
  }
}
function $c(e) {
  return t;
  function t(n, r, l) {
    return !!(WJe(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      l || void 0
    ));
  }
}
function UJe() {
  return !0;
}
function WJe(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Ipe = [], GJe = !0, Ise = !1, KJe = "skip";
function YJe(e, t, n, r) {
  let l;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : l = t;
  const i = Bpe(l), c = r ? -1 : 1;
  f(e, void 0, [])();
  function f(d, h, g) {
    const m = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof m.type == "string") {
      const w = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(y, "name", {
        value: "node (" + (d.type + (w ? "<" + w + ">" : "")) + ")"
      });
    }
    return y;
    function y() {
      let w = Ipe, C, E, R;
      if ((!t || i(d, h, g[g.length - 1] || void 0)) && (w = XJe(n(d, g)), w[0] === Ise))
        return w;
      if ("children" in d && d.children) {
        const M = (
          /** @type {UnistParent} */
          d
        );
        if (M.children && w[0] !== KJe)
          for (E = (r ? M.children.length : -1) + c, R = g.concat(M); E > -1 && E < M.children.length; ) {
            const P = M.children[E];
            if (C = f(P, E, R)(), C[0] === Ise)
              return C;
            E = typeof C[1] == "number" ? C[1] : E + c;
          }
      }
      return w;
    }
  }
}
function XJe(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [GJe, e] : e == null ? Ipe : [e];
}
function Hpe(e, t, n, r) {
  let l, i, c;
  typeof t == "function" && typeof n != "function" ? (i = void 0, c = t, l = n) : (i = t, c = n, l = r), YJe(e, i, f, l);
  function f(d, h) {
    const g = h[h.length - 1], m = g ? g.children.indexOf(d) : void 0;
    return c(d, m, g);
  }
}
function Dpe(e) {
  e.data || (e.data = {}), e.data.headingStyle = "atx", e.depth < 3 && e.position !== void 0 && e.position.start.line !== e.position.end.line && (e.data.headingStyle = "setext");
}
const QJe = () => (e) => {
  Hpe(e, "heading", Dpe);
}, JJe = () => (e) => {
  Hpe(e, "heading", (t) => {
    var n, r, l;
    (n = t.data) != null && n.headingStyle || Dpe(t), ((r = t.data) == null ? void 0 : r.headingStyle) === "setext" && (t.type = "paragraph", delete t.depth, (l = t.data) == null || delete l.setext);
  });
}, eet = [
  "Blog",
  "Book",
  "Code",
  "Docs",
  "Learn",
  "Video",
  "Website"
];
function tet(e) {
  return eet.includes(e);
}
function net(e, { tck: t } = {}) {
  return e.map((n) => {
    const r = {
      href: t ? zge(n.url, { tck: t }) : n.url,
      children: n.title
    }, { sourceType: l } = n.metadata ?? {};
    return l && tet(l) ? {
      ...r,
      variant: l
    } : r;
  });
}
const m1 = 300, Ma = {
  message_prompts: tn`
    margin-left: 70px;
    @media screen and (max-width: 804px) {
      margin-left: 50px;
    }

    transition: opacity ${m1}ms ease-in;

    &-enter {
      opacity: 0;
    }
    &-enter-active {
      opacity: 1;
    }
    &-exit {
      opacity: 1;
    }
    &-exit-active {
      opacity: 0;
    }
  `,
  message_rating: tn`
    margin-top: 0.5rem;

    // Ensure that the rating icons are properly center aligned. The
    // docs site has a global label style that adds a margin here
    // without this style.
    & label {
      margin: 0;
    }
  `,
  // This is a hacky fix for weird white-space issues in LG Chat.
  markdown_container: tn`
    display: flex;
    flex-direction: column;

    & * {
      line-height: 28px;
    }

    & p {
      font-weight: 400;
    }

    & a {
      font-weight: 400;
    }

    & li {
      white-space: normal;
      margin-top: -1.5rem;

      & li {
        margin-top: 0;
      }
    }

    & code {
      white-space: pre-wrap;
    }
  `,
  // End hacky fix
  markdown_list: tn`
    overflow-wrap: anywhere;
    margin-bottom: -1.5rem;

    & ul {
      margin-bottom: 0;
    }

    & ol {
      margin-bottom: 0;
    }
  `,
  loading_skeleton: tn`
    width: 100%;
    min-width: 120px;

    & > div {
      width: 100%;
    }
  `,
  message_rating_comment: tn`
    transition: opacity ${m1}ms ease-in;

    &-enter {
      opacity: 0;
    }
    &-enter-active {
      opacity: 1;
    }
    &-exit {
      opacity: 1;
    }
    &-exit-active {
      opacity: 0;
    }
  `
}, ret = {
  className: Ma.markdown_container,
  components: {
    a: ({ children: e, href: t }) => /* @__PURE__ */ Ze.jsx(mge, { hideExternalIcon: !0, href: t, children: e }),
    p: ({ children: e, ...t }) => /* @__PURE__ */ Ze.jsx(ta, { ...t, children: e }),
    ol: ({ children: e, ordered: t, ...n }) => /* @__PURE__ */ Ze.jsx(ta, { as: "ol", className: Ma.markdown_list, ...n, children: e }),
    ul: ({ children: e, ordered: t, ...n }) => /* @__PURE__ */ Ze.jsx(ta, { className: Ma.markdown_list, as: "ul", ...n, children: e }),
    li: ({ children: e, ordered: t, node: n, ...r }) => /* @__PURE__ */ Ze.jsx(ta, { as: "li", ...r, children: e })
  }
}, aet = () => /* @__PURE__ */ Ze.jsx(Hce, { className: Ma.loading_skeleton });
function iet(e, t) {
  return {
    isSender: e.role === "user",
    senderName: e.role === "user" ? t == null ? void 0 : t.name : "Mongo",
    avatarVariant: e.role === "user" ? sw.User : sw.Mongo
  };
}
const oet = {
  remarkPlugins: [QJe, JJe]
};
function set({
  markdownProps: e,
  ...t
}) {
  return /* @__PURE__ */ Ze.jsx(
    My,
    {
      ...t,
      markdownProps: {
        ...oet,
        ...e
      }
    }
  );
}
const cet = ({
  messageData: e,
  suggestedPrompts: t = [],
  showSuggestedPrompts: n = !0,
  canSubmitSuggestedPrompt: r = () => !0,
  onSuggestedPromptClick: l,
  isLoading: i,
  showRating: c,
  conversation: f
}) => {
  var O;
  const { maxCommentCharacters: d } = rce(), h = g_e(), g = iet(e, h), [m, y] = ht("none"), [w, C] = ht(), [E, R] = ht(void 0);
  async function M(x) {
    if (x)
      try {
        await f.commentMessage(e.id, x), y("submitted"), R(e.rating ? "liked" : "disliked"), C(void 0);
      } catch {
        C(
          "Oops, there was an issue submitting the response to the server. Please try again."
        );
      }
  }
  function P() {
    y("abandoned");
  }
  const a = (O = e.metadata) == null ? void 0 : O.verifiedAnswer, o = a ? {
    verifier: "MongoDB Staff",
    verifiedAt: new Date(a.updated ?? a.created)
  } : void 0, { tck: s } = hge(), p = e.references && e.references.length > 0 ? net(e.references, { tck: s }) : void 0;
  return /* @__PURE__ */ Ze.jsxs(bge, { children: [
    /* @__PURE__ */ Ze.jsxs(
      R5e,
      {
        baseFontSize: 16,
        isSender: g.isSender,
        avatar: /* @__PURE__ */ Ze.jsx(Pge, { variant: g.avatarVariant, name: g.senderName }),
        sourceType: i ? void 0 : S5e.Markdown,
        markdownProps: ret,
        messageBody: e.content,
        verified: o,
        links: p,
        componentOverrides: { MessageContent: set },
        children: [
          i ? /* @__PURE__ */ Ze.jsx(aet, {}) : null,
          c ? /* @__PURE__ */ Ze.jsx(
            fet,
            {
              submit: M,
              abandon: P,
              status: m,
              errorMessage: w,
              clearErrorMessage: () => C(void 0),
              maxCommentCharacterCount: d,
              messageRatingProps: {
                value: e.rating === void 0 ? void 0 : e.rating ? "liked" : "disliked",
                className: Ma.message_rating,
                description: "How was the response?",
                hideThumbsUp: E === "disliked",
                hideThumbsDown: E === "liked",
                onChange: async (x) => {
                  const N = x.target.value;
                  N && m !== "submitted" && await f.rateMessage(
                    e.id,
                    N === "liked"
                  );
                }
              }
            }
          ) : null
        ]
      }
    ),
    n && /* @__PURE__ */ Ze.jsx(
      uet,
      {
        messagePrompts: t,
        messagePromptsOnClick: (x) => l == null ? void 0 : l(x),
        canSubmitSuggestedPrompt: r
      }
    )
  ] }, e.id);
}, uet = ({
  messagePrompts: e,
  messagePromptsOnClick: t,
  canSubmitSuggestedPrompt: n
}) => {
  const [r, l] = ht(void 0), i = Dn(null), c = Dn(!1), f = (d, h) => {
    n(d) && (c.current || (c.current = !0, l(h), setTimeout(() => {
      t(d);
    }, m1)));
  };
  return /* @__PURE__ */ Ze.jsx(
    Wge,
    {
      in: r === void 0,
      timeout: m1,
      nodeRef: i,
      classNames: Ma.message_prompts,
      children: /* @__PURE__ */ Ze.jsx("div", { className: Ma.message_prompts, ref: i, children: /* @__PURE__ */ Ze.jsx(z5e, { label: "Suggested Prompts", children: e.map((d, h) => /* @__PURE__ */ Ze.jsx(
        D5e,
        {
          onClick: () => f(d, h),
          selected: h === r,
          children: d
        },
        d
      )) }) })
    }
  );
};
function fet(e) {
  const {
    submit: t,
    abandon: n,
    status: r,
    errorMessage: l,
    maxCommentCharacterCount: i,
    messageRatingProps: c
  } = e, f = c.value !== void 0, d = Dn(null), h = r === "submitted", [g, m] = ht(0), y = i ? g > i : !1;
  return /* @__PURE__ */ Ze.jsxs(
    "div",
    {
      className: tn`
        & > div + div {
          margin-top: 0.5rem;
        }
      `,
      children: [
        /* @__PURE__ */ Ze.jsx(tfe, { ...c }),
        f && r !== "abandoned" ? /* @__PURE__ */ Ze.jsxs(Ze.Fragment, { children: [
          /* @__PURE__ */ Ze.jsx(
            Ky,
            {
              ref: d,
              cancelButtonText: "Cancel",
              onCancel: () => n(),
              submitButtonText: "Submit",
              onSubmit: async (w) => {
                const E = w.target.querySelector("textarea");
                y || await t((E == null ? void 0 : E.value) ?? "");
              },
              textareaProps: {
                onChange: (w) => {
                  const C = w.target;
                  m(C.value.length);
                },
                // @ts-expect-error Hacky fix for https://jira.mongodb.org/browse/LG-3964
                label: c.value === "liked" ? "Provide additional feedback here. What did you like about this response?" : "Provide additional feedback here. How can we improve?"
              },
              isSubmitted: h,
              submittedMessage: "Submitted! Thank you for your feedback."
            }
          ),
          i && r !== "submitted" ? /* @__PURE__ */ Ze.jsxs(
            "div",
            {
              className: tn`
                margin-top: -2rem !important;
                display: flex;
                flex-direction: row;
                gap: 0.5rem;
              `,
              children: [
                /* @__PURE__ */ Ze.jsx(
                  Yse,
                  {
                    current: g,
                    max: i
                  }
                ),
                y ? /* @__PURE__ */ Ze.jsx(
                  ta,
                  {
                    className: tn`
                    color: ${b.red.base};
                  `,
                    children: `Message must contain ${i} characters or fewer`
                  }
                ) : null
              ]
            }
          ) : null,
          l ? /* @__PURE__ */ Ze.jsx(det, { errorMessage: l }) : null
        ] }) : null
      ]
    }
  );
}
function det({
  errorMessage: e
}) {
  const { darkMode: t } = K();
  return /* @__PURE__ */ Ze.jsxs(
    "div",
    {
      className: tn`
        display: flex;
        gap: ${ee[1]}px;
        align-items: center;
      `,
      children: [
        /* @__PURE__ */ Ze.jsx(zJe, { color: b.red.base }),
        /* @__PURE__ */ Ze.jsx(
          ta,
          {
            className: tn`
          color: ${t ? b.gray.light1 : b.gray.dark2};
        `,
            children: e
          }
        )
      ]
    }
  );
}
const Oa = {
  chatbot_input: tn`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
  `,
  chatbot_input_area: tn`
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 0.5rem;
    padding-bottom: 1rem;
  `,
  conversation_id: tn`
    display: flex;
    flex-direction: row;
    justify-content: center;
  `,
  disclaimer_text: tn`
    text-align: center;
    margin-top: 16px;
    margin-bottom: 32px;
  `,
  chat_window: tn`
    border-radius: 24px;
  `,
  message_feed: tn`
    height: 100%;
    max-height: 70vh;
    & > div {
      box-sizing: border-box;
      max-height: 70vh;
    }
  `,
  verify_information: tn`
    text-align: center;
  `
};
function Aet(e) {
  var j;
  const { darkMode: t } = K(e.darkMode), {
    className: n,
    disclaimer: r,
    disclaimerHeading: l,
    fatalErrorMessage: i = $ge,
    initialMessageText: c,
    initialMessageReferences: f,
    initialMessageSuggestedPrompts: d,
    inputBarId: h = "chatbot-input-bar",
    inputBottomText: g,
    windowTitle: m
  } = e, {
    awaitingReply: y,
    canSubmit: w,
    chatbotName: C,
    conversation: E,
    handleSubmit: R,
    inputBarRef: M,
    inputText: P,
    inputTextError: a,
    isExperimental: o,
    maxInputCharacters: s,
    setInputText: p
  } = rce(), O = kt(() => c ? {
    id: crypto.randomUUID(),
    role: "assistant",
    content: c,
    createdAt: (/* @__PURE__ */ new Date()).toLocaleTimeString(),
    suggestedPrompts: d,
    references: f
  } : null, [
    c,
    f,
    d
  ]), x = O ? [O, ...E.messages] : E.messages, N = x.length === 0, T = a !== "", $ = E.error ? i : e.inputBarPlaceholder ?? xge();
  return /* @__PURE__ */ Ze.jsx(Nge, { children: /* @__PURE__ */ Ze.jsxs(
    Sge,
    {
      className: iw(Oa.chat_window, n),
      badgeText: o ? "Experimental" : void 0,
      title: m ?? C ?? "",
      darkMode: t,
      children: [
        N ? null : /* @__PURE__ */ Ze.jsxs(Yu, { darkMode: t, className: Oa.message_feed, children: [
          r ? /* @__PURE__ */ Ze.jsx(
            wce,
            {
              title: l ?? "Terms of Use",
              className: Oa.disclaimer_text,
              children: r
            }
          ) : null,
          x.map((A, Z) => {
            var F, U, B;
            const G = E.isStreamingMessage ? A.id === ((F = E.streamingMessage) == null ? void 0 : F.id) && ((U = E.streamingMessage) == null ? void 0 : U.content) === "" : !1, I = Z === 0;
            return /* @__PURE__ */ Ze.jsx(
              cet,
              {
                messageData: A,
                isLoading: G,
                showRating: (
                  // Users can rate assistant messages that have started streaming
                  A.role === "assistant" && !G && !(y && ((B = E.streamingMessage) == null ? void 0 : B.id) === A.id) && // We don't want users to rate the initial message (and they can't because it's not in the database)
                  !I
                ),
                conversation: E,
                suggestedPrompts: A.suggestedPrompts,
                showSuggestedPrompts: (
                  // For now we'll only show suggested prompts for the initial message and hide them once the user submits anything
                  I && E.messages.length === 0
                ),
                onSuggestedPromptClick: R,
                canSubmitSuggestedPrompt: w
              },
              A.id
            );
          })
        ] }),
        /* @__PURE__ */ Ze.jsxs("div", { className: iw(Oa.chatbot_input, Oa.chatbot_input_area), children: [
          E.error ? /* @__PURE__ */ Ze.jsx(tve, { darkMode: t, message: E.error }) : null,
          E.error ? null : /* @__PURE__ */ Ze.jsxs(Ze.Fragment, { children: [
            /* @__PURE__ */ Ze.jsx(
              Ege,
              {
                hasError: T,
                shouldRenderGradient: !a,
                darkMode: t,
                ref: M,
                disabled: !!((j = E.error) != null && j.length),
                disableSend: T || y,
                onMessageSend: (A) => {
                  a.length === 0 && !E.error && R(A);
                },
                textareaProps: {
                  id: h,
                  value: P,
                  onChange: (A) => {
                    p(A.target.value);
                  },
                  placeholder: $
                }
              }
            ),
            /* @__PURE__ */ Ze.jsxs(
              "div",
              {
                className: tn`
                    display: flex;
                    justify-content: space-between;
                  `,
                children: [
                  g ? /* @__PURE__ */ Ze.jsx(ta, { baseFontSize: 13, className: Oa.verify_information, children: g }) : null,
                  s ? /* @__PURE__ */ Ze.jsx(
                    Yse,
                    {
                      darkMode: t,
                      current: P.length,
                      max: s
                    }
                  ) : null
                ]
              }
            )
          ] }),
          /* @__PURE__ */ Ze.jsx(pet, { conversation: E })
        ] })
      ]
    }
  ) });
}
function pet({ conversation: e }) {
  return {}.VITE_QA === "true" ? /* @__PURE__ */ Ze.jsx("div", { className: Oa.conversation_id, children: /* @__PURE__ */ Ze.jsxs(ta, { children: [
    "Conversation ID: ",
    /* @__PURE__ */ Ze.jsx(vge, { children: e.conversationId })
  ] }) }) : null;
}
export {
  Aet as ChatWindow
};
